/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/piano-blues-maker/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 216);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(28);
var hide = __webpack_require__(17);
var redefine = __webpack_require__(18);
var ctx = __webpack_require__(24);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(223);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(234)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(79)('wks');
var uid = __webpack_require__(40);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(161);
var toPrimitive = __webpack_require__(29);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(31);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(97);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(503);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(507);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(97);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(17);
var has = __webpack_require__(16);
var SRC = __webpack_require__(40)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(28).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(4);
var defined = __webpack_require__(30);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(473);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(68);
var defined = __webpack_require__(30);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(69);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(29);
var has = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(161);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(16);
var toObject = __webpack_require__(11);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(12);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(224);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(28);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(24);
var IObject = __webpack_require__(68);
var toObject = __webpack_require__(11);
var toLength = __webpack_require__(10);
var asc = __webpack_require__(123);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(8)) {
  var LIBRARY = __webpack_require__(41);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(4);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(89);
  var $buffer = __webpack_require__(129);
  var ctx = __webpack_require__(24);
  var anInstance = __webpack_require__(47);
  var propertyDesc = __webpack_require__(39);
  var hide = __webpack_require__(17);
  var redefineAll = __webpack_require__(49);
  var toInteger = __webpack_require__(31);
  var toLength = __webpack_require__(10);
  var toIndex = __webpack_require__(187);
  var toAbsoluteIndex = __webpack_require__(43);
  var toPrimitive = __webpack_require__(29);
  var has = __webpack_require__(16);
  var classof = __webpack_require__(70);
  var isObject = __webpack_require__(6);
  var toObject = __webpack_require__(11);
  var isArrayIter = __webpack_require__(120);
  var create = __webpack_require__(44);
  var getPrototypeOf = __webpack_require__(23);
  var gOPN = __webpack_require__(45).f;
  var getIterFn = __webpack_require__(122);
  var uid = __webpack_require__(40);
  var wks = __webpack_require__(7);
  var createArrayMethod = __webpack_require__(33);
  var createArrayIncludes = __webpack_require__(80);
  var speciesConstructor = __webpack_require__(87);
  var ArrayIterators = __webpack_require__(125);
  var Iterators = __webpack_require__(58);
  var $iterDetect = __webpack_require__(84);
  var setSpecies = __webpack_require__(46);
  var arrayFill = __webpack_require__(124);
  var arrayCopyWithin = __webpack_require__(177);
  var $DP = __webpack_require__(9);
  var $GOPD = __webpack_require__(22);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(182);
var $export = __webpack_require__(0);
var shared = __webpack_require__(79)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(185))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(40)('meta');
var isObject = __webpack_require__(6);
var has = __webpack_require__(16);
var setDesc = __webpack_require__(9).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(4)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(7)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(17)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(163);
var enumBugKeys = __webpack_require__(107);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(164);
var enumBugKeys = __webpack_require__(107);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(104)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(108).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(163);
var hiddenKeys = __webpack_require__(107).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(8);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(24);
var call = __webpack_require__(175);
var isArrayIter = __webpack_require__(120);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(10);
var getIterFn = __webpack_require__(122);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(18);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var IE8_DOM_DEFINE = __webpack_require__(196);
var toPrimitive = __webpack_require__(131);
var dP = Object.defineProperty;

exports.f = __webpack_require__(52) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(72)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {"intros":[{"id":0,"type":"INTRO","description":"Classic","phrases":[{"bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"qr"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4,"acc":"b"}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"D","oct":4},{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"D","oct":4},{"step":"F","oct":4}],"dur":"8"}],"beams":[{"from":1,"to":4},{"from":4,"to":7},{"from":7,"to":10}],"tuplets":[{"from":1,"to":4},{"from":4,"to":7},{"from":7,"to":10}]}],"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"qr","clef":"bass"},{"keys":[{"step":"B","oct":3,"acc":"b"}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":3,"acc":"b"}],"dur":"q","clef":"bass"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4},{"step":"E","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4,"acc":"b"}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"D","oct":4}],"dur":"h"}],"tuplets":[{"from":0,"to":3},{"from":3,"to":6}],"beams":[{"from":0,"to":3},{"from":3,"to":6}]}],"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"b"},{"step":"G","oct":3,"acc":"b"}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2},{"step":"F","oct":3}],"dur":"h","clef":"bass"}]}]}]}]},{"id":1,"type":"INTRO","description":"Barrelhouse","phrases":[{"bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"G","oct":4}],"dur":"32"},{"keys":[{"step":"E","oct":4}],"dur":"32"},{"keys":[{"step":"C","oct":4}],"dur":"32"},{"keys":[{"step":"A","oct":3}],"dur":"32"},{"keys":[{"step":"G","oct":3}],"dur":"8"},{"keys":[{"step":"F","oct":3,"acc":"#"}],"dur":"8"}]}],"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"F","oct":3,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"F","oct":3,"ties":[{"type":"stop"},{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"F","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]}],"dur":"q"},{"keys":[{"step":"B","oct":4}],"dur":"hr"}]}],"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4}],"dur":"8","grace":{"notes":[{"keys":[{"step":"D","oct":4}],"dur":"8","slash":true}]}},{"keys":[{"step":"G","oct":4}],"dur":"32"},{"keys":[{"step":"E","oct":4}],"dur":"32"},{"keys":[{"step":"C","oct":4}],"dur":"32"},{"keys":[{"step":"G","oct":3}],"dur":"32"},{"keys":[{"step":"F","oct":3}],"dur":"8"},{"keys":[{"step":"D","oct":3,"acc":"#"}],"dur":"8"},{"keys":[{"step":"E","oct":3,"ties":[{"type":"start"}]}],"dur":"8"}],"beams":[{"from":2,"to":4},{"from":4,"to":9},{"from":9,"to":12}],"tuplets":[{"from":9,"to":12}]}],"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":3,"ties":[{"type":"stop"}]},{"step":"C","oct":4}],"dur":"q"},{"keys":[{"step":"C","oct":4},{"step":"F","oct":4,"acc":"#"},{"step":"B","oct":4,"acc":"b"}],"dur":"8"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"start"}]},{"step":"F","oct":4,"acc":"n","ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"F","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"q"},{"keys":[{"step":"B","oct":4}],"dur":"qr"}]}],"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"C","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":2,"acc":"b"},{"step":"A","oct":3,"acc":"b"}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2,"ties":[{"type":"start"}]},{"step":"G","oct":3,"ties":[{"type":"start"}]}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2,"ties":[{"type":"stop"}]},{"step":"G","oct":3,"ties":[{"type":"stop"}]}],"dur":"q","clef":"bass"},{"keys":[{"step":"D","oct":3}],"dur":"qr","clef":"bass"}]}]}]}]}],"endings":[{"id":100,"type":"ENDING","description":"Descending  ninth chords","phrases":[{"type":"ENDING","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":5,"acc":"b"},{"step":"G","oct":5}],"dur":"8"},{"keys":[{"step":"D","oct":5}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"B","oct":4,"acc":"b"},{"step":"D","oct":5}],"dur":"8"},{"keys":[{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"D","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8"},{"keys":[{"step":"C","oct":5}],"dur":"8"},{"keys":[{"step":"F","oct":4}],"dur":"8"}],"beams":[{"from":0,"to":3},{"from":3,"to":6},{"from":6,"to":9},{"from":9,"to":12}],"tuplets":[{"from":0,"to":3},{"from":3,"to":6},{"from":6,"to":9},{"from":9,"to":12}]}],"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":2}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2,"acc":"#"}],"dur":"q","clef":"bass","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"b","oct":3},{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"q"},{"keys":[{"step":"F","oct":4},{"step":"B","oct":4},{"step":"E","oct":5,"acc":"b"}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"n","ties":[{"type":"start"}]},{"step":"B","oct":4,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":5,"ties":[{"type":"start"}]}],"dur":"q","stem":"up"},{"keys":[{"step":"E","oct":4,"ties":[{"type":"stop"}]},{"step":"B","oct":4,"ties":[{"type":"stop"}]},{"step":"D","oct":5,"ties":[{"type":"stop"}]}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r"}]}],"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":2,"acc":"b"},{"step":"D","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2,"ties":[{"type":"start"}]},{"step":"C","oct":3,"ties":[{"type":"start"}]}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2,"ties":[{"type":"stop"}]},{"step":"C","oct":3,"ties":[{"type":"stop"}]}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3}],"dur":"8r","clef":"bass","stem":"up"}]}]}]}]},{"id":101,"type":"ENDING","description":"Classic","phrases":[{"type":"","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"G","oct":4}],"dur":"q"}],"beams":[{"from":0,"to":3},{"from":3,"to":6},{"from":6,"to":9}],"tuplets":[{"from":0,"to":3},{"from":3,"to":6},{"from":6,"to":9}]}],"bassVoices":[{"notes":[{"keys":[{"step":"B","oct":2,"acc":"b"},{"step":"B","oct":3,"acc":"b"}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2},{"step":"A","oct":3}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"},{"step":"A","oct":3,"acc":"b"}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"q","clef":"bass","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":3},{"step":"D","oct":4,"acc":"b"},{"step":"F","oct":4},{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"q"},{"keys":[{"step":"G","oct":3},{"step":"B","oct":3,"acc":"b"},{"step":"D","oct":4,"acc":"n"},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"h","dots":1}]}],"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":2,"acc":"b"},{"step":"D","oct":3,"acc":"b"}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"C","oct":3}],"dur":"h","clef":"bass","stem":"up","dots":1}]}]}]}]}],"leftHandPatterns":[{"id":200,"description":"Blank","phrases":[{"type":"I-I-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]}]},{"type":"IV-IV-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass"}]}]}]},{"type":"V-V-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"D","oct":3}],"dur":"wr","clef":"bass","stem":"up"}]}]}]}]},{"id":201,"description":"Classic","phrases":[{"type":"I-I-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]}]},{"type":"IV-IV-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]}]},{"type":"V-V-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"D","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"q","clef":"bass"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"q","clef":"bass"},{"keys":[{"step":"E","oct":2}],"dur":"8","clef":"bass"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":1}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":1}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":1,"acc":"b"}],"dur":"q","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":1,"acc":"n"}],"dur":"q","clef":"bass","stem":"up"}]}]}]}]},{"id":202,"description":"Chicago","phrases":[{"type":"I-I-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"IV-IV-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"V-V-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]}]}]},{"id":203,"description":"Ray Charles style","phrases":[{"type":"I-I-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"IV-IV-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"V-V-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"E","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"D","oct":3,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"b"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"B","oct":2,"acc":"n"}],"dur":"8","clef":"bass","stem":"up"}]}]}]}]},{"id":214,"description":"Basic (5th & 6th intervals)","phrases":[{"type":"I-I-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"IV-IV-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]}]},{"type":"V-V-I-I","bars":[{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"E","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"C","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"F","oct":2},{"step":"D","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"G","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"C","oct":2},{"step":"A","oct":2}],"dur":"8","clef":"bass","stem":"up"}]}]},{"bassVoices":[{"notes":[{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"},{"keys":[{"step":"G","oct":2},{"step":"G","oct":3}],"dur":"8","clef":"bass","stem":"up"}]}]}]}]}],"rightHandPatterns":[{"id":300,"description":"Blank","demo":true,"phrases":[{"type":"I-I-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]}]},{"type":"IV-IV-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]}]},{"type":"V-V-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"wr"}]}]}]}]},{"id":301,"demo":true,"description":"Boogie style (chords)","phrases":[{"type":"I-I-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"B","oct":4,"acc":"b"},{"step":"E","oct":5,"acc":"b"}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]}]},{"type":"IV-IV-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4,"acc":"b"},{"step":"B","oct":4,"acc":"b"},{"step":"D","oct":5,"acc":"b"}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]}]},{"type":"V-V-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"F","oct":4},{"step":"A","oct":4},{"step":"B","oct":4},{"step":"D","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4},{"step":"A","oct":4},{"step":"B","oct":4},{"step":"D","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"G","oct":4},{"step":"A","oct":4},{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4},{"step":"A","oct":4,"acc":"#"},{"step":"C","oct":5,"acc":"#"}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"start"}]},{"step":"B","oct":4,"ties":[{"type":"start","stem":"DOWN"}]},{"step":"D","oct":5,"ties":[{"type":"start","stem":"DOWN"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"stop"}]},{"step":"B","oct":4,"ties":[{"type":"stop"}]},{"step":"D","oct":5,"ties":[{"type":"stop"}]}],"dur":"q","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"G","oct":4}],"dur":"8","stem":"up"}]}]}]}]},{"id":305,"description":"Guitar style","phrases":[{"type":"I-I-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start","stem":"DOWN"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]}]},{"type":"IV-IV-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"F","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4},{"step":"A","oct":4},{"step":"D","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b","ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]},{"step":"C","oct":5,"ties":[{"type":"start","stem":"DOWN"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]},{"step":"C","oct":5,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"F","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4},{"step":"A","oct":4},{"step":"D","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b","ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]},{"step":"C","oct":5,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]},{"step":"C","oct":5,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]}]},{"type":"V-V-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"G","oct":4},{"step":"B","oct":4},{"step":"E","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"start"}]},{"step":"A","oct":4,"ties":[{"type":"start"}]},{"step":"D","oct":5,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"stop"}]},{"step":"A","oct":4,"ties":[{"type":"stop"}]},{"step":"D","oct":5,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"F","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"F","oct":4},{"step":"A","oct":4},{"step":"D","oct":5}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"acc":"b","ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]},{"step":"C","oct":5,"ties":[{"type":"start","stem":"DOWN"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"E","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]},{"step":"C","oct":5,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"C","oct":4},{"step":"E","oct":4},{"step":"A","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"acc":"b","ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":3},{"step":"D","oct":4},{"step":"E","oct":4}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":3,"ties":[{"type":"start"}]},{"step":"D","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"F","oct":3,"ties":[{"type":"stop"}]},{"step":"D","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"8","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"8r","stem":"up"},{"keys":[{"step":"B","oct":4}],"dur":"qr","stem":"up"}]}]}]}]},{"id":307,"description":"Lonely avenue","phrases":[{"type":"I-I-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"D","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7},{"from":7,"to":10}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7},{"from":7,"to":10}]}]}]},{"type":"IV-IV-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]}]},{"type":"V-V-I-I","bars":[{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"q"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"B","oct":3,"acc":"b"},{"step":"E","oct":4},{"step":"G","oct":4,"acc":"b"}],"dur":"8"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"A","oct":3},{"step":"E","oct":4,"acc":"b"},{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"A","oct":3},{"step":"E","oct":4},{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"A","oct":3},{"step":"E","oct":4},{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"A","oct":3},{"step":"E","oct":4},{"step":"F","oct":4}],"dur":"8"},{"keys":[{"step":"A","oct":3},{"step":"E","oct":4},{"step":"F","oct":4}],"dur":"q"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"G","oct":4},{"step":"B","oct":4,"acc":"b"}],"dur":"8","grace":{"notes":[{"keys":[{"step":"F","oct":4,"acc":"#"}],"dur":"8","slash":true}]}},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4,"acc":"n"},{"step":"A","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4}],"dur":"8"},{"keys":[{"step":"E","oct":4,"acc":"b"},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"C","oct":4,"ties":[{"type":"stop"}]}],"dur":"8"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}],"tuplets":[{"from":4,"to":7}],"beams":[{"from":0,"to":2},{"from":2,"to":4},{"from":4,"to":7}]}]},{"trebleVoices":[{"notes":[{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3},{"step":"F","oct":4},{"step":"G","oct":4}],"dur":"8"},{"keys":[{"step":"F","oct":4},{"step":"G","oct":4},{"step":"B","oct":4}],"dur":"8"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"start"}]},{"step":"F","oct":4,"ties":[{"type":"start"}]},{"step":"G","oct":4,"ties":[{"type":"start"}]}],"dur":"8"},{"keys":[{"step":"B","oct":3,"ties":[{"type":"stop"}]},{"step":"F","oct":4,"ties":[{"type":"stop"}]},{"step":"G","oct":4,"ties":[{"type":"stop"}]}],"dur":"q"},{"keys":[{"step":"B","oct":4}],"dur":"8r"},{"keys":[{"step":"C","oct":4}],"dur":"8"}]}]}]}]}]}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(9).f;
var has = __webpack_require__(16);
var TAG = __webpack_require__(7)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var fails = __webpack_require__(4);
var spaces = __webpack_require__(110);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(50);
var ctx = __webpack_require__(195);
var hide = __webpack_require__(61);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(51);
var createDesc = __webpack_require__(93);
module.exports = __webpack_require__(52) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(199);
var defined = __webpack_require__(132);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(135)('wks');
var uid = __webpack_require__(95);
var Symbol = __webpack_require__(38).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(527);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony export (immutable) */ __webpack_exports__["h"] = tokenize;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return midi; });
/* unused harmony export midiToFreq */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return freq; });
/* unused harmony export freqToMidi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chroma; });
/* unused harmony export oct */
/* unused harmony export stepToLetter */
/* unused harmony export altToAcc */
/* unused harmony export from */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return build; });
/* unused harmony export fromMidi */
/* unused harmony export simplify */
/* unused harmony export enharmonic */
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-note.svg)](https://www.npmjs.com/package/tonal-note)
 * [![tonal](https://img.shields.io/badge/tonal-note-yellow.svg)](https://www.npmjs.com/browse/keyword/tonal)
 *
 * `tonal-note` is a collection of functions to manipulate musical notes in scientific notation
 *
 * This is part of [tonal](https://www.npmjs.com/package/tonal) music theory library.
 *
 * ## Usage
 *
 * ```js
 * import * as Note from "tonal-note"
 * // or const Note = require("tonal-note")
 * Note.name("bb2") // => "Bb2"
 * Note.chroma("bb2") // => 10
 * Note.midi("a4") // => 69
 * Note.freq("a4") // => 440
 * Note.oct("G3") // => 3
 *
 * // part of tonal
 * const Tonal = require("tonal")
 * // or import Note from "tonal"
 * Tonal.Note.midi("d4") // => 62
 * ```
 *
 * ## Install
 *
 * [![npm install tonal-note](https://nodei.co/npm/tonal-note.png?mini=true)](https://npmjs.org/package/tonal-note/)
 *
 * ## API Documentation
 *
 * @module Note
 */

var NAMES = "C C# Db D D# Eb E F F# Gb G G# Ab A A# Bb B".split(" ");

/**
 * Get a list of note names (pitch classes) within a octave
 *
 * @param {string} accTypes - (Optional, by default " b#"). A string with the
 * accidentals types: " " means no accidental, "#" means sharps, "b" mean flats,
 * can be conbined (see examples)
 * @return {Array}
 * @example
 * Note.names(" b") // => [ "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B" ]
 * Note.names(" #") // => [ "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B" ]
 */
var names = function (accTypes) { return typeof accTypes !== "string"
    ? NAMES.slice()
    : NAMES.filter(function (n) {
        var acc = n[1] || " ";
        return accTypes.indexOf(acc) !== -1;
      }); };

var SHARPS = names(" #");
var FLATS = names(" b");
var REGEX = /^([a-gA-G]?)(#{1,}|b{1,}|x{1,}|)(-?\d*)\s*(.*)$/;

/**
 * Split a string into tokens related to note parts.
 * It returns an array of strings `[letter, accidental, octave, modifier]`
 *
 * It always returns an array
 *
 * @param {String} str
 * @return {Array} an array of note tokens
 * @example
 * Note.tokenize("C#2") // => ["C", "#", "2", ""]
 * Note.tokenize("Db3 major") // => ["D", "b", "3", "major"]
 * Note.tokenize("major") // => ["", "", "", "major"]
 * Note.tokenize("##") // => ["", "##", "", ""]
 * Note.tokenize() // => ["", "", "", ""]
 */
function tokenize(str) {
  if (typeof str !== "string") { str = ""; }
  var m = REGEX.exec(str);
  if (!m) { return null; }
  return [m[1].toUpperCase(), m[2].replace(/x/g, "##"), m[3], m[4]];
}

var NO_NOTE = Object.freeze({
  pc: null,
  name: null,
  step: null,
  alt: null,
  oct: null,
  octStr: null,
  chroma: null,
  midi: null,
  freq: null
});

var SEMI = [0, 2, 4, 5, 7, 9, 11];
var properties = function (str) {
  var tokens = tokenize(str);
  if (tokens[0] === "" || tokens[3] !== "") { return NO_NOTE; }
  var letter = tokens[0];
  var acc = tokens[1];
  var octStr = tokens[2];
  var p = { letter: letter, acc: acc, octStr: octStr };
  p.pc = p.letter + p.acc;
  p.name = p.pc + octStr;
  p.step = (p.letter.charCodeAt(0) + 3) % 7;
  p.alt = p.acc[0] === "b" ? -p.acc.length : p.acc.length;
  p.oct = octStr.length ? +octStr : null;
  p.chroma = (SEMI[p.step] + p.alt + 120) % 12;
  p.midi = p.oct !== null ? SEMI[p.step] + p.alt + 12 * (p.oct + 1) : null;
  p.freq = midiToFreq(p.midi);
  return Object.freeze(p);
};

var memo = function (fn, cache) {
  if ( cache === void 0 ) cache = {};

  return function (str) { return cache[str] || (cache[str] = fn(str)); };
};

/**
 * Get note properties. It returns an object with the following information:
 *
 * - name {String}: the note name. The letter is always in uppercase
 * - letter {String}: the note letter, always in uppercase
 * - acc {String}: the note accidentals
 * - octave {Number}: the octave or null if not present
 * - pc {String}: the pitch class (letter + accidentals)
 * - step {Number}: number equivalent of the note letter. 0 means C ... 6 means B.
 * - alt {Number}: number equivalent of accidentals (negative are flats, positive sharps)
 * - chroma {Number}: number equivalent of the pitch class, where 0 is C, 1 is C# or Db, 2 is D...
 * - midi {Number}: the note midi number
 * - freq {Number}: the frequency using an equal temperament at 440Hz
 *
 * This function *always* returns an object with all this properties, but if it"s
 * not a valid note all properties will be null.
 *
 * The returned object can"t be mutated.
 *
 * @param {String} note - the note name in scientific notation
 * @return {Object} an object with the properties (or an object will all properties
 * set to null if not valid note)
 * @example
 * Note.props("fx-3").name // => "F##-3"
 * Note.props("invalid").name // => null
 * Note.props("C#3").oct // => 3
 * Note.props().oct // => null
 */
var props = memo(properties);

/**
 * Given a note name, return the note name or null if not valid note.
 * The note name will ALWAYS have the letter in upercase and accidentals
 * using # or b
 *
 * Can be used to test if a string is a valid note name.
 *
 * @function
 * @param {Pitch|string}
 * @return {string}
 *
 * @example
 * Note.name("cb2") // => "Cb2"
 * ["c", "db3", "2", "g+", "gx4"].map(Note.name) // => ["C", "Db3", null, null, "G##4"]
 */
var name = function (str) { return props(str).name; };

/**
 * Get pitch class of a note. The note can be a string or a pitch array.
 *
 * @function
 * @param {string|Pitch}
 * @return {string} the pitch class
 * @example
 * Note.pc("Db3") // => "Db"
 * ["db3", "bb6", "fx2"].map(Note.pc) // => [ "Db", "Bb", "F##"]
 */
var pc = function (str) { return props(str).pc; };

/**
 * Get the note midi number
 * (an alias of tonal-midi `toMidi` function)
 *
 * @function
 * @param {string|Number} note - the note to get the midi number from
 * @return {Integer} the midi number or null if not valid pitch
 * @example
 * Note.midi("C4") // => 60
 * Note.midi(60) // => 60
 * @see midi.toMidi
 */
var midi = function (note) { return props(note).midi || +note || null; };

/**
 * Get the frequency from midi number
 *
 * @param {Number} midi - the note midi number
 * @param {Number} tuning - (Optional) 440 by default
 * @return {Number} the frequency or null if not valid note midi
 */
var midiToFreq = function (midi, tuning) {
    if ( tuning === void 0 ) tuning = 440;

    return typeof midi === "number" ? Math.pow(2, (midi - 69) / 12) * tuning : null;
};

/**
 * Get the frequency of a note
 *
 * @function
 * @param {string|Number} note - the note name or midi note number
 * @return {Number} the frequency
 * @example
 * Note.freq("A4") // => 440
 * Note.freq(69) // => 440
 */
var freq = function (note) { return props(note).freq || midiToFreq(note); };

var L2 = Math.log(2);
var L440 = Math.log(440);
/**
 * Get the midi number from a frequency in hertz. The midi number can
 * contain decimals (with two digits precission)
 *
 * @param {Number} frequency
 * @return {Number}
 * @example
 * Note.freqToMidi(220)); //=> 57;
 * Note.freqToMidi(261.62)); //=> 60;
 * Note.freqToMidi(261)); //=> 59.96;
 */
var freqToMidi = function (freq) {
  var v = 12 * (Math.log(freq) - L440) / L2 + 69;
  return Math.round(v * 100) / 100;
};

/**
 * Return the chroma of a note. The chroma is the numeric equivalent to the
 * pitch class, where 0 is C, 1 is C# or Db, 2 is D... 11 is B
 *
 * @param {string} note - the note name
 * @return {Integer} the chroma number
 * @example
 * Note.chroma("Cb") // => 11
 * ["C", "D", "E", "F"].map(Note.chroma) // => [0, 2, 4, 5]
 */
var chroma = function (str) { return props(str).chroma; };

/**
 * Get the octave of the given pitch
 *
 * @function
 * @param {string} note - the note
 * @return {Integer} the octave or null if doesn"t have an octave or not a valid note
 * @example
 * Note.oct("C#4") // => 4
 * Note.oct("C") // => null
 * Note.oct("blah") // => undefined
 */
var oct = function (str) { return props(str).oct; };

var LETTERS = "CDEFGAB";
/**
 * Given a step number return it"s letter (0 = C, 1 = D, 2 = E)
 * @param {number} step
 * @return {string} the letter
 * @example
 * Note.stepToLetter(3) // => "F"
 */
var stepToLetter = function (step) { return LETTERS[step]; };

var fillStr = function (s, n) { return Array(n + 1).join(s); };
var numToStr = function (num, op) { return (typeof num !== "number" ? "" : op(num)); };

/**
 * Given an alteration number, return the accidentals
 * @param {Number} alt
 * @return {String}
 * @example
 * Note.altToAcc(-3) // => "bbb"
 */
var altToAcc = function (alt) { return numToStr(alt, function (alt) { return (alt < 0 ? fillStr("b", -alt) : fillStr("#", alt)); }); };

/**
 * Creates a note name in scientific notation from note properties,
 * and optionally another note name.
 * It receives an object with:
 * - step: the note step (0 = C, 1 = D, ... 6 = B)
 * - alt: (optional) the alteration. Negative numbers are flats, positive sharps
 * - oct: (optional) the octave
 *
 * Optionally it receives another note as a "base", meaning that any prop not explicitly
 * received on the first parameter will be taken from that base note. That way it can be used
 * as an immutable "set" operator for a that base note
 *
 * @function
 * @param {Object} props - the note properties
 * @param {String} [baseNote] - note to build the result from. If given, it returns
 * the result of applying the given props to this note.
 * @return {String} the note name in scientific notation or null if not valid properties
 * @example
 * Note.from({ step: 5 }) // => "A"
 * Note.from({ step: 1, acc: -1 }) // => "Db"
 * Note.from({ step: 2, acc: 2, oct: 2 }) // => "E##2"
 * Note.from({ step: 7 }) // => null
 * Note.from({alt: 1, oct: 3}, "C4") // => "C#3"
 */
var from = function (fromProps, baseNote) {
  if ( fromProps === void 0 ) fromProps = {};
  if ( baseNote === void 0 ) baseNote = null;

  var ref = baseNote
    ? Object.assign({}, props(baseNote), fromProps)
    : fromProps;
  var step = ref.step;
  var alt = ref.alt;
  var oct = ref.oct;
  var letter = stepToLetter(step);
  if (!letter) { return null; }
  var pc = letter + altToAcc(alt);
  return oct || oct === 0 ? pc + oct : pc;
};

/**
 * Deprecated. This is kept for backwards compatibility only.
 * Use Note.from instead
 */
var build = from;

/**
 * Given a midi number, returns a note name. The altered notes will have
 * flats unless explicitly set with the optional `useSharps` parameter.
 *
 * @function
 * @param {number} midi - the midi note number
 * @param {boolean} useSharps - (Optional) set to true to use sharps instead of flats
 * @return {string} the note name
 * @example
 * Note.fromMidi(61) // => "Db4"
 * Note.fromMidi(61, true) // => "C#4"
 * // it rounds to nearest note
 * Note.fromMidi(61.7) // => "D4"
 */
function fromMidi(num, sharps) {
  num = Math.round(num);
  var pcs = sharps === true ? SHARPS : FLATS;
  var pc = pcs[num % 12];
  var o = Math.floor(num / 12) - 1;
  return pc + o;
}

/**
 * Simplify the note: find an enhramonic note with less accidentals.
 *
 * @param {String} note - the note to be simplified
 * @param {boolean} useSameAccType - (optional, true by default) set to true
 * to ensure the returned note has the same accidental types that the given note
 * @return {String} the simplfiied note or null if not valid note
 * @example
 * Note.simplify("C##") // => "D"
 * Note.simplify("C###") // => "D#"
 * Note.simplify("C###", false) // => "Eb"
 * Note.simplify("B#4") // => "C5"
 */
var simplify = function (note, sameAcc) {
  var ref = props(note);
  var alt = ref.alt;
  var chroma = ref.chroma;
  var midi = ref.midi;
  if (chroma === null) { return null; }
  var useSharps = sameAcc === false ? alt < 0 : alt > 0;
  return midi === null
    ? pc(fromMidi(chroma, useSharps))
    : fromMidi(midi, useSharps);
};

/**
 * Get the simplified and enhramonic note of the given one.
 *
 * @param {String} note
 * @return {String} the enhramonic note
 * @example
 * Note.enharmonic("Db") // => "C#"
 * Note.enhramonic("C") // => "C"
 */
var enharmonic = function (note) { return simplify(note, false); };


/***/ }),
/* 67 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(25);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(25);
var TAG = __webpack_require__(7)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				className: className,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(21);
var toLength = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(43);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(25);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(6);
var cof = __webpack_require__(25);
var MATCH = __webpack_require__(7)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(7)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(17);
var redefine = __webpack_require__(18);
var fails = __webpack_require__(4);
var defined = __webpack_require__(30);
var wks = __webpack_require__(7);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(12);
var SPECIES = __webpack_require__(7)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(18);
var redefineAll = __webpack_require__(49);
var meta = __webpack_require__(36);
var forOf = __webpack_require__(48);
var anInstance = __webpack_require__(47);
var isObject = __webpack_require__(6);
var fails = __webpack_require__(4);
var $iterDetect = __webpack_require__(84);
var setToStringTag = __webpack_require__(56);
var inheritIfRequired = __webpack_require__(111);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(17);
var uid = __webpack_require__(40);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(41) || !__webpack_require__(4)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(3)[K];
});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var ctx = __webpack_require__(24);
var forOf = __webpack_require__(48);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(198);
var enumBugKeys = __webpack_require__(136);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(481);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(493);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(209);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chroma;
/* unused harmony export chromas */
/* harmony export (immutable) */ __webpack_exports__["d"] = modes;
/* unused harmony export isChroma */
/* unused harmony export intervals */
/* unused harmony export isEqual */
/* harmony export (immutable) */ __webpack_exports__["b"] = isSubsetOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSupersetOf;
/* unused harmony export includes */
/* unused harmony export filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_note__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tonal_interval__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tonal_array__ = __webpack_require__(147);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-pcset.svg?style=flat-square)](https://www.npmjs.com/package/tonal-pcset)
 * [![tonal](https://img.shields.io/badge/tonal-pcset-yellow.svg?style=flat-square)](https://www.npmjs.com/browse/keyword/tonal)
 *
 * `tonal-pcset` is a collection of functions to work with pitch class sets, oriented
 * to make comparations (isEqual, isSubset, isSuperset)
 *
 * This is part of [tonal](https://www.npmjs.com/package/tonal) music theory library.
 *
 * You can install via npm: `npm i --save tonal-pcset`
 *
 * ```js
 * // es6
 * import PcSet from "tonal-pcset"
 * var PcSet = require("tonal-pcset")
 *
 * PcSet.isEqual("c2 d5 e6", "c6 e3 d1") // => true
 * ```
 *
 * ## API documentation
 *
 * @module PcSet
 */




var chr = function (str) { return Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["b" /* chroma */])(str) || Object(__WEBPACK_IMPORTED_MODULE_1_tonal_interval__["chroma"])(str) || 0; };
var pcsetNum = function (set) { return parseInt(chroma(set), 2); };
var clen = function (chroma) { return chroma.replace(/0/g, "").length; };

/**
 * Get chroma of a pitch class set. A chroma identifies each set uniquely.
 * It"s a 12-digit binary each presenting one semitone of the octave.
 *
 * Note that this function accepts a chroma as parameter and return it
 * without modification.
 *
 * @param {Array|String} set - the pitch class set
 * @return {String} a binary representation of the pitch class set
 * @example
 * PcSet.chroma(["C", "D", "E"]) // => "1010100000000"
 */
function chroma(set) {
  if (isChroma(set)) { return set; }
  if (!Array.isArray(set)) { return ""; }
  var b = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  set.map(chr).forEach(function (i) {
    b[i] = 1;
  });
  return b.join("");
}

var all = null;
/**
 * Get a list of all possible chromas (all possible scales)
 * More information: http://allthescales.org/
 * @return {Array} an array of possible chromas from '10000000000' to '11111111111'
 *
 */
function chromas(n) {
  all = all || Object(__WEBPACK_IMPORTED_MODULE_2_tonal_array__["b" /* range */])(2048, 4095).map(function (n) { return n.toString(2); });
  return typeof n === "number"
    ? all.filter(function (chroma) { return clen(chroma) === n; })
    : all.slice();
}

/**
 * Given a a list of notes or a pcset chroma, produce the rotations
 * of the chroma discarding the ones that starts with "0"
 *
 * This is used, for example, to get all the modes of a scale.
 *
 * @param {Array|String} set - the list of notes or pitchChr of the set
 * @param {Boolean} normalize - (Optional, true by default) remove all
 * the rotations that starts with "0"
 * @return {Array<String>} an array with all the modes of the chroma
 *
 * @example
 * PcSet.modes(["C", "D", "E"]).map(PcSet.intervals)
 */
function modes(set, normalize) {
  normalize = normalize !== false;
  var binary = chroma(set).split("");
  return Object(__WEBPACK_IMPORTED_MODULE_2_tonal_array__["a" /* compact */])(
    binary.map(function(_, i) {
      var r = Object(__WEBPACK_IMPORTED_MODULE_2_tonal_array__["c" /* rotate */])(i, binary);
      return normalize && r[0] === "0" ? null : r.join("");
    })
  );
}

var REGEX = /^[01]{12}$/;
/**
 * Test if the given string is a pitch class set chroma.
 * @param {String} chroma - the pitch class set chroma
 * @return {Boolean} true if its a valid pcset chroma
 * @example
 * PcSet.isChroma("101010101010") // => true
 * PcSet.isChroma("101001") // => false
 */
function isChroma(set) {
  return REGEX.test(set);
}

var IVLS = "1P 2m 2M 3m 3M 4P 5d 5P 6m 6M 7m 7M".split(" ");
/**
 * Given a pcset (notes or chroma) return it"s intervals
 * @param {String|Array} pcset - the pitch class set (notes or chroma)
 * @return {Array} intervals or empty array if not valid pcset
 * @example
 * PcSet.intervals("1010100000000") => ["1P", "2M", "3M"]
 */
function intervals(set) {
  if (!isChroma(set)) { return []; }
  return Object(__WEBPACK_IMPORTED_MODULE_2_tonal_array__["a" /* compact */])(
    set.split("").map(function(d, i) {
      return d === "1" ? IVLS[i] : null;
    })
  );
}

/**
 * Test if two pitch class sets are identical
 *
 * @param {Array|String} set1 - one of the pitch class sets
 * @param {Array|String} set2 - the other pitch class set
 * @return {Boolean} true if they are equal
 * @example
 * PcSet.isEqual(["c2", "d3"], ["c5", "d2"]) // => true
 */
function isEqual(s1, s2) {
  if (arguments.length === 1) { return function (s) { return isEqual(s1, s); }; }
  return chroma(s1) === chroma(s2);
}

/**
 * Create a function that test if a collection of notes is a
 * subset of a given set
 *
 * The function can be partially applied
 *
 * @param {Array|String} set - an array of notes or a chroma set string to test against
 * @param {Array|String} notes - an array of notes or a chroma set
 * @return {boolean} true if notes is a subset of set, false otherwise
 * @example
 * const inCMajor = PcSet.isSubsetOf(["C", "E", "G"])
 * inCMajor(["e6", "c4"]) // => true
 * inCMajor(["e6", "c4", "d3"]) // => false
 */
function isSubsetOf(set, notes) {
  if (arguments.length > 1) { return isSubsetOf(set)(notes); }
  set = pcsetNum(set);
  return function(notes) {
    notes = pcsetNum(notes);
    return notes !== set && (notes & set) === notes;
  };
}

/**
 * Create a function that test if a collectio of notes is a
 * superset of a given set (it contains all notes and at least one more)
 *
 * @param {Array|String} set - an array of notes or a chroma set string to test against
 * @param {Array|String} notes - an array of notes or a chroma set
 * @return {boolean} true if notes is a superset of set, false otherwise
 * @example
 * const extendsCMajor = PcSet.isSupersetOf(["C", "E", "G"])
 * extendsCMajor(["e6", "a", "c4", "g2"]) // => true
 * extendsCMajor(["c6", "e4", "g3"]) // => false
 */
function isSupersetOf(set, notes) {
  if (arguments.length > 1) { return isSupersetOf(set)(notes); }
  set = pcsetNum(set);
  return function(notes) {
    notes = pcsetNum(notes);
    return notes !== set && (notes | set) === notes;
  };
}

/**
 * Test if a given pitch class set includes a note
 * @param {Array|String} set - the base set to test against
 * @param {String|Pitch} note - the note to test
 * @return {Boolean} true if the note is included in the pcset
 * @example
 * PcSet.includes(["C", "D", "E"], "C4") // => true
 * PcSet.includes(["C", "D", "E"], "C#4") // => false
 */
function includes(set, note) {
  if (arguments.length > 1) { return includes(set)(note); }
  set = chroma(set);
  return function(note) {
    return set[chr(note)] === "1";
  };
}

/**
 * Filter a list with a pitch class set
 *
 * @param {Array|String} set - the pitch class set notes
 * @param {Array|String} notes - the note list to be filtered
 * @return {Array} the filtered notes
 *
 * @example
 * PcSet.filter(["C", "D", "E"], ["c2", "c#2", "d2", "c3", "c#3", "d3"]) // => [ "c2", "d2", "c3", "d3" ])
 * PcSet.filter(["C2"], ["c2", "c#2", "d2", "c3", "c#3", "d3"]) // => [ "c2", "c3" ])
 */
function filter(set, notes) {
  if (arguments.length === 1) { return function (n) { return filter(set, n); }; }
  return notes.filter(includes(set));
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateId;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRandomInt;
function generateId(){return Math.random().toString(36).substr(2,9);}function getRandomInt(min,max){return Math.floor(Math.random()*(max-min))+min;}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(250);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(28);
var LIBRARY = __webpack_require__(41);
var wksExt = __webpack_require__(162);
var defineProperty = __webpack_require__(9).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(79)('keys');
var uid = __webpack_require__(40);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(6);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(24)(Function.call, __webpack_require__(22).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var setPrototypeOf = __webpack_require__(109).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(30);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(41);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(18);
var hide = __webpack_require__(17);
var has = __webpack_require__(16);
var Iterators = __webpack_require__(58);
var $iterCreate = __webpack_require__(117);
var setToStringTag = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(23);
var ITERATOR = __webpack_require__(7)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(44);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(56);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(17)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(83);
var defined = __webpack_require__(30);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(7)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(58);
var ITERATOR = __webpack_require__(7)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(9);
var createDesc = __webpack_require__(39);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(70);
var ITERATOR = __webpack_require__(7)('iterator');
var Iterators = __webpack_require__(58);
module.exports = __webpack_require__(28).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(353);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(11);
var toAbsoluteIndex = __webpack_require__(43);
var toLength = __webpack_require__(10);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(37);
var step = __webpack_require__(178);
var Iterators = __webpack_require__(58);
var toIObject = __webpack_require__(21);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(116)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(24);
var invoke = __webpack_require__(168);
var html = __webpack_require__(108);
var cel = __webpack_require__(104);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(25)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(126).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(25)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(12);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(8);
var LIBRARY = __webpack_require__(41);
var $typed = __webpack_require__(89);
var hide = __webpack_require__(17);
var redefineAll = __webpack_require__(49);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(47);
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(10);
var toIndex = __webpack_require__(187);
var gOPN = __webpack_require__(45).f;
var dP = __webpack_require__(9).f;
var arrayFill = __webpack_require__(124);
var setToStringTag = __webpack_require__(56);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(62);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(135)('keys');
var uid = __webpack_require__(95);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 137 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(71);
var dPs = __webpack_require__(486);
var enumBugKeys = __webpack_require__(136);
var IE_PROTO = __webpack_require__(134)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(197)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(487).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(51).f;
var has = __webpack_require__(53);
var TAG = __webpack_require__(64)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(64);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38);
var core = __webpack_require__(50);
var LIBRARY = __webpack_require__(138);
var wksExt = __webpack_require__(142);
var defineProperty = __webpack_require__(51).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback);
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Handle.prototype.focus = function focus() {
    this.handle.focus();
  };

  Handle.prototype.blur = function blur() {
    this.handle.blur();
  };

  Handle.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        vertical = _props.vertical,
        offset = _props.offset,
        style = _props.style,
        disabled = _props.disabled,
        min = _props.min,
        max = _props.max,
        value = _props.value,
        tabIndex = _props.tabIndex,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

    var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
    var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, postionStyle);
    var ariaProps = {};
    if (value !== undefined) {
      ariaProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ariaProps, {
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      });
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      ref: function ref(node) {
        return _this2.handle = node;
      },
      role: 'slider',
      tabIndex: tabIndex || 0
    }, ariaProps, restProps, {
      className: className,
      style: elStyle
    }));
  };

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__ = __webpack_require__(515);



function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === Object(__WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"])(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, diffs))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function getKeyboardValueMutator(e) {
  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].UP:
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      return function (value, props) {
        return value + props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].DOWN:
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].LEFT:
      return function (value, props) {
        return value - props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = range;
/* harmony export (immutable) */ __webpack_exports__["c"] = rotate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compact; });
/* unused harmony export sort */
/* harmony export (immutable) */ __webpack_exports__["d"] = unique;
/* unused harmony export shuffle */
/* unused harmony export permutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_note__ = __webpack_require__(66);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-array.svg?style=flat-square)](https://www.npmjs.com/package/tonal-array)
 *
 * Tonal array utilities. Create ranges, sort notes, ...
 *
 * @example
 * import * as Array;
 * Array.sort(["f", "a", "c"]) // => ["C", "F", "A"]
 *
 * @example
 * const Array = require("tonal-array)
 * Array.range(1, 4) // => [1, 2, 3, 4]
 *
 * @module Array
 */


// ascending range
function ascR(b, n) {
  for (var a = []; n--; a[n] = n + b){ ; }
  return a;
}
// descending range
function descR(b, n) {
  for (var a = []; n--; a[n] = b - n){ ; }
  return a;
}

/**
 * Create a numeric range
 *
 * @param {Number} from
 * @param {Number} to
 * @return {Array}
 *
 * @example
 * Array.range(-2, 2) // => [-2, -1, 0, 1, 2]
 * Array.range(2, -2) // => [2, 1, 0, -1, -2]
 */
function range(a, b) {
  return a === null || b === null
    ? []
    : a < b ? ascR(a, b - a + 1) : descR(a, a - b + 1);
}
/**
 *
 * Rotates a list a number of times. It"s completly agnostic about the
 * contents of the list.
 *
 * @param {Integer} times - the number of rotations
 * @param {Array} array
 * @return {Array} the rotated array
 * @example
 * Array.rotate(1, [1, 2, 3]) // => [2, 3, 1]
 */
function rotate(times, arr) {
  var len = arr.length;
  var n = (times % len + len) % len;
  return arr.slice(n, len).concat(arr.slice(0, n));
}

/**
 * Return a copy of the array with the null values removed
 * @function
 * @param {Array} array
 * @return {Array}
 *
 * @example
 * Array.compact(["a", "b", null, "c"]) // => ["a", "b", "c"]
 */
var compact = function (arr) { return arr.filter(function (n) { return n === 0 || n; }); };

// a function that get note heights (with negative number for pitch classes)
var height = function (n) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["d" /* midi */])(n);
  return m !== null ? m : Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["d" /* midi */])(n + "-100");
};

/**
 * Sort an array of notes in ascending order
 *
 * @param {String|Array} notes
 * @return {Array} sorted array of notes
 */
function sort(src) {
  return compact(src.map(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["e" /* name */])).sort(function (a, b) { return height(a) > height(b); });
}

/**
 * Get sorted notes with duplicates removed
 *
 * @function
 * @param {Array} notes
 */
function unique(arr) {
  return sort(arr).filter(function (n, i, a) { return i === 0 || n !== a[i - 1]; });
}

/**
 * Randomizes the order of the specified array in-place, using the Fisher–Yates shuffle.
 *
 * @private
 * @function
 * @param {Array|String} arr - the array
 * @return {Array} the shuffled array
 *
 * @example
 * Array.shuffle(["C", "D", "E", "F"])
 */
var shuffle = function (arr, rnd) {
  if ( rnd === void 0 ) rnd = Math.random;

  var i, t;
  var m = arr.length;
  while (m) {
    i = (rnd() * m--) | 0;
    t = arr[m];
    arr[m] = arr[i];
    arr[i] = t;
  }
  return arr;
};

/**
 * Get all permutations of an array
 * http://stackoverflow.com/questions/9960908/permutations-in-javascript
 *
 * @param {Array} array - the array
 * @return {Array<Array>} an array with all the permutations
 */
var permutations = function (arr) {
  if (arr.length === 0) { return [[]]; }
  return permutations(arr.slice(1)).reduce(function(acc, perm) {
    return acc.concat(
      arr.map(function(e, pos) {
        var newPerm = perm.slice();
        newPerm.splice(pos, 0, arr[0]);
        return newPerm;
      })
    );
  }, []);
};


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "names", function() { return names; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tokenize", function() { return tokenize; });
/* harmony export (immutable) */ __webpack_exports__["props"] = props;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "num", function() { return num; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "name", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "semitones", function() { return semitones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chroma", function() { return chroma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ic", function() { return ic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "build", function() { return build; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "simplify", function() { return simplify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromSemitones", function() { return fromSemitones; });
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-interval.svg)](https://www.npmjs.com/package/tonal-interval)
 * [![tonal](https://img.shields.io/badge/tonal-interval-yellow.svg)](https://www.npmjs.com/browse/keyword/tonal)
 *
 * `tonal-interval` is a collection of functions to create and manipulate music intervals.
 *
 * The intervals are strings in shorthand notation. Two variations are supported:
 *
 * - standard shorthand notation: type and number, for example: "M3", "d-4"
 * - inverse shorthand notation: number and then type, for example: "3M", "-4d"
 *
 * The problem with the standard shorthand notation is that some strings can be
 * parsed as notes or intervals, for example: "A4" can be note A in 4th octave
 * or an augmented four. To remove ambiguity, the prefered notation in tonal is the
 * inverse shortand notation.
 *
 * This is part of [tonal](https://www.npmjs.com/package/tonal) music theory library.
 *
 * ## Usage
 *
 * ```js
 * // es6
 * import * as Interval from "tonal-interval"
 * // es5
 * const Interval = require("tonal-interval")
 * // part of tonal
 * import { Interval } from "tonal"
 *
 * Interval.semitones("4P") // => 5
 * Interval.invert("3m") // => "6M"
 * Interval.simplify("9m") // => "2m"
 * ```
 *
 * ## Install
 *
 * [![npm install tonal-interval](https://nodei.co/npm/tonal-interval.png?mini=true)](https://npmjs.org/package/tonal-interval/)
 *
 * ## API Documentation
 *
 * @module Interval
 */
// shorthand tonal notation (with quality after number)
var IVL_TNL = "([-+]?\\d+)(d{1,4}|m|M|P|A{1,4})";
// standard shorthand notation (with quality before number)
var IVL_STR = "(AA|A|P|M|m|d|dd)([-+]?\\d+)";
var REGEX = new RegExp("^" + IVL_TNL + "|" + IVL_STR + "$");
var SIZES = [0, 2, 4, 5, 7, 9, 11];
var TYPES = "PMMPPMM";
var CLASSES = [0, 1, 2, 3, 4, 5, 6, 5, 4, 3, 2, 1];
var NAMES = "1P 2m 2M 3m 3M 4P 5P 6m 6M 7m 7M 8P".split(" ");

/**
 * List basic (perfect, major, minor) interval names within a octave
 * @param {String} qualities - (Optional, default "PMm") the valid types
 * @return {Array} the interval names
 * @example
 * Interval.names() // => [ "1P", "2m", "2M", "3m", "3M", "4P", "5P", "6m", "6M", "7m", "7M", "8P" ]
 * Interval.names("P") // => [ "1P", "4P", "5P", "8P" ]
 * Interval.names("PM") // => [ "1P", "2M", "3M", "4P", "5P", "6M", "7M", "8P" ]
 * Interval.names("Pm") // => [ "1P", "2m", "3m", "4P", "5P", "6m", "7m", "8P" ]
 * Interval.names("d") // => []
 */
var names = function (types) { return typeof types !== "string"
    ? NAMES.slice()
    : NAMES.filter(function (n) { return types.indexOf(n[1]) !== -1; }); };

var tokenize = function (str) {
  var m = REGEX.exec(str);
  return m === null ? null : m[1] ? [m[1], m[2]] : [m[4], m[3]];
};

var NO_IVL = Object.freeze({
  name: null,
  num: null,
  q: null,
  step: null,
  alt: null,
  dir: null,
  type: null,
  simple: null,
  semitones: null,
  chroma: null
});

var fillStr = function (s, n) { return Array(Math.abs(n) + 1).join(s); };

var qToAlt = function (type, q) {
  if (q === "M" && type === "M") { return 0; }
  if (q === "P" && type === "P") { return 0; }
  if (q === "m" && type === "M") { return -1; }
  if (/^A+$/.test(q)) { return q.length; }
  if (/^d+$/.test(q)) { return type === "P" ? -q.length : -q.length - 1; }
  return null;
};

var altToQ = function (type, alt) {
  if (alt === 0) { return type === "M" ? "M" : "P"; }
  else if (alt === -1 && type === "M") { return "m"; }
  else if (alt > 0) { return fillStr("A", alt); }
  else if (alt < 0) { return fillStr("d", type === "P" ? alt : alt + 1); }
  else { return null; }
};

var numToStep = function (num) { return (Math.abs(num) - 1) % 7; };

var properties = function (str) {
  var t = tokenize(str);
  if (t === null) { return NO_IVL; }
  var p = { num: +t[0], q: t[1] };
  p.step = numToStep(p.num);
  p.type = TYPES[p.step];
  if (p.type === "M" && p.q === "P") { return NO_IVL; }

  p.name = "" + p.num + p.q;
  p.dir = p.num < 0 ? -1 : 1;
  p.simple = p.num === 8 || p.num === -8 ? p.num : p.dir * (p.step + 1);
  p.alt = qToAlt(p.type, p.q);
  p.oct = Math.floor((Math.abs(p.num) - 1) / 7);
  p.semitones = p.dir * (SIZES[p.step] + p.alt + 12 * p.oct);
  p.chroma = ((p.dir * (SIZES[p.step] + p.alt)) % 12 + 12) % 12;
  return Object.freeze(p);
};

var cache = {};
/**
 * Get interval properties. It returns an object with:
 *
 * - name: name
 * - num: number
 * - q: quality
 * - step: step
 * - alt: alteration
 * - dir: direction (1 ascending, -1 descending)
 * - type: "P" or "M" for perfectable or majorable
 * - simple: the simplified number
 * - semitones: the size in semitones
 * - chroma: the interval chroma
 * - ic: the interval class
 *
 * @function
 * @param {String} interval - the interval
 * @return {Object} the interval in the form [number, alt]
 */
function props(str) {
  if (typeof str !== "string") { return NO_IVL; }
  return cache[str] || (cache[str] = properties(str));
}

/**
 * Get the number of the interval
 *
 * @function
 * @param {String} interval - the interval
 * @return {Integer}
 * @example
 * Interval.num("m2") // => 2
 * Interval.num("P9") // => 9
 * Interval.num("P-4") // => -4
 */
var num = function (str) { return props(str).num; };

/**
 * Get interval name. Can be used to test if it"s an interval. It accepts intervals
 * as pitch or string in shorthand notation or tonal notation. It returns always
 * intervals in tonal notation.
 *
 * @function
 * @param {String} interval - the interval string or array
 * @return {String} the interval name or null if not valid interval
 * @example
 * Interval.name("m-3") // => "-3m"
 * Interval.name("3") // => null
 */
var name = function (str) { return props(str).name; };

/**
 * Get size in semitones of an interval
 *
 * @function
 * @param {String} ivl
 * @return {Integer} the number of semitones or null if not an interval
 * @example
 * import { semitones } from "tonal-interval"
 * semitones("P4") // => 5
 * // or using tonal
 * Tonal.Interval.semitones("P5") // => 7
 */
var semitones = function (str) { return props(str).semitones; };

/**
 * Get the chroma of the interval. The chroma is a number between 0 and 7
 * that represents the position within an octave (pitch set)
 *
 * @function
 * @param {String} str
 * @return {Number}
 */
var chroma = function (str) { return props(str).chroma; };

/**
 * Get the [interval class](https://en.wikipedia.org/wiki/Interval_class)
 * number of a given interval.
 *
 * In musical set theory, an interval class is the shortest distance in
 * pitch class space between two unordered pitch classes
 *
 * @function
 * @param {String|Integer} interval - the interval or the number of semitones
 * @return {Integer} A value between 0 and 6
 *
 * @example
 * Interval.ic("P8") // => 0
 * Interval.ic("m6") // => 4
 * Interval.ic(10) // => 2
 * ["P1", "M2", "M3", "P4", "P5", "M6", "M7"].map(ic) // => [0, 2, 4, 5, 5, 3, 1]
 */
var ic = function (ivl) {
  if (typeof ivl === "string") { ivl = props(ivl).chroma; }
  return typeof ivl === "number" ? CLASSES[ivl % 12] : null;
};

/**
 * Given a interval property object, get the interval name
 *
 * The properties must contain a `num` *or* `step`, and `alt`:
 *
 * - num: the interval number
 * - step: the interval step (overrides the num property)
 * - alt: the interval alteration
 * - oct: (Optional) the number of octaves
 * - dir: (Optional) the direction
 *
 * @function
 * @param {Object} props - the interval property object
 *
 * @return {String} the interval name
 * @example
 * Interval.build({ step: 1, alt: -1, oct: 0, dir: 1 }) // => "1d"
 * Interval.build({ num: 9, alt: -1 }) // => "9m"
 */
var build = function (ref) {
  if ( ref === void 0 ) ref = {};
  var num = ref.num;
  var step = ref.step;
  var alt = ref.alt;
  var oct = ref.oct; if ( oct === void 0 ) oct = 1;
  var dir = ref.dir;

  if (step !== undefined) { num = step + 1 + 7 * oct; }
  if (num === undefined) { return null; }

  var d = dir < 0 ? "-" : "";
  var type = TYPES[numToStep(num)];
  return d + num + altToQ(type, alt);
};

/**
 * Get the simplified version of an interval.
 *
 * @function
 * @param {String} interval - the interval to simplify
 * @return {String} the simplified interval
 *
 * @example
 * Interval.simplify("9M") // => "2M"
 * ["8P", "9M", "10M", "11P", "12P", "13M", "14M", "15P"].map(Interval.simplify)
 * // => [ "8P", "2M", "3M", "4P", "5P", "6M", "7M", "8P" ]
 * Interval.simplify("2M") // => "2M"
 * Interval.simplify("-2M") // => "7m"
 */
var simplify = function (str) {
  var p = props(str);
  if (p === NO_IVL) { return null; }
  return p.simple + p.q;
};

/**
 * Get the inversion (https://en.wikipedia.org/wiki/Inversion_(music)#Intervals)
 * of an interval.
 *
 * @function
 * @param {String} interval - the interval to invert in interval shorthand
 * notation or interval array notation
 * @return {String} the inverted interval
 *
 * @example
 * Interval.invert("3m") // => "6M"
 * Interval.invert("2M") // => "7m"
 */
var invert = function (str) {
  var p = props(str);
  if (p === NO_IVL) { return null; }
  var step = (7 - p.step) % 7;
  var alt = p.type === "P" ? -p.alt : -(p.alt + 1);
  return build({ step: step, alt: alt, oct: p.oct, dir: p.dir });
};

// interval numbers
var IN = [1, 2, 2, 3, 3, 4, 5, 5, 6, 6, 7, 7];
// interval qualities
var IQ = "P m M m M P d P m M m M".split(" ");

/**
 * Get interval name from semitones number. Since there are several interval
 * names for the same number, the name it"s arbitraty, but deterministic.
 *
 * @function
 * @param {Integer} num - the number of semitones (can be negative)
 * @return {String} the interval name
 * @example
 * import { fromSemitones } from "tonal-interval"
 * fromSemitones(7) // => "5P"
 * // or using tonal
 * Tonal.Distance.fromSemitones(-7) // => "-5P"
 */
var fromSemitones = function (num) {
  var d = num < 0 ? -1 : 1;
  var n = Math.abs(num);
  var c = n % 12;
  var o = Math.floor(n / 12);
  return d * (IN[c] + 7 * o) + IQ[c];
};


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["transpose"] = transpose;
/* harmony export (immutable) */ __webpack_exports__["trFifths"] = trFifths;
/* harmony export (immutable) */ __webpack_exports__["fifths"] = fifths;
/* harmony export (immutable) */ __webpack_exports__["transposeBy"] = transposeBy;
/* harmony export (immutable) */ __webpack_exports__["addIntervals"] = addIntervals;
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["interval"] = interval;
/* harmony export (immutable) */ __webpack_exports__["semitones"] = semitones;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_note__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tonal_interval__ = __webpack_require__(148);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-distance.svg)](https://www.npmjs.com/package/tonal-distance)
 * [![tonal](https://img.shields.io/badge/tonal-distance-yellow.svg)](https://github.com/danigb/tonal/tree/master/packages/tonal/distance)
 *
 * Transpose notes by intervals and find distances between notes
 *
 * @example
 * // es6
 * import * as Distance from "tonal-distance"
 * Distance.interval("C3", "C4") // => "1P"
 *
 * @example
 * // es6 import selected functions
 * import { interval, semitones, transpose } from "tonal-distance"
 *
 * semitones("C" ,"D") // => 2
 * interval("C4", "G4") // => "5P"
 * transpose("C4", "P5") // => "G4"
 *
 * @example
 * // included in tonal facade
 * const Tonal = require("tonal");
 * Tonal.Distance.transpose("C4", "P5")
 * Tonal.Distance.transposeBy("P5", "C4")
 *
 * @module Distance
 */



// Map from letter step to number of fifths starting from "C":
// { C: 0, D: 2, E: 4, F: -1, G: 1, A: 3, B: 5 }
var FIFTHS = [0, 2, 4, -1, 1, 3, 5];

// Given a number of fifths, return the octaves they span
var fOcts = function (f) { return Math.floor(f * 7 / 12); };

// Get the number of octaves it span each step
var FIFTH_OCTS = FIFTHS.map(fOcts);

var encode = function (ref) {
  var step = ref.step;
  var alt = ref.alt;
  var oct = ref.oct;
  var dir = ref.dir; if ( dir === void 0 ) dir = 1;

  var f = FIFTHS[step] + 7 * alt;
  if (oct === null) { return [dir * f]; }
  var o = oct - FIFTH_OCTS[step] - 4 * alt;
  return [dir * f, dir * o];
};

// We need to get the steps from fifths
// Fifths for CDEFGAB are [ 0, 2, 4, -1, 1, 3, 5 ]
// We add 1 to fifths to avoid negative numbers, so:
// for ["F", "C", "G", "D", "A", "E", "B"] we have:
var STEPS = [3, 0, 4, 1, 5, 2, 6];

// Return the number of fifths as if it were unaltered
function unaltered(f) {
  var i = (f + 1) % 7;
  return i < 0 ? 7 + i : i;
}

var decode = function (f, o, dir) {
  var step = STEPS[unaltered(f)];
  var alt = Math.floor((f + 1) / 7);
  if (o === undefined) { return { step: step, alt: alt, dir: dir }; }
  var oct = o + 4 * alt + FIFTH_OCTS[step];
  return { step: step, alt: alt, oct: oct, dir: dir };
};

var memo = function (fn, cache) {
  if ( cache === void 0 ) cache = {};

  return function (str) { return cache[str] || (cache[str] = fn(str)); };
};

var encoder = function (props) { return memo(function (str) {
    var p = props(str);
    return p.name === null ? null : encode(p);
  }); };

var encodeNote = encoder(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["g" /* props */]);
var encodeIvl = encoder(__WEBPACK_IMPORTED_MODULE_1_tonal_interval__["props"]);

/**
 * Transpose a note by an interval. The note can be a pitch class.
 *
 * This function can be partially applied.
 *
 * @param {String} note
 * @param {String} interval
 * @return {String} the transposed note
 * @example
 * import { tranpose } from "tonal-distance"
 * transpose("d3", "3M") // => "F#3"
 * // it works with pitch classes
 * transpose("D", "3M") // => "F#"
 * // can be partially applied
 * ["C", "D", "E", "F", "G"].map(transpose("M3)) // => ["E", "F#", "G#", "A", "B"]
 */
function transpose(note, interval) {
  if (arguments.length === 1) { return function (i) { return transpose(note, i); }; }
  var n = encodeNote(note);
  var i = encodeIvl(interval);
  if (n === null || i === null) { return null; }
  var tr = n.length === 1 ? [n[0] + i[0]] : [n[0] + i[0], n[1] + i[1]];
  return Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["a" /* build */])(decode(tr[0], tr[1]));
}

/**
 * Transpose a pitch class by a number of perfect fifths.
 *
 * It can be partially applied.
 *
 * @function
 * @param {String} pitchClass - the pitch class
 * @param {Integer} fifhts - the number of fifths
 * @return {String} the transposed pitch class
 *
 * @example
 * import { trFifths } from "tonal-transpose"
 * [0, 1, 2, 3, 4].map(trFifths("C")) // => ["C", "G", "D", "A", "E"]
 * // or using tonal
 * Distance.trFifths("G4", 1) // => "D"
 */

function trFifths(note, fifths) {
  if (arguments.length === 1) { return function (f) { return trFifths(note, f); }; }
  var n = encodeNote(note);
  if (n === null) { return null; }
  return Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["a" /* build */])(decode(n[0] + fifths));
}

/**
 * Get the distance in fifths between pitch classes
 *
 * Can be partially applied.
 *
 * @param {String} to - note or pitch class
 * @param {String} from - note or pitch class
 */
function fifths(from, to) {
  if (arguments.length === 1) { return function (to) { return fifths(from, to); }; }
  var f = encodeNote(from);
  var t = encodeNote(to);
  if (t === null || f === null) { return null; }
  return t[0] - f[0];
}

/**
 * The same as transpose with the arguments inverted.
 *
 * Can be partially applied.
 *
 * @param {String} note
 * @param {String} interval
 * @return {String} the transposed note
 * @example
 * import { tranposeBy } from "tonal-distance"
 * transposeBy("3m", "5P") // => "7m"
 */
function transposeBy(interval, note) {
  if (arguments.length === 1) { return function (n) { return transpose(n, interval); }; }
  return transpose(note, interval);
}

var isDescending = function (e) { return e[0] * 7 + e[1] * 12 < 0; };
var decodeIvl = function (i) { return isDescending(i) ? decode(-i[0], -i[1], -1) : decode(i[0], i[1], 1); };

function addIntervals(ivl1, ivl2, dir) {
  var i1 = encodeIvl(ivl1);
  var i2 = encodeIvl(ivl2);
  if (i1 === null || i2 === null) { return null; }
  var i = [i1[0] + dir * i2[0], i1[1] + dir * i2[1]];
  return Object(__WEBPACK_IMPORTED_MODULE_1_tonal_interval__["build"])(decodeIvl(i));
}

/**
 * Add two intervals
 *
 * Can be partially applied.
 *
 * @param {String} interval1
 * @param {String} interval2
 * @return {String} the resulting interval
 * @example
 * import { add } from "tonal-distance"
 * add("3m", "5P") // => "7m"
 */
function add(ivl1, ivl2) {
  if (arguments.length === 1) { return function (i2) { return add(ivl1, i2); }; }
  return addIntervals(ivl1, ivl2, 1);
}

/**
 * Subtract two intervals
 *
 * Can be partially applied
 *
 * @param {String} minuend
 * @param {String} subtrahend
 * @return {String} interval diference
 */
function subtract(ivl1, ivl2) {
  if (arguments.length === 1) { return function (i2) { return add(ivl1, i2); }; }
  return addIntervals(ivl1, ivl2, -1);
}

/**
 * Find the interval between two pitches. It works with pitch classes
 * (both must be pitch classes and the interval is always ascending)
 *
 * Can be partially applied
 *
 * @param {String} from - distance from
 * @param {String} to - distance to
 * @return {String} the interval distance
 *
 * @example
 * import { interval } from "tonal-distance"
 * interval("C2", "C3") // => "P8"
 * interval("G", "B") // => "M3"
 *
 * @example
 * import * as Distance from "tonal-distance"
 * Distance.interval("M2", "P5") // => "P4"
 */
function interval(from, to) {
  if (arguments.length === 1) { return function (t) { return interval(from, t); }; }
  var f = encodeNote(from);
  var t = encodeNote(to);
  if (f === null || t === null || f.length !== t.length) { return null; }
  var d =
    f.length === 1
      ? [t[0] - f[0], -Math.floor((t[0] - f[0]) * 7 / 12)]
      : [t[0] - f[0], t[1] - f[1]];
  return Object(__WEBPACK_IMPORTED_MODULE_1_tonal_interval__["build"])(decodeIvl(d));
}

/**
 * Get the distance between two notes in semitones
 *
 * @param {String|Pitch} from - first note
 * @param {String|Pitch} to - last note
 * @return {Integer} the distance in semitones or null if not valid notes
 * @example
 * import { semitones } from "tonal-distance"
 * semitones("C3", "A2") // => -3
 * // or use tonal
 * Tonal.Distance.semitones("C3", "G3") // => 7
 */
function semitones(from, to) {
  if (arguments.length === 1) { return function (t) { return semitones(from, t); }; }
  var f = Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["g" /* props */])(from);
  var t = Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["g" /* props */])(to);
  return f.midi !== null && t.midi !== null
    ? t.midi - f.midi
    : f.chroma !== null && t.chroma !== null
      ? (t.chroma - f.chroma + 12) % 12
      : null;
}


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dictionary */
/* unused harmony export combine */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chord; });
/* unused harmony export pcset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_scales_json__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_scales_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_scales_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_chords_json__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_chords_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_chords_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tonal_pcset__ = __webpack_require__(100);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-dictionary.svg)](https://www.npmjs.com/package/tonal-dictionary)
 *
 * `tonal-dictionary` contains a dictionary of musical scales and chords
 *
 * This is part of [tonal](https://www.npmjs.com/package/tonal) music theory library.
 *
 * @example
 * // es6
 * import * as Dictionary from "tonal-dictionary"
 * // es5
 * const Dictionary = require("tonal-dictionary")
 *
 * @example
 * Dictionary.chord("Maj7") // => ["1P", "3M", "5P", "7M"]
 *
 * @module Dictionary
 */




var dictionary = function (raw) {
  var keys = Object.keys(raw).sort();
  var data = [];
  var index = [];

  var add = function (name, ivls, chroma) {
    data[name] = ivls;
    index[chroma] = index[chroma] || [];
    index[chroma].push(name);
  };

  keys.forEach(function (key) {
    var ivls = raw[key][0].split(" ");
    var alias = raw[key][1];
    var chr = Object(__WEBPACK_IMPORTED_MODULE_2_tonal_pcset__["a" /* chroma */])(ivls);

    add(key, ivls, chr);
    if (alias) { alias.forEach(function (a) { return add(a, ivls, chr); }); }
  });
  var allKeys = Object.keys(data).sort();

  var dict = function (name) { return data[name]; };
  dict.names = function (p) {
    if (typeof p === "string") { return (index[p] || []).slice(); }
    else { return (p === true ? allKeys : keys).slice(); }
  };
  return dict;
};

var combine = function (a, b) {
  var dict = function (name) { return a(name) || b(name); };
  dict.names = function (p) { return a.names(p).concat(b.names(p)); };
  return dict;
};

/**
 * A dictionary of scales: a function that given a scale name (without tonic)
 * returns an array of intervals
 *
 * @function
 * @param {String} name
 * @return {Array} intervals
 * @example
 * import { scale } from "tonal-dictionary"
 * scale("major") // => ["1P", "2M", ...]
 * scale.names(); // => ["major", ...]
 */
var scale = dictionary(__WEBPACK_IMPORTED_MODULE_0__data_scales_json___default.a);

/**
 * A dictionary of chords: a function that given a chord type
 * returns an array of intervals
 *
 * @function
 * @param {String} type
 * @return {Array} intervals
 * @example
 * import { chord } from "tonal-dictionary"
 * chord("Maj7") // => ["1P", "3M", ...]
 * chord.names(); // => ["Maj3", ...]
 */
var chord = dictionary(__WEBPACK_IMPORTED_MODULE_1__data_chords_json___default.a);
var pcset = combine(scale, chord);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(219);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(153);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(251);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(244);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(160);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(102);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(104)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(7);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(16);
var toIObject = __webpack_require__(21);
var arrayIndexOf = __webpack_require__(80)(false);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(42);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(21);
var gOPN = __webpack_require__(45).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(42);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(69);
var toObject = __webpack_require__(11);
var IObject = __webpack_require__(68);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(12);
var isObject = __webpack_require__(6);
var invoke = __webpack_require__(168);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(57).trim;
var ws = __webpack_require__(110);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(57).trim;

module.exports = 1 / $parseFloat(__webpack_require__(110) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(25);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(6);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(113);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(12);
var toObject = __webpack_require__(11);
var IObject = __webpack_require__(68);
var toLength = __webpack_require__(10);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(11);
var toAbsoluteIndex = __webpack_require__(43);
var toLength = __webpack_require__(10);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(9).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(85)
});


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(128);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(183);
var validate = __webpack_require__(59);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(88)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(9).f;
var create = __webpack_require__(44);
var redefineAll = __webpack_require__(49);
var ctx = __webpack_require__(24);
var anInstance = __webpack_require__(47);
var forOf = __webpack_require__(48);
var $iterDefine = __webpack_require__(116);
var step = __webpack_require__(178);
var setSpecies = __webpack_require__(46);
var DESCRIPTORS = __webpack_require__(8);
var fastKey = __webpack_require__(36).fastKey;
var validate = __webpack_require__(59);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(183);
var validate = __webpack_require__(59);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(88)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(33)(0);
var redefine = __webpack_require__(18);
var meta = __webpack_require__(36);
var assign = __webpack_require__(166);
var weak = __webpack_require__(186);
var isObject = __webpack_require__(6);
var fails = __webpack_require__(4);
var validate = __webpack_require__(59);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(88)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(49);
var getWeak = __webpack_require__(36).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(6);
var anInstance = __webpack_require__(47);
var forOf = __webpack_require__(48);
var createArrayMethod = __webpack_require__(33);
var $has = __webpack_require__(16);
var validate = __webpack_require__(59);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(10);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(45);
var gOPS = __webpack_require__(81);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(82);
var isObject = __webpack_require__(6);
var toLength = __webpack_require__(10);
var ctx = __webpack_require__(24);
var IS_CONCAT_SPREADABLE = __webpack_require__(7)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(10);
var repeat = __webpack_require__(112);
var defined = __webpack_require__(30);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(42);
var toIObject = __webpack_require__(21);
var isEnum = __webpack_require__(69).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(70);
var from = __webpack_require__(193);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(48);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(476);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(52) && !__webpack_require__(72)(function () {
  return Object.defineProperty(__webpack_require__(197)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
var document = __webpack_require__(38).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(53);
var toIObject = __webpack_require__(63);
var arrayIndexOf = __webpack_require__(478)(false);
var IE_PROTO = __webpack_require__(134)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(200);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 200 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(132);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(138);
var $export = __webpack_require__(60);
var redefine = __webpack_require__(203);
var hide = __webpack_require__(61);
var has = __webpack_require__(53);
var Iterators = __webpack_require__(139);
var $iterCreate = __webpack_require__(485);
var setToStringTag = __webpack_require__(141);
var getPrototypeOf = __webpack_require__(488);
var ITERATOR = __webpack_require__(64)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(61);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(198);
var hiddenKeys = __webpack_require__(136).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(96);
var createDesc = __webpack_require__(93);
var toIObject = __webpack_require__(63);
var toPrimitive = __webpack_require__(131);
var has = __webpack_require__(53);
var IE8_DOM_DEFINE = __webpack_require__(196);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(52) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);

/* eslint-disable react/prop-types */


var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;


  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positonStyle);
  return included ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: className, style: elStyle }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Steps__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Marks__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Handle__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(146);















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["e" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
        __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_13__utils__["h" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["f" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd(e);
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["e" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_13__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["f" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    ComponentEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (_Component.prototype.componentWillUnmount) _Component.prototype.componentWillUnmount.call(this);
      this.removeDocumentEvents();
    };

    ComponentEnhancer.prototype.componentDidMount = function componentDidMount() {
      // Snapshot testing cannot handle refs, so be sure to null-check this.
      this.document = this.sliderRef && this.sliderRef.ownerDocument;
    };

    ComponentEnhancer.prototype.addDocumentTouchEvents = function addDocumentTouchEvents() {
      // just work for Chrome iOS Safari and Android Browser
      this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
      this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
    };

    ComponentEnhancer.prototype.addDocumentMouseEvents = function addDocumentMouseEvents() {
      this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
    };

    ComponentEnhancer.prototype.removeDocumentEvents = function removeDocumentEvents() {
      /* eslint-disable no-unused-expressions */
      this.onTouchMoveListener && this.onTouchMoveListener.remove();
      this.onTouchUpListener && this.onTouchUpListener.remove();

      this.onMouseMoveListener && this.onMouseMoveListener.remove();
      this.onMouseUpListener && this.onMouseUpListener.remove();
      /* eslint-enable no-unused-expressions */
    };

    ComponentEnhancer.prototype.focus = function focus() {
      if (!this.props.disabled) {
        this.handlesRefs[0].focus();
      }
    };

    ComponentEnhancer.prototype.blur = function blur() {
      if (!this.props.disabled) {
        this.handlesRefs[0].blur();
      }
    };

    ComponentEnhancer.prototype.getSliderStart = function getSliderStart() {
      var slider = this.sliderRef;
      var rect = slider.getBoundingClientRect();

      return this.props.vertical ? rect.top : rect.left;
    };

    ComponentEnhancer.prototype.getSliderLength = function getSliderLength() {
      var slider = this.sliderRef;
      if (!slider) {
        return 0;
      }

      var coords = slider.getBoundingClientRect();
      return this.props.vertical ? coords.height : coords.width;
    };

    ComponentEnhancer.prototype.calcValue = function calcValue(offset) {
      var _props = this.props,
          vertical = _props.vertical,
          min = _props.min,
          max = _props.max;

      var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
      var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
      return value;
    };

    ComponentEnhancer.prototype.calcValueByPos = function calcValueByPos(position) {
      var pixelOffset = position - this.getSliderStart();
      var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
      return nextValue;
    };

    ComponentEnhancer.prototype.calcOffset = function calcOffset(value) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;

      var ratio = (value - min) / (max - min);
      return ratio * 100;
    };

    ComponentEnhancer.prototype.saveHandle = function saveHandle(index, handle) {
      this.handlesRefs[index] = handle;
    };

    ComponentEnhancer.prototype.render = function render() {
      var _classNames;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          className = _props3.className,
          marks = _props3.marks,
          dots = _props3.dots,
          step = _props3.step,
          included = _props3.included,
          disabled = _props3.disabled,
          vertical = _props3.vertical,
          min = _props3.min,
          max = _props3.max,
          children = _props3.children,
          maximumTrackStyle = _props3.maximumTrackStyle,
          style = _props3.style,
          railStyle = _props3.railStyle,
          dotStyle = _props3.dotStyle,
          activeDotStyle = _props3.activeDotStyle;

      var _Component$prototype$ = _Component.prototype.render.call(this),
          tracks = _Component$prototype$.tracks,
          handles = _Component$prototype$.handles;

      var sliderClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, (_classNames = {}, _classNames[prefixCls + '-with-marks'] = Object.keys(marks).length, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-vertical'] = vertical, _classNames[className] = className, _classNames));
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: prefixCls + '-rail',
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, maximumTrackStyle, railStyle)
        }),
        tracks,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Steps__["a" /* default */], {
          prefixCls: prefixCls,
          vertical: vertical,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }),
        handles,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Marks__["a" /* default */], {
          className: prefixCls + '-mark',
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min
        }),
        children
      );
    };

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, // just for compatibility, will be deperecate
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, // just for compatibility, will be deperecate
    handleStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object)]),
    trackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object)]),
    railStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    dotStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    activeDotStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(537), __esModule: true };

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopupClassNameFromAlign;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(215);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}//TODO: rewrite transpose function
// посмотреть music.js vexflow
//Note.fromMidi(61, true) // => "C#4"//
//note-parser
var Transposer=function(){function Transposer(signature){_classCallCheck(this,Transposer);this.keyAccidentals=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* keysAccidentals */][signature];this.keyShift=__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* keysShifts */][signature];this.accidentals={};this.originalAccidentals={};}_createClass(Transposer,[{key:'resetAccidentals',value:function resetAccidentals(){this.accidentals={};this.originalAccidentals={};}},{key:'transpose',value:function transpose(key,duration){// не транспонировать паузы
// todo: транспонировать если несколько голосов
if(duration.charAt(duration.length-1)==='r'){return{trStep:key.step,trAccidental:key.acc||"",trOctave:key.oct};}var step=key.step,octave=key.oct,accidental=key.acc;var isNatural=accidental==='n';if(accidental){this.originalAccidentals[step+octave]=accidental;}// при проигрывании
var removeAccidental=false;if(!accidental&&this.originalAccidentals[step+octave]&&this.originalAccidentals[step+octave]!=='n'){accidental=this.originalAccidentals[step+octave];removeAccidental=true;}var transposedKey=__WEBPACK_IMPORTED_MODULE_0_tonal__["a" /* Distance */].transpose(step+(isNatural?'':accidental||'')+octave,__WEBPACK_IMPORTED_MODULE_0_tonal__["b" /* Interval */].fromSemitones(this.keyShift));var length=transposedKey.length;var trStepAcc=transposedKey.substr(0,length-1);var trStep=trStepAcc.slice(0,1);var trAccidental=trStepAcc.slice(1,trStepAcc.length+1||9e9)||'';var trOctave=transposedKey.substr(length-1);var trKey={trStep:trStep,trAccidental:trAccidental,trOctave:trOctave,trPitch:''+trStep+trAccidental+trOctave};if(this.keyAccidentals[trStep]&&this.keyAccidentals[trStep]===trAccidental&&this.accidentals[trStep+trOctave]!=='n'){//есть знак при ключе и ранее он не был отменен
trKey.trAccidental='';}if(trAccidental){this.accidentals[trStep+trOctave]=trAccidental;}if(!trAccidental&&(this.keyAccidentals[trStep]||isNatural)){//если знак при ключе, но надо сыграть без знака или ранее была отмена, то бекар 
this.accidentals[trStep+trOctave]='n';trKey.trAccidental='n';}if(removeAccidental){trKey.trAccidental='';}return trKey;}}]);return Transposer;}();/* harmony default export */ __webpack_exports__["a"] = (Transposer);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keysShifts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keysAccidentals; });
var keysShifts={'C':0,'Db':1,'D':2,'Eb':3,'E':4,'F':5,'Gb':6,'G':-5,'Ab':-4,'A':-3,'Bb':-2,'B':-1};var durations={'64':0.0625,'32':0.125,'16':0.25,'8':0.5,'q':1,'h':2,'w':4};var keysAccidentals={'C':{},'Db':{'B':'b','E':'b','A':'b','D':'b','G':'b'},'D':{'F':'#','C':'#'},'Eb':{'B':'b','E':'b','A':'b'},'E':{'F':'#','C':'#','G':'#','D':'#'},'F':{'B':'b'},'Gb':{'B':'b','E':'b','A':'b','D':'b','G':'b','C':'b'},'G':{'F':'#'},'Ab':{'B':'b','E':'b','A':'b','D':'b'},'A':{'F':'#','C':'#','G':'#'},'Bb':{'B':'b','E':'b'},'B':{'F':'#','C':'#','G':'#','D':'#','A':'#'}};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217);
module.exports = __webpack_require__(222);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(218).enable();
  window.Promise = __webpack_require__(220);
}

// fetch() polyfill for making API calls.
__webpack_require__(221);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(76);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(151);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(151);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_App__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_configureStore__ = __webpack_require__(572);
var store=Object(__WEBPACK_IMPORTED_MODULE_7__store_configureStore__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_App__["a" /* default */],null)),document.getElementById('root'));// инициализация приложения: загрузка пресетов, сэмплов и т.д.
// store.dispatch(initApp({
// }));
Object(__WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(76),n=__webpack_require__(152),p=__webpack_require__(77),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),l=__webpack_require__(225),B=__webpack_require__(76),C=__webpack_require__(77),ba=__webpack_require__(226),da=__webpack_require__(227),ea=__webpack_require__(228),fa=__webpack_require__(229),ia=__webpack_require__(232),D=__webpack_require__(152);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(77);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(230);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(231);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(77);
var invariant = __webpack_require__(235);
var ReactPropTypesSecret = __webpack_require__(236);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(259);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(159);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(247);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(245);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(156);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(249);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(253);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67), __webpack_require__(252)(module)))

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(157);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(159);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(160);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(260);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(102);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(262);

__webpack_require__(459);

__webpack_require__(460);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(263);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(125);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(179);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(182);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
module.exports = __webpack_require__(28);


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(18);
var META = __webpack_require__(36).KEY;
var $fails = __webpack_require__(4);
var shared = __webpack_require__(79);
var setToStringTag = __webpack_require__(56);
var uid = __webpack_require__(40);
var wks = __webpack_require__(7);
var wksExt = __webpack_require__(162);
var wksDefine = __webpack_require__(105);
var enumKeys = __webpack_require__(264);
var isArray = __webpack_require__(82);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(6);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(29);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(44);
var gOPNExt = __webpack_require__(165);
var $GOPD = __webpack_require__(22);
var $DP = __webpack_require__(9);
var $keys = __webpack_require__(42);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(45).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(69).f = $propertyIsEnumerable;
  __webpack_require__(81).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(41)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(17)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(42);
var gOPS = __webpack_require__(81);
var pIE = __webpack_require__(69);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(44) });


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(9).f });


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperties: __webpack_require__(164) });


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(21);
var $getOwnPropertyDescriptor = __webpack_require__(22).f;

__webpack_require__(32)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(11);
var $getPrototypeOf = __webpack_require__(23);

__webpack_require__(32)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(11);
var $keys = __webpack_require__(42);

__webpack_require__(32)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(32)('getOwnPropertyNames', function () {
  return __webpack_require__(165).f;
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(36).onFreeze;

__webpack_require__(32)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(36).onFreeze;

__webpack_require__(32)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(6);
var meta = __webpack_require__(36).onFreeze;

__webpack_require__(32)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(6);

__webpack_require__(32)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(166) });


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(280) });


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(109).set });


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(70);
var test = {};
test[__webpack_require__(7)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(167) });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(23);
var HAS_INSTANCE = __webpack_require__(7)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(9).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(169);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(170);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(16);
var cof = __webpack_require__(25);
var inheritIfRequired = __webpack_require__(111);
var toPrimitive = __webpack_require__(29);
var fails = __webpack_require__(4);
var gOPN = __webpack_require__(45).f;
var gOPD = __webpack_require__(22).f;
var dP = __webpack_require__(9).f;
var $trim = __webpack_require__(57).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(44)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(8) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(18)(global, NUMBER, $Number);
}


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(31);
var aNumberValue = __webpack_require__(171);
var repeat = __webpack_require__(112);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(4)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(4);
var aNumberValue = __webpack_require__(171);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(172) });


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(172);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(170);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(169);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(173);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(113);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(114);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(174) });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(173) });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(113) });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(114);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(114);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(43);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(21);
var toLength = __webpack_require__(10);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(57)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(115)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(116)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(115)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(10);
var context = __webpack_require__(118);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(119)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(118);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(119)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(112)
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(10);
var context = __webpack_require__(118);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(119)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(19)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(19)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(19)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(19)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(19)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(19)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(19)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(19)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(19)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(19)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(19)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(19)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(19)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(29);

$export($export.P + $export.F * __webpack_require__(4)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(342);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(4);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(7)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(17)(proto, TO_PRIMITIVE, __webpack_require__(345));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(82) });


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(24);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var call = __webpack_require__(175);
var isArrayIter = __webpack_require__(120);
var toLength = __webpack_require__(10);
var createProperty = __webpack_require__(121);
var getIterFn = __webpack_require__(122);

$export($export.S + $export.F * !__webpack_require__(84)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(121);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(4)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(21);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(68) != Object || !__webpack_require__(26)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(108);
var cof = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(43);
var toLength = __webpack_require__(10);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(4)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var toObject = __webpack_require__(11);
var fails = __webpack_require__(4);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(26)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(33)(0);
var STRICT = __webpack_require__(26)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var isArray = __webpack_require__(82);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(33)(1);

$export($export.P + $export.F * !__webpack_require__(26)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(33)(2);

$export($export.P + $export.F * !__webpack_require__(26)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(33)(3);

$export($export.P + $export.F * !__webpack_require__(26)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(33)(4);

$export($export.P + $export.F * !__webpack_require__(26)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(176);

$export($export.P + $export.F * !__webpack_require__(26)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(176);

$export($export.P + $export.F * !__webpack_require__(26)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(80)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(26)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(21);
var toInteger = __webpack_require__(31);
var toLength = __webpack_require__(10);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(26)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(177) });

__webpack_require__(37)('copyWithin');


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(124) });

__webpack_require__(37)('fill');


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(37)(KEY);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(33)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(37)(KEY);


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46)('Array');


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(111);
var dP = __webpack_require__(9).f;
var gOPN = __webpack_require__(45).f;
var isRegExp = __webpack_require__(83);
var $flags = __webpack_require__(85);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(4)(function () {
  re2[__webpack_require__(7)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(18)(global, 'RegExp', $RegExp);
}

__webpack_require__(46)('RegExp');


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(179);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(85);
var DESCRIPTORS = __webpack_require__(8);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(4)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(86)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(86)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(86)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(86)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(83);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(41);
var global = __webpack_require__(3);
var ctx = __webpack_require__(24);
var classof = __webpack_require__(70);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(6);
var aFunction = __webpack_require__(12);
var anInstance = __webpack_require__(47);
var forOf = __webpack_require__(48);
var speciesConstructor = __webpack_require__(87);
var task = __webpack_require__(126).set;
var microtask = __webpack_require__(127)();
var newPromiseCapabilityModule = __webpack_require__(128);
var perform = __webpack_require__(180);
var promiseResolve = __webpack_require__(181);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(7)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(49)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(56)($Promise, PROMISE);
__webpack_require__(46)(PROMISE);
Wrapper = __webpack_require__(28)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(84)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(186);
var validate = __webpack_require__(59);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(88)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(89);
var buffer = __webpack_require__(129);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(43);
var toLength = __webpack_require__(10);
var isObject = __webpack_require__(6);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(87);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(46)(ARRAY_BUFFER);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(89).ABV, {
  DataView: __webpack_require__(129).DataView
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(4)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(44);
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(6);
var fails = __webpack_require__(4);
var bind = __webpack_require__(167);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(9);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(4)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(22).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(117)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(23);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(6);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(22);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(23);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(188) });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(9);
var gOPD = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(23);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(39);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(6);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(109);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(80)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(37)('includes');


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(189);
var toObject = __webpack_require__(11);
var toLength = __webpack_require__(10);
var aFunction = __webpack_require__(12);
var arraySpeciesCreate = __webpack_require__(123);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(37)('flatMap');


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(189);
var toObject = __webpack_require__(11);
var toLength = __webpack_require__(10);
var toInteger = __webpack_require__(31);
var arraySpeciesCreate = __webpack_require__(123);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(37)('flatten');


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(115)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(190);
var userAgent = __webpack_require__(130);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(190);
var userAgent = __webpack_require__(130);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(57)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(57)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var toLength = __webpack_require__(10);
var isRegExp = __webpack_require__(83);
var getFlags = __webpack_require__(85);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(117)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('asyncIterator');


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('observable');


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(188);
var toIObject = __webpack_require__(21);
var gOPD = __webpack_require__(22);
var createProperty = __webpack_require__(121);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(191)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(191)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var aFunction = __webpack_require__(12);
var $defineProperty = __webpack_require__(9);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(8) && $export($export.P + __webpack_require__(90), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var aFunction = __webpack_require__(12);
var $defineProperty = __webpack_require__(9);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(8) && $export($export.P + __webpack_require__(90), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(23);
var getOwnPropertyDescriptor = __webpack_require__(22).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(90), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(23);
var getOwnPropertyDescriptor = __webpack_require__(22).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(90), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(192)('Map') });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(192)('Set') });


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(91)('Map');


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(91)('Set');


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(91)('WeakMap');


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(91)('WeakSet');


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(92)('Map');


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(92)('Set');


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(92)('WeakMap');


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(92)('WeakSet');


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(3) });


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(3) });


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(25);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(194);
var fround = __webpack_require__(174);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(194) });


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(28);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(87);
var promiseResolve = __webpack_require__(181);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(128);
var perform = __webpack_require__(180);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(23);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(184);
var from = __webpack_require__(193);
var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(23);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(23);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(35);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(12);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(127)();
var process = __webpack_require__(3).process;
var isNode = __webpack_require__(25)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(3);
var core = __webpack_require__(28);
var microtask = __webpack_require__(127)();
var OBSERVABLE = __webpack_require__(7)('observable');
var aFunction = __webpack_require__(12);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(47);
var redefineAll = __webpack_require__(49);
var hide = __webpack_require__(17);
var forOf = __webpack_require__(48);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(46)('Observable');


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(130);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(126);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(125);
var getKeys = __webpack_require__(42);
var redefine = __webpack_require__(18);
var global = __webpack_require__(3);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(58);
var wks = __webpack_require__(7);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(461);
module.exports = __webpack_require__(28).RegExp.escape;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(462)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Header__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Scheme__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_SheetContainer__ = __webpack_require__(561);
var App=function App(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_Scheme__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_SheetContainer__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Settings__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_player__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PlayButton__ = __webpack_require__(550);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.state={showSettings:false},_this.toggleSettings=function(){_this.setState({showSettings:!_this.state.showSettings});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_PlayButton__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-header button-settings',onClick:this.toggleSettings})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_Settings__["a" /* default */],{visible:this.state.showSettings}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;var mapStateToProps=function mapStateToProps(state){var _state$player=state.player,isPlaying=_state$player.isPlaying,isLoading=_state$player.isLoading;return{isPlaying:isPlaying,isLoading:isLoading};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{play:function play(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_player__["a" /* play */])());},stop:function stop(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_player__["b" /* stop */])());}};};Header.propTypes={play:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isPlaying:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Header));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_settings__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_switch__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_slider__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var keys=[{value:'C',label:'C'},{value:'Db',label:'D♭'},{value:'D',label:'D'},{value:'Eb',label:'E♭'},{value:'E',label:'E'},{value:'F',label:'F'},{value:'Gb',label:'G♭'},{value:'G',label:'G'},{value:'Ab',label:'A♭'},{value:'A',label:'A'},{value:'Bb',label:'B♭'},{value:'B',label:'B'}];var Settings=function(_Component){_inherits(Settings,_Component);function Settings(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Settings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Settings.__proto__||Object.getPrototypeOf(Settings)).call.apply(_ref,[this].concat(args))),_this),_this.keyOnChange=function(option){_this.props.keyOnChange(option.value);},_this.tempoOnChange=function(value){_this.props.tempoOnChange(value);},_this.scaleOnChange=function(value){_this.props.scaleOnChange(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Settings,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'settings',className:this.props.visible?'slideIn':'slideOut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-header'},'Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-label'},'Swing 8th notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_switch___default.a,{onChange:this.props.toggleSwing,checked:this.props.swing,id:'swing',className:'swing-feel',onColor:'#28a37a',onHandleColor:'#eaecef',offColor:'#7c7a7a',handleDiameter:20,uncheckedIcon:false,checkedIcon:false,height:20,width:48}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-label'},'Tempo (bpm)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_slider__["a" /* default */],{value:this.props.tempo,min:50,max:130,onChange:this.tempoOnChange,trackStyle:{backgroundColor:'#b2b0b0'},handleStyle:{borderColor:'#eaecef',backgroundColor:'#eaecef'},railStyle:{backgroundColor:'#b2b0b0'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-label'},'Key (transposition)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{value:keys.find(function(key){return key.value===_this2.props.signature;}),onChange:this.keyOnChange,className:'select-key',name:'key',searchable:false,clearable:false,multi:false,onBlurResetsInput:false,onSelectResetsInput:false,options:keys,style:{width:60,backgroundColor:'#e8e8e8'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-label'},'Sheet scale'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setting-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_slider__["a" /* default */],{value:this.props.scale,min:80,max:100,onChange:this.scaleOnChange,trackStyle:{backgroundColor:'#b2b0b0'},handleStyle:{borderColor:'#eaecef',backgroundColor:'#eaecef'},railStyle:{backgroundColor:'#b2b0b0'}}))));}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var _state$settings=state.settings,key=_state$settings.key,tempo=_state$settings.tempo,swing=_state$settings.swing,scale=_state$settings.scale;return{signature:key,tempo:tempo,swing:swing,scale:scale};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{tempoOnChange:function tempoOnChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["c" /* setTempo */])(value));},keyOnChange:function keyOnChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["a" /* setKey */])(value));},scaleOnChange:function scaleOnChange(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["b" /* setScale */])(value));},toggleSwing:function toggleSwing(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["d" /* toggleSwing */])());}};};Settings.propTypes={signature:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,swing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,tempo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,scale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tempoOnChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,keyOnChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,scaleOnChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,toggleSwing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Settings));

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTempo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleSwing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setScale; });
var setTempo=function setTempo(value){return{type:'SET_TEMPO',tempo:value};};var setKey=function setKey(value){return{type:'SET_KEY',key:value};};var toggleSwing=function toggleSwing(){return{type:'TOGGLE_SWING'};};var setScale=function setScale(value){return{type:'SET_SCALE',scale:value};};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icons = __webpack_require__(469);

var _getBackgroundColor = __webpack_require__(470);

var _getBackgroundColor2 = _interopRequireDefault(_getBackgroundColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switch = function (_Component) {
  _inherits(Switch, _Component);

  function Switch(props) {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

    _initialiseProps.call(_this);

    var height = props.height,
        width = props.width,
        handleDiameter = props.handleDiameter,
        checked = props.checked;

    _this.handleDiameter = handleDiameter || height - 2;
    _this.checkedPos = Math.max(width - height, width - (height + _this.handleDiameter) / 2);
    _this.uncheckedPos = Math.max(0, (height - _this.handleDiameter) / 2);
    _this.state = {
      pos: checked ? _this.checkedPos : _this.uncheckedPos,
      startX: null,
      isDragging: false,
      hasOutline: false
    };
    return _this;
  }

  _createClass(Switch, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var checked = _ref.checked;

      var pos = checked ? this.checkedPos : this.uncheckedPos;
      this.setState({ pos: pos });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          checked = _props.checked,
          disabled = _props.disabled,
          className = _props.className,
          offColor = _props.offColor,
          onColor = _props.onColor,
          offHandleColor = _props.offHandleColor,
          onHandleColor = _props.onHandleColor,
          checkedIcon = _props.checkedIcon,
          uncheckedIcon = _props.uncheckedIcon,
          boxShadow = _props.boxShadow,
          activeBoxShadow = _props.activeBoxShadow,
          height = _props.height,
          width = _props.width,
          id = _props.id,
          ariaLabelledby = _props["aria-labelledby"],
          ariaLabel = _props["aria-label"];
      var _state = this.state,
          pos = _state.pos,
          isDragging = _state.isDragging,
          hasOutline = _state.hasOutline;


      var rootStyle = {
        position: "relative",
        display: "inline-block",
        opacity: disabled ? 0.5 : 1,
        borderRadius: height / 2,
        WebkitTransition: "opacity 0.25s",
        MozTransition: "opacity 0.25s",
        transition: "opacity 0.25s",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none"
      };

      var backgroundStyle = {
        height: height,
        width: width,
        margin: Math.max(0, (this.handleDiameter - height) / 2),
        position: "relative",
        background: (0, _getBackgroundColor2.default)(pos, this.checkedPos, this.uncheckedPos, offColor, onColor),
        borderRadius: height / 2,
        cursor: disabled ? "default" : "pointer",
        WebkitTransition: isDragging ? null : "background 0.25s",
        MozTransition: isDragging ? null : "background 0.25s",
        transition: isDragging ? null : "background 0.25s"
      };

      var checkedIconStyle = {
        height: height,
        width: Math.min(height * 1.5, width - (this.handleDiameter + height) / 2 + 1),
        position: "relative",
        opacity: (pos - this.uncheckedPos) / (this.checkedPos - this.uncheckedPos),
        pointerEvents: "none",
        WebkitTransition: isDragging ? null : "opacity 0.25s",
        MozTransition: isDragging ? null : "opacity 0.25s",
        transition: isDragging ? null : "opacity 0.25s"
      };

      var uncheckedIconStyle = {
        height: height,
        width: Math.min(height * 1.5, width - (this.handleDiameter + height) / 2 + 1),
        position: "absolute",
        opacity: 1 - (pos - this.uncheckedPos) / (this.checkedPos - this.uncheckedPos),
        right: 0,
        top: 0,
        pointerEvents: "none",
        WebkitTransition: isDragging ? null : "opacity 0.25s",
        MozTransition: isDragging ? null : "opacity 0.25s",
        transition: isDragging ? null : "opacity 0.25s"
      };

      var handleStyle = {
        height: this.handleDiameter,
        width: this.handleDiameter,
        background: (0, _getBackgroundColor2.default)(pos, this.checkedPos, this.uncheckedPos, offHandleColor, onHandleColor),
        cursor: disabled ? "default" : "pointer",
        display: "inline-block",
        borderRadius: "50%",
        position: "absolute",
        transform: "translateX(" + pos + "px)",
        top: Math.max(0, (height - this.handleDiameter) / 2),
        outline: 0,
        boxShadow: hasOutline ? activeBoxShadow : boxShadow,
        border: 0,
        WebkitTransition: isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        MozTransition: isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        transition: isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
      };

      return _react2.default.createElement(
        "div",
        { className: className, style: rootStyle },
        _react2.default.createElement(
          "div",
          {
            className: "react-switch-bg",
            style: backgroundStyle,
            onClick: disabled ? null : this.handleClick
          },
          checkedIcon && _react2.default.createElement(
            "div",
            { style: checkedIconStyle },
            checkedIcon
          ),
          uncheckedIcon && _react2.default.createElement(
            "div",
            { style: uncheckedIconStyle },
            uncheckedIcon
          )
        ),
        _react2.default.createElement("div", {
          className: "react-switch-handle",
          role: "checkbox",
          tabIndex: disabled ? null : 0,
          onMouseDown: disabled ? null : this.handleMouseDown,
          onTouchStart: disabled ? null : this.handleTouchStart,
          onTouchMove: disabled ? null : this.handleTouchMove,
          onTouchEnd: disabled ? null : this.handleTouchEnd,
          onTouchCancel: disabled ? null : this.handleTouchCancel,
          onKeyDown: this.handleKeyDown,
          onFocus: function onFocus() {
            return _this2.setState({ hasOutline: true });
          },
          onBlur: function onBlur() {
            return _this2.setState({ hasOutline: false });
          },
          style: handleStyle,
          id: id,
          "aria-checked": checked,
          "aria-disabled": disabled,
          "aria-labelledby": ariaLabelledby,
          "aria-label": ariaLabel
        })
      );
    }
  }]);

  return Switch;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleDragStart = function (clientX) {
    _this3.setState({ startX: clientX, hasOutline: true });
  };

  this.handleDrag = function (clientX) {
    var startX = _this3.state.startX;
    var checked = _this3.props.checked;

    var startPos = checked ? _this3.checkedPos : _this3.uncheckedPos;
    var newPos = startPos + clientX - startX;
    var pos = Math.min(_this3.checkedPos, Math.max(_this3.uncheckedPos, newPos));
    _this3.setState({ pos: pos, isDragging: true });
  };

  this.handleDragStop = function (event) {
    var _state2 = _this3.state,
        pos = _state2.pos,
        isDragging = _state2.isDragging;
    var _props2 = _this3.props,
        checked = _props2.checked,
        onChange = _props2.onChange,
        id = _props2.id;

    // Simulate clicking the handle

    if (!isDragging) {
      _this3.setState({ startX: null, hasOutline: false });
      onChange(!checked, event, id);
      return;
    }
    if (checked) {
      if (pos > (_this3.checkedPos + _this3.uncheckedPos) / 2) {
        _this3.setState({
          pos: _this3.checkedPos,
          startX: null,
          isDragging: false,
          hasOutline: false
        });
        return;
      }
      _this3.setState({ startX: null, isDragging: false, hasOutline: false });
      onChange(false, event, id);
      return;
    }
    if (pos < (_this3.checkedPos + _this3.uncheckedPos) / 2) {
      _this3.setState({
        pos: _this3.uncheckedPos,
        startX: null,
        isDragging: false,
        hasOutline: false
      });
      return;
    }
    _this3.setState({ startX: null, isDragging: false, hasOutline: false });
    onChange(true, event, id);
  };

  this.handleMouseDown = function (event) {
    // Ignore right click and scroll
    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    _this3.handleDragStart(event.clientX);
    document.addEventListener("mousemove", _this3.handleMouseMove);
    document.addEventListener("mouseup", _this3.handleMouseUp);
  };

  this.handleMouseMove = function (event) {
    event.preventDefault();
    _this3.handleDrag(event.clientX);
  };

  this.handleMouseUp = function (event) {
    _this3.handleDragStop(event);
    document.removeEventListener("mousemove", _this3.handleMouseMove);
    document.removeEventListener("mouseup", _this3.handleMouseUp);
  };

  this.handleTouchStart = function (event) {
    _this3.handleDragStart(event.touches[0].clientX);
  };

  this.handleTouchMove = function (event) {
    _this3.handleDrag(event.touches[0].clientX);
  };

  this.handleTouchEnd = function (event) {
    event.preventDefault();
    _this3.handleDragStop(event);
  };

  this.handleTouchCancel = function () {
    _this3.setState({ startX: null, hasOutline: false });
  };

  this.handleClick = function (event) {
    var _props3 = _this3.props,
        checked = _props3.checked,
        onChange = _props3.onChange,
        id = _props3.id;

    onChange(!checked, event, id);
  };

  this.handleKeyDown = function (event) {
    var _props4 = _this3.props,
        checked = _props4.checked,
        onChange = _props4.onChange,
        id = _props4.id;
    var isDragging = _this3.state.isDragging;
    // Trigger change on spacebar and enter keys (in violation of wai-aria spec).

    if ((event.keyCode === 32 || event.keyCode === 13) && !isDragging) {
      event.preventDefault();
      onChange(!checked, event, id);
    }
  };
};

Switch.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,
  offColor: _propTypes2.default.string,
  onColor: _propTypes2.default.string,
  offHandleColor: _propTypes2.default.string,
  onHandleColor: _propTypes2.default.string,
  handleDiameter: _propTypes2.default.number,
  uncheckedIcon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element]),
  checkedIcon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element]),
  boxShadow: _propTypes2.default.string,
  activeBoxShadow: _propTypes2.default.string,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  "aria-labelledby": _propTypes2.default.string,
  "aria-label": _propTypes2.default.string
};

Switch.defaultProps = {
  disabled: false,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  handleDiameter: null,
  uncheckedIcon: _icons.uncheckedIcon,
  checkedIcon: _icons.checkedIcon,
  boxShadow: null,
  activeBoxShadow: "0px 0px 2px 3px #33bbff",
  height: 28,
  width: 56,
  className: null,
  id: null,
  "aria-labelledby": null,
  "aria-label": null
};

exports.default = Switch;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkedIcon = exports.uncheckedIcon = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uncheckedIcon = exports.uncheckedIcon = _react2.default.createElement(
  "svg",
  {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: { position: "absolute", top: 0 }
  },
  _react2.default.createElement("path", {
    /* eslint-disable max-len */
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12"
    /* eslint-eable max-len */
    , fill: "#fff",
    fillRule: "evenodd"
  })
); /*
   The MIT License (MIT)
   
   Copyright (c) 2015 instructure-react
   
   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:
   
   The above copyright notice and this permission notice shall be included in all
   copies or substantial portions of the Software.
   
   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   SOFTWARE.
   */

var checkedIcon = exports.checkedIcon = _react2.default.createElement(
  "svg",
  {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: { position: "absolute", top: 0 }
  },
  _react2.default.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
  })
);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBackgroundColor;
function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);
  if (relativePos === 0) {
    return offColor;
  }
  if (relativePos === 1) {
    return onColor;
  }

  var newColor = "#";
  for (var i = 1; i < 6; i += 2) {
    var offComponent = parseInt(offColor.substr(i, 2), 16);
    var onComponent = parseInt(onColor.substr(i, 2), 16);
    var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
    var newComponent = weightedValue.toString(16);
    if (newComponent.length === 1) {
      newComponent = "0" + newComponent;
    }
    newColor += newComponent;
  }
  return newColor;
}

function convertShorthandColor(color) {
  if (color.length === 7) {
    return color;
  }
  var sixDigitColor = "#";
  for (var i = 1; i < 4; i += 1) {
    sixDigitColor += color[i] + color[i];
  }
  return sixDigitColor;
}

function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var sixDigitOffColor = convertShorthandColor(offColor);
  var sixDigitOnColor = convertShorthandColor(onColor);
  return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(518);
/* unused harmony reexport Range */
/* unused harmony reexport Handle */
/* unused harmony reexport createSliderWithTooltip */





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Track__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_createSlider__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(146);




/* eslint-disable react/prop-types */







var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      warning(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      warning(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  Slider.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        disabled = _props.disabled;

    if (autoFocus && !disabled) {
      this.focus();
    }
  };

  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

    var prevValue = this.state.value;
    var value = nextProps.value !== undefined ? nextProps.value : prevValue;
    var nextValue = this.trimAlignValue(value, nextProps);
    if (nextValue === prevValue) return;

    this.setState({ value: nextValue });
    if (__WEBPACK_IMPORTED_MODULE_9__utils__["i" /* isValueOutOfRange */](value, nextProps)) {
      this.props.onChange(nextValue);
    }
  };

  Slider.prototype.onChange = function onChange(state) {
    var props = this.props;
    var isNotControlled = !('value' in props);
    if (isNotControlled) {
      this.setState(state);
    }

    var changedValue = state.value;
    props.onChange(changedValue);
  };

  Slider.prototype.onStart = function onStart(position) {
    this.setState({ dragging: true });
    var props = this.props;
    var prevValue = this.getValue();
    props.onBeforeChange(prevValue);

    var value = this.calcValueByPos(position);
    this.startValue = value;
    this.startPosition = position;

    if (value === prevValue) return;

    this.onChange({ value: value });
  };

  Slider.prototype.onMove = function onMove(e, position) {
    __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
    var oldValue = this.state.value;

    var value = this.calcValueByPos(position);
    if (value === oldValue) return;

    this.onChange({ value: value });
  };

  Slider.prototype.onKeyboard = function onKeyboard(e) {
    var valueMutator = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getKeyboardValueMutator */](e);

    if (valueMutator) {
      __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
      var state = this.state;
      var oldValue = state.value;
      var mutatedValue = valueMutator(oldValue, this.props);
      var value = this.trimAlignValue(mutatedValue);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  };

  Slider.prototype.getValue = function getValue() {
    return this.state.value;
  };

  Slider.prototype.getLowerBound = function getLowerBound() {
    return this.props.min;
  };

  Slider.prototype.getUpperBound = function getUpperBound() {
    return this.state.value;
  };

  Slider.prototype.trimAlignValue = function trimAlignValue(v) {
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
    var val = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* ensureValueInRange */](v, mergedProps);
    return __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* ensureValuePrecision */](val, mergedProps);
  };

  Slider.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        vertical = _props2.vertical,
        included = _props2.included,
        disabled = _props2.disabled,
        minimumTrackStyle = _props2.minimumTrackStyle,
        trackStyle = _props2.trackStyle,
        handleStyle = _props2.handleStyle,
        tabIndex = _props2.tabIndex,
        min = _props2.min,
        max = _props2.max,
        handleGenerator = _props2.handle;
    var _state = this.state,
        value = _state.value,
        dragging = _state.dragging;

    var offset = this.calcOffset(value);
    var handle = handleGenerator({
      className: prefixCls + '-handle',
      vertical: vertical,
      offset: offset,
      value: value,
      dragging: dragging,
      disabled: disabled,
      min: min,
      max: max,
      index: 0,
      tabIndex: tabIndex,
      style: handleStyle[0] || handleStyle,
      ref: function ref(h) {
        return _this2.saveHandle(0, h);
      }
    });

    var _trackStyle = trackStyle[0] || trackStyle;
    var track = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Track__["a" /* default */], {
      className: prefixCls + '-track',
      vertical: vertical,
      included: included,
      offset: 0,
      length: offset,
      style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, minimumTrackStyle, _trackStyle)
    });

    return { tracks: track, handles: handle };
  };

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(474), __esModule: true };

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(475);
module.exports = __webpack_require__(50).Object.assign;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(60);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(477) });


/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(94);
var gOPS = __webpack_require__(137);
var pIE = __webpack_require__(96);
var toObject = __webpack_require__(201);
var IObject = __webpack_require__(199);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(72)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(63);
var toLength = __webpack_require__(479);
var toAbsoluteIndex = __webpack_require__(480);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(133);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(482), __esModule: true };

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(483);
__webpack_require__(489);
module.exports = __webpack_require__(142).f('iterator');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(484)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(202)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var defined = __webpack_require__(132);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(140);
var descriptor = __webpack_require__(93);
var setToStringTag = __webpack_require__(141);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(61)(IteratorPrototype, __webpack_require__(64)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(51);
var anObject = __webpack_require__(71);
var getKeys = __webpack_require__(94);

module.exports = __webpack_require__(52) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(38).document;
module.exports = document && document.documentElement;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(53);
var toObject = __webpack_require__(201);
var IE_PROTO = __webpack_require__(134)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(490);
var global = __webpack_require__(38);
var hide = __webpack_require__(61);
var Iterators = __webpack_require__(139);
var TO_STRING_TAG = __webpack_require__(64)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(491);
var step = __webpack_require__(492);
var Iterators = __webpack_require__(139);
var toIObject = __webpack_require__(63);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(202)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(494), __esModule: true };

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(495);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
module.exports = __webpack_require__(50).Symbol;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(38);
var has = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(52);
var $export = __webpack_require__(60);
var redefine = __webpack_require__(203);
var META = __webpack_require__(496).KEY;
var $fails = __webpack_require__(72);
var shared = __webpack_require__(135);
var setToStringTag = __webpack_require__(141);
var uid = __webpack_require__(95);
var wks = __webpack_require__(64);
var wksExt = __webpack_require__(142);
var wksDefine = __webpack_require__(143);
var enumKeys = __webpack_require__(497);
var isArray = __webpack_require__(498);
var anObject = __webpack_require__(71);
var isObject = __webpack_require__(62);
var toIObject = __webpack_require__(63);
var toPrimitive = __webpack_require__(131);
var createDesc = __webpack_require__(93);
var _create = __webpack_require__(140);
var gOPNExt = __webpack_require__(499);
var $GOPD = __webpack_require__(205);
var $DP = __webpack_require__(51);
var $keys = __webpack_require__(94);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(204).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(96).f = $propertyIsEnumerable;
  __webpack_require__(137).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(138)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(61)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(95)('meta');
var isObject = __webpack_require__(62);
var has = __webpack_require__(53);
var setDesc = __webpack_require__(51).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(72)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(94);
var gOPS = __webpack_require__(137);
var pIE = __webpack_require__(96);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(200);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(63);
var gOPN = __webpack_require__(204).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 500 */
/***/ (function(module, exports) {



/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143)('asyncIterator');


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143)('observable');


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(504), __esModule: true };

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(505);
module.exports = __webpack_require__(50).Object.setPrototypeOf;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(60);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(506).set });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(62);
var anObject = __webpack_require__(71);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(195)(Function.call, __webpack_require__(205).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(508), __esModule: true };

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(509);
var $Object = __webpack_require__(50).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(60);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(140) });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListener;

var _EventObject = __webpack_require__(511);

var _EventObject2 = _interopRequireDefault(_EventObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListener(target, eventType, callback) {
  function wrapCallback(e) {
    var ne = new _EventObject2["default"](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    target.addEventListener(eventType, wrapCallback, false);
    return {
      remove: function remove() {
        target.removeEventListener(eventType, wrapCallback, false);
      }
    };
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBaseObject = __webpack_require__(512);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(76);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = void 0;
    var deltaY = void 0;
    var delta = void 0;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = void 0;
    var doc = void 0;
    var body = void 0;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2["default"].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = void 0;
  var l = void 0;
  var prop = void 0;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2["default"].prototype;

(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },
  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports["default"] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },
  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },
  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },
  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);





var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_3_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i = i + step) {
      if (points.indexOf(i) >= 0) continue;
      points.push(i);
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ bottom: offset }, dotStyle) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ left: offset }, dotStyle);
    if (isActived) {
      style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _classNames[prefixCls + '-dot'] = true, _classNames[prefixCls + '-dot-active'] = isActived, _classNames));

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _classNames[className + '-text'] = true, _classNames[className + '-text-active'] = isActive, _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Track__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_createSlider__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(146);




/* eslint-disable react/prop-types */









var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onEnd = function () {
      _this.setState({ handle: null });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _this.trimAlignValue(v, i);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  Range.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
    if (this.props.min === nextProps.min && this.props.max === nextProps.max && __WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(this.props.value, nextProps.value)) {
      return;
    }

    var bounds = this.state.bounds;

    var value = nextProps.value || bounds;
    var nextBounds = value.map(function (v, i) {
      return _this2.trimAlignValue(v, i, nextProps);
    });
    if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
      return v === bounds[i];
    })) return;

    this.setState({ bounds: nextBounds });
    if (bounds.some(function (v) {
      return __WEBPACK_IMPORTED_MODULE_11__utils__["i" /* isValueOutOfRange */](v, nextProps);
    })) {
      this.props.onChange(nextBounds);
    }
  };

  Range.prototype.onChange = function onChange(state) {
    var props = this.props;
    var isNotControlled = !('value' in props);
    if (isNotControlled) {
      this.setState(state);
    } else if (state.handle !== undefined) {
      this.setState({ handle: state.handle });
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.state, state);
    var changedValue = data.bounds;
    props.onChange(changedValue);
  };

  Range.prototype.onStart = function onStart(position) {
    var props = this.props;
    var state = this.state;
    var bounds = this.getValue();
    props.onBeforeChange(bounds);

    var value = this.calcValueByPos(position);
    this.startValue = value;
    this.startPosition = position;

    var closestBound = this.getClosestBound(value);
    var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);

    this.setState({
      handle: boundNeedMoving,
      recent: boundNeedMoving
    });

    var prevValue = bounds[boundNeedMoving];
    if (value === prevValue) return;

    var nextBounds = [].concat(state.bounds);
    nextBounds[boundNeedMoving] = value;
    this.onChange({ bounds: nextBounds });
  };

  Range.prototype.onMove = function onMove(e, position) {
    __WEBPACK_IMPORTED_MODULE_11__utils__["j" /* pauseEvent */](e);
    var props = this.props;
    var state = this.state;

    var value = this.calcValueByPos(position);
    var oldValue = state.bounds[state.handle];
    if (value === oldValue) return;

    var nextBounds = [].concat(state.bounds);
    nextBounds[state.handle] = value;
    var nextHandle = state.handle;
    if (props.pushable !== false) {
      this.pushSurroundingHandles(nextBounds, nextHandle);
    } else if (props.allowCross) {
      nextBounds.sort(function (a, b) {
        return a - b;
      });
      nextHandle = nextBounds.indexOf(value);
    }
    this.onChange({
      handle: nextHandle,
      bounds: nextBounds
    });
  };

  Range.prototype.onKeyboard = function onKeyboard() {
    __WEBPACK_IMPORTED_MODULE_8_warning___default()(true, 'Keyboard support is not yet supported for ranges.');
  };

  Range.prototype.getValue = function getValue() {
    return this.state.bounds;
  };

  Range.prototype.getClosestBound = function getClosestBound(value) {
    var bounds = this.state.bounds;

    var closestBound = 0;
    for (var i = 1; i < bounds.length - 1; ++i) {
      if (value > bounds[i]) {
        closestBound = i;
      }
    }
    if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
      closestBound = closestBound + 1;
    }
    return closestBound;
  };

  Range.prototype.getBoundNeedMoving = function getBoundNeedMoving(value, closestBound) {
    var _state = this.state,
        bounds = _state.bounds,
        recent = _state.recent;

    var boundNeedMoving = closestBound;
    var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

    if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
      boundNeedMoving = recent;
    }

    if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
      boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
    }
    return boundNeedMoving;
  };

  Range.prototype.getLowerBound = function getLowerBound() {
    return this.state.bounds[0];
  };

  Range.prototype.getUpperBound = function getUpperBound() {
    var bounds = this.state.bounds;

    return bounds[bounds.length - 1];
  };

  /**
   * Returns an array of possible slider points, taking into account both
   * `marks` and `step`. The result is cached.
   */


  Range.prototype.getPoints = function getPoints() {
    var _props = this.props,
        marks = _props.marks,
        step = _props.step,
        min = _props.min,
        max = _props.max;

    var cache = this._getPointsCache;
    if (!cache || cache.marks !== marks || cache.step !== step) {
      var pointsObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, marks);
      if (step !== null) {
        for (var point = min; point <= max; point += step) {
          pointsObject[point] = point;
        }
      }
      var points = Object.keys(pointsObject).map(parseFloat);
      points.sort(function (a, b) {
        return a - b;
      });
      this._getPointsCache = { marks: marks, step: step, points: points };
    }
    return this._getPointsCache.points;
  };

  Range.prototype.pushSurroundingHandles = function pushSurroundingHandles(bounds, handle) {
    var value = bounds[handle];
    var threshold = this.props.pushable;

    threshold = Number(threshold);

    var direction = 0;
    if (bounds[handle + 1] - value < threshold) {
      direction = +1; // push to right
    }
    if (value - bounds[handle - 1] < threshold) {
      direction = -1; // push to left
    }

    if (direction === 0) {
      return;
    }

    var nextHandle = handle + direction;
    var diffToNext = direction * (bounds[nextHandle] - value);
    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
      // revert to original value if pushing is impossible
      bounds[handle] = bounds[nextHandle] - direction * threshold;
    }
  };

  Range.prototype.pushHandle = function pushHandle(bounds, handle, direction, amount) {
    var originalValue = bounds[handle];
    var currentValue = bounds[handle];
    while (direction * (currentValue - originalValue) < amount) {
      if (!this.pushHandleOnePoint(bounds, handle, direction)) {
        // can't push handle enough to create the needed `amount` gap, so we
        // revert its position to the original value
        bounds[handle] = originalValue;
        return false;
      }
      currentValue = bounds[handle];
    }
    // the handle was pushed enough to create the needed `amount` gap
    return true;
  };

  Range.prototype.pushHandleOnePoint = function pushHandleOnePoint(bounds, handle, direction) {
    var points = this.getPoints();
    var pointIndex = points.indexOf(bounds[handle]);
    var nextPointIndex = pointIndex + direction;
    if (nextPointIndex >= points.length || nextPointIndex < 0) {
      // reached the minimum or maximum available point, can't push anymore
      return false;
    }
    var nextHandle = handle + direction;
    var nextValue = points[nextPointIndex];
    var threshold = this.props.pushable;

    var diffToNext = direction * (bounds[nextHandle] - nextValue);
    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
      // couldn't push next handle, so we won't push this one either
      return false;
    }
    // push the handle
    bounds[handle] = nextValue;
    return true;
  };

  Range.prototype.trimAlignValue = function trimAlignValue(v, handle) {
    var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
    var valInRange = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* ensureValueInRange */](v, mergedProps);
    var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
    return __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* ensureValuePrecision */](valNotConflict, mergedProps);
  };

  Range.prototype.ensureValueNotConflict = function ensureValueNotConflict(handle, val, _ref) {
    var allowCross = _ref.allowCross,
        thershold = _ref.pushable;

    var state = this.state || {};
    var bounds = state.bounds;

    handle = handle === undefined ? state.handle : handle;
    thershold = Number(thershold);
    /* eslint-disable eqeqeq */
    if (!allowCross && handle != null && bounds !== undefined) {
      if (handle > 0 && val <= bounds[handle - 1] + thershold) {
        return bounds[handle - 1] + thershold;
      }
      if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
        return bounds[handle + 1] - thershold;
      }
    }
    /* eslint-enable eqeqeq */
    return val;
  };

  Range.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        handle = _state2.handle,
        bounds = _state2.bounds;
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        vertical = _props2.vertical,
        included = _props2.included,
        disabled = _props2.disabled,
        min = _props2.min,
        max = _props2.max,
        handleGenerator = _props2.handle,
        trackStyle = _props2.trackStyle,
        handleStyle = _props2.handleStyle,
        tabIndex = _props2.tabIndex;


    var offsets = bounds.map(function (v) {
      return _this3.calcOffset(v);
    });

    var handleClassName = prefixCls + '-handle';
    var handles = bounds.map(function (v, i) {
      var _classNames;

      return handleGenerator({
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classNames = {}, _classNames[handleClassName] = true, _classNames[handleClassName + '-' + (i + 1)] = true, _classNames)),
        vertical: vertical,
        offset: offsets[i],
        value: v,
        dragging: handle === i,
        index: i,
        tabIndex: tabIndex[i] || 0,
        min: min,
        max: max,
        disabled: disabled,
        style: handleStyle[i],
        ref: function ref(h) {
          return _this3.saveHandle(i, h);
        }
      });
    });

    var tracks = bounds.slice(0, -1).map(function (_, index) {
      var _classNames2;

      var i = index + 1;
      var trackClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classNames2 = {}, _classNames2[prefixCls + '-track'] = true, _classNames2[prefixCls + '-track-' + i] = true, _classNames2));
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Track__["a" /* default */], {
        className: trackClassName,
        vertical: vertical,
        included: included,
        offset: offsets[i - 1],
        length: offsets[i] - offsets[i - 1],
        style: trackStyle[index],
        key: i
      });
    });

    return { tracks: tracks, handles: handles };
  };

  return Range;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number)
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_tooltip__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Handle__ = __webpack_require__(145);










function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper(props) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          var _extends2;

          return {
            visibles: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState.visibles, (_extends2 = {}, _extends2[index] = visible, _extends2))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? visible || false : _tipProps$visible,
            restTooltipProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_tooltip__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, {
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, handleStyle[0]),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      };

      _this.state = { visibles: {} };
      return _this;
    }

    ComponentWrapper.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
    };

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    handleStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
    tipProps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp;
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(520);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(547);










var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-inner', key: 'content', id: id },
        typeof overlay === 'function' ? overlay() : overlay
      )];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Popup__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__ = __webpack_require__(546);














function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible) {
    this.clearDelayTimer();
    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({
          popupVisible: popupVisible
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;

    var props = this.props;
    var children = props.children;
    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: props.forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || props.forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, _this5.props.mouseEnterDelay);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    event.preventDefault();
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    var popupNode = _this5.getPopupDomNode();
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var props = _this5.props;
    var popupPlacement = props.popupPlacement,
        builtinPlacements = props.builtinPlacements,
        prefixCls = props.prefixCls;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getPopupClassNameFromAlign */])(builtinPlacements, prefixCls, align));
    }
    if (props.getPopupClassNameFromAlign) {
      className.push(props.getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var props = _this5.props,
        state = _this5.state;

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: props.prefixCls,
        destroyPopupOnHide: props.destroyPopupOnHide,
        visible: state.popupVisible,
        className: props.popupClassName,
        action: props.action,
        align: _this5.getPopupAlign(),
        onAlign: props.onPopupAlign,
        animation: props.popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        getRootDomNode: _this5.getRootDomNode,
        style: props.popupStyle,
        mask: props.mask,
        zIndex: props.zIndex,
        transitionName: props.popupTransitionName,
        maskAnimation: props.maskAnimation,
        maskTransitionName: props.maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof props.popup === 'function' ? props.popup() : props.popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(213);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
  };

  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var savePopupRef = this.savePopupRef,
        props = this.props;
    var align = props.align,
        style = props.style,
        visible = props.visible,
        prefixCls = props.prefixCls,
        destroyPopupOnHide = props.destroyPopupOnHide;

    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';
    if (!visible) {
      this.currentAlignClassName = null;
    }
    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, this.getZIndexStyle());
    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getTarget,
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            props.children
          )
        ) : null
      );
    }
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getTarget,
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          props.children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this2.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this2.currentAlignClassName !== currentAlignClassName) {
      _this2.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this2.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.getTarget = function () {
    return _this2.props.getRootDomNode();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(525);
// export this package's api

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isWindow__ = __webpack_require__(534);










function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var props = _this.props;
      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);
        props.onAlign(source, Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* default */])(source, props.target(), props.align));
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      if (prevProps.disabled || prevProps.align !== props.align) {
        reAlign = true;
      } else {
        var lastTarget = prevProps.target();
        var currentTarget = props.target();
        if (Object(__WEBPACK_IMPORTED_MODULE_8__isWindow__["a" /* default */])(lastTarget) && Object(__WEBPACK_IMPORTED_MODULE_8__isWindow__["a" /* default */])(currentTarget)) {
          reAlign = false;
        } else if (lastTarget !== currentTarget) {
          reAlign = true;
        }
      }
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      for (var prop in childrenProps) {
        if (childrenProps.hasOwnProperty(prop)) {
          newProps[prop] = this.props[childrenProps[prop]];
        }
      }
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  onAlign: function onAlign() {},
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adjustForViewport__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRegion__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getElFuturePos__ = __webpack_require__(532);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */








// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

function domAlign(el, refNode, align) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var target = align.target || refNode;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(source);
  // 参照节点所占的区域, left/top/width/height
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(target);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, refNodeRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTargetNotOutOfVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_3__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

domAlign.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

domAlign.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (domAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(529);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(65);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(533);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWindow;
function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(211);










var defaultKey = 'rc_animate_' + Date.now();


function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                return _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else {
      if (type === 'appear') {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowEnterCallback(props)) {
          props.onEnter(key);
          props.onEnd(key, true);
        }
      }
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(209);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(538);
var $Object = __webpack_require__(50).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(60);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(52), 'Object', { defineProperty: __webpack_require__(51).f });


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_css_animation__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(211);











var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_8_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_8_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(210);
} catch (err) {
  var index = __webpack_require__(210);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(212);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return play; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stop; });
var play=function play(){return{type:'PLAY'};};var stop=function stop(){return{type:'STOP'};};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var PlayButton=function PlayButton(props){if(props.isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'button-header button-loading'});}else if(props.isPlaying){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-header button-stop',onClick:props.stop});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-header button-play',onClick:props.play});}// return (
//     <button disabled = {props.isLoading} className='button-header button-stop' onClick={props.stop}/>
// );
};PlayButton.propTypes={stop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PlayButton);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_intro__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_ending__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_sections__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Accordion__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Intro__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Ending__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Section__ = __webpack_require__(558);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Scheme=function(_Component){_inherits(Scheme,_Component);function Scheme(){_classCallCheck(this,Scheme);return _possibleConstructorReturn(this,(Scheme.__proto__||Object.getPrototypeOf(Scheme)).apply(this,arguments));}_createClass(Scheme,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scheme-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scheme-btn-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'scheme-button',onClick:this.props.removeAll},' Clear all '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'scheme-button',onClick:this.props.addSection},' Add progression ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scheme'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{type:'INTRO'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Intro__["a" /* default */],{intro:this.props.intro,setIntro:this.props.setIntro})),this.props.sections.map(function(s,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{key:s.id,type:'PROGRESSION',index:index+1,removeSection:function removeSection(){return _this2.props.removeSection(s.id);},cloneSection:function cloneSection(){return _this2.props.cloneSection(s.id);},moveSectionUp:function moveSectionUp(){return _this2.props.moveSection(s.id,'UP');},moveSectionDown:function moveSectionDown(){return _this2.props.moveSection(s.id,'DOWN');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Section__["a" /* default */],{section:s,setPattern:_this2.props.setPattern}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{type:'ENDING'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Ending__["a" /* default */],{ending:this.props.ending,setEnding:this.props.setEnding}))));}}]);return Scheme;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Scheme.propTypes={sections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};var mapStateToProps=function mapStateToProps(state){return{intro:state.intro,sections:state.sections,ending:state.ending};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setIntro:function setIntro(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_intro__["a" /* setIntro */])(id));},setEnding:function setEnding(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_ending__["a" /* setEnding */])(id));},setPattern:function setPattern(sectionId,patternId,hand){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["f" /* setPattern */])(sectionId,patternId,hand));},addSection:function addSection(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["a" /* addSection */])());},removeAll:function removeAll(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["d" /* removeAll */])());},moveSection:function moveSection(id,direction){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["c" /* moveSection */])(id,direction));},cloneSection:function cloneSection(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["b" /* cloneSection */])(id));},removeSection:function removeSection(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_sections__["e" /* removeSection */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Scheme));

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setIntro; });
var setIntro=function setIntro(id){return{type:'SET_INTRO',id:id};};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setEnding; });
var setEnding=function setEnding(id){return{type:'SET_ENDING',id:id};};// export const setEndingData = (data) => {
//     return {
//         type: 'SET_ENDING_DATA',
//         data
//     }
// }
// export const fetchError = (bool) => {
//     return {
//         type: 'FETCH_ERROR',
//         fetchError: bool
//     }
// }
//thunk  async action
// export function fetchEnding(id) {
//     return (dispatch) => {
//         if (id === null) {
//             return dispatch(setEndingData(null))
//         }  
//         fetch(`/presets/${id}.json`)
//             .then(response => response.json())
//             .then(data => dispatch(setEndingData(data)))
//             .catch(err => console.log(err));
//     };
// }

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloneSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moveSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeAll; });
var setPattern=function setPattern(sectionId,patternId,hand){return{type:'SET_PATTERN',sectionId:sectionId,patternId:patternId,hand:hand};};var addSection=function addSection(){return{type:'ADD_SECTION'};};var removeSection=function removeSection(id){return{type:'REMOVE_SECTION',id:id};};var cloneSection=function cloneSection(id){return{type:'CLONE_SECTION',id:id};};var moveSection=function moveSection(id,direction){return{type:'MOVE_SECTION',direction:direction,id:id};};var removeAll=function removeAll(){return{type:'REMOVE_ALL'};};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accordion=function(_Component){_inherits(Accordion,_Component);function Accordion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Accordion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Accordion.__proto__||Object.getPrototypeOf(Accordion)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpened:false},_this.open=function(){_this.setState({isOpened:!_this.state.isOpened});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Accordion,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-type',onClick:this.open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.isOpened?'section-opened':'section-closed'}),this.props.type+' '+this.props.index),this.props.type==='PROGRESSION'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'clone progression',className:'btn-section fa fa-plus',onClick:this.props.cloneSection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'move progression up',className:'btn-section fa fa-arrow-up',onClick:this.props.moveSectionUp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'move progression down',className:'btn-section fa fa-arrow-down',onClick:this.props.moveSectionDown}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'remove progression',className:'btn-section fa fa-close',onClick:this.props.removeSection}))),this.state.isOpened&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-details'},this.props.children));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Accordion.defaultProps={index:''};Accordion.propTypes={cloneSection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,moveSectionUp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,moveSectionDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeSection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__presets_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var intros=__WEBPACK_IMPORTED_MODULE_2__presets_json___default.a.intros.map(function(preset){return{value:preset.id,label:preset.description};});var Intro=function(_Component){_inherits(Intro,_Component);function Intro(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Intro);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Intro.__proto__||Object.getPrototypeOf(Intro)).call.apply(_ref,[this].concat(args))),_this),_this.introOnChange=function(option){_this.props.setIntro(option===null?null:option.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Intro,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{placeholder:'Select...',name:'intro',searchable:false,multi:false,value:this.props.intro===null?null:{value:this.props.intro.id,label:this.props.intro.description},onChange:this.introOnChange,onBlurResetsInput:false,onSelectResetsInput:false,options:intros});}}]);return Intro;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Intro.propTypes={introOnChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,intro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__presets_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var endings=__WEBPACK_IMPORTED_MODULE_2__presets_json___default.a.endings.map(function(preset){return{value:preset.id,label:preset.description};});var Ending=function(_Component){_inherits(Ending,_Component);function Ending(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Ending);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Ending.__proto__||Object.getPrototypeOf(Ending)).call.apply(_ref,[this].concat(args))),_this),_this.endingOnChange=function(option){_this.props.setEnding(option===null?null:option.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Ending,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{placeholder:'Select...',name:'ending',searchable:false,multi:false,value:this.props.ending===null?null:{value:this.props.ending.id,label:this.props.ending.description},onChange:this.endingOnChange,onBlurResetsInput:false,onSelectResetsInput:false,options:endings});}}]);return Ending;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Ending.propTypes={introOnChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,intro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Ending);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftHandSection__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RightHandSection__ = __webpack_require__(560);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Section=function(_Component){_inherits(Section,_Component);function Section(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Section);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Section.__proto__||Object.getPrototypeOf(Section)).call.apply(_ref,[this].concat(args))),_this),_this.setPattern=function(patternId,hand){_this.props.setPattern(_this.props.section.id,patternId,hand);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Section,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'handGroup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Right hand:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RightHandSection__["a" /* default */],{pattern:this.props.section.rightHand,setPattern:this.setPattern}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Left hand:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LeftHandSection__["a" /* default */],{pattern:this.props.section.leftHand,setPattern:this.setPattern}));}}]);return Section;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Section.propTypes={setPattern:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,rightHand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,leftHand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__presets_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var patterns=__WEBPACK_IMPORTED_MODULE_2__presets_json__["leftHandPatterns"].map(function(preset){return{value:preset.id,label:preset.description};});var LeftHandsection=function(_Component){_inherits(LeftHandsection,_Component);function LeftHandsection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LeftHandsection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LeftHandsection.__proto__||Object.getPrototypeOf(LeftHandsection)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(pattern){_this.props.setPattern(pattern.value,'left');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LeftHandsection,[{key:'render',value:function render(){var _props$pattern=this.props.pattern,id=_props$pattern.id,description=_props$pattern.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{placeholder:'Left hand pattern',name:'lh',value:{value:id,label:description},onChange:this.handleChange,options:patterns,clearable:false,searchable:false});}}]);return LeftHandsection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LeftHandsection);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__presets_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__presets_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var patterns=__WEBPACK_IMPORTED_MODULE_2__presets_json__["rightHandPatterns"].map(function(preset){return{value:preset.id,label:preset.description};});var RightHandsection=function(_Component){_inherits(RightHandsection,_Component);function RightHandsection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RightHandsection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RightHandsection.__proto__||Object.getPrototypeOf(RightHandsection)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(pattern){_this.props.setPattern(pattern.value,'right');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RightHandsection,[{key:'render',value:function render(){var _props$pattern=this.props.pattern,id=_props$pattern.id,description=_props$pattern.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{placeholder:'Right hand pattern',name:'rh',value:{value:id,label:description},onChange:this.handleChange,options:patterns,clearable:false,searchable:false});}}]);return RightHandsection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RightHandsection);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sheet__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_sheet__ = __webpack_require__(570);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SheetContainer=function(_Component){_inherits(SheetContainer,_Component);function SheetContainer(){_classCallCheck(this,SheetContainer);return _possibleConstructorReturn(this,(SheetContainer.__proto__||Object.getPrototypeOf(SheetContainer)).apply(this,arguments));}_createClass(SheetContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.isOutdated?'blur':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sheet__["a" /* default */],{shouldUpdate:this.props.isOutdated})),this.props.isOutdated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-update',onClick:this.props.update}));}}]);return SheetContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SheetContainer.propTypes={isOutdated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,update:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{isOutdated:state.sheet.isOutdated};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{update:function update(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_sheet__["a" /* update */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SheetContainer));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_SheetDrawer__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sheet=function(_Component){_inherits(Sheet,_Component);function Sheet(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sheet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sheet.__proto__||Object.getPrototypeOf(Sheet)).call.apply(_ref,[this].concat(args))),_this),_this.state={windowWidth:window.innerWidth},_this.drawSheet=function(){new __WEBPACK_IMPORTED_MODULE_2__services_SheetDrawer__["a" /* default */](_this.sheetContainer,[_this.props.intro].concat(_toConsumableArray(_this.props.sections),[_this.props.ending]).filter(function(x){return x!==null;}),{width:_this.state.windowWidth,signature:_this.props.signature,scale:_this.props.scale}).draw();},_this.updateDimensions=function(){_this.setState({windowWidth:window.innerWidth});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sheet,[{key:'componentDidMount',value:function componentDidMount(){// console.log('sheet did mount');
this.drawSheet();window.addEventListener("resize",this.updateDimensions);}},{key:'componentDidUpdate',value:function componentDidUpdate(){// console.log('sheet did update');
this.drawSheet();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("resize",this.updateDimensions);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!nextProps.shouldUpdate;}},{key:'render',value:function render(){var _this2=this;// console.log('sheet render');
// всегда передаем разный key, чтобы реакт каждый раз полностью пересоздавал
// https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sheet',ref:function ref(x){return _this2.sheetContainer=x;},key:Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* generateId */])()});}}]);return Sheet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Sheet.propTypes={sections:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,signature:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,scale:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,intro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,ending:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{signature:state.settings.key,scale:state.settings.scale,intro:state.intro,sections:state.sections,ending:state.ending};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(Sheet));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vexflow__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vexflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vexflow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transposer__ = __webpack_require__(214);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var VF=__WEBPACK_IMPORTED_MODULE_0_vexflow___default.a.Flow;var SCHEME_WIDTH=350;var SPACE_BETWEEN_STAVES=120;var SPACE_BETWEEN_GRAND_STAVES=260;var BAR_MIN_WIDTH=100;var PADDING_TOP=50;var PADDING_LEFT=50;var COEFFICIENT=1;var SHEET_MIN_WIDTH=600;var FIRST_NOTE_SPACE=10;var LAST_NOTE_SPACE=10;function disributeValue(arr,value,precision){var sum=arr.reduce(function(sum,value){return sum+value;},0);var percentages=arr.map(function(value){return value/sum;});var valueDistribution=percentages.map(function(percentage){var factor=Math.pow(10,precision);return Math.round(value*percentage*factor)/factor;});return valueDistribution;}var SheetDrawer=function(){function SheetDrawer(container,sections,_ref){var width=_ref.width,signature=_ref.signature,scale=_ref.scale;_classCallCheck(this,SheetDrawer);this.sheetContainer=container;this.sections=sections;this.scale=scale/100;this.svgWidth=Math.max(width-SCHEME_WIDTH,SHEET_MIN_WIDTH)/this.scale;this.sheetWidth=this.svgWidth-PADDING_LEFT*2;this.beams=[];this.tuplets=[];this.openedTies={};this.ties=[];this.rowFirstBars=[];this.rowLastBars=[];this.width=width;this.signature=signature;// this.rowsCounter = 0;
this.transposer=new __WEBPACK_IMPORTED_MODULE_1__Transposer__["a" /* default */](signature);}_createClass(SheetDrawer,[{key:'drawGrandStaveRow',value:function drawGrandStaveRow(currentRowBars,widthArray,rowsCounter){var _this=this;var widthRest=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;this.rowFirstBars.push(currentRowBars[0].barId);this.rowLastBars.push(currentRowBars[currentRowBars.length-1].barId);var barOffset=PADDING_LEFT;//if (widthRest !== 0) {
var widthRestArray=disributeValue(widthArray,widthRest,0);//}
currentRowBars.forEach(function(b,index){var barWidth=b.barWidth+(widthRest!==0?widthRestArray[index]:0);var trebleStave=b.tStave;var bassStave=b.bStave;trebleStave.setX(barOffset);bassStave.setX(barOffset);trebleStave.setY(PADDING_TOP+rowsCounter*SPACE_BETWEEN_GRAND_STAVES);bassStave.setY(PADDING_TOP+rowsCounter*SPACE_BETWEEN_GRAND_STAVES+SPACE_BETWEEN_STAVES);trebleStave.setWidth(barWidth);bassStave.setWidth(barWidth);//grand stave group
// const group = this.context.openGroup(b.sectionId);
// this.context.rect(barOffset, PADDING_TOP + rowsCounter * SPACE_BETWEEN_GRAND_STAVES + 40, barWidth, SPACE_BETWEEN_STAVES + 50 * 2 - 60, { stroke: 'none', fill: "rgba(124,240,10,0.1)" });
// this.context.closeGroup();
barOffset+=barWidth;if(b.text){// trebleStave.setText(b.text[0], VF.Modifier.Position.ABOVE, { shift_y: 0, justification: VF.TextNote.Justification.LEFT });
trebleStave.setSection(b.text[0],0);}var lineLeft=new VF.StaveConnector(trebleStave,bassStave).setType(1);var lineRight=new VF.StaveConnector(trebleStave,bassStave).setType(b.isLastBar?6:0);trebleStave.setContext(_this.context).draw();bassStave.setContext(_this.context).draw();lineLeft.setContext(_this.context).draw();lineRight.setContext(_this.context).draw();b.formatter.format(b.trebleStaveVoices.concat(b.bassStaveVoices),b.minTotalWidth+(widthRest!==0?widthRestArray[index]:0));// Render voices
b.trebleStaveVoices.forEach(function(v){v.draw(this.context,trebleStave);}.bind(_this));b.bassStaveVoices.forEach(function(v){v.draw(this.context,bassStave);}.bind(_this));});}},{key:'buildVoice',value:function buildVoice(voice,symbol,vInd,bInd,pInd,sInd){var _this3=this;var vexVoice=new VF.Voice({num_beats:4,beat_value:4,resolution:VF.RESOLUTION});var vexNotes=voice.notes.map(function(note,nInd){var _this2=this;var keys=note.keys,duration=note.dur,grace=note.grace,options=_objectWithoutProperties(note,['keys','dur','grace']);var noteKeysAccidentals=[];var noteTies=[];var graceNotes=[];if(grace){graceNotes=grace.notes.map(function(gn,gInd){var noteGraceAccidentals=[];var keys=gn.keys,duration=gn.dur,options=_objectWithoutProperties(gn,['keys','dur']);var gnTrasposedKeys=keys.map(function(_ref2,keyIndex){var key=_objectWithoutProperties(_ref2,[]);var _transposer$transpose=this.transposer.transpose(key,duration),trStep=_transposer$transpose.trStep,trAccidental=_transposer$transpose.trAccidental,trOctave=_transposer$transpose.trOctave;noteGraceAccidentals[keyIndex]=trAccidental;return''+trStep+(trAccidental||'')+'/'+trOctave;}.bind(_this2));var graceNote=new VF.GraceNote(Object.assign({keys:gnTrasposedKeys,duration:duration},options));graceNote.setAttribute('id',sInd+'-'+pInd+'-'+bInd+'-'+symbol+'-'+vInd+'-'+nInd+'-'+gInd);noteGraceAccidentals.forEach(function(acc,i){if(acc){graceNote.addAccidental(i,new VF.Accidental(acc));}});return graceNote;});}var trasposedKeys=keys.map(function(_ref3,keyIndex){var ties=_ref3.ties,key=_objectWithoutProperties(_ref3,['ties']);var _transposer$transpose2=this.transposer.transpose(key,duration),trStep=_transposer$transpose2.trStep,trAccidental=_transposer$transpose2.trAccidental,trOctave=_transposer$transpose2.trOctave,pitch=_transposer$transpose2.trPitch;noteKeysAccidentals[keyIndex]=trAccidental;if(ties){noteTies[keyIndex]={pitch:pitch,ties:ties};}return''+trStep+(trAccidental||'')+'/'+trOctave;}.bind(this));var staveNote=new VF.StaveNote(Object.assign({keys:trasposedKeys,duration:duration},options));if(options.dots){staveNote.addDotToAll();}if(grace){var gnGroup=new __WEBPACK_IMPORTED_MODULE_0_vexflow___default.a.Flow.GraceNoteGroup(graceNotes);//gnGroup.setXShift(10)
staveNote.addModifier(0,gnGroup);}noteKeysAccidentals.forEach(function(acc,i){if(acc){staveNote.addAccidental(i,new VF.Accidental(acc));}});noteTies.forEach(function(nt,i){if(nt){var pitch=nt.pitch,ties=nt.ties;ties.forEach(function(t){if(t.type==='start'){this.openedTies[pitch]={first:{staveNote:staveNote,i:i,barId:sInd+'-'+pInd+'-'+bInd},stem:t.stem||'UP'};}else{if(this.openedTies[pitch]){this.ties.push(Object.assign({last:{staveNote:staveNote,i:i,barId:sInd+'-'+pInd+'-'+bInd}},this.openedTies[pitch]));delete this.openedTies[pitch];}}}.bind(this));}}.bind(this));staveNote.setAttribute('id',sInd+'-'+pInd+'-'+bInd+'-'+symbol+'-'+vInd+'-'+nInd);return staveNote;}.bind(this));if(voice.beams){voice.beams.forEach(function(beam){var from=beam.from,to=beam.to;_this3.beams.push(new VF.Beam(vexNotes.slice(from,to)));});}else{var _beams;var autoBeams=VF.Beam.generateBeams(vexNotes);(_beams=this.beams).push.apply(_beams,_toConsumableArray(autoBeams));}if(voice.tuplets){voice.tuplets.forEach(function(tuplet){var from=tuplet.from,to=tuplet.to,options=_objectWithoutProperties(tuplet,['from','to']);_this3.tuplets.push(new VF.Tuplet(vexNotes.slice(from,to),options));});}vexVoice.addTickables(vexNotes);return vexVoice;}},{key:'draw',value:function draw(){var _this4=this;var renderer=new VF.Renderer(this.sheetContainer,VF.Renderer.Backends.SVG);this.context=renderer.getContext();this.context.setFont("Arial",10,"").setBackgroundFillStyle("#eed");var rowsCounter=0;var currentWidth=0;var currentRowBars=[];var widthArray=[];var firstRow=true;var sectionsLength=this.sections.length;this.sections.forEach(function(section,sInd){var isLastSection=sInd===sectionsLength-1;var phrasesLength=section.phrases.length;section.phrases.forEach(function(phrase,pInd){var isLastPhrase=pInd===phrasesLength-1;var barsLength=phrase.bars.length;phrase.bars.forEach(function(bar,bInd){_this4.transposer.resetAccidentals();var isFirstSectionBar=pInd===0&bInd===0;var isLastBar=bInd===barsLength-1&&isLastPhrase&&isLastSection;var trebleStaveVoices=bar.trebleVoices.map(function(voice,vInd){return _this4.buildVoice(voice,'t',vInd,bInd,pInd,sInd);});var bassStaveVoices=bar.bassVoices.map(function(voice,vInd){return _this4.buildVoice(voice,'b',vInd,bInd,pInd,sInd);});var formatter=new VF.Formatter();formatter.joinVoices(trebleStaveVoices).joinVoices(bassStaveVoices);var allVoicesTogether=trebleStaveVoices.concat(bassStaveVoices);var minTotalWidth=Math.ceil(Math.max(formatter.preCalculateMinTotalWidth(allVoicesTogether),BAR_MIN_WIDTH)*COEFFICIENT);// добавим нотные станы, пока с 0 координатами
var tStave=new VF.Stave(0,0);var bStave=new VF.Stave(0,0);// Add a clef and time signature.
if(firstRow){tStave.addClef("treble").addTimeSignature("4/4").addKeySignature(_this4.signature);bStave.addClef("bass").addTimeSignature("4/4").addKeySignature(_this4.signature);firstRow=false;}var startX=Math.max(tStave.getNoteStartX(),bStave.getNoteStartX());tStave.setNoteStartX(startX);bStave.setNoteStartX(startX);var barWidth=minTotalWidth+(startX-0)+FIRST_NOTE_SPACE+LAST_NOTE_SPACE;if(currentWidth+barWidth<_this4.sheetWidth){currentWidth+=barWidth;currentRowBars.push({bar:bar,barWidth:barWidth,minTotalWidth:minTotalWidth,tStave:tStave,bStave:bStave,formatter:formatter,trebleStaveVoices:trebleStaveVoices,bassStaveVoices:bassStaveVoices,isLastBar:isLastBar,text:isFirstSectionBar?section.type:'',sectionId:section.id,barId:sInd+'-'+pInd+'-'+bInd});widthArray.push(barWidth);}else{// new stave row
// draw current row and begin new row 
var widthRest=_this4.sheetWidth-currentWidth;_this4.drawGrandStaveRow(currentRowBars,widthArray,rowsCounter,widthRest);//newRow = true;
tStave.addClef("treble").addTimeSignature("4/4").addKeySignature(_this4.signature);bStave.addClef("bass").addTimeSignature("4/4").addKeySignature(_this4.signature);var _startX=Math.max(tStave.getNoteStartX(),bStave.getNoteStartX());tStave.setNoteStartX(_startX);bStave.setNoteStartX(_startX);var _barWidth=minTotalWidth+(_startX-0)+FIRST_NOTE_SPACE+LAST_NOTE_SPACE;rowsCounter++;currentWidth=_barWidth;currentRowBars.length=0;widthArray.length=0;widthArray.push(_barWidth);currentRowBars.push({bar:bar,barWidth:_barWidth,minTotalWidth:minTotalWidth,tStave:tStave,bStave:bStave,formatter:formatter,trebleStaveVoices:trebleStaveVoices,bassStaveVoices:bassStaveVoices,isLastBar:isLastBar,text:isFirstSectionBar?section.type:'',sectionId:section.id,barId:sInd+'-'+pInd+'-'+bInd});}});});});if(currentRowBars.length){this.drawGrandStaveRow(currentRowBars,widthArray,rowsCounter);}this.beams.forEach(function(b){b.setContext(_this4.context).draw();});this.tuplets.forEach(function(tuplet){tuplet.setContext(_this4.context).draw();});this.ties.forEach(function(t){if(_this4.rowFirstBars.indexOf(t.last.barId)>-1&&_this4.rowLastBars.indexOf(t.first.barId)>-1&&t.first.barId!==t.last.barId){new VF.StaveTie({first_note:t.first.staveNote,last_note:null,first_indices:[t.first.i]}).setDirection(VF.Stem[t.stem]).setContext(_this4.context).draw();new VF.StaveTie({first_note:null,last_note:t.last.staveNote,last_indices:[t.last.i]}).setDirection(VF.Stem[t.stem]).setContext(_this4.context).draw();}else{var tie=new VF.StaveTie({first_note:t.first.staveNote,last_note:t.last.staveNote,first_indices:[t.first.i],last_indices:[t.last.i]}).setDirection(VF.Stem[t.stem]);tie.setContext(_this4.context).draw();}});renderer.resize(this.svgWidth,PADDING_TOP+SPACE_BETWEEN_GRAND_STAVES*(rowsCounter+1));if(this.scale!==1){this.context.scale(this.scale,this.scale);}}}]);return SheetDrawer;}();/* harmony default export */ __webpack_exports__["a"] = (SheetDrawer);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vex"] = factory();
	else
		root["Vex"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _element = __webpack_require__(5);
	
	var _fraction = __webpack_require__(3);
	
	var _renderer = __webpack_require__(10);
	
	var _formatter = __webpack_require__(14);
	
	var _music = __webpack_require__(30);
	
	var _glyph = __webpack_require__(4);
	
	var _stave = __webpack_require__(43);
	
	var _stavenote = __webpack_require__(20);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _voice = __webpack_require__(18);
	
	var _accidental = __webpack_require__(29);
	
	var _beam = __webpack_require__(15);
	
	var _stavetie = __webpack_require__(33);
	
	var _tabstave = __webpack_require__(55);
	
	var _tabnote = __webpack_require__(56);
	
	var _bend = __webpack_require__(41);
	
	var _vibrato = __webpack_require__(42);
	
	var _vibratobracket = __webpack_require__(57);
	
	var _note = __webpack_require__(22);
	
	var _modifiercontext = __webpack_require__(27);
	
	var _tickcontext = __webpack_require__(39);
	
	var _articulation = __webpack_require__(37);
	
	var _annotation = __webpack_require__(40);
	
	var _stavebarline = __webpack_require__(44);
	
	var _notehead = __webpack_require__(21);
	
	var _staveconnector = __webpack_require__(19);
	
	var _clefnote = __webpack_require__(58);
	
	var _keysignature = __webpack_require__(52);
	
	var _timesignature = __webpack_require__(53);
	
	var _timesignote = __webpack_require__(59);
	
	var _stem = __webpack_require__(17);
	
	var _tabtie = __webpack_require__(34);
	
	var _clef = __webpack_require__(51);
	
	var _modifier = __webpack_require__(25);
	
	var _tabslide = __webpack_require__(60);
	
	var _tuplet = __webpack_require__(16);
	
	var _gracenote = __webpack_require__(61);
	
	var _gracetabnote = __webpack_require__(62);
	
	var _tuning = __webpack_require__(63);
	
	var _keymanager = __webpack_require__(64);
	
	var _stavehairpin = __webpack_require__(65);
	
	var _boundingbox = __webpack_require__(8);
	
	var _strokes = __webpack_require__(35);
	
	var _textnote = __webpack_require__(50);
	
	var _curve = __webpack_require__(66);
	
	var _textdynamics = __webpack_require__(67);
	
	var _staveline = __webpack_require__(68);
	
	var _ornament = __webpack_require__(38);
	
	var _pedalmarking = __webpack_require__(69);
	
	var _textbracket = __webpack_require__(70);
	
	var _frethandfinger = __webpack_require__(28);
	
	var _staverepetition = __webpack_require__(46);
	
	var _barnote = __webpack_require__(71);
	
	var _ghostnote = __webpack_require__(72);
	
	var _notesubgroup = __webpack_require__(31);
	
	var _gracenotegroup = __webpack_require__(32);
	
	var _tremolo = __webpack_require__(73);
	
	var _stringnumber = __webpack_require__(36);
	
	var _crescendo = __webpack_require__(74);
	
	var _stavevolta = __webpack_require__(54);
	
	var _vexflow_font = __webpack_require__(9);
	
	var _system = __webpack_require__(75);
	
	var _factory = __webpack_require__(76);
	
	var _parser = __webpack_require__(78);
	
	var _easyscore = __webpack_require__(77);
	
	var _registry = __webpack_require__(6);
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	_vex.Vex.Flow = _tables.Flow;
	_vex.Vex.Flow.Element = _element.Element;
	_vex.Vex.Flow.Fraction = _fraction.Fraction;
	_vex.Vex.Flow.Renderer = _renderer.Renderer;
	_vex.Vex.Flow.Formatter = _formatter.Formatter;
	_vex.Vex.Flow.Music = _music.Music;
	_vex.Vex.Flow.Glyph = _glyph.Glyph;
	_vex.Vex.Flow.Stave = _stave.Stave;
	_vex.Vex.Flow.StaveNote = _stavenote.StaveNote;
	_vex.Vex.Flow.StaveModifier = _stavemodifier.StaveModifier;
	_vex.Vex.Flow.Voice = _voice.Voice;
	_vex.Vex.Flow.Accidental = _accidental.Accidental;
	_vex.Vex.Flow.Beam = _beam.Beam;
	_vex.Vex.Flow.StaveTie = _stavetie.StaveTie;
	_vex.Vex.Flow.TabStave = _tabstave.TabStave;
	_vex.Vex.Flow.TabNote = _tabnote.TabNote;
	_vex.Vex.Flow.Bend = _bend.Bend;
	_vex.Vex.Flow.Vibrato = _vibrato.Vibrato;
	_vex.Vex.Flow.VibratoBracket = _vibratobracket.VibratoBracket;
	_vex.Vex.Flow.Note = _note.Note;
	_vex.Vex.Flow.ModifierContext = _modifiercontext.ModifierContext;
	_vex.Vex.Flow.TickContext = _tickcontext.TickContext;
	_vex.Vex.Flow.Articulation = _articulation.Articulation;
	_vex.Vex.Flow.Annotation = _annotation.Annotation;
	_vex.Vex.Flow.Barline = _stavebarline.Barline;
	_vex.Vex.Flow.NoteHead = _notehead.NoteHead;
	_vex.Vex.Flow.StaveConnector = _staveconnector.StaveConnector;
	_vex.Vex.Flow.ClefNote = _clefnote.ClefNote;
	_vex.Vex.Flow.KeySignature = _keysignature.KeySignature;
	_vex.Vex.Flow.TimeSignature = _timesignature.TimeSignature;
	_vex.Vex.Flow.TimeSigNote = _timesignote.TimeSigNote;
	_vex.Vex.Flow.Stem = _stem.Stem;
	_vex.Vex.Flow.TabTie = _tabtie.TabTie;
	_vex.Vex.Flow.Clef = _clef.Clef;
	_vex.Vex.Flow.Modifier = _modifier.Modifier;
	_vex.Vex.Flow.TabSlide = _tabslide.TabSlide;
	_vex.Vex.Flow.Tuplet = _tuplet.Tuplet;
	_vex.Vex.Flow.GraceNote = _gracenote.GraceNote;
	_vex.Vex.Flow.GraceTabNote = _gracetabnote.GraceTabNote;
	_vex.Vex.Flow.Tuning = _tuning.Tuning;
	_vex.Vex.Flow.KeyManager = _keymanager.KeyManager;
	_vex.Vex.Flow.StaveHairpin = _stavehairpin.StaveHairpin;
	_vex.Vex.Flow.BoundingBox = _boundingbox.BoundingBox;
	_vex.Vex.Flow.Stroke = _strokes.Stroke;
	_vex.Vex.Flow.TextNote = _textnote.TextNote;
	_vex.Vex.Flow.Curve = _curve.Curve;
	_vex.Vex.Flow.TextDynamics = _textdynamics.TextDynamics;
	_vex.Vex.Flow.StaveLine = _staveline.StaveLine;
	_vex.Vex.Flow.Ornament = _ornament.Ornament;
	_vex.Vex.Flow.PedalMarking = _pedalmarking.PedalMarking;
	_vex.Vex.Flow.TextBracket = _textbracket.TextBracket;
	_vex.Vex.Flow.FretHandFinger = _frethandfinger.FretHandFinger;
	_vex.Vex.Flow.Repetition = _staverepetition.Repetition;
	_vex.Vex.Flow.BarNote = _barnote.BarNote;
	_vex.Vex.Flow.GhostNote = _ghostnote.GhostNote;
	_vex.Vex.Flow.NoteSubGroup = _notesubgroup.NoteSubGroup;
	_vex.Vex.Flow.GraceNoteGroup = _gracenotegroup.GraceNoteGroup;
	_vex.Vex.Flow.Tremolo = _tremolo.Tremolo;
	_vex.Vex.Flow.StringNumber = _stringnumber.StringNumber;
	_vex.Vex.Flow.Crescendo = _crescendo.Crescendo;
	_vex.Vex.Flow.Volta = _stavevolta.Volta;
	_vex.Vex.Flow.Font = _vexflow_font.Font;
	_vex.Vex.Flow.System = _system.System;
	_vex.Vex.Flow.Factory = _factory.Factory;
	_vex.Vex.Flow.Parser = _parser.Parser;
	_vex.Vex.Flow.EasyScore = _easyscore.EasyScore;
	_vex.Vex.Flow.Registry = _registry.Registry;
	
	exports.default = _vex.Vex;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This file implements utility methods used by the rest of the VexFlow
	// codebase.
	//
	
	var Vex = function Vex() {};
	
	// Default log function sends all arguments to console.
	Vex.L = function (block, args) {
	  if (!args) return;
	  var line = Array.prototype.slice.call(args).join(' ');
	  window.console.log(block + ': ' + line);
	};
	
	Vex.MakeException = function (name) {
	  var exception = function (_Error) {
	    _inherits(exception, _Error);
	
	    function exception(message, data) {
	      _classCallCheck(this, exception);
	
	      var _this = _possibleConstructorReturn(this, (exception.__proto__ || Object.getPrototypeOf(exception)).call(this, message));
	
	      _this.name = name;
	      _this.message = message;
	      _this.data = data;
	      return _this;
	    }
	
	    return exception;
	  }(Error);
	
	  return exception;
	};
	
	// Default runtime exception.
	
	var RuntimeError = function () {
	  function RuntimeError(code, message) {
	    _classCallCheck(this, RuntimeError);
	
	    this.code = code;
	    this.message = message;
	  }
	
	  _createClass(RuntimeError, [{
	    key: 'toString',
	    value: function toString() {
	      return '[RuntimeError] ' + this.code + ':' + this.message;
	    }
	  }]);
	
	  return RuntimeError;
	}();
	
	// Shortcut method for `RuntimeError`.
	
	
	Vex.RuntimeError = RuntimeError;
	Vex.RERR = Vex.RuntimeError;
	
	// Merge `destination` hash with `source` hash, overwriting like keys
	// in `source` if necessary.
	Vex.Merge = function (destination, source) {
	  for (var property in source) {
	    // eslint-disable-line guard-for-in
	    destination[property] = source[property];
	  }
	  return destination;
	};
	
	// DEPRECATED. Use `Math.*`.
	Vex.Min = Math.min;
	Vex.Max = Math.max;
	Vex.forEach = function (a, fn) {
	  for (var i = 0; i < a.length; i++) {
	    fn(a[i], i);
	  }
	};
	
	// Round number to nearest fractional value (`.5`, `.25`, etc.)
	Vex.RoundN = function (x, n) {
	  return x % n >= n / 2 ? parseInt(x / n, 10) * n + n : parseInt(x / n, 10) * n;
	};
	
	// Locate the mid point between stave lines. Returns a fractional line if a space.
	Vex.MidLine = function (a, b) {
	  var mid_line = b + (a - b) / 2;
	  if (mid_line % 2 > 0) {
	    mid_line = Vex.RoundN(mid_line * 10, 5) / 10;
	  }
	  return mid_line;
	};
	
	// Take `arr` and return a new list consisting of the sorted, unique,
	// contents of arr. Does not modify `arr`.
	Vex.SortAndUnique = function (arr, cmp, eq) {
	  if (arr.length > 1) {
	    var newArr = [];
	    var last = void 0;
	    arr.sort(cmp);
	
	    for (var i = 0; i < arr.length; ++i) {
	      if (i === 0 || !eq(arr[i], last)) {
	        newArr.push(arr[i]);
	      }
	      last = arr[i];
	    }
	
	    return newArr;
	  } else {
	    return arr;
	  }
	};
	
	// Check if array `a` contains `obj`.
	Vex.Contains = function (a, obj) {
	  var i = a.length;
	  while (i--) {
	    if (a[i] === obj) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Get the 2D Canvas context from DOM element `canvas_sel`.
	Vex.getCanvasContext = function (canvas_sel) {
	  if (!canvas_sel) {
	    throw new Vex.RERR('BadArgument', 'Invalid canvas selector: ' + canvas_sel);
	  }
	
	  var canvas = document.getElementById(canvas_sel);
	  if (!(canvas && canvas.getContext)) {
	    throw new Vex.RERR('UnsupportedBrowserError', 'This browser does not support HTML5 Canvas');
	  }
	
	  return canvas.getContext('2d');
	};
	
	// Draw a tiny dot marker on the specified canvas. A great debugging aid.
	//
	// `ctx`: Canvas context.
	// `x`, `y`: Dot coordinates.
	Vex.drawDot = function (ctx, x, y) {
	  var color = arguments.length <= 3 || arguments[3] === undefined ? '#55' : arguments[3];
	
	  ctx.save();
	  ctx.setFillStyle(color);
	
	  // draw a circle
	  ctx.beginPath();
	  ctx.arc(x, y, 3, 0, Math.PI * 2, true);
	  ctx.closePath();
	  ctx.fill();
	  ctx.restore();
	};
	
	// Benchmark. Run function `f` once and report time elapsed shifted by `s` milliseconds.
	Vex.BM = function (s, f) {
	  var start_time = new Date().getTime();
	  f();
	  var elapsed = new Date().getTime() - start_time;
	  Vex.L(s + elapsed + 'ms');
	};
	
	// Get stack trace.
	Vex.StackTrace = function () {
	  var err = new Error();
	  return err.stack;
	};
	
	// Dump warning to console.
	Vex.W = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var line = args.join(' ');
	  window.console.log('Warning: ', line, Vex.StackTrace());
	};
	
	// Used by various classes (e.g., SVGContext) to provide a
	// unique prefix to element names (or other keys in shared namespaces).
	Vex.Prefix = function (text) {
	  return Vex.Prefix.prefix + text;
	};
	Vex.Prefix.prefix = 'vf-';
	
	exports.Vex = Vex;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Flow = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	/* eslint-disable key-spacing */
	
	var _vex = __webpack_require__(1);
	
	var _fraction = __webpack_require__(3);
	
	var _glyph = __webpack_require__(4);
	
	var Flow = {
	  STEM_WIDTH: 1.5,
	  STEM_HEIGHT: 35,
	  STAVE_LINE_THICKNESS: 1,
	  RESOLUTION: 16384,
	  DEFAULT_NOTATION_FONT_SCALE: 39,
	  DEFAULT_TABLATURE_FONT_SCALE: 39,
	  SLASH_NOTEHEAD_WIDTH: 15,
	
	  // HACK:
	  // Since text origins are positioned at the baseline, we must
	  // compensate for the ascender of the text. Of course, 1 staff space is
	  // a very poor approximation.
	  //
	  // This will be deprecated in the future. This is a temporary solution until
	  // we have more robust text metrics.
	  TEXT_HEIGHT_OFFSET_HACK: 1,
	
	  /* Kerning (DEPRECATED) */
	  IsKerned: true
	};
	
	Flow.clefProperties = function (clef) {
	  if (!clef) throw new _vex.Vex.RERR('BadArgument', 'Invalid clef: ' + clef);
	
	  var props = Flow.clefProperties.values[clef];
	  if (!props) throw new _vex.Vex.RERR('BadArgument', 'Invalid clef: ' + clef);
	
	  return props;
	};
	
	Flow.clefProperties.values = {
	  'treble': { line_shift: 0 },
	  'bass': { line_shift: 6 },
	  'tenor': { line_shift: 4 },
	  'alto': { line_shift: 3 },
	  'soprano': { line_shift: 1 },
	  'percussion': { line_shift: 0 },
	  'mezzo-soprano': { line_shift: 2 },
	  'baritone-c': { line_shift: 5 },
	  'baritone-f': { line_shift: 5 },
	  'subbass': { line_shift: 7 },
	  'french': { line_shift: -1 }
	};
	
	/*
	  Take a note in the format "Key/Octave" (e.g., "C/5") and return properties.
	
	  The last argument, params, is a struct the currently can contain one option,
	  octave_shift for clef ottavation (0 = default; 1 = 8va; -1 = 8vb, etc.).
	*/
	Flow.keyProperties = function (key, clef, params) {
	  if (clef === undefined) {
	    clef = 'treble';
	  }
	
	  var options = { octave_shift: 0 };
	
	  if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	    _vex.Vex.Merge(options, params);
	  }
	
	  var pieces = key.split('/');
	
	  if (pieces.length < 2) {
	    throw new _vex.Vex.RERR('BadArguments', 'Key must have note + octave and an optional glyph: ' + key);
	  }
	
	  var k = pieces[0].toUpperCase();
	  var value = Flow.keyProperties.note_values[k];
	  if (!value) throw new _vex.Vex.RERR('BadArguments', 'Invalid key name: ' + k);
	  if (value.octave) pieces[1] = value.octave;
	
	  var octave = parseInt(pieces[1], 10);
	
	  // Octave_shift is the shift to compensate for clef 8va/8vb.
	  octave += -1 * options.octave_shift;
	
	  var base_index = octave * 7 - 4 * 7;
	  var line = (base_index + value.index) / 2;
	  line += Flow.clefProperties(clef).line_shift;
	
	  var stroke = 0;
	
	  if (line <= 0 && line * 2 % 2 === 0) stroke = 1; // stroke up
	  if (line >= 6 && line * 2 % 2 === 0) stroke = -1; // stroke down
	
	  // Integer value for note arithmetic.
	  var int_value = typeof value.int_val !== 'undefined' ? octave * 12 + value.int_val : null;
	
	  /* Check if the user specified a glyph. */
	  var code = value.code;
	  var shift_right = value.shift_right;
	  if (pieces.length > 2 && pieces[2]) {
	    var glyph_name = pieces[2].toUpperCase();
	    var note_glyph = Flow.keyProperties.note_glyph[glyph_name];
	    if (note_glyph) {
	      code = note_glyph.code;
	      shift_right = note_glyph.shift_right;
	    }
	  }
	
	  return {
	    key: k,
	    octave: octave,
	    line: line,
	    int_value: int_value,
	    accidental: value.accidental,
	    code: code,
	    stroke: stroke,
	    shift_right: shift_right,
	    displaced: false
	  };
	};
	
	Flow.keyProperties.note_values = {
	  'C': { index: 0, int_val: 0, accidental: null },
	  'CN': { index: 0, int_val: 0, accidental: 'n' },
	  'C#': { index: 0, int_val: 1, accidental: '#' },
	  'C##': { index: 0, int_val: 2, accidental: '##' },
	  'CB': { index: 0, int_val: -1, accidental: 'b' },
	  'CBB': { index: 0, int_val: -2, accidental: 'bb' },
	  'D': { index: 1, int_val: 2, accidental: null },
	  'DN': { index: 1, int_val: 2, accidental: 'n' },
	  'D#': { index: 1, int_val: 3, accidental: '#' },
	  'D##': { index: 1, int_val: 4, accidental: '##' },
	  'DB': { index: 1, int_val: 1, accidental: 'b' },
	  'DBB': { index: 1, int_val: 0, accidental: 'bb' },
	  'E': { index: 2, int_val: 4, accidental: null },
	  'EN': { index: 2, int_val: 4, accidental: 'n' },
	  'E#': { index: 2, int_val: 5, accidental: '#' },
	  'E##': { index: 2, int_val: 6, accidental: '##' },
	  'EB': { index: 2, int_val: 3, accidental: 'b' },
	  'EBB': { index: 2, int_val: 2, accidental: 'bb' },
	  'F': { index: 3, int_val: 5, accidental: null },
	  'FN': { index: 3, int_val: 5, accidental: 'n' },
	  'F#': { index: 3, int_val: 6, accidental: '#' },
	  'F##': { index: 3, int_val: 7, accidental: '##' },
	  'FB': { index: 3, int_val: 4, accidental: 'b' },
	  'FBB': { index: 3, int_val: 3, accidental: 'bb' },
	  'G': { index: 4, int_val: 7, accidental: null },
	  'GN': { index: 4, int_val: 7, accidental: 'n' },
	  'G#': { index: 4, int_val: 8, accidental: '#' },
	  'G##': { index: 4, int_val: 9, accidental: '##' },
	  'GB': { index: 4, int_val: 6, accidental: 'b' },
	  'GBB': { index: 4, int_val: 5, accidental: 'bb' },
	  'A': { index: 5, int_val: 9, accidental: null },
	  'AN': { index: 5, int_val: 9, accidental: 'n' },
	  'A#': { index: 5, int_val: 10, accidental: '#' },
	  'A##': { index: 5, int_val: 11, accidental: '##' },
	  'AB': { index: 5, int_val: 8, accidental: 'b' },
	  'ABB': { index: 5, int_val: 7, accidental: 'bb' },
	  'B': { index: 6, int_val: 11, accidental: null },
	  'BN': { index: 6, int_val: 11, accidental: 'n' },
	  'B#': { index: 6, int_val: 12, accidental: '#' },
	  'B##': { index: 6, int_val: 13, accidental: '##' },
	  'BB': { index: 6, int_val: 10, accidental: 'b' },
	  'BBB': { index: 6, int_val: 9, accidental: 'bb' },
	  'R': { index: 6, int_val: 9, rest: true }, // Rest
	  'X': {
	    index: 6,
	    accidental: '',
	    octave: 4,
	    code: 'v3e',
	    shift_right: 5.5
	  }
	};
	
	Flow.keyProperties.note_glyph = {
	  /* Diamond */
	  'D0': { code: 'v27', shift_right: -0.5 },
	  'D1': { code: 'v2d', shift_right: -0.5 },
	  'D2': { code: 'v22', shift_right: -0.5 },
	  'D3': { code: 'v70', shift_right: -0.5 },
	
	  /* Triangle */
	  'T0': { code: 'v49', shift_right: -2 },
	  'T1': { code: 'v93', shift_right: 0.5 },
	  'T2': { code: 'v40', shift_right: 0.5 },
	  'T3': { code: 'v7d', shift_right: 0.5 },
	
	  /* Cross */
	  'X0': { code: 'v92', shift_right: -2 },
	  'X1': { code: 'v95', shift_right: -0.5 },
	  'X2': { code: 'v7f', shift_right: 0.5 },
	  'X3': { code: 'v3b', shift_right: -2 }
	};
	
	Flow.integerToNote = function (integer) {
	  if (typeof integer === 'undefined') {
	    throw new _vex.Vex.RERR('BadArguments', 'Undefined integer for integerToNote');
	  }
	
	  if (integer < -2) {
	    throw new _vex.Vex.RERR('BadArguments', 'integerToNote requires integer > -2: ' + integer);
	  }
	
	  var noteValue = Flow.integerToNote.table[integer];
	  if (!noteValue) {
	    throw new _vex.Vex.RERR('BadArguments', 'Unknown note value for integer: ' + integer);
	  }
	
	  return noteValue;
	};
	
	Flow.integerToNote.table = {
	  0: 'C',
	  1: 'C#',
	  2: 'D',
	  3: 'D#',
	  4: 'E',
	  5: 'F',
	  6: 'F#',
	  7: 'G',
	  8: 'G#',
	  9: 'A',
	  10: 'A#',
	  11: 'B'
	};
	
	Flow.tabToGlyph = function (fret) {
	  var scale = arguments.length <= 1 || arguments[1] === undefined ? 1.0 : arguments[1];
	
	  var glyph = null;
	  var width = 0;
	  var shift_y = 0;
	
	  if (fret.toString().toUpperCase() === 'X') {
	    var glyphMetrics = new _glyph.Glyph('v7f', Flow.DEFAULT_TABLATURE_FONT_SCALE).getMetrics();
	    glyph = 'v7f';
	    width = glyphMetrics.width;
	    shift_y = -glyphMetrics.height / 2;
	  } else {
	    width = Flow.textWidth(fret.toString());
	  }
	
	  return {
	    text: fret,
	    code: glyph,
	    getWidth: function getWidth() {
	      return width * scale;
	    },
	    shift_y: shift_y
	  };
	};
	
	Flow.textWidth = function (text) {
	  return 7 * text.toString().length;
	};
	
	Flow.articulationCodes = function (artic) {
	  return Flow.articulationCodes.articulations[artic];
	};
	
	Flow.articulationCodes.articulations = {
	  'a.': { code: 'v23', between_lines: true }, // Staccato
	  'av': { code: 'v28', between_lines: true }, // Staccatissimo
	  'a>': { code: 'v42', between_lines: true }, // Accent
	  'a-': { code: 'v25', between_lines: true }, // Tenuto
	  'a^': { code: 'va', between_lines: false }, // Marcato
	  'a+': { code: 'v8b', between_lines: false }, // Left hand pizzicato
	  'ao': { code: 'v94', between_lines: false }, // Snap pizzicato
	  'ah': { code: 'vb9', between_lines: false }, // Natural harmonic or open note
	  'a@a': { code: 'v43', between_lines: false }, // Fermata above staff
	  'a@u': { code: 'v5b', between_lines: false }, // Fermata below staff
	  'a|': { code: 'v75', between_lines: false }, // Bow up - up stroke
	  'am': { code: 'v97', between_lines: false }, // Bow down - down stroke
	  'a,': { code: 'vb3', between_lines: false } };
	
	Flow.accidentalCodes = function (acc) {
	  return Flow.accidentalCodes.accidentals[acc];
	};
	
	Flow.accidentalCodes.accidentals = {
	  '#': { code: 'v18', parenRightPaddingAdjustment: -1 },
	  '##': { code: 'v7f', parenRightPaddingAdjustment: -1 },
	  'b': { code: 'v44', parenRightPaddingAdjustment: -2 },
	  'bb': { code: 'v26', parenRightPaddingAdjustment: -2 },
	  'n': { code: 'v4e', parenRightPaddingAdjustment: -1 },
	  '{': { code: 'v9c', parenRightPaddingAdjustment: -1 },
	  '}': { code: 'v84', parenRightPaddingAdjustment: -1 },
	  'db': { code: 'v9e', parenRightPaddingAdjustment: -1 },
	  'd': { code: 'vab', parenRightPaddingAdjustment: 0 },
	  'bbs': { code: 'v90', parenRightPaddingAdjustment: -1 },
	  '++': { code: 'v51', parenRightPaddingAdjustment: -1 },
	  '+': { code: 'v78', parenRightPaddingAdjustment: -1 },
	  '+-': { code: 'v8d', parenRightPaddingAdjustment: -1 },
	  '++-': { code: 'v7a', parenRightPaddingAdjustment: -1 },
	  'bs': { code: 'vb7', parenRightPaddingAdjustment: -1 },
	  'bss': { code: 'v39', parenRightPaddingAdjustment: -1 },
	  'o': { code: 'vd0', parenRightPaddingAdjustment: -1 },
	  'k': { code: 'vd1', parenRightPaddingAdjustment: -1 }
	};
	
	Flow.accidentalColumnsTable = {
	  1: {
	    a: [1],
	    b: [1]
	  },
	  2: {
	    a: [1, 2]
	  },
	  3: {
	    a: [1, 3, 2],
	    b: [1, 2, 1],
	    second_on_bottom: [1, 2, 3]
	  },
	  4: {
	    a: [1, 3, 4, 2],
	    b: [1, 2, 3, 1],
	    spaced_out_tetrachord: [1, 2, 1, 2]
	  },
	  5: {
	    a: [1, 3, 5, 4, 2],
	    b: [1, 2, 4, 3, 1],
	    spaced_out_pentachord: [1, 2, 3, 2, 1],
	    very_spaced_out_pentachord: [1, 2, 1, 2, 1] },
	  6: {
	    a: [1, 3, 5, 6, 4, 2],
	    b: [1, 2, 4, 5, 3, 1],
	    spaced_out_hexachord: [1, 3, 2, 1, 3, 2],
	    very_spaced_out_hexachord: [1, 2, 1, 2, 1, 2]
	  }
	};
	
	Flow.ornamentCodes = function (acc) {
	  return Flow.ornamentCodes.ornaments[acc];
	};
	
	Flow.ornamentCodes.ornaments = {
	  'mordent': { code: 'v1e' },
	  'mordent_inverted': { code: 'v45' },
	  'turn': { code: 'v72' },
	  'turn_inverted': { code: 'v33' },
	  'tr': { code: 'v1f' },
	  'upprall': { code: 'v60' },
	  'downprall': { code: 'vb4' },
	  'prallup': { code: 'v6d' },
	  'pralldown': { code: 'v2c' },
	  'upmordent': { code: 'v29' },
	  'downmordent': { code: 'v68' },
	  'lineprall': { code: 'v20' },
	  'prallprall': { code: 'v86' }
	};
	
	Flow.keySignature = function (spec) {
	  var keySpec = Flow.keySignature.keySpecs[spec];
	
	  if (!keySpec) {
	    throw new _vex.Vex.RERR('BadKeySignature', 'Bad key signature spec: \'' + spec + '\'');
	  }
	
	  if (!keySpec.acc) {
	    return [];
	  }
	
	  var notes = Flow.keySignature.accidentalList(keySpec.acc);
	
	  var acc_list = [];
	  for (var i = 0; i < keySpec.num; ++i) {
	    var line = notes[i];
	    acc_list.push({ type: keySpec.acc, line: line });
	  }
	
	  return acc_list;
	};
	
	Flow.keySignature.keySpecs = {
	  'C': { acc: null, num: 0 },
	  'Am': { acc: null, num: 0 },
	  'F': { acc: 'b', num: 1 },
	  'Dm': { acc: 'b', num: 1 },
	  'Bb': { acc: 'b', num: 2 },
	  'Gm': { acc: 'b', num: 2 },
	  'Eb': { acc: 'b', num: 3 },
	  'Cm': { acc: 'b', num: 3 },
	  'Ab': { acc: 'b', num: 4 },
	  'Fm': { acc: 'b', num: 4 },
	  'Db': { acc: 'b', num: 5 },
	  'Bbm': { acc: 'b', num: 5 },
	  'Gb': { acc: 'b', num: 6 },
	  'Ebm': { acc: 'b', num: 6 },
	  'Cb': { acc: 'b', num: 7 },
	  'Abm': { acc: 'b', num: 7 },
	  'G': { acc: '#', num: 1 },
	  'Em': { acc: '#', num: 1 },
	  'D': { acc: '#', num: 2 },
	  'Bm': { acc: '#', num: 2 },
	  'A': { acc: '#', num: 3 },
	  'F#m': { acc: '#', num: 3 },
	  'E': { acc: '#', num: 4 },
	  'C#m': { acc: '#', num: 4 },
	  'B': { acc: '#', num: 5 },
	  'G#m': { acc: '#', num: 5 },
	  'F#': { acc: '#', num: 6 },
	  'D#m': { acc: '#', num: 6 },
	  'C#': { acc: '#', num: 7 },
	  'A#m': { acc: '#', num: 7 }
	};
	
	Flow.unicode = {
	  // Unicode accidentals
	  'sharp': String.fromCharCode(parseInt('266F', 16)),
	  'flat': String.fromCharCode(parseInt('266D', 16)),
	  'natural': String.fromCharCode(parseInt('266E', 16)),
	  // Major Chord
	  'triangle': String.fromCharCode(parseInt('25B3', 16)),
	  // half-diminished
	  'o-with-slash': String.fromCharCode(parseInt('00F8', 16)),
	  // Diminished
	  'degrees': String.fromCharCode(parseInt('00B0', 16)),
	  'circle': String.fromCharCode(parseInt('25CB', 16))
	};
	
	Flow.keySignature.accidentalList = function (acc) {
	  var patterns = {
	    'b': [2, 0.5, 2.5, 1, 3, 1.5, 3.5],
	    '#': [0, 1.5, -0.5, 1, 2.5, 0.5, 2]
	  };
	
	  return patterns[acc];
	};
	
	Flow.parseNoteDurationString = function (durationString) {
	  if (typeof durationString !== 'string') {
	    return null;
	  }
	
	  var regexp = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/;
	
	  var result = regexp.exec(durationString);
	  if (!result) {
	    return null;
	  }
	
	  var duration = result[1];
	  var dots = result[2].length;
	  var type = result[3];
	
	  if (type.length === 0) {
	    type = 'n';
	  }
	
	  return {
	    duration: duration,
	    dots: dots,
	    type: type
	  };
	};
	
	Flow.parseNoteData = function (noteData) {
	  var duration = noteData.duration;
	
	  // Preserve backwards-compatibility
	  var durationStringData = Flow.parseNoteDurationString(duration);
	  if (!durationStringData) {
	    return null;
	  }
	
	  var ticks = Flow.durationToTicks(durationStringData.duration);
	  if (ticks == null) {
	    return null;
	  }
	
	  var type = noteData.type;
	
	  if (type) {
	    if (!(type === 'n' || type === 'r' || type === 'h' || type === 'm' || type === 's')) {
	      return null;
	    }
	  } else {
	    type = durationStringData.type;
	    if (!type) {
	      type = 'n';
	    }
	  }
	
	  var dots = noteData.dots ? noteData.dots : durationStringData.dots;
	
	  if (typeof dots !== 'number') {
	    return null;
	  }
	
	  var currentTicks = ticks;
	
	  for (var i = 0; i < dots; i++) {
	    if (currentTicks <= 1) return null;
	
	    currentTicks = currentTicks / 2;
	    ticks += currentTicks;
	  }
	
	  return {
	    duration: durationStringData.duration,
	    type: type,
	    dots: dots,
	    ticks: ticks
	  };
	};
	
	// Used to convert duration aliases to the number based duration.
	// If the input isn't an alias, simply return the input.
	//
	// example: 'q' -> '4', '8' -> '8'
	Flow.sanitizeDuration = function (duration) {
	  var alias = Flow.durationAliases[duration];
	  if (alias !== undefined) {
	    duration = alias;
	  }
	
	  if (Flow.durationToTicks.durations[duration] === undefined) {
	    throw new _vex.Vex.RERR('BadArguments', 'The provided duration is not valid: ' + duration);
	  }
	
	  return duration;
	};
	
	// Convert the `duration` to an fraction
	Flow.durationToFraction = function (duration) {
	  return new _fraction.Fraction().parse(Flow.sanitizeDuration(duration));
	};
	
	// Convert the `duration` to an number
	Flow.durationToNumber = function (duration) {
	  return Flow.durationToFraction(duration).value();
	};
	
	// Convert the `duration` to total ticks
	Flow.durationToTicks = function (duration) {
	  duration = Flow.sanitizeDuration(duration);
	
	  var ticks = Flow.durationToTicks.durations[duration];
	  if (ticks === undefined) {
	    return null;
	  }
	
	  return ticks;
	};
	
	Flow.durationToTicks.durations = {
	  '1/2': Flow.RESOLUTION * 2,
	  '1': Flow.RESOLUTION / 1,
	  '2': Flow.RESOLUTION / 2,
	  '4': Flow.RESOLUTION / 4,
	  '8': Flow.RESOLUTION / 8,
	  '16': Flow.RESOLUTION / 16,
	  '32': Flow.RESOLUTION / 32,
	  '64': Flow.RESOLUTION / 64,
	  '128': Flow.RESOLUTION / 128,
	  '256': Flow.RESOLUTION / 256
	};
	
	Flow.durationAliases = {
	  'w': '1',
	  'h': '2',
	  'q': '4',
	
	  // This is the default duration used to render bars (BarNote). Bars no longer
	  // consume ticks, so this should be a no-op.
	  //
	  // TODO(0xfe): This needs to be cleaned up.
	  'b': '256'
	};
	
	Flow.durationToGlyph = function (duration, type) {
	  duration = Flow.sanitizeDuration(duration);
	
	  var code = Flow.durationToGlyph.duration_codes[duration];
	  if (code === undefined) {
	    return null;
	  }
	
	  if (!type) {
	    type = 'n';
	  }
	
	  var glyphTypeProperties = code.type[type];
	  if (glyphTypeProperties === undefined) {
	    return null;
	  }
	
	  return _vex.Vex.Merge(_vex.Vex.Merge({}, code.common), glyphTypeProperties);
	};
	
	Flow.durationToGlyph.duration_codes = {
	  '1/2': {
	    common: {
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'v53', scale).getMetrics().width;
	      },
	
	      stem: false,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: -Flow.STEM_HEIGHT,
	      stem_down_extension: -Flow.STEM_HEIGHT,
	      gracenote_stem_up_extension: -Flow.STEM_HEIGHT,
	      gracenote_stem_down_extension: -Flow.STEM_HEIGHT,
	      tabnote_stem_up_extension: -Flow.STEM_HEIGHT,
	      tabnote_stem_down_extension: -Flow.STEM_HEIGHT,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Breve note
	        code_head: 'v53'
	      },
	      'h': { // Breve note harmonic
	        code_head: 'v59'
	      },
	      'm': { // Breve note muted -
	        code_head: 'vf',
	        stem_offset: 0
	      },
	      'r': { // Breve rest
	        code_head: 'v31',
	        rest: true,
	        position: 'B/5',
	        dot_shiftY: 0.5
	      },
	      's': { // Breve note slash -
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '1': {
	    common: {
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'v1d', scale).getMetrics().width;
	      },
	
	      stem: false,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: -Flow.STEM_HEIGHT,
	      stem_down_extension: -Flow.STEM_HEIGHT,
	      gracenote_stem_up_extension: -Flow.STEM_HEIGHT,
	      gracenote_stem_down_extension: -Flow.STEM_HEIGHT,
	      tabnote_stem_up_extension: -Flow.STEM_HEIGHT,
	      tabnote_stem_down_extension: -Flow.STEM_HEIGHT,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Whole note
	        code_head: 'v1d'
	      },
	      'h': { // Whole note harmonic
	        code_head: 'v46'
	      },
	      'm': { // Whole note muted
	        code_head: 'v92',
	        stem_offset: -3
	      },
	      'r': { // Whole rest
	        code_head: 'v5c',
	        rest: true,
	        position: 'D/5',
	        dot_shiftY: 0.5
	      },
	      's': { // Whole note slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '2': {
	    common: {
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'v81', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Half note
	        code_head: 'v81'
	      },
	      'h': { // Half note harmonic
	        code_head: 'v2d'
	      },
	      'm': { // Half note muted
	        code_head: 'v95',
	        stem_offset: -3
	      },
	      'r': { // Half rest
	        code_head: 'vc',
	        stem: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -0.5
	      },
	      's': { // Half note slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '4': {
	    common: {
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Quarter note
	        code_head: 'vb'
	      },
	      'h': { // Quarter harmonic
	        code_head: 'v22'
	      },
	      'm': { // Quarter muted
	        code_head: 'v3e',
	        stem_offset: -3
	      },
	      'r': { // Quarter rest
	        code_head: 'v7c',
	        stem: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -0.5,
	        line_above: 1.5,
	        line_below: 1.5
	      },
	      's': { // Quarter slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '8': {
	    common: {
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      beam_count: 1,
	      code_flag_upstem: 'v54',
	      code_flag_downstem: 'v9a',
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Eighth note
	        code_head: 'vb'
	      },
	      'h': { // Eighth note harmonic
	        code_head: 'v22'
	      },
	      'm': { // Eighth note muted
	        code_head: 'v3e'
	      },
	      'r': { // Eighth rest
	        code_head: 'va5',
	        stem: false,
	        flag: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -0.5,
	        line_above: 1.0,
	        line_below: 1.0
	      },
	      's': { // Eight slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '16': {
	    common: {
	      beam_count: 2,
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: 'v3f',
	      code_flag_downstem: 'v8f',
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Sixteenth note
	        code_head: 'vb'
	      },
	      'h': { // Sixteenth note harmonic
	        code_head: 'v22'
	      },
	      'm': { // Sixteenth note muted
	        code_head: 'v3e'
	      },
	      'r': { // Sixteenth rest
	        code_head: 'v3c',
	        stem: false,
	        flag: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -0.5,
	        line_above: 1.0,
	        line_below: 2.0
	      },
	      's': { // Sixteenth slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '32': {
	    common: {
	      beam_count: 3,
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: 'v47',
	      code_flag_downstem: 'v2a',
	      stem_up_extension: 9,
	      stem_down_extension: 9,
	      gracenote_stem_up_extension: -12,
	      gracenote_stem_down_extension: -12,
	      tabnote_stem_up_extension: 8,
	      tabnote_stem_down_extension: 5,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Thirty-second note
	        code_head: 'vb'
	      },
	      'h': { // Thirty-second harmonic
	        code_head: 'v22'
	      },
	      'm': { // Thirty-second muted
	        code_head: 'v3e'
	      },
	      'r': { // Thirty-second rest
	        code_head: 'v55',
	        stem: false,
	        flag: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -1.5,
	        line_above: 2.0,
	        line_below: 2.0
	      },
	      's': { // Thirty-second slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '64': {
	    common: {
	      beam_count: 4,
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: 'va9',
	      code_flag_downstem: 'v58',
	      stem_up_extension: 13,
	      stem_down_extension: 13,
	      gracenote_stem_up_extension: -10,
	      gracenote_stem_down_extension: -10,
	      tabnote_stem_up_extension: 12,
	      tabnote_stem_down_extension: 9,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Sixty-fourth note
	        code_head: 'vb'
	      },
	      'h': { // Sixty-fourth harmonic
	        code_head: 'v22'
	      },
	      'm': { // Sixty-fourth muted
	        code_head: 'v3e'
	      },
	      'r': { // Sixty-fourth rest
	        code_head: 'v38',
	        stem: false,
	        flag: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: -1.5,
	        line_above: 2.0,
	        line_below: 3.0
	      },
	      's': { // Sixty-fourth slash
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  },
	  '128': {
	    common: {
	      beam_count: 5,
	      getWidth: function getWidth() {
	        var scale = arguments.length <= 0 || arguments[0] === undefined ? Flow.DEFAULT_NOTATION_FONT_SCALE : arguments[0];
	
	        return new _glyph.Glyph(this.code_head || 'vb', scale).getMetrics().width;
	      },
	
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: 'v9b',
	      code_flag_downstem: 'v30',
	      stem_up_extension: 22,
	      stem_down_extension: 22,
	      gracenote_stem_up_extension: -8,
	      gracenote_stem_down_extension: -8,
	      tabnote_stem_up_extension: 21,
	      tabnote_stem_down_extension: 18,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      'n': { // Hundred-twenty-eight note
	        code_head: 'vb'
	      },
	      'h': { // Hundred-twenty-eight harmonic
	        code_head: 'v22'
	      },
	      'm': { // Hundred-twenty-eight muted
	        code_head: 'v3e'
	      },
	      'r': { // Hundred-twenty-eight rest
	        code_head: 'vaa',
	        stem: false,
	        flag: false,
	        rest: true,
	        position: 'B/4',
	        dot_shiftY: 1.5,
	        line_above: 3.0,
	        line_below: 3.0
	      },
	      's': { // Hundred-twenty-eight rest
	        // Drawn with canvas primitives
	        getWidth: function getWidth() {
	          return Flow.SLASH_NOTEHEAD_WIDTH;
	        },
	        position: 'B/4'
	      }
	    }
	  }
	};
	
	// Some defaults
	Flow.TIME4_4 = {
	  num_beats: 4,
	  beat_value: 4,
	  resolution: Flow.RESOLUTION
	};
	exports.Flow = Flow;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Fraction = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// Fraction class that represents a rational number
	//
	// @author zz85
	// @author incompleteopus (modifications)
	
	/* eslint-disable no-underscore-dangle */
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Fraction = function () {
	  _createClass(Fraction, null, [{
	    key: 'GCD',
	
	
	    /**
	     * GCD: Find greatest common divisor using Euclidean algorithm
	     */
	    value: function GCD(a, b) {
	      if (typeof a !== 'number' || typeof b !== 'number') {
	        throw new _vex.Vex.RERR('BadArgument', 'Invalid numbers: ' + a + ', ' + b);
	      }
	
	      var t = void 0;
	
	      while (b !== 0) {
	        t = b;
	        b = a % b;
	        a = t;
	      }
	
	      return a;
	    }
	
	    /**
	     * LCM: Lowest common multiple
	     */
	
	  }, {
	    key: 'LCM',
	    value: function LCM(a, b) {
	      return a * b / Fraction.GCD(a, b);
	    }
	
	    /**
	     * LCMM: Lowest common multiple for more than two numbers
	     */
	
	  }, {
	    key: 'LCMM',
	    value: function LCMM(args) {
	      if (args.length === 0) {
	        return 0;
	      } else if (args.length === 1) {
	        return args[0];
	      } else if (args.length === 2) {
	        return Fraction.LCM(args[0], args[1]);
	      } else {
	        var arg0 = args[0];
	        args.shift();
	        return Fraction.LCM(arg0, Fraction.LCMM(args));
	      }
	    }
	  }]);
	
	  function Fraction(numerator, denominator) {
	    _classCallCheck(this, Fraction);
	
	    this.set(numerator, denominator);
	  }
	
	  _createClass(Fraction, [{
	    key: 'set',
	    value: function set(numerator, denominator) {
	      this.numerator = numerator === undefined ? 1 : numerator;
	      this.denominator = denominator === undefined ? 1 : denominator;
	      return this;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return this.numerator / this.denominator;
	    }
	  }, {
	    key: 'simplify',
	    value: function simplify() {
	      var u = this.numerator;
	      var d = this.denominator;
	
	      var gcd = Fraction.GCD(u, d);
	      u /= gcd;
	      d /= gcd;
	
	      if (d < 0) {
	        d = -d;
	        u = -u;
	      }
	      return this.set(u, d);
	    }
	  }, {
	    key: 'add',
	    value: function add(param1, param2) {
	      var otherNumerator = void 0;
	      var otherDenominator = void 0;
	
	      if (param1 instanceof Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 0;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      var lcm = Fraction.LCM(this.denominator, otherDenominator);
	      var a = lcm / this.denominator;
	      var b = lcm / otherDenominator;
	
	      var u = this.numerator * a + otherNumerator * b;
	      return this.set(u, lcm);
	    }
	  }, {
	    key: 'subtract',
	    value: function subtract(param1, param2) {
	      var otherNumerator = void 0;
	      var otherDenominator = void 0;
	
	      if (param1 instanceof Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 0;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      var lcm = Fraction.LCM(this.denominator, otherDenominator);
	      var a = lcm / this.denominator;
	      var b = lcm / otherDenominator;
	
	      var u = this.numerator * a - otherNumerator * b;
	      return this.set(u, lcm);
	    }
	  }, {
	    key: 'multiply',
	    value: function multiply(param1, param2) {
	      var otherNumerator = void 0;
	      var otherDenominator = void 0;
	
	      if (param1 instanceof Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 1;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      return this.set(this.numerator * otherNumerator, this.denominator * otherDenominator);
	    }
	  }, {
	    key: 'divide',
	    value: function divide(param1, param2) {
	      var otherNumerator = void 0;
	      var otherDenominator = void 0;
	
	      if (param1 instanceof Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 1;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      return this.set(this.numerator * otherDenominator, this.denominator * otherNumerator);
	    }
	
	    // Simplifies both sides and checks if they are equal.
	
	  }, {
	    key: 'equals',
	    value: function equals(compare) {
	      var a = Fraction.__compareA.copy(compare).simplify();
	      var b = Fraction.__compareB.copy(this).simplify();
	
	      return a.numerator === b.numerator && a.denominator === b.denominator;
	    }
	
	    // Greater than operator.
	
	  }, {
	    key: 'greaterThan',
	    value: function greaterThan(compare) {
	      var a = Fraction.__compareB.copy(this);
	      a.subtract(compare);
	      return a.numerator > 0;
	    }
	
	    // Greater than or equals operator.
	
	  }, {
	    key: 'greaterThanEquals',
	    value: function greaterThanEquals(compare) {
	      var a = Fraction.__compareB.copy(this);
	      a.subtract(compare);
	      return a.numerator >= 0;
	    }
	
	    // Less than operator.
	
	  }, {
	    key: 'lessThan',
	    value: function lessThan(compare) {
	      return !this.greaterThanEquals(compare);
	    }
	
	    // Less than or equals operator.
	
	  }, {
	    key: 'lessThanEquals',
	    value: function lessThanEquals(compare) {
	      return !this.greaterThan(compare);
	    }
	
	    // Creates a new copy with this current values.
	
	  }, {
	    key: 'clone',
	    value: function clone() {
	      return new Fraction(this.numerator, this.denominator);
	    }
	
	    // Copies value of another Fraction into itself.
	
	  }, {
	    key: 'copy',
	    value: function copy(_copy) {
	      return this.set(_copy.numerator, _copy.denominator);
	    }
	
	    // Returns the integer component eg. (4/2) == 2
	
	  }, {
	    key: 'quotient',
	    value: function quotient() {
	      return Math.floor(this.numerator / this.denominator);
	    }
	
	    // Returns the fraction component when reduced to a mixed number
	
	  }, {
	    key: 'fraction',
	    value: function fraction() {
	      return this.numerator % this.denominator;
	    }
	
	    // Returns the absolute value
	
	  }, {
	    key: 'abs',
	    value: function abs() {
	      this.denominator = Math.abs(this.denominator);
	      this.numerator = Math.abs(this.numerator);
	      return this;
	    }
	
	    // Returns a raw string representation
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.numerator + '/' + this.denominator;
	    }
	
	    // Returns a simplified string respresentation
	
	  }, {
	    key: 'toSimplifiedString',
	    value: function toSimplifiedString() {
	      return Fraction.__tmp.copy(this).simplify().toString();
	    }
	
	    // Returns string representation in mixed form
	
	  }, {
	    key: 'toMixedString',
	    value: function toMixedString() {
	      var s = '';
	      var q = this.quotient();
	      var f = Fraction.__tmp.copy(this);
	
	      if (q < 0) {
	        f.abs().fraction();
	      } else {
	        f.fraction();
	      }
	
	      if (q !== 0) {
	        s += q;
	
	        if (f.numerator !== 0) {
	          s += ' ' + f.toSimplifiedString();
	        }
	      } else {
	        if (f.numerator === 0) {
	          s = '0';
	        } else {
	          s = f.toSimplifiedString();
	        }
	      }
	
	      return s;
	    }
	
	    // Parses a fraction string
	
	  }, {
	    key: 'parse',
	    value: function parse(str) {
	      var i = str.split('/');
	      var n = parseInt(i[0], 10);
	      var d = i[1] ? parseInt(i[1], 10) : 1;
	
	      return this.set(n, d);
	    }
	  }]);
	
	  return Fraction;
	}();
	
	// Temporary cached objects
	
	
	exports.Fraction = Fraction;
	Fraction.__compareA = new Fraction();
	Fraction.__compareB = new Fraction();
	Fraction.__tmp = new Fraction();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Glyph = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _boundingboxcomputation = __webpack_require__(7);
	
	var _boundingbox = __webpack_require__(8);
	
	var _vexflow_font = __webpack_require__(9);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	function processOutline(outline, originX, originY, scaleX, scaleY, outlineFns) {
	  var command = void 0;
	  var x = void 0;
	  var y = void 0;
	  var i = 0;
	
	  function nextX() {
	    return originX + outline[i++] * scaleX;
	  }
	  function nextY() {
	    return originY + outline[i++] * scaleY;
	  }
	
	  while (i < outline.length) {
	    command = outline[i++];
	    switch (command) {
	      case 'm':
	      case 'l':
	        outlineFns[command](nextX(), nextY());
	        break;
	      case 'q':
	        x = nextX();
	        y = nextY();
	        outlineFns.q(nextX(), nextY(), x, y);
	        break;
	      case 'b':
	        x = nextX();
	        y = nextY();
	        outlineFns.b(nextX(), nextY(), nextX(), nextY(), x, y);
	        break;
	      default:
	        break;
	    }
	  }
	}
	
	var Glyph = exports.Glyph = function (_Element) {
	  _inherits(Glyph, _Element);
	
	  _createClass(Glyph, null, [{
	    key: 'loadMetrics',
	
	    /* Static methods used to implement loading / unloading of glyphs */
	    value: function loadMetrics(font, code, cache) {
	      var glyph = font.glyphs[code];
	      if (!glyph) {
	        throw new _vex.Vex.RERR('BadGlyph', 'Glyph ' + code + ' does not exist in font.');
	      }
	
	      var x_min = glyph.x_min;
	      var x_max = glyph.x_max;
	      var ha = glyph.ha;
	
	      var outline = void 0;
	
	      if (glyph.o) {
	        if (cache) {
	          if (glyph.cached_outline) {
	            outline = glyph.cached_outline;
	          } else {
	            outline = glyph.o.split(' ');
	            glyph.cached_outline = outline;
	          }
	        } else {
	          if (glyph.cached_outline) delete glyph.cached_outline;
	          outline = glyph.o.split(' ');
	        }
	
	        return {
	          x_min: x_min,
	          x_max: x_max,
	          ha: ha,
	          outline: outline
	        };
	      } else {
	        throw new _vex.Vex.RERR('BadGlyph', 'Glyph ' + code + ' has no outline defined.');
	      }
	    }
	
	    /**
	     * A quick and dirty static glyph renderer. Renders glyphs from the default
	     * font defined in Vex.Flow.Font.
	     *
	     * @param {!Object} ctx The canvas context.
	     * @param {number} x_pos X coordinate.
	     * @param {number} y_pos Y coordinate.
	     * @param {number} point The point size to use.
	     * @param {string} val The glyph code in Vex.Flow.Font.
	     * @param {boolean} nocache If set, disables caching of font outline.
	     */
	
	  }, {
	    key: 'renderGlyph',
	    value: function renderGlyph(ctx, x_pos, y_pos, point, val, nocache) {
	      var scale = point * 72.0 / (_vexflow_font.Font.resolution * 100.0);
	      var metrics = Glyph.loadMetrics(_vexflow_font.Font, val, !nocache);
	      Glyph.renderOutline(ctx, metrics.outline, scale, x_pos, y_pos);
	    }
	  }, {
	    key: 'renderOutline',
	    value: function renderOutline(ctx, outline, scale, x_pos, y_pos) {
	      ctx.beginPath();
	      ctx.moveTo(x_pos, y_pos);
	      processOutline(outline, x_pos, y_pos, scale, -scale, {
	        m: ctx.moveTo.bind(ctx),
	        l: ctx.lineTo.bind(ctx),
	        q: ctx.quadraticCurveTo.bind(ctx),
	        b: ctx.bezierCurveTo.bind(ctx)
	      });
	      ctx.fill();
	    }
	  }, {
	    key: 'getOutlineBoundingBox',
	    value: function getOutlineBoundingBox(outline, scale, x_pos, y_pos) {
	      var bboxComp = new _boundingboxcomputation.BoundingBoxComputation();
	
	      processOutline(outline, x_pos, y_pos, scale, -scale, {
	        m: bboxComp.addPoint.bind(bboxComp),
	        l: bboxComp.addPoint.bind(bboxComp),
	        q: bboxComp.addQuadraticCurve.bind(bboxComp),
	        b: bboxComp.addBezierCurve.bind(bboxComp)
	      });
	
	      return new _boundingbox.BoundingBox(bboxComp.x1, bboxComp.y1, bboxComp.width(), bboxComp.height());
	    }
	
	    /**
	     * @constructor
	     */
	
	  }]);
	
	  function Glyph(code, point, options) {
	    _classCallCheck(this, Glyph);
	
	    var _this = _possibleConstructorReturn(this, (Glyph.__proto__ || Object.getPrototypeOf(Glyph)).call(this));
	
	    _this.setAttribute('type', 'Glyph');
	
	    _this.code = code;
	    _this.point = point;
	    _this.options = {
	      cache: true,
	      font: _vexflow_font.Font
	    };
	
	    _this.metrics = null;
	    _this.x_shift = 0;
	    _this.y_shift = 0;
	
	    _this.originShift = {
	      x: 0,
	      y: 0
	    };
	
	    if (options) {
	      _this.setOptions(options);
	    } else {
	      _this.reset();
	    }
	    return _this;
	  }
	
	  _createClass(Glyph, [{
	    key: 'setOptions',
	    value: function setOptions(options) {
	      _vex.Vex.Merge(this.options, options);
	      this.reset();
	    }
	  }, {
	    key: 'setPoint',
	    value: function setPoint(point) {
	      this.point = point;return this;
	    }
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      this.stave = stave;return this;
	    }
	  }, {
	    key: 'setXShift',
	    value: function setXShift(x_shift) {
	      this.x_shift = x_shift;return this;
	    }
	  }, {
	    key: 'setYShift',
	    value: function setYShift(y_shift) {
	      this.y_shift = y_shift;return this;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.scale = this.point * 72 / (this.options.font.resolution * 100);
	      this.metrics = Glyph.loadMetrics(this.options.font, this.code, this.options.cache);
	      this.bbox = Glyph.getOutlineBoundingBox(this.metrics.outline, this.scale, 0, 0);
	    }
	  }, {
	    key: 'getMetrics',
	    value: function getMetrics() {
	      if (!this.metrics) {
	        throw new _vex.Vex.RuntimeError('BadGlyph', 'Glyph ' + this.code + ' is not initialized.');
	      }
	
	      return {
	        x_min: this.metrics.x_min * this.scale,
	        x_max: this.metrics.x_max * this.scale,
	        width: this.bbox.getW(),
	        height: this.bbox.getH()
	      };
	    }
	  }, {
	    key: 'setOriginX',
	    value: function setOriginX(x) {
	      var bbox = this.bbox;
	
	      var originX = Math.abs(bbox.getX() / bbox.getW());
	      var xShift = (x - originX) * bbox.getW();
	      this.originShift.x = -xShift;
	    }
	  }, {
	    key: 'setOriginY',
	    value: function setOriginY(y) {
	      var bbox = this.bbox;
	
	      var originY = Math.abs(bbox.getY() / bbox.getH());
	      var yShift = (y - originY) * bbox.getH();
	      this.originShift.y = -yShift;
	    }
	  }, {
	    key: 'setOrigin',
	    value: function setOrigin(x, y) {
	      this.setOriginX(x);
	      this.setOriginY(y);
	    }
	  }, {
	    key: 'render',
	    value: function render(ctx, x, y) {
	      if (!this.metrics) {
	        throw new _vex.Vex.RuntimeError('BadGlyph', 'Glyph ' + this.code + ' is not initialized.');
	      }
	
	      var outline = this.metrics.outline;
	      var scale = this.scale;
	
	      this.setRendered();
	      this.applyStyle(ctx);
	      Glyph.renderOutline(ctx, outline, scale, x + this.originShift.x, y + this.originShift.y);
	      this.restoreStyle(ctx);
	    }
	  }, {
	    key: 'renderToStave',
	    value: function renderToStave(x) {
	      this.checkContext();
	
	      if (!this.metrics) {
	        throw new _vex.Vex.RuntimeError('BadGlyph', 'Glyph ' + this.code + ' is not initialized.');
	      }
	
	      if (!this.stave) {
	        throw new _vex.Vex.RuntimeError('GlyphError', 'No valid stave');
	      }
	
	      var outline = this.metrics.outline;
	      var scale = this.scale;
	
	      this.setRendered();
	      this.applyStyle();
	      Glyph.renderOutline(this.context, outline, scale, x + this.x_shift, this.stave.getYForGlyphs() + this.y_shift);
	      this.restoreStyle();
	    }
	  }]);

	  return Glyph;
	}(_element.Element);

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Element = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Mohit Cheppudira
	//
	// ## Description
	//
	// This file implements a generic base class for VexFlow, with implementations
	// of general functions and properties that can be inherited by all VexFlow elements.
	
	var _vex = __webpack_require__(1);
	
	var _registry = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Element = exports.Element = function () {
	  _createClass(Element, null, [{
	    key: 'newID',
	    value: function newID() {
	      return 'auto' + Element.ID++;
	    }
	  }]);
	
	  function Element() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var type = _ref.type;
	
	    _classCallCheck(this, Element);
	
	    this.attrs = {
	      id: Element.newID(),
	      el: null,
	      type: type || 'Base',
	      classes: {}
	    };
	
	    this.boundingBox = null;
	    this.context = null;
	    this.rendered = false;
	
	    // If a default registry exist, then register with it right away.
	    if (_registry.Registry.getDefaultRegistry()) {
	      _registry.Registry.getDefaultRegistry().register(this);
	    }
	  }
	
	  // set the draw style of a stemmable note:
	
	
	  _createClass(Element, [{
	    key: 'setStyle',
	    value: function setStyle(style) {
	      this.style = style;return this;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return this.style;
	    }
	
	    // Apply current style to Canvas `context`
	
	  }, {
	    key: 'applyStyle',
	    value: function applyStyle() {
	      var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	      var style = arguments.length <= 1 || arguments[1] === undefined ? this.getStyle() : arguments[1];
	
	      if (!style) return this;
	
	      context.save();
	      if (style.shadowColor) context.setShadowColor(style.shadowColor);
	      if (style.shadowBlur) context.setShadowBlur(style.shadowBlur);
	      if (style.fillStyle) context.setFillStyle(style.fillStyle);
	      if (style.strokeStyle) context.setStrokeStyle(style.strokeStyle);
	      if (style.lineWidth) context.setLineWidth(style.lineWidth);
	      return this;
	    }
	  }, {
	    key: 'restoreStyle',
	    value: function restoreStyle() {
	      var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	      var style = arguments.length <= 1 || arguments[1] === undefined ? this.getStyle() : arguments[1];
	
	      if (!style) return this;
	      context.restore();
	      return this;
	    }
	
	    // An element can have multiple class labels.
	
	  }, {
	    key: 'hasClass',
	    value: function hasClass(className) {
	      return this.attrs.classes[className] === true;
	    }
	  }, {
	    key: 'addClass',
	    value: function addClass(className) {
	      this.attrs.classes[className] = true;
	      if (this.registry) {
	        this.registry.onUpdate({
	          id: this.getAttribute('id'),
	          name: 'class',
	          value: className,
	          oldValue: null
	        });
	      }
	      return this;
	    }
	  }, {
	    key: 'removeClass',
	    value: function removeClass(className) {
	      delete this.attrs.classes[className];
	      if (this.registry) {
	        this.registry.onUpdate({
	          id: this.getAttribute('id'),
	          name: 'class',
	          value: null,
	          oldValue: className
	        });
	      }
	      return this;
	    }
	
	    // This is called by the registry after the element is registered.
	
	  }, {
	    key: 'onRegister',
	    value: function onRegister(registry) {
	      this.registry = registry;return this;
	    }
	  }, {
	    key: 'isRendered',
	    value: function isRendered() {
	      return this.rendered;
	    }
	  }, {
	    key: 'setRendered',
	    value: function setRendered() {
	      var rendered = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	      this.rendered = rendered;return this;
	    }
	  }, {
	    key: 'getAttributes',
	    value: function getAttributes() {
	      return this.attrs;
	    }
	  }, {
	    key: 'getAttribute',
	    value: function getAttribute(name) {
	      return this.attrs[name];
	    }
	  }, {
	    key: 'setAttribute',
	    value: function setAttribute(name, value) {
	      var id = this.attrs.id;
	      var oldValue = this.attrs[name];
	      this.attrs[name] = value;
	      if (this.registry) {
	        // Register with old id to support id changes.
	        this.registry.onUpdate({ id: id, name: name, value: value, oldValue: oldValue });
	      }
	      return this;
	    }
	  }, {
	    key: 'getContext',
	    value: function getContext() {
	      return this.context;
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      this.context = context;return this;
	    }
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return this.boundingBox;
	    }
	
	    // Validators
	
	  }, {
	    key: 'checkContext',
	    value: function checkContext() {
	      if (!this.context) {
	        throw new _vex.Vex.RERR('NoContext', 'No rendering context attached to instance');
	      }
	      return this.context;
	    }
	  }]);
	
	  return Element;
	}();
	
	Element.ID = 1000;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Registry = exports.X = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Mohit Cheppudira
	//
	// ## Description
	//
	// This file implements a registry for VexFlow elements. It allows users
	// to track, query, and manage some subset of generated elements, and
	// dynamically get and set attributes.
	//
	// There are two ways to regiser with a registry:
	//
	// 1) Explicitly call `element.register(registry)`, or,
	// 2) Call `Registry.enableDefaultRegistry(registry)` when ready, and all future
	//    elements will automatically register with it.
	//
	// Once an element is registered, selected attributes are tracked and indexed by
	// the registry. This allows fast look up of elements by attributes like id, type,
	// and class.
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var X = exports.X = _vex.Vex.MakeException('RegistryError');
	
	function setIndexValue(index, name, value, id, elem) {
	  if (!index[name][value]) index[name][value] = {};
	  index[name][value][id] = elem;
	}
	
	var Registry = exports.Registry = function () {
	  _createClass(Registry, null, [{
	    key: 'INDEXES',
	    get: function get() {
	      return ['type'];
	    }
	  }]);
	
	  function Registry() {
	    _classCallCheck(this, Registry);
	
	    this.clear();
	  }
	
	  // If you call `enableDefaultRegistry`, any new elements will auto-register with
	  // the provided registry as soon as they're constructed.
	
	
	  _createClass(Registry, [{
	    key: 'clear',
	    value: function clear() {
	      // Indexes are represented as maps of maps (of maps). This allows
	      // for both multi-labeling (e.g., an element can have multiple classes)
	      // and efficient lookup.
	      this.index = {
	        id: {},
	        type: {},
	        class: {}
	      };
	      return this;
	    }
	
	    // Updates the indexes for element 'id'. If an element's attribute changes
	    // from A -> B, make sure to remove the element from A.
	
	  }, {
	    key: 'updateIndex',
	    value: function updateIndex(_ref) {
	      var id = _ref.id;
	      var name = _ref.name;
	      var value = _ref.value;
	      var oldValue = _ref.oldValue;
	
	      var elem = this.getElementById(id);
	      if (oldValue !== null && this.index[name][oldValue]) {
	        delete this.index[name][oldValue][id];
	      }
	      if (value !== null) {
	        setIndexValue(this.index, name, value, elem.getAttribute('id'), elem);
	      }
	    }
	
	    // Register element `elem` with this registry. This adds the element to its index and watches
	    // it for attribute changes.
	
	  }, {
	    key: 'register',
	    value: function register(elem, id) {
	      var _this = this;
	
	      id = id || elem.getAttribute('id');
	
	      if (!id) {
	        throw new X('Can\'t add element without `id` attribute to registry', elem);
	      }
	
	      // Manually add id to index, then update other indexes.
	      elem.setAttribute('id', id);
	      setIndexValue(this.index, 'id', id, id, elem);
	      Registry.INDEXES.forEach(function (name) {
	        _this.updateIndex({ id: id, name: name, value: elem.getAttribute(name), oldValue: null });
	      });
	      elem.onRegister(this);
	      return this;
	    }
	  }, {
	    key: 'getElementById',
	    value: function getElementById(id) {
	      return this.index.id[id] ? this.index.id[id][id] : null;
	    }
	  }, {
	    key: 'getElementsByAttribute',
	    value: function getElementsByAttribute(attrName, value) {
	      var index = this.index[attrName];
	      if (index && index[value]) {
	        return Object.keys(index[value]).map(function (i) {
	          return index[value][i];
	        });
	      } else {
	        return [];
	      }
	    }
	  }, {
	    key: 'getElementsByType',
	    value: function getElementsByType(type) {
	      return this.getElementsByAttribute('type', type);
	    }
	  }, {
	    key: 'getElementsByClass',
	    value: function getElementsByClass(className) {
	      return this.getElementsByAttribute('class', className);
	    }
	
	    // This is called by the element when an attribute value changes. If an indexed
	    // attribute changes, then update the local index.
	
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate(_ref2) {
	      var id = _ref2.id;
	      var name = _ref2.name;
	      var value = _ref2.value;
	      var oldValue = _ref2.oldValue;
	
	      function includes(array, value) {
	        return array.filter(function (x) {
	          return x === value;
	        }).length > 0;
	      }
	
	      if (!includes(Registry.INDEXES.concat(['id', 'class']), name)) return this;
	      this.updateIndex({ id: id, name: name, value: value, oldValue: oldValue });
	      return this;
	    }
	  }], [{
	    key: 'enableDefaultRegistry',
	    value: function enableDefaultRegistry(registry) {
	      Registry.defaultRegistry = registry;
	    }
	  }, {
	    key: 'getDefaultRegistry',
	    value: function getDefaultRegistry() {
	      return Registry.defaultRegistry;
	    }
	  }, {
	    key: 'disableDefaultRegistry',
	    value: function disableDefaultRegistry() {
	      Registry.defaultRegistry = null;
	    }
	  }]);
	
	  return Registry;
	}();
	
	Registry.defaultRegistry = null;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// ## Description
	//
	// Object which computes metrics for a bounding box by continuously
	// taking canvas path commands
	
	// Warning: This file is merely a crutch to get bounding box information without
	// explicit metadata. This is likely to get deprecated following SMuFL support.
	//
	// taken from: https://github.com/gabelerner/canvg/blob/860e418aca67b9a41e858a223d74d375793ec364/ca
	// nvg.js#L449
	
	var BoundingBoxComputation = exports.BoundingBoxComputation = function () {
	  function BoundingBoxComputation(x1, y1, x2, y2) {
	    _classCallCheck(this, BoundingBoxComputation);
	
	    // pass in initial points if you want
	    this.x1 = Number.NaN;
	    this.y1 = Number.NaN;
	    this.x2 = Number.NaN;
	    this.y2 = Number.NaN;
	
	    this.addPoint(x1, y1);
	    this.addPoint(x2, y2);
	  }
	
	  _createClass(BoundingBoxComputation, [{
	    key: "width",
	    value: function width() {
	      return this.x2 - this.x1;
	    }
	  }, {
	    key: "height",
	    value: function height() {
	      return this.y2 - this.y1;
	    }
	  }, {
	    key: "addPoint",
	    value: function addPoint(x, y) {
	      if (x != null) {
	        if (isNaN(this.x1) || isNaN(this.x2)) {
	          this.x1 = x;
	          this.x2 = x;
	        }
	        if (x < this.x1) this.x1 = x;
	        if (x > this.x2) this.x2 = x;
	      }
	
	      if (y != null) {
	        if (isNaN(this.y1) || isNaN(this.y2)) {
	          this.y1 = y;
	          this.y2 = y;
	        }
	        if (y < this.y1) this.y1 = y;
	        if (y > this.y2) this.y2 = y;
	      }
	    }
	  }, {
	    key: "addX",
	    value: function addX(x) {
	      this.addPoint(x, null);
	    }
	  }, {
	    key: "addY",
	    value: function addY(y) {
	      this.addPoint(null, y);
	    }
	  }, {
	    key: "addQuadraticCurve",
	    value: function addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
	      var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
	      var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
	      var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
	      var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
	      this.addBezierCurve(p0x, p0y, cp1x, cp1y, cp2x, cp2y, p2x, p2y);
	    }
	  }, {
	    key: "addBezierCurve",
	    value: function addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
	      // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	      var p0 = [p0x, p0y];
	      var p1 = [p1x, p1y];
	      var p2 = [p2x, p2y];
	      var p3 = [p3x, p3y];
	      var i = void 0;
	
	      this.addPoint(p0[0], p0[1]);
	      this.addPoint(p3[0], p3[1]);
	
	      var f = function f(t, i) {
	        return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
	      };
	
	      for (i = 0; i <= 1; i++) {
	        var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	        var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	        var c = 3 * p1[i] - 3 * p0[i];
	
	        if (a === 0) {
	          if (b === 0) continue;
	          var t = -c / b;
	          if (0 < t && t < 1) {
	            if (i === 0) this.addX(f(t, i));
	            if (i === 1) this.addY(f(t, i));
	          }
	          continue;
	        }
	
	        var b2ac = Math.pow(b, 2) - 4 * c * a;
	        if (b2ac < 0) continue;
	        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
	        if (0 < t1 && t1 < 1) {
	          if (i === 0) this.addX(f(t1, i));
	          if (i === 1) this.addY(f(t1, i));
	        }
	        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
	        if (0 < t2 && t2 < 1) {
	          if (i === 0) this.addX(f(t2, i));
	          if (i === 1) this.addY(f(t2, i));
	        }
	      }
	    }
	  }]);

	  return BoundingBoxComputation;
	}();

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Vex Music Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	
	// Bounding boxes for interactive notation
	
	var BoundingBox = exports.BoundingBox = function () {
	  _createClass(BoundingBox, null, [{
	    key: "copy",
	    value: function copy(that) {
	      return new BoundingBox(that.x, that.y, that.w, that.h);
	    }
	  }]);
	
	  function BoundingBox(x, y, w, h) {
	    _classCallCheck(this, BoundingBox);
	
	    this.x = x;
	    this.y = y;
	    this.w = w;
	    this.h = h;
	  }
	
	  _createClass(BoundingBox, [{
	    key: "getX",
	    value: function getX() {
	      return this.x;
	    }
	  }, {
	    key: "getY",
	    value: function getY() {
	      return this.y;
	    }
	  }, {
	    key: "getW",
	    value: function getW() {
	      return this.w;
	    }
	  }, {
	    key: "getH",
	    value: function getH() {
	      return this.h;
	    }
	  }, {
	    key: "setX",
	    value: function setX(x) {
	      this.x = x;return this;
	    }
	  }, {
	    key: "setY",
	    value: function setY(y) {
	      this.y = y;return this;
	    }
	  }, {
	    key: "setW",
	    value: function setW(w) {
	      this.w = w;return this;
	    }
	  }, {
	    key: "setH",
	    value: function setH(h) {
	      this.h = h;return this;
	    }
	  }, {
	    key: "move",
	    value: function move(x, y) {
	      this.x += x;this.y += y;
	    }
	  }, {
	    key: "clone",
	    value: function clone() {
	      return BoundingBox.copy(this);
	    }
	
	    // Merge my box with given box. Creates a bigger bounding box unless
	    // the given box is contained in this one.
	
	  }, {
	    key: "mergeWith",
	    value: function mergeWith(boundingBox, ctx) {
	      var that = boundingBox;
	
	      var new_x = this.x < that.x ? this.x : that.x;
	      var new_y = this.y < that.y ? this.y : that.y;
	      var new_w = Math.max(this.x + this.w, that.x + that.w) - new_x;
	      var new_h = Math.max(this.y + this.h, that.y + that.h) - new_y;
	
	      this.x = new_x;
	      this.y = new_y;
	      this.w = new_w;
	      this.h = new_h;
	
	      if (ctx) this.draw(ctx);
	      return this;
	    }
	  }, {
	    key: "draw",
	    value: function draw(ctx, x, y) {
	      if (!x) x = 0;
	      if (!y) y = 0;
	      ctx.rect(this.x + x, this.y + y, this.w, this.h);
	      ctx.stroke();
	    }
	  }]);

	  return BoundingBox;
	}();

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var Font=exports.Font={"glyphs":{"v0":{"x_min":0,"x_max":514.5,"ha":525,"o":"m 236 648 b 246 648 238 648 242 648 b 288 646 261 648 283 648 b 472 513 364 634 428 587 b 514 347 502 464 514 413 b 462 163 514 272 499 217 b 257 44 409 83 333 44 b 50 163 181 44 103 83 b 0 347 14 217 0 272 b 40 513 0 413 12 464 b 236 648 87 591 155 638 m 277 614 b 253 616 273 616 261 616 b 242 616 247 616 243 616 b 170 499 193 609 181 589 b 159 348 163 446 159 398 b 166 222 159 308 161 266 b 201 91 174 138 183 106 b 257 76 215 81 235 76 b 311 91 277 76 299 81 b 347 222 330 106 338 138 b 353 348 352 266 353 308 b 344 499 353 398 351 446 b 277 614 333 587 322 606 m 257 -1 l 258 -1 l 255 -1 l 257 -1 m 257 673 l 258 673 l 255 673 l 257 673 "},"v1":{"x_min":-1.359375,"x_max":344.359375,"ha":351,"o":"m 126 637 l 129 638 l 198 638 l 266 638 l 269 635 b 274 631 272 634 273 632 l 277 627 l 277 395 b 279 156 277 230 277 161 b 329 88 281 123 295 106 b 344 69 341 81 344 79 b 337 55 344 62 343 59 l 333 54 l 197 54 l 61 54 l 58 55 b 50 69 53 59 50 62 b 65 88 50 79 53 81 b 80 97 72 91 74 93 b 117 156 103 113 112 129 b 117 345 117 161 117 222 l 117 528 l 100 503 l 38 406 b 14 383 24 384 23 383 b -1 398 5 383 -1 390 b 4 415 -1 403 1 409 b 16 437 5 416 10 426 l 72 539 l 100 596 b 121 632 119 631 119 631 b 126 637 122 634 125 635 m 171 -1 l 172 -1 l 170 -1 l 171 -1 m 171 673 l 172 673 l 170 673 l 171 673 "},"v2":{"x_min":-1.359375,"x_max":458.6875,"ha":468,"o":"m 197 648 b 216 648 201 648 208 648 b 258 646 232 648 253 648 b 419 546 333 637 393 599 b 432 489 428 528 432 509 b 356 342 432 440 405 384 b 235 278 322 313 288 295 b 69 170 166 256 107 217 b 69 169 69 170 69 169 b 69 169 69 169 69 169 b 74 173 69 169 72 170 b 209 222 112 204 163 222 b 310 195 247 222 274 215 b 371 179 332 184 352 179 b 396 181 379 179 387 179 b 428 202 409 184 423 194 b 442 212 431 209 436 212 b 458 197 450 212 458 206 b 441 148 458 190 449 165 b 299 44 409 84 353 44 b 288 45 295 44 292 44 b 250 61 274 45 268 49 b 122 99 212 86 164 99 b 73 91 104 99 88 97 b 28 63 53 84 34 72 b 14 54 25 56 20 54 b 1 62 9 54 4 56 l -1 65 l -1 79 b 0 99 -1 91 0 95 b 2 113 1 102 2 108 b 164 309 20 197 81 272 b 285 470 232 341 277 398 b 287 487 287 476 287 481 b 171 595 287 551 239 595 b 155 595 166 595 160 595 b 142 592 145 594 142 594 b 145 589 142 592 142 591 b 179 527 168 576 179 551 b 132 455 179 496 163 467 b 104 451 122 452 112 451 b 27 530 62 451 27 487 b 29 555 27 538 27 546 b 197 648 44 601 115 639 m 228 -1 l 230 -1 l 227 -1 l 228 -1 m 228 673 l 230 673 l 227 673 l 228 673 "},"v3":{"x_min":-1.359375,"x_max":409.6875,"ha":418,"o":"m 174 648 b 191 648 176 648 183 648 b 225 648 204 648 220 648 b 402 523 317 638 389 588 b 404 503 404 517 404 510 b 402 484 404 495 404 488 b 264 373 389 437 334 394 b 257 370 259 371 257 371 b 257 370 257 370 257 370 b 264 369 258 370 261 369 b 409 202 359 334 409 267 b 318 72 409 152 381 104 b 200 43 281 52 240 43 b 23 113 134 43 69 68 b 0 169 6 129 0 149 b 77 249 0 210 29 249 l 77 249 b 152 174 125 249 152 212 b 103 102 152 145 137 116 b 103 102 103 102 103 102 b 147 94 103 101 132 95 b 153 94 149 94 151 94 b 265 206 219 94 265 141 b 264 226 265 213 265 219 b 147 355 253 299 204 353 b 126 371 133 356 126 362 b 147 388 126 383 132 388 b 254 474 196 391 238 424 b 259 502 258 484 259 494 b 182 592 259 544 228 582 b 156 595 175 595 166 595 b 115 592 142 595 129 594 l 111 591 l 115 588 b 152 524 141 574 152 549 b 92 449 152 491 130 458 b 76 448 87 448 81 448 b -1 530 32 448 -1 488 b 20 581 -1 548 5 566 b 174 648 55 619 108 641 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},"v4":{"x_min":0,"x_max":468.21875,"ha":478,"o":"m 174 637 b 232 638 175 638 189 638 b 277 638 245 638 259 638 l 378 638 l 381 635 b 389 623 386 632 389 627 b 382 609 389 617 386 613 b 366 589 381 606 372 598 l 313 528 l 245 451 l 209 410 l 155 348 l 84 267 b 59 240 72 252 59 240 b 59 240 59 240 59 240 b 151 238 59 238 68 238 l 242 238 l 242 303 b 243 371 242 369 242 370 b 289 426 245 374 254 385 l 303 441 l 317 456 l 338 483 l 360 506 l 371 520 b 386 527 375 526 381 527 b 400 519 392 527 397 524 b 401 440 401 516 401 514 b 401 377 401 423 401 402 l 401 238 l 426 238 b 453 237 449 238 450 238 b 465 217 461 234 465 226 b 460 202 465 212 464 206 b 426 197 454 197 453 197 l 401 197 l 401 180 b 451 88 402 129 412 109 b 468 69 465 81 468 79 b 461 55 468 62 466 59 l 458 54 l 321 54 l 185 54 l 182 55 b 175 69 176 59 175 62 b 191 88 175 79 176 81 b 240 180 230 109 240 129 l 240 197 l 125 197 b 73 195 104 195 87 195 b 8 197 10 195 9 197 b 0 212 2 199 0 205 b 0 212 0 212 0 212 b 20 242 0 219 0 219 b 163 610 104 344 163 492 b 174 637 163 628 166 634 m 234 -1 l 235 -1 l 232 -1 l 234 -1 m 234 673 l 235 673 l 232 673 l 234 673 "},"v5":{"x_min":0,"x_max":409.6875,"ha":418,"o":"m 47 637 b 53 638 49 638 50 638 b 69 634 55 638 61 637 b 210 610 114 619 161 610 b 363 634 259 610 311 619 b 382 638 372 637 378 638 b 392 634 386 638 389 637 b 397 623 396 630 397 627 b 393 610 397 620 396 616 b 298 505 368 552 338 520 b 212 494 277 498 246 494 b 65 517 163 494 106 502 b 61 517 62 517 61 517 b 61 517 61 517 61 517 b 51 408 61 517 51 412 b 51 408 51 408 51 408 b 51 408 51 408 51 408 b 61 412 53 408 55 409 b 125 434 80 421 103 430 b 185 441 145 440 166 441 b 409 244 310 441 409 353 b 401 191 409 227 406 209 b 197 43 375 105 287 43 b 159 47 183 43 171 44 b 23 123 112 56 61 86 b 0 180 6 140 0 159 b 76 260 0 220 31 260 b 92 259 81 260 87 259 b 152 183 132 251 152 216 b 100 112 152 152 134 122 b 95 111 98 112 95 111 b 95 111 95 111 95 111 b 129 98 95 109 119 101 b 148 97 136 97 141 97 b 264 235 206 97 261 158 b 265 248 265 240 265 244 b 210 398 265 312 243 373 b 179 408 201 406 194 408 b 174 408 178 408 176 408 b 53 369 130 408 88 394 b 34 359 39 359 38 359 b 17 374 24 359 17 365 b 39 628 17 384 38 625 b 47 637 40 631 43 635 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},"v6":{"x_min":0,"x_max":475.03125,"ha":485,"o":"m 255 648 b 274 648 259 648 266 648 b 314 646 288 648 307 648 b 450 555 374 637 438 594 b 454 530 453 546 454 538 b 375 451 454 485 416 451 b 328 467 359 451 343 455 b 300 526 310 483 300 503 b 352 598 300 557 319 589 b 356 599 355 598 356 599 b 352 602 356 599 355 601 b 288 616 330 612 308 616 b 210 584 257 616 230 605 b 164 433 189 559 174 508 b 160 374 163 415 160 381 b 160 374 160 374 160 374 b 160 374 160 374 160 374 b 168 377 160 374 164 376 b 258 395 200 390 228 395 b 366 367 294 395 328 387 b 475 223 436 333 475 283 b 472 197 475 215 473 206 b 349 65 462 141 419 95 b 259 43 317 51 288 43 b 167 69 230 43 200 52 b 4 290 80 113 20 195 b 0 349 1 309 0 328 b 20 467 0 391 6 433 b 255 648 58 563 155 637 m 269 363 b 257 363 265 363 261 363 b 210 345 236 363 220 356 b 186 226 196 324 186 272 b 187 198 186 216 186 206 b 213 95 191 151 202 112 b 257 76 221 83 238 76 b 270 77 261 76 266 76 b 321 156 299 81 310 99 b 329 229 326 183 329 206 b 321 301 329 252 326 274 b 269 363 311 342 298 359 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},"v7":{"x_min":0,"x_max":442.359375,"ha":451,"o":"m 147 648 b 166 649 153 649 160 649 b 313 598 217 649 273 630 b 340 587 323 588 328 587 l 341 587 b 412 628 367 587 390 601 b 427 638 416 635 421 638 b 439 632 431 638 435 637 b 442 623 441 630 442 628 b 430 569 442 616 439 603 b 352 369 408 492 377 410 b 300 259 325 324 313 298 b 273 84 283 205 273 140 b 265 55 273 65 272 59 l 261 54 l 181 54 l 99 54 l 96 55 b 91 61 95 56 92 59 l 89 63 l 89 77 b 147 263 89 133 111 202 b 261 401 176 313 212 355 b 378 541 315 449 349 489 l 382 548 l 375 544 b 240 495 333 512 285 495 b 129 535 198 495 160 509 b 84 560 108 552 95 560 b 76 559 81 560 78 560 b 31 487 59 555 43 530 b 14 470 27 473 24 470 b 1 477 8 470 4 471 l 0 480 l 0 553 l 0 627 l 1 630 b 16 638 4 635 9 638 b 23 635 17 638 20 637 b 49 626 36 626 39 626 b 96 638 59 626 80 630 b 104 639 99 638 102 639 b 117 644 107 641 112 642 b 147 648 125 645 137 648 m 220 -1 l 221 -1 l 219 -1 l 220 -1 m 220 673 l 221 673 l 219 673 l 220 673 "},"v8":{"x_min":0,"x_max":488.640625,"ha":499,"o":"m 217 648 b 245 649 225 648 235 649 b 453 516 343 649 430 595 b 458 478 455 503 458 491 b 412 370 458 440 441 398 b 411 369 412 369 411 369 b 415 365 411 367 412 367 b 488 231 462 331 488 281 b 472 165 488 208 483 186 b 243 43 434 86 338 43 b 63 104 178 43 112 62 b 0 233 20 140 0 186 b 73 365 0 283 24 331 l 77 369 l 72 374 b 29 476 42 406 29 441 b 217 648 29 557 103 635 m 258 605 b 242 606 253 605 247 606 b 157 552 198 606 157 580 b 160 541 157 548 159 544 b 319 413 176 503 242 452 l 337 403 l 338 406 b 359 476 352 428 359 452 b 258 605 359 537 318 595 m 138 326 b 130 330 134 328 130 330 b 130 330 130 330 130 330 b 107 305 127 330 112 313 b 84 231 91 281 84 256 b 243 86 84 156 151 86 b 249 87 245 86 246 87 b 347 156 303 88 347 120 b 344 172 347 162 345 167 b 156 319 325 227 257 281 b 138 326 151 322 144 324 m 243 -1 l 245 -1 l 242 -1 l 243 -1 m 243 673 l 245 673 l 242 673 l 243 673 "},"v9":{"x_min":0,"x_max":475.03125,"ha":485,"o":"m 191 646 b 212 649 198 648 205 649 b 255 644 227 649 243 646 b 458 448 348 616 428 539 b 475 342 469 415 475 378 b 460 244 475 308 469 274 b 193 44 421 124 303 44 b 91 69 157 44 122 51 b 19 161 43 97 19 126 b 21 181 19 167 20 174 b 98 241 32 220 65 241 b 170 186 129 241 160 223 b 172 166 171 179 172 173 b 121 94 172 134 152 102 b 117 93 118 94 117 93 b 121 90 117 93 118 91 b 185 76 142 80 164 76 b 270 119 220 76 251 91 b 308 259 287 145 300 194 b 313 317 310 277 313 310 b 313 317 313 317 313 317 b 313 317 313 317 313 317 b 304 315 313 317 308 316 b 216 295 273 302 245 295 b 145 308 193 295 170 299 b 19 398 88 327 42 360 b 0 469 5 420 0 444 b 24 551 0 496 8 526 b 191 646 54 596 125 637 m 227 614 b 215 616 224 616 220 616 b 202 614 210 616 206 616 b 152 535 174 610 163 592 b 144 463 147 509 144 485 b 152 391 144 440 147 417 b 216 328 163 344 179 328 b 280 391 253 328 269 344 b 288 463 285 417 288 440 b 280 535 288 485 285 509 b 227 614 269 594 258 610 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},"va":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -8 -1 b -1 0 -5 -1 -4 0 b 16 -11 5 0 13 -4 b 83 -186 17 -12 47 -90 l 148 -358 l 148 -363 b 127 -385 148 -376 138 -385 b 112 -378 122 -385 118 -383 b 54 -226 110 -374 114 -385 b 0 -81 24 -147 0 -81 b -55 -226 -1 -81 -25 -147 b -114 -378 -115 -385 -111 -374 b -129 -385 -119 -383 -123 -385 b -149 -363 -140 -385 -149 -376 l -149 -358 l -84 -186 b -19 -11 -49 -90 -19 -12 b -8 -1 -17 -8 -12 -4 "},"vb":{"x_min":0,"x_max":428.75,"ha":438,"o":"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 "},"vc":{"x_min":0,"x_max":447.8125,"ha":457,"o":"m 0 86 l 0 173 l 223 173 l 447 173 l 447 86 l 447 0 l 223 0 l 0 0 l 0 86 "},"vf":{"x_min":0,"x_max":370.21875,"ha":378,"o":"m 0 0 l 0 277 l 61 277 l 122 277 l 122 0 l 122 -278 l 61 -278 l 0 -278 l 0 0 m 246 -1 l 246 277 l 308 277 l 370 277 l 370 -1 l 370 -278 l 308 -278 l 246 -278 l 246 -1 "},"v10":{"x_min":0,"x_max":559.421875,"ha":571,"o":"m 5 127 b 14 127 6 127 9 127 b 51 126 25 127 43 127 b 175 98 93 122 138 112 l 186 94 b 279 51 210 86 255 65 b 285 47 280 51 283 48 b 319 27 291 44 311 31 l 326 22 b 359 0 332 19 352 4 l 367 -6 b 371 -9 368 -6 370 -8 l 379 -15 b 387 -22 383 -18 386 -20 l 398 -30 l 411 -40 l 417 -47 l 427 -55 l 434 -61 b 441 -66 436 -62 439 -65 l 446 -72 l 453 -77 l 462 -87 b 558 -188 490 -113 549 -176 b 559 -195 559 -191 559 -194 b 548 -205 559 -201 555 -205 b 541 -204 547 -205 544 -205 b 534 -198 539 -201 536 -199 l 525 -191 b 481 -162 518 -187 490 -167 b 472 -155 477 -159 472 -156 b 468 -152 470 -155 469 -154 b 461 -149 466 -152 464 -151 b 428 -130 454 -145 441 -137 b 371 -99 413 -122 372 -99 b 363 -95 371 -99 367 -98 b 353 -91 357 -94 353 -91 b 348 -90 353 -91 352 -91 b 332 -81 343 -87 341 -86 b 27 -12 230 -37 127 -13 b 0 -5 4 -11 2 -11 b 0 58 0 -2 0 27 b 0 122 0 88 0 120 b 5 127 1 124 4 126 "},"v11":{"x_min":-155.171875,"x_max":153.8125,"ha":157,"o":"m -137 353 b -130 353 -136 353 -133 353 b -112 349 -125 353 -119 352 b -100 342 -110 347 -104 344 b 0 317 -69 326 -35 317 b 111 349 38 317 76 328 b 129 353 117 352 123 353 b 153 327 142 353 153 344 b 144 302 153 320 153 317 b 27 6 93 226 50 113 b 21 -13 24 -11 24 -11 b 0 -26 17 -22 8 -26 b -24 -12 -9 -26 -19 -22 b -28 5 -24 -9 -27 -2 b -145 302 -53 117 -95 224 b -155 327 -155 317 -155 320 b -137 353 -155 340 -148 349 "},"v18":{"x_min":0,"x_max":323.9375,"ha":331,"o":"m 217 535 b 225 537 220 537 221 537 b 245 524 235 537 242 533 l 246 521 l 247 390 l 247 258 l 273 265 b 306 270 288 269 299 270 b 322 259 315 270 319 267 b 323 208 323 256 323 233 b 322 158 323 184 323 159 b 288 140 318 148 315 147 b 247 130 254 131 247 130 b 247 65 247 130 247 104 b 247 20 247 51 247 36 l 247 -88 l 273 -81 b 306 -76 289 -77 299 -76 b 318 -81 311 -76 315 -77 b 323 -123 323 -87 323 -86 l 323 -138 l 323 -154 b 318 -195 323 -191 323 -190 b 269 -210 314 -199 315 -199 b 249 -216 259 -213 250 -216 l 247 -216 l 247 -349 l 246 -483 l 245 -487 b 225 -499 242 -495 234 -499 b 206 -487 219 -499 210 -495 l 205 -483 l 205 -355 l 205 -227 l 204 -227 l 181 -233 l 138 -244 b 117 -249 127 -247 117 -249 b 115 -385 115 -249 115 -256 l 115 -523 l 114 -526 b 95 -538 110 -534 102 -538 b 74 -526 87 -538 78 -534 l 73 -523 l 73 -391 b 72 -260 73 -269 73 -260 b 72 -260 72 -260 72 -260 b 19 -273 61 -263 23 -273 b 0 -260 10 -273 4 -267 b 0 -209 0 -256 0 -256 l 0 -162 l 1 -158 b 61 -134 5 -148 5 -148 l 73 -131 l 73 -22 b 72 86 73 79 73 86 b 72 86 72 86 72 86 b 19 74 61 83 23 74 b 0 86 10 74 4 79 b 0 137 0 90 0 90 l 0 184 l 1 188 b 61 212 5 198 5 198 l 73 215 l 73 348 l 73 481 l 74 485 b 95 498 78 492 87 498 b 103 495 98 498 100 496 b 114 485 107 494 111 489 l 115 481 l 115 353 l 115 226 l 121 226 b 159 235 123 227 141 231 l 198 247 l 205 248 l 205 384 l 205 521 l 206 524 b 217 535 209 528 212 533 m 205 9 b 205 119 205 70 205 119 l 205 119 b 182 113 204 119 194 116 l 138 102 b 117 97 127 99 117 97 b 115 -12 115 97 115 91 l 115 -122 l 121 -120 b 159 -111 123 -119 141 -115 l 198 -101 l 205 -98 l 205 9 "},"v1b":{"x_min":0,"x_max":559.421875,"ha":571,"o":"m 544 204 b 548 204 545 204 547 204 b 559 194 555 204 559 199 b 559 190 559 192 559 191 b 530 156 559 188 556 184 b 462 86 510 134 481 104 b 453 76 458 81 454 77 l 446 70 l 441 65 b 434 59 439 63 436 61 l 427 54 b 409 37 426 51 416 44 b 392 23 398 29 394 26 b 387 19 389 22 387 20 b 379 13 386 19 383 16 l 371 8 l 367 5 l 359 -1 l 337 -16 b 285 -48 319 -29 298 -41 l 279 -52 b 186 -95 255 -66 210 -87 l 175 -99 b 23 -129 127 -117 68 -129 b 17 -129 20 -129 19 -129 b 1 -123 2 -129 2 -129 b 0 -49 0 -122 0 -83 b 0 4 0 -22 0 1 b 27 11 2 9 4 9 b 185 31 78 12 145 20 b 198 34 186 31 193 33 b 314 73 234 44 277 58 b 349 88 328 79 340 84 b 353 90 352 90 353 90 b 363 94 353 90 357 93 b 371 98 367 97 371 98 b 428 129 372 98 413 120 b 461 148 441 136 454 144 b 468 151 464 149 466 151 b 472 154 469 152 470 154 b 481 161 473 155 477 158 b 525 190 490 166 518 186 l 534 197 b 540 201 536 198 539 199 b 544 204 541 202 544 204 "},"v1d":{"x_min":0,"x_max":619.3125,"ha":632,"o":"m 274 184 b 307 186 285 186 296 186 b 616 22 465 186 597 116 b 619 -1 617 13 619 5 b 308 -187 619 -104 483 -187 b 0 -1 133 -187 0 -102 b 5 36 0 11 1 23 b 274 184 29 115 141 176 m 289 161 b 272 162 284 162 277 162 b 171 41 209 162 171 108 b 205 -73 171 5 182 -34 b 345 -163 243 -133 298 -163 b 436 -98 385 -163 420 -142 b 446 -43 443 -80 446 -62 b 289 161 446 47 377 147 "},"v1e":{"x_min":-402.890625,"x_max":401.53125,"ha":410,"o":"m -219 173 b -213 174 -217 174 -215 174 b -202 173 -209 174 -205 173 b -114 86 -200 172 -179 151 b -28 0 -66 37 -28 0 b 40 84 -28 0 2 37 b 117 174 111 173 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b -42 -86 27 0 -4 -38 b -118 -174 -112 -174 -111 -173 b -123 -176 -119 -176 -121 -176 b -133 -174 -126 -176 -130 -174 b -296 -12 -136 -173 -172 -137 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 172 -398 -43 -228 167 b -219 173 -223 172 -220 173 "},"v1f":{"x_min":-340.28125,"x_max":338.921875,"ha":346,"o":"m -32 520 b -29 521 -31 520 -31 521 b -23 519 -27 521 -24 520 b -20 513 -21 517 -20 516 b -21 506 -20 512 -20 509 b -31 474 -23 502 -27 488 l -53 402 l -66 352 l -68 349 l -57 349 b -32 351 -51 349 -40 351 b 123 370 19 352 74 359 b 137 371 127 370 133 371 b 170 356 152 371 164 366 b 171 355 170 355 170 355 b 216 366 174 355 183 358 b 280 378 268 377 266 377 b 287 378 283 378 284 378 b 332 349 307 378 322 369 b 338 319 336 341 338 330 b 332 301 338 310 336 302 b 242 280 329 299 246 280 b 242 280 242 280 242 280 b 235 288 236 280 235 283 b 235 292 235 290 235 291 b 236 302 236 297 236 299 b 220 337 236 316 230 330 l 216 340 l 210 335 b 159 276 189 322 172 301 b 118 149 152 265 156 274 b 81 34 84 36 85 36 b -8 13 78 33 -4 13 b -8 13 -8 13 -8 13 b -14 20 -12 15 -14 15 b -8 44 -14 24 -12 31 b -2 66 -5 55 -2 65 b -2 66 -2 66 -2 66 l -2 66 b -43 41 -2 66 -21 55 b -114 4 -98 8 -98 8 b -144 0 -123 0 -134 0 b -242 99 -197 0 -242 43 b -242 109 -242 102 -242 105 b -212 219 -240 122 -242 116 b -185 312 -197 270 -185 312 l -185 312 b -189 312 -185 312 -186 312 b -259 312 -200 312 -227 312 b -321 310 -291 312 -310 310 b -334 312 -330 310 -334 312 b -340 319 -338 313 -340 316 b -336 326 -340 322 -338 324 b -291 337 -334 326 -314 331 l -247 347 l -210 348 b -172 348 -190 348 -172 348 b -168 363 -172 348 -171 355 b -145 442 -151 424 -145 441 b -133 452 -144 444 -140 446 l -77 489 b -32 520 -53 506 -32 520 m 57 334 b 53 335 55 335 54 335 b 44 334 50 335 49 335 b -70 316 8 326 -28 320 b -78 309 -78 316 -78 316 b -108 202 -80 305 -88 274 b -141 81 -136 112 -141 93 b -140 74 -141 79 -141 77 b -117 49 -137 59 -127 49 b -107 52 -114 49 -110 51 b 16 127 -106 54 14 126 b 42 217 16 127 42 215 b 49 241 42 222 44 229 b 73 320 53 251 73 317 b 57 334 73 327 65 333 "},"v20":{"x_min":-571.671875,"x_max":570.3125,"ha":582,"o":"m -559 351 b -551 352 -556 352 -553 352 b -530 338 -543 352 -533 348 b -529 169 -530 337 -529 291 l -529 1 l -507 27 l -441 112 b -382 174 -394 169 -390 174 b -378 174 -381 174 -379 174 b -281 86 -370 174 -375 179 b -196 0 -234 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 279 172 b 289 174 285 174 288 174 b 300 173 294 174 298 173 b 462 11 303 172 340 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 375 -176 371 -176 b 280 -87 367 -173 347 -152 b 194 0 234 -38 194 0 b 126 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 44 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -140 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -288 -176 b -300 -174 -294 -176 -298 -174 b -464 -11 -303 -173 -374 -102 l -476 0 l -506 -37 b -539 -76 -528 -65 -537 -74 b -551 -80 -543 -79 -547 -80 b -570 -68 -558 -80 -566 -76 l -571 -65 l -571 136 b -570 340 -571 331 -571 337 b -559 351 -568 344 -564 348 "},"v22":{"x_min":0,"x_max":432.828125,"ha":442,"o":"m 209 186 b 213 187 210 187 212 187 b 216 187 215 187 216 187 b 224 174 216 186 220 180 b 420 -1 269 105 338 43 b 432 -12 431 -8 432 -9 b 421 -23 432 -15 432 -16 b 228 -180 345 -70 264 -137 b 219 -188 221 -188 221 -188 l 219 -188 b 208 -177 215 -188 215 -188 b 10 1 163 -106 93 -44 b 0 11 0 6 0 8 b 10 22 0 13 0 15 b 202 179 87 69 167 136 b 209 186 206 183 209 186 "},"v23":{"x_min":0,"x_max":133.390625,"ha":136,"o":"m 54 66 b 65 68 58 68 61 68 b 122 37 88 68 110 56 b 133 -1 130 26 133 12 b 104 -58 133 -23 123 -44 b 66 -69 92 -65 78 -69 b 10 -38 44 -69 23 -58 b 0 -1 2 -27 0 -13 b 54 66 0 30 20 61 "},"v25":{"x_min":0,"x_max":318.5,"ha":325,"o":"m 20 376 b 167 377 23 377 96 377 b 296 376 231 377 294 377 b 318 347 311 371 318 359 b 296 316 318 333 311 320 b 159 315 294 315 227 315 b 21 316 91 315 24 315 b 0 345 6 320 0 333 b 20 376 0 359 6 371 "},"v26":{"x_min":-21.78125,"x_max":483.1875,"ha":493,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 179 164 199 187 192 l 210 176 l 210 396 l 210 617 l 212 621 b 231 632 216 628 223 632 b 250 620 239 632 247 628 b 251 383 251 616 251 616 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},"v27":{"x_min":0,"x_max":432.828125,"ha":442,"o":"m 208 184 b 213 187 209 186 212 187 b 224 176 217 187 221 183 b 245 147 225 172 235 159 b 419 -1 288 90 347 38 b 431 -8 424 -4 431 -8 b 432 -12 432 -9 432 -11 b 430 -18 432 -13 432 -16 b 364 -61 424 -20 383 -47 b 225 -183 307 -102 250 -152 b 223 -187 224 -184 223 -187 b 220 -188 221 -188 220 -188 b 208 -176 216 -188 210 -184 b 187 -148 205 -173 197 -159 b 12 0 144 -90 84 -38 b 0 11 4 5 0 8 b 16 24 0 13 4 18 b 183 158 83 69 141 115 b 208 184 194 169 198 173 m 183 105 b 176 113 181 109 176 113 b 172 109 176 113 175 112 b 92 45 149 90 117 62 l 88 41 l 102 31 b 247 -105 160 -6 210 -55 l 254 -115 l 257 -112 l 269 -102 b 340 -45 287 -87 319 -61 l 344 -43 l 330 -33 b 183 105 272 6 221 54 "},"v28":{"x_min":-73.5,"x_max":72.140625,"ha":74,"o":"m -72 252 l -73 254 l 0 254 l 72 254 l 70 252 b 0 -1 70 248 0 -1 b -72 252 -1 -1 -72 248 "},"v29":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m 175 273 b 182 274 178 273 181 274 b 202 262 190 274 198 269 b 204 158 204 259 204 259 l 204 56 l 250 112 b 303 174 296 172 298 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 208 -6 213 0 210 -2 l 204 -12 l 204 -147 b 204 -210 204 -173 204 -194 b 198 -292 204 -297 204 -287 b 183 -299 194 -297 189 -299 b 164 -287 175 -299 167 -295 b 163 -174 163 -284 163 -284 l 161 -63 l 119 -117 b 65 -176 76 -170 73 -176 b 61 -176 63 -176 62 -176 b -35 -87 51 -174 57 -180 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -363 174 -374 170 -371 174 b -359 174 -362 174 -360 174 b -262 86 -351 174 -356 179 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 147 11 -13 172 35 123 l 157 -1 l 160 1 l 163 4 l 163 130 b 164 260 163 256 163 258 b 175 273 166 266 170 270 "},"v2a":{"x_min":-21.78125,"x_max":366.140625,"ha":374,"o":"m 276 1378 b 284 1379 279 1379 281 1379 b 306 1360 292 1379 298 1374 b 352 1247 326 1326 343 1286 b 366 1139 362 1213 366 1175 b 347 1009 366 1093 359 1049 l 344 1002 l 347 992 b 352 971 348 986 351 977 b 366 863 362 936 366 899 b 347 732 366 818 359 773 l 344 725 l 347 716 b 352 695 348 710 351 700 b 366 588 362 659 366 623 b 223 262 366 464 314 345 b 189 233 212 252 212 252 b 35 76 126 183 73 129 b -1 16 20 56 2 27 b -19 4 -4 9 -12 4 l -21 4 l -21 137 l -21 270 l -17 270 b 186 344 59 281 134 308 b 319 606 270 399 319 499 b 317 650 319 620 319 635 l 315 659 l 314 655 b 223 537 288 607 258 570 b 189 509 212 528 212 528 b 35 352 126 459 73 405 b -1 292 20 333 2 303 b -19 280 -4 285 -12 280 l -21 280 l -21 413 l -21 546 l -17 546 b 186 620 59 557 134 584 b 319 882 270 675 319 775 b 317 925 319 896 319 911 l 315 935 l 314 931 b 223 813 288 884 258 846 b 189 785 212 805 212 805 b 35 628 126 735 73 681 b -1 569 20 609 2 580 b -19 556 -4 562 -12 556 l -21 556 l -21 689 l -21 823 l -17 823 b 202 907 68 835 152 867 b 319 1157 280 968 319 1061 b 270 1338 319 1218 303 1281 b 262 1358 264 1349 262 1353 b 262 1364 262 1360 262 1363 b 276 1378 265 1371 269 1376 "},"v2c":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -413 173 b -408 174 -412 174 -409 174 b -397 173 -404 174 -400 173 b -308 86 -394 172 -374 151 b -223 0 -261 37 -223 0 b -153 84 -223 0 -191 37 b -77 174 -83 173 -84 172 b -72 174 -76 174 -74 174 b -62 173 -68 174 -63 173 b 25 86 -59 172 -39 151 b 112 0 73 37 111 0 b 181 84 112 0 144 37 b 257 174 251 173 251 172 b 262 174 258 174 261 174 b 273 173 266 174 270 173 b 436 9 276 172 347 101 l 447 -1 l 477 36 b 522 79 511 79 513 79 l 522 79 b 552 51 533 79 539 73 b 596 -112 582 6 596 -51 b 567 -262 596 -161 586 -213 b 539 -322 558 -287 544 -316 b 524 -327 534 -326 529 -327 b 504 -315 515 -327 507 -323 b 503 -308 503 -312 503 -309 b 511 -285 503 -302 504 -297 b 555 -113 540 -227 555 -169 b 544 -34 555 -86 551 -59 b 522 19 540 -16 530 8 l 521 22 l 481 -26 l 405 -122 b 353 -176 366 -172 362 -176 b 349 -176 352 -176 351 -176 b 253 -87 341 -176 347 -180 b 167 0 206 -38 167 0 b 99 -86 167 0 136 -38 b 21 -174 27 -174 28 -173 b 17 -176 20 -176 19 -176 b 6 -174 13 -176 9 -174 b -81 -87 4 -173 -14 -152 b -167 0 -129 -38 -167 0 b -236 -86 -167 0 -198 -38 b -313 -174 -307 -174 -306 -173 b -318 -176 -314 -176 -315 -176 b -328 -174 -321 -176 -325 -174 b -491 -12 -330 -173 -367 -137 l -503 0 l -530 -34 b -570 -77 -562 -73 -564 -76 b -577 -79 -571 -79 -574 -79 b -597 -58 -588 -79 -597 -69 b -596 -49 -597 -55 -597 -52 b -417 172 -593 -43 -423 167 b -413 173 -417 172 -415 173 "},"v2d":{"x_min":0,"x_max":438.28125,"ha":447,"o":"m 212 190 b 219 191 213 191 216 191 b 236 176 225 191 228 190 b 419 18 277 105 341 49 b 436 5 431 13 434 11 b 438 -1 438 4 438 1 b 424 -16 438 -8 432 -13 b 356 -49 409 -20 379 -36 b 234 -180 306 -83 258 -133 b 219 -192 230 -188 224 -192 b 200 -176 213 -192 206 -187 b 9 -15 157 -102 89 -45 b 0 0 2 -12 0 -6 b 16 18 0 9 2 12 b 200 176 93 48 159 104 b 212 190 205 186 208 188 m 239 113 b 236 117 238 116 238 117 b 230 108 235 117 234 115 b 92 -15 196 58 140 8 b 88 -18 91 -16 88 -18 b 92 -20 88 -18 91 -19 b 198 -116 130 -43 166 -74 b 200 -117 200 -117 200 -117 b 201 -117 200 -117 201 -117 b 264 -43 212 -98 242 -62 b 345 15 288 -19 321 4 b 348 18 347 16 348 16 b 344 20 348 18 347 19 b 239 113 307 41 266 79 "},"v2f":{"x_min":-1.359375,"x_max":680.5625,"ha":694,"o":"m 597 1042 b 604 1042 600 1042 602 1042 b 642 1002 627 1042 642 1022 b 619 966 642 988 635 974 b 439 927 574 942 503 927 l 426 927 l 426 921 b 430 838 428 893 430 866 b 345 480 430 696 398 560 b 179 391 307 423 249 391 b 156 392 171 391 164 392 b 138 394 149 394 142 394 b 103 434 115 396 103 416 b 129 471 103 451 111 466 b 141 474 133 473 137 474 b 172 459 153 474 164 469 b 181 455 175 456 176 455 b 187 456 182 455 185 455 b 253 520 212 460 234 483 b 315 836 294 605 315 714 b 311 928 315 867 314 898 b 302 945 310 943 311 942 b 245 953 283 950 262 953 b 130 891 193 953 149 931 b 84 860 119 870 102 860 b 36 905 61 860 39 877 b 36 910 36 907 36 909 b 80 970 36 931 50 949 b 249 1017 125 1000 187 1017 b 322 1009 273 1017 299 1014 l 341 1003 b 436 991 372 995 406 991 b 577 1031 495 991 545 1004 b 597 1042 583 1038 590 1041 m 416 360 b 424 360 419 360 421 360 b 481 309 454 360 479 338 b 503 145 484 280 495 199 b 585 -185 525 16 555 -106 b 630 -245 596 -213 613 -237 l 634 -247 l 638 -245 b 647 -244 641 -245 645 -244 b 680 -278 666 -244 680 -262 b 664 -308 680 -290 675 -301 b 638 -312 658 -310 650 -312 b 613 -309 631 -312 623 -310 b 477 -201 555 -303 502 -260 b 417 -2 460 -159 434 -72 b 416 5 417 1 416 5 b 416 5 416 5 416 5 b 411 -5 415 5 413 0 b 359 -97 397 -33 377 -70 b 353 -106 355 -102 353 -105 b 359 -112 353 -108 355 -109 b 409 -130 375 -123 390 -129 b 426 -134 420 -130 421 -131 b 431 -147 428 -137 431 -141 b 420 -162 431 -152 427 -159 b 382 -169 409 -166 396 -169 b 323 -155 363 -169 341 -165 l 317 -152 l 314 -155 b 62 -303 240 -240 148 -295 b 36 -305 55 -305 44 -305 b 23 -303 29 -305 24 -305 b -1 -273 6 -299 -1 -287 b 31 -240 -1 -256 10 -240 b 36 -240 32 -240 34 -240 b 42 -241 38 -241 39 -241 b 134 -204 63 -241 99 -226 b 367 288 265 -115 357 81 b 375 330 368 313 370 320 b 416 360 383 347 400 358 m 360 -359 b 379 -359 363 -359 371 -359 b 424 -360 396 -359 416 -359 b 646 -502 536 -373 624 -430 b 649 -527 649 -510 649 -519 b 530 -673 649 -578 604 -635 l 521 -677 l 529 -681 b 653 -811 592 -714 637 -762 b 660 -853 658 -827 660 -839 b 645 -911 660 -873 656 -892 b 426 -1021 608 -981 519 -1021 b 283 -989 377 -1021 328 -1011 b 235 -949 249 -972 239 -964 b 234 -936 234 -946 234 -941 b 234 -928 234 -934 234 -931 l 235 -925 l 234 -927 l 225 -934 b 87 -982 186 -966 138 -982 b 80 -982 85 -982 83 -982 b 55 -981 70 -981 58 -981 b 17 -943 32 -981 17 -964 b 54 -904 17 -921 35 -904 b 78 -914 62 -904 72 -909 l 83 -918 l 88 -918 b 190 -831 122 -918 166 -881 b 269 -506 242 -727 269 -612 b 268 -462 269 -492 269 -477 b 266 -449 266 -458 266 -452 b 265 -444 266 -445 266 -444 b 257 -446 264 -444 261 -445 b 132 -545 196 -470 152 -505 b 88 -573 122 -563 104 -573 b 39 -523 63 -573 39 -553 b 63 -476 39 -505 44 -494 b 360 -359 136 -408 235 -369 m 419 -424 b 393 -423 411 -423 406 -423 l 375 -423 l 377 -426 b 379 -439 377 -427 378 -434 b 383 -510 382 -463 383 -487 b 314 -811 383 -609 360 -710 b 266 -893 296 -850 285 -870 b 264 -898 265 -896 264 -898 l 264 -898 b 264 -898 264 -898 264 -898 b 268 -898 264 -898 266 -898 b 273 -898 270 -898 272 -898 b 300 -909 283 -898 291 -900 b 426 -957 340 -941 385 -957 b 476 -949 443 -957 460 -954 b 547 -853 522 -931 547 -893 b 485 -745 547 -816 526 -775 b 397 -707 460 -727 432 -714 b 366 -675 375 -703 366 -692 b 396 -642 366 -657 377 -645 b 530 -557 455 -637 511 -601 b 536 -527 534 -548 536 -537 b 419 -424 536 -480 490 -437 "},"v30":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 276 1900 b 284 1901 279 1900 281 1901 b 306 1883 291 1901 298 1896 b 367 1686 347 1825 367 1757 b 343 1558 367 1643 359 1600 l 338 1549 l 343 1537 b 367 1411 359 1497 367 1454 b 343 1282 367 1367 359 1324 l 338 1272 l 343 1261 b 367 1135 359 1221 367 1178 b 343 1007 367 1090 359 1047 l 338 996 l 343 985 b 367 859 359 945 367 902 b 343 731 367 814 359 771 l 338 720 l 343 709 b 367 582 359 667 367 626 b 289 362 367 503 340 426 b 239 312 276 345 259 330 b 29 77 152 237 76 152 b -1 18 14 54 2 30 b -19 4 -4 11 -12 4 l -21 4 l -21 133 l -20 260 l -13 262 b 98 299 17 269 62 284 b 111 305 103 302 110 305 b 167 334 123 310 156 327 b 319 595 264 391 319 491 b 313 659 319 616 318 638 b 310 667 311 664 311 667 b 307 663 310 667 308 666 b 240 588 289 637 269 614 b 16 331 141 505 62 413 b -1 294 8 316 1 302 b -19 280 -4 287 -12 280 l -21 280 l -21 408 l -20 537 l -13 538 b 98 576 17 545 62 560 b 111 581 103 578 110 581 b 167 610 123 587 156 603 b 319 871 264 667 319 767 b 313 935 319 892 318 913 b 310 942 311 941 311 942 b 307 939 310 942 308 941 b 240 864 289 913 269 889 b 16 607 141 781 62 689 b -1 570 8 592 1 578 b -19 556 -4 563 -12 556 l -21 556 l -21 684 l -20 813 l -13 814 b 98 852 17 821 62 836 b 111 857 103 855 110 857 b 167 886 123 863 156 880 b 319 1147 264 943 319 1043 b 313 1211 319 1168 318 1189 b 310 1218 311 1217 311 1218 b 307 1215 310 1218 308 1217 b 240 1140 289 1188 269 1165 b 16 884 141 1057 62 966 b -1 846 8 868 1 855 b -19 832 -4 839 -12 832 l -21 832 l -21 960 l -20 1089 l -13 1090 b 98 1128 17 1097 62 1111 b 111 1134 103 1131 110 1134 b 167 1163 123 1139 156 1156 b 319 1424 264 1220 319 1320 b 313 1486 319 1444 318 1465 b 310 1494 311 1493 311 1494 b 307 1492 310 1494 308 1493 b 240 1417 289 1464 269 1442 b 16 1160 141 1333 62 1242 b -1 1121 8 1145 1 1131 b -19 1109 -4 1115 -12 1109 l -21 1109 l -21 1236 l -20 1365 l -13 1367 b 98 1404 17 1374 62 1388 b 111 1410 103 1407 110 1410 b 250 1508 172 1437 215 1467 b 319 1701 296 1564 319 1633 b 270 1859 319 1757 303 1814 b 262 1882 265 1868 262 1875 b 276 1900 262 1890 266 1896 "},"v31":{"x_min":0,"x_max":386.5625,"ha":394,"o":"m 0 173 l 0 347 l 193 347 l 386 347 l 386 173 l 386 0 l 193 0 l 0 0 l 0 173 "},"v33":{"x_min":-423.3125,"x_max":421.9375,"ha":431,"o":"m -10 276 b -2 277 -8 277 -5 277 b 17 265 5 277 13 273 b 19 163 19 260 19 260 l 19 68 l 39 45 b 277 -95 122 -34 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -54 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 200 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 137 b 421 22 421 37 421 29 b 257 -198 421 -86 347 -188 b 242 -198 251 -198 247 -198 b 20 -105 181 -198 95 -163 l 19 -104 l 19 -183 b 19 -216 19 -195 19 -206 b 12 -273 19 -272 17 -267 b -2 -278 8 -277 2 -278 b -21 -266 -10 -278 -19 -274 b -23 -165 -23 -263 -23 -262 l -23 -69 l -44 -47 b -250 86 -117 23 -183 66 b -295 94 -270 93 -284 94 b -315 91 -302 94 -308 94 b -381 5 -356 81 -381 43 b -355 -56 -381 -16 -372 -40 b -299 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -168 -77 -196 -58 -179 -65 b -151 -122 -156 -90 -151 -105 b -179 -174 -151 -141 -160 -162 b -239 -195 -194 -184 -217 -192 b -257 -197 -245 -195 -250 -197 b -423 -5 -349 -197 -423 -113 b -423 0 -423 -4 -423 -1 b -277 194 -420 97 -362 173 b -247 197 -268 197 -258 197 b -24 104 -185 197 -100 162 l -23 102 l -23 181 b -21 265 -23 260 -23 260 b -10 276 -20 269 -14 274 "},"v34":{"x_min":0,"x_max":622.03125,"ha":635,"o":"m 398 417 b 406 419 401 419 404 419 b 427 398 417 419 427 409 b 427 391 427 395 427 392 b 34 -274 424 385 38 -272 b 20 -280 29 -278 25 -280 b 0 -259 9 -280 0 -270 b 0 -252 0 -256 0 -254 b 393 413 2 -247 389 410 b 398 417 394 415 397 416 m 592 417 b 600 419 594 419 597 419 b 622 398 611 419 622 409 b 620 391 622 395 620 392 b 227 -274 617 385 231 -272 b 213 -280 223 -278 219 -280 b 193 -259 202 -280 193 -270 b 194 -252 193 -256 193 -254 b 586 413 196 -247 582 410 b 592 417 588 415 590 416 "},"v36":{"x_min":-1.359375,"x_max":1064.390625,"ha":1086,"o":"m 296 692 b 314 694 302 694 307 694 b 386 685 337 694 366 689 b 548 498 480 660 548 580 b 548 481 548 492 548 487 b 455 395 541 426 499 395 b 370 462 420 395 383 417 b 362 496 364 477 362 488 b 377 514 362 509 367 514 b 393 501 386 514 390 510 b 432 474 397 484 413 474 b 470 487 445 474 458 478 b 491 530 484 496 491 510 b 490 544 491 534 491 539 b 333 660 479 606 411 657 l 323 662 l 315 646 b 269 524 285 591 269 556 b 321 431 269 492 287 466 b 349 395 338 413 343 408 b 363 342 359 378 363 362 b 359 312 363 333 362 322 b 285 158 348 266 318 206 b 281 152 283 155 281 152 b 281 152 281 152 281 152 b 287 154 283 152 284 152 b 318 155 298 154 308 155 b 461 98 371 155 419 136 l 464 97 l 483 112 b 503 129 494 120 503 127 b 504 130 503 129 504 129 b 503 138 504 131 503 134 b 500 180 500 152 500 166 b 553 326 500 238 518 288 b 604 366 560 331 592 358 b 649 381 617 376 632 381 b 696 362 665 381 681 374 b 724 302 714 347 724 324 b 695 238 724 278 714 255 b 660 210 691 234 662 212 b 579 148 658 209 582 151 b 579 148 579 148 579 148 b 596 106 579 144 589 119 b 622 77 604 88 609 83 b 657 69 632 72 645 69 b 748 112 688 69 721 84 b 755 123 754 117 755 120 b 755 127 755 124 755 126 b 751 165 752 137 751 151 b 758 219 751 183 754 202 b 894 387 774 290 820 347 b 896 390 896 388 896 388 b 891 398 896 391 895 392 b 622 560 827 477 730 535 b 600 580 605 564 600 569 b 617 596 600 591 607 596 b 628 595 622 596 624 596 b 1057 248 846 552 1020 412 b 1064 191 1061 229 1064 209 b 922 0 1064 94 1005 9 b 902 -1 916 -1 909 -1 b 774 76 847 -1 800 26 b 769 83 770 81 770 83 b 769 81 769 83 769 83 b 627 -1 733 29 677 -1 b 548 27 597 -1 570 8 b 515 88 537 37 525 61 l 513 95 l 510 93 l 453 45 b 390 0 396 0 396 0 b 390 0 390 0 390 0 b 374 15 381 0 377 4 b 268 105 359 69 314 105 b 250 104 262 105 257 105 l 243 102 l 234 90 b 155 1 201 49 159 2 b 147 -1 152 0 149 -1 b 130 15 138 -1 130 6 b 132 20 130 18 132 19 b 136 31 133 22 134 27 b 220 131 149 74 178 109 b 231 137 225 134 230 136 b 302 278 280 202 302 244 b 265 335 302 299 295 309 b 209 442 234 363 213 402 b 209 455 209 446 209 451 b 279 648 209 502 232 564 l 285 659 l 283 659 b 176 627 238 653 210 645 b 57 477 111 594 66 538 b 55 459 55 471 55 464 b 72 409 55 437 61 415 b 93 403 78 405 87 403 b 152 467 123 403 151 431 b 168 488 153 483 157 488 b 185 462 181 488 185 483 l 185 460 b 137 344 183 409 168 369 b 78 322 119 328 98 322 b 13 360 50 322 25 335 b -1 426 4 380 -1 402 b 89 610 -1 488 32 559 b 296 692 147 659 210 685 m 926 348 b 921 353 924 351 922 353 b 914 348 920 353 918 351 b 823 167 857 306 823 237 b 828 124 823 154 826 138 b 890 31 837 79 862 40 b 896 31 892 31 894 31 b 956 104 916 31 940 59 b 970 191 965 129 970 159 b 966 241 970 208 969 224 b 926 348 959 277 945 313 m 627 326 b 619 326 624 326 622 326 b 598 316 611 326 604 323 b 568 215 579 288 568 255 b 568 208 568 213 568 210 b 571 183 570 195 570 184 l 571 183 b 594 201 571 183 582 191 l 634 231 b 660 259 653 247 656 248 b 664 278 662 266 664 272 b 627 326 664 299 649 320 "},"v38":{"x_min":-1.359375,"x_max":651.96875,"ha":665,"o":"m 389 644 b 405 645 394 645 400 645 b 504 566 450 645 492 613 b 507 541 506 557 507 549 b 480 471 507 514 498 489 l 477 467 l 483 470 b 609 591 539 485 586 531 b 613 601 611 595 613 599 b 631 609 619 607 624 609 b 651 588 641 609 651 602 b 200 -946 651 584 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 537 313 478 300 508 b 389 644 300 585 334 635 "},"v39":{"x_min":-171.5,"x_max":251.8125,"ha":257,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 553 20 616 20 614 b 20 491 20 503 20 491 l 20 491 b 153 535 47 501 149 535 b 174 514 167 535 174 524 b 164 496 174 508 171 501 b 92 470 164 495 132 484 l 20 445 l 20 390 b 20 363 20 378 20 370 b 20 333 20 340 20 333 l 20 333 b 153 377 47 344 149 377 b 174 356 167 377 174 367 b 164 338 174 349 171 342 b 92 312 164 338 132 326 l 20 288 l 20 219 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 30 -21 -212 -21 -212 b -21 273 -21 163 -21 273 b -84 252 -21 273 -50 263 b -152 230 -133 234 -145 230 b -157 231 -155 230 -156 231 b -171 252 -166 234 -171 244 b -160 270 -171 259 -167 266 b -27 316 -159 270 -93 294 l -21 319 l -21 374 b -21 431 -21 406 -21 431 b -84 409 -21 431 -50 421 b -152 388 -133 392 -145 388 b -157 390 -155 388 -156 388 b -171 409 -166 392 -171 401 b -160 428 -171 417 -167 424 b -27 474 -159 428 -93 451 l -21 476 l -21 546 b -20 620 -21 614 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},"v3b":{"x_min":0,"x_max":484.5625,"ha":494,"o":"m 228 245 b 239 247 234 247 239 247 b 243 247 240 247 242 247 b 303 238 257 247 287 242 b 484 -2 417 208 484 104 b 412 -177 484 -65 461 -127 b 243 -248 363 -226 303 -248 b 6 -63 138 -248 36 -180 b 0 -1 1 -41 0 -20 b 228 245 0 127 98 240 m 255 181 b 240 183 247 183 245 183 b 232 181 238 183 235 183 b 142 152 200 180 168 170 l 138 149 l 190 97 l 242 44 l 294 97 l 345 149 l 340 152 b 255 181 315 169 284 180 m 147 -54 l 197 -1 l 147 51 l 95 104 l 91 99 b 62 -1 72 70 62 34 b 66 -43 62 -15 63 -29 b 91 -101 72 -63 80 -84 l 95 -106 l 147 -54 m 393 99 b 389 104 390 102 389 104 b 337 51 389 104 366 80 l 285 -1 l 337 -54 l 389 -106 l 393 -101 b 421 -1 412 -72 421 -36 b 393 99 421 34 412 69 m 294 -98 b 242 -45 265 -69 242 -45 b 190 -98 242 -45 219 -69 l 138 -151 l 142 -154 b 242 -184 172 -174 206 -184 b 340 -154 276 -184 311 -174 l 345 -151 l 294 -98 "},"v3c":{"x_min":0,"x_max":450.53125,"ha":460,"o":"m 189 302 b 204 303 193 302 198 303 b 303 224 250 303 292 270 b 306 199 304 216 306 208 b 279 129 306 173 296 147 l 276 126 l 281 127 b 408 249 337 142 385 190 b 412 259 409 254 412 258 b 430 267 417 265 423 267 b 450 247 441 267 450 259 b 200 -605 450 242 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 194 111 136 99 165 b 189 302 99 244 133 292 "},"v3e":{"x_min":0,"x_max":406.96875,"ha":415,"o":"m 21 183 b 28 183 24 183 25 183 b 42 181 34 183 39 183 b 127 108 47 179 47 179 b 202 41 168 72 202 41 b 279 108 204 41 238 72 b 357 177 321 145 356 176 b 375 183 363 181 370 183 b 406 151 392 183 406 169 b 404 137 406 147 405 141 b 322 62 401 131 398 129 b 251 0 284 27 251 0 b 322 -63 251 -1 284 -29 b 404 -138 398 -130 401 -133 b 406 -152 405 -142 406 -148 b 375 -184 406 -170 392 -184 b 357 -179 370 -184 363 -183 b 279 -109 356 -177 321 -147 b 202 -43 238 -73 204 -43 b 127 -109 202 -43 168 -73 b 49 -179 85 -147 50 -177 b 31 -184 43 -183 36 -184 b 0 -152 13 -184 0 -170 b 2 -138 0 -148 0 -142 b 83 -63 5 -133 8 -130 b 155 0 122 -29 155 -1 b 83 62 155 0 122 27 b 8 129 43 97 10 127 b 0 151 2 136 0 144 b 21 183 0 165 8 177 "},"v3f":{"x_min":-24.5,"x_max":317.140625,"ha":324,"o":"m -24 -147 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 58 -123 6 -43 31 -86 b 196 -278 93 -173 134 -219 b 317 -570 274 -356 317 -460 b 294 -713 317 -617 308 -666 l 289 -724 l 294 -735 b 317 -873 308 -780 317 -827 b 235 -1132 317 -963 288 -1054 b 209 -1165 228 -1140 224 -1146 b 189 -1177 204 -1172 196 -1177 b 171 -1164 182 -1177 175 -1172 b 168 -1154 170 -1161 168 -1159 b 181 -1132 168 -1149 172 -1142 b 269 -891 238 -1064 269 -975 b 269 -881 269 -886 269 -884 b 262 -814 269 -857 265 -827 b 258 -800 261 -811 259 -806 b 142 -628 240 -731 198 -667 b -8 -589 112 -606 47 -589 b -20 -589 -13 -589 -19 -589 l -24 -589 l -24 -449 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 58 -424 6 -345 31 -388 b 194 -580 93 -476 136 -523 b 259 -660 221 -606 245 -635 b 261 -663 259 -662 261 -663 b 264 -656 262 -663 262 -660 b 269 -587 268 -632 269 -610 b 264 -521 269 -566 268 -544 b 262 -512 264 -517 262 -513 b 258 -498 261 -509 259 -503 b 142 -326 240 -428 198 -365 b -8 -287 112 -303 47 -288 b -20 -287 -13 -287 -19 -287 l -24 -287 l -24 -147 "},"v40":{"x_min":-1.359375,"x_max":436.921875,"ha":446,"o":"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},"v41":{"x_min":-1.359375,"x_max":556.6875,"ha":568,"o":"m 294 322 b 318 323 299 322 308 323 b 360 320 334 323 352 322 b 526 217 430 310 490 273 b 543 166 537 202 543 184 b 447 70 543 117 503 70 b 445 70 447 70 446 70 b 359 159 394 72 359 113 b 368 201 359 173 362 187 b 442 245 382 229 412 245 b 455 244 446 245 451 245 b 460 244 458 244 460 244 b 460 244 460 244 460 244 b 454 248 460 244 458 245 b 325 291 417 276 372 291 b 285 287 313 291 299 290 b 144 -2 183 269 144 190 b 281 -290 144 -208 179 -280 b 304 -291 289 -291 298 -291 b 524 -105 412 -291 506 -212 b 541 -84 526 -88 530 -84 b 556 -101 551 -84 556 -90 b 549 -138 556 -111 553 -122 b 334 -322 521 -237 435 -310 b 302 -324 323 -323 313 -324 b 13 -101 172 -324 54 -234 b -1 -1 4 -68 -1 -34 b 294 322 -1 161 121 303 "},"v42":{"x_min":-348.4375,"x_max":24.5,"ha":25,"o":"m -330 155 b -322 156 -329 156 -326 156 b -315 156 -319 156 -317 156 b -298 147 -311 155 -308 154 b -19 30 -224 98 -122 55 l 2 26 b 24 -1 17 22 24 13 b 2 -27 24 -15 17 -23 l -19 -31 b -298 -148 -122 -56 -224 -99 b -322 -158 -313 -158 -315 -158 b -348 -131 -338 -158 -348 -145 b -344 -117 -348 -127 -347 -122 b -328 -104 -341 -112 -338 -111 b -127 -8 -269 -65 -202 -33 b -106 0 -115 -4 -106 -1 b -127 6 -106 0 -115 2 b -328 102 -202 31 -269 63 b -344 116 -338 109 -341 111 b -348 130 -347 120 -348 124 b -330 155 -348 141 -341 152 "},"v43":{"x_min":-442.359375,"x_max":441,"ha":450,"o":"m -31 487 b -1 488 -21 488 -10 488 b 434 104 216 488 397 330 b 441 27 438 79 441 47 b 439 12 441 20 439 15 b 419 0 435 4 427 0 b 404 5 413 0 408 1 b 398 30 400 11 398 13 b 0 351 390 213 213 351 b -59 348 -20 351 -39 349 b -400 30 -251 324 -393 191 b -405 5 -400 13 -401 11 b -420 0 -409 1 -415 0 b -441 12 -428 0 -436 4 b -442 27 -441 15 -442 20 b -435 104 -442 47 -439 79 b -31 487 -401 316 -235 474 m -13 131 b -1 133 -9 133 -5 133 b 51 105 19 133 39 123 b 61 70 58 95 61 83 b 51 34 61 58 58 45 b -1 6 39 16 19 6 b -46 27 -17 6 -34 13 b -62 69 -57 38 -62 54 b -13 131 -62 98 -44 124 "},"v44":{"x_min":-21.78125,"x_max":251.8125,"ha":257,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},"v45":{"x_min":-402.890625,"x_max":401.53125,"ha":410,"o":"m -10 273 b -4 274 -9 273 -6 274 b 16 262 4 274 12 269 b 17 158 17 259 17 259 l 17 56 l 62 112 b 117 174 110 172 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b 21 -6 27 0 24 -2 l 17 -12 l 17 -147 b 17 -210 17 -173 17 -194 b 10 -292 17 -297 16 -287 b -2 -299 6 -297 2 -299 b -21 -287 -10 -299 -19 -295 b -24 -174 -23 -284 -23 -284 l -24 -63 l -66 -117 b -121 -176 -110 -170 -114 -176 b -125 -176 -122 -176 -123 -176 b -296 -12 -134 -174 -125 -184 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 170 -398 -43 -231 165 b -212 174 -221 173 -216 174 b -202 173 -208 174 -205 174 b -39 11 -200 172 -151 122 l -28 -1 l -25 1 l -24 4 l -24 130 b -23 260 -24 256 -24 258 b -10 273 -20 266 -16 270 "},"v46":{"x_min":0,"x_max":627.46875,"ha":640,"o":"m 306 190 b 314 191 308 191 311 191 b 326 184 318 191 322 190 l 336 173 b 510 52 377 127 442 80 b 515 49 513 51 515 49 b 611 16 537 40 579 24 b 627 0 624 13 627 9 b 607 -18 627 -11 624 -13 b 330 -181 490 -49 389 -109 b 314 -192 323 -190 319 -192 b 306 -191 311 -192 308 -192 b 294 -177 302 -188 302 -188 b 257 -140 287 -170 265 -148 b 19 -18 193 -84 114 -44 b 0 0 2 -13 0 -11 b 16 16 0 9 2 13 b 110 49 47 24 89 40 b 117 52 111 49 114 51 b 145 65 126 56 130 58 b 281 163 200 93 245 124 b 300 186 288 170 291 174 b 306 190 300 187 303 188 m 317 137 b 313 142 315 141 314 142 b 308 137 313 142 311 141 b 161 4 276 84 220 33 b 155 0 159 1 155 0 b 163 -4 155 0 159 -2 b 308 -138 220 -34 276 -84 b 313 -142 311 -141 313 -142 b 317 -138 314 -142 315 -141 b 464 -4 351 -84 406 -34 b 470 0 468 -2 470 0 b 464 4 470 0 468 1 b 317 137 406 33 351 84 "},"v47":{"x_min":-24.5,"x_max":315.78125,"ha":322,"o":"m -24 -145 l -24 -5 l -20 -5 b 1 -26 -10 -5 -6 -9 b 175 -241 31 -86 96 -166 b 314 -548 259 -323 304 -420 b 315 -589 315 -555 315 -571 b 314 -630 315 -606 315 -623 b 298 -730 311 -664 306 -699 l 295 -742 l 296 -748 b 314 -850 304 -778 311 -813 b 315 -892 315 -857 315 -874 b 314 -932 315 -909 315 -925 b 298 -1032 311 -967 306 -1002 l 295 -1045 l 296 -1050 b 314 -1153 304 -1081 311 -1115 b 315 -1193 315 -1160 315 -1177 b 314 -1235 315 -1211 315 -1228 b 217 -1526 306 -1338 270 -1444 b 201 -1533 213 -1532 208 -1533 b 182 -1522 193 -1533 185 -1529 b 179 -1514 181 -1518 179 -1517 b 189 -1489 179 -1508 182 -1501 b 266 -1217 240 -1403 266 -1308 b 262 -1156 266 -1196 265 -1177 b 110 -907 247 -1043 190 -950 b 0 -889 87 -895 50 -889 l -1 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 1 -631 -10 -610 -6 -614 b 175 -846 31 -691 96 -771 b 259 -956 213 -884 236 -914 b 265 -966 262 -961 264 -966 b 265 -966 265 -966 265 -966 b 265 -953 265 -964 265 -959 b 266 -920 266 -943 266 -932 b 262 -853 266 -898 265 -873 b 110 -605 247 -741 190 -648 b 0 -587 87 -592 50 -587 l -1 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 1 -328 -10 -308 -6 -312 b 175 -544 31 -388 96 -469 b 259 -655 213 -581 236 -612 b 265 -663 262 -659 264 -663 b 265 -663 265 -663 265 -663 b 265 -650 265 -663 265 -657 b 266 -617 266 -641 266 -630 b 262 -551 266 -595 265 -570 b 110 -303 247 -438 190 -345 b 0 -284 87 -290 50 -284 l -1 -284 l -24 -284 l -24 -145 "},"v49":{"x_min":0,"x_max":630.203125,"ha":643,"o":"m 308 204 b 314 205 310 205 313 205 b 326 201 319 205 323 204 b 355 154 328 199 338 180 b 401 83 362 142 392 95 l 409 72 b 431 41 412 66 424 49 b 619 -174 498 -51 570 -134 b 630 -192 626 -180 630 -186 b 626 -202 630 -195 628 -199 b 616 -206 623 -205 620 -206 b 552 -188 608 -206 592 -202 b 310 -155 488 -169 392 -155 b 268 -156 295 -155 281 -155 b 77 -188 197 -161 126 -173 b 13 -206 35 -202 20 -206 b 9 -206 12 -206 10 -206 b 0 -191 2 -202 0 -197 b 8 -176 0 -186 2 -180 b 204 49 58 -136 138 -43 l 220 72 l 227 83 b 295 188 245 108 281 166 b 308 204 299 197 304 202 m 315 147 b 314 147 315 147 314 147 b 314 147 314 147 314 147 b 306 129 314 145 310 138 l 296 105 b 281 72 292 97 284 77 l 274 56 b 181 -123 247 -4 212 -72 l 174 -134 l 176 -133 b 314 -123 215 -127 272 -123 b 451 -133 356 -123 413 -127 l 454 -134 l 449 -123 b 353 56 417 -72 381 -4 l 347 72 b 332 105 344 77 336 97 l 322 129 b 315 147 318 138 315 145 "},"v4a":{"x_min":70.78125,"x_max":378.390625,"ha":315,"o":"m 246 373 b 254 373 249 373 251 373 b 372 324 303 373 360 351 b 378 302 377 317 378 309 b 338 251 378 278 362 255 b 328 249 334 249 332 249 b 283 294 303 249 283 270 b 288 315 283 301 284 308 b 289 319 289 317 289 319 b 289 319 289 319 289 319 b 283 320 289 320 287 320 b 270 322 279 322 274 322 b 206 288 242 322 215 308 b 206 283 206 287 206 285 b 257 223 206 267 230 238 b 284 206 272 213 277 210 b 351 90 328 173 351 130 b 340 47 351 74 348 59 b 205 -30 314 -2 264 -30 b 182 -29 198 -30 190 -30 b 84 15 147 -24 103 -5 b 70 48 74 24 70 36 b 108 99 70 70 85 94 b 121 102 112 101 117 102 b 167 56 147 102 167 80 b 159 31 167 48 164 40 l 156 26 l 157 26 b 190 20 167 22 178 20 b 220 26 201 20 212 22 b 258 65 243 34 258 51 b 257 70 258 66 258 69 b 204 126 249 94 234 109 b 114 258 148 158 114 209 b 125 302 114 273 118 288 b 246 373 147 342 193 370 "},"v4b":{"x_min":0,"x_max":503.609375,"ha":514,"o":"m 274 430 b 277 430 276 430 277 430 b 310 394 296 430 310 415 b 308 383 310 391 308 387 b 306 367 307 381 307 374 b 236 120 298 305 272 210 b 40 -273 189 -5 125 -134 b 20 -287 35 -283 27 -287 b 5 -281 14 -287 9 -285 b 0 -267 1 -277 0 -273 b 9 -242 0 -262 2 -255 b 246 395 137 -12 232 242 b 274 430 249 416 257 427 m 468 430 b 472 430 469 430 470 430 b 503 394 490 430 503 415 b 502 383 503 391 503 387 b 499 367 502 381 500 374 b 431 120 491 305 465 210 b 234 -273 382 -5 318 -134 b 213 -287 228 -283 220 -287 b 198 -281 208 -287 202 -285 b 193 -267 194 -277 193 -273 b 202 -242 193 -262 196 -255 b 439 395 330 -12 426 242 b 468 430 442 416 451 427 "},"v4d":{"x_min":-311.6875,"x_max":310.328125,"ha":317,"o":"m -9 388 b -2 390 -8 390 -5 390 b 5 388 1 390 4 390 b 19 378 10 387 16 383 b 23 333 23 371 23 371 b 24 298 23 299 24 298 b 81 276 34 298 65 285 b 213 91 145 240 190 177 b 224 24 217 76 224 36 b 257 24 224 24 235 24 b 299 19 292 24 292 24 b 310 -1 306 15 310 6 b 299 -23 310 -11 306 -19 b 257 -27 292 -27 292 -27 b 224 -29 235 -27 224 -29 b 213 -95 224 -40 217 -80 b 81 -280 190 -181 145 -244 b 24 -301 65 -290 34 -301 b 23 -335 24 -301 23 -303 l 23 -340 b 17 -381 23 -374 23 -374 b -1 -391 13 -388 5 -391 b -21 -381 -9 -391 -17 -388 b -27 -340 -27 -374 -27 -374 l -27 -335 b -28 -301 -27 -303 -27 -301 b -85 -280 -38 -301 -69 -290 b -217 -95 -149 -244 -194 -181 b -228 -29 -221 -80 -228 -40 b -259 -27 -228 -29 -238 -27 b -300 -23 -294 -27 -294 -27 b -311 -2 -307 -19 -311 -11 b -294 23 -311 8 -304 19 b -259 24 -291 23 -284 24 b -228 24 -239 24 -228 24 b -217 91 -228 36 -221 76 b -85 276 -194 177 -149 240 b -28 298 -69 285 -38 298 b -27 333 -27 298 -27 299 b -27 371 -27 362 -27 369 b -9 388 -24 378 -17 385 m -27 136 b -28 247 -27 197 -28 247 b -61 216 -31 247 -53 226 b -123 33 -95 172 -121 98 l -125 24 l -76 24 l -27 24 l -27 136 m 29 242 b 24 247 27 245 24 247 b 23 136 24 247 23 197 l 23 24 l 72 24 l 121 24 l 119 33 b 29 242 115 116 77 206 m -27 -140 l -27 -27 l -76 -27 l -125 -27 l -123 -36 b -61 -220 -121 -102 -95 -176 b -28 -251 -53 -230 -31 -251 b -27 -140 -28 -251 -27 -201 m 119 -36 l 121 -27 l 72 -27 l 23 -27 l 23 -140 b 24 -251 23 -201 24 -251 b 57 -220 27 -251 49 -230 b 119 -36 91 -176 117 -102 "},"v4e":{"x_min":0,"x_max":239.5625,"ha":244,"o":"m 10 460 b 20 462 13 462 14 462 b 39 449 28 462 35 458 l 40 446 l 40 326 b 40 205 40 259 40 205 b 127 227 40 205 80 215 b 220 249 196 244 213 249 b 227 247 224 249 225 248 b 238 237 231 245 235 241 l 239 233 l 239 -106 l 239 -448 l 238 -451 b 219 -463 234 -459 225 -463 b 198 -451 210 -463 202 -459 l 197 -448 l 197 -324 b 197 -201 197 -248 197 -201 b 110 -223 196 -201 157 -210 b 17 -245 42 -240 24 -245 b 10 -242 13 -245 13 -244 b 0 -233 6 -241 2 -237 l 0 -230 l 0 108 l 0 446 l 0 449 b 10 460 2 453 6 458 m 197 22 b 197 70 197 41 197 58 b 196 116 197 113 197 116 l 196 116 b 118 97 196 116 160 106 l 40 77 l 40 -18 b 40 -112 40 -69 40 -112 l 119 -93 l 197 -73 l 197 22 "},"v51":{"x_min":-1.359375,"x_max":455.96875,"ha":465,"o":"m 352 541 b 357 542 353 542 355 542 b 377 530 364 542 372 537 l 378 526 l 378 394 l 379 262 l 404 266 b 436 270 420 269 430 270 b 450 265 443 270 446 269 b 455 220 455 259 455 260 l 455 208 l 455 161 l 454 156 b 411 140 449 147 447 147 b 378 133 393 137 379 134 b 378 68 378 133 378 106 b 378 22 378 54 378 38 l 379 -87 l 404 -83 b 436 -79 420 -80 430 -79 b 450 -84 443 -79 446 -80 b 455 -129 455 -90 455 -88 l 455 -141 l 455 -188 l 454 -192 b 413 -209 449 -202 447 -202 b 382 -215 398 -212 383 -215 l 378 -215 l 378 -345 l 378 -380 b 375 -485 378 -484 378 -480 b 357 -494 371 -491 364 -494 b 340 -485 351 -494 344 -491 b 336 -383 337 -480 336 -484 l 336 -349 l 336 -223 l 334 -223 b 291 -231 334 -223 314 -227 l 247 -240 l 247 -371 l 246 -503 l 245 -506 b 225 -519 242 -514 234 -519 b 206 -506 219 -519 210 -514 l 205 -503 l 205 -376 l 205 -248 l 160 -256 l 115 -265 l 115 -396 l 115 -527 l 114 -531 b 95 -544 110 -539 102 -544 b 76 -531 87 -544 78 -539 l 73 -527 l 73 -399 b 73 -273 73 -330 73 -273 b 49 -277 73 -273 61 -274 b 17 -281 32 -280 24 -281 b 4 -276 10 -281 8 -280 b -1 -234 0 -269 -1 -272 b 0 -219 -1 -229 0 -224 l 0 -170 l 1 -167 b 10 -158 2 -163 6 -159 b 49 -149 13 -156 16 -155 l 73 -145 l 73 -34 b 73 76 73 26 73 76 b 49 72 73 76 61 74 b 17 68 32 69 24 68 b 4 73 10 68 8 69 b -1 115 0 80 -1 77 b 0 130 -1 120 0 124 l 0 179 l 1 181 b 10 191 2 186 6 190 b 49 199 13 192 16 194 l 73 204 l 73 338 b 73 374 73 352 73 365 b 77 483 73 484 73 477 b 95 492 81 489 88 492 b 111 483 100 492 107 489 b 115 378 115 477 115 483 l 115 342 b 117 212 115 223 115 212 b 204 229 117 212 200 227 l 205 229 l 205 365 l 205 502 l 206 505 b 225 517 210 513 219 517 b 245 505 234 517 242 513 l 246 502 l 247 369 l 247 237 l 249 237 b 336 254 253 238 336 254 b 337 390 336 254 337 302 l 337 526 l 338 530 b 352 541 341 535 347 539 m 336 15 b 336 126 336 102 336 126 l 336 126 b 291 117 336 126 315 122 l 247 109 l 247 -1 l 247 -112 l 249 -112 b 336 -95 253 -111 336 -95 b 336 15 336 -95 336 -56 m 205 -120 b 205 -55 205 -120 205 -93 b 205 -9 205 -41 205 -24 l 205 101 l 160 93 l 115 84 l 115 -26 b 115 -83 115 -49 115 -69 b 117 -137 115 -133 115 -137 b 205 -120 118 -137 204 -120 "},"v52":{"x_min":-10.890625,"x_max":298.078125,"ha":294,"o":"m 138 473 b 142 474 140 473 141 474 b 164 459 148 474 153 470 b 191 402 183 442 191 423 b 181 353 191 388 187 371 b 178 349 179 352 178 349 b 179 348 178 348 179 348 b 185 349 181 348 182 348 b 255 376 210 355 234 363 b 272 381 264 381 266 381 b 298 355 287 381 298 370 b 288 330 298 348 298 345 b 171 34 238 254 194 141 b 166 13 168 16 168 16 b 144 1 161 5 152 1 b 121 15 134 1 125 5 b 115 33 119 18 117 24 b 0 330 91 145 49 252 b -10 355 -9 345 -10 348 b 13 381 -10 371 0 381 b 31 376 19 381 25 380 b 132 345 61 358 103 345 l 136 345 l 137 355 b 145 378 138 359 142 370 b 152 415 149 394 152 405 b 137 452 152 427 148 438 b 133 464 134 458 133 460 b 138 473 133 467 134 470 "},"v53":{"x_min":0,"x_max":902.421875,"ha":921,"o":"m 17 240 b 24 241 19 241 21 241 b 32 240 28 241 31 241 b 46 229 38 238 43 234 b 50 88 50 223 50 237 b 50 -1 50 63 50 34 b 50 -90 50 -36 50 -65 b 46 -231 50 -238 50 -224 b 25 -242 42 -238 34 -242 b 0 -224 14 -242 4 -235 b 0 2 0 -222 0 -108 b 0 223 0 112 0 220 b 17 240 2 230 9 237 m 110 240 b 118 241 111 241 114 241 b 126 240 121 241 123 241 b 142 223 133 237 140 230 b 144 123 144 220 144 205 b 144 29 144 45 144 29 b 144 29 144 29 144 29 b 393 183 166 106 264 167 b 450 186 412 184 431 186 b 756 29 600 186 732 120 b 756 29 756 29 756 29 b 758 123 758 29 758 45 b 760 227 758 226 758 223 b 784 241 766 237 774 241 b 804 229 792 241 800 237 b 809 88 808 223 809 237 l 809 -1 l 809 -90 b 804 -231 809 -238 808 -224 b 784 -242 800 -238 792 -242 b 762 -231 775 -242 766 -238 b 758 -124 756 -224 758 -231 b 756 -30 758 -47 758 -30 b 756 -30 756 -30 756 -30 b 509 -184 736 -108 637 -169 b 450 -187 488 -187 469 -187 b 144 -30 300 -187 168 -122 b 144 -30 144 -30 144 -30 b 144 -124 144 -30 144 -47 b 140 -231 144 -231 144 -224 b 118 -242 134 -238 126 -242 b 92 -224 107 -242 96 -235 b 92 2 92 -222 92 -108 b 92 223 92 112 92 220 b 110 240 95 230 102 237 m 432 161 b 413 162 426 162 420 162 b 313 41 351 162 313 109 b 347 -73 313 5 323 -34 b 487 -163 385 -133 439 -163 b 578 -97 526 -163 562 -142 b 588 -43 585 -80 588 -62 b 432 161 588 47 518 147 m 868 240 b 876 241 869 241 872 241 b 884 240 879 241 882 241 b 898 229 890 238 894 234 b 902 88 902 223 902 237 l 902 -1 l 902 -90 b 898 -231 902 -238 902 -224 b 876 -242 892 -238 884 -242 b 852 -224 865 -242 854 -235 b 850 2 850 -222 850 -108 b 852 223 850 112 850 220 b 868 240 853 230 860 237 "},"v54":{"x_min":-24.5,"x_max":317.140625,"ha":324,"o":"m -24 -161 l -24 -5 l -20 -5 b 0 -24 -9 -5 -2 -12 b 171 -315 21 -124 84 -233 b 317 -660 268 -406 317 -531 b 187 -1014 317 -782 274 -909 b 161 -1034 172 -1034 171 -1034 b 141 -1013 149 -1034 141 -1025 b 152 -991 141 -1004 142 -1002 b 266 -682 228 -899 266 -788 b 174 -430 266 -588 236 -498 b -23 -317 136 -388 66 -348 b -24 -161 -23 -316 -24 -285 "},"v55":{"x_min":0,"x_max":551.25,"ha":563,"o":"m 289 644 b 304 645 294 645 299 645 b 404 566 349 645 392 613 b 406 541 405 557 406 549 b 379 471 406 514 397 489 l 377 467 l 382 470 b 509 591 438 485 485 531 b 513 601 510 595 513 599 b 530 609 518 607 524 609 b 551 588 540 609 551 602 b 200 -605 551 584 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 195 112 136 99 165 b 118 256 99 217 106 238 b 204 303 138 287 171 303 b 292 249 238 303 273 285 b 306 199 302 234 306 217 b 279 129 306 173 296 148 l 276 126 l 281 127 b 408 248 336 142 385 190 b 473 470 409 254 473 469 b 473 470 473 470 473 470 b 465 464 473 470 469 467 b 341 421 428 435 383 421 b 236 458 303 421 266 433 b 200 537 212 478 200 508 b 289 644 200 585 234 635 "},"v58":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 259 1553 b 265 1553 261 1553 264 1553 b 288 1540 272 1553 277 1550 b 367 1351 340 1493 367 1424 b 336 1221 367 1308 357 1263 l 332 1211 l 333 1208 b 367 1077 356 1170 367 1124 b 336 945 367 1032 357 986 l 332 935 l 333 932 b 367 800 356 893 367 848 b 336 669 367 756 357 710 l 332 659 l 333 656 b 367 523 356 617 367 571 b 345 412 367 485 360 446 b 231 273 322 356 284 310 b -1 19 121 195 27 93 b -17 4 -4 11 -10 5 l -21 4 l -21 134 l -21 265 l -17 265 b 133 291 20 265 96 278 b 318 537 245 328 318 433 b 307 603 318 559 315 582 b 303 614 304 612 304 614 b 298 609 302 614 300 613 b 231 549 281 589 258 567 b -1 295 121 471 27 369 b -17 280 -4 287 -10 281 l -21 280 l -21 410 l -21 541 l -17 541 b 133 567 20 541 96 555 b 318 813 245 605 318 709 b 307 880 318 835 315 859 b 303 891 304 888 304 891 b 298 885 302 891 300 888 b 231 825 281 866 258 843 b -1 571 121 748 27 645 b -17 556 -4 563 -10 557 l -21 556 l -21 687 l -21 817 l -17 817 b 133 843 20 817 96 830 b 318 1089 245 881 318 985 b 307 1156 318 1111 315 1134 b 303 1167 304 1164 304 1167 b 298 1161 302 1167 300 1164 b 231 1102 281 1140 258 1120 b -1 848 121 1024 27 921 b -17 832 -4 839 -10 834 l -21 832 l -21 963 l -21 1093 l -17 1093 b 114 1113 12 1093 78 1103 b 313 1314 215 1142 289 1218 b 318 1364 317 1331 318 1347 b 255 1511 318 1422 295 1478 b 243 1532 247 1519 243 1525 b 259 1553 243 1540 250 1550 "},"v59":{"x_min":0,"x_max":464.140625,"ha":474,"o":"m 0 0 l 0 347 l 76 347 l 153 347 l 153 0 l 153 -348 l 76 -348 l 0 -348 l 0 0 m 308 -1 l 308 347 l 386 347 l 464 347 l 464 -1 l 464 -348 l 386 -348 l 308 -348 l 308 -1 "},"v5a":{"x_min":-171.5,"x_max":170.140625,"ha":174,"o":"m -6 566 b 0 567 -5 567 -2 567 b 14 556 6 567 12 563 b 92 285 14 555 50 433 b 170 13 166 33 170 19 b 168 13 170 13 170 13 b 161 1 168 8 167 4 l 159 0 l 122 0 l 84 0 l 81 1 b 21 195 76 5 78 -5 b -32 381 -8 297 -32 381 b -87 197 -32 381 -57 298 b -141 8 -115 94 -140 9 b -155 0 -142 2 -149 0 b -171 15 -163 0 -171 5 b -14 556 -171 18 -24 528 b -6 566 -14 560 -10 564 "},"v5b":{"x_min":-441,"x_max":439.640625,"ha":449,"o":"m -428 -2 b -421 0 -427 -1 -424 0 b -406 -6 -416 0 -409 -2 b -400 -31 -401 -12 -400 -15 b -1 -352 -392 -215 -215 -352 b 58 -349 19 -352 38 -351 b 398 -31 250 -326 392 -192 b 404 -6 398 -15 400 -12 b 419 -1 408 -2 413 -1 b 439 -13 427 -1 435 -5 b 439 -29 439 -16 439 -22 b 434 -105 439 -48 438 -80 b 0 -489 397 -333 213 -489 b -68 -484 -23 -489 -44 -488 b -441 -36 -280 -452 -436 -263 b -441 -30 -441 -34 -441 -31 b -428 -2 -441 -11 -439 -5 m -13 -9 b -1 -8 -9 -8 -5 -8 b 50 -36 19 -8 39 -19 b 61 -72 57 -47 61 -59 b 50 -106 61 -84 57 -97 b -1 -134 39 -124 19 -134 b -46 -115 -17 -134 -34 -129 b -62 -72 -57 -102 -62 -87 b -13 -9 -62 -44 -44 -16 "},"v5c":{"x_min":0,"x_max":447.8125,"ha":457,"o":"m 0 -87 l 0 0 l 223 0 l 447 0 l 447 -87 l 447 -174 l 223 -174 l 0 -174 l 0 -87 "},"v5d":{"x_min":-1.359375,"x_max":592.078125,"ha":604,"o":"m 280 692 b 295 694 283 692 289 694 b 310 692 300 694 307 692 b 357 630 340 684 357 657 b 336 580 357 612 351 594 b 311 538 321 566 311 549 b 352 492 311 512 330 492 b 366 495 357 492 362 492 b 397 553 390 503 397 517 b 415 603 397 576 402 591 b 460 623 427 617 443 623 b 509 599 479 623 498 614 b 522 559 518 587 522 573 b 494 506 522 538 513 519 b 451 495 481 498 473 496 b 415 488 432 495 426 494 b 394 449 404 483 394 464 b 394 448 394 448 394 448 l 394 440 l 397 433 b 428 409 404 420 413 413 b 438 408 431 408 435 408 b 479 431 450 408 462 415 b 528 455 495 448 510 455 b 548 452 534 455 541 453 b 592 391 577 442 592 416 b 549 331 592 365 577 340 b 528 327 541 328 534 327 b 479 351 510 327 495 335 b 438 374 464 367 450 374 b 417 369 431 374 424 373 b 394 333 402 360 394 348 b 400 312 394 326 396 319 b 451 287 408 294 420 288 b 513 258 484 285 499 278 b 522 223 519 247 522 234 b 461 159 522 190 496 159 b 449 161 457 159 453 159 b 397 229 416 167 397 191 b 366 288 397 265 390 278 b 352 290 362 290 357 290 b 315 262 336 290 321 280 b 311 245 313 256 311 251 b 334 204 311 233 318 220 b 355 170 348 190 351 184 b 357 152 356 166 357 159 b 355 136 357 147 356 140 b 295 88 345 104 321 88 b 232 152 264 88 232 112 b 255 204 232 174 238 186 b 279 244 273 222 279 231 l 279 245 b 238 290 279 270 259 290 b 224 288 234 290 228 290 b 193 229 200 278 193 265 b 141 161 193 191 174 167 b 129 159 137 159 133 159 b 68 223 93 159 68 190 b 77 258 68 234 70 247 b 138 287 91 278 106 285 b 185 302 166 287 175 291 b 196 333 193 312 196 323 b 174 369 196 347 187 360 b 152 374 166 373 159 374 b 111 351 140 374 126 367 b 62 327 95 335 80 327 b 51 328 58 327 54 327 b -1 391 16 334 -1 363 b 53 455 -1 420 17 449 b 62 455 57 455 59 455 b 111 431 80 455 95 448 b 152 408 127 415 140 408 b 161 409 155 408 159 408 b 193 433 176 413 186 420 l 196 440 l 196 448 b 196 451 196 449 196 449 b 190 471 196 459 194 463 b 137 495 182 489 167 495 l 134 495 l 134 495 b 68 560 95 495 68 521 b 129 623 68 596 95 623 b 144 621 134 623 138 623 b 193 553 175 614 193 589 b 224 495 193 517 200 503 b 238 492 228 492 234 492 b 279 538 259 492 279 512 b 254 580 279 549 269 566 b 232 630 239 594 232 612 b 280 692 232 657 250 684 m 307 456 b 295 458 303 458 299 458 b 230 391 258 458 230 426 b 236 360 230 381 231 371 b 295 324 249 337 272 324 b 353 360 318 324 341 337 b 360 391 357 370 360 381 b 307 456 360 421 340 451 "},"v60":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m -367 173 b -362 174 -366 174 -364 174 b -351 173 -357 174 -353 173 b -262 86 -348 172 -328 151 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 72 86 -13 172 6 151 b 157 0 119 37 157 0 b 227 84 159 0 189 37 b 303 174 298 173 296 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 144 -86 213 0 182 -38 b 68 -174 73 -174 74 -173 b 62 -176 66 -176 65 -176 b 53 -174 59 -176 55 -174 b -35 -87 50 -173 29 -152 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -367 173 -375 169 -372 172 "},"v62":{"x_min":46.28125,"x_max":669.671875,"ha":563,"o":"m 183 376 b 189 376 185 376 187 376 b 212 374 197 376 208 376 b 265 337 234 369 253 355 b 274 317 268 331 273 320 b 274 316 274 317 274 316 b 280 323 276 316 276 319 b 311 358 288 337 299 348 b 319 366 315 360 318 365 b 356 376 326 373 340 376 b 382 371 364 376 374 374 b 428 337 400 366 417 352 b 436 317 431 331 436 320 b 438 316 436 317 436 316 b 442 323 438 316 439 319 b 475 358 451 337 462 348 b 483 366 477 360 481 365 b 518 376 488 373 503 376 b 544 373 528 376 536 376 b 604 285 579 360 604 326 b 597 249 604 273 601 258 b 543 63 596 247 544 70 b 541 54 543 61 541 55 b 540 44 540 51 540 47 b 552 23 540 33 545 23 b 552 23 552 23 552 23 b 647 126 586 29 627 72 b 658 138 651 136 653 138 b 660 138 660 138 660 138 b 669 129 666 137 669 136 b 654 88 669 122 665 109 b 562 -12 631 43 602 9 l 549 -19 b 521 -27 540 -24 530 -27 b 447 30 490 -27 458 -4 b 443 58 445 38 443 48 b 450 93 443 72 446 84 b 504 278 453 97 504 272 b 507 288 506 283 506 287 b 509 298 507 292 509 295 b 491 326 509 310 502 320 b 487 327 490 327 488 327 b 479 324 484 327 483 326 b 441 270 462 316 443 288 b 435 249 441 265 436 254 b 398 127 434 248 419 195 b 362 4 379 61 362 5 b 328 -1 359 -1 362 -1 b 314 -1 323 -1 319 -1 b 302 -1 310 -1 306 -1 b 266 4 266 -1 269 -1 b 265 6 265 5 265 5 b 303 144 265 13 272 34 b 343 278 325 216 343 276 b 344 288 343 281 344 285 b 345 298 345 291 345 295 b 330 326 345 310 340 320 b 323 327 328 327 325 327 b 317 324 322 327 321 326 b 279 270 300 316 281 288 b 273 249 279 265 274 254 b 236 127 272 248 255 195 b 200 4 216 61 200 5 b 164 -1 197 -1 198 -1 b 151 -1 161 -1 156 -1 b 140 -1 147 -1 142 -1 b 103 4 104 -1 106 -1 b 103 6 103 5 103 5 b 141 144 103 13 108 34 b 181 278 161 216 179 276 b 182 288 181 281 181 285 b 183 298 182 291 183 295 b 168 324 183 310 178 320 b 160 327 166 326 163 327 b 141 320 156 327 151 324 b 69 230 112 305 85 272 b 57 215 65 217 62 215 b 55 215 57 215 55 215 b 46 224 49 215 46 217 b 59 260 46 231 50 242 b 151 363 81 306 112 341 b 161 369 155 365 160 367 b 183 376 166 371 174 374 "},"v68":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 155 11 -5 172 43 123 l 166 -1 l 168 1 l 170 4 l 170 130 b 171 260 170 256 170 258 b 191 274 175 269 183 274 b 205 267 196 274 201 272 b 212 158 212 262 210 273 l 212 56 l 257 112 b 311 173 304 172 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 216 -6 221 -1 219 -2 l 212 -12 l 212 -147 b 212 -210 212 -173 212 -194 b 205 -292 212 -297 210 -287 b 191 -299 201 -297 196 -299 b 172 -287 183 -299 175 -295 b 170 -174 171 -284 171 -284 l 170 -63 l 127 -117 b 73 -176 84 -170 80 -176 b 68 -176 72 -176 70 -176 b -27 -87 59 -174 65 -180 b -114 0 -74 -38 -112 0 b -182 -86 -114 0 -145 -38 b -258 -174 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},"v6c":{"x_min":-1.359375,"x_max":193.28125,"ha":197,"o":"m 78 233 b 87 233 81 233 84 233 b 187 140 132 233 174 195 b 193 102 190 127 193 115 b 43 -113 193 22 136 -62 b 27 -119 36 -116 31 -119 b 19 -108 21 -119 19 -115 b 29 -97 19 -102 20 -101 b 102 13 73 -72 102 -27 b 92 51 102 26 98 40 l 91 54 l 84 54 b 8 104 53 54 21 74 b -1 142 1 116 -1 130 b 78 233 -1 187 31 227 "},"v6d":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m 544 335 b 553 337 548 337 551 337 b 575 313 563 337 570 330 b 589 226 583 285 589 256 b 517 8 589 152 563 76 b 464 -58 507 -4 503 -9 l 401 -136 b 362 -176 372 -172 370 -176 b 357 -176 360 -176 359 -176 b 261 -87 349 -174 355 -180 b 175 0 215 -38 175 0 b 106 -86 175 0 144 -38 b 29 -174 35 -174 36 -173 b 24 -176 28 -176 27 -176 b 14 -174 21 -176 17 -174 b -73 -87 12 -173 -8 -152 b -159 0 -121 -38 -159 0 b -228 -86 -160 0 -190 -38 b -304 -174 -299 -174 -298 -173 b -310 -176 -306 -176 -308 -176 b -319 -174 -314 -176 -318 -174 b -483 -12 -323 -173 -359 -137 l -495 0 l -524 -34 b -562 -77 -553 -73 -556 -76 b -568 -79 -564 -79 -566 -79 b -590 -58 -581 -79 -590 -69 b -588 -49 -590 -55 -589 -52 b -412 170 -585 -43 -417 165 b -398 174 -408 173 -402 174 b -389 173 -394 174 -392 174 b -300 86 -387 172 -366 151 b -215 -1 -254 37 -215 -1 b -145 84 -215 -1 -183 37 b -69 173 -74 173 -76 172 b -63 174 -68 174 -66 174 b -54 173 -61 174 -57 173 b 34 86 -51 172 -31 151 b 119 -1 81 37 119 -1 b 189 84 121 -1 151 37 b 265 173 259 173 258 172 b 270 174 266 174 269 174 b 280 173 274 174 279 173 b 370 84 283 172 303 151 b 455 -1 416 37 455 -1 l 455 -1 b 476 24 455 -1 469 15 b 547 226 522 87 547 159 b 534 302 547 252 543 278 b 532 317 533 308 532 313 b 544 335 532 326 536 333 "},"v6f":{"x_min":-80.3125,"x_max":78.9375,"ha":81,"o":"m 63 191 b 69 192 65 192 66 192 b 77 188 72 192 76 191 b 78 183 78 187 78 186 b 74 158 78 179 77 172 l 66 115 b 9 -161 49 30 10 -158 b -10 -187 6 -172 -1 -181 b -34 -194 -17 -191 -25 -194 b -80 -147 -58 -194 -80 -174 b -80 -141 -80 -144 -80 -142 b 9 70 -80 -134 -73 -117 l 49 163 b 63 191 59 188 61 190 "},"v70":{"x_min":0,"x_max":436.921875,"ha":446,"o":"m 213 190 b 217 191 215 191 216 191 b 231 184 223 191 228 188 b 249 154 240 167 246 159 b 419 18 292 91 348 45 b 436 -1 435 11 436 8 b 424 -16 436 -9 434 -13 b 308 -87 394 -26 340 -59 b 231 -186 276 -117 257 -142 b 219 -192 228 -191 225 -192 b 198 -174 209 -192 208 -191 b 47 -33 161 -113 110 -63 b 10 -16 34 -26 17 -19 b 0 -1 2 -13 0 -9 b 17 18 0 8 1 11 b 198 173 95 48 156 101 b 213 190 206 187 208 188 "},"v72":{"x_min":-423.3125,"x_max":421.9375,"ha":431,"o":"m -262 197 b -247 197 -257 197 -253 197 b -118 162 -210 197 -163 184 b 40 45 -61 134 -13 98 b 277 -95 119 -33 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -55 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 201 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 136 b 421 22 421 37 421 29 b 245 -199 421 -93 338 -199 b 238 -198 243 -199 240 -199 b -44 -47 148 -194 50 -141 b -250 86 -114 22 -183 66 b -295 94 -270 91 -283 94 b -315 91 -302 94 -307 94 b -381 4 -356 81 -381 43 b -355 -56 -381 -18 -372 -40 b -298 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -178 -69 -200 -58 -189 -62 b -151 -122 -160 -81 -151 -101 b -171 -167 -151 -138 -157 -155 b -239 -195 -185 -181 -213 -192 b -257 -197 -245 -197 -250 -197 b -423 -5 -352 -197 -423 -109 b -412 65 -423 16 -419 40 b -262 197 -389 137 -329 188 "},"v74":{"x_min":-206.890625,"x_max":428.75,"ha":438,"o":"m 389 -351 b 394 -351 390 -351 393 -351 b 428 -385 413 -351 428 -367 b 428 -394 428 -388 428 -391 b 394 -428 426 -406 421 -410 l 332 -473 l 269 -516 l 205 -560 l 141 -603 l 77 -648 l 13 -692 l -50 -737 l -114 -780 l -145 -802 b -171 -813 -157 -810 -163 -813 b -175 -813 -172 -813 -174 -813 b -206 -777 -194 -811 -206 -795 b -202 -760 -206 -771 -205 -766 b -87 -675 -197 -752 -206 -757 l -34 -639 l 83 -557 l 145 -514 l 209 -470 l 272 -427 b 389 -351 375 -356 381 -352 "},"v75":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -137 381 b -130 383 -134 383 -133 383 b -111 371 -122 383 -114 378 b -55 224 -110 370 -85 305 b 0 80 -25 145 -1 80 b 54 224 0 80 24 145 b 112 377 114 384 110 373 b 127 384 118 381 122 384 b 148 362 138 384 148 374 l 148 356 l 83 183 b 16 9 47 88 17 11 b -1 0 12 2 5 0 b -14 5 -5 0 -10 1 b -84 183 -19 9 -13 -6 l -149 356 l -149 362 b -137 381 -149 371 -145 378 "},"v78":{"x_min":0,"x_max":193.28125,"ha":197,"o":"m 85 514 b 95 517 88 517 89 517 b 114 505 103 517 110 513 l 115 502 l 115 376 b 115 249 115 306 115 249 b 141 258 117 249 127 252 l 167 266 l 172 266 b 190 254 181 265 187 262 l 193 251 l 193 202 l 193 188 b 187 147 193 149 191 152 b 147 130 183 142 182 141 l 115 119 l 115 9 b 115 -99 115 -51 115 -99 b 141 -91 115 -99 127 -95 b 171 -81 166 -81 167 -81 l 171 -81 b 191 -94 181 -81 189 -87 b 193 -142 191 -97 193 -120 b 191 -195 193 -167 191 -194 b 125 -227 187 -205 187 -204 l 115 -230 l 115 -366 l 115 -503 l 114 -506 b 95 -519 110 -514 102 -519 b 74 -506 87 -519 78 -514 l 73 -503 l 73 -374 b 73 -245 73 -260 73 -245 b 73 -245 73 -245 73 -245 b 55 -252 72 -245 63 -249 l 32 -260 b 19 -263 27 -262 23 -263 b 4 -256 13 -263 8 -260 b 0 -215 0 -251 0 -254 b 0 -199 0 -210 0 -206 l 0 -152 l 1 -149 b 8 -140 2 -145 5 -141 b 42 -127 9 -140 24 -133 l 73 -116 l 73 -5 b 73 23 73 4 73 15 b 73 105 73 70 73 105 b 49 97 73 105 61 101 b 17 88 32 91 23 88 b 4 95 10 88 8 91 b 0 137 0 101 0 98 b 0 151 0 141 0 145 l 0 199 l 1 202 b 43 224 5 212 5 212 l 73 234 l 73 367 l 73 502 l 74 505 b 85 514 77 509 81 513 "},"v79":{"x_min":-1.359375,"x_max":899.703125,"ha":918,"o":"m 307 349 b 332 351 315 351 323 351 b 443 340 367 351 408 347 b 741 47 607 306 720 195 b 744 0 743 31 744 16 b 660 -303 744 -90 713 -206 b 28 -755 534 -531 304 -695 b 14 -756 23 -755 19 -756 b -1 -741 4 -756 -1 -750 b 21 -720 -1 -731 1 -728 b 567 -56 337 -601 548 -344 b 568 -11 568 -41 568 -24 b 442 285 568 129 525 233 b 325 319 406 308 367 319 b 93 177 232 319 137 266 b 84 154 91 170 84 155 b 84 154 84 154 84 154 b 88 156 84 154 85 155 b 159 177 110 170 134 177 b 257 134 194 177 231 162 b 294 41 281 108 294 73 b 171 -97 294 -24 246 -90 b 156 -98 166 -97 161 -98 b 6 74 73 -98 6 -22 b 6 80 6 76 6 79 b 307 349 10 223 141 340 m 839 215 b 845 216 841 216 842 216 b 862 213 852 216 860 215 b 899 163 887 206 899 184 b 872 117 899 145 890 127 b 847 111 865 112 856 111 b 808 130 833 111 818 117 b 796 162 800 140 796 151 b 839 215 796 187 812 212 m 839 -112 b 845 -112 841 -112 842 -112 b 862 -115 852 -112 860 -113 b 899 -165 887 -122 899 -144 b 872 -210 899 -183 890 -201 b 847 -217 865 -215 856 -217 b 808 -198 833 -217 818 -210 b 796 -165 800 -188 796 -177 b 839 -112 796 -140 812 -116 "},"v7a":{"x_min":-1.359375,"x_max":386.5625,"ha":394,"o":"m 249 535 b 257 537 251 537 253 537 b 276 524 266 537 273 533 l 277 521 l 279 419 l 279 316 l 304 323 b 337 328 319 326 330 328 b 353 316 347 328 349 324 b 355 266 355 315 355 290 b 353 215 355 241 355 217 b 319 198 349 206 347 205 b 279 187 284 190 279 188 b 279 156 279 187 279 174 b 279 136 279 151 279 144 l 279 84 l 289 87 l 330 98 b 367 105 352 102 362 105 b 378 101 372 105 375 104 b 386 61 385 95 386 94 b 386 40 386 55 386 48 l 386 -5 l 385 -8 b 374 -19 383 -12 378 -18 b 291 -40 372 -19 347 -26 b 279 -43 284 -41 279 -43 b 279 -83 279 -43 279 -59 b 279 -95 279 -87 279 -91 l 279 -145 l 304 -140 b 337 -133 321 -136 330 -133 b 349 -140 343 -133 347 -136 b 355 -181 355 -145 355 -142 l 355 -197 l 355 -210 b 349 -252 355 -249 355 -247 b 300 -269 345 -258 347 -258 b 280 -274 291 -272 281 -273 l 279 -274 l 277 -378 l 277 -483 l 276 -487 b 257 -499 273 -495 265 -499 b 238 -487 249 -499 242 -495 l 236 -483 l 236 -384 l 236 -285 l 235 -285 l 212 -291 l 170 -301 b 148 -308 159 -305 148 -306 b 147 -415 147 -308 147 -313 l 147 -523 l 145 -526 b 126 -538 141 -534 133 -538 b 106 -526 118 -538 110 -534 l 104 -523 l 104 -420 b 103 -317 104 -326 104 -317 b 103 -317 103 -317 103 -317 b 50 -330 92 -322 54 -330 b 31 -317 42 -330 35 -326 b 29 -267 29 -315 29 -315 l 29 -219 l 32 -216 b 92 -192 36 -206 36 -206 l 104 -190 l 104 -138 b 103 -87 104 -91 104 -87 b 103 -87 103 -87 103 -87 b 88 -91 103 -87 96 -88 l 49 -101 b 17 -106 32 -105 23 -106 b 6 -102 13 -106 10 -105 b -1 -62 0 -97 -1 -95 b 0 -41 -1 -56 0 -49 l 0 4 l 1 6 b 10 16 2 11 6 15 b 91 37 12 18 38 24 l 104 41 l 104 93 b 103 144 104 140 104 144 b 103 144 103 144 103 144 b 50 131 92 141 54 131 b 31 144 42 131 35 137 b 29 195 29 147 29 148 l 29 242 l 32 245 b 92 269 36 255 36 255 l 104 273 l 104 377 l 104 481 l 106 485 b 126 498 110 492 118 498 b 134 495 129 498 132 496 b 145 485 138 494 142 489 l 147 481 l 147 383 l 147 283 l 152 284 b 190 294 155 285 171 290 l 230 303 l 236 305 l 236 413 l 236 521 l 238 524 b 249 535 240 528 243 533 m 236 126 b 235 177 236 154 236 177 l 235 177 b 213 172 235 177 225 174 l 170 161 b 147 155 157 158 147 155 b 147 124 147 155 147 142 b 147 102 147 117 147 111 l 147 52 l 153 54 l 228 72 l 236 74 l 236 126 m 236 -105 b 235 -54 236 -65 236 -54 l 235 -54 b 231 -55 235 -54 234 -54 b 172 -69 227 -55 204 -62 l 149 -76 l 147 -76 l 147 -127 l 147 -179 l 152 -177 b 190 -167 155 -177 171 -173 l 230 -158 l 236 -156 l 236 -105 "},"v7c":{"x_min":0,"x_max":300.8125,"ha":307,"o":"m 49 505 b 53 506 50 505 51 506 b 70 496 58 506 62 503 b 81 485 73 492 78 488 l 96 473 l 111 459 l 122 449 l 134 438 l 182 396 l 255 330 b 292 291 292 298 292 298 l 292 290 l 292 284 l 283 270 b 209 36 234 197 209 113 b 288 -170 209 -44 235 -119 b 299 -184 295 -179 299 -181 b 300 -191 300 -187 300 -188 b 285 -206 300 -199 294 -206 b 280 -206 283 -206 281 -206 b 247 -201 270 -202 259 -201 b 176 -222 223 -201 197 -208 b 114 -340 136 -249 114 -292 b 172 -471 114 -384 134 -433 b 185 -492 182 -481 185 -487 b 181 -502 185 -496 183 -499 b 171 -508 176 -505 174 -508 b 152 -498 166 -508 160 -503 b 0 -284 65 -428 12 -352 b 0 -260 0 -278 0 -270 b 1 -238 0 -252 0 -242 b 148 -140 16 -177 73 -140 b 209 -148 167 -140 189 -142 b 215 -149 212 -148 215 -149 b 215 -149 215 -149 215 -149 l 215 -149 b 201 -136 215 -148 209 -142 l 157 -97 l 96 -41 b 17 34 21 24 17 29 b 17 37 17 36 17 36 b 17 38 17 37 17 38 b 25 56 17 44 17 44 b 110 298 81 131 110 219 b 46 474 110 367 88 431 b 38 491 40 480 38 487 b 49 505 38 498 42 502 "},"v7d":{"x_min":-1.359375,"x_max":436.921875,"ha":446,"o":"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},"v7f":{"x_min":0,"x_max":367.5,"ha":375,"o":"m 0 124 l 0 187 l 61 187 l 122 187 l 122 138 l 122 91 l 153 61 l 183 30 l 213 61 l 243 91 l 243 138 l 243 187 l 306 187 l 367 187 l 367 124 l 367 61 l 321 61 l 274 61 l 243 30 l 213 0 l 243 -31 l 274 -62 l 321 -62 l 367 -62 l 367 -124 l 367 -188 l 306 -188 l 243 -188 l 243 -140 l 243 -93 l 213 -62 l 183 -31 l 153 -62 l 122 -93 l 122 -140 l 122 -188 l 61 -188 l 0 -188 l 0 -124 l 0 -62 l 46 -62 l 92 -62 l 123 -31 l 153 0 l 123 30 l 92 61 l 46 61 l 0 61 l 0 124 "},"v80":{"x_min":29.9375,"x_max":420.578125,"ha":371,"o":"m 115 345 b 221 347 117 345 166 347 b 411 345 306 347 409 345 b 420 330 416 342 420 335 b 415 319 420 326 419 321 b 178 118 397 303 179 118 b 178 117 178 118 178 117 b 181 117 178 117 178 117 b 189 117 182 117 185 117 b 193 117 190 117 191 117 b 247 98 215 117 232 111 b 296 75 266 83 280 76 b 302 75 299 75 300 75 b 322 91 311 75 315 79 b 322 91 322 91 322 91 b 322 91 322 91 322 91 b 319 91 322 91 321 91 b 313 90 318 90 315 90 b 283 107 300 90 288 97 b 277 126 279 114 277 121 b 319 167 277 149 295 167 b 319 167 319 167 319 167 b 362 118 347 167 362 147 b 355 82 362 108 359 96 b 311 33 349 65 340 55 b 224 1 284 12 253 1 b 194 5 213 1 204 2 b 168 18 183 8 178 11 b 110 36 151 30 130 36 b 57 15 88 36 68 29 b 47 11 54 12 51 11 b 31 20 40 11 34 13 b 29 26 31 22 29 25 b 68 66 29 36 39 45 b 285 250 73 71 281 248 b 285 250 285 250 285 250 b 231 252 285 252 261 252 b 137 250 190 252 141 250 b 93 227 122 248 110 241 b 78 220 88 222 83 220 b 66 227 74 220 70 222 b 63 234 65 229 63 231 b 85 291 63 241 69 252 b 115 345 108 342 108 344 "},"v81":{"x_min":0,"x_max":428.75,"ha":438,"o":"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 m 366 131 b 352 134 362 133 357 134 b 219 81 321 134 269 115 b 47 -111 126 23 50 -62 b 47 -112 47 -111 47 -112 b 77 -136 47 -129 58 -136 b 264 -45 118 -136 194 -101 b 382 109 336 12 382 76 b 366 131 382 120 377 129 "},"v83":{"x_min":-1.359375,"x_max":847.96875,"ha":865,"o":"m 488 1499 b 495 1500 490 1500 492 1500 b 541 1465 507 1500 521 1490 b 679 1078 622 1372 679 1210 b 677 1050 679 1068 677 1060 b 477 642 668 893 604 764 l 443 609 l 431 596 l 431 592 l 438 562 l 449 508 l 460 458 b 481 355 475 390 481 355 b 481 355 481 355 481 355 b 490 356 481 355 485 355 b 528 358 495 356 511 358 b 558 356 540 358 552 356 b 839 95 699 338 808 237 b 847 22 845 72 847 47 b 631 -303 847 -113 766 -242 b 620 -309 623 -308 620 -309 l 620 -310 b 631 -359 620 -310 626 -333 l 646 -435 l 660 -496 b 672 -588 668 -535 672 -563 b 664 -653 672 -610 669 -630 b 383 -875 630 -792 509 -875 b 201 -810 321 -875 257 -855 b 129 -680 151 -768 129 -730 b 274 -530 129 -592 200 -530 b 351 -553 300 -530 326 -538 b 412 -669 393 -582 412 -626 b 287 -805 412 -735 366 -800 l 279 -805 l 285 -809 b 383 -830 318 -823 351 -830 b 586 -718 464 -830 540 -789 b 626 -584 612 -678 626 -631 b 619 -528 626 -566 623 -548 b 612 -495 619 -526 616 -510 b 577 -324 590 -387 577 -324 b 577 -324 577 -324 577 -324 b 568 -326 575 -324 571 -324 b 528 -334 558 -328 537 -333 b 465 -338 506 -337 485 -338 b 24 -11 269 -338 87 -206 b -1 145 8 41 -1 93 b 96 442 -1 249 32 351 b 322 714 166 541 236 626 l 352 745 l 345 782 l 332 843 l 315 921 b 303 984 310 950 304 978 b 295 1082 298 1017 295 1049 b 413 1426 295 1208 336 1329 b 488 1499 436 1456 477 1496 m 549 1301 b 541 1301 547 1301 544 1301 b 411 1207 500 1301 447 1263 b 355 1004 374 1152 355 1079 b 359 942 355 984 356 963 b 371 881 362 927 363 917 l 385 818 b 392 782 389 799 392 784 l 392 782 b 434 828 393 782 424 816 b 607 1165 534 941 594 1060 b 608 1193 608 1175 608 1183 b 597 1270 608 1224 604 1254 b 549 1301 589 1286 571 1299 m 398 528 b 393 555 396 542 393 553 b 392 555 393 555 393 555 b 317 470 390 555 347 505 b 190 298 266 408 212 334 b 127 70 148 227 127 148 b 155 -77 127 19 137 -30 b 468 -303 209 -216 333 -303 b 519 -299 484 -303 502 -302 b 568 -284 541 -295 568 -287 l 568 -284 b 563 -263 568 -284 566 -274 l 534 -120 l 511 -13 l 496 61 l 480 133 b 469 187 472 176 469 187 b 468 188 469 187 469 188 b 416 162 462 188 430 172 b 337 13 364 126 337 69 b 413 -124 337 -40 363 -93 b 428 -144 424 -131 428 -137 b 428 -149 428 -145 428 -148 b 409 -166 426 -161 419 -166 b 394 -162 405 -166 400 -165 b 240 77 302 -122 240 -27 l 240 77 b 430 342 240 197 315 301 l 436 344 l 426 394 l 398 528 m 548 194 b 526 195 540 195 532 195 b 519 195 524 195 521 195 l 514 195 l 518 177 l 539 79 l 552 15 l 566 -48 l 594 -187 l 605 -240 b 612 -266 609 -254 611 -266 b 612 -266 612 -266 612 -266 b 641 -248 613 -266 630 -256 b 744 -98 692 -212 730 -156 b 751 -40 749 -79 751 -59 b 548 194 751 76 665 181 "},"v84":{"x_min":25.859375,"x_max":164.6875,"ha":168,"o":"m 34 369 b 40 370 35 370 38 370 b 59 353 49 370 50 367 b 164 40 122 254 155 158 b 164 0 164 33 164 16 b 164 -40 164 -16 164 -34 b 59 -353 155 -158 122 -254 b 40 -371 53 -366 47 -371 b 34 -370 38 -371 36 -370 b 25 -358 28 -367 25 -363 b 31 -337 25 -352 27 -347 b 92 0 72 -234 92 -117 b 31 335 92 116 72 233 b 25 356 27 345 25 352 b 34 369 25 363 28 366 "},"v86":{"x_min":-571.671875,"x_max":570.3125,"ha":582,"o":"m -386 173 b -381 174 -385 174 -383 174 b -370 173 -377 174 -372 173 b -281 86 -367 172 -347 151 b -196 0 -235 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 277 172 b 289 174 285 174 288 174 b 299 173 294 174 298 173 b 462 11 303 172 338 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 374 -176 371 -176 b 280 -87 367 -173 345 -152 b 194 0 234 -38 194 0 b 125 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 43 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -141 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -289 -176 b -300 -174 -295 -176 -299 -174 b -464 -12 -304 -173 -340 -137 l -476 0 l -504 -34 b -543 -77 -534 -73 -537 -76 b -549 -79 -545 -79 -547 -79 b -571 -58 -562 -79 -571 -69 b -568 -49 -571 -55 -570 -52 b -392 172 -566 -43 -396 167 b -386 173 -390 172 -387 173 "},"v8a":{"x_min":-170.140625,"x_max":168.78125,"ha":172,"o":"m -160 567 b -122 567 -159 567 -149 567 l -87 567 l -84 566 b -74 553 -78 563 -77 560 b -20 366 -73 551 -49 466 b 31 186 8 267 31 186 b 85 371 31 186 55 269 b 140 559 114 473 138 557 b 153 567 141 564 148 567 b 168 559 159 567 166 564 b 168 555 168 557 168 557 b 92 281 168 548 159 513 b 14 13 50 134 14 13 b 0 0 14 6 6 0 b -17 15 -8 0 -17 8 b -93 283 -17 15 -51 136 b -170 552 -166 533 -170 548 b -170 553 -170 552 -170 552 b -160 567 -170 560 -167 564 "},"v8b":{"x_min":0,"x_max":319.859375,"ha":326,"o":"m 149 508 b 159 509 152 509 155 509 b 186 494 170 509 181 503 b 190 440 190 487 190 488 l 190 430 l 190 377 l 242 377 l 251 377 b 303 373 298 377 296 377 b 319 345 314 367 319 356 b 304 319 319 335 314 324 b 250 315 296 315 299 315 l 242 315 l 190 315 l 190 262 l 190 252 b 186 198 190 204 190 205 b 159 183 179 188 170 183 b 132 198 148 183 138 188 b 127 252 127 205 127 204 l 127 262 l 127 315 l 76 315 l 68 315 b 14 319 20 315 21 315 b 0 347 4 324 0 335 b 14 373 0 356 4 367 b 68 377 21 377 20 377 l 76 377 l 127 377 l 127 430 l 127 440 b 132 494 127 488 127 487 b 149 508 136 501 142 505 "},"v8c":{"x_min":-330.75,"x_max":329.390625,"ha":336,"o":"m -133 483 b -117 484 -127 484 -122 484 b 31 373 -51 484 9 440 b 35 348 34 365 35 356 b -25 285 35 313 10 285 b -87 331 -55 285 -76 302 b -167 402 -100 376 -133 402 b -191 398 -175 402 -183 401 b -227 341 -215 388 -227 369 b -225 320 -227 334 -227 327 b -13 74 -209 230 -125 133 b 6 65 -4 70 5 66 l 9 63 l 10 65 b 117 231 12 68 40 112 l 189 341 l 242 424 b 268 460 262 456 264 458 b 283 464 273 463 277 464 b 308 438 296 464 308 453 l 308 437 b 287 396 308 430 308 428 l 95 98 l 59 43 l 58 41 l 65 37 b 253 -156 151 -8 217 -77 b 281 -285 272 -199 281 -244 b 148 -481 281 -381 231 -463 b 115 -485 137 -484 126 -485 b -32 -376 51 -485 -9 -442 b -36 -349 -35 -366 -36 -358 b 25 -287 -36 -315 -12 -287 b 85 -333 54 -287 74 -302 b 166 -403 99 -377 133 -403 b 190 -399 174 -403 182 -402 b 225 -342 215 -390 225 -370 b 224 -322 225 -335 225 -328 b 12 -76 208 -231 125 -134 b -8 -66 2 -72 -6 -68 l -10 -65 l -12 -66 b -118 -231 -13 -68 -42 -113 l -190 -342 l -243 -426 b -269 -462 -264 -458 -265 -458 b -284 -466 -274 -464 -279 -466 b -310 -440 -298 -466 -310 -455 l -310 -438 b -288 -398 -310 -430 -308 -430 l -96 -99 l -59 -44 l -59 -43 l -66 -38 b -281 284 -198 33 -281 158 l -281 284 b -133 483 -281 392 -220 474 m 254 177 b 266 179 258 177 262 179 b 319 149 287 179 307 167 b 329 115 326 140 329 127 b 319 79 329 102 326 90 b 268 51 307 61 287 51 b 221 72 250 51 234 58 b 205 115 210 84 205 99 b 254 177 205 142 223 170 m -281 -54 b -269 -52 -277 -52 -273 -52 b -223 -73 -253 -52 -235 -59 b -206 -116 -212 -84 -206 -101 b -216 -151 -206 -129 -209 -141 b -269 -179 -228 -170 -249 -179 b -314 -159 -285 -179 -302 -173 b -330 -116 -325 -147 -330 -131 b -281 -54 -330 -88 -313 -61 "},"v8d":{"x_min":-1.359375,"x_max":255.890625,"ha":261,"o":"m 118 514 b 127 517 121 517 122 517 b 147 505 136 517 142 513 l 148 502 l 148 403 b 148 306 148 351 148 306 b 174 315 149 306 160 310 l 200 324 l 205 323 b 223 312 213 323 220 319 l 225 308 l 225 260 b 225 245 225 255 225 249 b 220 204 225 208 224 209 b 179 188 216 199 215 199 l 148 177 l 148 124 l 148 70 l 189 84 b 236 98 219 94 230 98 b 247 94 240 98 243 97 b 255 52 254 88 255 87 b 255 33 255 47 255 40 l 254 -12 l 253 -15 b 249 -22 253 -18 250 -20 l 245 -24 l 196 -41 l 148 -58 l 148 -108 b 148 -158 148 -136 148 -158 b 174 -148 148 -158 160 -154 b 204 -140 198 -140 200 -140 l 204 -140 b 224 -152 213 -140 221 -145 b 225 -201 224 -155 225 -177 b 224 -254 225 -226 224 -251 b 157 -284 220 -262 220 -262 l 148 -288 l 148 -395 l 148 -503 l 147 -506 b 127 -519 142 -514 134 -519 b 107 -506 119 -519 111 -514 l 106 -503 l 106 -403 b 106 -303 106 -316 106 -303 b 104 -303 104 -303 104 -303 b 88 -310 104 -303 96 -306 l 63 -319 b 51 -322 59 -320 55 -322 b 36 -315 46 -322 40 -319 b 31 -273 32 -309 31 -312 b 31 -258 31 -269 31 -263 l 31 -210 l 34 -206 b 40 -198 35 -204 38 -199 b 74 -186 42 -197 57 -191 l 106 -173 l 106 -123 b 106 -97 106 -112 106 -104 b 106 -72 106 -76 106 -72 b 104 -72 106 -72 106 -72 b 20 -99 89 -79 23 -99 b 0 -84 10 -99 2 -93 b -1 -37 0 -81 -1 -59 b 0 11 -1 -15 0 9 b 58 40 4 22 2 22 l 106 56 l 106 109 b 106 123 106 115 106 119 b 106 162 106 147 106 162 b 81 155 106 162 93 159 b 50 147 65 149 55 147 b 36 152 43 147 40 148 b 31 194 32 158 31 156 b 31 209 31 198 31 204 l 31 256 l 34 260 b 76 281 38 269 38 269 l 106 292 l 106 396 l 106 502 l 107 505 b 118 514 110 509 114 513 "},"v8f":{"x_min":-21.78125,"x_max":362.0625,"ha":369,"o":"m 302 1031 b 308 1032 304 1032 307 1032 b 330 1016 318 1032 325 1027 b 362 867 351 970 362 920 b 340 738 362 824 353 780 l 336 727 l 340 717 b 362 591 355 677 362 634 b 257 323 362 496 325 401 b 204 272 243 306 227 290 b 20 56 129 206 66 133 b -1 18 12 44 0 22 b -19 4 -4 9 -12 4 l -21 4 l -21 140 l -21 276 l -12 277 b 167 333 61 288 127 309 b 319 598 262 388 319 491 b 311 664 319 620 317 642 l 310 673 l 304 664 b 204 548 279 620 250 587 b 20 333 129 483 66 409 b -1 292 12 320 0 298 b -19 280 -4 285 -12 280 l -21 280 l -21 416 l -21 552 l -12 553 b 167 609 61 564 127 585 b 319 874 264 666 319 770 b 294 992 319 914 311 954 b 288 1011 288 1004 288 1007 b 302 1031 288 1021 294 1028 "},"v90":{"x_min":-171.5,"x_max":483.1875,"ha":493,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},"v92":{"x_min":0,"x_max":598.890625,"ha":611,"o":"m 62 181 b 77 183 66 183 72 183 b 91 181 83 183 88 183 b 202 131 100 180 106 177 l 299 87 l 394 131 b 517 183 499 181 502 183 b 519 183 517 183 518 183 b 598 104 567 183 598 144 b 577 49 598 84 592 65 b 518 15 567 38 563 37 b 484 0 499 6 484 0 b 518 -16 484 -1 499 -8 b 577 -51 563 -38 567 -40 b 598 -105 592 -66 598 -86 b 519 -184 598 -145 567 -184 b 517 -184 518 -184 517 -184 b 394 -133 502 -184 499 -183 l 299 -88 l 202 -133 b 81 -184 99 -183 95 -184 b 77 -184 80 -184 78 -184 b 0 -105 29 -184 0 -145 b 20 -51 0 -86 5 -66 b 80 -16 29 -40 34 -38 b 114 -1 98 -8 114 -1 b 80 15 114 0 98 6 b 20 49 34 37 29 38 b 0 104 6 65 0 84 b 62 181 0 140 23 174 m 88 134 b 74 136 85 134 80 136 b 68 134 72 136 69 136 b 46 104 54 130 46 117 b 55 81 46 95 49 88 b 149 34 59 76 53 80 b 224 -1 190 15 224 0 b 144 -38 224 -1 187 -18 b 54 -84 59 -79 58 -79 b 46 -105 49 -90 46 -98 b 76 -137 46 -122 58 -137 b 78 -137 77 -137 77 -137 b 194 -86 87 -137 76 -141 b 298 -36 250 -58 298 -36 b 298 -36 298 -36 298 -36 b 402 -84 299 -36 345 -58 b 518 -137 522 -141 510 -137 b 521 -137 519 -137 519 -137 b 551 -105 539 -137 551 -122 b 541 -83 551 -98 548 -90 b 447 -36 537 -77 544 -81 b 374 -1 406 -16 374 -1 b 447 34 374 0 406 15 b 541 81 544 80 537 76 b 551 104 548 88 551 97 b 521 136 551 120 539 136 b 518 136 519 136 519 136 b 517 136 518 136 517 136 l 517 136 b 402 83 511 136 511 136 b 298 34 345 56 299 34 b 298 34 298 34 298 34 b 194 84 298 34 250 56 b 88 134 137 111 89 133 "},"v93":{"x_min":0,"x_max":438.28125,"ha":447,"o":"m 212 205 b 219 205 213 205 216 205 b 239 183 228 205 231 204 b 421 -163 298 40 363 -83 b 438 -191 434 -180 438 -186 b 436 -197 438 -192 438 -195 b 424 -206 434 -204 431 -206 b 406 -201 420 -206 415 -205 b 216 -156 347 -172 281 -156 b 23 -205 148 -156 80 -173 b 14 -206 20 -206 17 -206 b 0 -191 6 -206 0 -201 b 6 -176 0 -187 1 -183 b 202 192 63 -104 142 45 b 212 205 205 199 208 202 m 264 48 l 249 81 l 243 94 l 242 91 b 89 -126 208 36 137 -66 b 81 -138 85 -133 81 -138 b 81 -138 81 -138 81 -138 b 81 -138 81 -138 81 -138 b 95 -133 81 -138 87 -136 b 280 -94 156 -108 221 -94 b 334 -98 299 -94 317 -95 b 343 -99 338 -99 343 -99 b 343 -99 343 -99 343 -99 b 338 -94 343 -99 341 -97 b 264 48 318 -58 287 1 "},"v94":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -9 215 b 0 217 -6 217 -4 217 b 19 205 8 217 14 213 b 20 142 20 202 20 201 l 20 84 l 23 84 b 144 -27 81 74 129 30 b 148 -66 147 -40 148 -54 b 36 -213 148 -134 103 -197 b 0 -219 24 -217 12 -219 b -145 -104 -68 -219 -129 -173 b -149 -68 -148 -91 -149 -79 b -24 84 -149 6 -98 74 l -21 84 l -21 142 b -19 205 -20 201 -20 202 b -9 215 -17 209 -13 213 m -21 -15 b -23 41 -21 37 -21 41 b -23 41 -23 41 -23 41 b -76 11 -35 40 -62 26 b -108 -65 -98 -11 -108 -38 b -1 -176 -108 -122 -65 -176 b 107 -65 63 -176 107 -122 b 74 11 107 -38 96 -11 b 20 41 61 26 32 41 b 20 -15 20 41 20 15 b 19 -74 20 -72 20 -72 b 0 -87 14 -83 6 -87 b -19 -74 -8 -87 -16 -83 b -21 -15 -20 -72 -20 -72 "},"v95":{"x_min":0,"x_max":406.96875,"ha":415,"o":"m 55 181 b 70 183 61 183 66 183 b 111 170 85 183 99 179 b 160 130 115 167 137 149 l 202 95 l 245 130 b 319 181 299 176 302 179 b 334 183 325 183 330 183 b 406 109 375 183 406 148 b 401 81 406 99 405 91 b 348 24 394 65 390 59 b 318 -1 332 11 318 0 b 348 -26 318 -1 332 -12 b 401 -83 390 -61 394 -66 b 406 -111 405 -93 406 -101 b 334 -184 406 -149 375 -184 b 319 -183 330 -184 325 -184 b 245 -131 302 -180 299 -177 l 202 -97 l 160 -131 b 85 -183 107 -177 103 -180 b 70 -184 80 -184 76 -184 b 0 -111 31 -184 0 -149 b 4 -83 0 -101 1 -93 b 58 -26 10 -66 16 -61 b 88 -1 74 -12 88 -1 b 58 24 88 0 74 11 b 10 69 23 54 17 59 b 0 109 2 81 0 95 b 55 181 0 142 21 173 m 83 133 b 72 136 78 136 76 136 b 57 131 66 136 61 134 b 46 109 49 126 46 117 b 50 93 46 104 47 98 b 107 45 51 91 77 70 b 160 0 137 20 160 0 b 107 -47 160 -1 137 -22 b 50 -94 77 -72 51 -93 b 46 -111 47 -99 46 -105 b 59 -134 46 -120 50 -130 b 72 -137 62 -136 68 -137 b 83 -136 76 -137 80 -136 b 144 -84 84 -134 107 -116 b 202 -36 176 -58 202 -36 b 261 -84 202 -36 230 -58 b 323 -136 299 -116 321 -134 b 334 -137 326 -136 330 -137 b 345 -134 338 -137 343 -136 b 360 -111 355 -130 360 -120 b 355 -94 360 -105 359 -99 b 299 -47 353 -93 329 -72 b 245 0 269 -22 245 -1 b 299 45 245 0 269 20 b 355 93 329 70 353 91 b 360 109 359 98 360 104 b 345 133 360 119 355 129 b 334 136 343 134 338 136 b 323 134 330 136 326 134 b 261 83 321 133 299 115 b 202 34 230 56 202 34 b 144 83 202 34 176 56 b 83 133 106 115 84 133 "},"v97":{"x_min":-228.671875,"x_max":227.3125,"ha":232,"o":"m -217 487 l -213 488 l 0 488 l 212 488 l 216 487 b 225 476 220 484 224 480 l 227 473 l 227 244 l 227 15 l 225 12 b 206 0 223 4 215 0 b 197 1 204 0 200 0 b 187 12 193 4 189 6 l 186 15 l 186 138 l 186 262 l -1 262 l -187 262 l -187 138 l -187 15 l -189 12 b -208 0 -193 4 -200 0 b -227 12 -216 0 -223 4 l -228 15 l -228 244 l -228 473 l -227 476 b -217 487 -225 480 -221 484 "},"v9a":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 230 1031 b 238 1032 232 1032 235 1032 b 259 1014 245 1032 251 1027 b 367 662 330 906 367 782 b 364 602 367 641 367 621 b 232 317 352 488 304 384 b 57 120 155 245 103 187 b -1 18 31 84 6 40 b -19 4 -4 11 -12 4 l -21 4 l -21 159 l -21 315 l -16 315 b 96 335 10 315 62 324 b 315 695 227 380 315 527 b 313 738 315 709 314 724 b 224 991 304 825 273 916 b 216 1013 219 999 216 1007 b 230 1031 216 1021 220 1028 "},"v9b":{"x_min":-24.5,"x_max":313.0625,"ha":319,"o":"m -24 -133 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 142 -213 13 -61 74 -144 b 258 -376 196 -269 230 -315 b 313 -605 295 -449 313 -528 b 292 -742 313 -652 306 -699 b 288 -752 289 -748 288 -752 b 288 -752 288 -752 288 -752 b 292 -764 289 -753 291 -757 b 313 -907 306 -811 313 -860 b 292 -1045 313 -954 306 -1002 b 288 -1054 289 -1050 288 -1054 b 288 -1054 288 -1054 288 -1054 b 292 -1067 289 -1054 291 -1060 b 313 -1210 306 -1113 313 -1161 b 292 -1346 313 -1257 306 -1304 b 288 -1357 289 -1353 288 -1357 b 288 -1357 288 -1357 288 -1357 b 292 -1368 289 -1357 291 -1363 b 313 -1512 306 -1415 313 -1464 b 292 -1648 313 -1560 306 -1605 b 288 -1660 289 -1654 288 -1660 b 288 -1660 288 -1660 288 -1660 b 292 -1671 289 -1660 291 -1665 b 313 -1814 306 -1719 313 -1766 b 250 -2040 313 -1897 291 -1977 b 232 -2062 238 -2057 236 -2059 b 221 -2065 230 -2063 225 -2065 b 200 -2045 210 -2065 201 -2057 b 200 -2043 200 -2044 200 -2044 b 208 -2026 200 -2037 202 -2034 b 269 -1826 249 -1966 269 -1897 b 153 -1544 269 -1726 230 -1625 b -9 -1472 115 -1506 58 -1481 b -21 -1471 -14 -1471 -19 -1471 l -24 -1471 l -24 -1343 l -24 -1215 l -20 -1215 b -1 -1229 -12 -1215 -4 -1221 b 142 -1424 13 -1270 74 -1353 b 257 -1582 196 -1478 228 -1524 b 264 -1594 261 -1589 264 -1594 l 264 -1594 b 265 -1582 264 -1594 264 -1589 b 270 -1525 268 -1562 270 -1544 b 153 -1243 270 -1424 228 -1321 b -9 -1170 115 -1203 58 -1178 b -21 -1168 -14 -1170 -19 -1168 l -24 -1168 l -24 -1041 l -24 -913 l -20 -913 b -1 -927 -12 -913 -4 -918 b 142 -1121 13 -967 74 -1050 b 257 -1281 196 -1175 228 -1221 b 264 -1292 261 -1286 264 -1292 l 264 -1292 b 265 -1279 264 -1292 264 -1286 b 270 -1222 268 -1261 270 -1242 b 153 -941 270 -1121 228 -1018 b -9 -867 115 -900 58 -875 b -21 -866 -14 -867 -19 -866 l -24 -866 l -24 -738 l -24 -610 l -20 -610 b -1 -624 -12 -610 -4 -616 b 142 -818 13 -664 74 -749 b 257 -978 196 -873 228 -918 b 264 -989 261 -984 264 -989 l 264 -989 b 265 -977 264 -989 264 -984 b 270 -920 268 -959 270 -939 b 153 -638 270 -818 228 -716 b -9 -564 115 -598 58 -573 b -21 -563 -14 -564 -19 -563 l -24 -563 l -24 -435 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 142 -516 13 -363 74 -446 b 257 -675 196 -571 228 -616 b 264 -687 261 -681 264 -687 l 264 -687 b 265 -674 264 -687 264 -681 b 270 -617 268 -656 270 -637 b 153 -335 270 -516 228 -413 b -9 -262 115 -295 58 -270 b -21 -260 -14 -262 -19 -260 l -24 -260 l -24 -133 "},"v9c":{"x_min":-166.0625,"x_max":-25.859375,"ha":0,"o":"m -49 369 b -42 370 -46 369 -44 370 b -27 360 -36 370 -29 366 b -25 355 -27 359 -25 358 b -32 335 -25 351 -28 347 b -92 52 -66 248 -87 159 b -93 -1 -93 43 -93 20 b -92 -54 -93 -23 -93 -45 b -32 -337 -85 -162 -66 -251 b -25 -355 -27 -349 -25 -352 b -42 -371 -25 -365 -32 -371 b -61 -353 -50 -371 -51 -369 b -163 -63 -119 -262 -153 -165 b -166 -1 -166 -37 -166 -31 b -163 62 -166 30 -166 36 b -61 352 -153 163 -119 260 b -49 369 -54 365 -51 366 "},"v9e":{"x_min":0,"x_max":607.0625,"ha":619,"o":"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 m 347 631 b 353 632 348 632 351 632 b 374 620 363 632 371 628 b 375 383 375 616 375 616 l 375 148 l 377 151 b 492 199 415 183 454 199 b 537 191 507 199 522 197 b 607 84 582 176 607 134 b 583 0 607 58 598 29 b 455 -142 562 -40 533 -72 l 378 -215 b 355 -229 364 -229 362 -229 b 334 -216 345 -229 337 -224 l 333 -212 l 333 201 l 333 616 l 334 620 b 347 631 337 624 341 630 m 465 131 b 451 133 461 133 455 133 b 445 133 449 133 446 133 b 379 87 419 129 396 113 l 375 80 l 375 -37 l 375 -156 l 378 -152 b 499 81 451 -72 499 20 l 499 83 b 465 131 499 113 490 126 "},"va3":{"x_min":58.53125,"x_max":228.671875,"ha":294,"o":"m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "},"va5":{"x_min":0,"x_max":349.8125,"ha":357,"o":"m 88 302 b 103 303 93 302 98 303 b 202 224 149 303 191 270 b 205 199 204 216 205 208 b 178 129 205 173 196 147 l 175 126 l 182 127 b 307 249 236 142 284 190 b 313 259 308 254 311 258 b 329 267 317 265 323 267 b 349 247 340 267 349 259 b 201 -263 349 242 204 -258 b 182 -273 197 -270 190 -273 b 163 -260 174 -273 166 -269 b 161 -256 161 -259 161 -258 b 217 -59 161 -248 170 -220 b 272 129 247 43 272 127 b 272 129 272 129 272 129 b 264 122 272 129 268 126 b 140 80 227 94 183 80 b 36 115 102 80 65 91 b 0 194 10 136 0 165 b 88 302 0 244 32 292 "},"va9":{"x_min":-24.5,"x_max":314.421875,"ha":321,"o":"m -24 -145 l -24 -5 l -20 -5 b 0 -23 -9 -5 -2 -12 b 27 -87 4 -38 14 -66 b 138 -220 53 -136 88 -177 b 235 -328 179 -255 208 -288 b 314 -592 287 -409 314 -501 b 292 -732 314 -639 307 -687 l 289 -742 l 294 -756 b 314 -896 307 -802 314 -849 b 292 -1035 314 -943 307 -991 l 289 -1045 l 294 -1057 b 314 -1197 307 -1104 314 -1152 b 292 -1338 314 -1246 307 -1292 l 289 -1347 l 294 -1360 b 314 -1500 307 -1407 314 -1454 b 273 -1689 314 -1565 300 -1628 b 250 -1712 265 -1710 261 -1712 b 228 -1691 236 -1712 228 -1704 l 228 -1685 l 234 -1675 b 270 -1507 258 -1621 270 -1564 b 98 -1193 270 -1381 209 -1261 b 40 -1174 76 -1179 58 -1174 b -10 -1189 24 -1174 8 -1178 b -20 -1192 -14 -1192 -16 -1192 l -24 -1192 l -24 -1052 l -24 -913 l -20 -913 b 0 -931 -9 -913 -2 -920 b 27 -995 4 -946 14 -974 b 138 -1128 53 -1043 88 -1085 b 257 -1275 190 -1172 228 -1220 b 262 -1283 259 -1279 262 -1283 l 262 -1283 b 269 -1249 264 -1282 268 -1260 b 270 -1206 270 -1233 270 -1220 b 98 -891 270 -1075 206 -957 b 40 -871 76 -877 58 -871 b -10 -886 24 -871 8 -875 b -20 -889 -14 -889 -16 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 0 -628 -9 -610 -2 -617 b 27 -692 4 -644 14 -671 b 138 -825 53 -741 88 -782 b 257 -973 190 -870 228 -917 b 262 -981 259 -977 262 -981 l 262 -981 b 269 -946 264 -979 268 -957 b 270 -903 270 -931 270 -917 b 98 -588 270 -774 206 -655 b 40 -569 76 -574 58 -569 b -10 -584 24 -569 8 -574 b -20 -587 -14 -587 -16 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 0 -326 -9 -308 -2 -315 b 27 -390 4 -341 14 -369 b 138 -523 53 -438 88 -480 b 257 -670 190 -567 228 -614 b 262 -678 259 -674 262 -678 b 262 -678 262 -678 262 -678 b 269 -644 264 -677 268 -656 b 270 -601 270 -628 270 -614 b 98 -285 270 -471 206 -352 b 40 -266 76 -273 58 -266 b -10 -281 24 -266 8 -272 b -20 -284 -14 -284 -16 -284 l -24 -284 l -24 -145 "},"vaa":{"x_min":-1.359375,"x_max":752.703125,"ha":768,"o":"m 490 985 b 504 986 495 986 500 986 b 604 907 551 986 593 954 b 607 884 607 900 607 892 b 581 813 607 857 597 831 l 578 810 l 583 811 b 710 932 638 827 687 873 b 714 943 711 936 713 942 b 730 952 720 949 725 952 b 752 931 741 952 752 943 b 200 -946 752 927 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 538 314 477 300 508 b 318 598 300 559 306 580 b 404 645 340 630 372 645 b 494 592 439 645 475 627 b 507 541 502 577 507 559 b 480 471 507 516 498 489 l 477 467 l 483 470 b 608 589 537 485 586 531 b 675 811 611 595 675 810 b 675 811 675 811 675 811 b 666 806 675 811 671 809 b 543 763 628 777 585 763 b 438 799 504 763 468 775 b 401 878 412 820 401 849 b 490 985 401 928 434 977 "},"vab":{"x_min":0,"x_max":272.21875,"ha":278,"o":"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 "},"vad":{"x_min":0,"x_max":873.828125,"ha":892,"o":"m 0 0 l 0 703 l 81 703 l 164 703 l 164 0 l 164 -705 l 81 -705 l 0 -705 l 0 0 m 225 0 l 225 703 l 246 703 l 268 703 l 268 366 l 268 30 l 274 36 b 314 79 284 44 302 63 b 413 302 357 137 392 213 b 432 327 419 324 421 327 b 449 306 443 327 447 322 b 611 115 457 195 529 115 b 651 122 624 115 638 117 b 728 316 705 140 724 188 b 729 388 728 342 729 366 b 671 635 729 533 711 602 b 581 662 649 652 616 662 b 477 637 545 662 510 653 l 475 635 l 477 634 b 503 627 488 632 495 631 b 545 556 532 612 545 584 b 491 480 545 524 526 491 b 465 474 481 476 473 474 b 379 563 417 474 379 516 b 389 602 379 576 382 588 b 541 691 409 641 479 681 b 582 694 555 692 568 694 b 865 462 714 694 834 598 b 873 392 871 440 873 416 b 865 317 873 367 871 341 b 639 84 839 194 748 101 b 612 83 630 83 620 83 b 511 116 577 83 543 94 b 504 120 509 119 506 120 b 504 120 504 120 504 120 b 469 59 504 120 488 93 l 432 -1 l 469 -61 b 504 -122 488 -94 504 -122 b 504 -122 504 -122 504 -122 b 511 -117 506 -122 509 -120 b 612 -84 543 -95 577 -84 b 665 -91 630 -84 647 -87 b 869 -338 771 -122 850 -216 b 873 -392 872 -356 873 -374 b 798 -595 873 -469 847 -539 b 581 -695 741 -662 660 -695 b 406 -626 517 -695 454 -671 b 381 -563 389 -607 381 -585 b 465 -477 381 -519 413 -477 b 545 -559 514 -477 545 -519 b 503 -628 545 -587 532 -613 b 477 -635 495 -632 488 -634 l 475 -637 l 477 -638 b 581 -663 510 -655 545 -663 b 671 -637 616 -663 649 -653 b 729 -391 711 -603 729 -534 b 728 -317 729 -367 728 -344 b 623 -117 722 -173 698 -124 b 611 -116 619 -116 615 -116 b 449 -308 528 -116 457 -198 b 432 -328 447 -323 443 -328 b 413 -303 421 -328 419 -326 b 314 -80 392 -215 357 -138 b 274 -37 302 -65 284 -45 l 268 -31 l 268 -367 l 268 -705 l 246 -705 l 225 -705 l 225 0 "},"vb1":{"x_min":78.9375,"x_max":485.921875,"ha":417,"o":"m 362 378 b 378 380 367 380 372 380 b 472 348 415 380 453 367 b 485 315 481 338 485 327 b 462 273 485 298 477 281 b 439 267 454 269 446 267 b 398 290 424 267 409 274 b 344 319 385 309 364 319 b 281 269 315 319 289 301 b 279 262 280 266 279 262 b 276 256 279 260 277 258 b 274 249 276 254 274 251 b 238 127 273 248 257 192 b 201 4 217 61 201 5 b 166 -1 198 -1 200 -1 b 153 -1 163 -1 157 -1 b 141 -1 148 -1 144 -1 b 104 4 106 -1 107 -1 b 104 6 104 5 104 5 b 142 144 104 13 110 34 b 182 278 164 219 181 276 b 183 288 182 281 182 285 b 185 302 185 292 185 298 b 164 330 185 317 176 328 b 159 330 163 330 161 330 b 102 302 140 330 119 320 b 91 294 95 295 93 294 b 88 294 91 294 89 294 b 78 303 83 294 78 298 b 81 312 78 306 78 309 b 200 373 106 347 160 373 b 215 371 205 373 209 371 b 266 335 235 367 254 353 b 269 331 268 333 269 331 b 269 331 269 331 269 331 b 273 335 269 331 270 334 b 362 378 298 359 330 376 "},"vb3":{"x_min":0,"x_max":227.3125,"ha":232,"o":"m 91 213 b 100 215 93 215 96 215 b 227 58 167 215 224 144 b 227 52 227 56 227 54 b 61 -201 227 -43 164 -138 b 29 -216 44 -212 36 -216 b 23 -210 27 -216 24 -213 b 21 -205 21 -208 21 -206 b 34 -192 21 -201 25 -197 b 122 -55 89 -161 122 -106 b 104 6 122 -33 117 -12 l 103 9 l 96 9 b 4 79 57 9 17 38 b 0 112 1 90 0 101 b 91 213 0 163 36 209 "},"vb4":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 80 86 -5 172 13 151 b 166 -1 127 37 166 -1 b 235 84 166 -1 197 37 b 311 173 306 173 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 152 -86 221 -1 190 -38 b 76 -176 81 -174 83 -173 b 70 -176 74 -176 73 -176 b 61 -174 66 -176 62 -174 b -27 -87 58 -173 38 -152 b -114 -1 -74 -38 -112 -1 b -182 -86 -114 -1 -145 -38 b -258 -176 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},"vb6":{"x_min":0,"x_max":556.6875,"ha":568,"o":"m 289 545 b 298 546 292 545 295 546 b 318 533 306 546 315 541 b 319 428 319 530 319 528 l 319 327 l 334 327 b 526 223 412 326 485 285 b 543 172 537 206 543 190 b 447 76 543 122 503 76 b 445 76 446 76 446 76 b 359 165 394 77 359 119 b 368 205 359 179 362 192 b 441 251 382 233 412 251 b 455 249 446 251 451 251 b 460 248 458 249 460 248 b 460 248 460 248 460 248 b 454 254 460 249 458 251 b 334 295 419 280 378 294 l 319 295 l 319 4 l 319 -287 l 321 -285 b 328 -285 322 -285 325 -285 b 524 -99 424 -277 507 -198 b 541 -79 526 -84 530 -79 b 556 -97 551 -79 556 -84 b 548 -133 556 -105 553 -117 b 334 -317 521 -233 434 -306 b 322 -319 329 -317 323 -317 l 319 -319 l 319 -424 b 319 -471 319 -444 319 -459 b 313 -541 319 -544 318 -535 b 298 -548 308 -545 303 -548 b 279 -534 289 -548 281 -542 b 277 -424 277 -531 277 -530 l 277 -317 l 273 -317 b 13 -95 153 -305 51 -217 b 0 2 4 -62 0 -29 b 182 295 0 126 66 238 b 274 324 210 309 249 320 l 277 324 l 277 427 b 279 533 277 528 277 530 b 289 545 281 538 285 542 m 277 2 b 277 291 277 161 277 291 b 268 288 277 291 273 290 b 144 1 179 265 144 184 b 276 -284 144 -199 175 -267 l 277 -285 l 277 2 "},"vb7":{"x_min":-176.9375,"x_max":251.8125,"ha":257,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 503 20 616 20 614 b 20 391 20 442 20 391 b 84 424 20 391 49 406 l 147 456 l 152 456 b 153 456 153 456 153 456 b 175 435 166 456 175 446 b 172 427 175 433 174 430 b 92 380 170 420 172 421 l 20 342 l 20 245 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 54 -21 -212 -21 -212 b -21 322 -21 201 -21 322 b -85 290 -21 322 -50 308 l -148 256 l -153 256 b -155 256 -155 256 -155 256 b -176 277 -167 256 -176 266 b -174 285 -176 280 -175 283 b -93 333 -171 294 -174 292 l -21 370 l -21 494 b -20 620 -21 616 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},"vb9":{"x_min":-122.5,"x_max":121.140625,"ha":124,"o":"m -16 145 b 0 147 -10 147 -5 147 b 121 -1 66 147 121 77 b 114 -49 121 -16 118 -33 b -1 -148 95 -112 47 -148 b -85 -106 -31 -148 -61 -134 b -122 -1 -110 -76 -122 -38 b -16 145 -122 68 -81 134 m 12 111 b 0 113 8 113 4 113 b -68 22 -29 113 -61 73 b -70 0 -69 15 -70 6 b -13 -113 -70 -49 -47 -98 b -1 -115 -9 -115 -5 -115 b 63 -40 24 -115 53 -83 b 68 -1 66 -27 68 -15 b 12 111 68 48 46 97 "},"vba":{"x_min":-118.421875,"x_max":597.53125,"ha":381,"o":"m 460 574 b 464 574 461 574 462 574 b 488 574 470 574 481 574 b 500 573 491 574 498 574 b 594 503 543 570 588 538 b 597 488 596 498 597 494 b 528 417 597 449 564 417 b 502 423 519 417 510 419 b 465 481 477 434 465 458 b 488 528 465 499 472 516 b 490 530 490 530 490 530 b 490 530 490 530 490 530 b 468 517 488 530 475 523 b 349 340 419 485 377 420 b 347 330 348 334 347 330 b 383 328 347 328 363 328 b 428 326 423 328 424 328 b 442 302 438 320 442 312 b 430 281 442 294 438 285 b 385 276 424 277 426 276 l 377 276 l 332 276 l 330 269 b 178 -117 303 126 250 -9 b 1 -249 129 -194 69 -237 b -20 -251 -6 -251 -13 -251 b -114 -187 -65 -251 -100 -227 b -118 -156 -117 -177 -118 -166 b -51 -84 -118 -116 -91 -84 b -31 -87 -46 -84 -39 -86 b 16 -152 0 -95 16 -124 b -12 -205 16 -173 8 -194 b -16 -208 -14 -206 -16 -208 b -14 -208 -16 -208 -14 -208 b -9 -206 -14 -208 -12 -208 b 74 -124 23 -197 54 -166 b 172 224 98 -79 125 22 b 185 276 178 252 183 274 b 185 276 185 276 185 276 b 141 276 185 276 181 276 b 91 280 96 276 96 276 b 77 302 83 285 77 294 b 91 326 77 312 83 320 b 148 328 95 328 96 328 l 198 330 l 202 341 b 460 574 249 473 351 566 "},"vbf":{"x_min":-53.078125,"x_max":513.140625,"ha":485,"o":"m 185 383 b 196 384 187 383 191 384 b 277 334 230 384 259 365 b 288 301 281 324 288 306 b 288 297 288 298 288 297 b 294 302 289 297 291 299 b 394 370 323 338 367 367 b 404 371 398 370 401 371 b 510 272 453 371 498 328 b 513 237 513 262 513 251 b 507 172 513 217 511 192 b 326 -34 487 59 412 -26 b 314 -36 322 -36 318 -36 b 274 -24 298 -36 283 -31 l 265 -16 b 224 44 246 -1 232 20 b 223 49 224 47 223 49 b 223 49 223 49 223 49 b 149 -197 221 48 149 -194 b 149 -198 149 -197 149 -198 b 170 -210 149 -202 155 -205 b 187 -215 174 -210 175 -212 b 204 -231 201 -219 204 -222 b 197 -245 204 -240 202 -242 l 194 -248 l 76 -248 l -42 -248 l -46 -245 b -53 -231 -51 -242 -53 -240 b -35 -215 -53 -222 -49 -217 b -13 -210 -21 -212 -20 -212 b -6 -208 -10 -209 -8 -208 b 0 -206 -6 -208 -2 -206 b 25 -188 13 -201 21 -195 b 163 280 28 -183 163 276 b 166 291 163 283 164 287 b 167 302 167 295 167 299 b 155 324 167 315 161 324 b 155 324 155 324 155 324 b 65 230 125 322 85 280 b 53 215 61 217 58 215 b 51 215 53 215 51 215 b 42 224 46 215 42 217 b 57 263 42 231 47 244 b 140 360 77 305 104 337 b 152 370 144 365 149 369 b 185 383 157 376 172 381 m 374 306 b 366 308 371 308 368 308 b 300 273 348 308 321 294 b 284 254 288 262 287 259 b 280 242 283 249 281 245 b 257 169 279 240 270 213 l 236 98 l 236 93 b 251 48 238 77 243 61 b 279 27 258 37 272 27 b 281 27 279 27 280 27 b 291 31 281 27 287 30 b 396 170 334 52 378 109 b 406 247 402 197 406 224 b 401 277 406 259 405 270 b 374 306 397 290 383 303 "},"vc3":{"x_min":-10.890625,"x_max":299.4375,"ha":294,"o":"m 136 460 b 142 462 137 462 140 462 b 166 449 152 462 161 456 b 171 428 168 446 168 445 b 288 131 194 322 238 209 b 298 115 295 120 296 117 b 299 106 298 112 299 109 b 273 81 299 91 287 81 b 255 86 268 81 261 83 b 155 116 225 104 183 116 l 152 116 l 149 108 b 141 83 148 102 144 91 b 134 48 137 69 134 58 b 149 9 134 34 140 24 b 153 -1 152 5 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 147 -11 b 122 2 138 -11 133 -6 b 95 61 104 20 95 38 b 107 108 95 74 99 90 b 108 113 107 111 108 112 b 107 113 108 113 108 113 b 102 113 106 113 104 113 b 31 86 76 108 53 98 b 14 80 24 81 20 80 b -10 106 0 80 -10 91 b 0 131 -10 115 -9 116 b 115 430 49 209 91 317 b 136 460 119 451 123 456 "},"vd0":{"x_min":-10.890625,"x_max":299.4375,"ha":294,"o":"m 44 174 b 51 174 47 174 49 174 b 68 173 55 174 61 174 l 287 112 l 551 40 b 615 20 617 22 609 23 b 626 0 622 16 626 8 b 615 -22 626 -9 622 -18 b 613 -23 613 -23 613 -23 b 613 -23 613 -23 613 -23 b 287 -113 613 -24 597 -29 l 68 -174 b 53 -176 61 -176 57 -176 b 39 -172 47 -176 43 -174 b 27 -151 31 -167 27 -159 b 39 -129 27 -141 31 -133 b 230 -74 43 -124 20 -131 l 370 -36 l 468 -9 b 498 0 484 -4 498 -1 b 468 8 498 0 484 2 l 370 34 l 230 73 b 40 126 28 129 43 124 b 27 149 31 131 27 140 b 44 174 27 161 34 170 m 205 110 l 205 300 b 205 330 245 330 245 300 l 245 300 l 245 -300 b 245 -330 205 -330 205 -300 l 205 -300 l 205 110 l 345 90 m 345 90 l 345 330 b 345 360 385 360 385 330 l 385 330 l 385 -270 b 385 -300 345 -300 345 -270 l 345 -270 l 345 90 "},"vd1":{"x_min":-20,"x_max":320,"ha":257,"o":"m -8 200 b -8 210 8 200 16 200 l 20 148 -199 l 23 -615 b 0 -629 9 -629 6 -629 l -21 -612 l -21 -201 l -21 216 l -20 200 m 16 200 l 310 0 l 240 0 l 16 140 l 16 -120 l 240 0 l 310 0 l 16 -200 "}},"cssFontWeight":"normal","ascender":1903,"underlinePosition":-125,"cssFontStyle":"normal","boundingBox":{"yMin":-2065.375,"xMin":-695.53125,"yMax":1901.578125,"xMax":1159.671875},"resolution":1000,"descender":-2066,"familyName":"VexFlow-18","lineHeight":4093,"underlineThickness":50};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Renderer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// Support for different rendering contexts: Canvas, Raphael
	
	/* global document: false */
	
	var _canvascontext = __webpack_require__(11);
	
	var _raphaelcontext = __webpack_require__(12);
	
	var _svgcontext = __webpack_require__(13);
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lastContext = null;
	
	var Renderer = exports.Renderer = function () {
	  _createClass(Renderer, null, [{
	    key: 'buildContext',
	    value: function buildContext(elementId, backend, width, height, background) {
	      var renderer = new Renderer(elementId, backend);
	      if (width && height) {
	        renderer.resize(width, height);
	      }
	
	      if (!background) background = '#FFF';
	      var ctx = renderer.getContext();
	      ctx.setBackgroundFillStyle(background);
	      Renderer.lastContext = ctx;
	      return ctx;
	    }
	  }, {
	    key: 'getCanvasContext',
	    value: function getCanvasContext(elementId, width, height, background) {
	      return Renderer.buildContext(elementId, Renderer.Backends.CANVAS, width, height, background);
	    }
	  }, {
	    key: 'getRaphaelContext',
	    value: function getRaphaelContext(elementId, width, height, background) {
	      return Renderer.buildContext(elementId, Renderer.Backends.RAPHAEL, width, height, background);
	    }
	  }, {
	    key: 'getSVGContext',
	    value: function getSVGContext(elementId, width, height, background) {
	      return Renderer.buildContext(elementId, Renderer.Backends.SVG, width, height, background);
	    }
	  }, {
	    key: 'bolsterCanvasContext',
	    value: function bolsterCanvasContext(ctx) {
	      if (Renderer.USE_CANVAS_PROXY) {
	        return new _canvascontext.CanvasContext(ctx);
	      }
	
	      var methodNames = ['clear', 'setFont', 'setRawFont', 'setFillStyle', 'setBackgroundFillStyle', 'setStrokeStyle', 'setShadowColor', 'setShadowBlur', 'setLineWidth', 'setLineCap', 'setLineDash', 'openGroup', 'closeGroup', 'getGroup'];
	
	      ctx.vexFlowCanvasContext = ctx;
	
	      methodNames.forEach(function (methodName) {
	        ctx[methodName] = ctx[methodName] || _canvascontext.CanvasContext.prototype[methodName];
	      });
	
	      return ctx;
	    }
	
	    // Draw a dashed line (horizontal, vertical or diagonal
	    // dashPattern = [3,3] draws a 3 pixel dash followed by a three pixel space.
	    // setting the second number to 0 draws a solid line.
	
	  }, {
	    key: 'drawDashedLine',
	    value: function drawDashedLine(context, fromX, fromY, toX, toY, dashPattern) {
	      context.beginPath();
	
	      var dx = toX - fromX;
	      var dy = toY - fromY;
	      var angle = Math.atan2(dy, dx);
	      var x = fromX;
	      var y = fromY;
	      context.moveTo(fromX, fromY);
	      var idx = 0;
	      var draw = true;
	      while (!((dx < 0 ? x <= toX : x >= toX) && (dy < 0 ? y <= toY : y >= toY))) {
	        var dashLength = dashPattern[idx++ % dashPattern.length];
	        var nx = x + Math.cos(angle) * dashLength;
	        x = dx < 0 ? Math.max(toX, nx) : Math.min(toX, nx);
	        var ny = y + Math.sin(angle) * dashLength;
	        y = dy < 0 ? Math.max(toY, ny) : Math.min(toY, ny);
	        if (draw) {
	          context.lineTo(x, y);
	        } else {
	          context.moveTo(x, y);
	        }
	        draw = !draw;
	      }
	
	      context.closePath();
	      context.stroke();
	    }
	  }, {
	    key: 'Backends',
	    get: function get() {
	      return {
	        CANVAS: 1,
	        RAPHAEL: 2,
	        SVG: 3,
	        VML: 4
	      };
	    }
	
	    // End of line types
	
	  }, {
	    key: 'LineEndType',
	    get: function get() {
	      return {
	        NONE: 1, // No leg
	        UP: 2, // Upward leg
	        DOWN: 3 };
	    }
	
	    // Set this to true if you're using VexFlow inside a runtime
	    // that does not allow modifiying canvas objects. There is a small
	    // performance degradation due to the extra indirection.
	
	  }, {
	    key: 'USE_CANVAS_PROXY',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'lastContext',
	    get: function get() {
	      return lastContext;
	    },
	    set: function set(ctx) {
	      lastContext = ctx;
	    }
	  }]);
	
	  function Renderer(elementId, backend) {
	    _classCallCheck(this, Renderer);
	
	    this.elementId = elementId;
	    if (!this.elementId) {
	      throw new _vex.Vex.RERR('BadArgument', 'Invalid id for renderer.');
	    }
	
	    this.element = document.getElementById(elementId);
	    if (!this.element) this.element = elementId;
	
	    // Verify backend and create context
	    this.ctx = null;
	    this.paper = null;
	    this.backend = backend;
	    if (this.backend === Renderer.Backends.CANVAS) {
	      // Create context.
	      if (!this.element.getContext) {
	        throw new _vex.Vex.RERR('BadElement', 'Can\'t get canvas context from element: ' + elementId);
	      }
	      this.ctx = Renderer.bolsterCanvasContext(this.element.getContext('2d'));
	    } else if (this.backend === Renderer.Backends.RAPHAEL) {
	      this.ctx = new _raphaelcontext.RaphaelContext(this.element);
	    } else if (this.backend === Renderer.Backends.SVG) {
	      this.ctx = new _svgcontext.SVGContext(this.element);
	    } else {
	      throw new _vex.Vex.RERR('InvalidBackend', 'No support for backend: ' + this.backend);
	    }
	  }
	
	  _createClass(Renderer, [{
	    key: 'resize',
	    value: function resize(width, height) {
	      if (this.backend === Renderer.Backends.CANVAS) {
	        if (!this.element.getContext) {
	          throw new _vex.Vex.RERR('BadElement', 'Can\'t get canvas context from element: ' + this.elementId);
	        }
	
	        var devicePixelRatio = window.devicePixelRatio || 1;
	
	        this.element.width = width * devicePixelRatio;
	        this.element.height = height * devicePixelRatio;
	        this.element.style.width = width + 'px';
	        this.element.style.height = height + 'px';
	
	        this.ctx = Renderer.bolsterCanvasContext(this.element.getContext('2d'));
	        this.ctx.scale(devicePixelRatio, devicePixelRatio);
	      } else {
	        this.ctx.resize(width, height);
	      }
	
	      return this;
	    }
	  }, {
	    key: 'getContext',
	    value: function getContext() {
	      return this.ctx;
	    }
	  }]);

	  return Renderer;
	}();

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// A rendering context for the Raphael backend.
	//
	// Copyright Mohit Cheppudira 2010
	
	/** @constructor */
	var CanvasContext = exports.CanvasContext = function () {
	  _createClass(CanvasContext, null, [{
	    key: 'WIDTH',
	    get: function get() {
	      return 600;
	    }
	  }, {
	    key: 'HEIGHT',
	    get: function get() {
	      return 400;
	    }
	  }]);
	
	  function CanvasContext(context) {
	    _classCallCheck(this, CanvasContext);
	
	    // Use a name that is unlikely to clash with a canvas context
	    // property
	    this.vexFlowCanvasContext = context;
	    if (!context.canvas) {
	      this.canvas = {
	        width: CanvasContext.WIDTH,
	        height: CanvasContext.HEIGHT
	      };
	    } else {
	      this.canvas = context.canvas;
	    }
	  }
	
	  _createClass(CanvasContext, [{
	    key: 'clear',
	    value: function clear() {
	      this.vexFlowCanvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
	    }
	
	    // Containers not implemented
	
	  }, {
	    key: 'openGroup',
	    value: function openGroup() {}
	  }, {
	    key: 'closeGroup',
	    value: function closeGroup() {}
	  }, {
	    key: 'add',
	    value: function add() {}
	  }, {
	    key: 'setFont',
	    value: function setFont(family, size, weight) {
	      this.vexFlowCanvasContext.font = (weight || '') + ' ' + size + 'pt ' + family;
	      return this;
	    }
	  }, {
	    key: 'setRawFont',
	    value: function setRawFont(font) {
	      this.vexFlowCanvasContext.font = font;
	      return this;
	    }
	  }, {
	    key: 'setFillStyle',
	    value: function setFillStyle(style) {
	      this.vexFlowCanvasContext.fillStyle = style;
	      return this;
	    }
	  }, {
	    key: 'setBackgroundFillStyle',
	    value: function setBackgroundFillStyle(style) {
	      this.background_fillStyle = style;
	      return this;
	    }
	  }, {
	    key: 'setStrokeStyle',
	    value: function setStrokeStyle(style) {
	      this.vexFlowCanvasContext.strokeStyle = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowColor',
	    value: function setShadowColor(style) {
	      this.vexFlowCanvasContext.shadowColor = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowBlur',
	    value: function setShadowBlur(blur) {
	      this.vexFlowCanvasContext.shadowBlur = blur;
	      return this;
	    }
	  }, {
	    key: 'setLineWidth',
	    value: function setLineWidth(width) {
	      this.vexFlowCanvasContext.lineWidth = width;
	      return this;
	    }
	  }, {
	    key: 'setLineCap',
	    value: function setLineCap(cap_type) {
	      this.vexFlowCanvasContext.lineCap = cap_type;
	      return this;
	    }
	
	    // setLineDash: is the one native method in a canvas context
	    // that begins with set, therefore we don't bolster the method
	    // if it already exists (see renderer.bolsterCanvasContext).
	    // If it doesn't exist, we bolster it and assume it's looking for
	    // a ctx.lineDash method, as previous versions of VexFlow
	    // expected.
	
	  }, {
	    key: 'setLineDash',
	    value: function setLineDash(dash) {
	      this.vexFlowCanvasContext.lineDash = dash;
	      return this;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(x, y) {
	      return this.vexFlowCanvasContext.scale(parseFloat(x), parseFloat(y));
	    }
	  }, {
	    key: 'resize',
	    value: function resize(width, height) {
	      return this.vexFlowCanvasContext.resize(parseInt(width, 10), parseInt(height, 10));
	    }
	  }, {
	    key: 'rect',
	    value: function rect(x, y, width, height) {
	      return this.vexFlowCanvasContext.rect(x, y, width, height);
	    }
	  }, {
	    key: 'fillRect',
	    value: function fillRect(x, y, width, height) {
	      return this.vexFlowCanvasContext.fillRect(x, y, width, height);
	    }
	  }, {
	    key: 'clearRect',
	    value: function clearRect(x, y, width, height) {
	      return this.vexFlowCanvasContext.clearRect(x, y, width, height);
	    }
	  }, {
	    key: 'beginPath',
	    value: function beginPath() {
	      return this.vexFlowCanvasContext.beginPath();
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(x, y) {
	      return this.vexFlowCanvasContext.moveTo(x, y);
	    }
	  }, {
	    key: 'lineTo',
	    value: function lineTo(x, y) {
	      return this.vexFlowCanvasContext.lineTo(x, y);
	    }
	  }, {
	    key: 'bezierCurveTo',
	    value: function bezierCurveTo(x1, y1, x2, y2, x, y) {
	      return this.vexFlowCanvasContext.bezierCurveTo(x1, y1, x2, y2, x, y);
	    }
	  }, {
	    key: 'quadraticCurveTo',
	    value: function quadraticCurveTo(x1, y1, x, y) {
	      return this.vexFlowCanvasContext.quadraticCurveTo(x1, y1, x, y);
	    }
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	
	  }, {
	    key: 'arc',
	    value: function arc(x, y, radius, startAngle, endAngle, antiClockwise) {
	      return this.vexFlowCanvasContext.arc(x, y, radius, startAngle, endAngle, antiClockwise);
	    }
	
	    // Adapted from the source for Raphael's Element.glow
	
	  }, {
	    key: 'glow',
	    value: function glow() {
	      return this.vexFlowCanvasContext.glow();
	    }
	  }, {
	    key: 'fill',
	    value: function fill() {
	      return this.vexFlowCanvasContext.fill();
	    }
	  }, {
	    key: 'stroke',
	    value: function stroke() {
	      return this.vexFlowCanvasContext.stroke();
	    }
	  }, {
	    key: 'closePath',
	    value: function closePath() {
	      return this.vexFlowCanvasContext.closePath();
	    }
	  }, {
	    key: 'measureText',
	    value: function measureText(text) {
	      return this.vexFlowCanvasContext.measureText(text);
	    }
	  }, {
	    key: 'fillText',
	    value: function fillText(text, x, y) {
	      return this.vexFlowCanvasContext.fillText(text, x, y);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      return this.vexFlowCanvasContext.save();
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      return this.vexFlowCanvasContext.restore();
	    }
	  }]);

	  return CanvasContext;
	}();

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// A rendering context for the Raphael backend.
	//
	// ## Warning: Deprecated for SVGContext
	// Except in instances where SVG support for IE < 9.0 is
	// needed, SVGContext is recommended.
	
	var RaphaelContext = exports.RaphaelContext = function () {
	  function RaphaelContext(element) {
	    _classCallCheck(this, RaphaelContext);
	
	    this.element = element;
	    this.paper = Raphael(element); // eslint-disable-line
	    this.path = '';
	    this.pen = { x: 0, y: 0 };
	    this.lineWidth = 1.0;
	    this.state = {
	      scale: { x: 1, y: 1 },
	      font_family: 'Arial',
	      font_size: 8,
	      font_weight: 800
	    };
	
	    this.attributes = {
	      'stroke-width': 0.3,
	      'fill': 'black',
	      'stroke': 'black',
	      'font': '10pt Arial'
	    };
	
	    this.background_attributes = {
	      'stroke-width': 0,
	      'fill': 'white',
	      'stroke': 'white',
	      'font': '10pt Arial'
	    };
	
	    this.shadow_attributes = {
	      width: 0,
	      color: 'black'
	    };
	
	    this.state_stack = [];
	  }
	
	  // Containers not implemented
	
	
	  _createClass(RaphaelContext, [{
	    key: 'openGroup',
	    value: function openGroup() {}
	  }, {
	    key: 'closeGroup',
	    value: function closeGroup() {}
	  }, {
	    key: 'add',
	    value: function add() {}
	  }, {
	    key: 'setFont',
	    value: function setFont(family, size, weight) {
	      this.state.font_family = family;
	      this.state.font_size = size;
	      this.state.font_weight = weight;
	      this.attributes.font = (this.state.font_weight || '') + ' ' + this.state.font_size * this.state.scale.x + 'pt ' + this.state.font_family;
	      return this;
	    }
	  }, {
	    key: 'setRawFont',
	    value: function setRawFont(font) {
	      this.attributes.font = font;
	      return this;
	    }
	  }, {
	    key: 'setFillStyle',
	    value: function setFillStyle(style) {
	      this.attributes.fill = style;
	      return this;
	    }
	  }, {
	    key: 'setBackgroundFillStyle',
	    value: function setBackgroundFillStyle(style) {
	      this.background_attributes.fill = style;
	      this.background_attributes.stroke = style;
	      return this;
	    }
	  }, {
	    key: 'setStrokeStyle',
	    value: function setStrokeStyle(style) {
	      this.attributes.stroke = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowColor',
	    value: function setShadowColor(style) {
	      this.shadow_attributes.color = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowBlur',
	    value: function setShadowBlur(blur) {
	      this.shadow_attributes.width = blur;
	      return this;
	    }
	  }, {
	    key: 'setLineWidth',
	    value: function setLineWidth(width) {
	      this.attributes['stroke-width'] = width;
	      this.lineWidth = width;
	    }
	
	    // Empty because there is no equivalent in SVG
	
	  }, {
	    key: 'setLineDash',
	    value: function setLineDash() {
	      return this;
	    }
	  }, {
	    key: 'setLineCap',
	    value: function setLineCap() {
	      return this;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(x, y) {
	      this.state.scale = { x: x, y: y };
	      // The scale() method is deprecated as of Raphael.JS 2.0, and
	      // can no longer be used as an option in an Element.attr() call.
	      // It is preserved here for users running earlier versions of
	      // Raphael.JS, though it has no effect on the SVG output in
	      // Raphael 2 and higher.
	      this.attributes.transform = 'S' + x + ',' + y + ',0,0';
	      this.attributes.scale = x + ',' + y + ',0,0';
	      this.attributes.font = this.state.font_size * this.state.scale.x + 'pt ' + this.state.font_family;
	      this.background_attributes.transform = 'S' + x + ',' + y + ',0,0';
	      this.background_attributes.font = this.state.font_size * this.state.scale.x + 'pt ' + this.state.font_family;
	      return this;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.paper.clear();
	    }
	  }, {
	    key: 'resize',
	    value: function resize(width, height) {
	      this.element.style.width = width;
	      this.paper.setSize(width, height);
	      return this;
	    }
	
	    // Sets the SVG `viewBox` property, which results in auto scaling images when its container
	    // is resized.
	    //
	    // Usage: `ctx.setViewBox("0 0 600 400")`
	
	  }, {
	    key: 'setViewBox',
	    value: function setViewBox(viewBox) {
	      this.paper.canvas.setAttribute('viewBox', viewBox);
	    }
	  }, {
	    key: 'rect',
	    value: function rect(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).attr(this.attributes).attr('fill', 'none').attr('stroke-width', this.lineWidth);
	      return this;
	    }
	  }, {
	    key: 'fillRect',
	    value: function fillRect(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).attr(this.attributes);
	      return this;
	    }
	  }, {
	    key: 'clearRect',
	    value: function clearRect(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).attr(this.background_attributes);
	      return this;
	    }
	  }, {
	    key: 'beginPath',
	    value: function beginPath() {
	      this.path = '';
	      this.pen.x = 0;
	      this.pen.y = 0;
	      return this;
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(x, y) {
	      this.path += 'M' + x + ',' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'lineTo',
	    value: function lineTo(x, y) {
	      this.path += 'L' + x + ',' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'bezierCurveTo',
	    value: function bezierCurveTo(x1, y1, x2, y2, x, y) {
	      this.path += 'C' + x1 + ',' + y1 + ',' + x2 + ',' + y2 + ',' + x + ',' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'quadraticCurveTo',
	    value: function quadraticCurveTo(x1, y1, x, y) {
	      this.path += 'Q' + x1 + ',' + y1 + ',' + x + ',' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	
	  }, {
	    key: 'arc',
	    value: function arc(x, y, radius, startAngle, endAngle, antiClockwise) {
	      function normalizeAngle(angle) {
	        while (angle < 0) {
	          angle += Math.PI * 2;
	        }
	
	        while (angle > Math.PI * 2) {
	          angle -= Math.PI * 2;
	        }
	        return angle;
	      }
	
	      startAngle = normalizeAngle(startAngle);
	      endAngle = normalizeAngle(endAngle);
	
	      if (startAngle > endAngle) {
	        var tmp = startAngle;
	        startAngle = endAngle;
	        endAngle = tmp;
	        antiClockwise = !antiClockwise;
	      }
	
	      var delta = endAngle - startAngle;
	
	      if (delta > Math.PI) {
	        this.arcHelper(x, y, radius, startAngle, startAngle + delta / 2, antiClockwise);
	        this.arcHelper(x, y, radius, startAngle + delta / 2, endAngle, antiClockwise);
	      } else {
	        this.arcHelper(x, y, radius, startAngle, endAngle, antiClockwise);
	      }
	      return this;
	    }
	  }, {
	    key: 'arcHelper',
	    value: function arcHelper(x, y, radius, startAngle, endAngle, antiClockwise) {
	      var x1 = x + radius * Math.cos(startAngle);
	      var y1 = y + radius * Math.sin(startAngle);
	
	      var x2 = x + radius * Math.cos(endAngle);
	      var y2 = y + radius * Math.sin(endAngle);
	
	      var largeArcFlag = 0;
	      var sweepFlag = 0;
	      if (antiClockwise) {
	        sweepFlag = 1;
	        if (endAngle - startAngle < Math.PI) {
	          largeArcFlag = 1;
	        }
	      } else if (endAngle - startAngle > Math.PI) {
	        largeArcFlag = 1;
	      }
	
	      this.path += 'M' + x1 + ',' + y1 + ',A' + radius + ',' + radius + ',0,' + largeArcFlag + ',' + sweepFlag + ',' + x2 + ',' + y2 + 'M' + this.pen.x + ',' + this.pen.y;
	    }
	
	    // Adapted from the source for Raphael's Element.glow
	
	  }, {
	    key: 'glow',
	    value: function glow() {
	      var out = this.paper.set();
	      if (this.shadow_attributes.width > 0) {
	        var sa = this.shadow_attributes;
	        var num_paths = sa.width / 2;
	        for (var i = 1; i <= num_paths; i++) {
	          out.push(this.paper.path(this.path).attr({
	            stroke: sa.color,
	            'stroke-linejoin': 'round',
	            'stroke-linecap': 'round',
	            'stroke-width': +(sa.width / num_paths * i).toFixed(3),
	            opacity: +((sa.opacity || 0.3) / num_paths).toFixed(3),
	            // See note in this.scale(): In Raphael the scale() method
	            // is deprecated and removed as of Raphael 2.0 and replaced
	            // by the transform() method.  It is preserved here for
	            // users with earlier versions of Raphael, but has no effect
	            // on the output SVG in Raphael 2.0+.
	            transform: this.attributes.transform,
	            scale: this.attributes.scale
	          }));
	        }
	      }
	      return out;
	    }
	  }, {
	    key: 'fill',
	    value: function fill() {
	      var elem = this.paper.path(this.path).attr(this.attributes).attr('stroke-width', 0);
	      this.glow(elem);
	      return this;
	    }
	  }, {
	    key: 'stroke',
	    value: function stroke() {
	      // The first line of code below is, unfortunately, a bit of a hack:
	      // Raphael's transform() scaling does not scale the stroke-width, so
	      // in order to scale a stroke, we have to manually scale the
	      // stroke-width.
	      //
	      // This works well so long as the X & Y states for this.scale() are
	      // relatively similar.  However, if they are very different, we
	      // would expect horizontal and vertical lines to have different
	      // stroke-widths.
	      //
	      // In the future, if we want to support very divergent values for
	      // horizontal and vertical scaling, we may want to consider
	      // implementing SVG scaling with properties of the SVG viewBox &
	      // viewPort and removing it entirely from the Element.attr() calls.
	      // This would more closely parallel the approach taken in
	      // canvascontext.js as well.
	
	      var strokeWidth = this.lineWidth * (this.state.scale.x + this.state.scale.y) / 2;
	      var elem = this.paper.path(this.path).attr(this.attributes).attr('fill', 'none').attr('stroke-width', strokeWidth);
	      this.glow(elem);
	      return this;
	    }
	  }, {
	    key: 'closePath',
	    value: function closePath() {
	      this.path += 'Z';
	      return this;
	    }
	  }, {
	    key: 'measureText',
	    value: function measureText(text) {
	      var txt = this.paper.text(0, 0, text).attr(this.attributes).attr('fill', 'none').attr('stroke', 'none');
	      var bounds = txt.getBBox();
	      txt.remove();
	
	      return {
	        width: bounds.width,
	        height: bounds.height
	      };
	    }
	  }, {
	    key: 'fillText',
	    value: function fillText(text, x, y) {
	      this.paper.text(x + this.measureText(text).width / 2, y - this.state.font_size / (2.25 * this.state.scale.y), text).attr(this.attributes);
	
	      return this;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      // TODO(mmuthanna): State needs to be deep-copied.
	      this.state_stack.push({
	        state: {
	          font_family: this.state.font_family
	        },
	        attributes: {
	          font: this.attributes.font,
	          fill: this.attributes.fill,
	          stroke: this.attributes.stroke,
	          'stroke-width': this.attributes['stroke-width']
	        },
	        shadow_attributes: {
	          width: this.shadow_attributes.width,
	          color: this.shadow_attributes.color
	        }
	      });
	      return this;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      // TODO(0xfe): State needs to be deep-restored.
	      var state = this.state_stack.pop();
	      this.state.font_family = state.state.font_family;
	      this.attributes.font = state.attributes.font;
	      this.attributes.fill = state.attributes.fill;
	      this.attributes.stroke = state.attributes.stroke;
	      this.attributes['stroke-width'] = state.attributes['stroke-width'];
	      this.shadow_attributes.width = state.shadow_attributes.width;
	      this.shadow_attributes.color = state.shadow_attributes.color;
	      return this;
	    }
	  }]);

	  return RaphaelContext;
	}();

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Gregory Ristow (2015)
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SVGContext = exports.SVGContext = function () {
	  function SVGContext(element) {
	    _classCallCheck(this, SVGContext);
	
	    // element is the parent DOM object
	    this.element = element;
	    // Create the SVG in the SVG namespace:
	    this.svgNS = 'http://www.w3.org/2000/svg';
	    var svg = this.create('svg');
	    // Add it to the canvas:
	    this.element.appendChild(svg);
	
	    // Point to it:
	    this.svg = svg;
	    this.groups = [this.svg]; // Create the group stack
	    this.parent = this.svg;
	
	    this.path = '';
	    this.pen = { x: 0, y: 0 };
	    this.lineWidth = 1.0;
	    this.state = {
	      scale: { x: 1, y: 1 },
	      'font-family': 'Arial',
	      'font-size': '8pt',
	      'font-weight': 'normal'
	    };
	
	    this.attributes = {
	      'stroke-width': 0.3,
	      'fill': 'black',
	      'stroke': 'black',
	      'stroke-dasharray': 'none',
	      'font-family': 'Arial',
	      'font-size': '10pt',
	      'font-weight': 'normal',
	      'font-style': 'normal'
	    };
	
	    this.background_attributes = {
	      'stroke-width': 0,
	      'fill': 'white',
	      'stroke': 'white',
	      'stroke-dasharray': 'none',
	      'font-family': 'Arial',
	      'font-size': '10pt',
	      'font-weight': 'normal',
	      'font-style': 'normal'
	    };
	
	    this.shadow_attributes = {
	      width: 0,
	      color: 'black'
	    };
	
	    this.state_stack = [];
	
	    // Test for Internet Explorer
	    this.iePolyfill();
	  }
	
	  _createClass(SVGContext, [{
	    key: 'create',
	    value: function create(svgElementType) {
	      return document.createElementNS(this.svgNS, svgElementType);
	    }
	
	    // Allow grouping elements in containers for interactivity.
	
	  }, {
	    key: 'openGroup',
	    value: function openGroup(cls, id, attrs) {
	      var group = this.create('g');
	      this.groups.push(group);
	      this.parent.appendChild(group);
	      this.parent = group;
	      if (cls) group.setAttribute('class', _vex.Vex.Prefix(cls));
	      if (id) group.setAttribute('id', _vex.Vex.Prefix(id));
	
	      if (attrs && attrs.pointerBBox) {
	        group.setAttribute('pointer-events', 'bounding-box');
	      }
	      return group;
	    }
	  }, {
	    key: 'closeGroup',
	    value: function closeGroup() {
	      this.groups.pop();
	      this.parent = this.groups[this.groups.length - 1];
	    }
	  }, {
	    key: 'add',
	    value: function add(elem) {
	      this.parent.appendChild(elem);
	    }
	
	    // Tests if the browser is Internet Explorer; if it is,
	    // we do some tricks to improve text layout.  See the
	    // note at ieMeasureTextFix() for details.
	
	  }, {
	    key: 'iePolyfill',
	    value: function iePolyfill() {
	      if (typeof navigator !== 'undefined') {
	        this.ie = /MSIE 9/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /rv:11\.0/i.test(navigator.userAgent) || /Trident/i.test(navigator.userAgent);
	      }
	    }
	
	    // ### Styling & State Methods:
	
	  }, {
	    key: 'setFont',
	    value: function setFont(family, size, weight) {
	      // Unlike canvas, in SVG italic is handled by font-style,
	      // not weight. So: we search the weight argument and
	      // apply bold and italic to weight and style respectively.
	      var bold = false;
	      var italic = false;
	      var style = 'normal';
	      // Weight might also be a number (200, 400, etc...) so we
	      // test its type to be sure we have access to String methods.
	      if (typeof weight === 'string') {
	        // look for "italic" in the weight:
	        if (weight.indexOf('italic') !== -1) {
	          weight = weight.replace(/italic/g, '');
	          italic = true;
	        }
	        // look for "bold" in weight
	        if (weight.indexOf('bold') !== -1) {
	          weight = weight.replace(/bold/g, '');
	          bold = true;
	        }
	        // remove any remaining spaces
	        weight = weight.replace(/ /g, '');
	      }
	      weight = bold ? 'bold' : weight;
	      weight = typeof weight === 'undefined' || weight === '' ? 'normal' : weight;
	
	      style = italic ? 'italic' : style;
	
	      var fontAttributes = {
	        'font-family': family,
	        'font-size': size + 'pt',
	        'font-weight': weight,
	        'font-style': style
	      };
	
	      // Store the font size so that if the browser is Internet
	      // Explorer we can fix its calculations of text width.
	      this.fontSize = Number(size);
	
	      _vex.Vex.Merge(this.attributes, fontAttributes);
	      _vex.Vex.Merge(this.state, fontAttributes);
	
	      return this;
	    }
	  }, {
	    key: 'setRawFont',
	    value: function setRawFont(font) {
	      font = font.trim();
	      // Assumes size first, splits on space -- which is presently
	      // how all existing modules are calling this.
	      var fontArray = font.split(' ');
	
	      this.attributes['font-family'] = fontArray[1];
	      this.state['font-family'] = fontArray[1];
	
	      this.attributes['font-size'] = fontArray[0];
	      this.state['font-size'] = fontArray[0];
	
	      // Saves fontSize for IE polyfill
	      this.fontSize = Number(fontArray[0].match(/\d+/));
	      return this;
	    }
	  }, {
	    key: 'setFillStyle',
	    value: function setFillStyle(style) {
	      this.attributes.fill = style;
	      return this;
	    }
	  }, {
	    key: 'setBackgroundFillStyle',
	    value: function setBackgroundFillStyle(style) {
	      this.background_attributes.fill = style;
	      this.background_attributes.stroke = style;
	      return this;
	    }
	  }, {
	    key: 'setStrokeStyle',
	    value: function setStrokeStyle(style) {
	      this.attributes.stroke = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowColor',
	    value: function setShadowColor(style) {
	      this.shadow_attributes.color = style;
	      return this;
	    }
	  }, {
	    key: 'setShadowBlur',
	    value: function setShadowBlur(blur) {
	      this.shadow_attributes.width = blur;
	      return this;
	    }
	  }, {
	    key: 'setLineWidth',
	    value: function setLineWidth(width) {
	      this.attributes['stroke-width'] = width;
	      this.lineWidth = width;
	    }
	
	    // @param array {lineDash} as [dashInt, spaceInt, dashInt, spaceInt, etc...]
	
	  }, {
	    key: 'setLineDash',
	    value: function setLineDash(lineDash) {
	      if (Object.prototype.toString.call(lineDash) === '[object Array]') {
	        lineDash = lineDash.join(', ');
	        this.attributes['stroke-dasharray'] = lineDash;
	        return this;
	      } else {
	        throw new _vex.Vex.RERR('ArgumentError', 'lineDash must be an array of integers.');
	      }
	    }
	  }, {
	    key: 'setLineCap',
	    value: function setLineCap(lineCap) {
	      this.attributes['stroke-linecap'] = lineCap;
	      return this;
	    }
	
	    // ### Sizing & Scaling Methods:
	
	    // TODO (GCR): See note at scale() -- seperate our internal
	    // conception of pixel-based width/height from the style.width
	    // and style.height properties eventually to allow users to
	    // apply responsive sizing attributes to the SVG.
	
	  }, {
	    key: 'resize',
	    value: function resize(width, height) {
	      this.width = width;
	      this.height = height;
	      this.element.style.width = width;
	      var attributes = {
	        width: width,
	        height: height
	      };
	      this.applyAttributes(this.svg, attributes);
	      return this;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(x, y) {
	      // uses viewBox to scale
	      // TODO (GCR): we may at some point want to distinguish the
	      // style.width / style.height properties that are applied to
	      // the SVG object from our internal conception of the SVG
	      // width/height.  This would allow us to create automatically
	      // scaling SVG's that filled their containers, for instance.
	      //
	      // As this isn't implemented in Canvas or Raphael contexts,
	      // I've left as is for now, but in using the viewBox to
	      // handle internal scaling, am trying to make it possible
	      // for us to eventually move in that direction.
	
	      this.state.scale = { x: x, y: y };
	      var visibleWidth = this.width / x;
	      var visibleHeight = this.height / y;
	      this.setViewBox(0, 0, visibleWidth, visibleHeight);
	
	      return this;
	    }
	  }, {
	    key: 'setViewBox',
	    value: function setViewBox() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      // Override for "x y w h" style:
	      if (args.length === 1) {
	        var viewBox = args[0];
	
	        this.svg.setAttribute('viewBox', viewBox);
	      } else {
	        var xMin = args[0];
	        var yMin = args[1];
	        var width = args[2];
	        var height = args[3];
	
	        var viewBoxString = xMin + ' ' + yMin + ' ' + width + ' ' + height;
	        this.svg.setAttribute('viewBox', viewBoxString);
	      }
	    }
	
	    // ### Drawing helper methods:
	
	  }, {
	    key: 'applyAttributes',
	    value: function applyAttributes(element, attributes) {
	      Object.keys(attributes).forEach(function (propertyName) {
	        return element.setAttributeNS(null, propertyName, attributes[propertyName]);
	      });
	
	      return element;
	    }
	
	    // ### Shape & Path Methods:
	
	  }, {
	    key: 'clear',
	    value: function clear() {
	      // Clear the SVG by removing all inner children.
	
	      // (This approach is usually slightly more efficient
	      // than removing the old SVG & adding a new one to
	      // the container element, since it does not cause the
	      // container to resize twice.  Also, the resize
	      // triggered by removing the entire SVG can trigger
	      // a touchcancel event when the element resizes away
	      // from a touch point.)
	
	      while (this.svg.lastChild) {
	        this.svg.removeChild(this.svg.lastChild);
	      }
	
	      // Replace the viewbox attribute we just removed:
	      this.scale(this.state.scale.x, this.state.scale.y);
	    }
	
	    // ## Rectangles:
	
	  }, {
	    key: 'rect',
	    value: function rect(x, y, width, height, attributes) {
	      // Avoid invalid negative height attribs by
	      // flipping the rectangle on its head:
	      if (height < 0) {
	        y += height;
	        height *= -1;
	      }
	
	      // Create the rect & style it:
	      var rectangle = this.create('rect');
	      if (typeof attributes === 'undefined') {
	        attributes = {
	          fill: 'none',
	          'stroke-width': this.lineWidth,
	          stroke: 'black'
	        };
	      }
	
	      _vex.Vex.Merge(attributes, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	
	      this.applyAttributes(rectangle, attributes);
	
	      this.add(rectangle);
	      return this;
	    }
	  }, {
	    key: 'fillRect',
	    value: function fillRect(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height *= -1;
	      }
	
	      this.rect(x, y, width, height, this.attributes);
	      return this;
	    }
	  }, {
	    key: 'clearRect',
	    value: function clearRect(x, y, width, height) {
	      // TODO(GCR): Improve implementation of this...
	      // Currently it draws a box of the background color, rather
	      // than creating alpha through lower z-levels.
	      //
	      // See the implementation of this in SVGKit:
	      // http://sourceforge.net/projects/svgkit/
	      // as a starting point.
	      //
	      // Adding a large number of transform paths (as we would
	      // have to do) could be a real performance hit.  Since
	      // tabNote seems to be the only module that makes use of this
	      // it may be worth creating a seperate tabStave that would
	      // draw lines around locations of tablature fingering.
	      //
	
	      this.rect(x, y, width, height, this.background_attributes);
	      return this;
	    }
	
	    // ## Paths:
	
	  }, {
	    key: 'beginPath',
	    value: function beginPath() {
	      this.path = '';
	      this.pen.x = 0;
	      this.pen.y = 0;
	      return this;
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(x, y) {
	      this.path += 'M' + x + ' ' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'lineTo',
	    value: function lineTo(x, y) {
	      this.path += 'L' + x + ' ' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'bezierCurveTo',
	    value: function bezierCurveTo(x1, y1, x2, y2, x, y) {
	      this.path += 'C' + x1 + ' ' + y1 + ',' + x2 + ' ' + y2 + ',' + x + ' ' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	  }, {
	    key: 'quadraticCurveTo',
	    value: function quadraticCurveTo(x1, y1, x, y) {
	      this.path += 'Q' + x1 + ' ' + y1 + ',' + x + ' ' + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    }
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	
	  }, {
	    key: 'arc',
	    value: function arc(x, y, radius, startAngle, endAngle, antiClockwise) {
	      function normalizeAngle(angle) {
	        while (angle < 0) {
	          angle += Math.PI * 2;
	        }
	
	        while (angle > Math.PI * 2) {
	          angle -= Math.PI * 2;
	        }
	        return angle;
	      }
	
	      startAngle = normalizeAngle(startAngle);
	      endAngle = normalizeAngle(endAngle);
	
	      if (startAngle > endAngle) {
	        var tmp = startAngle;
	        startAngle = endAngle;
	        endAngle = tmp;
	        antiClockwise = !antiClockwise;
	      }
	
	      var delta = endAngle - startAngle;
	
	      if (delta > Math.PI) {
	        this.arcHelper(x, y, radius, startAngle, startAngle + delta / 2, antiClockwise);
	        this.arcHelper(x, y, radius, startAngle + delta / 2, endAngle, antiClockwise);
	      } else {
	        this.arcHelper(x, y, radius, startAngle, endAngle, antiClockwise);
	      }
	      return this;
	    }
	  }, {
	    key: 'arcHelper',
	    value: function arcHelper(x, y, radius, startAngle, endAngle, antiClockwise) {
	      var x1 = x + radius * Math.cos(startAngle);
	      var y1 = y + radius * Math.sin(startAngle);
	
	      var x2 = x + radius * Math.cos(endAngle);
	      var y2 = y + radius * Math.sin(endAngle);
	
	      var largeArcFlag = 0;
	      var sweepFlag = 0;
	      if (antiClockwise) {
	        sweepFlag = 1;
	        if (endAngle - startAngle < Math.PI) {
	          largeArcFlag = 1;
	        }
	      } else if (endAngle - startAngle > Math.PI) {
	        largeArcFlag = 1;
	      }
	
	      this.path += 'M' + x1 + ' ' + y1 + ' A' + radius + ' ' + radius + ' 0 ' + largeArcFlag + ' ' + sweepFlag + ' ' + x2 + ' ' + y2 + 'M' + this.pen.x + ' ' + this.pen.y;
	    }
	  }, {
	    key: 'closePath',
	    value: function closePath() {
	      this.path += 'Z';
	
	      return this;
	    }
	
	    // Adapted from the source for Raphael's Element.glow
	
	  }, {
	    key: 'glow',
	    value: function glow() {
	      // Calculate the width & paths of the glow:
	      if (this.shadow_attributes.width > 0) {
	        var sa = this.shadow_attributes;
	        var num_paths = sa.width / 2;
	        // Stroke at varying widths to create effect of gaussian blur:
	        for (var i = 1; i <= num_paths; i++) {
	          var attributes = {
	            stroke: sa.color,
	            'stroke-linejoin': 'round',
	            'stroke-linecap': 'round',
	            'stroke-width': +(sa.width * 0.4 / num_paths * i).toFixed(3),
	            opacity: +((sa.opacity || 0.3) / num_paths).toFixed(3)
	          };
	
	          var path = this.create('path');
	          attributes.d = this.path;
	          this.applyAttributes(path, attributes);
	          this.add(path);
	        }
	      }
	      return this;
	    }
	  }, {
	    key: 'fill',
	    value: function fill(attributes) {
	      // If our current path is set to glow, make it glow
	      this.glow();
	
	      var path = this.create('path');
	      if (typeof attributes === 'undefined') {
	        attributes = {};
	        _vex.Vex.Merge(attributes, this.attributes);
	        attributes.stroke = 'none';
	      }
	
	      attributes.d = this.path;
	
	      this.applyAttributes(path, attributes);
	      this.add(path);
	      return this;
	    }
	  }, {
	    key: 'stroke',
	    value: function stroke() {
	      // If our current path is set to glow, make it glow.
	      this.glow();
	
	      var path = this.create('path');
	      var attributes = {};
	      _vex.Vex.Merge(attributes, this.attributes);
	      attributes.fill = 'none';
	      attributes['stroke-width'] = this.lineWidth;
	      attributes.d = this.path;
	
	      this.applyAttributes(path, attributes);
	      this.add(path);
	      return this;
	    }
	
	    // ## Text Methods:
	
	  }, {
	    key: 'measureText',
	    value: function measureText(text) {
	      var txt = this.create('text');
	      if (typeof txt.getBBox !== 'function') {
	        return { x: 0, y: 0, width: 0, height: 0 };
	      }
	
	      txt.textContent = text;
	      this.applyAttributes(txt, this.attributes);
	
	      // Temporarily add it to the document for measurement.
	      this.svg.appendChild(txt);
	
	      var bbox = txt.getBBox();
	      if (this.ie && text !== '' && this.attributes['font-style'] === 'italic') {
	        bbox = this.ieMeasureTextFix(bbox, text);
	      }
	
	      this.svg.removeChild(txt);
	      return bbox;
	    }
	  }, {
	    key: 'ieMeasureTextFix',
	    value: function ieMeasureTextFix(bbox) {
	      // Internet Explorer over-pads text in italics,
	      // resulting in giant width estimates for measureText.
	      // To fix this, we use this formula, tested against
	      // ie 11:
	      // overestimate (in pixels) = FontSize(in pt) * 1.196 + 1.96
	      // And then subtract the overestimate from calculated width.
	
	      var fontSize = Number(this.fontSize);
	      var m = 1.196;
	      var b = 1.9598;
	      var widthCorrection = m * fontSize + b;
	      var width = bbox.width - widthCorrection;
	      var height = bbox.height - 1.5;
	
	      // Get non-protected copy:
	      var box = {
	        x: bbox.x,
	        y: bbox.y,
	        width: width,
	        height: height
	      };
	
	      return box;
	    }
	  }, {
	    key: 'fillText',
	    value: function fillText(text, x, y) {
	      var attributes = {};
	      _vex.Vex.Merge(attributes, this.attributes);
	      attributes.stroke = 'none';
	      attributes.x = x;
	      attributes.y = y;
	
	      var txt = this.create('text');
	      txt.textContent = text;
	      this.applyAttributes(txt, attributes);
	      this.add(txt);
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      // TODO(mmuthanna): State needs to be deep-copied.
	      this.state_stack.push({
	        state: {
	          'font-family': this.state['font-family'],
	          'font-weight': this.state['font-weight'],
	          'font-style': this.state['font-style'],
	          'font-size': this.state['font-size']
	        },
	        attributes: {
	          'font-family': this.attributes['font-family'],
	          'font-weight': this.attributes['font-weight'],
	          'font-style': this.attributes['font-style'],
	          'font-size': this.attributes['font-size'],
	          fill: this.attributes.fill,
	          stroke: this.attributes.stroke,
	          'stroke-width': this.attributes['stroke-width'],
	          'stroke-dasharray': this.attributes['stroke-dasharray']
	        },
	        shadow_attributes: {
	          width: this.shadow_attributes.width,
	          color: this.shadow_attributes.color
	        }
	      });
	      return this;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      // TODO(0xfe): State needs to be deep-restored.
	      var state = this.state_stack.pop();
	      this.state['font-family'] = state.state['font-family'];
	      this.state['font-weight'] = state.state['font-weight'];
	      this.state['font-style'] = state.state['font-style'];
	      this.state['font-size'] = state.state['font-size'];
	
	      this.attributes['font-family'] = state.attributes['font-family'];
	      this.attributes['font-weight'] = state.attributes['font-weight'];
	      this.attributes['font-style'] = state.attributes['font-style'];
	      this.attributes['font-size'] = state.attributes['font-size'];
	
	      this.attributes.fill = state.attributes.fill;
	      this.attributes.stroke = state.attributes.stroke;
	      this.attributes['stroke-width'] = state.attributes['stroke-width'];
	      this.attributes['stroke-dasharray'] = state.attributes['stroke-dasharray'];
	
	      this.shadow_attributes.width = state.shadow_attributes.width;
	      this.shadow_attributes.color = state.shadow_attributes.color;
	      return this;
	    }
	  }]);

	  return SVGContext;
	}();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Formatter = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the formatting and layout algorithms that are used
	// to position notes in a voice. The algorithm can align multiple voices both
	// within a stave, and across multiple staves.
	//
	// To do this, the formatter breaks up voices into a grid of rational-valued
	// `ticks`, to which each note is assigned. Then, minimum widths are assigned
	// to each tick based on the widths of the notes and modifiers in that tick. This
	// establishes the smallest amount of space required for each tick.
	//
	// Finally, the formatter distributes the left over space proportionally to
	// all the ticks, setting the `x` values of the notes in each tick.
	//
	// See `tests/formatter_tests.js` for usage examples. The helper functions included
	// here (`FormatAndDraw`, `FormatAndDrawTab`) also serve as useful usage examples.
	
	var _vex = __webpack_require__(1);
	
	var _beam = __webpack_require__(15);
	
	var _tables = __webpack_require__(2);
	
	var _fraction = __webpack_require__(3);
	
	var _voice = __webpack_require__(18);
	
	var _staveconnector = __webpack_require__(19);
	
	var _stavenote = __webpack_require__(20);
	
	var _note = __webpack_require__(22);
	
	var _modifiercontext = __webpack_require__(27);
	
	var _tickcontext = __webpack_require__(39);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// To enable logging for this class. Set `Vex.Flow.Formatter.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Formatter.DEBUG) _vex.Vex.L('Vex.Flow.Formatter', args);
	}
	
	// Helper function to locate the next non-rest note(s).
	function lookAhead(notes, restLine, i, compare) {
	  // If no valid next note group, nextRestLine is same as current.
	  var nextRestLine = restLine;
	
	  // Get the rest line for next valid non-rest note group.
	  for (i += 1; i < notes.length; i += 1) {
	    var note = notes[i];
	    if (!note.isRest() && !note.shouldIgnoreTicks()) {
	      nextRestLine = note.getLineForRest();
	      break;
	    }
	  }
	
	  // Locate the mid point between two lines.
	  if (compare && restLine !== nextRestLine) {
	    var top = Math.max(restLine, nextRestLine);
	    var bot = Math.min(restLine, nextRestLine);
	    nextRestLine = _vex.Vex.MidLine(top, bot);
	  }
	  return nextRestLine;
	}
	
	// Take an array of `voices` and place aligned tickables in the same context. Returns
	// a mapping from `tick` to `ContextType`, a list of `tick`s, and the resolution
	// multiplier.
	//
	// Params:
	// * `voices`: Array of `Voice` instances.
	// * `ContextType`: A context class (e.g., `ModifierContext`, `TickContext`)
	// * `addToContext`: Function to add tickable to context.
	function createContexts(voices, ContextType, addToContext) {
	  if (!voices || !voices.length) {
	    throw new _vex.Vex.RERR('BadArgument', 'No voices to format');
	  }
	
	  // Find out highest common multiple of resolution multipliers.
	  // The purpose of this is to find out a common denominator
	  // for all fractional tick values in all tickables of all voices,
	  // so that the values can be expanded and the numerator used
	  // as an integer tick value.
	  var totalTicks = voices[0].getTotalTicks();
	  var resolutionMultiplier = voices.reduce(function (resolutionMultiplier, voice) {
	    if (!voice.getTotalTicks().equals(totalTicks)) {
	      throw new _vex.Vex.RERR('TickMismatch', 'Voices should have same total note duration in ticks.');
	    }
	
	    if (voice.getMode() === _voice.Voice.Mode.STRICT && !voice.isComplete()) {
	      throw new _vex.Vex.RERR('IncompleteVoice', 'Voice does not have enough notes.');
	    }
	
	    return Math.max(resolutionMultiplier, _fraction.Fraction.LCM(resolutionMultiplier, voice.getResolutionMultiplier()));
	  }, 1);
	
	  // Initialize tick maps.
	  var tickToContextMap = {};
	  var tickList = [];
	  var contexts = [];
	
	  // For each voice, extract notes and create a context for every
	  // new tick that hasn't been seen before.
	  voices.forEach(function (voice) {
	    // Use resolution multiplier as denominator to expand ticks
	    // to suitable integer values, so that no additional expansion
	    // of fractional tick values is needed.
	    var ticksUsed = new _fraction.Fraction(0, resolutionMultiplier);
	
	    voice.getTickables().forEach(function (tickable) {
	      var integerTicks = ticksUsed.numerator;
	
	      // If we have no tick context for this tick, create one.
	      if (!tickToContextMap[integerTicks]) {
	        var newContext = new ContextType();
	        contexts.push(newContext);
	        tickToContextMap[integerTicks] = newContext;
	      }
	
	      // Add this tickable to the TickContext.
	      addToContext(tickable, tickToContextMap[integerTicks]);
	
	      // Maintain a sorted list of tick contexts.
	      tickList.push(integerTicks);
	      ticksUsed.add(tickable.getTicks());
	    });
	  });
	
	  return {
	    map: tickToContextMap,
	    array: contexts,
	    list: _vex.Vex.SortAndUnique(tickList, function (a, b) {
	      return a - b;
	    }, function (a, b) {
	      return a === b;
	    }),
	    resolutionMultiplier: resolutionMultiplier
	  };
	}
	
	var Formatter = exports.Formatter = function () {
	  _createClass(Formatter, null, [{
	    key: 'SimpleFormat',
	
	    // Helper function to layout "notes" one after the other without
	    // regard for proportions. Useful for tests and debugging.
	    value: function SimpleFormat(notes) {
	      var x = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	      var _ref$paddingBetween = _ref.paddingBetween;
	      var paddingBetween = _ref$paddingBetween === undefined ? 10 : _ref$paddingBetween;
	
	      notes.reduce(function (x, note) {
	        note.addToModifierContext(new _modifiercontext.ModifierContext());
	        var tick = new _tickcontext.TickContext().addTickable(note).preFormat();
	        var extra = tick.getExtraPx();
	        tick.setX(x + extra.left);
	
	        return x + tick.getWidth() + extra.right + paddingBetween;
	      }, x);
	    }
	
	    // Helper function to plot formatter debug info.
	
	  }, {
	    key: 'plotDebugging',
	    value: function plotDebugging(ctx, formatter, xPos, y1, y2) {
	      var x = xPos + _note.Note.STAVEPADDING;
	      var contextGaps = formatter.contextGaps;
	      function stroke(x1, x2, color) {
	        ctx.beginPath();
	        ctx.setStrokeStyle(color);
	        ctx.setFillStyle(color);
	        ctx.setLineWidth(1);
	        ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
	      }
	
	      ctx.save();
	      ctx.setFont('Arial', 8, '');
	
	      contextGaps.gaps.forEach(function (gap) {
	        stroke(x + gap.x1, x + gap.x2, '#aaa');
	        // Vex.drawDot(ctx, xPos + gap.x1, yPos, 'blue');
	        ctx.fillText(Math.round(gap.x2 - gap.x1), x + gap.x1, y2 + 12);
	      });
	
	      ctx.fillText(Math.round(contextGaps.total) + 'px', x - 20, y2 + 12);
	      ctx.setFillStyle('red');
	
	      ctx.fillText('Loss: ' + formatter.lossHistory.map(function (loss) {
	        return Math.round(loss);
	      }), x - 20, y2 + 22);
	      ctx.restore();
	    }
	
	    // Helper function to format and draw a single voice. Returns a bounding
	    // box for the notation.
	    //
	    // Parameters:
	    // * `ctx` - The rendering context
	    // * `stave` - The stave to which to draw (`Stave` or `TabStave`)
	    // * `notes` - Array of `Note` instances (`StaveNote`, `TextNote`, `TabNote`, etc.)
	    // * `params` - One of below:
	    //    * Setting `autobeam` only `(context, stave, notes, true)` or
	    //      `(ctx, stave, notes, {autobeam: true})`
	    //    * Setting `align_rests` a struct is needed `(context, stave, notes, {align_rests: true})`
	    //    * Setting both a struct is needed `(context, stave, notes, {
	    //      autobeam: true, align_rests: true})`
	    //
	    // `autobeam` automatically generates beams for the notes.
	    // `align_rests` aligns rests with nearby notes.
	
	  }, {
	    key: 'FormatAndDraw',
	    value: function FormatAndDraw(ctx, stave, notes, params) {
	      var options = {
	        auto_beam: false,
	        align_rests: false
	      };
	
	      if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	        _vex.Vex.Merge(options, params);
	      } else if (typeof params === 'boolean') {
	        options.auto_beam = params;
	      }
	
	      // Start by creating a voice and adding all the notes to it.
	      var voice = new _voice.Voice(_tables.Flow.TIME4_4).setMode(_voice.Voice.Mode.SOFT).addTickables(notes);
	
	      // Then create beams, if requested.
	      var beams = options.auto_beam ? _beam.Beam.applyAndGetBeams(voice) : [];
	
	      // Instantiate a `Formatter` and format the notes.
	      new Formatter().joinVoices([voice], { align_rests: options.align_rests }).formatToStave([voice], stave, { align_rests: options.align_rests, stave: stave });
	
	      // Render the voice and beams to the stave.
	      voice.setStave(stave).draw(ctx, stave);
	      beams.forEach(function (beam) {
	        return beam.setContext(ctx).draw();
	      });
	
	      // Return the bounding box of the voice.
	      return voice.getBoundingBox();
	    }
	
	    // Helper function to format and draw aligned tab and stave notes in two
	    // separate staves.
	    //
	    // Parameters:
	    // * `ctx` - The rendering context
	    // * `tabstave` - A `TabStave` instance on which to render `TabNote`s.
	    // * `stave` - A `Stave` instance on which to render `Note`s.
	    // * `notes` - Array of `Note` instances for the stave (`StaveNote`, `BarNote`, etc.)
	    // * `tabnotes` - Array of `Note` instances for the tab stave (`TabNote`, `BarNote`, etc.)
	    // * `autobeam` - Automatically generate beams.
	    // * `params` - A configuration object:
	    //    * `autobeam` automatically generates beams for the notes.
	    //    * `align_rests` aligns rests with nearby notes.
	
	  }, {
	    key: 'FormatAndDrawTab',
	    value: function FormatAndDrawTab(ctx, tabstave, stave, tabnotes, notes, autobeam, params) {
	      var opts = {
	        auto_beam: autobeam,
	        align_rests: false
	      };
	
	      if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	        _vex.Vex.Merge(opts, params);
	      } else if (typeof params === 'boolean') {
	        opts.auto_beam = params;
	      }
	
	      // Create a `4/4` voice for `notes`.
	      var notevoice = new _voice.Voice(_tables.Flow.TIME4_4).setMode(_voice.Voice.Mode.SOFT).addTickables(notes);
	
	      // Create a `4/4` voice for `tabnotes`.
	      var tabvoice = new _voice.Voice(_tables.Flow.TIME4_4).setMode(_voice.Voice.Mode.SOFT).addTickables(tabnotes);
	
	      // Then create beams, if requested.
	      var beams = opts.auto_beam ? _beam.Beam.applyAndGetBeams(notevoice) : [];
	
	      // Instantiate a `Formatter` and align tab and stave notes.
	      new Formatter().joinVoices([notevoice], { align_rests: opts.align_rests }).joinVoices([tabvoice]).formatToStave([notevoice, tabvoice], stave, { align_rests: opts.align_rests });
	
	      // Render voices and beams to staves.
	      notevoice.draw(ctx, stave);
	      tabvoice.draw(ctx, tabstave);
	      beams.forEach(function (beam) {
	        return beam.setContext(ctx).draw();
	      });
	
	      // Draw a connector between tab and note staves.
	      new _staveconnector.StaveConnector(stave, tabstave).setContext(ctx).draw();
	    }
	
	    // Auto position rests based on previous/next note positions.
	    //
	    // Params:
	    // * `notes`: An array of notes.
	    // * `alignAllNotes`: If set to false, only aligns non-beamed notes.
	    // * `alignTuplets`: If set to false, ignores tuplets.
	
	  }, {
	    key: 'AlignRestsToNotes',
	    value: function AlignRestsToNotes(notes, alignAllNotes, alignTuplets) {
	      notes.forEach(function (note, index) {
	        if (note instanceof _stavenote.StaveNote && note.isRest()) {
	          if (note.tuplet && !alignTuplets) return;
	
	          // If activated rests not on default can be rendered as specified.
	          var position = note.getGlyph().position.toUpperCase();
	          if (position !== 'R/4' && position !== 'B/4') return;
	
	          if (alignAllNotes || note.beam != null) {
	            // Align rests with previous/next notes.
	            var props = note.getKeyProps()[0];
	            if (index === 0) {
	              props.line = lookAhead(notes, props.line, index, false);
	              note.setKeyLine(0, props.line);
	            } else if (index > 0 && index < notes.length) {
	              // If previous note is a rest, use its line number.
	              var restLine = void 0;
	              if (notes[index - 1].isRest()) {
	                restLine = notes[index - 1].getKeyProps()[0].line;
	                props.line = restLine;
	              } else {
	                restLine = notes[index - 1].getLineForRest();
	                // Get the rest line for next valid non-rest note group.
	                props.line = lookAhead(notes, restLine, index, true);
	              }
	              note.setKeyLine(0, props.line);
	            }
	          }
	        }
	      });
	
	      return this;
	    }
	  }]);
	
	  function Formatter() {
	    _classCallCheck(this, Formatter);
	
	    // Minimum width required to render all the notes in the voices.
	    this.minTotalWidth = 0;
	
	    // This is set to `true` after `minTotalWidth` is calculated.
	    this.hasMinTotalWidth = false;
	
	    // Total number of ticks in the voice.
	    this.totalTicks = new _fraction.Fraction(0, 1);
	
	    // Arrays of tick and modifier contexts.
	    this.tickContexts = null;
	    this.modiferContexts = null;
	
	    // Gaps between contexts, for free movement of notes post
	    // formatting.
	    this.contextGaps = {
	      total: 0,
	      gaps: []
	    };
	
	    this.voices = [];
	  }
	
	  // Find all the rests in each of the `voices` and align them
	  // to neighboring notes. If `alignAllNotes` is `false`, then only
	  // align non-beamed notes.
	
	
	  _createClass(Formatter, [{
	    key: 'alignRests',
	    value: function alignRests(voices, alignAllNotes) {
	      if (!voices || !voices.length) {
	        throw new _vex.Vex.RERR('BadArgument', 'No voices to format rests');
	      }
	
	      voices.forEach(function (voice) {
	        return Formatter.AlignRestsToNotes(voice.getTickables(), alignAllNotes);
	      });
	    }
	
	    // Calculate the minimum width required to align and format `voices`.
	
	  }, {
	    key: 'preCalculateMinTotalWidth',
	    value: function preCalculateMinTotalWidth(voices) {
	      // Cache results.
	      if (this.hasMinTotalWidth) return this.minTotalWidth;
	
	      // Create tick contexts if not already created.
	      if (!this.tickContexts) {
	        if (!voices) {
	          throw new _vex.Vex.RERR('BadArgument', "'voices' required to run preCalculateMinTotalWidth");
	        }
	
	        this.createTickContexts(voices);
	      }
	
	      var _tickContexts = this.tickContexts;
	      var contextList = _tickContexts.list;
	      var contextMap = _tickContexts.map;
	
	      // Go through each tick context and calculate total width.
	
	      this.minTotalWidth = contextList.map(function (tick) {
	        var context = contextMap[tick];
	        context.preFormat();
	        return context.getWidth();
	      }).reduce(function (a, b) {
	        return a + b;
	      }, 0);
	
	      this.hasMinTotalWidth = true;
	
	      return this.minTotalWidth;
	    }
	
	    // Get minimum width required to render all voices. Either `format` or
	    // `preCalculateMinTotalWidth` must be called before this method.
	
	  }, {
	    key: 'getMinTotalWidth',
	    value: function getMinTotalWidth() {
	      if (!this.hasMinTotalWidth) {
	        throw new _vex.Vex.RERR('NoMinTotalWidth', "Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");
	      }
	
	      return this.minTotalWidth;
	    }
	
	    // Create `ModifierContext`s for each tick in `voices`.
	
	  }, {
	    key: 'createModifierContexts',
	    value: function createModifierContexts(voices) {
	      var contexts = createContexts(voices, _modifiercontext.ModifierContext, function (tickable, context) {
	        return tickable.addToModifierContext(context);
	      });
	
	      this.modiferContexts = contexts;
	      return contexts;
	    }
	
	    // Create `TickContext`s for each tick in `voices`. Also calculate the
	    // total number of ticks in voices.
	
	  }, {
	    key: 'createTickContexts',
	    value: function createTickContexts(voices) {
	      var contexts = createContexts(voices, _tickcontext.TickContext, function (tickable, context) {
	        return context.addTickable(tickable);
	      });
	
	      contexts.array.forEach(function (context) {
	        context.tContexts = contexts.array;
	      });
	
	      this.totalTicks = voices[0].getTicksUsed().clone();
	      this.tickContexts = contexts;
	      return contexts;
	    }
	
	    // This is the core formatter logic. Format voices and justify them
	    // to `justifyWidth` pixels. `renderingContext` is required to justify elements
	    // that can't retreive widths without a canvas. This method sets the `x` positions
	    // of all the tickables/notes in the formatter.
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      var justifyWidth = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	      var renderingContext = arguments[1];
	
	      var _this = this;
	
	      var voices = arguments[2];
	      var stave = arguments[3];
	
	      // Initialize context maps.
	      var contexts = this.tickContexts;
	      var contextList = contexts.list;
	      var contextMap = contexts.map;
	      var resolutionMultiplier = contexts.resolutionMultiplier;
	
	      // If voices and a stave were provided, set the Stave for each voice
	      // and preFormat to apply Y values to the notes;
	
	      if (voices && stave) {
	        voices.forEach(function (voice) {
	          return voice.setStave(stave).preFormat();
	        });
	      }
	
	      // Now distribute the ticks to each tick context, and assign them their
	      // own X positions.
	      var x = 0;
	      var shift = 0;
	      var centerX = justifyWidth / 2;
	      this.minTotalWidth = 0;
	
	      // Pass 1: Give each note maximum width requested by context.
	      contextList.forEach(function (tick) {
	        var context = contextMap[tick];
	        if (renderingContext) context.setContext(renderingContext);
	
	        // Make sure that all tickables in this context have calculated their
	        // space requirements.
	        context.preFormat();
	
	        var width = context.getWidth();
	        _this.minTotalWidth += width;
	
	        var metrics = context.getMetrics();
	        x = x + shift + metrics.extraLeftPx;
	        context.setX(x);
	
	        // Calculate shift for the next tick.
	        shift = width - metrics.extraLeftPx;
	      });
	
	      this.minTotalWidth = x + shift;
	      this.hasMinTotalWidth = true;
	
	      // No justification needed. End formatting.
	      if (justifyWidth <= 0) return;
	
	      // Pass 2: Take leftover width, and distribute it to proportionately to
	      // all notes.
	      var remainingX = justifyWidth - this.minTotalWidth;
	      var leftoverPxPerTick = remainingX / (this.totalTicks.value() * resolutionMultiplier);
	      var spaceAccum = 0;
	
	      contextList.forEach(function (tick, index) {
	        var prevTick = contextList[index - 1] || 0;
	        var context = contextMap[tick];
	        var tickSpace = (tick - prevTick) * leftoverPxPerTick;
	
	        spaceAccum += tickSpace;
	        context.setX(context.getX() + spaceAccum);
	
	        // Move center aligned tickables to middle
	        context.getCenterAlignedTickables().forEach(function (tickable) {
	          // eslint-disable-line
	          tickable.center_x_shift = centerX - context.getX();
	        });
	      });
	
	      // Just one context. Done formatting.
	      if (contextList.length === 1) return;
	
	      this.justifyWidth = justifyWidth;
	      this.lossHistory = [];
	      this.evaluate();
	    }
	
	    // Calculate the total cost of this formatting decision.
	
	  }, {
	    key: 'evaluate',
	    value: function evaluate() {
	      var _this2 = this;
	
	      var justifyWidth = this.justifyWidth;
	      // Calculate available slack per tick context. This works out how much freedom
	      // to move a context has in either direction, without affecting other notes.
	      this.contextGaps = { total: 0, gaps: [] };
	      this.tickContexts.list.forEach(function (tick, index) {
	        if (index === 0) return;
	        var prevTick = _this2.tickContexts.list[index - 1];
	        var prevContext = _this2.tickContexts.map[prevTick];
	        var context = _this2.tickContexts.map[tick];
	        var prevMetrics = prevContext.getMetrics();
	
	        var insideRightEdge = prevContext.getX() + prevMetrics.width;
	        var insideLeftEdge = context.getX();
	        var gap = insideLeftEdge - insideRightEdge;
	        _this2.contextGaps.total += gap;
	        _this2.contextGaps.gaps.push({ x1: insideRightEdge, x2: insideLeftEdge });
	
	        // Tell the tick contexts how much they can reposition themselves.
	        context.getFormatterMetrics().freedom.left = gap;
	        prevContext.getFormatterMetrics().freedom.right = gap;
	      });
	
	      // Calculate mean distance in each voice for each duration type, then calculate
	      // how far each note is from the mean.
	      var durationStats = this.durationStats = {};
	
	      function updateStats(duration, space) {
	        var stats = durationStats[duration];
	        if (stats === undefined) {
	          durationStats[duration] = { mean: space, count: 1 };
	        } else {
	          stats.count += 1;
	          stats.mean = (stats.mean + space) / 2;
	        }
	      }
	
	      this.voices.forEach(function (voice) {
	        voice.getTickables().forEach(function (note, i, notes) {
	          var duration = note.getTicks().clone().simplify().toString();
	          var metrics = note.getMetrics();
	          var formatterMetrics = note.getFormatterMetrics();
	          var leftNoteEdge = note.getX() + metrics.noteWidth + metrics.modRightPx + metrics.extraRightPx;
	          var space = 0;
	
	          if (i < notes.length - 1) {
	            var rightNote = notes[i + 1];
	            var rightMetrics = rightNote.getMetrics();
	            var rightNoteEdge = rightNote.getX() - rightMetrics.modLeftPx - rightMetrics.extraLeftPx;
	
	            space = rightNoteEdge - leftNoteEdge;
	            formatterMetrics.space.used = rightNote.getX() - note.getX();
	            rightNote.getFormatterMetrics().freedom.left = space;
	          } else {
	            space = justifyWidth - leftNoteEdge;
	            formatterMetrics.space.used = justifyWidth - note.getX();
	          }
	
	          formatterMetrics.freedom.right = space;
	          updateStats(duration, formatterMetrics.space.used);
	        });
	      });
	
	      // Calculate how much each note deviates from the mean. Loss function is square
	      // root of the sum of squared deviations.
	      var totalDeviation = 0;
	      this.voices.forEach(function (voice) {
	        voice.getTickables().forEach(function (note) {
	          var duration = note.getTicks().clone().simplify().toString();
	          var metrics = note.getFormatterMetrics();
	          metrics.iterations += 1;
	          metrics.space.deviation = metrics.space.used - durationStats[duration].mean;
	          metrics.duration = duration;
	          metrics.space.mean = durationStats[duration].mean;
	
	          totalDeviation += Math.pow(durationStats[duration].mean, 2);
	        });
	      });
	
	      this.totalCost = Math.sqrt(totalDeviation);
	      this.lossHistory.push(this.totalCost);
	      return this;
	    }
	
	    // Run a single iteration of rejustification. At a high level, this method calculates
	    // the overall "loss" (or cost) of this layout, and repositions tickcontexts in an
	    // attempt to reduce the cost. You can call this method multiple times until it finds
	    // and oscillates around a global minimum.
	
	  }, {
	    key: 'tune',
	    value: function tune() {
	      var _this3 = this;
	
	      var sum = function sum(means) {
	        return means.reduce(function (a, b) {
	          return a + b;
	        });
	      };
	
	      // Move `current` tickcontext by `shift` pixels, and adjust the freedom
	      // on adjacent tickcontexts.
	      function move(current, prev, next, shift) {
	        current.setX(current.getX() + shift);
	        current.getFormatterMetrics().freedom.left += shift;
	        current.getFormatterMetrics().freedom.right -= shift;
	
	        if (prev) prev.getFormatterMetrics().freedom.right += shift;
	        if (next) next.getFormatterMetrics().freedom.left -= shift;
	      }
	
	      var shift = 0;
	      this.tickContexts.list.forEach(function (tick, index, list) {
	        var context = _this3.tickContexts.map[tick];
	        var prevContext = index > 0 ? _this3.tickContexts.map[list[index - 1]] : null;
	        var nextContext = index < list.length - 1 ? _this3.tickContexts.map[list[index + 1]] : null;
	
	        move(context, prevContext, nextContext, shift);
	
	        var cost = -sum(context.getTickables().map(function (t) {
	          return t.getFormatterMetrics().space.deviation;
	        }));
	
	        if (cost > 0) {
	          shift = -Math.min(context.getFormatterMetrics().freedom.right, Math.abs(cost));
	        } else if (cost < 0) {
	          if (nextContext) {
	            shift = Math.min(nextContext.getFormatterMetrics().freedom.right, Math.abs(cost));
	          } else {
	            shift = 0;
	          }
	        }
	
	        var minShift = Math.min(5, Math.abs(shift));
	        shift = shift > 0 ? minShift : -minShift;
	      });
	
	      return this.evaluate();
	    }
	
	    // This is the top-level call for all formatting logic completed
	    // after `x` *and* `y` values have been computed for the notes
	    // in the voices.
	
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      var postFormatContexts = function postFormatContexts(contexts) {
	        return contexts.list.forEach(function (tick) {
	          return contexts.map[tick].postFormat();
	        });
	      };
	
	      postFormatContexts(this.modiferContexts);
	      postFormatContexts(this.tickContexts);
	
	      return this;
	    }
	
	    // Take all `voices` and create `ModifierContext`s out of them. This tells
	    // the formatters that the voices belong on a single stave.
	
	  }, {
	    key: 'joinVoices',
	    value: function joinVoices(voices) {
	      this.createModifierContexts(voices);
	      this.hasMinTotalWidth = false;
	      return this;
	    }
	
	    // Align rests in voices, justify the contexts, and position the notes
	    // so voices are aligned and ready to render onto the stave. This method
	    // mutates the `x` positions of all tickables in `voices`.
	    //
	    // Voices are full justified to fit in `justifyWidth` pixels.
	    //
	    // Set `options.context` to the rendering context. Set `options.align_rests`
	    // to true to enable rest alignment.
	
	  }, {
	    key: 'format',
	    value: function format(voices, justifyWidth, options) {
	      var opts = {
	        align_rests: false,
	        context: null,
	        stave: null
	      };
	
	      _vex.Vex.Merge(opts, options);
	      this.voices = voices;
	      this.alignRests(voices, opts.align_rests);
	      this.createTickContexts(voices);
	      this.preFormat(justifyWidth, opts.context, voices, opts.stave);
	
	      // Only postFormat if a stave was supplied for y value formatting
	      if (opts.stave) this.postFormat();
	
	      return this;
	    }
	
	    // This method is just like `format` except that the `justifyWidth` is inferred
	    // from the `stave`.
	
	  }, {
	    key: 'formatToStave',
	    value: function formatToStave(voices, stave, options) {
	      var justifyWidth = stave.getNoteEndX() - stave.getNoteStartX() - 10;
	      L('Formatting voices to width: ', justifyWidth);
	      var opts = { context: stave.getContext() };
	      _vex.Vex.Merge(opts, options);
	      return this.format(voices, justifyWidth, opts);
	    }
	  }]);

	  return Formatter;
	}();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Beam = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _element = __webpack_require__(5);
	
	var _fraction = __webpack_require__(3);
	
	var _tuplet = __webpack_require__(16);
	
	var _stem = __webpack_require__(17);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `Beams` that span over a set of `StemmableNotes`.
	
	function calculateStemDirection(notes) {
	  var lineSum = 0;
	  notes.forEach(function (note) {
	    if (note.keyProps) {
	      note.keyProps.forEach(function (keyProp) {
	        lineSum += keyProp.line - 3;
	      });
	    }
	  });
	
	  if (lineSum >= 0) {
	    return _stem.Stem.DOWN;
	  }
	  return _stem.Stem.UP;
	}
	
	var getStemSlope = function getStemSlope(firstNote, lastNote) {
	  var firstStemTipY = firstNote.getStemExtents().topY;
	  var firstStemX = firstNote.getStemX();
	  var lastStemTipY = lastNote.getStemExtents().topY;
	  var lastStemX = lastNote.getStemX();
	  return (lastStemTipY - firstStemTipY) / (lastStemX - firstStemX);
	};
	
	var Beam = exports.Beam = function (_Element) {
	  _inherits(Beam, _Element);
	
	  _createClass(Beam, null, [{
	    key: 'getDefaultBeamGroups',
	
	    // Gets the default beam groups for a provided time signature.
	    // Attempts to guess if the time signature is not found in table.
	    // Currently this is fairly naive.
	    value: function getDefaultBeamGroups(time_sig) {
	      if (!time_sig || time_sig === 'c') {
	        time_sig = '4/4';
	      }
	
	      var defaults = {
	        '1/2': ['1/2'],
	        '2/2': ['1/2'],
	        '3/2': ['1/2'],
	        '4/2': ['1/2'],
	
	        '1/4': ['1/4'],
	        '2/4': ['1/4'],
	        '3/4': ['1/4'],
	        '4/4': ['1/4'],
	
	        '1/8': ['1/8'],
	        '2/8': ['2/8'],
	        '3/8': ['3/8'],
	        '4/8': ['2/8'],
	
	        '1/16': ['1/16'],
	        '2/16': ['2/16'],
	        '3/16': ['3/16'],
	        '4/16': ['2/16']
	      };
	
	      var groups = defaults[time_sig];
	
	      if (groups === undefined) {
	        // If no beam groups found, naively determine
	        // the beam groupings from the time signature
	        var beatTotal = parseInt(time_sig.split('/')[0], 10);
	        var beatValue = parseInt(time_sig.split('/')[1], 10);
	
	        var tripleMeter = beatTotal % 3 === 0;
	
	        if (tripleMeter) {
	          return [new _fraction.Fraction(3, beatValue)];
	        } else if (beatValue > 4) {
	          return [new _fraction.Fraction(2, beatValue)];
	        } else if (beatValue <= 4) {
	          return [new _fraction.Fraction(1, beatValue)];
	        }
	      } else {
	        return groups.map(function (group) {
	          return new _fraction.Fraction().parse(group);
	        });
	      }
	
	      return [new _fraction.Fraction(1, 4)];
	    }
	
	    // A helper function to automatically build basic beams for a voice. For more
	    // complex auto-beaming use `Beam.generateBeams()`.
	    //
	    // Parameters:
	    // * `voice` - The voice to generate the beams for
	    // * `stem_direction` - A stem direction to apply to the entire voice
	    // * `groups` - An array of `Fraction` representing beat groupings for the beam
	
	  }, {
	    key: 'applyAndGetBeams',
	    value: function applyAndGetBeams(voice, stem_direction, groups) {
	      return Beam.generateBeams(voice.getTickables(), {
	        groups: groups,
	        stem_direction: stem_direction
	      });
	    }
	
	    // A helper function to autimatically build beams for a voice with
	    // configuration options.
	    //
	    // Example configuration object:
	    //
	    // ```
	    // config = {
	    //   groups: [new Vex.Flow.Fraction(2, 8)],
	    //   stem_direction: -1,
	    //   beam_rests: true,
	    //   beam_middle_only: true,
	    //   show_stemlets: false
	    // };
	    // ```
	    //
	    // Parameters:
	    // * `notes` - An array of notes to create the beams for
	    // * `config` - The configuration object
	    //    * `groups` - Array of `Fractions` that represent the beat structure to beam the notes
	    //    * `stem_direction` - Set to apply the same direction to all notes
	    //    * `beam_rests` - Set to `true` to include rests in the beams
	    //    * `beam_middle_only` - Set to `true` to only beam rests in the middle of the beat
	    //    * `show_stemlets` - Set to `true` to draw stemlets for rests
	    //    * `maintain_stem_directions` - Set to `true` to not apply new stem directions
	    //
	
	  }, {
	    key: 'generateBeams',
	    value: function generateBeams(notes, config) {
	      if (!config) config = {};
	
	      if (!config.groups || !config.groups.length) {
	        config.groups = [new _fraction.Fraction(2, 8)];
	      }
	
	      // Convert beam groups to tick amounts
	      var tickGroups = config.groups.map(function (group) {
	        if (!group.multiply) {
	          throw new _vex.Vex.RuntimeError('InvalidBeamGroups', 'The beam groups must be an array of Vex.Flow.Fractions');
	        }
	        return group.clone().multiply(_tables.Flow.RESOLUTION, 1);
	      });
	
	      var unprocessedNotes = notes;
	      var currentTickGroup = 0;
	      var noteGroups = [];
	      var currentGroup = [];
	
	      function getTotalTicks(vf_notes) {
	        return vf_notes.reduce(function (memo, note) {
	          return note.getTicks().clone().add(memo);
	        }, new _fraction.Fraction(0, 1));
	      }
	
	      function nextTickGroup() {
	        if (tickGroups.length - 1 > currentTickGroup) {
	          currentTickGroup += 1;
	        } else {
	          currentTickGroup = 0;
	        }
	      }
	
	      function createGroups() {
	        var nextGroup = [];
	
	        unprocessedNotes.forEach(function (unprocessedNote) {
	          nextGroup = [];
	          if (unprocessedNote.shouldIgnoreTicks()) {
	            noteGroups.push(currentGroup);
	            currentGroup = nextGroup;
	            return; // Ignore untickables (like bar notes)
	          }
	
	          currentGroup.push(unprocessedNote);
	          var ticksPerGroup = tickGroups[currentTickGroup].clone();
	          var totalTicks = getTotalTicks(currentGroup);
	
	          // Double the amount of ticks in a group, if it's an unbeamable tuplet
	          var unbeamable = _tables.Flow.durationToNumber(unprocessedNote.duration) < 8;
	          if (unbeamable && unprocessedNote.tuplet) {
	            ticksPerGroup.numerator *= 2;
	          }
	
	          // If the note that was just added overflows the group tick total
	          if (totalTicks.greaterThan(ticksPerGroup)) {
	            // If the overflow note can be beamed, start the next group
	            // with it. Unbeamable notes leave the group overflowed.
	            if (!unbeamable) {
	              nextGroup.push(currentGroup.pop());
	            }
	            noteGroups.push(currentGroup);
	            currentGroup = nextGroup;
	            nextTickGroup();
	          } else if (totalTicks.equals(ticksPerGroup)) {
	            noteGroups.push(currentGroup);
	            currentGroup = nextGroup;
	            nextTickGroup();
	          }
	        });
	
	        // Adds any remainder notes
	        if (currentGroup.length > 0) {
	          noteGroups.push(currentGroup);
	        }
	      }
	
	      function getBeamGroups() {
	        return noteGroups.filter(function (group) {
	          if (group.length > 1) {
	            var beamable = true;
	            group.forEach(function (note) {
	              if (note.getIntrinsicTicks() >= _tables.Flow.durationToTicks('4')) {
	                beamable = false;
	              }
	            });
	            return beamable;
	          }
	          return false;
	        });
	      }
	
	      // Splits up groups by Rest
	      function sanitizeGroups() {
	        var sanitizedGroups = [];
	        noteGroups.forEach(function (group) {
	          var tempGroup = [];
	          group.forEach(function (note, index, group) {
	            var isFirstOrLast = index === 0 || index === group.length - 1;
	            var prevNote = group[index - 1];
	
	            var breaksOnEachRest = !config.beam_rests && note.isRest();
	            var breaksOnFirstOrLastRest = config.beam_rests && config.beam_middle_only && note.isRest() && isFirstOrLast;
	
	            var breakOnStemChange = false;
	            if (config.maintain_stem_directions && prevNote && !note.isRest() && !prevNote.isRest()) {
	              var prevDirection = prevNote.getStemDirection();
	              var currentDirection = note.getStemDirection();
	              breakOnStemChange = currentDirection !== prevDirection;
	            }
	
	            var isUnbeamableDuration = parseInt(note.duration, 10) < 8;
	
	            // Determine if the group should be broken at this note
	            var shouldBreak = breaksOnEachRest || breaksOnFirstOrLastRest || breakOnStemChange || isUnbeamableDuration;
	
	            if (shouldBreak) {
	              // Add current group
	              if (tempGroup.length > 0) {
	                sanitizedGroups.push(tempGroup);
	              }
	
	              // Start a new group. Include the current note if the group
	              // was broken up by stem direction, as that note needs to start
	              // the next group of notes
	              tempGroup = breakOnStemChange ? [note] : [];
	            } else {
	              // Add note to group
	              tempGroup.push(note);
	            }
	          });
	
	          // If there is a remaining group, add it as well
	          if (tempGroup.length > 0) {
	            sanitizedGroups.push(tempGroup);
	          }
	        });
	
	        noteGroups = sanitizedGroups;
	      }
	
	      function formatStems() {
	        noteGroups.forEach(function (group) {
	          var stemDirection = void 0;
	          if (config.maintain_stem_directions) {
	            var _note = findFirstNote(group);
	            stemDirection = _note ? _note.getStemDirection() : _stem.Stem.UP;
	          } else {
	            if (config.stem_direction) {
	              stemDirection = config.stem_direction;
	            } else {
	              stemDirection = calculateStemDirection(group);
	            }
	          }
	          applyStemDirection(group, stemDirection);
	        });
	      }
	
	      function findFirstNote(group) {
	        for (var _i = 0; _i < group.length; _i++) {
	          var _note2 = group[_i];
	          if (!_note2.isRest()) {
	            return _note2;
	          }
	        }
	
	        return false;
	      }
	
	      function applyStemDirection(group, direction) {
	        group.forEach(function (note) {
	          note.setStemDirection(direction);
	        });
	      }
	
	      // Get all of the tuplets in all of the note groups
	      function getTuplets() {
	        var uniqueTuplets = [];
	
	        // Go through all of the note groups and inspect for tuplets
	        noteGroups.forEach(function (group) {
	          var tuplet = null;
	          group.forEach(function (note) {
	            if (note.tuplet && tuplet !== note.tuplet) {
	              tuplet = note.tuplet;
	              uniqueTuplets.push(tuplet);
	            }
	          });
	        });
	        return uniqueTuplets;
	      }
	
	      // Using closures to store the variables throughout the various functions
	      // IMO Keeps it this process lot cleaner - but not super consistent with
	      // the rest of the API's style - Silverwolf90 (Cyril)
	      createGroups();
	      sanitizeGroups();
	      formatStems();
	
	      // Get the notes to be beamed
	      var beamedNoteGroups = getBeamGroups();
	
	      // Get the tuplets in order to format them accurately
	      var allTuplets = getTuplets();
	
	      // Create a Vex.Flow.Beam from each group of notes to be beamed
	      var beams = [];
	      beamedNoteGroups.forEach(function (group) {
	        var beam = new Beam(group);
	
	        if (config.show_stemlets) {
	          beam.render_options.show_stemlets = true;
	        }
	        if (config.secondary_breaks) {
	          beam.render_options.secondary_break_ticks = _tables.Flow.durationToTicks(config.secondary_breaks);
	        }
	        if (config.flat_beams === true) {
	          beam.render_options.flat_beams = true;
	          beam.render_options.flat_beam_offset = config.flat_beam_offset;
	        }
	        beams.push(beam);
	      });
	
	      // Reformat tuplets
	      allTuplets.forEach(function (tuplet) {
	        // Set the tuplet location based on the stem direction
	        var direction = tuplet.notes[0].stem_direction === _stem.Stem.DOWN ? _tuplet.Tuplet.LOCATION_BOTTOM : _tuplet.Tuplet.LOCATION_TOP;
	        tuplet.setTupletLocation(direction);
	
	        // If any of the notes in the tuplet are not beamed, draw a bracket.
	        var bracketed = false;
	        for (var _i2 = 0; _i2 < tuplet.notes.length; _i2++) {
	          var _note3 = tuplet.notes[_i2];
	          if (_note3.beam === null) {
	            bracketed = true;
	            break;
	          }
	        }
	        tuplet.setBracketed(bracketed);
	      });
	
	      return beams;
	    }
	  }]);
	
	  function Beam(notes, auto_stem) {
	    _classCallCheck(this, Beam);
	
	    var _this = _possibleConstructorReturn(this, (Beam.__proto__ || Object.getPrototypeOf(Beam)).call(this));
	
	    _this.setAttribute('type', 'Beam');
	
	    if (!notes || notes === []) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'No notes provided for beam.');
	    }
	
	    if (notes.length === 1) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Too few notes for beam.');
	    }
	
	    // Validate beam line, direction and ticks.
	    _this.ticks = notes[0].getIntrinsicTicks();
	
	    if (_this.ticks >= _tables.Flow.durationToTicks('4')) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Beams can only be applied to notes shorter than a quarter note.');
	    }
	
	    var i = void 0; // shared iterator
	    var note = void 0;
	
	    _this.stem_direction = _stem.Stem.UP;
	
	    for (i = 0; i < notes.length; ++i) {
	      note = notes[i];
	      if (note.hasStem()) {
	        _this.stem_direction = note.getStemDirection();
	        break;
	      }
	    }
	
	    var stem_direction = _this.stem_direction;
	    // Figure out optimal stem direction based on given notes
	    if (auto_stem && notes[0].getCategory() === 'stavenotes') {
	      stem_direction = calculateStemDirection(notes);
	    } else if (auto_stem && notes[0].getCategory() === 'tabnotes') {
	      // Auto Stem TabNotes
	      var stem_weight = notes.reduce(function (memo, note) {
	        return memo + note.stem_direction;
	      }, 0);
	
	      stem_direction = stem_weight > -1 ? _stem.Stem.UP : _stem.Stem.DOWN;
	    }
	
	    // Apply stem directions and attach beam to notes
	    for (i = 0; i < notes.length; ++i) {
	      note = notes[i];
	      if (auto_stem) {
	        note.setStemDirection(stem_direction);
	        _this.stem_direction = stem_direction;
	      }
	      note.setBeam(_this);
	    }
	
	    _this.postFormatted = false;
	    _this.notes = notes;
	    _this.beam_count = _this.getBeamCount();
	    _this.break_on_indices = [];
	    _this.render_options = {
	      beam_width: 5,
	      max_slope: 0.25,
	      min_slope: -0.25,
	      slope_iterations: 20,
	      slope_cost: 100,
	      show_stemlets: false,
	      stemlet_extension: 7,
	      partial_beam_length: 10,
	      flat_beams: false,
	      min_flat_beam_offset: 15
	    };
	    return _this;
	  }
	
	  // Get the notes in this beam
	
	
	  _createClass(Beam, [{
	    key: 'getNotes',
	    value: function getNotes() {
	      return this.notes;
	    }
	
	    // Get the max number of beams in the set of notes
	
	  }, {
	    key: 'getBeamCount',
	    value: function getBeamCount() {
	      var beamCounts = this.notes.map(function (note) {
	        return note.getGlyph().beam_count;
	      });
	
	      var maxBeamCount = beamCounts.reduce(function (max, beamCount) {
	        return beamCount > max ? beamCount : max;
	      });
	
	      return maxBeamCount;
	    }
	
	    // Set which note `indices` to break the secondary beam at
	
	  }, {
	    key: 'breakSecondaryAt',
	    value: function breakSecondaryAt(indices) {
	      this.break_on_indices = indices;
	      return this;
	    }
	
	    // Return the y coordinate for linear function
	
	  }, {
	    key: 'getSlopeY',
	    value: function getSlopeY(x, first_x_px, first_y_px, slope) {
	      return first_y_px + (x - first_x_px) * slope;
	    }
	
	    // Calculate the best possible slope for the provided notes
	
	  }, {
	    key: 'calculateSlope',
	    value: function calculateSlope() {
	      var notes = this.notes;
	      var stemDirection = this.stem_direction;
	      var _render_options = this.render_options;
	      var max_slope = _render_options.max_slope;
	      var min_slope = _render_options.min_slope;
	      var slope_iterations = _render_options.slope_iterations;
	      var slope_cost = _render_options.slope_cost;
	
	
	      var firstNote = notes[0];
	      var initialSlope = getStemSlope(firstNote, notes[notes.length - 1]);
	      var increment = (max_slope - min_slope) / slope_iterations;
	      var minCost = Number.MAX_VALUE;
	      var bestSlope = 0;
	      var yShift = 0;
	
	      // iterate through slope values to find best weighted fit
	      for (var slope = min_slope; slope <= max_slope; slope += increment) {
	        var totalStemExtension = 0;
	        var yShiftTemp = 0;
	
	        // iterate through notes, calculating y shift and stem extension
	        for (var _i3 = 1; _i3 < notes.length; ++_i3) {
	          var _note4 = notes[_i3];
	          var adjustedStemTipY = this.getSlopeY(_note4.getStemX(), firstNote.getStemX(), firstNote.getStemExtents().topY, slope) + yShiftTemp;
	
	          var stemTipY = _note4.getStemExtents().topY;
	          // beam needs to be shifted up to accommodate note
	          if (stemTipY * stemDirection < adjustedStemTipY * stemDirection) {
	            var diff = Math.abs(stemTipY - adjustedStemTipY);
	            yShiftTemp += diff * -stemDirection;
	            totalStemExtension += diff * _i3;
	          } else {
	            // beam overshoots note, account for the difference
	            totalStemExtension += (stemTipY - adjustedStemTipY) * stemDirection;
	          }
	        }
	
	        // most engraving books suggest aiming for a slope about half the angle of the
	        // difference between the first and last notes' stem length;
	        var idealSlope = initialSlope / 2;
	        var distanceFromIdeal = Math.abs(idealSlope - slope);
	
	        // This tries to align most beams to something closer to the idealSlope, but
	        // doesn't go crazy. To disable, set this.render_options.slope_cost = 0
	        var cost = slope_cost * distanceFromIdeal + Math.abs(totalStemExtension);
	
	        // update state when a more ideal slope is found
	        if (cost < minCost) {
	          minCost = cost;
	          bestSlope = slope;
	          yShift = yShiftTemp;
	        }
	      }
	
	      this.slope = bestSlope;
	      this.y_shift = yShift;
	    }
	
	    // Calculate a slope and y-shift for flat beams
	
	  }, {
	    key: 'calculateFlatSlope',
	    value: function calculateFlatSlope() {
	      var notes = this.notes;
	      var stem_direction = this.stem_direction;
	      var _render_options2 = this.render_options;
	      var beam_width = _render_options2.beam_width;
	      var min_flat_beam_offset = _render_options2.min_flat_beam_offset;
	      var flat_beam_offset = _render_options2.flat_beam_offset;
	
	      // If a flat beam offset has not yet been supplied or calculated,
	      // generate one based on the notes in this particular note group
	
	      var total = 0;
	      var extremeY = 0; // Store the highest or lowest note here
	      var extremeBeamCount = 0; // The beam count of the extreme note
	      var currentExtreme = 0;
	      for (var _i4 = 0; _i4 < notes.length; _i4++) {
	        // Total up all of the offsets so we can average them out later
	        var _note5 = notes[_i4];
	        var stemTipY = _note5.getStemExtents().topY;
	        total += stemTipY;
	
	        // Store the highest (stems-up) or lowest (stems-down) note so the
	        //  offset can be adjusted in case the average isn't enough
	        if (stem_direction === _stem.Stem.DOWN && currentExtreme < stemTipY) {
	          currentExtreme = stemTipY;
	          extremeY = Math.max.apply(Math, _toConsumableArray(_note5.getYs()));
	          extremeBeamCount = _note5.getBeamCount();
	        } else if (stem_direction === _stem.Stem.UP && (currentExtreme === 0 || currentExtreme > stemTipY)) {
	          currentExtreme = stemTipY;
	          extremeY = Math.min.apply(Math, _toConsumableArray(_note5.getYs()));
	          extremeBeamCount = _note5.getBeamCount();
	        }
	      }
	
	      // Average the offsets to try and come up with a reasonable one that
	      //  works for all of the notes in the beam group.
	      var offset = total / notes.length;
	
	      // In case the average isn't long enough, add or subtract some more
	      //  based on the highest or lowest note (again, based on the stem
	      //  direction). This also takes into account the added height due to
	      //  the width of the beams.
	      var beamWidth = beam_width * 1.5;
	      var extremeTest = min_flat_beam_offset + extremeBeamCount * beamWidth;
	      var newOffset = extremeY + extremeTest * -stem_direction;
	      if (stem_direction === _stem.Stem.DOWN && offset < newOffset) {
	        offset = extremeY + extremeTest;
	      } else if (stem_direction === _stem.Stem.UP && offset > newOffset) {
	        offset = extremeY - extremeTest;
	      }
	
	      if (!flat_beam_offset) {
	        // Set the offset for the group based on the calculations above.
	        this.render_options.flat_beam_offset = offset;
	      } else if (stem_direction === _stem.Stem.DOWN && offset > flat_beam_offset) {
	        this.render_options.flat_beam_offset = offset;
	      } else if (stem_direction === _stem.Stem.UP && offset < flat_beam_offset) {
	        this.render_options.flat_beam_offset = offset;
	      }
	
	      // for flat beams, the slope and y_shift are simply 0
	      this.slope = 0;
	      this.y_shift = 0;
	    }
	
	    // Create new stems for the notes in the beam, so that each stem
	    // extends into the beams.
	
	  }, {
	    key: 'applyStemExtensions',
	    value: function applyStemExtensions() {
	      var notes = this.notes;
	      var slope = this.slope;
	      var y_shift = this.y_shift;
	      var stem_direction = this.stem_direction;
	      var beam_count = this.beam_count;
	      var _render_options3 = this.render_options;
	      var show_stemlets = _render_options3.show_stemlets;
	      var flat_beam_offset = _render_options3.flat_beam_offset;
	      var flat_beams = _render_options3.flat_beams;
	      var stemlet_extension = _render_options3.stemlet_extension;
	      var beam_width = _render_options3.beam_width;
	
	
	      var firstNote = notes[0];
	      var firstStemTipY = firstNote.getStemExtents().topY;
	
	      // If rendering flat beams, and an offset exists, set the y-coordinat`e to
	      //  the offset so the stems all end at the beam offset.
	      if (flat_beams && flat_beam_offset) {
	        firstStemTipY = flat_beam_offset;
	      }
	      var firstStemX = firstNote.getStemX();
	
	      for (var _i5 = 0; _i5 < notes.length; ++_i5) {
	        var _note6 = notes[_i5];
	        var stemX = _note6.getStemX();
	
	        var _note6$getStemExtents = _note6.getStemExtents();
	
	        var stemTipY = _note6$getStemExtents.topY;
	
	        var beamedStemTipY = this.getSlopeY(stemX, firstStemX, firstStemTipY, slope) + y_shift;
	        var preBeamExtension = _note6.getStem().getExtension();
	        var beamExtension = stem_direction === _stem.Stem.UP ? stemTipY - beamedStemTipY : beamedStemTipY - stemTipY;
	
	        _note6.stem.setExtension(preBeamExtension + beamExtension);
	        _note6.stem.renderHeightAdjustment = -_stem.Stem.WIDTH / 2;
	
	        if (_note6.isRest() && show_stemlets) {
	          var beamWidth = beam_width;
	          var totalBeamWidth = (beam_count - 1) * beamWidth * 1.5 + beamWidth;
	          _note6.stem.setVisibility(true).setStemlet(true, totalBeamWidth + stemlet_extension);
	        }
	      }
	    }
	
	    // Get the x coordinates for the beam lines of specific `duration`
	
	  }, {
	    key: 'getBeamLines',
	    value: function getBeamLines(duration) {
	      var beam_lines = [];
	      var beam_started = false;
	      var current_beam = null;
	      var partial_beam_length = this.render_options.partial_beam_length;
	      var previous_should_break = false;
	      var tick_tally = 0;
	      for (var _i6 = 0; _i6 < this.notes.length; ++_i6) {
	        var _note7 = this.notes[_i6];
	
	        // See if we need to break secondary beams on this note.
	        var ticks = _note7.ticks.value();
	        tick_tally += ticks;
	        var should_break = false;
	
	        // 8th note beams are always drawn.
	        if (parseInt(duration, 10) >= 8) {
	          // First, check to see if any indices were set up through breakSecondaryAt()
	          should_break = this.break_on_indices.indexOf(_i6) !== -1;
	
	          // If the secondary breaks were auto-configured in the render options,
	          //  handle that as well.
	          if (this.render_options.secondary_break_ticks && tick_tally >= this.render_options.secondary_break_ticks) {
	            tick_tally = 0;
	            should_break = true;
	          }
	        }
	        var note_gets_beam = _note7.getIntrinsicTicks() < _tables.Flow.durationToTicks(duration);
	
	        var stem_x = _note7.getStemX() - _stem.Stem.WIDTH / 2;
	
	        // Check to see if the next note in the group will get a beam at this
	        //  level. This will help to inform the partial beam logic below.
	        var next_note = this.notes[_i6 + 1];
	        var beam_next = next_note && next_note.getIntrinsicTicks() < _tables.Flow.durationToTicks(duration);
	        if (note_gets_beam) {
	          // This note gets a beam at the current level
	          if (beam_started) {
	            // We're currently in the middle of a beam. Just continue it on to
	            //  the stem X of the current note.
	            current_beam = beam_lines[beam_lines.length - 1];
	            current_beam.end = stem_x;
	
	            // If a secondary beam break is set up, end the beam right now.
	            if (should_break) {
	              beam_started = false;
	              if (next_note && !beam_next && current_beam.end === null) {
	                // This note gets a beam,.but the next one does not. This means
	                //  we need a partial pointing right.
	                current_beam.end = current_beam.start - partial_beam_length;
	              }
	            }
	          } else {
	            // No beam started yet. Start a new one.
	            current_beam = { start: stem_x, end: null };
	            beam_started = true;
	            if (!beam_next) {
	              // The next note doesn't get a beam. Draw a partial.
	              if ((previous_should_break || _i6 === 0) && next_note) {
	                // This is the first note (but not the last one), or it is
	                //  following a secondary break. Draw a partial to the right.
	                current_beam.end = current_beam.start + partial_beam_length;
	              } else {
	                // By default, draw a partial to the left.
	                current_beam.end = current_beam.start - partial_beam_length;
	              }
	            } else if (should_break) {
	              // This note should have a secondary break after it. Even though
	              //  we just started a beam, it needs to end immediately.
	              current_beam.end = current_beam.start - partial_beam_length;
	              beam_started = false;
	            }
	            beam_lines.push(current_beam);
	          }
	        } else {
	          // The current note does not get a beam.
	          beam_started = false;
	        }
	
	        // Store the secondary break flag to inform the partial beam logic in
	        //  the next iteration of the loop.
	        previous_should_break = should_break;
	      }
	
	      // Add a partial beam pointing left if this is the last note in the group
	      var last_beam = beam_lines[beam_lines.length - 1];
	      if (last_beam && last_beam.end === null) {
	        last_beam.end = last_beam.start - partial_beam_length;
	      }
	      return beam_lines;
	    }
	
	    // Render the stems for each notes
	
	  }, {
	    key: 'drawStems',
	    value: function drawStems() {
	      var _this2 = this;
	
	      this.notes.forEach(function (note) {
	        if (note.getStem()) {
	          note.getStem().setContext(_this2.context).draw();
	        }
	      }, this);
	    }
	
	    // Render the beam lines
	
	  }, {
	    key: 'drawBeamLines',
	    value: function drawBeamLines() {
	      this.checkContext();
	
	      var valid_beam_durations = ['4', '8', '16', '32', '64'];
	
	      var firstNote = this.notes[0];
	
	      var firstStemTipY = firstNote.getStemExtents().topY;
	      var beamY = firstStemTipY;
	
	      // For flat beams, set the first and last Y to the offset, rather than
	      //  using the note's stem extents.
	      if (this.render_options.flat_beams && this.render_options.flat_beam_offset) {
	        beamY = this.render_options.flat_beam_offset;
	      }
	
	      var firstStemX = firstNote.getStemX();
	      var beamThickness = this.render_options.beam_width * this.stem_direction;
	
	      // Draw the beams.
	      for (var _i7 = 0; _i7 < valid_beam_durations.length; ++_i7) {
	        var duration = valid_beam_durations[_i7];
	        var beamLines = this.getBeamLines(duration);
	
	        for (var j = 0; j < beamLines.length; ++j) {
	          var beam_line = beamLines[j];
	          var startBeamX = beam_line.start;
	
	          var startBeamY = this.getSlopeY(startBeamX, firstStemX, beamY, this.slope);
	          var lastBeamX = beam_line.end;
	          var lastBeamY = this.getSlopeY(lastBeamX, firstStemX, beamY, this.slope);
	
	          this.context.beginPath();
	          this.context.moveTo(startBeamX, startBeamY);
	          this.context.lineTo(startBeamX, startBeamY + beamThickness);
	          this.context.lineTo(lastBeamX + 1, lastBeamY + beamThickness);
	          this.context.lineTo(lastBeamX + 1, lastBeamY);
	          this.context.closePath();
	          this.context.fill();
	        }
	
	        beamY += beamThickness * 1.5;
	      }
	    }
	
	    // Pre-format the beam
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      return this;
	    }
	
	    // Post-format the beam. This can only be called after
	    // the notes in the beam have both `x` and `y` values. ie: they've
	    // been formatted and have staves
	
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      if (this.postFormatted) return;
	
	      // Calculate a smart slope if we're not forcing the beams to be flat.
	      if (this.notes[0].getCategory() === 'tabnotes' || this.render_options.flat_beams) {
	        this.calculateFlatSlope();
	      } else {
	        this.calculateSlope();
	      }
	      this.applyStemExtensions();
	
	      this.postFormatted = true;
	    }
	
	    // Render the beam to the canvas context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	      if (this.unbeamable) return;
	
	      if (!this.postFormatted) {
	        this.postFormat();
	      }
	
	      this.drawStems();
	      this.applyStyle();
	      this.drawBeamLines();
	      this.restoreStyle();
	    }
	  }]);

	  return Beam;
	}(_element.Element);

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tuplet = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _formatter = __webpack_require__(14);
	
	var _glyph = __webpack_require__(4);
	
	var _stem = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	/**
	 * ## Description
	 *
	 * Create a new tuplet from the specified notes. The notes must
	 * be part of the same voice. If they are of different rhythmic
	 * values, then options.num_notes must be set.
	 *
	 * @constructor
	 * @param {Array.<Vex.Flow.StaveNote>} A set of notes: staveNotes,
	 *   notes, etc... any class that inherits stemmableNote at some
	 *   point in its prototype chain.
	 * @param options: object {
	 *
	 *   num_notes: fit this many notes into...
	 *   notes_occupied: ...the space of this many notes
	 *
	 *       Together, these two properties make up the tuplet ratio
	 *     in the form of num_notes : notes_occupied.
	 *       num_notes defaults to the number of notes passed in, so
	 *     it is important that if you omit this property, all of
	 *     the notes passed should be of the same note value.
	 *       notes_occupied defaults to 2 -- so you should almost
	 *     certainly pass this parameter for anything other than
	 *     a basic triplet.
	 *
	 *   location:
	 *     default 1, which is above the notes: ┌─── 3 ───┐
	 *      -1 is below the notes └─── 3 ───┘
	 *
	 *   bracketed: boolean, draw a bracket around the tuplet number
	 *     when true: ┌─── 3 ───┐   when false: 3
	 *     defaults to true if notes are not beamed, false otherwise
	 *
	 *   ratioed: boolean
	 *     when true: ┌─── 7:8 ───┐, when false: ┌─── 7 ───┐
	 *     defaults to true if the difference between num_notes and
	 *     notes_occupied is greater than 1.
	 *
	 *   y_offset: int, default 0
	 *     manually offset a tuplet, for instance to avoid collisions
	 *     with articulations, etc...
	 * }
	 */
	
	var Tuplet = exports.Tuplet = function (_Element) {
	  _inherits(Tuplet, _Element);
	
	  _createClass(Tuplet, null, [{
	    key: 'LOCATION_TOP',
	    get: function get() {
	      return 1;
	    }
	  }, {
	    key: 'LOCATION_BOTTOM',
	    get: function get() {
	      return -1;
	    }
	  }, {
	    key: 'NESTING_OFFSET',
	    get: function get() {
	      return 15;
	    }
	  }]);
	
	  function Tuplet(notes, options) {
	    _classCallCheck(this, Tuplet);
	
	    var _this = _possibleConstructorReturn(this, (Tuplet.__proto__ || Object.getPrototypeOf(Tuplet)).call(this));
	
	    _this.setAttribute('type', 'Tuplet');
	    if (!notes || !notes.length) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'No notes provided for tuplet.');
	    }
	
	    _this.options = _vex.Vex.Merge({}, options);
	    _this.notes = notes;
	    _this.num_notes = 'num_notes' in _this.options ? _this.options.num_notes : notes.length;
	
	    // We accept beats_occupied, but warn that it's deprecated:
	    // the preferred property name is now notes_occupied.
	    if (_this.options.beats_occupied) {
	      _this.beatsOccupiedDeprecationWarning();
	    }
	    _this.notes_occupied = _this.options.notes_occupied || _this.options.beats_occupied || 2;
	    if ('bracketed' in _this.options) {
	      _this.bracketed = _this.options.bracketed;
	    } else {
	      _this.bracketed = notes.some(function (note) {
	        return note.beam === null;
	      });
	    }
	
	    _this.ratioed = 'ratioed' in _this.options ? _this.options.ratioed : Math.abs(_this.notes_occupied - _this.num_notes) > 1;
	    _this.point = 28;
	    _this.y_pos = 16;
	    _this.x_pos = 100;
	    _this.width = 200;
	    _this.location = _this.options.location || Tuplet.LOCATION_TOP;
	
	    _formatter.Formatter.AlignRestsToNotes(notes, true, true);
	    _this.resolveGlyphs();
	    _this.attach();
	    return _this;
	  }
	
	  _createClass(Tuplet, [{
	    key: 'attach',
	    value: function attach() {
	      for (var i = 0; i < this.notes.length; i++) {
	        var note = this.notes[i];
	        note.setTuplet(this);
	      }
	    }
	  }, {
	    key: 'detach',
	    value: function detach() {
	      for (var i = 0; i < this.notes.length; i++) {
	        var note = this.notes[i];
	        note.resetTuplet(this);
	      }
	    }
	
	    /**
	     * Set whether or not the bracket is drawn.
	     */
	
	  }, {
	    key: 'setBracketed',
	    value: function setBracketed(bracketed) {
	      this.bracketed = !!bracketed;
	      return this;
	    }
	
	    /**
	     * Set whether or not the ratio is shown.
	     */
	
	  }, {
	    key: 'setRatioed',
	    value: function setRatioed(ratioed) {
	      this.ratioed = !!ratioed;
	      return this;
	    }
	
	    /**
	     * Set the tuplet to be displayed either on the top or bottom of the stave
	     */
	
	  }, {
	    key: 'setTupletLocation',
	    value: function setTupletLocation(location) {
	      if (!location) {
	        location = Tuplet.LOCATION_TOP;
	      } else if (location !== Tuplet.LOCATION_TOP && location !== Tuplet.LOCATION_BOTTOM) {
	        throw new _vex.Vex.RERR('BadArgument', 'Invalid tuplet location: ' + location);
	      }
	
	      this.location = location;
	      return this;
	    }
	  }, {
	    key: 'getNotes',
	    value: function getNotes() {
	      return this.notes;
	    }
	  }, {
	    key: 'getNoteCount',
	    value: function getNoteCount() {
	      return this.num_notes;
	    }
	  }, {
	    key: 'beatsOccupiedDeprecationWarning',
	    value: function beatsOccupiedDeprecationWarning() {
	      var msg = ['beats_occupied has been deprecated as an ', 'option for tuplets. Please use notes_occupied ', 'instead. Calls to getBeatsOccupied and ', 'setBeatsOccupied should now be routed to ', 'getNotesOccupied and setNotesOccupied instead'].join('');
	
	      if (console && console.warn) {
	        // eslint-disable-line no-console
	        console.warn(msg); // eslint-disable-line no-console
	      } else if (console) {
	        console.log(msg); // eslint-disable-line no-console
	      }
	    }
	  }, {
	    key: 'getBeatsOccupied',
	    value: function getBeatsOccupied() {
	      this.beatsOccupiedDeprecationWarning();
	      return this.getNotesOccupied();
	    }
	  }, {
	    key: 'setBeatsOccupied',
	    value: function setBeatsOccupied(beats) {
	      this.beatsOccupiedDeprecationWarning();
	      return this.setNotesOccupied(beats);
	    }
	  }, {
	    key: 'getNotesOccupied',
	    value: function getNotesOccupied() {
	      return this.notes_occupied;
	    }
	  }, {
	    key: 'setNotesOccupied',
	    value: function setNotesOccupied(notes) {
	      this.detach();
	      this.notes_occupied = notes;
	      this.resolveGlyphs();
	      this.attach();
	    }
	  }, {
	    key: 'resolveGlyphs',
	    value: function resolveGlyphs() {
	      this.num_glyphs = [];
	      var n = this.num_notes;
	      while (n >= 1) {
	        this.num_glyphs.push(new _glyph.Glyph('v' + n % 10, this.point));
	        n = parseInt(n / 10, 10);
	      }
	
	      this.denom_glyphs = [];
	      n = this.notes_occupied;
	      while (n >= 1) {
	        this.denom_glyphs.push(new _glyph.Glyph('v' + n % 10, this.point));
	        n = parseInt(n / 10, 10);
	      }
	    }
	
	    // determine how many tuplets are nested within this tuplet
	    // on the same side (above/below), to calculate a y
	    // offset for this tuplet:
	
	  }, {
	    key: 'getNestedTupletCount',
	    value: function getNestedTupletCount() {
	      var location = this.location;
	      var first_note = this.notes[0];
	      var maxTupletCount = countTuplets(first_note, location);
	      var minTupletCount = countTuplets(first_note, location);
	
	      // Count the tuplets that are on the same side (above/below)
	      // as this tuplet:
	      function countTuplets(note, location) {
	        return note.tupletStack.filter(function (tuplet) {
	          return tuplet.location === location;
	        }).length;
	      }
	
	      this.notes.forEach(function (note) {
	        var tupletCount = countTuplets(note, location);
	        maxTupletCount = tupletCount > maxTupletCount ? tupletCount : maxTupletCount;
	        minTupletCount = tupletCount < minTupletCount ? tupletCount : minTupletCount;
	      });
	
	      return maxTupletCount - minTupletCount;
	    }
	
	    // determine the y position of the tuplet:
	
	  }, {
	    key: 'getYPosition',
	    value: function getYPosition() {
	      // offset the tuplet for any nested tuplets between
	      // it and the notes:
	      var nested_tuplet_y_offset = this.getNestedTupletCount() * Tuplet.NESTING_OFFSET * -this.location;
	
	      // offset the tuplet for any manual y_offset:
	      var y_offset = this.options.y_offset || 0;
	
	      // now iterate through the notes and find our highest
	      // or lowest locations, to form a base y_pos
	      var first_note = this.notes[0];
	      var y_pos = void 0;
	      if (this.location === Tuplet.LOCATION_TOP) {
	        y_pos = first_note.getStave().getYForLine(0) - 15;
	        // y_pos = first_note.getStemExtents().topY - 10;
	
	        for (var i = 0; i < this.notes.length; ++i) {
	          var top_y = this.notes[i].getStemDirection() === _stem.Stem.UP ? this.notes[i].getStemExtents().topY - 10 : this.notes[i].getStemExtents().baseY - 20;
	
	          if (top_y < y_pos) {
	            y_pos = top_y;
	          }
	        }
	      } else {
	        y_pos = first_note.getStave().getYForLine(4) + 20;
	
	        for (var _i = 0; _i < this.notes.length; ++_i) {
	          var bottom_y = this.notes[_i].getStemDirection() === _stem.Stem.UP ? this.notes[_i].getStemExtents().baseY + 20 : this.notes[_i].getStemExtents().topY + 10;
	          if (bottom_y > y_pos) {
	            y_pos = bottom_y;
	          }
	        }
	      }
	
	      return y_pos + nested_tuplet_y_offset + y_offset;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      this.checkContext();
	      this.setRendered();
	
	      // determine x value of left bound of tuplet
	      var first_note = this.notes[0];
	      var last_note = this.notes[this.notes.length - 1];
	
	      if (!this.bracketed) {
	        this.x_pos = first_note.getStemX();
	        this.width = last_note.getStemX() - this.x_pos;
	      } else {
	        this.x_pos = first_note.getTieLeftX() - 5;
	        this.width = last_note.getTieRightX() - this.x_pos + 5;
	      }
	
	      // determine y value for tuplet
	      this.y_pos = this.getYPosition();
	
	      var addGlyphWidth = function addGlyphWidth(width, glyph) {
	        return width + glyph.getMetrics().width;
	      };
	
	      // calculate total width of tuplet notation
	      var width = this.num_glyphs.reduce(addGlyphWidth, 0);
	      if (this.ratioed) {
	        width = this.denom_glyphs.reduce(addGlyphWidth, width);
	        width += this.point * 0.32;
	      }
	
	      var notation_center_x = this.x_pos + this.width / 2;
	      var notation_start_x = notation_center_x - width / 2;
	
	      // draw bracket if the tuplet is not beamed
	      if (this.bracketed) {
	        var line_width = this.width / 2 - width / 2 - 5;
	
	        // only draw the bracket if it has positive length
	        if (line_width > 0) {
	          this.context.fillRect(this.x_pos, this.y_pos, line_width, 1);
	          this.context.fillRect(this.x_pos + this.width / 2 + width / 2 + 5, this.y_pos, line_width, 1);
	          this.context.fillRect(this.x_pos, this.y_pos + (this.location === Tuplet.LOCATION_BOTTOM), 1, this.location * 10);
	          this.context.fillRect(this.x_pos + this.width, this.y_pos + (this.location === Tuplet.LOCATION_BOTTOM), 1, this.location * 10);
	        }
	      }
	
	      // draw numerator glyphs
	      var x_offset = 0;
	      this.num_glyphs.forEach(function (glyph) {
	        glyph.render(_this2.context, notation_start_x + x_offset, _this2.y_pos + _this2.point / 3 - 2);
	        x_offset += glyph.getMetrics().width;
	      });
	
	      // display colon and denominator if the ratio is to be shown
	      if (this.ratioed) {
	        var colon_x = notation_start_x + x_offset + this.point * 0.16;
	        var colon_radius = this.point * 0.06;
	        this.context.beginPath();
	        this.context.arc(colon_x, this.y_pos - this.point * 0.08, colon_radius, 0, Math.PI * 2, true);
	        this.context.closePath();
	        this.context.fill();
	        this.context.beginPath();
	        this.context.arc(colon_x, this.y_pos + this.point * 0.12, colon_radius, 0, Math.PI * 2, true);
	        this.context.closePath();
	        this.context.fill();
	        x_offset += this.point * 0.32;
	        this.denom_glyphs.forEach(function (glyph) {
	          glyph.render(_this2.context, notation_start_x + x_offset, _this2.y_pos + _this2.point / 3 - 2);
	          x_offset += glyph.getMetrics().width;
	        });
	      }
	    }
	  }]);

	  return Tuplet;
	}(_element.Element);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This file implements the `Stem` object. Generally this object is handled
	// by its parent `StemmableNote`.
	
	// To enable logging for this class. Set `Vex.Flow.Stem.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Stem.DEBUG) _vex.Vex.L('Vex.Flow.Stem', args);
	}
	
	var Stem = exports.Stem = function (_Element) {
	  _inherits(Stem, _Element);
	
	  _createClass(Stem, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stem';
	    }
	
	    // Stem directions
	
	  }, {
	    key: 'UP',
	    get: function get() {
	      return 1;
	    }
	  }, {
	    key: 'DOWN',
	    get: function get() {
	      return -1;
	    }
	
	    // Theme
	
	  }, {
	    key: 'WIDTH',
	    get: function get() {
	      return _tables.Flow.STEM_WIDTH;
	    }
	  }, {
	    key: 'HEIGHT',
	    get: function get() {
	      return _tables.Flow.STEM_HEIGHT;
	    }
	  }]);
	
	  function Stem() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Stem);
	
	    var _this = _possibleConstructorReturn(this, (Stem.__proto__ || Object.getPrototypeOf(Stem)).call(this));
	
	    _this.setAttribute('type', 'Stem');
	
	    // Default notehead x bounds
	    _this.x_begin = options.x_begin || 0;
	    _this.x_end = options.x_end || 0;
	
	    // Y bounds for top/bottom most notehead
	    _this.y_top = options.y_top || 0;
	    _this.y_bottom = options.y_bottom || 0;
	
	    // Stem top extension
	    _this.stem_extension = options.stem_extension || 0;
	
	    // Direction of the stem
	    _this.stem_direction = options.stem_direction || 0;
	
	    // Flag to override all draw calls
	    _this.hide = options.hide || false;
	
	    _this.isStemlet = options.isStemlet || false;
	    _this.stemletHeight = options.stemletHeight || 0;
	
	    // Use to adjust the rendered height without affecting
	    // the results of `.getExtents()`
	    _this.renderHeightAdjustment = 0;
	    return _this;
	  }
	
	  // Set the x bounds for the default notehead
	
	
	  _createClass(Stem, [{
	    key: 'setNoteHeadXBounds',
	    value: function setNoteHeadXBounds(x_begin, x_end) {
	      this.x_begin = x_begin;
	      this.x_end = x_end;
	      return this;
	    }
	
	    // Set the direction of the stem in relation to the noteheads
	
	  }, {
	    key: 'setDirection',
	    value: function setDirection(direction) {
	      this.stem_direction = direction;
	    }
	
	    // Set the extension for the stem, generally for flags or beams
	
	  }, {
	    key: 'setExtension',
	    value: function setExtension(ext) {
	      this.stem_extension = ext;
	    }
	  }, {
	    key: 'getExtension',
	    value: function getExtension() {
	      return this.stem_extension;
	    }
	
	    // The the y bounds for the top and bottom noteheads
	
	  }, {
	    key: 'setYBounds',
	    value: function setYBounds(y_top, y_bottom) {
	      this.y_top = y_top;
	      this.y_bottom = y_bottom;
	    }
	
	    // The category of the object
	
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return Stem.CATEGORY;
	    }
	
	    // Gets the entire height for the stem
	
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return (this.y_bottom - this.y_top) * this.stem_direction + (Stem.HEIGHT + this.stem_extension) * this.stem_direction;
	    }
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      throw new _vex.Vex.RERR('NotImplemented', 'getBoundingBox() not implemented.');
	    }
	
	    // Get the y coordinates for the very base of the stem to the top of
	    // the extension
	
	  }, {
	    key: 'getExtents',
	    value: function getExtents() {
	      var isStemUp = this.stem_direction === Stem.UP;
	      var ys = [this.y_top, this.y_bottom];
	      var stemHeight = Stem.HEIGHT + this.stem_extension;
	      var innerMostNoteheadY = (isStemUp ? Math.min : Math.max).apply(undefined, ys);
	      var outerMostNoteheadY = (isStemUp ? Math.max : Math.min).apply(undefined, ys);
	      var stemTipY = innerMostNoteheadY + stemHeight * -this.stem_direction;
	
	      return { topY: stemTipY, baseY: outerMostNoteheadY };
	    }
	  }, {
	    key: 'setVisibility',
	    value: function setVisibility(isVisible) {
	      this.hide = !isVisible;
	      return this;
	    }
	  }, {
	    key: 'setStemlet',
	    value: function setStemlet(isStemlet, stemletHeight) {
	      this.isStemlet = isStemlet;
	      this.stemletHeight = stemletHeight;
	      return this;
	    }
	
	    // Render the stem onto the canvas
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.setRendered();
	      if (this.hide) return;
	      var ctx = this.checkContext();
	
	      var stem_x = void 0;
	      var stem_y = void 0;
	      var stem_direction = this.stem_direction;
	
	      if (stem_direction === Stem.DOWN) {
	        // Down stems are rendered to the left of the head.
	        stem_x = this.x_begin;
	        stem_y = this.y_top;
	      } else {
	        // Up stems are rendered to the right of the head.
	        stem_x = this.x_end;
	        stem_y = this.y_bottom;
	      }
	
	      var stemHeight = this.getHeight();
	
	      L('Rendering stem - ', 'Top Y: ', this.y_top, 'Bottom Y: ', this.y_bottom);
	
	      // The offset from the stem's base which is required fo satisfy the stemlet height
	      var stemletYOffset = this.isStemlet ? stemHeight - this.stemletHeight * this.stem_direction : 0;
	
	      // Draw the stem
	      ctx.save();
	      this.applyStyle(ctx);
	      ctx.beginPath();
	      ctx.setLineWidth(Stem.WIDTH);
	      ctx.moveTo(stem_x, stem_y - stemletYOffset);
	      ctx.lineTo(stem_x, stem_y - stemHeight - this.renderHeightAdjustment * stem_direction);
	      ctx.stroke();
	      ctx.restore();
	    }
	  }]);

	  return Stem;
	}(_element.Element);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Voice = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	var _fraction = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the main Voice class. It's mainly a container
	// object to group `Tickables` for formatting.
	
	var Voice = exports.Voice = function (_Element) {
	  _inherits(Voice, _Element);
	
	  _createClass(Voice, null, [{
	    key: 'Mode',
	
	    // Modes allow the addition of ticks in three different ways:
	    //
	    // STRICT: This is the default. Ticks must fill the voice.
	    // SOFT:   Ticks can be added without restrictions.
	    // FULL:   Ticks do not need to fill the voice, but can't exceed the maximum
	    //         tick length.
	    get: function get() {
	      return {
	        STRICT: 1,
	        SOFT: 2,
	        FULL: 3
	      };
	    }
	  }]);
	
	  function Voice(time) {
	    _classCallCheck(this, Voice);
	
	    var _this = _possibleConstructorReturn(this, (Voice.__proto__ || Object.getPrototypeOf(Voice)).call(this));
	
	    _this.setAttribute('type', 'Voice');
	
	    // Time signature shortcut: "4/4", "3/8", etc.
	    if (typeof time === 'string') {
	      var match = time.match(/(\d+)\/(\d+)/);
	      if (match) {
	        time = {
	          num_beats: match[1],
	          beat_value: match[2],
	          resolution: _tables.Flow.RESOLUTION
	        };
	      }
	    }
	
	    // Default time sig is 4/4
	    _this.time = _vex.Vex.Merge({
	      num_beats: 4,
	      beat_value: 4,
	      resolution: _tables.Flow.RESOLUTION
	    }, time);
	
	    // Recalculate total ticks.
	    _this.totalTicks = new _fraction.Fraction(_this.time.num_beats * (_this.time.resolution / _this.time.beat_value), 1);
	
	    _this.resolutionMultiplier = 1;
	
	    // Set defaults
	    _this.tickables = [];
	    _this.ticksUsed = new _fraction.Fraction(0, 1);
	    _this.smallestTickCount = _this.totalTicks.clone();
	    _this.largestTickWidth = 0;
	    _this.stave = null;
	    // Do we care about strictly timed notes
	    _this.mode = Voice.Mode.STRICT;
	
	    // This must belong to a VoiceGroup
	    _this.voiceGroup = null;
	    return _this;
	  }
	
	  // Get the total ticks in the voice
	
	
	  _createClass(Voice, [{
	    key: 'getTotalTicks',
	    value: function getTotalTicks() {
	      return this.totalTicks;
	    }
	
	    // Get the total ticks used in the voice by all the tickables
	
	  }, {
	    key: 'getTicksUsed',
	    value: function getTicksUsed() {
	      return this.ticksUsed;
	    }
	
	    // Get the largest width of all the tickables
	
	  }, {
	    key: 'getLargestTickWidth',
	    value: function getLargestTickWidth() {
	      return this.largestTickWidth;
	    }
	
	    // Get the tick count for the shortest tickable
	
	  }, {
	    key: 'getSmallestTickCount',
	    value: function getSmallestTickCount() {
	      return this.smallestTickCount;
	    }
	
	    // Get the tickables in the voice
	
	  }, {
	    key: 'getTickables',
	    value: function getTickables() {
	      return this.tickables;
	    }
	
	    // Get/set the voice mode, use a value from `Voice.Mode`
	
	  }, {
	    key: 'getMode',
	    value: function getMode() {
	      return this.mode;
	    }
	  }, {
	    key: 'setMode',
	    value: function setMode(mode) {
	      this.mode = mode;return this;
	    }
	
	    // Get the resolution multiplier for the voice
	
	  }, {
	    key: 'getResolutionMultiplier',
	    value: function getResolutionMultiplier() {
	      return this.resolutionMultiplier;
	    }
	
	    // Get the actual tick resolution for the voice
	
	  }, {
	    key: 'getActualResolution',
	    value: function getActualResolution() {
	      return this.resolutionMultiplier * this.time.resolution;
	    }
	
	    // Set the voice's stave
	
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      this.stave = stave;
	      this.boundingBox = null; // Reset bounding box so we can reformat
	      return this;
	    }
	
	    // Get the bounding box for the voice
	
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      var stave = void 0;
	      var boundingBox = void 0;
	      var bb = void 0;
	      var i = void 0;
	
	      if (!this.boundingBox) {
	        if (!this.stave) throw new _vex.Vex.RERR('NoStave', "Can't get bounding box without stave.");
	        stave = this.stave;
	        boundingBox = null;
	
	        for (i = 0; i < this.tickables.length; ++i) {
	          this.tickables[i].setStave(stave);
	
	          bb = this.tickables[i].getBoundingBox();
	          if (!bb) continue;
	
	          boundingBox = boundingBox ? boundingBox.mergeWith(bb) : bb;
	        }
	
	        this.boundingBox = boundingBox;
	      }
	      return this.boundingBox;
	    }
	
	    // Every tickable must be associated with a voiceGroup. This allows formatters
	    // and preformatters to associate them with the right modifierContexts.
	
	  }, {
	    key: 'getVoiceGroup',
	    value: function getVoiceGroup() {
	      if (!this.voiceGroup) {
	        throw new _vex.Vex.RERR('NoVoiceGroup', 'No voice group for voice.');
	      }
	
	      return this.voiceGroup;
	    }
	
	    // Set the voice group
	
	  }, {
	    key: 'setVoiceGroup',
	    value: function setVoiceGroup(g) {
	      this.voiceGroup = g;return this;
	    }
	
	    // Set the voice mode to strict or soft
	
	  }, {
	    key: 'setStrict',
	    value: function setStrict(strict) {
	      this.mode = strict ? Voice.Mode.STRICT : Voice.Mode.SOFT;
	      return this;
	    }
	
	    // Determine if the voice is complete according to the voice mode
	
	  }, {
	    key: 'isComplete',
	    value: function isComplete() {
	      if (this.mode === Voice.Mode.STRICT || this.mode === Voice.Mode.FULL) {
	        return this.ticksUsed.equals(this.totalTicks);
	      } else {
	        return true;
	      }
	    }
	
	    // Add a tickable to the voice
	
	  }, {
	    key: 'addTickable',
	    value: function addTickable(tickable) {
	      if (!tickable.shouldIgnoreTicks()) {
	        var ticks = tickable.getTicks();
	
	        // Update the total ticks for this line.
	        this.ticksUsed.add(ticks);
	
	        if ((this.mode === Voice.Mode.STRICT || this.mode === Voice.Mode.FULL) && this.ticksUsed.greaterThan(this.totalTicks)) {
	          this.totalTicks.subtract(ticks);
	          throw new _vex.Vex.RERR('BadArgument', 'Too many ticks.');
	        }
	
	        // Track the smallest tickable for formatting.
	        if (ticks.lessThan(this.smallestTickCount)) {
	          this.smallestTickCount = ticks.clone();
	        }
	
	        this.resolutionMultiplier = this.ticksUsed.denominator;
	
	        // Expand total ticks using denominator from ticks used.
	        this.totalTicks.add(0, this.ticksUsed.denominator);
	      }
	
	      // Add the tickable to the line.
	      this.tickables.push(tickable);
	      tickable.setVoice(this);
	      return this;
	    }
	
	    // Add an array of tickables to the voice.
	
	  }, {
	    key: 'addTickables',
	    value: function addTickables(tickables) {
	      for (var i = 0; i < tickables.length; ++i) {
	        this.addTickable(tickables[i]);
	      }
	
	      return this;
	    }
	
	    // Preformats the voice by applying the voice's stave to each note.
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      var _this2 = this;
	
	      if (this.preFormatted) return this;
	
	      this.tickables.forEach(function (tickable) {
	        if (!tickable.getStave()) {
	          tickable.setStave(_this2.stave);
	        }
	      });
	
	      this.preFormatted = true;
	      return this;
	    }
	
	    // Render the voice onto the canvas `context` and an optional `stave`.
	    // If `stave` is omitted, it is expected that the notes have staves
	    // already set.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var context = arguments.length <= 0 || arguments[0] === undefined ? this.context : arguments[0];
	      var stave = arguments.length <= 1 || arguments[1] === undefined ? this.stave : arguments[1];
	
	      this.setRendered();
	      var boundingBox = null;
	      for (var i = 0; i < this.tickables.length; ++i) {
	        var tickable = this.tickables[i];
	
	        // Set the stave if provided
	        if (stave) tickable.setStave(stave);
	
	        if (!tickable.getStave()) {
	          throw new _vex.Vex.RuntimeError('MissingStave', 'The voice cannot draw tickables without staves.');
	        }
	
	        if (i === 0) boundingBox = tickable.getBoundingBox();
	
	        if (i > 0 && boundingBox) {
	          var tickable_bb = tickable.getBoundingBox();
	          if (tickable_bb) boundingBox.mergeWith(tickable_bb);
	        }
	
	        tickable.setContext(context);
	        tickable.draw();
	      }
	
	      this.boundingBox = boundingBox;
	    }
	  }]);

	  return Voice;
	}(_element.Element);

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveConnector = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	function drawBoldDoubleLine(ctx, type, topX, topY, botY) {
	  if (type !== StaveConnector.type.BOLD_DOUBLE_LEFT && type !== StaveConnector.type.BOLD_DOUBLE_RIGHT) {
	    throw new _vex.Vex.RERR('InvalidConnector', 'A REPEAT_BEGIN or REPEAT_END type must be provided.');
	  }
	
	  var x_shift = 3;
	  var variableWidth = 3.5; // Width for avoiding anti-aliasing width issues
	  var thickLineOffset = 2; // For aesthetics
	
	  if (type === StaveConnector.type.BOLD_DOUBLE_RIGHT) {
	    x_shift = -5; // Flips the side of the thin line
	    variableWidth = 3;
	  }
	
	  // Thin line
	  ctx.fillRect(topX + x_shift, topY, 1, botY - topY);
	  // Thick line
	  ctx.fillRect(topX - thickLineOffset, topY, variableWidth, botY - topY);
	}
	
	var StaveConnector = exports.StaveConnector = function (_Element) {
	  _inherits(StaveConnector, _Element);
	
	  _createClass(StaveConnector, null, [{
	    key: 'type',
	
	    // SINGLE_LEFT and SINGLE are the same value for compatibility
	    // with older versions of vexflow which didn't have right sided
	    // stave connectors
	    get: function get() {
	      return {
	        SINGLE_RIGHT: 0,
	        SINGLE_LEFT: 1,
	        SINGLE: 1,
	        DOUBLE: 2,
	        BRACE: 3,
	        BRACKET: 4,
	        BOLD_DOUBLE_LEFT: 5,
	        BOLD_DOUBLE_RIGHT: 6,
	        THIN_DOUBLE: 7,
	        NONE: 8
	      };
	    }
	  }, {
	    key: 'typeString',
	    get: function get() {
	      return {
	        singleRight: StaveConnector.type.SINGLE_RIGHT,
	        singleLeft: StaveConnector.type.SINGLE_LEFT,
	        single: StaveConnector.type.SINGLE,
	        double: StaveConnector.type.DOUBLE,
	        brace: StaveConnector.type.BRACE,
	        bracket: StaveConnector.type.BRACKET,
	        boldDoubleLeft: StaveConnector.type.BOLD_DOUBLE_LEFT,
	        boldDoubleRight: StaveConnector.type.BOLD_DOUBLE_RIGHT,
	        thinDouble: StaveConnector.type.THIN_DOUBLE,
	        none: StaveConnector.type.NONE
	      };
	    }
	  }]);
	
	  function StaveConnector(top_stave, bottom_stave) {
	    _classCallCheck(this, StaveConnector);
	
	    var _this = _possibleConstructorReturn(this, (StaveConnector.__proto__ || Object.getPrototypeOf(StaveConnector)).call(this));
	
	    _this.setAttribute('type', 'StaveConnector');
	
	    _this.thickness = _tables.Flow.STAVE_LINE_THICKNESS;
	    _this.width = 3;
	    _this.top_stave = top_stave;
	    _this.bottom_stave = bottom_stave;
	    _this.type = StaveConnector.type.DOUBLE;
	    _this.font = {
	      family: 'times',
	      size: 16,
	      weight: 'normal'
	    };
	    // 1. Offset Bold Double Left to align with offset Repeat Begin bars
	    // 2. Offset BRACE type not to overlap with another StaveConnector
	    _this.x_shift = 0;
	    _this.texts = [];
	    return _this;
	  }
	
	  _createClass(StaveConnector, [{
	    key: 'setType',
	    value: function setType(type) {
	      type = typeof type === 'string' ? StaveConnector.typeString[type] : type;
	
	      if (type >= StaveConnector.type.SINGLE_RIGHT && type <= StaveConnector.type.NONE) {
	        this.type = type;
	      }
	      return this;
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text, options) {
	      this.texts.push({
	        content: text,
	        options: _vex.Vex.Merge({ shift_x: 0, shift_y: 0 }, options)
	      });
	      return this;
	    }
	  }, {
	    key: 'setFont',
	    value: function setFont(font) {
	      _vex.Vex.Merge(this.font, font);
	    }
	  }, {
	    key: 'setXShift',
	    value: function setXShift(x_shift) {
	      if (typeof x_shift !== 'number') {
	        throw _vex.Vex.RERR('InvalidType', 'x_shift must be a Number');
	      }
	
	      this.x_shift = x_shift;
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.checkContext();
	      this.setRendered();
	
	      var topY = this.top_stave.getYForLine(0);
	      var botY = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) + this.thickness;
	      var width = this.width;
	      var topX = this.top_stave.getX();
	
	      var isRightSidedConnector = this.type === StaveConnector.type.SINGLE_RIGHT || this.type === StaveConnector.type.BOLD_DOUBLE_RIGHT || this.type === StaveConnector.type.THIN_DOUBLE;
	
	      if (isRightSidedConnector) {
	        topX = this.top_stave.getX() + this.top_stave.width;
	      }
	
	      var attachment_height = botY - topY;
	      switch (this.type) {
	        case StaveConnector.type.SINGLE:
	          width = 1;
	          break;
	        case StaveConnector.type.SINGLE_LEFT:
	          width = 1;
	          break;
	        case StaveConnector.type.SINGLE_RIGHT:
	          width = 1;
	          break;
	        case StaveConnector.type.DOUBLE:
	          topX -= this.width + 2;
	          break;
	        case StaveConnector.type.BRACE:
	          {
	            width = 12;
	            // May need additional code to draw brace
	            var x1 = this.top_stave.getX() - 2 + this.x_shift;
	            var y1 = topY;
	            var x3 = x1;
	            var y3 = botY;
	            var x2 = x1 - width;
	            var y2 = y1 + attachment_height / 2.0;
	            var cpx1 = x2 - 0.90 * width;
	            var cpy1 = y1 + 0.2 * attachment_height;
	            var cpx2 = x1 + 1.10 * width;
	            var cpy2 = y2 - 0.135 * attachment_height;
	            var cpx3 = cpx2;
	            var cpy3 = y2 + 0.135 * attachment_height;
	            var cpx4 = cpx1;
	            var cpy4 = y3 - 0.2 * attachment_height;
	            var cpx5 = x2 - width;
	            var cpy5 = cpy4;
	            var cpx6 = x1 + 0.40 * width;
	            var cpy6 = y2 + 0.135 * attachment_height;
	            var cpx7 = cpx6;
	            var cpy7 = y2 - 0.135 * attachment_height;
	            var cpx8 = cpx5;
	            var cpy8 = cpy1;
	            ctx.beginPath();
	            ctx.moveTo(x1, y1);
	            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	            ctx.bezierCurveTo(cpx3, cpy3, cpx4, cpy4, x3, y3);
	            ctx.bezierCurveTo(cpx5, cpy5, cpx6, cpy6, x2, y2);
	            ctx.bezierCurveTo(cpx7, cpy7, cpx8, cpy8, x1, y1);
	            ctx.fill();
	            ctx.stroke();
	            break;
	          }case StaveConnector.type.BRACKET:
	          topY -= 4;
	          botY += 4;
	          attachment_height = botY - topY;
	          _glyph.Glyph.renderGlyph(ctx, topX - 5, topY - 3, 40, 'v1b', true);
	          _glyph.Glyph.renderGlyph(ctx, topX - 5, botY + 3, 40, 'v10', true);
	          topX -= this.width + 2;
	          break;
	        case StaveConnector.type.BOLD_DOUBLE_LEFT:
	          drawBoldDoubleLine(ctx, this.type, topX + this.x_shift, topY, botY);
	          break;
	        case StaveConnector.type.BOLD_DOUBLE_RIGHT:
	          drawBoldDoubleLine(ctx, this.type, topX, topY, botY);
	          break;
	        case StaveConnector.type.THIN_DOUBLE:
	          width = 1;
	          break;
	        case StaveConnector.type.NONE:
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidType', 'The provided StaveConnector.type (' + this.type + ') is invalid');
	      }
	
	      if (this.type !== StaveConnector.type.BRACE && this.type !== StaveConnector.type.BOLD_DOUBLE_LEFT && this.type !== StaveConnector.type.BOLD_DOUBLE_RIGHT && this.type !== StaveConnector.type.NONE) {
	        ctx.fillRect(topX, topY, width, attachment_height);
	      }
	
	      // If the connector is a thin double barline, draw the paralell line
	      if (this.type === StaveConnector.type.THIN_DOUBLE) {
	        ctx.fillRect(topX - 3, topY, width, attachment_height);
	      }
	
	      ctx.save();
	      ctx.lineWidth = 2;
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      // Add stave connector text
	      for (var i = 0; i < this.texts.length; i++) {
	        var text = this.texts[i];
	        var text_width = ctx.measureText('' + text.content).width;
	        var x = this.top_stave.getX() - text_width - 24 + text.options.shift_x;
	        var y = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 + text.options.shift_y;
	
	        ctx.fillText('' + text.content, x, y + 4);
	      }
	      ctx.restore();
	    }
	  }]);

	  return StaveConnector;
	}(_element.Element);

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveNote = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _boundingbox = __webpack_require__(8);
	
	var _stem = __webpack_require__(17);
	
	var _notehead = __webpack_require__(21);
	
	var _stemmablenote = __webpack_require__(24);
	
	var _modifier = __webpack_require__(25);
	
	var _dot = __webpack_require__(26);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This file implements notes for standard notation. This consists of one or
	// more `NoteHeads`, an optional stem, and an optional flag.
	//
	// *Throughout these comments, a "note" refers to the entire `StaveNote`,
	// and a "key" refers to a specific pitch/notehead within a note.*
	//
	// See `tests/stavenote_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.StaveNote.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (StaveNote.DEBUG) _vex.Vex.L('Vex.Flow.StaveNote', args);
	}
	
	var getStemAdjustment = function getStemAdjustment(note) {
	  return _stem.Stem.WIDTH / (2 * -note.getStemDirection());
	};
	
	var isInnerNoteIndex = function isInnerNoteIndex(note, index) {
	  return index === (note.getStemDirection() === _stem.Stem.UP ? note.keyProps.length - 1 : 0);
	};
	
	// Helper methods for rest positioning in ModifierContext.
	function shiftRestVertical(rest, note, dir) {
	  var delta = (note.isrest ? 0.0 : 1.0) * dir;
	
	  rest.line += delta;
	  rest.maxLine += delta;
	  rest.minLine += delta;
	  rest.note.setKeyLine(0, rest.note.getKeyLine(0) + delta);
	}
	
	// Called from formatNotes :: center a rest between two notes
	function centerRest(rest, noteU, noteL) {
	  var delta = rest.line - _vex.Vex.MidLine(noteU.minLine, noteL.maxLine);
	  rest.note.setKeyLine(0, rest.note.getKeyLine(0) - delta);
	  rest.line -= delta;
	  rest.maxLine -= delta;
	  rest.minLine -= delta;
	}
	
	var StaveNote = exports.StaveNote = function (_StemmableNote) {
	  _inherits(StaveNote, _StemmableNote);
	
	  _createClass(StaveNote, null, [{
	    key: 'format',
	
	
	    // ## Static Methods
	    //
	    // Format notes inside a ModifierContext.
	    value: function format(notes, state) {
	      if (!notes || notes.length < 2) return false;
	
	      // FIXME: VexFlow will soon require that a stave be set before formatting.
	      // Which, according to the below condition, means that following branch will
	      // always be taken and the rest of this function is dead code.
	      //
	      // Problematically, `Formatter#formatByY` was not designed to work for more
	      // than 2 voices (although, doesn't throw on this condition, just tries
	      // to power through).
	      //
	      // Based on the above:
	      //   * 2 voices can be formatted *with or without* a stave being set but
	      //     the output will be different
	      //   * 3 voices can only be formatted *without* a stave
	      if (notes[0].getStave()) {
	        return StaveNote.formatByY(notes, state);
	      }
	
	      var notesList = [];
	
	      for (var i = 0; i < notes.length; i++) {
	        var props = notes[i].getKeyProps();
	        var line = props[0].line;
	        var minL = props[props.length - 1].line;
	        var stemDirection = notes[i].getStemDirection();
	        var stemMax = notes[i].getStemLength() / 10;
	        var stemMin = notes[i].getStemMinumumLength() / 10;
	
	        var maxL = void 0;
	        if (notes[i].isRest()) {
	          maxL = line + notes[i].glyph.line_above;
	          minL = line - notes[i].glyph.line_below;
	        } else {
	          maxL = stemDirection === 1 ? props[props.length - 1].line + stemMax : props[props.length - 1].line;
	
	          minL = stemDirection === 1 ? props[0].line : props[0].line - stemMax;
	        }
	
	        notesList.push({
	          line: props[0].line, // note/rest base line
	          maxLine: maxL, // note/rest upper bounds line
	          minLine: minL, // note/rest lower bounds line
	          isrest: notes[i].isRest(),
	          stemDirection: stemDirection,
	          stemMax: stemMax, // Maximum (default) note stem length;
	          stemMin: stemMin, // minimum note stem length
	          voice_shift: notes[i].getVoiceShiftWidth(),
	          is_displaced: notes[i].isDisplaced(), // note manually displaced
	          note: notes[i]
	        });
	      }
	
	      var voices = notesList.length;
	
	      var noteU = notesList[0];
	      var noteM = voices > 2 ? notesList[1] : null;
	      var noteL = voices > 2 ? notesList[2] : notesList[1];
	
	      // for two voice backward compatibility, ensure upper voice is stems up
	      // for three voices, the voices must be in order (upper, middle, lower)
	      if (voices === 2 && noteU.stemDirection === -1 && noteL.stemDirection === 1) {
	        noteU = notesList[1];
	        noteL = notesList[0];
	      }
	
	      var voiceXShift = Math.max(noteU.voice_shift, noteL.voice_shift);
	      var xShift = 0;
	      var stemDelta = void 0;
	
	      // Test for two voice note intersection
	      if (voices === 2) {
	        var lineSpacing = noteU.stemDirection === noteL.stemDirection ? 0.0 : 0.5;
	        // if top voice is a middle voice, check stem intersection with lower voice
	        if (noteU.stemDirection === noteL.stemDirection && noteU.minLine <= noteL.maxLine) {
	          if (!noteU.isrest) {
	            stemDelta = Math.abs(noteU.line - (noteL.maxLine + 0.5));
	            stemDelta = Math.max(stemDelta, noteU.stemMin);
	            noteU.minLine = noteU.line - stemDelta;
	            noteU.note.setStemLength(stemDelta * 10);
	          }
	        }
	        if (noteU.minLine <= noteL.maxLine + lineSpacing) {
	          if (noteU.isrest) {
	            // shift rest up
	            shiftRestVertical(noteU, noteL, 1);
	          } else if (noteL.isrest) {
	            // shift rest down
	            shiftRestVertical(noteL, noteU, -1);
	          } else {
	            xShift = voiceXShift;
	            if (noteU.stemDirection === noteL.stemDirection) {
	              // upper voice is middle voice, so shift it right
	              noteU.note.setXShift(xShift + 3);
	            } else {
	              // shift lower voice right
	              noteL.note.setXShift(xShift);
	            }
	          }
	        }
	
	        // format complete
	        return true;
	      }
	
	      // Check middle voice stem intersection with lower voice
	      if (noteM !== null && noteM.minLine < noteL.maxLine + 0.5) {
	        if (!noteM.isrest) {
	          stemDelta = Math.abs(noteM.line - (noteL.maxLine + 0.5));
	          stemDelta = Math.max(stemDelta, noteM.stemMin);
	          noteM.minLine = noteM.line - stemDelta;
	          noteM.note.setStemLength(stemDelta * 10);
	        }
	      }
	
	      // For three voices, test if rests can be repositioned
	      //
	      // Special case 1 :: middle voice rest between two notes
	      //
	      if (noteM.isrest && !noteU.isrest && !noteL.isrest) {
	        if (noteU.minLine <= noteM.maxLine || noteM.minLine <= noteL.maxLine) {
	          var restHeight = noteM.maxLine - noteM.minLine;
	          var space = noteU.minLine - noteL.maxLine;
	          if (restHeight < space) {
	            // center middle voice rest between the upper and lower voices
	            centerRest(noteM, noteU, noteL);
	          } else {
	            xShift = voiceXShift + 3; // shift middle rest right
	            noteM.note.setXShift(xShift);
	          }
	          // format complete
	          return true;
	        }
	      }
	
	      // Special case 2 :: all voices are rests
	      if (noteU.isrest && noteM.isrest && noteL.isrest) {
	        // Shift upper voice rest up
	        shiftRestVertical(noteU, noteM, 1);
	        // Shift lower voice rest down
	        shiftRestVertical(noteL, noteM, -1);
	        // format complete
	        return true;
	      }
	
	      // Test if any other rests can be repositioned
	      if (noteM.isrest && noteU.isrest && noteM.minLine <= noteL.maxLine) {
	        // Shift middle voice rest up
	        shiftRestVertical(noteM, noteL, 1);
	      }
	      if (noteM.isrest && noteL.isrest && noteU.minLine <= noteM.maxLine) {
	        // Shift middle voice rest down
	        shiftRestVertical(noteM, noteU, -1);
	      }
	      if (noteU.isrest && noteU.minLine <= noteM.maxLine) {
	        // shift upper voice rest up;
	        shiftRestVertical(noteU, noteM, 1);
	      }
	      if (noteL.isrest && noteM.minLine <= noteL.maxLine) {
	        // shift lower voice rest down
	        shiftRestVertical(noteL, noteM, -1);
	      }
	
	      // If middle voice intersects upper or lower voice
	      if (!noteU.isrest && !noteM.isrest && noteU.minLine <= noteM.maxLine + 0.5 || !noteM.isrest && !noteL.isrest && noteM.minLine <= noteL.maxLine) {
	        xShift = voiceXShift + 3; // shift middle note right
	        noteM.note.setXShift(xShift);
	      }
	
	      return true;
	    }
	  }, {
	    key: 'formatByY',
	    value: function formatByY(notes, state) {
	      // NOTE: this function does not support more than two voices per stave
	      // use with care.
	      var hasStave = true;
	
	      for (var i = 0; i < notes.length; i++) {
	        hasStave = hasStave && notes[i].getStave() != null;
	      }
	
	      if (!hasStave) {
	        throw new _vex.Vex.RERR('Stave Missing', 'All notes must have a stave - Vex.Flow.ModifierContext.formatMultiVoice!');
	      }
	
	      var xShift = 0;
	
	      for (var _i = 0; _i < notes.length - 1; _i++) {
	        var topNote = notes[_i];
	        var bottomNote = notes[_i + 1];
	
	        if (topNote.getStemDirection() === _stem.Stem.DOWN) {
	          topNote = notes[_i + 1];
	          bottomNote = notes[_i];
	        }
	
	        var topKeys = topNote.getKeyProps();
	        var bottomKeys = bottomNote.getKeyProps();
	
	        var HALF_NOTEHEAD_HEIGHT = 0.5;
	
	        // `keyProps` and `stave.getYForLine` have different notions of a `line`
	        // so we have to convert the keyProps value by subtracting 5.
	        // See https://github.com/0xfe/vexflow/wiki/Development-Gotchas
	        //
	        // We also extend the y for each note by a half notehead because the
	        // notehead's origin is centered
	        var topNotBottomY = topNote.getStave().getYForLine(5 - topKeys[0].line + HALF_NOTEHEAD_HEIGHT);
	
	        var bottomNoteTopY = bottomNote.getStave().getYForLine(5 - bottomKeys[bottomKeys.length - 1].line - HALF_NOTEHEAD_HEIGHT);
	
	        var areNotesColliding = bottomNoteTopY - topNotBottomY < 0;
	
	        if (areNotesColliding) {
	          xShift = topNote.getVoiceShiftWidth() + 2;
	          bottomNote.setXShift(xShift);
	        }
	      }
	
	      state.right_shift += xShift;
	    }
	  }, {
	    key: 'postFormat',
	    value: function postFormat(notes) {
	      if (!notes) return false;
	
	      notes.forEach(function (note) {
	        return note.postFormat();
	      });
	
	      return true;
	    }
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stavenotes';
	    }
	  }, {
	    key: 'STEM_UP',
	    get: function get() {
	      return _stem.Stem.UP;
	    }
	  }, {
	    key: 'STEM_DOWN',
	    get: function get() {
	      return _stem.Stem.DOWN;
	    }
	  }, {
	    key: 'DEFAULT_LEDGER_LINE_OFFSET',
	    get: function get() {
	      return 3;
	    }
	  }]);
	
	  function StaveNote(noteStruct) {
	    _classCallCheck(this, StaveNote);
	
	    var _this = _possibleConstructorReturn(this, (StaveNote.__proto__ || Object.getPrototypeOf(StaveNote)).call(this, noteStruct));
	
	    _this.setAttribute('type', 'StaveNote');
	
	    _this.keys = noteStruct.keys;
	    _this.clef = noteStruct.clef;
	    _this.octave_shift = noteStruct.octave_shift;
	    _this.beam = null;
	
	    // Pull note rendering properties
	    _this.glyph = _tables.Flow.durationToGlyph(_this.duration, _this.noteType);
	
	    if (!_this.glyph) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Invalid note initialization data (No glyph found): ' + JSON.stringify(noteStruct));
	    }
	
	    // if true, displace note to right
	    _this.displaced = false;
	    _this.dot_shiftY = 0;
	    // per-pitch properties
	    _this.keyProps = [];
	    // for displaced ledger lines
	    _this.use_default_head_x = false;
	
	    // Drawing
	    _this.note_heads = [];
	    _this.modifiers = [];
	
	    _vex.Vex.Merge(_this.render_options, {
	      // font size for note heads and rests
	      glyph_font_scale: noteStruct.glyph_font_scale || _tables.Flow.DEFAULT_NOTATION_FONT_SCALE,
	      // number of stroke px to the left and right of head
	      stroke_px: noteStruct.stroke_px || StaveNote.DEFAULT_LEDGER_LINE_OFFSET
	    });
	
	    _this.calculateKeyProps();
	    _this.buildStem();
	
	    // Set the stem direction
	    if (noteStruct.auto_stem) {
	      _this.autoStem();
	    } else {
	      _this.setStemDirection(noteStruct.stem_direction);
	    }
	    _this.reset();
	    _this.buildFlag();
	    return _this;
	  }
	
	  _createClass(StaveNote, [{
	    key: 'reset',
	    value: function reset() {
	      var _this2 = this;
	
	      _get(StaveNote.prototype.__proto__ || Object.getPrototypeOf(StaveNote.prototype), 'reset', this).call(this);
	
	      // Save prior noteHead styles & reapply them after making new noteheads.
	      var noteHeadStyles = this.note_heads.map(function (noteHead) {
	        return noteHead.getStyle();
	      });
	      this.buildNoteHeads();
	      this.note_heads.forEach(function (noteHead, index) {
	        return noteHead.setStyle(noteHeadStyles[index]);
	      });
	
	      if (this.stave) {
	        this.note_heads.forEach(function (head) {
	          return head.setStave(_this2.stave);
	        });
	      }
	      this.calcExtraPx();
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return StaveNote.CATEGORY;
	    }
	
	    // Builds a `Stem` for the note
	
	  }, {
	    key: 'buildStem',
	    value: function buildStem() {
	      var glyph = this.getGlyph();
	      var yExtend = glyph.code_head === 'v95' || glyph.code_head === 'v3e' ? -4 : 0;
	
	      this.setStem(new _stem.Stem({
	        yExtend: yExtend,
	        hide: !!this.isRest()
	      }));
	    }
	
	    // Builds a `NoteHead` for each key in the note
	
	  }, {
	    key: 'buildNoteHeads',
	    value: function buildNoteHeads() {
	      this.note_heads = [];
	      var stemDirection = this.getStemDirection();
	      var keys = this.getKeys();
	
	      var lastLine = null;
	      var lineDiff = null;
	      var displaced = false;
	
	      // Draw notes from bottom to top.
	
	      // For down-stem notes, we draw from top to bottom.
	      var start = void 0;
	      var end = void 0;
	      var step = void 0;
	      if (stemDirection === _stem.Stem.UP) {
	        start = 0;
	        end = keys.length;
	        step = 1;
	      } else if (stemDirection === _stem.Stem.DOWN) {
	        start = keys.length - 1;
	        end = -1;
	        step = -1;
	      }
	
	      for (var i = start; i !== end; i += step) {
	        var noteProps = this.keyProps[i];
	        var line = noteProps.line;
	
	        // Keep track of last line with a note head, so that consecutive heads
	        // are correctly displaced.
	        if (lastLine === null) {
	          lastLine = line;
	        } else {
	          lineDiff = Math.abs(lastLine - line);
	          if (lineDiff === 0 || lineDiff === 0.5) {
	            displaced = !displaced;
	          } else {
	            displaced = false;
	            this.use_default_head_x = true;
	          }
	        }
	        lastLine = line;
	
	        var notehead = new _notehead.NoteHead({
	          duration: this.duration,
	          note_type: this.noteType,
	          displaced: displaced,
	          stem_direction: stemDirection,
	          custom_glyph_code: noteProps.code,
	          glyph_font_scale: this.render_options.glyph_font_scale,
	          x_shift: noteProps.shift_right,
	          line: noteProps.line
	        });
	
	        this.note_heads[i] = notehead;
	      }
	    }
	
	    // Automatically sets the stem direction based on the keys in the note
	
	  }, {
	    key: 'autoStem',
	    value: function autoStem() {
	      // Figure out optimal stem direction based on given notes
	      this.minLine = this.keyProps[0].line;
	      this.maxLine = this.keyProps[this.keyProps.length - 1].line;
	
	      var MIDDLE_LINE = 3;
	      var decider = (this.minLine + this.maxLine) / 2;
	      var stemDirection = decider < MIDDLE_LINE ? _stem.Stem.UP : _stem.Stem.DOWN;
	
	      this.setStemDirection(stemDirection);
	    }
	
	    // Calculates and stores the properties for each key in the note
	
	  }, {
	    key: 'calculateKeyProps',
	    value: function calculateKeyProps() {
	      var lastLine = null;
	      for (var i = 0; i < this.keys.length; ++i) {
	        var key = this.keys[i];
	
	        // All rests use the same position on the line.
	        // if (this.glyph.rest) key = this.glyph.position;
	        if (this.glyph.rest) this.glyph.position = key;
	
	        var options = { octave_shift: this.octave_shift || 0 };
	        var props = _tables.Flow.keyProperties(key, this.clef, options);
	
	        if (!props) {
	          throw new _vex.Vex.RuntimeError('BadArguments', 'Invalid key for note properties: ' + key);
	        }
	
	        // Override line placement for default rests
	        if (props.key === 'R') {
	          if (this.duration === '1' || this.duration === 'w') {
	            props.line = 4;
	          } else {
	            props.line = 3;
	          }
	        }
	
	        // Calculate displacement of this note
	        var line = props.line;
	        if (lastLine === null) {
	          lastLine = line;
	        } else {
	          if (Math.abs(lastLine - line) === 0.5) {
	            this.displaced = true;
	            props.displaced = true;
	
	            // Have to mark the previous note as
	            // displaced as well, for modifier placement
	            if (this.keyProps.length > 0) {
	              this.keyProps[i - 1].displaced = true;
	            }
	          }
	        }
	
	        lastLine = line;
	        this.keyProps.push(props);
	      }
	
	      // Sort the notes from lowest line to highest line
	      lastLine = -Infinity;
	      this.keyProps.forEach(function (key) {
	        if (key.line < lastLine) {
	          _vex.Vex.W('Unsorted keys in note will be sorted. ' + 'See https://github.com/0xfe/vexflow/issues/104 for details.');
	        }
	        lastLine = key.line;
	      });
	      this.keyProps.sort(function (a, b) {
	        return a.line - b.line;
	      });
	    }
	
	    // Get the `BoundingBox` for the entire note
	
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call getBoundingBox on an unformatted note.");
	      }
	
	      var _getMetrics = this.getMetrics();
	
	      var w = _getMetrics.width;
	      var modLeftPx = _getMetrics.modLeftPx;
	      var extraLeftPx = _getMetrics.extraLeftPx;
	
	      var x = this.getAbsoluteX() - modLeftPx - extraLeftPx;
	
	      var minY = 0;
	      var maxY = 0;
	      var halfLineSpacing = this.getStave().getSpacingBetweenLines() / 2;
	      var lineSpacing = halfLineSpacing * 2;
	
	      if (this.isRest()) {
	        var y = this.ys[0];
	        var frac = _tables.Flow.durationToFraction(this.duration);
	        if (frac.equals(1) || frac.equals(2)) {
	          minY = y - halfLineSpacing;
	          maxY = y + halfLineSpacing;
	        } else {
	          minY = y - this.glyph.line_above * lineSpacing;
	          maxY = y + this.glyph.line_below * lineSpacing;
	        }
	      } else if (this.glyph.stem) {
	        var ys = this.getStemExtents();
	        ys.baseY += halfLineSpacing * this.stem_direction;
	        minY = Math.min(ys.topY, ys.baseY);
	        maxY = Math.max(ys.topY, ys.baseY);
	      } else {
	        minY = null;
	        maxY = null;
	
	        for (var i = 0; i < this.ys.length; ++i) {
	          var yy = this.ys[i];
	          if (i === 0) {
	            minY = yy;
	            maxY = yy;
	          } else {
	            minY = Math.min(yy, minY);
	            maxY = Math.max(yy, maxY);
	          }
	        }
	        minY -= halfLineSpacing;
	        maxY += halfLineSpacing;
	      }
	
	      return new _boundingbox.BoundingBox(x, minY, w, maxY - minY);
	    }
	
	    // Gets the line number of the top or bottom note in the chord.
	    // If `isTopNote` is `true` then get the top note
	
	  }, {
	    key: 'getLineNumber',
	    value: function getLineNumber(isTopNote) {
	      if (!this.keyProps.length) {
	        throw new _vex.Vex.RERR('NoKeyProps', "Can't get bottom note line, because note is not initialized properly.");
	      }
	
	      var resultLine = this.keyProps[0].line;
	
	      // No precondition assumed for sortedness of keyProps array
	      for (var i = 0; i < this.keyProps.length; i++) {
	        var thisLine = this.keyProps[i].line;
	        if (isTopNote) {
	          if (thisLine > resultLine) resultLine = thisLine;
	        } else {
	          if (thisLine < resultLine) resultLine = thisLine;
	        }
	      }
	
	      return resultLine;
	    }
	
	    // Determine if current note is a rest
	
	  }, {
	    key: 'isRest',
	    value: function isRest() {
	      return this.glyph.rest;
	    }
	
	    // Determine if the current note is a chord
	
	  }, {
	    key: 'isChord',
	    value: function isChord() {
	      return !this.isRest() && this.keys.length > 1;
	    }
	
	    // Determine if the `StaveNote` has a stem
	
	  }, {
	    key: 'hasStem',
	    value: function hasStem() {
	      return this.glyph.stem;
	    }
	  }, {
	    key: 'hasFlag',
	    value: function hasFlag() {
	      return _get(StaveNote.prototype.__proto__ || Object.getPrototypeOf(StaveNote.prototype), 'hasFlag', this).call(this) && !this.isRest();
	    }
	  }, {
	    key: 'getStemX',
	    value: function getStemX() {
	      if (this.noteType === 'r') {
	        return this.getCenterGlyphX();
	      } else {
	        // We adjust the origin of the stem because we want the stem left-aligned
	        // with the notehead if stemmed-down, and right-aligned if stemmed-up
	        return _get(StaveNote.prototype.__proto__ || Object.getPrototypeOf(StaveNote.prototype), 'getStemX', this).call(this) + getStemAdjustment(this);
	      }
	    }
	
	    // Get the `y` coordinate for text placed on the top/bottom of a
	    // note at a desired `text_line`
	
	  }, {
	    key: 'getYForTopText',
	    value: function getYForTopText(textLine) {
	      var extents = this.getStemExtents();
	      return Math.min(this.stave.getYForTopText(textLine), extents.topY - this.render_options.annotation_spacing * (textLine + 1));
	    }
	  }, {
	    key: 'getYForBottomText',
	    value: function getYForBottomText(textLine) {
	      var extents = this.getStemExtents();
	      return Math.max(this.stave.getYForTopText(textLine), extents.baseY + this.render_options.annotation_spacing * textLine);
	    }
	
	    // Sets the current note to the provided `stave`. This applies
	    // `y` values to the `NoteHeads`.
	
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      _get(StaveNote.prototype.__proto__ || Object.getPrototypeOf(StaveNote.prototype), 'setStave', this).call(this, stave);
	
	      var ys = this.note_heads.map(function (notehead) {
	        notehead.setStave(stave);
	        return notehead.getY();
	      });
	
	      this.setYs(ys);
	
	      if (this.stem) {
	        var _getNoteHeadBounds = this.getNoteHeadBounds();
	
	        var y_top = _getNoteHeadBounds.y_top;
	        var y_bottom = _getNoteHeadBounds.y_bottom;
	
	        this.stem.setYBounds(y_top, y_bottom);
	      }
	
	      return this;
	    }
	
	    // Get the pitches in the note
	
	  }, {
	    key: 'getKeys',
	    value: function getKeys() {
	      return this.keys;
	    }
	
	    // Get the properties for all the keys in the note
	
	  }, {
	    key: 'getKeyProps',
	    value: function getKeyProps() {
	      return this.keyProps;
	    }
	
	    // Check if note is shifted to the right
	
	  }, {
	    key: 'isDisplaced',
	    value: function isDisplaced() {
	      return this.displaced;
	    }
	
	    // Sets whether shift note to the right. `displaced` is a `boolean`
	
	  }, {
	    key: 'setNoteDisplaced',
	    value: function setNoteDisplaced(displaced) {
	      this.displaced = displaced;
	      return this;
	    }
	
	    // Get the starting `x` coordinate for a `StaveTie`
	
	  }, {
	    key: 'getTieRightX',
	    value: function getTieRightX() {
	      var tieStartX = this.getAbsoluteX();
	      tieStartX += this.getGlyphWidth() + this.x_shift + this.extraRightPx;
	      if (this.modifierContext) tieStartX += this.modifierContext.getExtraRightPx();
	      return tieStartX;
	    }
	
	    // Get the ending `x` coordinate for a `StaveTie`
	
	  }, {
	    key: 'getTieLeftX',
	    value: function getTieLeftX() {
	      var tieEndX = this.getAbsoluteX();
	      tieEndX += this.x_shift - this.extraLeftPx;
	      return tieEndX;
	    }
	
	    // Get the stave line on which to place a rest
	
	  }, {
	    key: 'getLineForRest',
	    value: function getLineForRest() {
	      var restLine = this.keyProps[0].line;
	      if (this.keyProps.length > 1) {
	        var lastLine = this.keyProps[this.keyProps.length - 1].line;
	        var top = Math.max(restLine, lastLine);
	        var bot = Math.min(restLine, lastLine);
	        restLine = _vex.Vex.MidLine(top, bot);
	      }
	
	      return restLine;
	    }
	
	    // Get the default `x` and `y` coordinates for the provided `position`
	    // and key `index`
	
	  }, {
	    key: 'getModifierStartXY',
	    value: function getModifierStartXY(position, index) {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call GetModifierStartXY on an unformatted note");
	      }
	
	      if (this.ys.length === 0) {
	        throw new _vex.Vex.RERR('NoYValues', 'No Y-Values calculated for this note.');
	      }
	
	      var _Modifier$Position = _modifier.Modifier.Position;
	      var ABOVE = _Modifier$Position.ABOVE;
	      var BELOW = _Modifier$Position.BELOW;
	      var LEFT = _Modifier$Position.LEFT;
	      var RIGHT = _Modifier$Position.RIGHT;
	
	      var x = 0;
	      if (position === LEFT) {
	        // extra_left_px
	        // FIXME: What are these magic numbers?
	        x = -1 * 2;
	      } else if (position === RIGHT) {
	        // extra_right_px
	        // FIXME: What is this magical +2?
	        x = this.getGlyphWidth() + this.x_shift + 2;
	
	        if (this.stem_direction === _stem.Stem.UP && this.hasFlag() && isInnerNoteIndex(this, index)) {
	          x += this.flag.getMetrics().width;
	        }
	      } else if (position === BELOW || position === ABOVE) {
	        x = this.getGlyphWidth() / 2;
	      }
	
	      return {
	        x: this.getAbsoluteX() + x,
	        y: this.ys[index]
	      };
	    }
	
	    // Sets the style of the complete StaveNote, including all keys
	    // and the stem.
	
	  }, {
	    key: 'setStyle',
	    value: function setStyle(style) {
	      _get(StaveNote.prototype.__proto__ || Object.getPrototypeOf(StaveNote.prototype), 'setStyle', this).call(this, style);
	      this.note_heads.forEach(function (notehead) {
	        return notehead.setStyle(style);
	      });
	      this.stem.setStyle(style);
	    }
	  }, {
	    key: 'setStemStyle',
	    value: function setStemStyle(style) {
	      var stem = this.getStem();
	      stem.setStyle(style);
	    }
	  }, {
	    key: 'getStemStyle',
	    value: function getStemStyle() {
	      return this.stem.getStyle();
	    }
	  }, {
	    key: 'setLedgerLineStyle',
	    value: function setLedgerLineStyle(style) {
	      this.ledgerLineStyle = style;
	    }
	  }, {
	    key: 'getLedgerLineStyle',
	    value: function getLedgerLineStyle() {
	      return this.ledgerLineStyle;
	    }
	  }, {
	    key: 'setFlagStyle',
	    value: function setFlagStyle(style) {
	      this.flagStyle = style;
	    }
	  }, {
	    key: 'getFlagStyle',
	    value: function getFlagStyle() {
	      return this.flagStyle;
	    }
	
	    // Sets the notehead at `index` to the provided coloring `style`.
	    //
	    // `style` is an `object` with the following properties: `shadowColor`,
	    // `shadowBlur`, `fillStyle`, `strokeStyle`
	
	  }, {
	    key: 'setKeyStyle',
	    value: function setKeyStyle(index, style) {
	      this.note_heads[index].setStyle(style);
	      return this;
	    }
	  }, {
	    key: 'setKeyLine',
	    value: function setKeyLine(index, line) {
	      this.keyProps[index].line = line;
	      this.reset();
	      return this;
	    }
	  }, {
	    key: 'getKeyLine',
	    value: function getKeyLine(index) {
	      return this.keyProps[index].line;
	    }
	
	    // Add self to modifier context. `mContext` is the `ModifierContext`
	    // to be added to.
	
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext(mContext) {
	      this.setModifierContext(mContext);
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        this.modifierContext.addModifier(this.modifiers[i]);
	      }
	      this.modifierContext.addModifier(this);
	      this.setPreFormatted(false);
	      return this;
	    }
	
	    // Generic function to add modifiers to a note
	    //
	    // Parameters:
	    // * `index`: The index of the key that we're modifying
	    // * `modifier`: The modifier to add
	
	  }, {
	    key: 'addModifier',
	    value: function addModifier(index, modifier) {
	      modifier.setNote(this);
	      modifier.setIndex(index);
	      this.modifiers.push(modifier);
	      this.setPreFormatted(false);
	      return this;
	    }
	
	    // Helper function to add an accidental to a key
	
	  }, {
	    key: 'addAccidental',
	    value: function addAccidental(index, accidental) {
	      return this.addModifier(index, accidental);
	    }
	
	    // Helper function to add an articulation to a key
	
	  }, {
	    key: 'addArticulation',
	    value: function addArticulation(index, articulation) {
	      return this.addModifier(index, articulation);
	    }
	
	    // Helper function to add an annotation to a key
	
	  }, {
	    key: 'addAnnotation',
	    value: function addAnnotation(index, annotation) {
	      return this.addModifier(index, annotation);
	    }
	
	    // Helper function to add a dot on a specific key
	
	  }, {
	    key: 'addDot',
	    value: function addDot(index) {
	      var dot = new _dot.Dot();
	      dot.setDotShiftY(this.glyph.dot_shiftY);
	      this.dots++;
	      return this.addModifier(index, dot);
	    }
	
	    // Convenience method to add dot to all keys in note
	
	  }, {
	    key: 'addDotToAll',
	    value: function addDotToAll() {
	      for (var i = 0; i < this.keys.length; ++i) {
	        this.addDot(i);
	      }
	      return this;
	    }
	
	    // Get all accidentals in the `ModifierContext`
	
	  }, {
	    key: 'getAccidentals',
	    value: function getAccidentals() {
	      return this.modifierContext.getModifiers('accidentals');
	    }
	
	    // Get all dots in the `ModifierContext`
	
	  }, {
	    key: 'getDots',
	    value: function getDots() {
	      return this.modifierContext.getModifiers('dots');
	    }
	
	    // Get the width of the note if it is displaced. Used for `Voice`
	    // formatting
	
	  }, {
	    key: 'getVoiceShiftWidth',
	    value: function getVoiceShiftWidth() {
	      // TODO: may need to accomodate for dot here.
	      return this.getGlyphWidth() * (this.displaced ? 2 : 1);
	    }
	
	    // Calculates and sets the extra pixels to the left or right
	    // if the note is displaced.
	
	  }, {
	    key: 'calcExtraPx',
	    value: function calcExtraPx() {
	      this.setExtraLeftPx(this.displaced && this.stem_direction === _stem.Stem.DOWN ? this.getGlyphWidth() : 0);
	
	      // For upstems with flags, the extra space is unnecessary, since it's taken
	      // up by the flag.
	      this.setExtraRightPx(!this.hasFlag() && this.displaced && this.stem_direction === _stem.Stem.UP ? this.getGlyphWidth() : 0);
	    }
	
	    // Pre-render formatting
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return;
	      if (this.modifierContext) this.modifierContext.preFormat();
	
	      var width = this.getGlyphWidth() + this.extraLeftPx + this.extraRightPx;
	
	      // For upward flagged notes, the width of the flag needs to be added
	      if (this.glyph.flag && this.beam === null && this.stem_direction === _stem.Stem.UP) {
	        width += this.getGlyphWidth();
	      }
	
	      this.setWidth(width);
	      this.setPreFormatted(true);
	    }
	
	    /**
	     * @typedef {Object} noteHeadBounds
	     * @property {number} y_top the highest notehead bound
	     * @property {number} y_bottom the lowest notehead bound
	     * @property {number|Null} displaced_x the starting x for displaced noteheads
	     * @property {number|Null} non_displaced_x the starting x for non-displaced noteheads
	     * @property {number} highest_line the highest notehead line in traditional music line
	     *  numbering (bottom line = 1, top line = 5)
	     * @property {number} lowest_line the lowest notehead line
	     * @property {number|false} highest_displaced_line the highest staff line number
	     *   for a displaced notehead
	     * @property {number|false} lowest_displaced_line
	     * @property {number} highest_non_displaced_line
	     * @property {number} lowest_non_displaced_line
	     */
	
	    /**
	     * Get the staff line and y value for the highest & lowest noteheads
	     * @returns {noteHeadBounds}
	     */
	
	  }, {
	    key: 'getNoteHeadBounds',
	    value: function getNoteHeadBounds() {
	      // Top and bottom Y values for stem.
	      var yTop = null;
	      var yBottom = null;
	      var nonDisplacedX = null;
	      var displacedX = null;
	
	      var highestLine = this.stave.getNumLines();
	      var lowestLine = 1;
	      var highestDisplacedLine = false;
	      var lowestDisplacedLine = false;
	      var highestNonDisplacedLine = highestLine;
	      var lowestNonDisplacedLine = lowestLine;
	
	      this.note_heads.forEach(function (notehead) {
	        var line = notehead.getLine();
	        var y = notehead.getY();
	
	        if (yTop === null || y < yTop) {
	          yTop = y;
	        }
	
	        if (yBottom === null || y > yBottom) {
	          yBottom = y;
	        }
	
	        if (displacedX === null && notehead.isDisplaced()) {
	          displacedX = notehead.getAbsoluteX();
	        }
	
	        if (nonDisplacedX === null && !notehead.isDisplaced()) {
	          nonDisplacedX = notehead.getAbsoluteX();
	        }
	
	        highestLine = line > highestLine ? line : highestLine;
	        lowestLine = line < lowestLine ? line : lowestLine;
	
	        if (notehead.isDisplaced()) {
	          highestDisplacedLine = highestDisplacedLine === false ? line : Math.max(line, highestDisplacedLine);
	          lowestDisplacedLine = lowestDisplacedLine === false ? line : Math.min(line, lowestDisplacedLine);
	        } else {
	          highestNonDisplacedLine = Math.max(line, highestNonDisplacedLine);
	          lowestNonDisplacedLine = Math.min(line, lowestNonDisplacedLine);
	        }
	      }, this);
	
	      return {
	        y_top: yTop,
	        y_bottom: yBottom,
	        displaced_x: displacedX,
	        non_displaced_x: nonDisplacedX,
	        highest_line: highestLine,
	        lowest_line: lowestLine,
	        highest_displaced_line: highestDisplacedLine,
	        lowest_displaced_line: lowestDisplacedLine,
	        highest_non_displaced_line: highestNonDisplacedLine,
	        lowest_non_displaced_line: lowestNonDisplacedLine
	      };
	    }
	
	    // Get the starting `x` coordinate for the noteheads
	
	  }, {
	    key: 'getNoteHeadBeginX',
	    value: function getNoteHeadBeginX() {
	      return this.getAbsoluteX() + this.x_shift;
	    }
	
	    // Get the ending `x` coordinate for the noteheads
	
	  }, {
	    key: 'getNoteHeadEndX',
	    value: function getNoteHeadEndX() {
	      var xBegin = this.getNoteHeadBeginX();
	      return xBegin + this.getGlyphWidth();
	    }
	
	    // Draw the ledger lines between the stave and the highest/lowest keys
	
	  }, {
	    key: 'drawLedgerLines',
	    value: function drawLedgerLines() {
	      var stave = this.stave;
	      var glyph = this.glyph;
	      var stroke_px = this.render_options.stroke_px;
	      var ctx = this.context;
	
	
	      var width = glyph.getWidth() + stroke_px * 2;
	      var doubleWidth = 2 * (glyph.getWidth() + stroke_px) - _stem.Stem.WIDTH / 2;
	
	      if (this.isRest()) return;
	      if (!ctx) {
	        throw new _vex.Vex.RERR('NoCanvasContext', "Can't draw without a canvas context.");
	      }
	
	      var _getNoteHeadBounds2 = this.getNoteHeadBounds();
	
	      var highest_line = _getNoteHeadBounds2.highest_line;
	      var lowest_line = _getNoteHeadBounds2.lowest_line;
	      var highest_displaced_line = _getNoteHeadBounds2.highest_displaced_line;
	      var highest_non_displaced_line = _getNoteHeadBounds2.highest_non_displaced_line;
	      var lowest_displaced_line = _getNoteHeadBounds2.lowest_displaced_line;
	      var lowest_non_displaced_line = _getNoteHeadBounds2.lowest_non_displaced_line;
	      var displaced_x = _getNoteHeadBounds2.displaced_x;
	      var non_displaced_x = _getNoteHeadBounds2.non_displaced_x;
	
	
	      var min_x = Math.min(displaced_x, non_displaced_x);
	
	      var drawLedgerLine = function drawLedgerLine(y, normal, displaced) {
	        var x = void 0;
	        if (displaced && normal) x = min_x - stroke_px;else if (normal) x = non_displaced_x - stroke_px;else x = displaced_x - stroke_px;
	        var ledgerWidth = normal && displaced ? doubleWidth : width;
	
	        ctx.beginPath();
	        ctx.moveTo(x, y);
	        ctx.lineTo(x + ledgerWidth, y);
	        ctx.stroke();
	      };
	
	      var style = _extends({}, stave.getStyle() || {}, this.getLedgerLineStyle() || {});
	      this.applyStyle(ctx, style);
	
	      // Draw ledger lines below the staff:
	      for (var line = 6; line <= highest_line; ++line) {
	        var normal = non_displaced_x !== null && line <= highest_non_displaced_line;
	        var displaced = displaced_x !== null && line <= highest_displaced_line;
	        drawLedgerLine(stave.getYForNote(line), normal, displaced);
	      }
	
	      // Draw ledger lines above the staff:
	      for (var _line = 0; _line >= lowest_line; --_line) {
	        var _normal = non_displaced_x !== null && _line >= lowest_non_displaced_line;
	        var _displaced = displaced_x !== null && _line >= lowest_displaced_line;
	        drawLedgerLine(stave.getYForNote(_line), _normal, _displaced);
	      }
	
	      this.restoreStyle(ctx, style);
	    }
	
	    // Draw all key modifiers
	
	  }, {
	    key: 'drawModifiers',
	    value: function drawModifiers() {
	      if (!this.context) {
	        throw new _vex.Vex.RERR('NoCanvasContext', "Can't draw without a canvas context.");
	      }
	
	      var ctx = this.context;
	      ctx.openGroup('modifiers');
	      for (var i = 0; i < this.modifiers.length; i++) {
	        var modifier = this.modifiers[i];
	        var notehead = this.note_heads[modifier.getIndex()];
	        var noteheadStyle = notehead.getStyle();
	        if (noteheadStyle) {
	          ctx.save();
	          notehead.applyStyle(ctx);
	        }
	        modifier.setContext(ctx);
	        modifier.draw();
	        if (noteheadStyle) {
	          ctx.restore();
	        }
	      }
	      ctx.closeGroup();
	    }
	
	    // Draw the flag for the note
	
	  }, {
	    key: 'drawFlag',
	    value: function drawFlag() {
	      var stem = this.stem;
	      var beam = this.beam;
	      var ctx = this.context;
	
	
	      if (!ctx) {
	        throw new _vex.Vex.RERR('NoCanvasContext', "Can't draw without a canvas context.");
	      }
	
	      var shouldRenderFlag = beam === null;
	      var glyph = this.getGlyph();
	
	      if (glyph.flag && shouldRenderFlag) {
	        var _getNoteHeadBounds3 = this.getNoteHeadBounds();
	
	        var y_top = _getNoteHeadBounds3.y_top;
	        var y_bottom = _getNoteHeadBounds3.y_bottom;
	
	        var noteStemHeight = stem.getHeight();
	        var flagX = this.getStemX();
	        // FIXME: What's with the magic +/- 2
	        var flagY = this.getStemDirection() === _stem.Stem.DOWN
	        // Down stems have flags on the left
	        ? y_top - noteStemHeight + 2
	        // Up stems have flags on the eft.
	        : y_bottom - noteStemHeight - 2;
	
	        // Draw the Flag
	        ctx.openGroup('flag', null, { pointerBBox: true });
	        this.applyStyle(ctx, this.getFlagStyle() || false);
	        this.flag.render(ctx, flagX, flagY);
	        this.restoreStyle(ctx, this.getFlagStyle() || false);
	        ctx.closeGroup();
	      }
	    }
	
	    // Draw the NoteHeads
	
	  }, {
	    key: 'drawNoteHeads',
	    value: function drawNoteHeads() {
	      var _this3 = this;
	
	      this.note_heads.forEach(function (notehead) {
	        _this3.context.openGroup('notehead', null, { pointerBBox: true });
	        notehead.setContext(_this3.context).draw();
	        _this3.context.closeGroup();
	      });
	    }
	
	    // Render the stem onto the canvas
	
	  }, {
	    key: 'drawStem',
	    value: function drawStem(stemStruct) {
	      // GCR TODO: I can't find any context in which this is called with the stemStruct
	      // argument in the codebase or tests. Nor can I find a case where super.drawStem
	      // is called at all. Perhaps these should be removed?
	      if (!this.context) {
	        throw new _vex.Vex.RERR('NoCanvasContext', "Can't draw without a canvas context.");
	      }
	
	      if (stemStruct) {
	        this.setStem(new _stem.Stem(stemStruct));
	      }
	
	      this.context.openGroup('stem', null, { pointerBBox: true });
	      this.stem.setContext(this.context).draw();
	      this.context.closeGroup();
	    }
	
	    // Draws all the `StaveNote` parts. This is the main drawing method.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.context) {
	        throw new _vex.Vex.RERR('NoCanvasContext', "Can't draw without a canvas context.");
	      }
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	      }
	      if (this.ys.length === 0) {
	        throw new _vex.Vex.RERR('NoYValues', "Can't draw note without Y values.");
	      }
	
	      var xBegin = this.getNoteHeadBeginX();
	      var shouldRenderStem = this.hasStem() && !this.beam;
	
	      // Format note head x positions
	      this.note_heads.forEach(function (notehead) {
	        return notehead.setX(xBegin);
	      });
	
	      // Format stem x positions
	      var stemX = this.getStemX();
	      this.stem.setNoteHeadXBounds(stemX, stemX);
	
	      L('Rendering ', this.isChord() ? 'chord :' : 'note :', this.keys);
	
	      // Draw each part of the note
	      this.drawLedgerLines();
	
	      // Apply the overall style -- may be contradicted by local settings:
	      this.applyStyle();
	      this.setAttribute('el', this.context.openGroup('stavenote', this.getAttribute('id')));
	      this.context.openGroup('note', null, { pointerBBox: true });
	      if (shouldRenderStem) this.drawStem();
	      this.drawNoteHeads();
	      this.drawFlag();
	      this.context.closeGroup();
	      this.drawModifiers();
	      this.context.closeGroup();
	      this.restoreStyle();
	      this.setRendered();
	    }
	  }]);

	  return StaveNote;
	}(_stemmablenote.StemmableNote);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NoteHead = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _note = __webpack_require__(22);
	
	var _stem = __webpack_require__(17);
	
	var _stavenote = __webpack_require__(20);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `NoteHeads`. `NoteHeads` are typically not manipulated
	// directly, but used internally in `StaveNote`.
	//
	// See `tests/notehead_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.NoteHead.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (NoteHead.DEBUG) _vex.Vex.L('Vex.Flow.NoteHead', args);
	}
	
	// Draw slashnote head manually. No glyph exists for this.
	//
	// Parameters:
	// * `ctx`: the Canvas context
	// * `duration`: the duration of the note. ex: "4"
	// * `x`: the x coordinate to draw at
	// * `y`: the y coordinate to draw at
	// * `stem_direction`: the direction of the stem
	function drawSlashNoteHead(ctx, duration, x, y, stem_direction, staveSpace) {
	  var width = _tables.Flow.SLASH_NOTEHEAD_WIDTH;
	  ctx.save();
	  ctx.setLineWidth(_tables.Flow.STEM_WIDTH);
	
	  var fill = false;
	
	  if (_tables.Flow.durationToNumber(duration) > 2) {
	    fill = true;
	  }
	
	  if (!fill) x -= _tables.Flow.STEM_WIDTH / 2 * stem_direction;
	
	  ctx.beginPath();
	  ctx.moveTo(x, y + staveSpace);
	  ctx.lineTo(x, y + 1);
	  ctx.lineTo(x + width, y - staveSpace);
	  ctx.lineTo(x + width, y);
	  ctx.lineTo(x, y + staveSpace);
	  ctx.closePath();
	
	  if (fill) {
	    ctx.fill();
	  } else {
	    ctx.stroke();
	  }
	
	  if (_tables.Flow.durationToFraction(duration).equals(0.5)) {
	    var breve_lines = [-3, -1, width + 1, width + 3];
	    for (var i = 0; i < breve_lines.length; i++) {
	      ctx.beginPath();
	      ctx.moveTo(x + breve_lines[i], y - 10);
	      ctx.lineTo(x + breve_lines[i], y + 11);
	      ctx.stroke();
	    }
	  }
	
	  ctx.restore();
	}
	
	var NoteHead = exports.NoteHead = function (_Note) {
	  _inherits(NoteHead, _Note);
	
	  _createClass(NoteHead, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'notehead';
	    }
	  }]);
	
	  function NoteHead(head_options) {
	    _classCallCheck(this, NoteHead);
	
	    var _this = _possibleConstructorReturn(this, (NoteHead.__proto__ || Object.getPrototypeOf(NoteHead)).call(this, head_options));
	
	    _this.setAttribute('type', 'NoteHead');
	
	    _this.index = head_options.index;
	    _this.x = head_options.x || 0;
	    _this.y = head_options.y || 0;
	    _this.note_type = head_options.note_type;
	    _this.duration = head_options.duration;
	    _this.displaced = head_options.displaced || false;
	    _this.stem_direction = head_options.stem_direction || _stavenote.StaveNote.STEM_UP;
	    _this.line = head_options.line;
	
	    // Get glyph code based on duration and note type. This could be
	    // regular notes, rests, or other custom codes.
	    _this.glyph = _tables.Flow.durationToGlyph(_this.duration, _this.note_type);
	    if (!_this.glyph) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'No glyph found for duration \'' + _this.duration + '\' and type \'' + _this.note_type + '\'');
	    }
	
	    _this.glyph_code = _this.glyph.code_head;
	    _this.x_shift = head_options.x_shift;
	    if (head_options.custom_glyph_code) {
	      _this.custom_glyph = true;
	      _this.glyph_code = head_options.custom_glyph_code;
	    }
	
	    _this.style = head_options.style;
	    _this.slashed = head_options.slashed;
	
	    _vex.Vex.Merge(_this.render_options, {
	      // font size for note heads
	      glyph_font_scale: head_options.glyph_font_scale || _tables.Flow.DEFAULT_NOTATION_FONT_SCALE,
	      // number of stroke px to the left and right of head
	      stroke_px: 3
	    });
	
	    _this.setWidth(_this.glyph.getWidth(_this.render_options.glyph_font_scale));
	    return _this;
	  }
	
	  _createClass(NoteHead, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return NoteHead.CATEGORY;
	    }
	
	    // Get the width of the notehead
	
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	
	    // Determine if the notehead is displaced
	
	  }, {
	    key: 'isDisplaced',
	    value: function isDisplaced() {
	      return this.displaced === true;
	    }
	
	    // Get the glyph data
	
	  }, {
	    key: 'getGlyph',
	    value: function getGlyph() {
	      return this.glyph;
	    }
	
	    // Set the X coordinate
	
	  }, {
	    key: 'setX',
	    value: function setX(x) {
	      this.x = x;return this;
	    }
	
	    // get/set the Y coordinate
	
	  }, {
	    key: 'getY',
	    value: function getY() {
	      return this.y;
	    }
	  }, {
	    key: 'setY',
	    value: function setY(y) {
	      this.y = y;return this;
	    }
	
	    // Get/set the stave line the notehead is placed on
	
	  }, {
	    key: 'getLine',
	    value: function getLine() {
	      return this.line;
	    }
	  }, {
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;return this;
	    }
	
	    // Get the canvas `x` coordinate position of the notehead.
	
	  }, {
	    key: 'getAbsoluteX',
	    value: function getAbsoluteX() {
	      // If the note has not been preformatted, then get the static x value
	      // Otherwise, it's been formatted and we should use it's x value relative
	      // to its tick context
	      var x = !this.preFormatted ? this.x : _get(NoteHead.prototype.__proto__ || Object.getPrototypeOf(NoteHead.prototype), 'getAbsoluteX', this).call(this);
	
	      // For a more natural displaced notehead, we adjust the displacement amount
	      // by half the stem width in order to maintain a slight overlap with the stem
	      var displacementStemAdjustment = _stem.Stem.WIDTH / 2;
	
	      return x + (this.displaced ? (this.width - displacementStemAdjustment) * this.stem_direction : 0);
	    }
	
	    // Get the `BoundingBox` for the `NoteHead`
	
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call getBoundingBox on an unformatted note.");
	      }
	
	      var spacing = this.stave.getSpacingBetweenLines();
	      var half_spacing = spacing / 2;
	      var min_y = this.y - half_spacing;
	
	      return new _tables.Flow.BoundingBox(this.getAbsoluteX(), min_y, this.width, spacing);
	    }
	
	    // Set notehead to a provided `stave`
	
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      var line = this.getLine();
	
	      this.stave = stave;
	      this.setY(stave.getYForNote(line));
	      this.context = this.stave.context;
	      return this;
	    }
	
	    // Pre-render formatting
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return this;
	
	      var width = this.getWidth() + this.extraLeftPx + this.extraRightPx;
	
	      this.setWidth(width);
	      this.setPreFormatted(true);
	      return this;
	    }
	
	    // Draw the notehead
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var ctx = this.context;
	      var head_x = this.getAbsoluteX();
	      var y = this.y;
	
	      L("Drawing note head '", this.note_type, this.duration, "' at", head_x, y);
	
	      // Begin and end positions for head.
	      var stem_direction = this.stem_direction;
	      var glyph_font_scale = this.render_options.glyph_font_scale;
	
	      if (this.note_type === 's') {
	        var staveSpace = this.stave.getSpacingBetweenLines();
	        drawSlashNoteHead(ctx, this.duration, head_x, y, stem_direction, staveSpace);
	      } else {
	        if (this.style) {
	          this.applyStyle(ctx);
	          _glyph.Glyph.renderGlyph(ctx, head_x, y, glyph_font_scale, this.glyph_code);
	          this.restoreStyle(ctx);
	        } else {
	          _glyph.Glyph.renderGlyph(ctx, head_x, y, glyph_font_scale, this.glyph_code);
	        }
	      }
	    }
	  }]);

	  return NoteHead;
	}(_note.Note);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Note = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _tickable = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements an abstract interface for notes and chords that
	// are rendered on a stave. Notes have some common properties: All of them
	// have a value (e.g., pitch, fret, etc.) and a duration (quarter, half, etc.)
	//
	// Some notes have stems, heads, dots, etc. Most notational elements that
	// surround a note are called *modifiers*, and every note has an associated
	// array of them. All notes also have a rendering context and belong to a stave.
	
	var Note = exports.Note = function (_Tickable) {
	  _inherits(Note, _Tickable);
	
	  _createClass(Note, null, [{
	    key: 'plotMetrics',
	
	
	    // Debug helper. Displays various note metrics for the given
	    // note.
	    value: function plotMetrics(ctx, note, yPos) {
	      var metrics = note.getMetrics();
	      var xStart = note.getAbsoluteX() - metrics.modLeftPx - metrics.extraLeftPx;
	      var xPre1 = note.getAbsoluteX() - metrics.extraLeftPx;
	      var xAbs = note.getAbsoluteX();
	      var xPost1 = note.getAbsoluteX() + metrics.noteWidth;
	      var xPost2 = note.getAbsoluteX() + metrics.noteWidth + metrics.extraRightPx;
	      var xEnd = note.getAbsoluteX() + metrics.noteWidth + metrics.extraRightPx + metrics.modRightPx;
	      var xFreedomRight = xEnd + note.getFormatterMetrics().freedom.right;
	
	      var xWidth = xEnd - xStart;
	      ctx.save();
	      ctx.setFont('Arial', 8, '');
	      ctx.fillText(Math.round(xWidth) + 'px', xStart + note.getXShift(), yPos);
	
	      var y = yPos + 7;
	      function stroke(x1, x2, color) {
	        var yy = arguments.length <= 3 || arguments[3] === undefined ? y : arguments[3];
	
	        ctx.beginPath();
	        ctx.setStrokeStyle(color);
	        ctx.setFillStyle(color);
	        ctx.setLineWidth(3);
	        ctx.moveTo(x1 + note.getXShift(), yy);
	        ctx.lineTo(x2 + note.getXShift(), yy);
	        ctx.stroke();
	      }
	
	      stroke(xStart, xPre1, 'red');
	      stroke(xPre1, xAbs, '#999');
	      stroke(xAbs, xPost1, 'green');
	      stroke(xPost1, xPost2, '#999');
	      stroke(xPost2, xEnd, 'red');
	      stroke(xEnd, xFreedomRight, '#DD0');
	      stroke(xStart - note.getXShift(), xStart, '#BBB'); // Shift
	      _vex.Vex.drawDot(ctx, xAbs + note.getXShift(), y, 'blue');
	
	      var formatterMetrics = note.getFormatterMetrics();
	      if (formatterMetrics.iterations > 0) {
	        var spaceDeviation = formatterMetrics.space.deviation;
	        var prefix = spaceDeviation >= 0 ? '+' : '';
	        ctx.setFillStyle('red');
	        ctx.fillText(prefix + Math.round(spaceDeviation), xAbs + note.getXShift(), yPos - 10);
	      }
	      ctx.restore();
	    }
	
	    // Every note is a tickable, i.e., it can be mutated by the `Formatter` class for
	    // positioning and layout.
	    // To create a new note you need to provide a `note_struct`, which consists
	    // of the following fields:
	    //
	    // `type`: The note type (e.g., `r` for rest, `s` for slash notes, etc.)
	    // `dots`: The number of dots, which affects the duration.
	    // `duration`: The time length (e.g., `q` for quarter, `h` for half, `8` for eighth etc.)
	    //
	    // The range of values for these parameters are available in `src/tables.js`.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'note';
	    }
	  }, {
	    key: 'STAVEPADDING',
	    get: function get() {
	      return 12;
	    }
	  }]);
	
	  function Note(note_struct) {
	    _classCallCheck(this, Note);
	
	    var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this));
	
	    _this.setAttribute('type', 'Note');
	
	    if (!note_struct) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Note must have valid initialization data to identify duration and type.');
	    }
	
	    // Parse `note_struct` and get note properties.
	    var initData = _tables.Flow.parseNoteData(note_struct);
	    if (!initData) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Invalid note initialization object: ' + JSON.stringify(note_struct));
	    }
	
	    // Set note properties from parameters.
	    _this.duration = initData.duration;
	    _this.dots = initData.dots;
	    _this.noteType = initData.type;
	
	    if (note_struct.duration_override) {
	      // Custom duration
	      _this.setDuration(note_struct.duration_override);
	    } else {
	      // Default duration
	      _this.setIntrinsicTicks(initData.ticks);
	    }
	
	    _this.modifiers = [];
	
	    // Get the glyph code for this note from the font.
	    _this.glyph = _tables.Flow.durationToGlyph(_this.duration, _this.noteType);
	
	    if (_this.positions && (_typeof(_this.positions) !== 'object' || !_this.positions.length)) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Note keys must be array type.');
	    }
	
	    // Note to play for audio players.
	    _this.playNote = null;
	
	    // Positioning contexts used by the Formatter.
	    _this.tickContext = null; // The current tick context.
	    _this.modifierContext = null;
	    _this.ignore_ticks = false;
	
	    // Positioning variables
	    _this.width = 0; // Width in pixels calculated after preFormat
	    _this.extraLeftPx = 0; // Extra room on left for offset note head
	    _this.extraRightPx = 0; // Extra room on right for offset note head
	    _this.x_shift = 0; // X shift from tick context X
	    _this.left_modPx = 0; // Max width of left modifiers
	    _this.right_modPx = 0; // Max width of right modifiers
	    _this.voice = null; // The voice that this note is in
	    _this.preFormatted = false; // Is this note preFormatted?
	    _this.ys = []; // list of y coordinates for each note
	    // we need to hold on to these for ties and beams.
	
	    if (note_struct.align_center) {
	      _this.setCenterAlignment(note_struct.align_center);
	    }
	
	    // The render surface.
	    _this.stave = null;
	    _this.render_options = {
	      annotation_spacing: 5,
	      stave_padding: Note.STAVEPADDING
	    };
	    return _this;
	  }
	
	  // Get and set the play note, which is arbitrary data that can be used by an
	  // audio player.
	
	
	  _createClass(Note, [{
	    key: 'getPlayNote',
	    value: function getPlayNote() {
	      return this.playNote;
	    }
	  }, {
	    key: 'setPlayNote',
	    value: function setPlayNote(note) {
	      this.playNote = note;return this;
	    }
	
	    // Don't play notes by default, call them rests. This is also used by things like
	    // beams and dots for positioning.
	
	  }, {
	    key: 'isRest',
	    value: function isRest() {
	      return false;
	    }
	
	    // TODO(0xfe): Why is this method here?
	
	  }, {
	    key: 'addStroke',
	    value: function addStroke(index, stroke) {
	      stroke.setNote(this);
	      stroke.setIndex(index);
	      this.modifiers.push(stroke);
	      this.setPreFormatted(false);
	      return this;
	    }
	
	    // Get and set the target stave.
	
	  }, {
	    key: 'getStave',
	    value: function getStave() {
	      return this.stave;
	    }
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      this.stave = stave;
	      this.setYs([stave.getYForLine(0)]); // Update Y values if the stave is changed.
	      this.context = this.stave.context;
	      return this;
	    }
	
	    // `Note` is not really a modifier, but is used in
	    // a `ModifierContext`.
	
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return Note.CATEGORY;
	    }
	
	    // Set the rendering context for the note.
	
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      this.context = context;return this;
	    }
	
	    // Get and set spacing to the left and right of the notes.
	
	  }, {
	    key: 'getExtraLeftPx',
	    value: function getExtraLeftPx() {
	      return this.extraLeftPx;
	    }
	  }, {
	    key: 'getExtraRightPx',
	    value: function getExtraRightPx() {
	      return this.extraRightPx;
	    }
	  }, {
	    key: 'setExtraLeftPx',
	    value: function setExtraLeftPx(x) {
	      this.extraLeftPx = x;return this;
	    }
	  }, {
	    key: 'setExtraRightPx',
	    value: function setExtraRightPx(x) {
	      this.extraRightPx = x;return this;
	    }
	
	    // Returns true if this note has no duration (e.g., bar notes, spacers, etc.)
	
	  }, {
	    key: 'shouldIgnoreTicks',
	    value: function shouldIgnoreTicks() {
	      return this.ignore_ticks;
	    }
	
	    // Get the stave line number for the note.
	
	  }, {
	    key: 'getLineNumber',
	    value: function getLineNumber() {
	      return 0;
	    }
	
	    // Get the stave line number for rest.
	
	  }, {
	    key: 'getLineForRest',
	    value: function getLineForRest() {
	      return 0;
	    }
	
	    // Get the glyph associated with this note.
	
	  }, {
	    key: 'getGlyph',
	    value: function getGlyph() {
	      return this.glyph;
	    }
	  }, {
	    key: 'getGlyphWidth',
	    value: function getGlyphWidth() {
	      return this.glyph.getWidth(this.render_options.glyph_font_scale);
	    }
	
	    // Set and get Y positions for this note. Each Y value is associated with
	    // an individual pitch/key within the note/chord.
	
	  }, {
	    key: 'setYs',
	    value: function setYs(ys) {
	      this.ys = ys;return this;
	    }
	  }, {
	    key: 'getYs',
	    value: function getYs() {
	      if (this.ys.length === 0) {
	        throw new _vex.Vex.RERR('NoYValues', 'No Y-values calculated for this note.');
	      }
	
	      return this.ys;
	    }
	
	    // Get the Y position of the space above the stave onto which text can
	    // be rendered.
	
	  }, {
	    key: 'getYForTopText',
	    value: function getYForTopText(text_line) {
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('NoStave', 'No stave attached to this note.');
	      }
	
	      return this.stave.getYForTopText(text_line);
	    }
	
	    // Get a `BoundingBox` for this note.
	
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return null;
	    }
	
	    // Returns the voice that this note belongs in.
	
	  }, {
	    key: 'getVoice',
	    value: function getVoice() {
	      if (!this.voice) throw new _vex.Vex.RERR('NoVoice', 'Note has no voice.');
	      return this.voice;
	    }
	
	    // Attach this note to `voice`.
	
	  }, {
	    key: 'setVoice',
	    value: function setVoice(voice) {
	      this.voice = voice;
	      this.preFormatted = false;
	      return this;
	    }
	
	    // Get and set the `TickContext` for this note.
	
	  }, {
	    key: 'getTickContext',
	    value: function getTickContext() {
	      return this.tickContext;
	    }
	  }, {
	    key: 'setTickContext',
	    value: function setTickContext(tc) {
	      this.tickContext = tc;
	      this.preFormatted = false;
	      return this;
	    }
	
	    // Accessors for the note type.
	
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'isDotted',
	    value: function isDotted() {
	      return this.dots > 0;
	    }
	  }, {
	    key: 'hasStem',
	    value: function hasStem() {
	      return false;
	    }
	  }, {
	    key: 'getDots',
	    value: function getDots() {
	      return this.dots;
	    }
	  }, {
	    key: 'getNoteType',
	    value: function getNoteType() {
	      return this.noteType;
	    }
	  }, {
	    key: 'setBeam',
	    value: function setBeam() {
	      return this;
	    } // ignore parameters
	
	    // Attach this note to a modifier context.
	
	  }, {
	    key: 'setModifierContext',
	    value: function setModifierContext(mc) {
	      this.modifierContext = mc;return this;
	    }
	
	    // Attach a modifier to this note.
	
	  }, {
	    key: 'addModifier',
	    value: function addModifier(modifier) {
	      var index = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      modifier.setNote(this);
	      modifier.setIndex(index);
	      this.modifiers.push(modifier);
	      this.setPreFormatted(false);
	      return this;
	    }
	
	    // Get the coordinates for where modifiers begin.
	
	  }, {
	    key: 'getModifierStartXY',
	    value: function getModifierStartXY() {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call GetModifierStartXY on an unformatted note");
	      }
	
	      return {
	        x: this.getAbsoluteX(),
	        y: this.ys[0]
	      };
	    }
	
	    // Get bounds and metrics for this note.
	    //
	    // Returns a struct with fields:
	    // `width`: The total width of the note (including modifiers.)
	    // `noteWidth`: The width of the note head only.
	    // `left_shift`: The horizontal displacement of the note.
	    // `modLeftPx`: Start `X` for left modifiers.
	    // `modRightPx`: Start `X` for right modifiers.
	    // `extraLeftPx`: Extra space on left of note.
	    // `extraRightPx`: Extra space on right of note.
	
	  }, {
	    key: 'getMetrics',
	    value: function getMetrics() {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call getMetrics on an unformatted note.");
	      }
	
	      var modLeftPx = 0;
	      var modRightPx = 0;
	      if (this.modifierContext != null) {
	        modLeftPx = this.modifierContext.state.left_shift;
	        modRightPx = this.modifierContext.state.right_shift;
	      }
	
	      var width = this.getWidth();
	      return {
	        width: width,
	        noteWidth: width - modLeftPx - modRightPx - this.extraLeftPx - this.extraRightPx,
	        left_shift: this.x_shift, // TODO(0xfe): Make style consistent
	
	        // Modifiers, accidentals etc.
	        modLeftPx: modLeftPx,
	        modRightPx: modRightPx,
	
	        // Displaced note head on left or right.
	        extraLeftPx: this.extraLeftPx,
	        extraRightPx: this.extraRightPx
	      };
	    }
	
	    // Get and set width of note. Used by the formatter for positioning.
	
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.width = width;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call GetWidth on an unformatted note.");
	      }
	
	      return this.width + (this.modifierContext ? this.modifierContext.getWidth() : 0);
	    }
	
	    // Displace note by `x` pixels. Used by the formatter.
	
	  }, {
	    key: 'setXShift',
	    value: function setXShift(x) {
	      this.x_shift = x;return this;
	    }
	  }, {
	    key: 'getXShift',
	    value: function getXShift() {
	      return this.x_shift;
	    }
	
	    // Get `X` position of this tick context.
	
	  }, {
	    key: 'getX',
	    value: function getX() {
	      if (!this.tickContext) {
	        throw new _vex.Vex.RERR('NoTickContext', 'Note needs a TickContext assigned for an X-Value');
	      }
	
	      return this.tickContext.getX() + this.x_shift;
	    }
	
	    // Get the absolute `X` position of this note's tick context. This
	    // excludes x_shift, so you'll need to factor it in if you're
	    // looking for the post-formatted x-position.
	
	  }, {
	    key: 'getAbsoluteX',
	    value: function getAbsoluteX() {
	      if (!this.tickContext) {
	        throw new _vex.Vex.RERR('NoTickContext', 'Note needs a TickContext assigned for an X-Value');
	      }
	
	      // Position note to left edge of tick context.
	      var x = this.tickContext.getX();
	      if (this.stave) {
	        x += this.stave.getNoteStartX() + this.render_options.stave_padding;
	      }
	
	      if (this.isCenterAligned()) {
	        x += this.getCenterXShift();
	      }
	
	      return x;
	    }
	  }, {
	    key: 'setPreFormatted',
	    value: function setPreFormatted(value) {
	      this.preFormatted = value;
	
	      // Maintain the width of left and right modifiers in pixels.
	      if (this.preFormatted) {
	        var extra = this.tickContext.getExtraPx();
	        this.left_modPx = Math.max(this.left_modPx, extra.left);
	        this.right_modPx = Math.max(this.right_modPx, extra.right);
	      }
	    }
	  }]);

	  return Note;
	}(_tickable.Tickable);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tickable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	var _fraction = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// The tickable interface. Tickables are things that sit on a score and
	// have a duration, i.e., they occupy space in the musical rendering dimension.
	
	var Tickable = exports.Tickable = function (_Element) {
	  _inherits(Tickable, _Element);
	
	  function Tickable() {
	    _classCallCheck(this, Tickable);
	
	    var _this = _possibleConstructorReturn(this, (Tickable.__proto__ || Object.getPrototypeOf(Tickable)).call(this));
	
	    _this.setAttribute('type', 'Tickable');
	
	    // These properties represent the duration of
	    // this tickable element.
	    _this.ticks = new _fraction.Fraction(0, 1);
	    _this.intrinsicTicks = 0;
	    _this.tickMultiplier = new _fraction.Fraction(1, 1);
	
	    _this.width = 0;
	    _this.x_shift = 0; // Shift from tick context
	    _this.voice = null;
	    _this.tickContext = null;
	    _this.modifierContext = null;
	    _this.modifiers = [];
	    _this.preFormatted = false;
	    _this.postFormatted = false;
	    _this.tuplet = null;
	    _this.tupletStack = [];
	
	    _this.align_center = false;
	    _this.center_x_shift = 0; // Shift from tick context if center aligned
	
	    // This flag tells the formatter to ignore this tickable during
	    // formatting and justification. It is set by tickables such as BarNote.
	    _this.ignore_ticks = false;
	
	    // This is a space for an external formatting class or function to maintain
	    // metrics.
	    _this.formatterMetrics = {
	      // The freedom of a tickable is the distance it can move without colliding
	      // with neighboring elements. A formatter can set these values during its
	      // formatting pass, which a different formatter can then use to fine tune.
	      freedom: { left: 0, right: 0 },
	
	      // The simplified rational duration of this tick as a string. It can be
	      // used as an index to a map or hashtable.
	      duration: '',
	
	      // The number of formatting iterations undergone.
	      iterations: 0,
	
	      // The space in pixels allocated by this formatter, along with the mean space
	      // for tickables of this duration, and the deviation from the mean.
	      space: {
	        used: 0,
	        mean: 0,
	        deviation: 0
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Tickable, [{
	    key: 'reset',
	    value: function reset() {
	      return this;
	    }
	  }, {
	    key: 'getTicks',
	    value: function getTicks() {
	      return this.ticks;
	    }
	  }, {
	    key: 'shouldIgnoreTicks',
	    value: function shouldIgnoreTicks() {
	      return this.ignore_ticks;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'getFormatterMetrics',
	    value: function getFormatterMetrics() {
	      return this.formatterMetrics;
	    }
	  }, {
	    key: 'setXShift',
	    value: function setXShift(x) {
	      this.x_shift = x;
	    }
	  }, {
	    key: 'getCenterXShift',
	    value: function getCenterXShift() {
	      if (this.isCenterAligned()) {
	        return this.center_x_shift;
	      }
	
	      return 0;
	    }
	  }, {
	    key: 'isCenterAligned',
	    value: function isCenterAligned() {
	      return this.align_center;
	    }
	  }, {
	    key: 'setCenterAlignment',
	    value: function setCenterAlignment(align_center) {
	      this.align_center = align_center;
	      return this;
	    }
	
	    // Every tickable must be associated with a voice. This allows formatters
	    // and preFormatter to associate them with the right modifierContexts.
	
	  }, {
	    key: 'getVoice',
	    value: function getVoice() {
	      if (!this.voice) throw new _vex.Vex.RERR('NoVoice', 'Tickable has no voice.');
	      return this.voice;
	    }
	  }, {
	    key: 'setVoice',
	    value: function setVoice(voice) {
	      this.voice = voice;
	    }
	  }, {
	    key: 'getTuplet',
	    value: function getTuplet() {
	      return this.tuplet;
	    }
	
	    /*
	     * resetTuplet
	     * @param tuplet -- the specific tuplet to reset
	     *   if this is not provided, all tuplets are reset.
	     * @returns this
	     *
	     * Removes any prior tuplets from the tick calculation and
	     * resets the intrinsic tick value to
	     */
	
	  }, {
	    key: 'resetTuplet',
	    value: function resetTuplet(tuplet) {
	      var noteCount = void 0;
	      var notesOccupied = void 0;
	      if (tuplet) {
	        var i = this.tupletStack.indexOf(tuplet);
	        if (i !== -1) {
	          this.tupletStack.splice(i, 1);
	          noteCount = tuplet.getNoteCount();
	          notesOccupied = tuplet.getNotesOccupied();
	
	          // Revert old multiplier by inverting numerator & denom.:
	          this.applyTickMultiplier(noteCount, notesOccupied);
	        }
	        return this;
	      }
	
	      while (this.tupletStack.length) {
	        tuplet = this.tupletStack.pop();
	        noteCount = tuplet.getNoteCount();
	        notesOccupied = tuplet.getNotesOccupied();
	
	        // Revert old multiplier by inverting numerator & denom.:
	        this.applyTickMultiplier(noteCount, notesOccupied);
	      }
	      return this;
	    }
	  }, {
	    key: 'setTuplet',
	    value: function setTuplet(tuplet) {
	      // Attach to new tuplet
	
	      if (tuplet) {
	        this.tupletStack.push(tuplet);
	
	        var noteCount = tuplet.getNoteCount();
	        var notesOccupied = tuplet.getNotesOccupied();
	
	        this.applyTickMultiplier(notesOccupied, noteCount);
	      }
	
	      this.tuplet = tuplet;
	
	      return this;
	    }
	
	    /** optional, if tickable has modifiers **/
	
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext(mc) {
	      this.modifierContext = mc;
	      // Add modifiers to modifier context (if any)
	      this.preFormatted = false;
	    }
	
	    /** optional, if tickable has modifiers **/
	
	  }, {
	    key: 'addModifier',
	    value: function addModifier(mod) {
	      this.modifiers.push(mod);
	      this.preFormatted = false;
	      return this;
	    }
	  }, {
	    key: 'getModifiers',
	    value: function getModifiers() {
	      return this.modifiers;
	    }
	  }, {
	    key: 'setTickContext',
	    value: function setTickContext(tc) {
	      this.tickContext = tc;
	      this.preFormatted = false;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return;
	
	      this.width = 0;
	      if (this.modifierContext) {
	        this.modifierContext.preFormat();
	        this.width += this.modifierContext.getWidth();
	      }
	    }
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      if (this.postFormatted) return this;
	      this.postFormatted = true;
	      return this;
	    }
	  }, {
	    key: 'getIntrinsicTicks',
	    value: function getIntrinsicTicks() {
	      return this.intrinsicTicks;
	    }
	  }, {
	    key: 'setIntrinsicTicks',
	    value: function setIntrinsicTicks(intrinsicTicks) {
	      this.intrinsicTicks = intrinsicTicks;
	      this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
	    }
	  }, {
	    key: 'getTickMultiplier',
	    value: function getTickMultiplier() {
	      return this.tickMultiplier;
	    }
	  }, {
	    key: 'applyTickMultiplier',
	    value: function applyTickMultiplier(numerator, denominator) {
	      this.tickMultiplier.multiply(numerator, denominator);
	      this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
	    }
	  }, {
	    key: 'setDuration',
	    value: function setDuration(duration) {
	      var ticks = duration.numerator * (_tables.Flow.RESOLUTION / duration.denominator);
	      this.ticks = this.tickMultiplier.clone().multiply(ticks);
	      this.intrinsicTicks = this.ticks.value();
	    }
	  }]);

	  return Tickable;
	}(_element.Element);

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StemmableNote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _stem = __webpack_require__(17);
	
	var _glyph = __webpack_require__(4);
	
	var _note = __webpack_require__(22);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// `StemmableNote` is an abstract interface for notes with optional stems.
	// Examples of stemmable notes are `StaveNote` and `TabNote`
	
	var StemmableNote = exports.StemmableNote = function (_Note) {
	  _inherits(StemmableNote, _Note);
	
	  function StemmableNote(note_struct) {
	    _classCallCheck(this, StemmableNote);
	
	    var _this = _possibleConstructorReturn(this, (StemmableNote.__proto__ || Object.getPrototypeOf(StemmableNote)).call(this, note_struct));
	
	    _this.setAttribute('type', 'StemmableNote');
	
	    _this.stem = null;
	    _this.stemExtensionOverride = null;
	    _this.beam = null;
	    return _this;
	  }
	
	  // Get and set the note's `Stem`
	
	
	  _createClass(StemmableNote, [{
	    key: 'getStem',
	    value: function getStem() {
	      return this.stem;
	    }
	  }, {
	    key: 'setStem',
	    value: function setStem(stem) {
	      this.stem = stem;return this;
	    }
	
	    // Builds and sets a new stem
	
	  }, {
	    key: 'buildStem',
	    value: function buildStem() {
	      var stem = new _stem.Stem();
	      this.setStem(stem);
	      return this;
	    }
	  }, {
	    key: 'buildFlag',
	    value: function buildFlag() {
	      var glyph = this.glyph;
	      var beam = this.beam;
	
	      var shouldRenderFlag = beam === null;
	
	      if (glyph && glyph.flag && shouldRenderFlag) {
	        var flagCode = this.getStemDirection() === _stem.Stem.DOWN ? glyph.code_flag_downstem : glyph.code_flag_upstem;
	
	        this.flag = new _glyph.Glyph(flagCode, this.render_options.glyph_font_scale);
	      }
	    }
	
	    // Get the full length of stem
	
	  }, {
	    key: 'getStemLength',
	    value: function getStemLength() {
	      return _stem.Stem.HEIGHT + this.getStemExtension();
	    }
	
	    // Get the number of beams for this duration
	
	  }, {
	    key: 'getBeamCount',
	    value: function getBeamCount() {
	      var glyph = this.getGlyph();
	
	      if (glyph) {
	        return glyph.beam_count;
	      } else {
	        return 0;
	      }
	    }
	
	    // Get the minimum length of stem
	
	  }, {
	    key: 'getStemMinumumLength',
	    value: function getStemMinumumLength() {
	      var frac = _tables.Flow.durationToFraction(this.duration);
	      var length = frac.value() <= 1 ? 0 : 20;
	      // if note is flagged, cannot shorten beam
	      switch (this.duration) {
	        case '8':
	          if (this.beam == null) length = 35;
	          break;
	        case '16':
	          length = this.beam == null ? 35 : 25;
	          break;
	        case '32':
	          length = this.beam == null ? 45 : 35;
	          break;
	        case '64':
	          length = this.beam == null ? 50 : 40;
	          break;
	        case '128':
	          length = this.beam == null ? 55 : 45;
	          break;
	        default:
	          break;
	      }
	      return length;
	    }
	
	    // Get/set the direction of the stem
	
	  }, {
	    key: 'getStemDirection',
	    value: function getStemDirection() {
	      return this.stem_direction;
	    }
	  }, {
	    key: 'setStemDirection',
	    value: function setStemDirection(direction) {
	      if (!direction) direction = _stem.Stem.UP;
	      if (direction !== _stem.Stem.UP && direction !== _stem.Stem.DOWN) {
	        throw new _vex.Vex.RERR('BadArgument', 'Invalid stem direction: ' + direction);
	      }
	
	      this.stem_direction = direction;
	      if (this.stem) {
	        this.stem.setDirection(direction);
	        this.stem.setExtension(this.getStemExtension());
	      }
	
	      this.reset();
	      if (this.flag) {
	        this.buildFlag();
	      }
	
	      this.beam = null;
	      if (this.preFormatted) {
	        this.preFormat();
	      }
	      return this;
	    }
	
	    // Get the `x` coordinate of the stem
	
	  }, {
	    key: 'getStemX',
	    value: function getStemX() {
	      var x_begin = this.getAbsoluteX() + this.x_shift;
	      var x_end = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
	      var stem_x = this.stem_direction === _stem.Stem.DOWN ? x_begin : x_end;
	      return stem_x;
	    }
	
	    // Get the `x` coordinate for the center of the glyph.
	    // Used for `TabNote` stems and stemlets over rests
	
	  }, {
	    key: 'getCenterGlyphX',
	    value: function getCenterGlyphX() {
	      return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
	    }
	
	    // Get the stem extension for the current duration
	
	  }, {
	    key: 'getStemExtension',
	    value: function getStemExtension() {
	      var glyph = this.getGlyph();
	
	      if (this.stemExtensionOverride != null) {
	        return this.stemExtensionOverride;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.stem_up_extension : glyph.stem_down_extension;
	      }
	
	      return 0;
	    }
	
	    // Set the stem length to a specific. Will override the default length.
	
	  }, {
	    key: 'setStemLength',
	    value: function setStemLength(height) {
	      this.stemExtensionOverride = height - _stem.Stem.HEIGHT;
	      return this;
	    }
	
	    // Get the top and bottom `y` values of the stem.
	
	  }, {
	    key: 'getStemExtents',
	    value: function getStemExtents() {
	      return this.stem.getExtents();
	    }
	
	    // Sets the current note's beam
	
	  }, {
	    key: 'setBeam',
	    value: function setBeam(beam) {
	      this.beam = beam;return this;
	    }
	
	    // Get the `y` value for the top/bottom modifiers at a specific `textLine`
	
	  }, {
	    key: 'getYForTopText',
	    value: function getYForTopText(textLine) {
	      var extents = this.getStemExtents();
	      if (this.hasStem()) {
	        return Math.min(this.stave.getYForTopText(textLine), extents.topY - this.render_options.annotation_spacing * (textLine + 1));
	      } else {
	        return this.stave.getYForTopText(textLine);
	      }
	    }
	  }, {
	    key: 'getYForBottomText',
	    value: function getYForBottomText(textLine) {
	      var extents = this.getStemExtents();
	      if (this.hasStem()) {
	        return Math.max(this.stave.getYForTopText(textLine), extents.baseY + this.render_options.annotation_spacing * textLine);
	      } else {
	        return this.stave.getYForBottomText(textLine);
	      }
	    }
	  }, {
	    key: 'hasFlag',
	    value: function hasFlag() {
	      return _tables.Flow.durationToGlyph(this.duration).flag && !this.beam;
	    }
	
	    // Post format the note
	
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      if (this.beam) this.beam.postFormat();
	
	      this.postFormatted = true;
	
	      return this;
	    }
	
	    // Render the stem onto the canvas
	
	  }, {
	    key: 'drawStem',
	    value: function drawStem(stem_struct) {
	      this.checkContext();
	      this.setRendered();
	
	      this.setStem(new _stem.Stem(stem_struct));
	      this.stem.setContext(this.context).draw();
	    }
	  }]);

	  return StemmableNote;
	}(_note.Note);

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modifier = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// `Modifier` is an abstract interface for notational elements that modify
	// a `Note`. Examples of modifiers are `Accidental`, `Annotation`, `Stroke`, etc.
	//
	// For a `Modifier` instance to be positioned correctly, it must be part of
	// a `ModifierContext`. All modifiers in the same context are rendered relative to
	// one another.
	//
	// Typically, all modifiers to a note are part of the same `ModifierContext` instance. Also,
	// in multi-voice staves, all modifiers to notes on the same `tick` are part of the same
	// `ModifierContext`. This ensures that multiple voices don't trample all over each other.
	
	// To enable logging for this class. Set `Vex.Flow.Modifier.DEBUG` to `true`.
	// function L(...args) { if (Modifier.DEBUG) Vex.L('Vex.Flow.Modifier', args); }
	
	var Modifier = exports.Modifier = function (_Element) {
	  _inherits(Modifier, _Element);
	
	  _createClass(Modifier, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'none';
	    }
	
	    // Modifiers can be positioned almost anywhere, relative to a note.
	
	  }, {
	    key: 'Position',
	    get: function get() {
	      return {
	        LEFT: 1,
	        RIGHT: 2,
	        ABOVE: 3,
	        BELOW: 4
	      };
	    }
	  }, {
	    key: 'PositionString',
	    get: function get() {
	      return {
	        above: Modifier.Position.ABOVE,
	        below: Modifier.Position.BELOW,
	        left: Modifier.Position.LEFT,
	        right: Modifier.Position.RIGHT
	      };
	    }
	  }]);
	
	  function Modifier() {
	    _classCallCheck(this, Modifier);
	
	    var _this = _possibleConstructorReturn(this, (Modifier.__proto__ || Object.getPrototypeOf(Modifier)).call(this));
	
	    _this.setAttribute('type', 'Modifier');
	
	    _this.width = 0;
	
	    // Modifiers are attached to a note and an index. An index is a
	    // specific head in a chord.
	    _this.note = null;
	    _this.index = null;
	
	    // The `text_line` is reserved space above or below a stave.
	    _this.text_line = 0;
	    _this.position = Modifier.Position.LEFT;
	    _this.modifier_context = null;
	    _this.x_shift = 0;
	    _this.y_shift = 0;
	    _this.spacingFromNextModifier = 0;
	    return _this;
	  }
	
	  // Every modifier has a category. The `ModifierContext` uses this to determine
	  // the type and order of the modifiers.
	
	
	  _createClass(Modifier, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Modifier.CATEGORY;
	    }
	
	    // Get and set modifier widths.
	
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.width = width;return this;
	    }
	
	    // Get and set attached note (`StaveNote`, `TabNote`, etc.)
	
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.note;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      this.note = note;return this;
	    }
	
	    // Get and set note index, which is a specific note in a chord.
	
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      return this.index;
	    }
	  }, {
	    key: 'setIndex',
	    value: function setIndex(index) {
	      this.index = index;return this;
	    }
	
	    // Every modifier must be part of a `ModifierContext`.
	
	  }, {
	    key: 'getModifierContext',
	    value: function getModifierContext() {
	      return this.modifier_context;
	    }
	  }, {
	    key: 'setModifierContext',
	    value: function setModifierContext(c) {
	      this.modifier_context = c;return this;
	    }
	
	    // Get and set articulation position.
	
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      return this.position;
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(position) {
	      this.position = typeof position === 'string' ? Modifier.PositionString[position] : position;
	      return this;
	    }
	
	    // Set the `text_line` for the modifier.
	
	  }, {
	    key: 'setTextLine',
	    value: function setTextLine(line) {
	      this.text_line = line;return this;
	    }
	
	    // Shift modifier down `y` pixels. Negative values shift up.
	
	  }, {
	    key: 'setYShift',
	    value: function setYShift(y) {
	      this.y_shift = y;return this;
	    }
	  }, {
	    key: 'setSpacingFromNextModifier',
	    value: function setSpacingFromNextModifier(x) {
	      this.spacingFromNextModifier = x;
	    }
	  }, {
	    key: 'getSpacingFromNextModifier',
	    value: function getSpacingFromNextModifier() {
	      return this.spacingFromNextModifier;
	    }
	
	    // Shift modifier `x` pixels in the direction of the modifier. Negative values
	    // shift reverse.
	
	  }, {
	    key: 'setXShift',
	    value: function setXShift(x) {
	      this.x_shift = 0;
	      if (this.position === Modifier.Position.LEFT) {
	        this.x_shift -= x;
	      } else {
	        this.x_shift += x;
	      }
	    }
	  }, {
	    key: 'getXShift',
	    value: function getXShift() {
	      return this.x_shift;
	    }
	
	    // Render the modifier onto the canvas.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      throw new _vex.Vex.RERR('MethodNotImplemented', 'draw() not implemented for this modifier.');
	    }
	  }]);

	  return Modifier;
	}(_element.Element);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements dot modifiers for notes.
	
	var Dot = exports.Dot = function (_Modifier) {
	  _inherits(Dot, _Modifier);
	
	  _createClass(Dot, null, [{
	    key: 'format',
	
	
	    // Arrange dots inside a ModifierContext.
	    value: function format(dots, state) {
	      var right_shift = state.right_shift;
	      var dot_spacing = 1;
	
	      if (!dots || dots.length === 0) return false;
	
	      var dot_list = [];
	      for (var i = 0; i < dots.length; ++i) {
	        var dot = dots[i];
	        var note = dot.getNote();
	
	        var props = void 0;
	        var shift = void 0;
	        // Only StaveNote has .getKeyProps()
	        if (typeof note.getKeyProps === 'function') {
	          props = note.getKeyProps()[dot.getIndex()];
	          shift = props.displaced ? note.getExtraRightPx() : 0;
	        } else {
	          // Else it's a TabNote
	          props = { line: 0.5 }; // Shim key props for dot placement
	          shift = 0;
	        }
	
	        dot_list.push({ line: props.line, shift: shift, note: note, dot: dot });
	      }
	
	      // Sort dots by line number.
	      dot_list.sort(function (a, b) {
	        return b.line - a.line;
	      });
	
	      var dot_shift = right_shift;
	      var x_width = 0;
	      var last_line = null;
	      var last_note = null;
	      var prev_dotted_space = null;
	      var half_shiftY = 0;
	
	      for (var _i = 0; _i < dot_list.length; ++_i) {
	        var _dot_list$_i = dot_list[_i];
	        var _dot = _dot_list$_i.dot;
	        var _note = _dot_list$_i.note;
	        var _shift = _dot_list$_i.shift;
	        var line = _dot_list$_i.line;
	
	        // Reset the position of the dot every line.
	
	        if (line !== last_line || _note !== last_note) {
	          dot_shift = _shift;
	        }
	
	        if (!_note.isRest() && line !== last_line) {
	          if (Math.abs(line % 1) === 0.5) {
	            // note is on a space, so no dot shift
	            half_shiftY = 0;
	          } else if (!_note.isRest()) {
	            // note is on a line, so shift dot to space above the line
	            half_shiftY = 0.5;
	            if (last_note != null && !last_note.isRest() && last_line - line === 0.5) {
	              // previous note on a space, so shift dot to space below the line
	              half_shiftY = -0.5;
	            } else if (line + half_shiftY === prev_dotted_space) {
	              // previous space is dotted, so shift dot to space below the line
	              half_shiftY = -0.5;
	            }
	          }
	        }
	
	        // convert half_shiftY to a multiplier for dots.draw()
	        _dot.dot_shiftY = -half_shiftY;
	        prev_dotted_space = line + half_shiftY;
	
	        _dot.setXShift(dot_shift);
	        dot_shift += _dot.getWidth() + dot_spacing; // spacing
	        x_width = dot_shift > x_width ? dot_shift : x_width;
	        last_line = line;
	        last_note = _note;
	      }
	
	      // Update state.
	      state.right_shift += x_width;
	      return true;
	    }
	
	    /**
	     * @constructor
	     */
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'dots';
	    }
	  }]);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    var _this = _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).call(this));
	
	    _this.setAttribute('type', 'Dot');
	
	    _this.note = null;
	    _this.index = null;
	    _this.position = _modifier.Modifier.Position.RIGHT;
	
	    _this.radius = 2;
	    _this.setWidth(5);
	    _this.dot_shiftY = 0;
	    return _this;
	  }
	
	  _createClass(Dot, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Dot.CATEGORY;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      this.note = note;
	
	      if (this.note.getCategory() === 'gracenotes') {
	        this.radius *= 0.50;
	        this.setWidth(3);
	      }
	    }
	  }, {
	    key: 'setDotShiftY',
	    value: function setDotShiftY(y) {
	      this.dot_shiftY = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      if (!this.note || this.index === null) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw dot without a note and index.");
	      }
	
	      var lineSpace = this.note.stave.options.spacing_between_lines_px;
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	
	      // Set the starting y coordinate to the base of the stem for TabNotes
	      if (this.note.getCategory() === 'tabnotes') {
	        start.y = this.note.getStemExtents().baseY;
	      }
	
	      var x = start.x + this.x_shift + this.width - this.radius;
	      var y = start.y + this.y_shift + this.dot_shiftY * lineSpace;
	      var ctx = this.context;
	
	      ctx.beginPath();
	      ctx.arc(x, y, this.radius, 0, Math.PI * 2, false);
	      ctx.fill();
	    }
	  }]);

	  return Dot;
	}(_modifier.Modifier);

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifierContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This class implements various types of modifiers to notes (e.g. bends,
	// fingering positions etc.)
	
	var _vex = __webpack_require__(1);
	
	var _stavenote = __webpack_require__(20);
	
	var _dot = __webpack_require__(26);
	
	var _frethandfinger = __webpack_require__(28);
	
	var _accidental = __webpack_require__(29);
	
	var _notesubgroup = __webpack_require__(31);
	
	var _gracenotegroup = __webpack_require__(32);
	
	var _strokes = __webpack_require__(35);
	
	var _stringnumber = __webpack_require__(36);
	
	var _articulation = __webpack_require__(37);
	
	var _ornament = __webpack_require__(38);
	
	var _annotation = __webpack_require__(40);
	
	var _bend = __webpack_require__(41);
	
	var _vibrato = __webpack_require__(42);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// To enable logging for this class. Set `Vex.Flow.ModifierContext.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (ModifierContext.DEBUG) _vex.Vex.L('Vex.Flow.ModifierContext', args);
	}
	
	var ModifierContext = exports.ModifierContext = function () {
	  function ModifierContext() {
	    _classCallCheck(this, ModifierContext);
	
	    // Current modifiers
	    this.modifiers = {};
	
	    // Formatting data.
	    this.preFormatted = false;
	    this.postFormatted = false;
	    this.width = 0;
	    this.spacing = 0;
	    this.state = {
	      left_shift: 0,
	      right_shift: 0,
	      text_line: 0,
	      top_text_line: 0
	    };
	
	    // Add new modifiers to this array. The ordering is significant -- lower
	    // modifiers are formatted and rendered before higher ones.
	    this.PREFORMAT = [_stavenote.StaveNote, _dot.Dot, _frethandfinger.FretHandFinger, _accidental.Accidental, _gracenotegroup.GraceNoteGroup, _notesubgroup.NoteSubGroup, _strokes.Stroke, _stringnumber.StringNumber, _articulation.Articulation, _ornament.Ornament, _annotation.Annotation, _bend.Bend, _vibrato.Vibrato];
	
	    // If post-formatting is required for an element, add it to this array.
	    this.POSTFORMAT = [_stavenote.StaveNote];
	  }
	
	  _createClass(ModifierContext, [{
	    key: 'addModifier',
	    value: function addModifier(modifier) {
	      var type = modifier.getCategory();
	      if (!this.modifiers[type]) this.modifiers[type] = [];
	      this.modifiers[type].push(modifier);
	      modifier.setModifierContext(this);
	      this.preFormatted = false;
	      return this;
	    }
	  }, {
	    key: 'getModifiers',
	    value: function getModifiers(type) {
	      return this.modifiers[type];
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'getExtraLeftPx',
	    value: function getExtraLeftPx() {
	      return this.state.left_shift;
	    }
	  }, {
	    key: 'getExtraRightPx',
	    value: function getExtraRightPx() {
	      return this.state.right_shift;
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.state;
	    }
	  }, {
	    key: 'getMetrics',
	    value: function getMetrics() {
	      if (!this.formatted) {
	        throw new _vex.Vex.RERR('UnformattedModifier', 'Unformatted modifier has no metrics.');
	      }
	
	      return {
	        width: this.state.left_shift + this.state.right_shift + this.spacing,
	        spacing: this.spacing,
	        extra_left_px: this.state.left_shift,
	        extra_right_px: this.state.right_shift
	      };
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      var _this = this;
	
	      if (this.preFormatted) return;
	      this.PREFORMAT.forEach(function (modifier) {
	        L('Preformatting ModifierContext: ', modifier.CATEGORY);
	        modifier.format(_this.getModifiers(modifier.CATEGORY), _this.state, _this);
	      });
	
	      // Update width of this modifier context
	      this.width = this.state.left_shift + this.state.right_shift;
	      this.preFormatted = true;
	    }
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      var _this2 = this;
	
	      if (this.postFormatted) return;
	      this.POSTFORMAT.forEach(function (modifier) {
	        L('Postformatting ModifierContext: ', modifier.CATEGORY);
	        modifier.postFormat(_this2.getModifiers(modifier.CATEGORY), _this2);
	      });
	    }
	  }]);

	  return ModifierContext;
	}();

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FretHandFinger = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	// Author Larry Kuhns 2013
	// Class to draws string numbers into the notation.
	
	/**
	 * @constructor
	 */
	var FretHandFinger = exports.FretHandFinger = function (_Modifier) {
	  _inherits(FretHandFinger, _Modifier);
	
	  _createClass(FretHandFinger, null, [{
	    key: 'format',
	
	
	    // Arrange fingerings inside a ModifierContext.
	    value: function format(nums, state) {
	      var left_shift = state.left_shift;
	      var right_shift = state.right_shift;
	
	      var num_spacing = 1;
	
	      if (!nums || nums.length === 0) return false;
	
	      var nums_list = [];
	      var prev_note = null;
	      var shiftLeft = 0;
	      var shiftRight = 0;
	
	      for (var i = 0; i < nums.length; ++i) {
	        var num = nums[i];
	        var note = num.getNote();
	        var pos = num.getPosition();
	        var props = note.getKeyProps()[num.getIndex()];
	        if (note !== prev_note) {
	          for (var n = 0; n < note.keys.length; ++n) {
	            var props_tmp = note.getKeyProps()[n];
	            if (left_shift === 0) {
	              shiftLeft = props_tmp.displaced ? note.getExtraLeftPx() : shiftLeft;
	            }
	            if (right_shift === 0) {
	              shiftRight = props_tmp.displaced ? note.getExtraRightPx() : shiftRight;
	            }
	          }
	          prev_note = note;
	        }
	
	        nums_list.push({
	          note: note,
	          num: num,
	          pos: pos,
	          line: props.line,
	          shiftL: shiftLeft,
	          shiftR: shiftRight
	        });
	      }
	
	      // Sort fingernumbers by line number.
	      nums_list.sort(function (a, b) {
	        return b.line - a.line;
	      });
	
	      var numShiftL = 0;
	      var numShiftR = 0;
	      var xWidthL = 0;
	      var xWidthR = 0;
	      var lastLine = null;
	      var lastNote = null;
	
	      for (var _i = 0; _i < nums_list.length; ++_i) {
	        var num_shift = 0;
	        var _nums_list$_i = nums_list[_i];
	        var _note = _nums_list$_i.note;
	        var _pos = _nums_list$_i.pos;
	        var _num = _nums_list$_i.num;
	        var line = _nums_list$_i.line;
	        var shiftL = _nums_list$_i.shiftL;
	        var shiftR = _nums_list$_i.shiftR;
	
	        // Reset the position of the string number every line.
	
	        if (line !== lastLine || _note !== lastNote) {
	          numShiftL = left_shift + shiftL;
	          numShiftR = right_shift + shiftR;
	        }
	
	        var numWidth = _num.getWidth() + num_spacing;
	        if (_pos === _modifier.Modifier.Position.LEFT) {
	          _num.setXShift(left_shift + numShiftL);
	          num_shift = left_shift + numWidth; // spacing
	          xWidthL = num_shift > xWidthL ? num_shift : xWidthL;
	        } else if (_pos === _modifier.Modifier.Position.RIGHT) {
	          _num.setXShift(numShiftR);
	          num_shift = shiftRight + numWidth; // spacing
	          xWidthR = num_shift > xWidthR ? num_shift : xWidthR;
	        }
	        lastLine = line;
	        lastNote = _note;
	      }
	
	      state.left_shift += xWidthL;
	      state.right_shift += xWidthR;
	
	      return true;
	    }
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'frethandfinger';
	    }
	  }]);
	
	  function FretHandFinger(number) {
	    _classCallCheck(this, FretHandFinger);
	
	    var _this = _possibleConstructorReturn(this, (FretHandFinger.__proto__ || Object.getPrototypeOf(FretHandFinger)).call(this));
	
	    _this.setAttribute('type', 'FretHandFinger');
	
	    _this.note = null;
	    _this.index = null;
	    _this.finger = number;
	    _this.width = 7;
	    _this.position = _modifier.Modifier.Position.LEFT; // Default position above stem or note head
	    _this.x_shift = 0;
	    _this.y_shift = 0;
	    _this.x_offset = 0; // Horizontal offset from default
	    _this.y_offset = 0; // Vertical offset from default
	    _this.font = {
	      family: 'sans-serif',
	      size: 9,
	      weight: 'bold'
	    };
	    return _this;
	  }
	
	  _createClass(FretHandFinger, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return FretHandFinger.CATEGORY;
	    }
	  }, {
	    key: 'setFretHandFinger',
	    value: function setFretHandFinger(number) {
	      this.finger = number;return this;
	    }
	  }, {
	    key: 'setOffsetX',
	    value: function setOffsetX(x) {
	      this.x_offset = x;return this;
	    }
	  }, {
	    key: 'setOffsetY',
	    value: function setOffsetY(y) {
	      this.y_offset = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!this.note || this.index == null) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw string number without a note and index.");
	      }
	
	      this.setRendered();
	      var ctx = this.context;
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var dot_x = start.x + this.x_shift + this.x_offset;
	      var dot_y = start.y + this.y_shift + this.y_offset + 5;
	
	      switch (this.position) {
	        case _modifier.Modifier.Position.ABOVE:
	          dot_x -= 4;
	          dot_y -= 12;
	          break;
	        case _modifier.Modifier.Position.BELOW:
	          dot_x -= 2;
	          dot_y += 10;
	          break;
	        case _modifier.Modifier.Position.LEFT:
	          dot_x -= this.width;
	          break;
	        case _modifier.Modifier.Position.RIGHT:
	          dot_x += 1;
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidPostion', 'The position ' + this.position + ' does not exist');
	      }
	
	      ctx.save();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      ctx.fillText('' + this.finger, dot_x, dot_y);
	      ctx.restore();
	    }
	  }]);

	  return FretHandFinger;
	}(_modifier.Modifier);

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Accidental = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _fraction = __webpack_require__(3);
	
	var _tables = __webpack_require__(2);
	
	var _music = __webpack_require__(30);
	
	var _modifier = __webpack_require__(25);
	
	var _glyph = __webpack_require__(4);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Mohit Cheppudira
	// @author Greg Ristow (modifications)
	//
	// ## Description
	//
	// This file implements accidentals as modifiers that can be attached to
	// notes. Support is included for both western and microtonal accidentals.
	//
	// See `tests/accidental_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.Accidental.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Accidental.DEBUG) _vex.Vex.L('Vex.Flow.Accidental', args);
	}
	
	var getGlyphWidth = function getGlyphWidth(glyph) {
	  return glyph.getMetrics().width;
	};
	
	// An `Accidental` inherits from `Modifier`, and is formatted within a
	// `ModifierContext`.
	
	var Accidental = exports.Accidental = function (_Modifier) {
	  _inherits(Accidental, _Modifier);
	
	  _createClass(Accidental, null, [{
	    key: 'format',
	
	
	    // Arrange accidentals inside a ModifierContext.
	    value: function format(accidentals, state) {
	      var _this2 = this;
	
	      var noteheadAccidentalPadding = 1;
	      var leftShift = state.left_shift + noteheadAccidentalPadding;
	      var accidentalSpacing = 3;
	
	      // If there are no accidentals, we needn't format their positions
	      if (!accidentals || accidentals.length === 0) return;
	
	      var accList = [];
	      var prevNote = null;
	      var shiftL = 0;
	
	      // First determine the accidentals' Y positions from the note.keys
	      var propsTemp = void 0;
	      for (var i = 0; i < accidentals.length; ++i) {
	        var acc = accidentals[i];
	        var note = acc.getNote();
	        var stave = note.getStave();
	        var props = note.getKeyProps()[acc.getIndex()];
	        if (note !== prevNote) {
	          // Iterate through all notes to get the displaced pixels
	          for (var n = 0; n < note.keys.length; ++n) {
	            propsTemp = note.getKeyProps()[n];
	            shiftL = propsTemp.displaced ? note.getExtraLeftPx() : shiftL;
	          }
	          prevNote = note;
	        }
	        if (stave !== null) {
	          var lineSpace = stave.options.spacing_between_lines_px;
	          var y = stave.getYForLine(props.line);
	          var accLine = Math.round(y / lineSpace * 2) / 2;
	          accList.push({ y: y, line: accLine, shift: shiftL, acc: acc, lineSpace: lineSpace });
	        } else {
	          accList.push({ line: props.line, shift: shiftL, acc: acc });
	        }
	      }
	
	      // Sort accidentals by line number.
	      accList.sort(function (a, b) {
	        return b.line - a.line;
	      });
	
	      // FIXME: Confusing name. Each object in this array has a property called `line`.
	      // So if this is a list of lines, you end up with: `line.line` which is very awkward.
	      var lineList = [];
	
	      // amount by which all accidentals must be shifted right or left for
	      // stem flipping, notehead shifting concerns.
	      var accShift = 0;
	      var previousLine = null;
	
	      // Create an array of unique line numbers (lineList) from accList
	      for (var _i = 0; _i < accList.length; _i++) {
	        var _acc = accList[_i];
	
	        // if this is the first line, or a new line, add a lineList
	        if (previousLine === null || previousLine !== _acc.line) {
	          lineList.push({
	            line: _acc.line,
	            flatLine: true,
	            dblSharpLine: true,
	            numAcc: 0,
	            width: 0
	          });
	        }
	        // if this accidental is not a flat, the accidental needs 3.0 lines lower
	        // clearance instead of 2.5 lines for b or bb.
	        // FIXME: Naming could use work. acc.acc is very awkward
	        if (_acc.acc.type !== 'b' && _acc.acc.type !== 'bb') {
	          lineList[lineList.length - 1].flatLine = false;
	        }
	
	        // if this accidental is not a double sharp, the accidental needs 3.0 lines above
	        if (_acc.acc.type !== '##') {
	          lineList[lineList.length - 1].dblSharpLine = false;
	        }
	
	        // Track how many accidentals are on this line:
	        lineList[lineList.length - 1].numAcc++;
	
	        // Track the total x_offset needed for this line which will be needed
	        // for formatting lines w/ multiple accidentals:
	
	        // width = accidental width + universal spacing between accidentals
	        lineList[lineList.length - 1].width += _acc.acc.getWidth() + accidentalSpacing;
	
	        // if this accShift is larger, use it to keep first column accidentals in the same line
	        accShift = _acc.shift > accShift ? _acc.shift : accShift;
	
	        previousLine = _acc.line;
	      }
	
	      // ### Place Accidentals in Columns
	      //
	      // Default to a classic triangular layout (middle accidental farthest left),
	      // but follow exceptions as outlined in G. Read's _Music Notation_ and
	      // Elaine Gould's _Behind Bars_.
	      //
	      // Additionally, this implements different vertical collision rules for
	      // flats (only need 2.5 lines clearance below) and double sharps (only
	      // need 2.5 lines of clearance above or below).
	      //
	      // Classic layouts and exception patterns are found in the 'tables.js'
	      // in 'Vex.Flow.accidentalColumnsTable'
	      //
	      // Beyond 6 vertical accidentals, default to the parallel ascending lines approach,
	      // using as few columns as possible for the verticle structure.
	      //
	      // TODO (?): Allow column to be specified for an accidental at run-time?
	
	      var totalColumns = 0;
	
	      // establish the boundaries for a group of notes with clashing accidentals:
	
	      var _loop = function _loop(_i3) {
	        var noFurtherConflicts = false;
	        var groupStart = _i3;
	        var groupEnd = _i3;
	
	        while (groupEnd + 1 < lineList.length && !noFurtherConflicts) {
	          // if this note conflicts with the next:
	          if (_this2.checkCollision(lineList[groupEnd], lineList[groupEnd + 1])) {
	            // include the next note in the group:
	            groupEnd++;
	          } else {
	            noFurtherConflicts = true;
	          }
	        }
	
	        // Gets an a line from the `lineList`, relative to the current group
	        var getGroupLine = function getGroupLine(index) {
	          return lineList[groupStart + index];
	        };
	        var getGroupLines = function getGroupLines(indexes) {
	          return indexes.map(getGroupLine);
	        };
	        var lineDifference = function lineDifference(indexA, indexB) {
	          var _getGroupLines$map = getGroupLines([indexA, indexB]).map(function (item) {
	            return item.line;
	          });
	
	          var _getGroupLines$map2 = _slicedToArray(_getGroupLines$map, 2);
	
	          var a = _getGroupLines$map2[0];
	          var b = _getGroupLines$map2[1];
	
	          return a - b;
	        };
	
	        var notColliding = function notColliding() {
	          for (var _len2 = arguments.length, indexPairs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            indexPairs[_key2] = arguments[_key2];
	          }
	
	          return indexPairs.map(getGroupLines).every(function (lines) {
	            return !_this2.checkCollision.apply(_this2, _toConsumableArray(lines));
	          });
	        };
	
	        // Set columns for the lines in this group:
	        var groupLength = groupEnd - groupStart + 1;
	
	        // Set the accidental column for each line of the group
	        var endCase = _this2.checkCollision(lineList[groupStart], lineList[groupEnd]) ? 'a' : 'b';
	
	        switch (groupLength) {
	          case 3:
	            if (endCase === 'a' && lineDifference(1, 2) === 0.5 && lineDifference(0, 1) !== 0.5) {
	              endCase = 'second_on_bottom';
	            }
	            break;
	          case 4:
	            if (notColliding([0, 2], [1, 3])) {
	              endCase = 'spaced_out_tetrachord';
	            }
	            break;
	          case 5:
	            if (endCase === 'b' && notColliding([1, 3])) {
	              endCase = 'spaced_out_pentachord';
	              if (notColliding([0, 2], [2, 4])) {
	                endCase = 'very_spaced_out_pentachord';
	              }
	            }
	            break;
	          case 6:
	            if (notColliding([0, 3], [1, 4], [2, 5])) {
	              endCase = 'spaced_out_hexachord';
	            }
	            if (notColliding([0, 2], [2, 4], [1, 3], [3, 5])) {
	              endCase = 'very_spaced_out_hexachord';
	            }
	            break;
	          default:
	            break;
	        }
	
	        var groupMember = void 0;
	        var column = void 0;
	        // If the group contains more than seven members, use ascending parallel lines
	        // of accidentals, using as few columns as possible while avoiding collisions.
	        if (groupLength >= 7) {
	          // First, determine how many columns to use:
	          var patternLength = 2;
	          var collisionDetected = true;
	          while (collisionDetected === true) {
	            collisionDetected = false;
	            for (var line = 0; line + patternLength < lineList.length; line++) {
	              if (_this2.checkCollision(lineList[line], lineList[line + patternLength])) {
	                collisionDetected = true;
	                patternLength++;
	                break;
	              }
	            }
	          }
	          // Then, assign a column to each line of accidentals
	          for (groupMember = _i3; groupMember <= groupEnd; groupMember++) {
	            column = (groupMember - _i3) % patternLength + 1;
	            lineList[groupMember].column = column;
	            totalColumns = totalColumns > column ? totalColumns : column;
	          }
	
	          // Otherwise, if the group contains fewer than seven members, use the layouts from
	          // the accidentalsColumnsTable housed in tables.js.
	        } else {
	          for (groupMember = _i3; groupMember <= groupEnd; groupMember++) {
	            column = _tables.Flow.accidentalColumnsTable[groupLength][endCase][groupMember - _i3];
	            lineList[groupMember].column = column;
	            totalColumns = totalColumns > column ? totalColumns : column;
	          }
	        }
	
	        // Increment i to the last note that was set, so that if a lower set of notes
	        // does not conflict at all with this group, it can have its own classic shape.
	        _i3 = groupEnd;
	        _i2 = _i3;
	      };
	
	      for (var _i2 = 0; _i2 < lineList.length; _i2++) {
	        _loop(_i2);
	      }
	
	      // ### Convert Columns to x_offsets
	      //
	      // This keeps columns aligned, even if they have different accidentals within them
	      // which sometimes results in a larger x_offset than is an accidental might need
	      // to preserve the symmetry of the accidental shape.
	      //
	      // Neither A.C. Vinci nor G. Read address this, and it typically only happens in
	      // music with complex chord clusters.
	      //
	      // TODO (?): Optionally allow closer compression of accidentals, instead of forcing
	      // parallel columns.
	
	      // track each column's max width, which will be used as initial shift of later columns:
	      var columnWidths = [];
	      var columnXOffsets = [];
	      for (var _i4 = 0; _i4 <= totalColumns; _i4++) {
	        columnWidths[_i4] = 0;
	        columnXOffsets[_i4] = 0;
	      }
	
	      columnWidths[0] = accShift + leftShift;
	      columnXOffsets[0] = accShift + leftShift;
	
	      // Fill columnWidths with widest needed x-space;
	      // this is what keeps the columns parallel.
	      lineList.forEach(function (line) {
	        if (line.width > columnWidths[line.column]) columnWidths[line.column] = line.width;
	      });
	
	      for (var _i5 = 1; _i5 < columnWidths.length; _i5++) {
	        // this column's offset = this column's width + previous column's offset
	        columnXOffsets[_i5] = columnWidths[_i5] + columnXOffsets[_i5 - 1];
	      }
	
	      var totalShift = columnXOffsets[columnXOffsets.length - 1];
	      // Set the xShift for each accidental according to column offsets:
	      var accCount = 0;
	      lineList.forEach(function (line) {
	        var lineWidth = 0;
	        var lastAccOnLine = accCount + line.numAcc;
	        // handle all of the accidentals on a given line:
	        for (accCount; accCount < lastAccOnLine; accCount++) {
	          var xShift = columnXOffsets[line.column - 1] + lineWidth;
	          accList[accCount].acc.setXShift(xShift);
	          // keep track of the width of accidentals we've added so far, so that when
	          // we loop, we add space for them.
	          lineWidth += accList[accCount].acc.getWidth() + accidentalSpacing;
	          L('Line, accCount, shift: ', line.line, accCount, xShift);
	        }
	      });
	
	      // update the overall layout with the full width of the accidental shapes:
	      state.left_shift += totalShift;
	    }
	
	    // Helper function to determine whether two lines of accidentals collide vertically
	
	  }, {
	    key: 'checkCollision',
	    value: function checkCollision(line1, line2) {
	      var clearance = line2.line - line1.line;
	      var clearanceRequired = 3;
	      // But less clearance is required for certain accidentals: b, bb and ##.
	      if (clearance > 0) {
	        // then line 2 is on top
	        clearanceRequired = line2.flatLine || line2.dblSharpLine ? 2.5 : 3.0;
	        if (line1.dblSharpLine) clearance -= 0.5;
	      } else {
	        // line 1 is on top
	        clearanceRequired = line1.flatLine || line1.dblSharpLine ? 2.5 : 3.0;
	        if (line2.dblSharpLine) clearance -= 0.5;
	      }
	      var collision = Math.abs(clearance) < clearanceRequired;
	      L('Line_1, Line_2, Collision: ', line1.line, line2.line, collision);
	      return collision;
	    }
	
	    // Use this method to automatically apply accidentals to a set of `voices`.
	    // The accidentals will be remembered between all the voices provided.
	    // Optionally, you can also provide an initial `keySignature`.
	
	  }, {
	    key: 'applyAccidentals',
	    value: function applyAccidentals(voices, keySignature) {
	      var tickPositions = [];
	      var tickNoteMap = {};
	
	      // Sort the tickables in each voice by their tick position in the voice
	      voices.forEach(function (voice) {
	        var tickPosition = new _fraction.Fraction(0, 1);
	        var notes = voice.getTickables();
	        notes.forEach(function (note) {
	          if (note.shouldIgnoreTicks()) return;
	
	          var notesAtPosition = tickNoteMap[tickPosition.value()];
	
	          if (!notesAtPosition) {
	            tickPositions.push(tickPosition.value());
	            tickNoteMap[tickPosition.value()] = [note];
	          } else {
	            notesAtPosition.push(note);
	          }
	
	          tickPosition.add(note.getTicks());
	        });
	      });
	
	      var music = new _music.Music();
	
	      // Default key signature is C major
	      if (!keySignature) keySignature = 'C';
	
	      // Get the scale map, which represents the current state of each pitch
	      var scaleMap = music.createScaleMap(keySignature);
	
	      tickPositions.forEach(function (tick) {
	        var notes = tickNoteMap[tick];
	
	        // Array to store all pitches that modified accidental states
	        // at this tick position
	        var modifiedPitches = [];
	
	        var processNote = function processNote(note) {
	          if (note.isRest() || note.shouldIgnoreTicks()) return;
	
	          // Go through each key and determine if an accidental should be
	          // applied
	          note.keys.forEach(function (keyString, keyIndex) {
	            var key = music.getNoteParts(keyString.split('/')[0]);
	
	            // Force a natural for every key without an accidental
	            var accidentalString = key.accidental || 'n';
	            var pitch = key.root + accidentalString;
	
	            // Determine if the current pitch has the same accidental
	            // as the scale state
	            var sameAccidental = scaleMap[key.root] === pitch;
	
	            // Determine if an identical pitch in the chord already
	            // modified the accidental state
	            var previouslyModified = modifiedPitches.indexOf(pitch) > -1;
	
	            // Add the accidental to the StaveNote
	            if (!sameAccidental || sameAccidental && previouslyModified) {
	              // Modify the scale map so that the root pitch has an
	              // updated state
	              scaleMap[key.root] = pitch;
	
	              // Create the accidental
	              var accidental = new Accidental(accidentalString);
	
	              // Attach the accidental to the StaveNote
	              note.addAccidental(keyIndex, accidental);
	
	              // Add the pitch to list of pitches that modified accidentals
	              modifiedPitches.push(pitch);
	            }
	          });
	
	          // process grace notes
	          note.getModifiers().forEach(function (modifier) {
	            if (modifier.getCategory() === 'gracenotegroups') {
	              modifier.getGraceNotes().forEach(processNote);
	            }
	          });
	        };
	
	        notes.forEach(processNote);
	      });
	    }
	
	    // Create accidental. `type` can be a value from the
	    // `Vex.Flow.accidentalCodes.accidentals` table in `tables.js`. For
	    // example: `#`, `##`, `b`, `n`, etc.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'accidentals';
	    }
	  }]);
	
	  function Accidental() {
	    var type = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	    _classCallCheck(this, Accidental);
	
	    var _this = _possibleConstructorReturn(this, (Accidental.__proto__ || Object.getPrototypeOf(Accidental)).call(this));
	
	    _this.setAttribute('type', 'Accidental');
	
	    L('New accidental: ', type);
	
	    _this.note = null;
	    // The `index` points to a specific note in a chord.
	    _this.index = null;
	    _this.type = type;
	    _this.position = _modifier.Modifier.Position.LEFT;
	
	    _this.render_options = {
	      // Font size for glyphs
	      font_scale: 38,
	
	      // Length of stroke across heads above or below the stave.
	      stroke_px: 3,
	
	      // Padding between accidental and parentheses on each side
	      parenLeftPadding: 2,
	      parenRightPadding: 2
	    };
	
	    _this.accidental = _tables.Flow.accidentalCodes(_this.type);
	    if (!_this.accidental) {
	      throw new _vex.Vex.RERR('ArgumentError', 'Unknown accidental type: ' + type);
	    }
	
	    // Cautionary accidentals have parentheses around them
	    _this.cautionary = false;
	    _this.parenLeft = null;
	    _this.parenRight = null;
	
	    _this.reset();
	    return _this;
	  }
	
	  _createClass(Accidental, [{
	    key: 'reset',
	    value: function reset() {
	      var fontScale = this.render_options.font_scale;
	      this.glyph = new _glyph.Glyph(this.accidental.code, fontScale);
	      this.glyph.setOriginX(1.0);
	
	      if (this.cautionary) {
	        this.parenLeft = new _glyph.Glyph(_tables.Flow.accidentalCodes('{').code, fontScale);
	        this.parenRight = new _glyph.Glyph(_tables.Flow.accidentalCodes('}').code, fontScale);
	        this.parenLeft.setOriginX(1.0);
	        this.parenRight.setOriginX(1.0);
	      }
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return Accidental.CATEGORY;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      var parenWidth = this.cautionary ? getGlyphWidth(this.parenLeft) + getGlyphWidth(this.parenRight) + this.render_options.parenLeftPadding + this.render_options.parenRightPadding : 0;
	
	      return getGlyphWidth(this.glyph) + parenWidth;
	    }
	
	    // Attach this accidental to `note`, which must be a `StaveNote`.
	
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      if (!note) {
	        throw new _vex.Vex.RERR('ArgumentError', 'Bad note value: ' + note);
	      }
	
	      this.note = note;
	
	      // Accidentals attached to grace notes are rendered smaller.
	      if (this.note.getCategory() === 'gracenotes') {
	        this.render_options.font_scale = 25;
	        this.reset();
	      }
	    }
	
	    // If called, draws parenthesis around accidental.
	
	  }, {
	    key: 'setAsCautionary',
	    value: function setAsCautionary() {
	      this.cautionary = true;
	      this.render_options.font_scale = 28;
	      this.reset();
	      return this;
	    }
	
	    // Render accidental onto canvas.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var context = this.context;
	      var type = this.type;
	      var position = this.position;
	      var note = this.note;
	      var index = this.index;
	      var cautionary = this.cautionary;
	      var x_shift = this.x_shift;
	      var y_shift = this.y_shift;
	      var glyph = this.glyph;
	      var parenLeft = this.parenLeft;
	      var parenRight = this.parenRight;
	      var _render_options = this.render_options;
	      var parenLeftPadding = _render_options.parenLeftPadding;
	      var parenRightPadding = _render_options.parenRightPadding;
	
	
	      this.checkContext();
	
	      if (!(note && index != null)) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw accidental without a note and index.");
	      }
	
	      // Figure out the start `x` and `y` coordinates for note and index.
	      var start = note.getModifierStartXY(position, index);
	      var accX = start.x + x_shift;
	      var accY = start.y + y_shift;
	      L('Rendering: ', type, accX, accY);
	
	      if (!cautionary) {
	        glyph.render(context, accX, accY);
	      } else {
	        // Render the accidental in parentheses.
	        parenRight.render(context, accX, accY);
	        accX -= getGlyphWidth(parenRight);
	        accX -= parenRightPadding;
	        accX -= this.accidental.parenRightPaddingAdjustment;
	        glyph.render(context, accX, accY);
	        accX -= getGlyphWidth(glyph);
	        accX -= parenLeftPadding;
	        parenLeft.render(context, accX, accY);
	      }
	
	      this.setRendered();
	    }
	  }]);

	  return Accidental;
	}(_modifier.Modifier);

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Music = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements some standard music theory routines.
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Music = exports.Music = function () {
	  function Music() {
	    _classCallCheck(this, Music);
	  }
	
	  _createClass(Music, [{
	    key: 'isValidNoteValue',
	    value: function isValidNoteValue(note) {
	      if (note == null || note < 0 || note >= Music.NUM_TONES) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'isValidIntervalValue',
	    value: function isValidIntervalValue(interval) {
	      return this.isValidNoteValue(interval);
	    }
	  }, {
	    key: 'getNoteParts',
	    value: function getNoteParts(noteString) {
	      if (!noteString || noteString.length < 1) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid note name: ' + noteString);
	      }
	
	      if (noteString.length > 3) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid note name: ' + noteString);
	      }
	
	      var note = noteString.toLowerCase();
	
	      var regex = /^([cdefgab])(b|bb|n|#|##)?$/;
	      var match = regex.exec(note);
	
	      if (match != null) {
	        var root = match[1];
	        var accidental = match[2];
	
	        return {
	          root: root,
	          accidental: accidental
	        };
	      } else {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid note name: ' + noteString);
	      }
	    }
	  }, {
	    key: 'getKeyParts',
	    value: function getKeyParts(keyString) {
	      if (!keyString || keyString.length < 1) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid key: ' + keyString);
	      }
	
	      var key = keyString.toLowerCase();
	
	      // Support Major, Minor, Melodic Minor, and Harmonic Minor key types.
	      var regex = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/;
	      var match = regex.exec(key);
	
	      if (match != null) {
	        var root = match[1];
	        var accidental = match[2];
	        var type = match[3];
	
	        // Unspecified type implies major
	        if (!type) type = 'M';
	
	        return {
	          root: root,
	          accidental: accidental,
	          type: type
	        };
	      } else {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid key: ' + keyString);
	      }
	    }
	  }, {
	    key: 'getNoteValue',
	    value: function getNoteValue(noteString) {
	      var value = Music.noteValues[noteString];
	      if (value == null) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid note name: ' + noteString);
	      }
	
	      return value.int_val;
	    }
	  }, {
	    key: 'getIntervalValue',
	    value: function getIntervalValue(intervalString) {
	      var value = Music.intervals[intervalString];
	      if (value == null) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid interval name: ${intervalString}');
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getCanonicalNoteName',
	    value: function getCanonicalNoteName(noteValue) {
	      if (!this.isValidNoteValue(noteValue)) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid note value: ' + noteValue);
	      }
	
	      return Music.canonical_notes[noteValue];
	    }
	  }, {
	    key: 'getCanonicalIntervalName',
	    value: function getCanonicalIntervalName(intervalValue) {
	      if (!this.isValidIntervalValue(intervalValue)) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid interval value: ' + intervalValue);
	      }
	
	      return Music.diatonic_intervals[intervalValue];
	    }
	
	    /* Given a note, interval, and interval direction, product the
	     * relative note.
	     */
	
	  }, {
	    key: 'getRelativeNoteValue',
	    value: function getRelativeNoteValue(noteValue, intervalValue, direction) {
	      if (direction == null) direction = 1;
	
	      if (direction !== 1 && direction !== -1) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid direction: ' + direction);
	      }
	
	      var sum = (noteValue + direction * intervalValue) % Music.NUM_TONES;
	      if (sum < 0) sum += Music.NUM_TONES;
	
	      return sum;
	    }
	  }, {
	    key: 'getRelativeNoteName',
	    value: function getRelativeNoteName(root, noteValue) {
	      var parts = this.getNoteParts(root);
	      var rootValue = this.getNoteValue(parts.root);
	      var interval = noteValue - rootValue;
	
	      if (Math.abs(interval) > Music.NUM_TONES - 3) {
	        var multiplier = 1;
	        if (interval > 0) multiplier = -1;
	
	        // Possibly wrap around. (Add +1 for modulo operator)
	        var reverse_interval = (noteValue + 1 + (rootValue + 1)) % Music.NUM_TONES * multiplier;
	
	        if (Math.abs(reverse_interval) > 2) {
	          throw new _vex.Vex.RERR('BadArguments', 'Notes not related: ' + root + ', ' + noteValue + ')');
	        } else {
	          interval = reverse_interval;
	        }
	      }
	
	      if (Math.abs(interval) > 2) {
	        throw new _vex.Vex.RERR('BadArguments', 'Notes not related: ' + root + ', ' + noteValue + ')');
	      }
	
	      var relativeNoteName = parts.root;
	      if (interval > 0) {
	        for (var i = 1; i <= interval; ++i) {
	          relativeNoteName += '#';
	        }
	      } else if (interval < 0) {
	        for (var _i = -1; _i >= interval; --_i) {
	          relativeNoteName += 'b';
	        }
	      }
	
	      return relativeNoteName;
	    }
	
	    /* Return scale tones, given intervals. Each successive interval is
	     * relative to the previous one, e.g., Major Scale:
	     *
	     *   TTSTTTS = [2,2,1,2,2,2,1]
	     *
	     * When used with key = 0, returns C scale (which is isomorphic to
	     * interval list).
	     */
	
	  }, {
	    key: 'getScaleTones',
	    value: function getScaleTones(key, intervals) {
	      var tones = [key];
	
	      var nextNote = key;
	      for (var i = 0; i < intervals.length; i += 1) {
	        nextNote = this.getRelativeNoteValue(nextNote, intervals[i]);
	        if (nextNote !== key) tones.push(nextNote);
	      }
	
	      return tones;
	    }
	
	    /* Returns the interval of a note, given a diatonic scale.
	     *
	     * E.g., Given the scale C, and the note E, returns M3
	     */
	
	  }, {
	    key: 'getIntervalBetween',
	    value: function getIntervalBetween(note1, note2, direction) {
	      if (direction == null) direction = 1;
	
	      if (direction !== 1 && direction !== -1) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid direction: ' + direction);
	      }
	
	      if (!this.isValidNoteValue(note1) || !this.isValidNoteValue(note2)) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid notes: ' + note1 + ', ' + note2);
	      }
	
	      var difference = direction === 1 ? note2 - note1 : note1 - note2;
	
	      if (difference < 0) difference += Music.NUM_TONES;
	
	      return difference;
	    }
	
	    // Create a scale map that represents the pitch state for a
	    // `keySignature`. For example, passing a `G` to `keySignature` would
	    // return a scale map with every note naturalized except for `F` which
	    // has an `F#` state.
	
	  }, {
	    key: 'createScaleMap',
	    value: function createScaleMap(keySignature) {
	      var keySigParts = this.getKeyParts(keySignature);
	      var scaleName = Music.scaleTypes[keySigParts.type];
	
	      var keySigString = keySigParts.root;
	      if (keySigParts.accidental) keySigString += keySigParts.accidental;
	
	      if (!scaleName) throw new _vex.Vex.RERR('BadArguments', 'Unsupported key type: ' + keySignature);
	
	      var scale = this.getScaleTones(this.getNoteValue(keySigString), scaleName);
	      var noteLocation = Music.root_indices[keySigParts.root];
	
	      var scaleMap = {};
	      for (var i = 0; i < Music.roots.length; ++i) {
	        var index = (noteLocation + i) % Music.roots.length;
	        var rootName = Music.roots[index];
	        var noteName = this.getRelativeNoteName(rootName, scale[i]);
	
	        if (noteName.length === 1) {
	          noteName += 'n';
	        }
	
	        scaleMap[rootName] = noteName;
	      }
	
	      return scaleMap;
	    }
	  }], [{
	    key: 'NUM_TONES',
	    get: function get() {
	      return 12;
	    }
	  }, {
	    key: 'roots',
	    get: function get() {
	      return ['c', 'd', 'e', 'f', 'g', 'a', 'b'];
	    }
	  }, {
	    key: 'root_values',
	    get: function get() {
	      return [0, 2, 4, 5, 7, 9, 11];
	    }
	  }, {
	    key: 'root_indices',
	    get: function get() {
	      return {
	        'c': 0,
	        'd': 1,
	        'e': 2,
	        'f': 3,
	        'g': 4,
	        'a': 5,
	        'b': 6
	      };
	    }
	  }, {
	    key: 'canonical_notes',
	    get: function get() {
	      return ['c', 'c#', 'd', 'd#', 'e', 'f', 'f#', 'g', 'g#', 'a', 'a#', 'b'];
	    }
	  }, {
	    key: 'diatonic_intervals',
	    get: function get() {
	      return ['unison', 'm2', 'M2', 'm3', 'M3', 'p4', 'dim5', 'p5', 'm6', 'M6', 'b7', 'M7', 'octave'];
	    }
	  }, {
	    key: 'diatonic_accidentals',
	    get: function get() {
	      return {
	        'unison': { note: 0, accidental: 0 },
	        'm2': { note: 1, accidental: -1 },
	        'M2': { note: 1, accidental: 0 },
	        'm3': { note: 2, accidental: -1 },
	        'M3': { note: 2, accidental: 0 },
	        'p4': { note: 3, accidental: 0 },
	        'dim5': { note: 4, accidental: -1 },
	        'p5': { note: 4, accidental: 0 },
	        'm6': { note: 5, accidental: -1 },
	        'M6': { note: 5, accidental: 0 },
	        'b7': { note: 6, accidental: -1 },
	        'M7': { note: 6, accidental: 0 },
	        'octave': { note: 7, accidental: 0 }
	      };
	    }
	  }, {
	    key: 'intervals',
	    get: function get() {
	      return {
	        'u': 0, 'unison': 0,
	        'm2': 1, 'b2': 1, 'min2': 1, 'S': 1, 'H': 1,
	        '2': 2, 'M2': 2, 'maj2': 2, 'T': 2, 'W': 2,
	        'm3': 3, 'b3': 3, 'min3': 3,
	        'M3': 4, '3': 4, 'maj3': 4,
	        '4': 5, 'p4': 5,
	        '#4': 6, 'b5': 6, 'aug4': 6, 'dim5': 6,
	        '5': 7, 'p5': 7,
	        '#5': 8, 'b6': 8, 'aug5': 8,
	        '6': 9, 'M6': 9, 'maj6': 9,
	        'b7': 10, 'm7': 10, 'min7': 10, 'dom7': 10,
	        'M7': 11, 'maj7': 11,
	        '8': 12, 'octave': 12
	      };
	    }
	  }, {
	    key: 'scales',
	    get: function get() {
	      return {
	        major: [2, 2, 1, 2, 2, 2, 1],
	        dorian: [2, 1, 2, 2, 2, 1, 2],
	        mixolydian: [2, 2, 1, 2, 2, 1, 2],
	        minor: [2, 1, 2, 2, 1, 2, 2]
	      };
	    }
	  }, {
	    key: 'scaleTypes',
	    get: function get() {
	      return {
	        'M': Music.scales.major,
	        'm': Music.scales.minor
	      };
	    }
	  }, {
	    key: 'accidentals',
	    get: function get() {
	      return ['bb', 'b', 'n', '#', '##'];
	    }
	  }, {
	    key: 'noteValues',
	    get: function get() {
	      return {
	        'c': { root_index: 0, int_val: 0 },
	        'cn': { root_index: 0, int_val: 0 },
	        'c#': { root_index: 0, int_val: 1 },
	        'c##': { root_index: 0, int_val: 2 },
	        'cb': { root_index: 0, int_val: 11 },
	        'cbb': { root_index: 0, int_val: 10 },
	        'd': { root_index: 1, int_val: 2 },
	        'dn': { root_index: 1, int_val: 2 },
	        'd#': { root_index: 1, int_val: 3 },
	        'd##': { root_index: 1, int_val: 4 },
	        'db': { root_index: 1, int_val: 1 },
	        'dbb': { root_index: 1, int_val: 0 },
	        'e': { root_index: 2, int_val: 4 },
	        'en': { root_index: 2, int_val: 4 },
	        'e#': { root_index: 2, int_val: 5 },
	        'e##': { root_index: 2, int_val: 6 },
	        'eb': { root_index: 2, int_val: 3 },
	        'ebb': { root_index: 2, int_val: 2 },
	        'f': { root_index: 3, int_val: 5 },
	        'fn': { root_index: 3, int_val: 5 },
	        'f#': { root_index: 3, int_val: 6 },
	        'f##': { root_index: 3, int_val: 7 },
	        'fb': { root_index: 3, int_val: 4 },
	        'fbb': { root_index: 3, int_val: 3 },
	        'g': { root_index: 4, int_val: 7 },
	        'gn': { root_index: 4, int_val: 7 },
	        'g#': { root_index: 4, int_val: 8 },
	        'g##': { root_index: 4, int_val: 9 },
	        'gb': { root_index: 4, int_val: 6 },
	        'gbb': { root_index: 4, int_val: 5 },
	        'a': { root_index: 5, int_val: 9 },
	        'an': { root_index: 5, int_val: 9 },
	        'a#': { root_index: 5, int_val: 10 },
	        'a##': { root_index: 5, int_val: 11 },
	        'ab': { root_index: 5, int_val: 8 },
	        'abb': { root_index: 5, int_val: 7 },
	        'b': { root_index: 6, int_val: 11 },
	        'bn': { root_index: 6, int_val: 11 },
	        'b#': { root_index: 6, int_val: 0 },
	        'b##': { root_index: 6, int_val: 1 },
	        'bb': { root_index: 6, int_val: 10 },
	        'bbb': { root_index: 6, int_val: 9 }
	      };
	    }
	  }]);

	  return Music;
	}();

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NoteSubGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _formatter = __webpack_require__(14);
	
	var _voice = __webpack_require__(18);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Taehoon Moon 2016
	//
	// ## Description
	//
	// This file implements `NoteSubGroup` which is used to format and
	// render notes as a `Modifier`
	// ex) ClefNote, TimeSigNote and BarNote.
	
	var NoteSubGroup = exports.NoteSubGroup = function (_Modifier) {
	  _inherits(NoteSubGroup, _Modifier);
	
	  _createClass(NoteSubGroup, null, [{
	    key: 'format',
	
	
	    // Arrange groups inside a `ModifierContext`
	    value: function format(groups, state) {
	      if (!groups || groups.length === 0) return false;
	
	      var width = 0;
	      for (var i = 0; i < groups.length; ++i) {
	        var group = groups[i];
	        group.preFormat();
	        width += group.getWidth();
	      }
	
	      state.left_shift += width;
	      return true;
	    }
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'notesubgroup';
	    }
	  }]);
	
	  function NoteSubGroup(subNotes) {
	    var _ret;
	
	    _classCallCheck(this, NoteSubGroup);
	
	    var _this = _possibleConstructorReturn(this, (NoteSubGroup.__proto__ || Object.getPrototypeOf(NoteSubGroup)).call(this));
	
	    _this.setAttribute('type', 'NoteSubGroup');
	
	    _this.note = null;
	    _this.index = null;
	    _this.position = _modifier.Modifier.Position.LEFT;
	    _this.subNotes = subNotes;
	    _this.subNotes.forEach(function (subNote) {
	      subNote.ignore_ticks = false;
	    });
	    _this.width = 0;
	    _this.preFormatted = false;
	
	    _this.formatter = new _formatter.Formatter();
	    _this.voice = new _voice.Voice({
	      num_beats: 4,
	      beat_value: 4,
	      resolution: _tables.Flow.RESOLUTION
	    }).setStrict(false);
	
	    _this.voice.addTickables(_this.subNotes);
	
	    return _ret = _this, _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NoteSubGroup, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return NoteSubGroup.CATEGORY;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return;
	
	      this.formatter.joinVoices([this.voice]).format([this.voice], 0);
	      this.setWidth(this.formatter.getMinTotalWidth());
	      this.preFormatted = true;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      this.note = note;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.width = width;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      this.checkContext();
	
	      var note = this.getNote();
	
	      if (!(note && this.index !== null)) {
	        throw new _vex.Vex.RuntimeError('NoAttachedNote', "Can't draw notes without a parent note and parent note index.");
	      }
	
	      this.setRendered();
	      var alignSubNotesWithNote = function alignSubNotesWithNote(subNotes, note) {
	        // Shift over the tick contexts of each note
	        var tickContext = note.getTickContext();
	        var extraPx = tickContext.getExtraPx();
	        var x = tickContext.getX() - extraPx.left - extraPx.extraLeft + _this2.getSpacingFromNextModifier();
	
	        subNotes.forEach(function (subNote) {
	          var tick_context = subNote.getTickContext();
	          var x_offset = tick_context.getX();
	          subNote.setStave(note.stave);
	          tick_context.setX(x + x_offset);
	        });
	      };
	
	      alignSubNotesWithNote(this.subNotes, note, this.width);
	
	      // Draw notes
	      this.subNotes.forEach(function (subNote) {
	        return subNote.setContext(_this2.context).draw();
	      });
	    }
	  }]);

	  return NoteSubGroup;
	}(_modifier.Modifier);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraceNoteGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _formatter = __webpack_require__(14);
	
	var _voice = __webpack_require__(18);
	
	var _beam = __webpack_require__(15);
	
	var _stavetie = __webpack_require__(33);
	
	var _tabtie = __webpack_require__(34);
	
	var _stavenote = __webpack_require__(20);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `GraceNoteGroup` which is used to format and
	// render grace notes.
	
	// To enable logging for this class. Set `Vex.Flow.GraceNoteGroup.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (GraceNoteGroup.DEBUG) _vex.Vex.L('Vex.Flow.GraceNoteGroup', args);
	}
	
	var GraceNoteGroup = exports.GraceNoteGroup = function (_Modifier) {
	  _inherits(GraceNoteGroup, _Modifier);
	
	  _createClass(GraceNoteGroup, null, [{
	    key: 'format',
	
	
	    // Arrange groups inside a `ModifierContext`
	    value: function format(gracenote_groups, state) {
	      var group_spacing_stave = 4;
	      var group_spacing_tab = 0;
	
	      if (!gracenote_groups || gracenote_groups.length === 0) return false;
	
	      var group_list = [];
	      var prev_note = null;
	      var shiftL = 0;
	
	      for (var i = 0; i < gracenote_groups.length; ++i) {
	        var gracenote_group = gracenote_groups[i];
	        var note = gracenote_group.getNote();
	        var is_stavenote = note.getCategory() === _stavenote.StaveNote.CATEGORY;
	        var spacing = is_stavenote ? group_spacing_stave : group_spacing_tab;
	
	        if (is_stavenote && note !== prev_note) {
	          // Iterate through all notes to get the displaced pixels
	          for (var n = 0; n < note.keys.length; ++n) {
	            var props_tmp = note.getKeyProps()[n];
	            shiftL = props_tmp.displaced ? note.getExtraLeftPx() : shiftL;
	          }
	          prev_note = note;
	        }
	
	        group_list.push({ shift: shiftL, gracenote_group: gracenote_group, spacing: spacing });
	      }
	
	      // If first note left shift in case it is displaced
	      var group_shift = group_list[0].shift;
	      var formatWidth = void 0;
	      for (var _i = 0; _i < group_list.length; ++_i) {
	        var _gracenote_group = group_list[_i].gracenote_group;
	        _gracenote_group.preFormat();
	        formatWidth = _gracenote_group.getWidth() + group_list[_i].spacing;
	        group_shift = Math.max(formatWidth, group_shift);
	      }
	
	      for (var _i2 = 0; _i2 < group_list.length; ++_i2) {
	        var _gracenote_group2 = group_list[_i2].gracenote_group;
	        formatWidth = _gracenote_group2.getWidth() + group_list[_i2].spacing;
	        _gracenote_group2.setSpacingFromNextModifier(group_shift - Math.min(formatWidth, group_shift));
	      }
	
	      state.left_shift += group_shift;
	      return true;
	    }
	
	    // ## Prototype Methods
	    //
	    // `GraceNoteGroup` inherits from `Modifier` and is placed inside a
	    // `ModifierContext`.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'gracenotegroups';
	    }
	  }]);
	
	  function GraceNoteGroup(grace_notes, show_slur) {
	    var _ret;
	
	    _classCallCheck(this, GraceNoteGroup);
	
	    var _this = _possibleConstructorReturn(this, (GraceNoteGroup.__proto__ || Object.getPrototypeOf(GraceNoteGroup)).call(this));
	
	    _this.setAttribute('type', 'GraceNoteGroup');
	
	    _this.note = null;
	    _this.index = null;
	    _this.position = _modifier.Modifier.Position.LEFT;
	    _this.grace_notes = grace_notes;
	    _this.width = 0;
	
	    _this.preFormatted = false;
	
	    _this.show_slur = show_slur;
	    _this.slur = null;
	
	    _this.formatter = new _formatter.Formatter();
	    _this.voice = new _voice.Voice({
	      num_beats: 4,
	      beat_value: 4,
	      resolution: _tables.Flow.RESOLUTION
	    }).setStrict(false);
	
	    _this.render_options = {
	      slur_y_shift: 0
	    };
	
	    _this.voice.addTickables(_this.grace_notes);
	
	    return _ret = _this, _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GraceNoteGroup, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return GraceNoteGroup.CATEGORY;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return;
	
	      this.formatter.joinVoices([this.voice]).format([this.voice], 0);
	      this.setWidth(this.formatter.getMinTotalWidth());
	      this.preFormatted = true;
	    }
	  }, {
	    key: 'beamNotes',
	    value: function beamNotes() {
	      if (this.grace_notes.length > 1) {
	        var beam = new _beam.Beam(this.grace_notes);
	
	        beam.render_options.beam_width = 3;
	        beam.render_options.partial_beam_length = 4;
	
	        this.beam = beam;
	      }
	
	      return this;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      this.note = note;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.width = width;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'getGraceNotes',
	    value: function getGraceNotes() {
	      return this.grace_notes;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      this.checkContext();
	
	      var note = this.getNote();
	
	      L('Drawing grace note group for:', note);
	
	      if (!(note && this.index !== null)) {
	        throw new _vex.Vex.RuntimeError('NoAttachedNote', "Can't draw grace note without a parent note and parent note index.");
	      }
	
	      this.setRendered();
	      var that = this;
	      function alignGraceNotesWithNote(grace_notes, note) {
	        // Shift over the tick contexts of each note
	        // So that th aligned with the note
	        var tickContext = note.getTickContext();
	        var extraPx = tickContext.getExtraPx();
	        var x = tickContext.getX() - extraPx.left - extraPx.extraLeft + that.getSpacingFromNextModifier();
	
	        grace_notes.forEach(function (graceNote) {
	          var tick_context = graceNote.getTickContext();
	          var x_offset = tick_context.getX();
	          graceNote.setStave(note.stave);
	          tick_context.setX(x + x_offset);
	        });
	      }
	
	      alignGraceNotesWithNote(this.grace_notes, note, this.width);
	
	      // Draw notes
	      this.grace_notes.forEach(function (graceNote) {
	        graceNote.setContext(_this2.context).draw();
	      });
	
	      // Draw beam
	      if (this.beam) {
	        this.beam.setContext(this.context).draw();
	      }
	
	      if (this.show_slur) {
	        // Create and draw slur
	        var is_stavenote = this.getNote().getCategory() === _stavenote.StaveNote.CATEGORY;
	        var TieClass = is_stavenote ? _stavetie.StaveTie : _tabtie.TabTie;
	
	        this.slur = new TieClass({
	          last_note: this.grace_notes[0],
	          first_note: note,
	          first_indices: [0],
	          last_indices: [0]
	        });
	
	        this.slur.render_options.cp2 = 12;
	        this.slur.render_options.y_shift = (is_stavenote ? 7 : 5) + this.render_options.slur_y_shift;
	        this.slur.setContext(this.context).draw();
	      }
	    }
	  }]);

	  return GraceNoteGroup;
	}(_modifier.Modifier);

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveTie = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	var StaveTie = exports.StaveTie = function (_Element) {
	  _inherits(StaveTie, _Element);
	
	  function StaveTie(notes, text) {
	    _classCallCheck(this, StaveTie);
	
	    var _this = _possibleConstructorReturn(this, (StaveTie.__proto__ || Object.getPrototypeOf(StaveTie)).call(this));
	    /**
	     * Notes is a struct that has:
	     *
	     *  {
	     *    first_note: Note,
	     *    last_note: Note,
	     *    first_indices: [n1, n2, n3],
	     *    last_indices: [n1, n2, n3]
	     *  }
	     *
	     **/
	
	
	    _this.setAttribute('type', 'StaveTie');
	    _this.notes = notes;
	    _this.context = null;
	    _this.text = text;
	    _this.direction = null;
	
	    _this.render_options = {
	      cp1: 8, // Curve control point 1
	      cp2: 12, // Curve control point 2
	      text_shift_x: 0,
	      first_x_shift: 0,
	      last_x_shift: 0,
	      y_shift: 7,
	      tie_spacing: 0,
	      font: { family: 'Arial', size: 10, style: '' }
	    };
	
	    _this.font = _this.render_options.font;
	    _this.setNotes(notes);
	    return _this;
	  }
	
	  _createClass(StaveTie, [{
	    key: 'setFont',
	    value: function setFont(font) {
	      this.font = font;return this;
	    }
	  }, {
	    key: 'setDirection',
	    value: function setDirection(direction) {
	      this.direction = direction;return this;
	    }
	
	    /**
	     * Set the notes to attach this tie to.
	     *
	     * @param {!Object} notes The notes to tie up.
	     */
	
	  }, {
	    key: 'setNotes',
	    value: function setNotes(notes) {
	      if (!notes.first_note && !notes.last_note) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Tie needs to have either first_note or last_note set.');
	      }
	
	      if (!notes.first_indices) notes.first_indices = [0];
	      if (!notes.last_indices) notes.last_indices = [0];
	
	      if (notes.first_indices.length !== notes.last_indices.length) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Tied notes must have similar index sizes');
	      }
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.first_indices = notes.first_indices;
	      this.last_note = notes.last_note;
	      this.last_indices = notes.last_indices;
	      return this;
	    }
	
	    /**
	     * @return {boolean} Returns true if this is a partial bar.
	     */
	
	  }, {
	    key: 'isPartial',
	    value: function isPartial() {
	      return !this.first_note || !this.last_note;
	    }
	  }, {
	    key: 'renderTie',
	    value: function renderTie(params) {
	      if (params.first_ys.length === 0 || params.last_ys.length === 0) {
	        throw new _vex.Vex.RERR('BadArguments', 'No Y-values to render');
	      }
	
	      var ctx = this.context;
	      var cp1 = this.render_options.cp1;
	      var cp2 = this.render_options.cp2;
	
	      if (Math.abs(params.last_x_px - params.first_x_px) < 10) {
	        cp1 = 2;cp2 = 8;
	      }
	
	      var first_x_shift = this.render_options.first_x_shift;
	      var last_x_shift = this.render_options.last_x_shift;
	      var y_shift = this.render_options.y_shift * params.direction;
	
	      for (var i = 0; i < this.first_indices.length; ++i) {
	        var cp_x = (params.last_x_px + last_x_shift + (params.first_x_px + first_x_shift)) / 2;
	        var first_y_px = params.first_ys[this.first_indices[i]] + y_shift;
	        var last_y_px = params.last_ys[this.last_indices[i]] + y_shift;
	
	        if (isNaN(first_y_px) || isNaN(last_y_px)) {
	          throw new _vex.Vex.RERR('BadArguments', 'Bad indices for tie rendering.');
	        }
	
	        var top_cp_y = (first_y_px + last_y_px) / 2 + cp1 * params.direction;
	        var bottom_cp_y = (first_y_px + last_y_px) / 2 + cp2 * params.direction;
	
	        ctx.beginPath();
	        ctx.moveTo(params.first_x_px + first_x_shift, first_y_px);
	        ctx.quadraticCurveTo(cp_x, top_cp_y, params.last_x_px + last_x_shift, last_y_px);
	        ctx.quadraticCurveTo(cp_x, bottom_cp_y, params.first_x_px + first_x_shift, first_y_px);
	        ctx.closePath();
	        ctx.fill();
	      }
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText(first_x_px, last_x_px) {
	      if (!this.text) return;
	      var center_x = (first_x_px + last_x_px) / 2;
	      center_x -= this.context.measureText(this.text).width / 2;
	
	      this.context.save();
	      this.context.setFont(this.font.family, this.font.size, this.font.style);
	      this.context.fillText(this.text, center_x + this.render_options.text_shift_x, (this.first_note || this.last_note).getStave().getYForTopText() - 1);
	      this.context.restore();
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	
	      var first_x_px = void 0;
	      var last_x_px = void 0;
	      var first_ys = void 0;
	      var last_ys = void 0;
	      var stem_direction = void 0;
	      if (first_note) {
	        first_x_px = first_note.getTieRightX() + this.render_options.tie_spacing;
	        stem_direction = first_note.getStemDirection();
	        first_ys = first_note.getYs();
	      } else {
	        first_x_px = last_note.getStave().getTieStartX();
	        first_ys = last_note.getYs();
	        this.first_indices = this.last_indices;
	      }
	
	      if (last_note) {
	        last_x_px = last_note.getTieLeftX() + this.render_options.tie_spacing;
	        stem_direction = last_note.getStemDirection();
	        last_ys = last_note.getYs();
	      } else {
	        last_x_px = first_note.getStave().getTieEndX();
	        last_ys = first_note.getYs();
	        this.last_indices = this.first_indices;
	      }
	
	      if (this.direction) {
	        stem_direction = this.direction;
	      }
	
	      this.renderTie({
	        first_x_px: first_x_px,
	        last_x_px: last_x_px,
	        first_ys: first_ys,
	        last_ys: last_ys,
	        direction: stem_direction
	      });
	
	      this.renderText(first_x_px, last_x_px);
	      return true;
	    }
	  }]);

	  return StaveTie;
	}(_element.Element);

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabTie = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stavetie = __webpack_require__(33);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // / [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	var TabTie = exports.TabTie = function (_StaveTie) {
	  _inherits(TabTie, _StaveTie);
	
	  _createClass(TabTie, null, [{
	    key: 'createHammeron',
	    value: function createHammeron(notes) {
	      return new TabTie(notes, 'H');
	    }
	  }, {
	    key: 'createPulloff',
	    value: function createPulloff(notes) {
	      return new TabTie(notes, 'P');
	    }
	  }]);
	
	  function TabTie(notes, text) {
	    _classCallCheck(this, TabTie);
	
	    var _this = _possibleConstructorReturn(this, (TabTie.__proto__ || Object.getPrototypeOf(TabTie)).call(this, notes, text));
	    /**
	     * Notes is a struct that has:
	     *
	     *  {
	     *    first_note: Note,
	     *    last_note: Note,
	     *    first_indices: [n1, n2, n3],
	     *    last_indices: [n1, n2, n3]
	     *  }
	     *
	     **/
	
	
	    _this.setAttribute('type', 'TabTie');
	
	    _this.render_options.cp1 = 9;
	    _this.render_options.cp2 = 11;
	    _this.render_options.y_shift = 3;
	
	    _this.setNotes(notes);
	    return _this;
	  }
	
	  _createClass(TabTie, [{
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	      var first_x_px = void 0;
	      var last_x_px = void 0;
	      var first_ys = void 0;
	      var last_ys = void 0;
	
	      if (first_note) {
	        first_x_px = first_note.getTieRightX() + this.render_options.tie_spacing;
	        first_ys = first_note.getYs();
	      } else {
	        first_x_px = last_note.getStave().getTieStartX();
	        first_ys = last_note.getYs();
	        this.first_indices = this.last_indices;
	      }
	
	      if (last_note) {
	        last_x_px = last_note.getTieLeftX() + this.render_options.tie_spacing;
	        last_ys = last_note.getYs();
	      } else {
	        last_x_px = first_note.getStave().getTieEndX();
	        last_ys = first_note.getYs();
	        this.last_indices = this.first_indices;
	      }
	
	      this.renderTie({
	        first_x_px: first_x_px,
	        last_x_px: last_x_px,
	        first_ys: first_ys,
	        last_ys: last_ys,
	        direction: -1 });
	
	      this.renderText(first_x_px, last_x_px);
	      return true;
	    }
	  }]);

	  return TabTie;
	}(_stavetie.StaveTie);

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stroke = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	var _stavenote = __webpack_require__(20);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns
	//
	// ## Description
	// This file implements the `Stroke` class which renders chord strokes
	// that can be arpeggiated, brushed, rasquedo, etc.
	
	var Stroke = exports.Stroke = function (_Modifier) {
	  _inherits(Stroke, _Modifier);
	
	  _createClass(Stroke, null, [{
	    key: 'format',
	
	
	    // Arrange strokes inside `ModifierContext`
	    value: function format(strokes, state) {
	      var left_shift = state.left_shift;
	      var stroke_spacing = 0;
	
	      if (!strokes || strokes.length === 0) return this;
	
	      var strokeList = strokes.map(function (stroke) {
	        var note = stroke.getNote();
	        if (note instanceof _stavenote.StaveNote) {
	          var _note$getKeyProps$str = note.getKeyProps()[stroke.getIndex()];
	          var line = _note$getKeyProps$str.line;
	          var displaced = _note$getKeyProps$str.displaced;
	
	          var shift = displaced ? note.getExtraLeftPx() : 0;
	          return { line: line, shift: shift, stroke: stroke };
	        } else {
	          var string = note.getPositions()[stroke.getIndex()].str;
	
	          return { line: string, shift: 0, stroke: stroke };
	        }
	      });
	
	      var strokeShift = left_shift;
	
	      // There can only be one stroke .. if more than one, they overlay each other
	      var xShift = strokeList.reduce(function (xShift, _ref) {
	        var stroke = _ref.stroke;
	        var shift = _ref.shift;
	
	        stroke.setXShift(strokeShift + shift);
	        return Math.max(stroke.getWidth() + stroke_spacing, xShift);
	      }, 0);
	
	      state.left_shift += xShift;
	      return true;
	    }
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'strokes';
	    }
	  }, {
	    key: 'Type',
	    get: function get() {
	      return {
	        BRUSH_DOWN: 1,
	        BRUSH_UP: 2,
	        ROLL_DOWN: 3, // Arpegiated chord
	        ROLL_UP: 4, // Arpegiated chord
	        RASQUEDO_DOWN: 5,
	        RASQUEDO_UP: 6
	      };
	    }
	  }]);
	
	  function Stroke(type, options) {
	    _classCallCheck(this, Stroke);
	
	    var _this = _possibleConstructorReturn(this, (Stroke.__proto__ || Object.getPrototypeOf(Stroke)).call(this));
	
	    _this.setAttribute('type', 'Stroke');
	
	    _this.note = null;
	    _this.options = _vex.Vex.Merge({}, options);
	
	    // multi voice - span stroke across all voices if true
	    _this.all_voices = 'all_voices' in _this.options ? _this.options.all_voices : true;
	
	    // multi voice - end note of stroke, set in draw()
	    _this.note_end = null;
	    _this.index = null;
	    _this.type = type;
	    _this.position = _modifier.Modifier.Position.LEFT;
	
	    _this.render_options = {
	      font_scale: 38,
	      stroke_px: 3,
	      stroke_spacing: 10
	    };
	
	    _this.font = {
	      family: 'serif',
	      size: 10,
	      weight: 'bold italic'
	    };
	
	    _this.setXShift(0);
	    _this.setWidth(10);
	    return _this;
	  }
	
	  _createClass(Stroke, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Stroke.CATEGORY;
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      return this.position;
	    }
	  }, {
	    key: 'addEndNote',
	    value: function addEndNote(note) {
	      this.note_end = note;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      if (!(this.note && this.index != null)) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw stroke without a note and index.");
	      }
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var ys = this.note.getYs();
	      var topY = start.y;
	      var botY = start.y;
	      var x = start.x - 5;
	      var line_space = this.note.stave.options.spacing_between_lines_px;
	
	      var notes = this.getModifierContext().getModifiers(this.note.getCategory());
	      for (var i = 0; i < notes.length; i++) {
	        ys = notes[i].getYs();
	        for (var n = 0; n < ys.length; n++) {
	          if (this.note === notes[i] || this.all_voices) {
	            topY = _vex.Vex.Min(topY, ys[n]);
	            botY = _vex.Vex.Max(botY, ys[n]);
	          }
	        }
	      }
	
	      var arrow = void 0;
	      var arrow_shift_x = void 0;
	      var arrow_y = void 0;
	      var text_shift_x = void 0;
	      var text_y = void 0;
	      switch (this.type) {
	        case Stroke.Type.BRUSH_DOWN:
	          arrow = 'vc3';
	          arrow_shift_x = -3;
	          arrow_y = topY - line_space / 2 + 10;
	          botY += line_space / 2;
	          break;
	        case Stroke.Type.BRUSH_UP:
	          arrow = 'v11';
	          arrow_shift_x = 0.5;
	          arrow_y = botY + line_space / 2;
	          topY -= line_space / 2;
	          break;
	        case Stroke.Type.ROLL_DOWN:
	        case Stroke.Type.RASQUEDO_DOWN:
	          arrow = 'vc3';
	          arrow_shift_x = -3;
	          text_shift_x = this.x_shift + arrow_shift_x - 2;
	          if (this.note instanceof _stavenote.StaveNote) {
	            topY += 1.5 * line_space;
	            if ((botY - topY) % 2 !== 0) {
	              botY += 0.5 * line_space;
	            } else {
	              botY += line_space;
	            }
	            arrow_y = topY - line_space;
	            text_y = botY + line_space + 2;
	          } else {
	            topY += 1.5 * line_space;
	            botY += line_space;
	            arrow_y = topY - 0.75 * line_space;
	            text_y = botY + 0.25 * line_space;
	          }
	          break;
	        case Stroke.Type.ROLL_UP:
	        case Stroke.Type.RASQUEDO_UP:
	          arrow = 'v52';
	          arrow_shift_x = -4;
	          text_shift_x = this.x_shift + arrow_shift_x - 1;
	          if (this.note instanceof _stavenote.StaveNote) {
	            arrow_y = line_space / 2;
	            topY += 0.5 * line_space;
	            if ((botY - topY) % 2 === 0) {
	              botY += line_space / 2;
	            }
	            arrow_y = botY + 0.5 * line_space;
	            text_y = topY - 1.25 * line_space;
	          } else {
	            topY += 0.25 * line_space;
	            botY += 0.5 * line_space;
	            arrow_y = botY + 0.25 * line_space;
	            text_y = topY - line_space;
	          }
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidType', 'The stroke type ' + this.type + ' does not exist');
	      }
	
	      // Draw the stroke
	      if (this.type === Stroke.Type.BRUSH_DOWN || this.type === Stroke.Type.BRUSH_UP) {
	        this.context.fillRect(x + this.x_shift, topY, 1, botY - topY);
	      } else {
	        if (this.note instanceof _stavenote.StaveNote) {
	          for (var _i = topY; _i <= botY; _i += line_space) {
	            _glyph.Glyph.renderGlyph(this.context, x + this.x_shift - 4, _i, this.render_options.font_scale, 'va3');
	          }
	        } else {
	          var _i2 = void 0;
	          for (_i2 = topY; _i2 <= botY; _i2 += 10) {
	            _glyph.Glyph.renderGlyph(this.context, x + this.x_shift - 4, _i2, this.render_options.font_scale, 'va3');
	          }
	          if (this.type === Stroke.Type.RASQUEDO_DOWN) {
	            text_y = _i2 + 0.25 * line_space;
	          }
	        }
	      }
	
	      // Draw the arrow head
	      _glyph.Glyph.renderGlyph(this.context, x + this.x_shift + arrow_shift_x, arrow_y, this.render_options.font_scale, arrow);
	
	      // Draw the rasquedo "R"
	      if (this.type === Stroke.Type.RASQUEDO_DOWN || this.type === Stroke.Type.RASQUEDO_UP) {
	        this.context.save();
	        this.context.setFont(this.font.family, this.font.size, this.font.weight);
	        this.context.fillText('R', x + text_shift_x, text_y);
	        this.context.restore();
	      }
	    }
	  }]);

	  return Stroke;
	}(_modifier.Modifier);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StringNumber = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	var _renderer = __webpack_require__(10);
	
	var _stavenote = __webpack_require__(20);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns
	//
	// ## Description
	// This file implements the `StringNumber` class which renders string
	// number annotations beside notes.
	
	var StringNumber = exports.StringNumber = function (_Modifier) {
	  _inherits(StringNumber, _Modifier);
	
	  _createClass(StringNumber, null, [{
	    key: 'format',
	
	
	    // ## Static Methods
	    // Arrange string numbers inside a `ModifierContext`
	    value: function format(nums, state) {
	      var left_shift = state.left_shift;
	      var right_shift = state.right_shift;
	      var num_spacing = 1;
	
	      if (!nums || nums.length === 0) return this;
	
	      var nums_list = [];
	      var prev_note = null;
	      var shift_left = 0;
	      var shift_right = 0;
	
	      var i = void 0;
	      var num = void 0;
	      var note = void 0;
	      var pos = void 0;
	      var props_tmp = void 0;
	      for (i = 0; i < nums.length; ++i) {
	        num = nums[i];
	        note = num.getNote();
	
	        for (i = 0; i < nums.length; ++i) {
	          num = nums[i];
	          note = num.getNote();
	          pos = num.getPosition();
	          var props = note.getKeyProps()[num.getIndex()];
	
	          if (note !== prev_note) {
	            for (var n = 0; n < note.keys.length; ++n) {
	              props_tmp = note.getKeyProps()[n];
	              if (left_shift === 0) {
	                shift_left = props_tmp.displaced ? note.getExtraLeftPx() : shift_left;
	              }
	              if (right_shift === 0) {
	                shift_right = props_tmp.displaced ? note.getExtraRightPx() : shift_right;
	              }
	            }
	            prev_note = note;
	          }
	
	          nums_list.push({
	            pos: pos,
	            note: note,
	            num: num,
	            line: props.line,
	            shiftL: shift_left,
	            shiftR: shift_right
	          });
	        }
	      }
	
	      // Sort string numbers by line number.
	      nums_list.sort(function (a, b) {
	        return b.line - a.line;
	      });
	
	      // TODO: This variable never gets assigned to anything. Is that a bug or can this be removed?
	      var num_shiftL = 0; // eslint-disable-line
	      var num_shiftR = 0;
	      var x_widthL = 0;
	      var x_widthR = 0;
	      var last_line = null;
	      var last_note = null;
	      for (i = 0; i < nums_list.length; ++i) {
	        var num_shift = 0;
	        note = nums_list[i].note;
	        pos = nums_list[i].pos;
	        num = nums_list[i].num;
	        var line = nums_list[i].line;
	        var shiftL = nums_list[i].shiftL;
	        var shiftR = nums_list[i].shiftR;
	
	        // Reset the position of the string number every line.
	        if (line !== last_line || note !== last_note) {
	          num_shiftL = left_shift + shiftL;
	          num_shiftR = right_shift + shiftR;
	        }
	
	        var num_width = num.getWidth() + num_spacing;
	        if (pos === _modifier.Modifier.Position.LEFT) {
	          num.setXShift(left_shift);
	          num_shift = shift_left + num_width; // spacing
	          x_widthL = num_shift > x_widthL ? num_shift : x_widthL;
	        } else if (pos === _modifier.Modifier.Position.RIGHT) {
	          num.setXShift(num_shiftR);
	          num_shift += num_width; // spacing
	          x_widthR = num_shift > x_widthR ? num_shift : x_widthR;
	        }
	        last_line = line;
	        last_note = note;
	      }
	
	      state.left_shift += x_widthL;
	      state.right_shift += x_widthR;
	      return true;
	    }
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stringnumber';
	    }
	  }]);
	
	  function StringNumber(number) {
	    _classCallCheck(this, StringNumber);
	
	    var _this = _possibleConstructorReturn(this, (StringNumber.__proto__ || Object.getPrototypeOf(StringNumber)).call(this));
	
	    _this.setAttribute('type', 'StringNumber');
	
	    _this.note = null;
	    _this.last_note = null;
	    _this.index = null;
	    _this.string_number = number;
	    _this.setWidth(20); // ???
	    _this.position = _modifier.Modifier.Position.ABOVE; // Default position above stem or note head
	    _this.x_shift = 0;
	    _this.y_shift = 0;
	    _this.x_offset = 0; // Horizontal offset from default
	    _this.y_offset = 0; // Vertical offset from default
	    _this.dashed = true; // true - draw dashed extension  false - no extension
	    _this.leg = _renderer.Renderer.LineEndType.NONE; // draw upward/downward leg at the of extension line
	    _this.radius = 8;
	    _this.font = {
	      family: 'sans-serif',
	      size: 10,
	      weight: 'bold'
	    };
	    return _this;
	  }
	
	  _createClass(StringNumber, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return StringNumber.CATEGORY;
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.note;
	    }
	  }, {
	    key: 'setNote',
	    value: function setNote(note) {
	      this.note = note;return this;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      return this.index;
	    }
	  }, {
	    key: 'setIndex',
	    value: function setIndex(index) {
	      this.index = index;return this;
	    }
	  }, {
	    key: 'setLineEndType',
	    value: function setLineEndType(leg) {
	      if (leg >= _renderer.Renderer.LineEndType.NONE && leg <= _renderer.Renderer.LineEndType.DOWN) {
	        this.leg = leg;
	      }
	      return this;
	    }
	  }, {
	    key: 'setStringNumber',
	    value: function setStringNumber(number) {
	      this.string_number = number;return this;
	    }
	  }, {
	    key: 'setOffsetX',
	    value: function setOffsetX(x) {
	      this.x_offset = x;return this;
	    }
	  }, {
	    key: 'setOffsetY',
	    value: function setOffsetY(y) {
	      this.y_offset = y;return this;
	    }
	  }, {
	    key: 'setLastNote',
	    value: function setLastNote(note) {
	      this.last_note = note;return this;
	    }
	  }, {
	    key: 'setDashed',
	    value: function setDashed(dashed) {
	      this.dashed = dashed;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.checkContext();
	      if (!(this.note && this.index != null)) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw string number without a note and index.");
	      }
	      this.setRendered();
	
	      var line_space = this.note.stave.options.spacing_between_lines_px;
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var dot_x = start.x + this.x_shift + this.x_offset;
	      var dot_y = start.y + this.y_shift + this.y_offset;
	
	      switch (this.position) {
	        case _modifier.Modifier.Position.ABOVE:
	        case _modifier.Modifier.Position.BELOW:
	          {
	            var stem_ext = this.note.getStemExtents();
	            var top = stem_ext.topY;
	            var bottom = stem_ext.baseY + 2;
	
	            if (this.note.stem_direction === _stavenote.StaveNote.STEM_DOWN) {
	              top = stem_ext.baseY;
	              bottom = stem_ext.topY - 2;
	            }
	
	            if (this.position === _modifier.Modifier.Position.ABOVE) {
	              dot_y = this.note.hasStem() ? top - line_space * 1.75 : start.y - line_space * 1.75;
	            } else {
	              dot_y = this.note.hasStem() ? bottom + line_space * 1.5 : start.y + line_space * 1.75;
	            }
	
	            dot_y += this.y_shift + this.y_offset;
	
	            break;
	          }case _modifier.Modifier.Position.LEFT:
	          dot_x -= this.radius / 2 + 5;
	          break;
	        case _modifier.Modifier.Position.RIGHT:
	          dot_x += this.radius / 2 + 6;
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidPosition', 'The position ' + this.position + ' is invalid');
	      }
	
	      ctx.save();
	      ctx.beginPath();
	      ctx.arc(dot_x, dot_y, this.radius, 0, Math.PI * 2, false);
	      ctx.lineWidth = 1.5;
	      ctx.stroke();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var x = dot_x - ctx.measureText(this.string_number).width / 2;
	      ctx.fillText('' + this.string_number, x, dot_y + 4.5);
	
	      if (this.last_note != null) {
	        var end = this.last_note.getStemX() - this.note.getX() + 5;
	        ctx.strokeStyle = '#000000';
	        ctx.lineCap = 'round';
	        ctx.lineWidth = 0.6;
	        if (this.dashed) {
	          _renderer.Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [3, 3]);
	        } else {
	          _renderer.Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [3, 0]);
	        }
	
	        var len = void 0;
	        var pattern = void 0;
	        switch (this.leg) {
	          case _renderer.Renderer.LineEndType.UP:
	            len = -10;
	            pattern = this.dashed ? [3, 3] : [3, 0];
	            _renderer.Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern);
	            break;
	          case _renderer.Renderer.LineEndType.DOWN:
	            len = 10;
	            pattern = this.dashed ? [3, 3] : [3, 0];
	            _renderer.Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern);
	            break;
	          default:
	            break;
	        }
	      }
	
	      ctx.restore();
	    }
	  }]);

	  return StringNumber;
	}(_modifier.Modifier);

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Articulation = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _glyph = __webpack_require__(4);
	
	var _stem = __webpack_require__(17);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns.
	//
	// ## Description
	//
	// This file implements articulations and accents as modifiers that can be
	// attached to notes. The complete list of articulations is available in
	// `tables.js` under `Vex.Flow.articulationCodes`.
	//
	// See `tests/articulation_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.Articulation.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Articulation.DEBUG) _vex.Vex.L('Vex.Flow.Articulation', args);
	}
	
	var _Modifier$Position = _modifier.Modifier.Position;
	var ABOVE = _Modifier$Position.ABOVE;
	var BELOW = _Modifier$Position.BELOW;
	
	
	var roundToNearestHalf = function roundToNearestHalf(mathFn, value) {
	  return mathFn(value / 0.5) * 0.5;
	};
	
	// This includes both staff and ledger lines
	var isWithinLines = function isWithinLines(line, position) {
	  return position === ABOVE ? line <= 5 : line >= 1;
	};
	
	var getRoundingFunction = function getRoundingFunction(line, position) {
	  if (isWithinLines(line, position)) {
	    if (position === ABOVE) {
	      return Math.ceil;
	    } else {
	      return Math.floor;
	    }
	  } else {
	    return Math.round;
	  }
	};
	
	var snapLineToStaff = function snapLineToStaff(canSitBetweenLines, line, position, offsetDirection) {
	  // Initially, snap to nearest staff line or space
	  var snappedLine = roundToNearestHalf(getRoundingFunction(line, position), line);
	  var canSnapToStaffSpace = canSitBetweenLines && isWithinLines(snappedLine, position);
	  var onStaffLine = snappedLine % 1 === 0;
	
	  if (canSnapToStaffSpace && onStaffLine) {
	    var HALF_STAFF_SPACE = 0.5;
	    return snappedLine + HALF_STAFF_SPACE * -offsetDirection;
	  } else {
	    return snappedLine;
	  }
	};
	
	var getTopY = function getTopY(note, textLine) {
	  var stave = note.getStave();
	  var stemDirection = note.getStemDirection();
	
	  var _note$getStemExtents = note.getStemExtents();
	
	  var stemTipY = _note$getStemExtents.topY;
	  var stemBaseY = _note$getStemExtents.baseY;
	
	
	  if (note.getCategory() === 'stavenotes') {
	    if (note.hasStem()) {
	      if (stemDirection === _stem.Stem.UP) {
	        return stemTipY;
	      } else {
	        return stemBaseY;
	      }
	    } else {
	      return Math.min.apply(Math, _toConsumableArray(note.getYs()));
	    }
	  } else if (note.getCategory() === 'tabnotes') {
	    if (note.hasStem()) {
	      if (stemDirection === _stem.Stem.UP) {
	        return stemTipY;
	      } else {
	        return stave.getYForTopText(textLine);
	      }
	    } else {
	      return stave.getYForTopText(textLine);
	    }
	  } else {
	    throw new _vex.Vex.RERR('UnknownCategory', 'Only can get the top and bottom ys of stavenotes and tabnotes');
	  }
	};
	
	var getBottomY = function getBottomY(note, textLine) {
	  var stave = note.getStave();
	  var stemDirection = note.getStemDirection();
	
	  var _note$getStemExtents2 = note.getStemExtents();
	
	  var stemTipY = _note$getStemExtents2.topY;
	  var stemBaseY = _note$getStemExtents2.baseY;
	
	
	  if (note.getCategory() === 'stavenotes') {
	    if (note.hasStem()) {
	      if (stemDirection === _stem.Stem.UP) {
	        return stemBaseY;
	      } else {
	        return stemTipY;
	      }
	    } else {
	      return Math.max.apply(Math, _toConsumableArray(note.getYs()));
	    }
	  } else if (note.getCategory() === 'tabnotes') {
	    if (note.hasStem()) {
	      if (stemDirection === _stem.Stem.UP) {
	        return stave.getYForBottomText(textLine);
	      } else {
	        return stemTipY;
	      }
	    } else {
	      return stave.getYForBottomText(textLine);
	    }
	  } else {
	    throw new _vex.Vex.RERR('UnknownCategory', 'Only can get the top and bottom ys of stavenotes and tabnotes');
	  }
	};
	
	// Gets the initial offset of the articulation from the y value of the starting position.
	// This is required because the top/bottom text positions already have spacing applied to
	// provide a "visually pleasent" default position. However the y values provided from
	// the stavenote's top/bottom do *not* have any pre-applied spacing. This function
	// normalizes this asymmetry.
	var getInitialOffset = function getInitialOffset(note, position) {
	  var isOnStemTip = position === ABOVE && note.getStemDirection() === _stem.Stem.UP || position === BELOW && note.getStemDirection() === _stem.Stem.DOWN;
	
	  if (note.getCategory() === 'stavenotes') {
	    if (note.hasStem() && isOnStemTip) {
	      return 0.5;
	    } else {
	      // this amount is larger than the stem-tip offset because we start from
	      // the center of the notehead
	      return 1;
	    }
	  } else {
	    if (note.hasStem() && isOnStemTip) {
	      return 1;
	    } else {
	      return 0;
	    }
	  }
	};
	
	var Articulation = exports.Articulation = function (_Modifier) {
	  _inherits(Articulation, _Modifier);
	
	  _createClass(Articulation, null, [{
	    key: 'format',
	
	
	    // FIXME:
	    // Most of the complex formatting logic (ie: snapping to space) is
	    // actually done in .render(). But that logic belongs in this method.
	    //
	    // Unfortunately, this isn't possible because, by this point, stem lengths
	    // have not yet been finalized. Finalized stem lengths are required to determine the
	    // initial position of any stem-side articulation.
	    //
	    // This indicates that all objects should have their stave set before being
	    // formatted. It can't be an optional if you want accurate vertical positioning.
	    // Consistently positioned articulations that play nice with other modifiers
	    // won't be possible until we stop relying on render-time formatting.
	    //
	    // Ideally, when this function has completed, the vertical articulation positions
	    // should be ready to render without further adjustment. But the current state
	    // is far from this ideal.
	    value: function format(articulations, state) {
	      if (!articulations || articulations.length === 0) return false;
	
	      var isAbove = function isAbove(artic) {
	        return artic.getPosition() === ABOVE;
	      };
	      var isBelow = function isBelow(artic) {
	        return artic.getPosition() === BELOW;
	      };
	      var margin = 0.5;
	      var getIncrement = function getIncrement(articulation, line, position) {
	        return roundToNearestHalf(getRoundingFunction(line, position), articulation.glyph.getMetrics().height / 10 + margin);
	      };
	
	      articulations.filter(isAbove).forEach(function (articulation) {
	        articulation.setTextLine(state.top_text_line);
	        state.top_text_line += getIncrement(articulation, state.top_text_line, ABOVE);
	      });
	
	      articulations.filter(isBelow).forEach(function (articulation) {
	        articulation.setTextLine(state.text_line);
	        state.text_line += getIncrement(articulation, state.text_line, BELOW);
	      });
	
	      var width = articulations.map(function (articulation) {
	        return articulation.getWidth();
	      }).reduce(function (maxWidth, articWidth) {
	        return Math.max(articWidth, maxWidth);
	      });
	
	      state.left_shift += width / 2;
	      state.right_shift += width / 2;
	      return true;
	    }
	  }, {
	    key: 'easyScoreHook',
	    value: function easyScoreHook(_ref, note, builder) {
	      var articulations = _ref.articulations;
	
	      if (!articulations) return;
	
	      var articNameToCode = {
	        staccato: 'a.',
	        tenuto: 'a-'
	      };
	
	      articulations.split(',').map(function (articString) {
	        return articString.trim().split('.');
	      }).map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2);
	
	        var name = _ref3[0];
	        var position = _ref3[1];
	
	        var artic = { type: articNameToCode[name] };
	        if (position) artic.position = _modifier.Modifier.PositionString[position];
	        return builder.getFactory().Articulation(artic);
	      }).map(function (artic) {
	        return note.addModifier(0, artic);
	      });
	    }
	
	    // Create a new articulation of type `type`, which is an entry in
	    // `Vex.Flow.articulationCodes` in `tables.js`.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'articulations';
	    }
	  }, {
	    key: 'INITIAL_OFFSET',
	    get: function get() {
	      return -0.5;
	    }
	  }]);
	
	  function Articulation(type) {
	    _classCallCheck(this, Articulation);
	
	    var _this = _possibleConstructorReturn(this, (Articulation.__proto__ || Object.getPrototypeOf(Articulation)).call(this));
	
	    _this.setAttribute('type', 'Articulation');
	
	    _this.note = null;
	    _this.index = null;
	    _this.type = type;
	    _this.position = BELOW;
	    _this.render_options = {
	      font_scale: 38
	    };
	
	    _this.articulation = _tables.Flow.articulationCodes(_this.type);
	    if (!_this.articulation) {
	      throw new _vex.Vex.RERR('ArgumentError', 'Articulation not found: ' + _this.type);
	    }
	
	    _this.glyph = new _glyph.Glyph(_this.articulation.code, _this.render_options.font_scale);
	
	    _this.setWidth(_this.glyph.getMetrics().width);
	    return _this;
	  }
	
	  _createClass(Articulation, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Articulation.CATEGORY;
	    }
	
	    // Render articulation in position next to note.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _ABOVE$BELOW$position;
	
	      var note = this.note;
	      var index = this.index;
	      var position = this.position;
	      var glyph = this.glyph;
	      var canSitBetweenLines = this.articulation.between_lines;
	      var textLine = this.text_line;
	      var ctx = this.context;
	
	
	      this.checkContext();
	
	      if (!note || index == null) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw Articulation without a note and index.");
	      }
	
	      this.setRendered();
	
	      var stave = note.getStave();
	      var staffSpace = stave.getSpacingBetweenLines();
	      var isTab = note.getCategory() === 'tabnotes';
	
	      // Articulations are centered over/under the note head.
	
	      var _note$getModifierStar = note.getModifierStartXY(position, index);
	
	      var x = _note$getModifierStar.x;
	
	      var shouldSitOutsideStaff = !canSitBetweenLines || isTab;
	
	      var initialOffset = getInitialOffset(note, position);
	
	      var y = (_ABOVE$BELOW$position = {}, _defineProperty(_ABOVE$BELOW$position, ABOVE, function () {
	        glyph.setOrigin(0.5, 1);
	        var y = getTopY(note, textLine) - (textLine + initialOffset) * staffSpace;
	        return shouldSitOutsideStaff ? Math.min(stave.getYForTopText(Articulation.INITIAL_OFFSET), y) : y;
	      }), _defineProperty(_ABOVE$BELOW$position, BELOW, function () {
	        glyph.setOrigin(0.5, 0);
	        var y = getBottomY(note, textLine) + (textLine + initialOffset) * staffSpace;
	        return shouldSitOutsideStaff ? Math.max(stave.getYForBottomText(Articulation.INITIAL_OFFSET), y) : y;
	      }), _ABOVE$BELOW$position)[position]();
	
	      if (!isTab) {
	        var offsetDirection = position === ABOVE ? -1 : +1;
	        var noteLine = isTab ? note.positions[index].str : note.getKeyProps()[index].line;
	        var distanceFromNote = (note.getYs()[index] - y) / staffSpace;
	        var articLine = distanceFromNote + noteLine;
	        var snappedLine = snapLineToStaff(canSitBetweenLines, articLine, position, offsetDirection);
	
	        if (isWithinLines(snappedLine, position)) glyph.setOrigin(0.5, 0.5);
	
	        y += Math.abs(snappedLine - articLine) * staffSpace * offsetDirection;
	      }
	
	      L('Rendering articulation at (x: ' + x + ', y: ' + y + ')');
	
	      glyph.render(ctx, x, y);
	    }
	  }]);

	  return Articulation;
	}(_modifier.Modifier);

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Ornament = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _tickcontext = __webpack_require__(39);
	
	var _stavenote = __webpack_require__(20);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implements ornaments as modifiers that can be
	// attached to notes. The complete list of ornaments is available in
	// `tables.js` under `Vex.Flow.ornamentCodes`.
	//
	// See `tests/ornament_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.Ornament.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Ornament.DEBUG) _vex.Vex.L('Vex.Flow.Ornament', args);
	}
	
	var Ornament = exports.Ornament = function (_Modifier) {
	  _inherits(Ornament, _Modifier);
	
	  _createClass(Ornament, null, [{
	    key: 'format',
	
	
	    // ## Static Methods
	    // Arrange ornaments inside `ModifierContext`
	    value: function format(ornaments, state) {
	      if (!ornaments || ornaments.length === 0) return false;
	
	      var width = 0;
	      for (var i = 0; i < ornaments.length; ++i) {
	        var ornament = ornaments[i];
	        var increment = 2;
	
	        width = Math.max(ornament.getWidth(), width);
	
	        if (ornament.getPosition() === _modifier.Modifier.Position.ABOVE) {
	          ornament.setTextLine(state.top_text_line);
	          state.top_text_line += increment;
	        } else {
	          ornament.setTextLine(state.text_line);
	          state.text_line += increment;
	        }
	      }
	
	      state.left_shift += width / 2;
	      state.right_shift += width / 2;
	      return true;
	    }
	
	    // Create a new ornament of type `type`, which is an entry in
	    // `Vex.Flow.ornamentCodes` in `tables.js`.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'ornaments';
	    }
	  }]);
	
	  function Ornament(type) {
	    _classCallCheck(this, Ornament);
	
	    var _this = _possibleConstructorReturn(this, (Ornament.__proto__ || Object.getPrototypeOf(Ornament)).call(this));
	
	    _this.setAttribute('type', 'Ornament');
	
	    _this.note = null;
	    _this.index = null;
	    _this.type = type;
	    _this.position = _modifier.Modifier.Position.ABOVE;
	    _this.delayed = false;
	
	    _this.accidentalUpper = null;
	    _this.accidentalLower = null;
	
	    _this.render_options = {
	      font_scale: 38,
	      accidentalLowerPadding: 3,
	      accidentalUpperPadding: 3
	    };
	
	    _this.ornament = _tables.Flow.ornamentCodes(_this.type);
	    if (!_this.ornament) {
	      throw new _vex.Vex.RERR('ArgumentError', 'Ornament not found: \'' + _this.type + '\'');
	    }
	
	    _this.glyph = new _glyph.Glyph(_this.ornament.code, _this.render_options.font_scale);
	    _this.glyph.setOrigin(0.5, 1.0); // FIXME: SMuFL won't require a vertical origin shift
	    return _this;
	  }
	
	  _createClass(Ornament, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Ornament.CATEGORY;
	    }
	
	    // Set whether the ornament is to be delayed
	
	  }, {
	    key: 'setDelayed',
	    value: function setDelayed(delayed) {
	      this.delayed = delayed;return this;
	    }
	
	    // Set the upper accidental for the ornament
	
	  }, {
	    key: 'setUpperAccidental',
	    value: function setUpperAccidental(accid) {
	      var scale = this.render_options.font_scale / 1.3;
	      this.accidentalUpper = new _glyph.Glyph(_tables.Flow.accidentalCodes(accid).code, scale);
	      this.accidentalUpper.setOrigin(0.5, 1.0);
	      return this;
	    }
	
	    // Set the lower accidental for the ornament
	
	  }, {
	    key: 'setLowerAccidental',
	    value: function setLowerAccidental(accid) {
	      var scale = this.render_options.font_scale / 1.3;
	      this.accidentalLower = new _glyph.Glyph(_tables.Flow.accidentalCodes(accid).code, scale);
	      this.accidentalLower.setOrigin(0.5, 1.0);
	      return this;
	    }
	
	    // Render ornament in position next to note.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!this.note || this.index == null) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw Ornament without a note and index.");
	      }
	
	      this.setRendered();
	
	      var ctx = this.context;
	      var stemDir = this.note.getStemDirection();
	      var stave = this.note.getStave();
	
	      // Get stem extents
	      var stemExtents = this.note.getStem().getExtents();
	      var y = stemDir === _stavenote.StaveNote.STEM_DOWN ? stemExtents.baseY : stemExtents.topY;
	
	      // TabNotes don't have stems attached to them. Tab stems are rendered
	      // outside the stave.
	      if (this.note.getCategory() === 'tabnotes') {
	        if (this.note.hasStem()) {
	          if (stemDir === _stavenote.StaveNote.STEM_DOWN) {
	            y = stave.getYForTopText(this.text_line);
	          }
	        } else {
	          // Without a stem
	          y = stave.getYForTopText(this.text_line);
	        }
	      }
	
	      var isPlacedOnNoteheadSide = stemDir === _stavenote.StaveNote.STEM_DOWN;
	      var spacing = stave.getSpacingBetweenLines();
	      var lineSpacing = 1;
	
	      // Beamed stems are longer than quarter note stems, adjust accordingly
	      if (!isPlacedOnNoteheadSide && this.note.beam) {
	        lineSpacing += 0.5;
	      }
	
	      var totalSpacing = spacing * (this.text_line + lineSpacing);
	      var glyphYBetweenLines = y - totalSpacing;
	
	      // Get initial coordinates for the modifier position
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var glyphX = start.x;
	      var glyphY = Math.min(stave.getYForTopText(this.text_line), glyphYBetweenLines);
	      glyphY += this.y_shift;
	
	      // Ajdust x position if ornament is delayed
	      if (this.delayed) {
	        glyphX += this.glyph.getMetrics().width;
	        var nextContext = _tickcontext.TickContext.getNextContext(this.note.getTickContext());
	        if (nextContext) {
	          glyphX += (nextContext.getX() - glyphX) * 0.5;
	        } else {
	          glyphX += (stave.x + stave.width - glyphX) * 0.5;
	        }
	      }
	
	      L('Rendering ornament: ', this.ornament, glyphX, glyphY);
	
	      if (this.accidentalLower) {
	        this.accidentalLower.render(ctx, glyphX, glyphY);
	        glyphY -= this.accidentalLower.getMetrics().height;
	        glyphY -= this.render_options.accidentalLowerPadding;
	      }
	
	      this.glyph.render(ctx, glyphX, glyphY);
	      glyphY -= this.glyph.getMetrics().height;
	
	      if (this.accidentalUpper) {
	        glyphY -= this.render_options.accidentalUpperPadding;
	        this.accidentalUpper.render(ctx, glyphX, glyphY);
	      }
	    }
	  }]);

	  return Ornament;
	}(_modifier.Modifier);

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TickContext = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tickable = __webpack_require__(23);
	
	var _fraction = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// A formatter for abstract tickable objects, such as notes, chords,
	// tabs, etc.
	
	var TickContext = exports.TickContext = function (_Tickable) {
	  _inherits(TickContext, _Tickable);
	
	  _createClass(TickContext, null, [{
	    key: 'getNextContext',
	    value: function getNextContext(tContext) {
	      var contexts = tContext.tContexts;
	      var index = contexts.indexOf(tContext);
	
	      return contexts[index + 1];
	    }
	  }]);
	
	  function TickContext() {
	    _classCallCheck(this, TickContext);
	
	    var _this = _possibleConstructorReturn(this, (TickContext.__proto__ || Object.getPrototypeOf(TickContext)).call(this));
	
	    _this.setAttribute('type', 'TickContext');
	    _this.currentTick = new _fraction.Fraction(0, 1);
	    _this.maxTicks = new _fraction.Fraction(0, 1);
	    _this.minTicks = null;
	    _this.padding = 3; // padding on each side (width += padding * 2)
	    _this.x = 0;
	    _this.tickables = []; // Notes, tabs, chords, lyrics.
	    _this.notePx = 0; // width of widest note in this context
	    _this.extraLeftPx = 0; // Extra left pixels for modifers & displace notes
	    _this.extraRightPx = 0; // Extra right pixels for modifers & displace notes
	    _this.tContexts = []; // Parent array of tick contexts
	    return _this;
	  }
	
	  _createClass(TickContext, [{
	    key: 'getX',
	    value: function getX() {
	      return this.x;
	    }
	  }, {
	    key: 'setX',
	    value: function setX(x) {
	      this.x = x;return this;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width + this.padding * 2;
	    }
	  }, {
	    key: 'setPadding',
	    value: function setPadding(padding) {
	      this.padding = padding;return this;
	    }
	  }, {
	    key: 'getMaxTicks',
	    value: function getMaxTicks() {
	      return this.maxTicks;
	    }
	  }, {
	    key: 'getMinTicks',
	    value: function getMinTicks() {
	      return this.minTicks;
	    }
	  }, {
	    key: 'getTickables',
	    value: function getTickables() {
	      return this.tickables;
	    }
	  }, {
	    key: 'getCenterAlignedTickables',
	    value: function getCenterAlignedTickables() {
	      return this.tickables.filter(function (tickable) {
	        return tickable.isCenterAligned();
	      });
	    }
	
	    // Get widths context, note and left/right modifiers for formatting
	
	  }, {
	    key: 'getMetrics',
	    value: function getMetrics() {
	      var width = this.width;
	      var notePx = this.notePx;
	      var extraLeftPx = this.extraLeftPx;
	      var extraRightPx = this.extraRightPx;
	
	      return { width: width, notePx: notePx, extraLeftPx: extraLeftPx, extraRightPx: extraRightPx };
	    }
	  }, {
	    key: 'getCurrentTick',
	    value: function getCurrentTick() {
	      return this.currentTick;
	    }
	  }, {
	    key: 'setCurrentTick',
	    value: function setCurrentTick(tick) {
	      this.currentTick = tick;
	      this.preFormatted = false;
	    }
	
	    // ### DEPRECATED ###
	    // Get left & right pixels used for modifiers. THIS METHOD IS DEPRECATED. Use
	    // the getMetrics() method instead!
	
	  }, {
	    key: 'getExtraPx',
	    value: function getExtraPx() {
	      var left_shift = 0;
	      var right_shift = 0;
	      var extraLeftPx = 0;
	      var extraRightPx = 0;
	      for (var i = 0; i < this.tickables.length; i++) {
	        extraLeftPx = Math.max(this.tickables[i].extraLeftPx || 0, extraLeftPx);
	        extraRightPx = Math.max(this.tickables[i].extraRightPx || 0, extraRightPx);
	        var mContext = this.tickables[i].modifierContext;
	        if (mContext && mContext != null) {
	          left_shift = Math.max(left_shift, mContext.state.left_shift);
	          right_shift = Math.max(right_shift, mContext.state.right_shift);
	        }
	      }
	      return {
	        left: left_shift,
	        right: right_shift,
	        extraLeft: extraLeftPx,
	        extraRight: extraRightPx
	      };
	    }
	  }, {
	    key: 'addTickable',
	    value: function addTickable(tickable) {
	      if (!tickable) {
	        throw new _vex.Vex.RERR('BadArgument', 'Invalid tickable added.');
	      }
	
	      if (!tickable.shouldIgnoreTicks()) {
	        this.ignore_ticks = false;
	
	        var ticks = tickable.getTicks();
	
	        if (ticks.greaterThan(this.maxTicks)) {
	          this.maxTicks = ticks.clone();
	        }
	
	        if (this.minTicks == null) {
	          this.minTicks = ticks.clone();
	        } else if (ticks.lessThan(this.minTicks)) {
	          this.minTicks = ticks.clone();
	        }
	      }
	
	      tickable.setTickContext(this);
	      this.tickables.push(tickable);
	      this.preFormatted = false;
	      return this;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return this;
	
	      for (var i = 0; i < this.tickables.length; ++i) {
	        var tickable = this.tickables[i];
	        tickable.preFormat();
	        var metrics = tickable.getMetrics();
	
	        // Maintain max extra pixels from all tickables in the context
	        this.extraLeftPx = Math.max(this.extraLeftPx, metrics.extraLeftPx + metrics.modLeftPx);
	        this.extraRightPx = Math.max(this.extraRightPx, metrics.extraRightPx + metrics.modRightPx);
	
	        // Maintain the widest note for all tickables in the context
	        this.notePx = Math.max(this.notePx, metrics.noteWidth);
	
	        // Recalculate the tick context total width
	        this.width = this.notePx + this.extraLeftPx + this.extraRightPx;
	      }
	
	      return this;
	    }
	  }, {
	    key: 'postFormat',
	    value: function postFormat() {
	      if (this.postFormatted) return this;
	      this.postFormatted = true;
	      return this;
	    }
	  }]);

	  return TickContext;
	}(_tickable.Tickable);

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Annotation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements text annotations as modifiers that can be attached to
	// notes.
	//
	// See `tests/annotation_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.Annotation.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Annotation.DEBUG) _vex.Vex.L('Vex.Flow.Annotation', args);
	}
	
	var Annotation = exports.Annotation = function (_Modifier) {
	  _inherits(Annotation, _Modifier);
	
	  _createClass(Annotation, null, [{
	    key: 'format',
	
	
	    // Arrange annotations within a `ModifierContext`
	    value: function format(annotations, state) {
	      if (!annotations || annotations.length === 0) return false;
	
	      var width = 0;
	      for (var i = 0; i < annotations.length; ++i) {
	        var annotation = annotations[i];
	        width = Math.max(annotation.getWidth(), width);
	        if (annotation.getPosition() === _modifier.Modifier.Position.ABOVE) {
	          annotation.setTextLine(state.top_text_line);
	          state.top_text_line++;
	        } else {
	          annotation.setTextLine(state.text_line);
	          state.text_line++;
	        }
	      }
	
	      state.left_shift += width / 2;
	      state.right_shift += width / 2;
	      return true;
	    }
	
	    // ## Prototype Methods
	    //
	    // Annotations inherit from `Modifier` and is positioned correctly when
	    // in a `ModifierContext`.
	    // Create a new `Annotation` with the string `text`.
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'annotations';
	    }
	
	    // Text annotations can be positioned and justified relative to the note.
	
	  }, {
	    key: 'Justify',
	    get: function get() {
	      return {
	        LEFT: 1,
	        CENTER: 2,
	        RIGHT: 3,
	        CENTER_STEM: 4
	      };
	    }
	  }, {
	    key: 'JustifyString',
	    get: function get() {
	      return {
	        left: Annotation.Justify.LEFT,
	        right: Annotation.Justify.RIGHT,
	        center: Annotation.Justify.CENTER,
	        centerStem: Annotation.Justify.CENTER_STEM
	      };
	    }
	  }, {
	    key: 'VerticalJustify',
	    get: function get() {
	      return {
	        TOP: 1,
	        CENTER: 2,
	        BOTTOM: 3,
	        CENTER_STEM: 4
	      };
	    }
	  }, {
	    key: 'VerticalJustifyString',
	    get: function get() {
	      return {
	        above: Annotation.VerticalJustify.TOP,
	        top: Annotation.VerticalJustify.TOP,
	        below: Annotation.VerticalJustify.BOTTOM,
	        bottom: Annotation.VerticalJustify.BOTTOM,
	        center: Annotation.VerticalJustify.CENTER,
	        centerStem: Annotation.VerticalJustify.CENTER_STEM
	      };
	    }
	  }]);
	
	  function Annotation(text) {
	    _classCallCheck(this, Annotation);
	
	    var _this = _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).call(this));
	
	    _this.setAttribute('type', 'Annotation');
	
	    _this.note = null;
	    _this.index = null;
	    _this.text = text;
	    _this.justification = Annotation.Justify.CENTER;
	    _this.vert_justification = Annotation.VerticalJustify.TOP;
	    _this.font = {
	      family: 'Arial',
	      size: 10,
	      weight: ''
	    };
	
	    // The default width is calculated from the text.
	    _this.setWidth(_tables.Flow.textWidth(text));
	    return _this;
	  }
	
	  _createClass(Annotation, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Annotation.CATEGORY;
	    }
	
	    // Set font family, size, and weight. E.g., `Arial`, `10pt`, `Bold`.
	
	  }, {
	    key: 'setFont',
	    value: function setFont(family, size, weight) {
	      this.font = { family: family, size: size, weight: weight };
	      return this;
	    }
	
	    // Set vertical position of text (above or below stave). `just` must be
	    // a value in `Annotation.VerticalJustify`.
	
	  }, {
	    key: 'setVerticalJustification',
	    value: function setVerticalJustification(just) {
	      this.vert_justification = typeof just === 'string' ? Annotation.VerticalJustifyString[just] : just;
	      return this;
	    }
	
	    // Get and set horizontal justification. `justification` is a value in
	    // `Annotation.Justify`.
	
	  }, {
	    key: 'getJustification',
	    value: function getJustification() {
	      return this.justification;
	    }
	  }, {
	    key: 'setJustification',
	    value: function setJustification(just) {
	      this.justification = typeof just === 'string' ? Annotation.JustifyString[just] : just;
	      return this;
	    }
	
	    // Render text beside the note.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!this.note) {
	        throw new _vex.Vex.RERR('NoNoteForAnnotation', "Can't draw text annotation without an attached note.");
	      }
	
	      this.setRendered();
	      var start = this.note.getModifierStartXY(_modifier.Modifier.Position.ABOVE, this.index);
	
	      // We're changing context parameters. Save current state.
	      this.context.save();
	      this.context.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = this.context.measureText(this.text).width;
	
	      // Estimate text height to be the same as the width of an 'm'.
	      //
	      // This is a hack to work around the inability to measure text height
	      // in HTML5 Canvas (and SVG).
	      var text_height = this.context.measureText('m').width;
	      var x = void 0;
	      var y = void 0;
	
	      if (this.justification === Annotation.Justify.LEFT) {
	        x = start.x;
	      } else if (this.justification === Annotation.Justify.RIGHT) {
	        x = start.x - text_width;
	      } else if (this.justification === Annotation.Justify.CENTER) {
	        x = start.x - text_width / 2;
	      } else /* CENTER_STEM */{
	          x = this.note.getStemX() - text_width / 2;
	        }
	
	      var stem_ext = void 0;
	      var spacing = void 0;
	      var has_stem = this.note.hasStem();
	      var stave = this.note.getStave();
	
	      // The position of the text varies based on whether or not the note
	      // has a stem.
	      if (has_stem) {
	        stem_ext = this.note.getStem().getExtents();
	        spacing = stave.getSpacingBetweenLines();
	      }
	
	      if (this.vert_justification === Annotation.VerticalJustify.BOTTOM) {
	        // HACK: We need to compensate for the text's height since its origin
	        // is bottom-right.
	        y = stave.getYForBottomText(this.text_line + _tables.Flow.TEXT_HEIGHT_OFFSET_HACK);
	        if (has_stem) {
	          var stem_base = this.note.getStemDirection() === 1 ? stem_ext.baseY : stem_ext.topY;
	          y = Math.max(y, stem_base + spacing * (this.text_line + 2));
	        }
	      } else if (this.vert_justification === Annotation.VerticalJustify.CENTER) {
	        var yt = this.note.getYForTopText(this.text_line) - 1;
	        var yb = stave.getYForBottomText(this.text_line);
	        y = yt + (yb - yt) / 2 + text_height / 2;
	      } else if (this.vert_justification === Annotation.VerticalJustify.TOP) {
	        y = Math.min(stave.getYForTopText(this.text_line), this.note.getYs()[0] - 10);
	        if (has_stem) {
	          y = Math.min(y, stem_ext.topY - 5 - spacing * this.text_line);
	        }
	      } else /* CENTER_STEM */{
	          var extents = this.note.getStemExtents();
	          y = extents.topY + (extents.baseY - extents.topY) / 2 + text_height / 2;
	        }
	
	      L('Rendering annotation: ', this.text, x, y);
	      this.context.fillText(this.text, x, y);
	      this.context.restore();
	    }
	  }]);

	  return Annotation;
	}(_modifier.Modifier);

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bend = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements tablature bends.
	
	/**
	   @param text Text for bend ("Full", "Half", etc.) (DEPRECATED)
	   @param release If true, render a release. (DEPRECATED)
	   @param phrase If set, ignore "text" and "release", and use the more
	                 sophisticated phrase specified.
	
	   Example of a phrase:
	
	     [{
	       type: UP,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: DOWN,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: UP,
	       text: "half"
	       width: 8;
	     },
	     {
	       type: UP,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: DOWN,
	       text: "1 1/2"
	       width: 8;
	     }]
	 */
	var Bend = exports.Bend = function (_Modifier) {
	  _inherits(Bend, _Modifier);
	
	  _createClass(Bend, null, [{
	    key: 'format',
	
	
	    // ## Static Methods
	    // Arrange bends in `ModifierContext`
	    value: function format(bends, state) {
	      if (!bends || bends.length === 0) return false;
	
	      var last_width = 0;
	      // Bends are always on top.
	      var text_line = state.top_text_line;
	
	      // Format Bends
	      for (var i = 0; i < bends.length; ++i) {
	        var bend = bends[i];
	        bend.setXShift(last_width);
	        last_width = bend.getWidth();
	        bend.setTextLine(text_line);
	      }
	
	      state.right_shift += last_width;
	      state.top_text_line += 1;
	      return true;
	    }
	
	    // ## Prototype Methods
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'bends';
	    }
	  }, {
	    key: 'UP',
	    get: function get() {
	      return 0;
	    }
	  }, {
	    key: 'DOWN',
	    get: function get() {
	      return 1;
	    }
	  }]);
	
	  function Bend(text, release, phrase) {
	    _classCallCheck(this, Bend);
	
	    var _this = _possibleConstructorReturn(this, (Bend.__proto__ || Object.getPrototypeOf(Bend)).call(this));
	
	    _this.setAttribute('type', 'Bend');
	
	    _this.text = text;
	    _this.x_shift = 0;
	    _this.release = release || false;
	    _this.font = '10pt Arial';
	    _this.render_options = {
	      line_width: 1.5,
	      line_style: '#777777',
	      bend_width: 8,
	      release_width: 8
	    };
	
	    if (phrase) {
	      _this.phrase = phrase;
	    } else {
	      // Backward compatibility
	      _this.phrase = [{ type: Bend.UP, text: _this.text }];
	      if (_this.release) _this.phrase.push({ type: Bend.DOWN, text: '' });
	    }
	
	    _this.updateWidth();
	    return _this;
	  }
	
	  _createClass(Bend, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Bend.CATEGORY;
	    }
	  }, {
	    key: 'setXShift',
	    value: function setXShift(value) {
	      this.x_shift = value;
	      this.updateWidth();
	    }
	  }, {
	    key: 'setFont',
	    value: function setFont(font) {
	      this.font = font;return this;
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      return this.text;
	    }
	  }, {
	    key: 'updateWidth',
	    value: function updateWidth() {
	      var that = this;
	
	      function measure_text(text) {
	        var text_width = void 0;
	        if (that.context) {
	          text_width = that.context.measureText(text).width;
	        } else {
	          text_width = _tables.Flow.textWidth(text);
	        }
	
	        return text_width;
	      }
	
	      var total_width = 0;
	      for (var i = 0; i < this.phrase.length; ++i) {
	        var bend = this.phrase[i];
	        if ('width' in bend) {
	          total_width += bend.width;
	        } else {
	          var additional_width = bend.type === Bend.UP ? this.render_options.bend_width : this.render_options.release_width;
	
	          bend.width = _vex.Vex.Max(additional_width, measure_text(bend.text)) + 3;
	          bend.draw_width = bend.width / 2;
	          total_width += bend.width;
	        }
	      }
	
	      this.setWidth(total_width + this.x_shift);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      if (!(this.note && this.index != null)) {
	        throw new _vex.Vex.RERR('NoNoteForBend', "Can't draw bend without a note or index.");
	      }
	
	      this.setRendered();
	
	      var start = this.note.getModifierStartXY(_modifier.Modifier.Position.RIGHT, this.index);
	      start.x += 3;
	      start.y += 0.5;
	      var x_shift = this.x_shift;
	
	      var ctx = this.context;
	      var bend_height = this.note.getStave().getYForTopText(this.text_line) + 3;
	      var annotation_y = this.note.getStave().getYForTopText(this.text_line) - 1;
	      var that = this;
	
	      function renderBend(x, y, width, height) {
	        var cp_x = x + width;
	        var cp_y = y;
	
	        ctx.save();
	        ctx.beginPath();
	        ctx.setLineWidth(that.render_options.line_width);
	        ctx.setStrokeStyle(that.render_options.line_style);
	        ctx.setFillStyle(that.render_options.line_style);
	        ctx.moveTo(x, y);
	        ctx.quadraticCurveTo(cp_x, cp_y, x + width, height);
	        ctx.stroke();
	        ctx.restore();
	      }
	
	      function renderRelease(x, y, width, height) {
	        ctx.save();
	        ctx.beginPath();
	        ctx.setLineWidth(that.render_options.line_width);
	        ctx.setStrokeStyle(that.render_options.line_style);
	        ctx.setFillStyle(that.render_options.line_style);
	        ctx.moveTo(x, height);
	        ctx.quadraticCurveTo(x + width, height, x + width, y);
	        ctx.stroke();
	        ctx.restore();
	      }
	
	      function renderArrowHead(x, y, direction) {
	        var width = 4;
	        var dir = direction || 1;
	
	        ctx.beginPath();
	        ctx.moveTo(x, y);
	        ctx.lineTo(x - width, y + width * dir);
	        ctx.lineTo(x + width, y + width * dir);
	        ctx.closePath();
	        ctx.fill();
	      }
	
	      function renderText(x, text) {
	        ctx.save();
	        ctx.setRawFont(that.font);
	        var render_x = x - ctx.measureText(text).width / 2;
	        ctx.fillText(text, render_x, annotation_y);
	        ctx.restore();
	      }
	
	      var last_bend = null;
	      var last_drawn_width = 0;
	      for (var i = 0; i < this.phrase.length; ++i) {
	        var bend = this.phrase[i];
	        if (i === 0) bend.draw_width += x_shift;
	
	        last_drawn_width = bend.draw_width + (last_bend ? last_bend.draw_width : 0) - (i === 1 ? x_shift : 0);
	        if (bend.type === Bend.UP) {
	          if (last_bend && last_bend.type === Bend.UP) {
	            renderArrowHead(start.x, bend_height);
	          }
	
	          renderBend(start.x, start.y, last_drawn_width, bend_height);
	        }
	
	        if (bend.type === Bend.DOWN) {
	          if (last_bend && last_bend.type === Bend.UP) {
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	
	          if (last_bend && last_bend.type === Bend.DOWN) {
	            renderArrowHead(start.x, start.y, -1);
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	
	          if (last_bend === null) {
	            last_drawn_width = bend.draw_width;
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	        }
	
	        renderText(start.x + last_drawn_width, bend.text);
	        last_bend = bend;
	        last_bend.x = start.x;
	
	        start.x += last_drawn_width;
	      }
	
	      // Final arrowhead and text
	      if (last_bend.type === Bend.UP) {
	        renderArrowHead(last_bend.x + last_drawn_width, bend_height);
	      } else if (last_bend.type === Bend.DOWN) {
	        renderArrowHead(last_bend.x + last_drawn_width, start.y, -1);
	      }
	    }
	  }]);

	  return Bend;
	}(_modifier.Modifier);

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vibrato = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	var _bend = __webpack_require__(41);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements vibratos.
	
	var Vibrato = exports.Vibrato = function (_Modifier) {
	  _inherits(Vibrato, _Modifier);
	
	  _createClass(Vibrato, null, [{
	    key: 'format',
	
	
	    // ## Static Methods
	    // Arrange vibratos inside a `ModifierContext`.
	    value: function format(vibratos, state, context) {
	      if (!vibratos || vibratos.length === 0) return false;
	
	      // Vibratos are always on top.
	      var text_line = state.top_text_line;
	      var width = 0;
	      var shift = state.right_shift - 7;
	
	      // If there's a bend, drop the text line
	      var bends = context.getModifiers(_bend.Bend.CATEGORY);
	      if (bends && bends.length > 0) {
	        text_line--;
	      }
	
	      // Format Vibratos
	      for (var i = 0; i < vibratos.length; ++i) {
	        var vibrato = vibratos[i];
	        vibrato.setXShift(shift);
	        vibrato.setTextLine(text_line);
	        width += vibrato.getWidth();
	        shift += width;
	      }
	
	      state.right_shift += width;
	      state.top_text_line += 1;
	      return true;
	    }
	
	    // ## Prototype Methods
	
	  }, {
	    key: 'CATEGORY',
	    get: function get() {
	      return 'vibratos';
	    }
	  }]);
	
	  function Vibrato() {
	    _classCallCheck(this, Vibrato);
	
	    var _this = _possibleConstructorReturn(this, (Vibrato.__proto__ || Object.getPrototypeOf(Vibrato)).call(this));
	
	    _this.setAttribute('type', 'Vibrato');
	
	    _this.position = _modifier.Modifier.Position.RIGHT;
	    _this.render_options = {
	      harsh: false,
	      vibrato_width: 20,
	      wave_height: 6,
	      wave_width: 4,
	      wave_girth: 2
	    };
	
	    _this.setVibratoWidth(_this.render_options.vibrato_width);
	    return _this;
	  }
	
	  _createClass(Vibrato, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Vibrato.CATEGORY;
	    }
	  }, {
	    key: 'setHarsh',
	    value: function setHarsh(harsh) {
	      this.render_options.harsh = harsh;return this;
	    }
	  }, {
	    key: 'setVibratoWidth',
	    value: function setVibratoWidth(width) {
	      this.render_options.vibrato_width = width;
	      this.setWidth(width);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.checkContext();
	
	      if (!this.note) {
	        throw new _vex.Vex.RERR('NoNoteForVibrato', "Can't draw vibrato without an attached note.");
	      }
	
	      this.setRendered();
	      var start = this.note.getModifierStartXY(_modifier.Modifier.Position.RIGHT, this.index);
	
	      var vx = start.x + this.x_shift;
	      var vy = this.note.getYForTopText(this.text_line) + 2;
	
	      Vibrato.renderVibrato(ctx, vx, vy, this.render_options);
	    }
	
	    // Static rendering method that can be called from
	    // other classes (e.g. VibratoBracket)
	
	  }], [{
	    key: 'renderVibrato',
	    value: function renderVibrato(ctx, x, y, opts) {
	      var harsh = opts.harsh;
	      var vibrato_width = opts.vibrato_width;
	      var wave_width = opts.wave_width;
	      var wave_girth = opts.wave_girth;
	      var wave_height = opts.wave_height;
	
	      var num_waves = vibrato_width / wave_width;
	
	      ctx.beginPath();
	
	      var i = void 0;
	      if (harsh) {
	        ctx.moveTo(x, y + wave_girth + 1);
	        for (i = 0; i < num_waves / 2; ++i) {
	          ctx.lineTo(x + wave_width, y - wave_height / 2);
	          x += wave_width;
	          ctx.lineTo(x + wave_width, y + wave_height / 2);
	          x += wave_width;
	        }
	        for (i = 0; i < num_waves / 2; ++i) {
	          ctx.lineTo(x - wave_width, y - wave_height / 2 + wave_girth + 1);
	          x -= wave_width;
	          ctx.lineTo(x - wave_width, y + wave_height / 2 + wave_girth + 1);
	          x -= wave_width;
	        }
	        ctx.fill();
	      } else {
	        ctx.moveTo(x, y + wave_girth);
	        for (i = 0; i < num_waves / 2; ++i) {
	          ctx.quadraticCurveTo(x + wave_width / 2, y - wave_height / 2, x + wave_width, y);
	          x += wave_width;
	          ctx.quadraticCurveTo(x + wave_width / 2, y + wave_height / 2, x + wave_width, y);
	          x += wave_width;
	        }
	
	        for (i = 0; i < num_waves / 2; ++i) {
	          ctx.quadraticCurveTo(x - wave_width / 2, y + wave_height / 2 + wave_girth, x - wave_width, y + wave_girth);
	          x -= wave_width;
	          ctx.quadraticCurveTo(x - wave_width / 2, y - wave_height / 2 + wave_girth, x - wave_width, y + wave_girth);
	          x -= wave_width;
	        }
	        ctx.fill();
	      }
	    }
	  }]);

	  return Vibrato;
	}(_modifier.Modifier);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stave = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	var _stavebarline = __webpack_require__(44);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _staverepetition = __webpack_require__(46);
	
	var _stavesection = __webpack_require__(47);
	
	var _stavetempo = __webpack_require__(48);
	
	var _stavetext = __webpack_require__(49);
	
	var _boundingbox = __webpack_require__(8);
	
	var _clef = __webpack_require__(51);
	
	var _keysignature = __webpack_require__(52);
	
	var _timesignature = __webpack_require__(53);
	
	var _stavevolta = __webpack_require__(54);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	var Stave = exports.Stave = function (_Element) {
	  _inherits(Stave, _Element);
	
	  function Stave(x, y, width, options) {
	    _classCallCheck(this, Stave);
	
	    var _this = _possibleConstructorReturn(this, (Stave.__proto__ || Object.getPrototypeOf(Stave)).call(this));
	
	    _this.setAttribute('type', 'Stave');
	
	    _this.x = x;
	    _this.y = y;
	    _this.width = width;
	    _this.formatted = false;
	    _this.start_x = x + 5;
	    _this.end_x = x + width;
	    _this.modifiers = []; // stave modifiers (clef, key, time, barlines, coda, segno, etc.)
	    _this.measure = 0;
	    _this.clef = 'treble';
	    _this.font = {
	      family: 'sans-serif',
	      size: 8,
	      weight: ''
	    };
	    _this.options = {
	      vertical_bar_width: 10, // Width around vertical bar end-marker
	      glyph_spacing_px: 10,
	      num_lines: 5,
	      fill_style: '#999999',
	      left_bar: true, // draw vertical bar on left
	      right_bar: true, // draw vertical bar on right
	      spacing_between_lines_px: 10, // in pixels
	      space_above_staff_ln: 4, // in staff lines
	      space_below_staff_ln: 4, // in staff lines
	      top_text_position: 1 };
	    _this.bounds = { x: _this.x, y: _this.y, w: _this.width, h: 0 };
	    _vex.Vex.Merge(_this.options, options);
	
	    _this.resetLines();
	
	    var BARTYPE = _stavebarline.Barline.type;
	    // beg bar
	    _this.addModifier(new _stavebarline.Barline(_this.options.left_bar ? BARTYPE.SINGLE : BARTYPE.NONE));
	    // end bar
	    _this.addEndModifier(new _stavebarline.Barline(_this.options.right_bar ? BARTYPE.SINGLE : BARTYPE.NONE));
	    return _this;
	  }
	
	  _createClass(Stave, [{
	    key: 'space',
	    value: function space(spacing) {
	      return this.options.spacing_between_lines_px * spacing;
	    }
	  }, {
	    key: 'resetLines',
	    value: function resetLines() {
	      this.options.line_config = [];
	      for (var i = 0; i < this.options.num_lines; i++) {
	        this.options.line_config.push({ visible: true });
	      }
	      this.height = (this.options.num_lines + this.options.space_above_staff_ln) * this.options.spacing_between_lines_px;
	      this.options.bottom_text_position = this.options.num_lines;
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return this.options;
	    }
	  }, {
	    key: 'setNoteStartX',
	    value: function setNoteStartX(x) {
	      if (!this.formatted) this.format();
	
	      this.start_x = x;
	      return this;
	    }
	  }, {
	    key: 'getNoteStartX',
	    value: function getNoteStartX() {
	      if (!this.formatted) this.format();
	
	      return this.start_x;
	    }
	  }, {
	    key: 'getNoteEndX',
	    value: function getNoteEndX() {
	      if (!this.formatted) this.format();
	
	      return this.end_x;
	    }
	  }, {
	    key: 'getTieStartX',
	    value: function getTieStartX() {
	      return this.start_x;
	    }
	  }, {
	    key: 'getTieEndX',
	    value: function getTieEndX() {
	      return this.x + this.width;
	    }
	  }, {
	    key: 'getX',
	    value: function getX() {
	      return this.x;
	    }
	  }, {
	    key: 'getNumLines',
	    value: function getNumLines() {
	      return this.options.num_lines;
	    }
	  }, {
	    key: 'setNumLines',
	    value: function setNumLines(lines) {
	      this.options.num_lines = parseInt(lines, 10);
	      this.resetLines();
	      return this;
	    }
	  }, {
	    key: 'setY',
	    value: function setY(y) {
	      this.y = y;return this;
	    }
	  }, {
	    key: 'getTopLineTopY',
	    value: function getTopLineTopY() {
	      return this.getYForLine(0) - _tables.Flow.STAVE_LINE_THICKNESS / 2;
	    }
	  }, {
	    key: 'getBottomLineBottomY',
	    value: function getBottomLineBottomY() {
	      return this.getYForLine(this.getNumLines() - 1) + _tables.Flow.STAVE_LINE_THICKNESS / 2;
	    }
	  }, {
	    key: 'setX',
	    value: function setX(x) {
	      var shift = x - this.x;
	      this.formatted = false;
	      this.x = x;
	      this.start_x += shift;
	      this.end_x += shift;
	      for (var i = 0; i < this.modifiers.length; i++) {
	        var mod = this.modifiers[i];
	        if (mod.x !== undefined) {
	          mod.x += shift;
	        }
	      }
	      return this;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.formatted = false;
	      this.width = width;
	      this.end_x = this.x + width;
	
	      // reset the x position of the end barline (TODO(0xfe): This makes no sense)
	      // this.modifiers[1].setX(this.end_x);
	      return this;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return _extends({
	        fillStyle: this.options.fill_style,
	        strokeStyle: this.options.fill_style, // yes, this is correct for legacy compatibility
	        lineWidth: _tables.Flow.STAVE_LINE_THICKNESS
	      }, this.style || {});
	    }
	  }, {
	    key: 'setMeasure',
	    value: function setMeasure(measure) {
	      this.measure = measure;return this;
	    }
	
	    /**
	     * Gets the pixels to shift from the beginning of the stave
	     * following the modifier at the provided index
	     * @param  {Number} index The index from which to determine the shift
	     * @return {Number}       The amount of pixels shifted
	     */
	
	  }, {
	    key: 'getModifierXShift',
	    value: function getModifierXShift() {
	      var index = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
	      if (typeof index !== 'number') {
	        throw new _vex.Vex.RERR('InvalidIndex', 'Must be of number type');
	      }
	
	      if (!this.formatted) this.format();
	
	      if (this.getModifiers(_stavemodifier.StaveModifier.Position.BEGIN).length === 1) {
	        return 0;
	      }
	
	      var start_x = this.start_x - this.x;
	      var begBarline = this.modifiers[0];
	      if (begBarline.getType() === _stavebarline.Barline.type.REPEAT_BEGIN && start_x > begBarline.getWidth()) {
	        start_x -= begBarline.getWidth();
	      }
	
	      return start_x;
	    }
	
	    // Coda & Segno Symbol functions
	
	  }, {
	    key: 'setRepetitionTypeLeft',
	    value: function setRepetitionTypeLeft(type, y) {
	      this.modifiers.push(new _staverepetition.Repetition(type, this.x, y));
	      return this;
	    }
	  }, {
	    key: 'setRepetitionTypeRight',
	    value: function setRepetitionTypeRight(type, y) {
	      this.modifiers.push(new _staverepetition.Repetition(type, this.x, y));
	      return this;
	    }
	
	    // Volta functions
	
	  }, {
	    key: 'setVoltaType',
	    value: function setVoltaType(type, number_t, y) {
	      this.modifiers.push(new _stavevolta.Volta(type, number_t, this.x, y));
	      return this;
	    }
	
	    // Section functions
	
	  }, {
	    key: 'setSection',
	    value: function setSection(section, y) {
	      this.modifiers.push(new _stavesection.StaveSection(section, this.x, y));
	      return this;
	    }
	
	    // Tempo functions
	
	  }, {
	    key: 'setTempo',
	    value: function setTempo(tempo, y) {
	      this.modifiers.push(new _stavetempo.StaveTempo(tempo, this.x, y));
	      return this;
	    }
	
	    // Text functions
	
	  }, {
	    key: 'setText',
	    value: function setText(text, position, options) {
	      this.modifiers.push(new _stavetext.StaveText(text, position, options));
	      return this;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return this.height;
	    }
	  }, {
	    key: 'getSpacingBetweenLines',
	    value: function getSpacingBetweenLines() {
	      return this.options.spacing_between_lines_px;
	    }
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return new _boundingbox.BoundingBox(this.x, this.y, this.width, this.getBottomY() - this.y);
	    }
	  }, {
	    key: 'getBottomY',
	    value: function getBottomY() {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var score_bottom = this.getYForLine(options.num_lines) + options.space_below_staff_ln * spacing;
	
	      return score_bottom;
	    }
	  }, {
	    key: 'getBottomLineY',
	    value: function getBottomLineY() {
	      return this.getYForLine(this.options.num_lines);
	    }
	
	    // This returns the y for the *center* of a staff line
	
	  }, {
	    key: 'getYForLine',
	    value: function getYForLine(line) {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var headroom = options.space_above_staff_ln;
	
	      var y = this.y + line * spacing + headroom * spacing;
	
	      return y;
	    }
	  }, {
	    key: 'getLineForY',
	    value: function getLineForY(y) {
	      // Does the reverse of getYForLine - somewhat dumb and just calls
	      // getYForLine until the right value is reaches
	
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var headroom = options.space_above_staff_ln;
	      return (y - this.y) / spacing - headroom;
	    }
	  }, {
	    key: 'getYForTopText',
	    value: function getYForTopText(line) {
	      var l = line || 0;
	      return this.getYForLine(-l - this.options.top_text_position);
	    }
	  }, {
	    key: 'getYForBottomText',
	    value: function getYForBottomText(line) {
	      var l = line || 0;
	      return this.getYForLine(this.options.bottom_text_position + l);
	    }
	  }, {
	    key: 'getYForNote',
	    value: function getYForNote(line) {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var headroom = options.space_above_staff_ln;
	      var y = this.y + headroom * spacing + 5 * spacing - line * spacing;
	
	      return y;
	    }
	  }, {
	    key: 'getYForGlyphs',
	    value: function getYForGlyphs() {
	      return this.getYForLine(3);
	    }
	  }, {
	    key: 'addModifier',
	    value: function addModifier(modifier, position) {
	      if (position !== undefined) {
	        modifier.setPosition(position);
	      }
	
	      modifier.setStave(this);
	      this.formatted = false;
	      this.modifiers.push(modifier);
	      return this;
	    }
	  }, {
	    key: 'addEndModifier',
	    value: function addEndModifier(modifier) {
	      this.addModifier(modifier, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	
	    // Bar Line functions
	
	  }, {
	    key: 'setBegBarType',
	    value: function setBegBarType(type) {
	      // Only valid bar types at beginning of stave is none, single or begin repeat
	      var _Barline$type = _stavebarline.Barline.type;
	      var SINGLE = _Barline$type.SINGLE;
	      var REPEAT_BEGIN = _Barline$type.REPEAT_BEGIN;
	      var NONE = _Barline$type.NONE;
	
	      if (type === SINGLE || type === REPEAT_BEGIN || type === NONE) {
	        this.modifiers[0].setType(type);
	        this.formatted = false;
	      }
	      return this;
	    }
	  }, {
	    key: 'setEndBarType',
	    value: function setEndBarType(type) {
	      // Repeat end not valid at end of stave
	      if (type !== _stavebarline.Barline.type.REPEAT_BEGIN) {
	        this.modifiers[1].setType(type);
	        this.formatted = false;
	      }
	      return this;
	    }
	  }, {
	    key: 'setClef',
	    value: function setClef(clefSpec, size, annotation, position) {
	      if (position === undefined) {
	        position = _stavemodifier.StaveModifier.Position.BEGIN;
	      }
	
	      this.clef = clefSpec;
	      var clefs = this.getModifiers(position, _clef.Clef.CATEGORY);
	      if (clefs.length === 0) {
	        this.addClef(clefSpec, size, annotation, position);
	      } else {
	        clefs[0].setType(clefSpec, size, annotation);
	      }
	
	      return this;
	    }
	  }, {
	    key: 'setEndClef',
	    value: function setEndClef(clefSpec, size, annotation) {
	      this.setClef(clefSpec, size, annotation, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	  }, {
	    key: 'setKeySignature',
	    value: function setKeySignature(keySpec, cancelKeySpec, position) {
	      if (position === undefined) {
	        position = _stavemodifier.StaveModifier.Position.BEGIN;
	      }
	
	      var keySignatures = this.getModifiers(position, _keysignature.KeySignature.CATEGORY);
	      if (keySignatures.length === 0) {
	        this.addKeySignature(keySpec, cancelKeySpec, position);
	      } else {
	        keySignatures[0].setKeySig(keySpec, cancelKeySpec);
	      }
	
	      return this;
	    }
	  }, {
	    key: 'setEndKeySignature',
	    value: function setEndKeySignature(keySpec, cancelKeySpec) {
	      this.setKeySignature(keySpec, cancelKeySpec, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	  }, {
	    key: 'setTimeSignature',
	    value: function setTimeSignature(timeSpec, customPadding, position) {
	      if (position === undefined) {
	        position = _stavemodifier.StaveModifier.Position.BEGIN;
	      }
	
	      var timeSignatures = this.getModifiers(position, _timesignature.TimeSignature.CATEGORY);
	      if (timeSignatures.length === 0) {
	        this.addTimeSignature(timeSpec, customPadding, position);
	      } else {
	        timeSignatures[0].setTimeSig(timeSpec);
	      }
	
	      return this;
	    }
	  }, {
	    key: 'setEndTimeSignature',
	    value: function setEndTimeSignature(timeSpec, customPadding) {
	      this.setTimeSignature(timeSpec, customPadding, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	  }, {
	    key: 'addKeySignature',
	    value: function addKeySignature(keySpec, cancelKeySpec, position) {
	      this.addModifier(new _keysignature.KeySignature(keySpec, cancelKeySpec), position);
	      return this;
	    }
	  }, {
	    key: 'addClef',
	    value: function addClef(clef, size, annotation, position) {
	      if (position === undefined || position === _stavemodifier.StaveModifier.Position.BEGIN) {
	        this.clef = clef;
	      }
	
	      this.addModifier(new _clef.Clef(clef, size, annotation), position);
	      return this;
	    }
	  }, {
	    key: 'addEndClef',
	    value: function addEndClef(clef, size, annotation) {
	      this.addClef(clef, size, annotation, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	  }, {
	    key: 'addTimeSignature',
	    value: function addTimeSignature(timeSpec, customPadding, position) {
	      this.addModifier(new _timesignature.TimeSignature(timeSpec, customPadding), position);
	      return this;
	    }
	  }, {
	    key: 'addEndTimeSignature',
	    value: function addEndTimeSignature(timeSpec, customPadding) {
	      this.addTimeSignature(timeSpec, customPadding, _stavemodifier.StaveModifier.Position.END);
	      return this;
	    }
	
	    // Deprecated
	
	  }, {
	    key: 'addTrebleGlyph',
	    value: function addTrebleGlyph() {
	      this.addClef('treble');
	      return this;
	    }
	  }, {
	    key: 'getModifiers',
	    value: function getModifiers(position, category) {
	      if (position === undefined) return this.modifiers;
	
	      return this.modifiers.filter(function (modifier) {
	        return position === modifier.getPosition() && (category === undefined || category === modifier.getCategory());
	      });
	    }
	  }, {
	    key: 'sortByCategory',
	    value: function sortByCategory(items, order) {
	      for (var i = items.length - 1; i >= 0; i--) {
	        for (var j = 0; j < i; j++) {
	          if (order[items[j].getCategory()] > order[items[j + 1].getCategory()]) {
	            var temp = items[j];
	            items[j] = items[j + 1];
	            items[j + 1] = temp;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format() {
	      var begBarline = this.modifiers[0];
	      var endBarline = this.modifiers[1];
	
	      var begModifiers = this.getModifiers(_stavemodifier.StaveModifier.Position.BEGIN);
	      var endModifiers = this.getModifiers(_stavemodifier.StaveModifier.Position.END);
	
	      this.sortByCategory(begModifiers, {
	        barlines: 0, clefs: 1, keysignatures: 2, timesignatures: 3
	      });
	
	      this.sortByCategory(endModifiers, {
	        timesignatures: 0, keysignatures: 1, barlines: 2, clefs: 3
	      });
	
	      if (begModifiers.length > 1 && begBarline.getType() === _stavebarline.Barline.type.REPEAT_BEGIN) {
	        begModifiers.push(begModifiers.splice(0, 1)[0]);
	        begModifiers.splice(0, 0, new _stavebarline.Barline(_stavebarline.Barline.type.SINGLE));
	      }
	
	      if (endModifiers.indexOf(endBarline) > 0) {
	        endModifiers.splice(0, 0, new _stavebarline.Barline(_stavebarline.Barline.type.NONE));
	      }
	
	      var width = void 0;
	      var padding = void 0;
	      var modifier = void 0;
	      var offset = 0;
	      var x = this.x;
	      for (var i = 0; i < begModifiers.length; i++) {
	        modifier = begModifiers[i];
	        padding = modifier.getPadding(i + offset);
	        width = modifier.getWidth();
	
	        x += padding;
	        modifier.setX(x);
	        x += width;
	
	        if (padding + width === 0) offset--;
	      }
	
	      this.start_x = x;
	      x = this.x + this.width;
	
	      for (var _i = 0; _i < endModifiers.length; _i++) {
	        modifier = endModifiers[_i];
	        x -= modifier.getPadding(_i);
	        if (_i !== 0) {
	          x -= modifier.getWidth();
	        }
	
	        modifier.setX(x);
	
	        if (_i === 0) {
	          x -= modifier.getWidth();
	        }
	      }
	
	      this.end_x = endModifiers.length === 1 ? this.x + this.width : x;
	      this.formatted = true;
	    }
	
	    /**
	     * All drawing functions below need the context to be set.
	     */
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      if (!this.formatted) this.format();
	
	      var num_lines = this.options.num_lines;
	      var width = this.width;
	      var x = this.x;
	      var y = void 0;
	
	      // Render lines
	      for (var line = 0; line < num_lines; line++) {
	        y = this.getYForLine(line);
	
	        this.applyStyle();
	        if (this.options.line_config[line].visible) {
	          this.context.beginPath();
	          this.context.moveTo(x, y);
	          this.context.lineTo(x + width, y);
	          this.context.stroke();
	        }
	        this.restoreStyle();
	      }
	
	      // Draw the modifiers (bar lines, coda, segno, repeat brackets, etc.)
	      for (var i = 0; i < this.modifiers.length; i++) {
	        // Only draw modifier if it has a draw function
	        if (typeof this.modifiers[i].draw === 'function') {
	          this.modifiers[i].draw(this, this.getModifierXShift(i));
	        }
	      }
	
	      // Render measure numbers
	      if (this.measure > 0) {
	        this.context.save();
	        this.context.setFont(this.font.family, this.font.size, this.font.weight);
	        var text_width = this.context.measureText('' + this.measure).width;
	        y = this.getYForTopText(0) + 3;
	        this.context.fillText('' + this.measure, this.x - text_width / 2, y);
	        this.context.restore();
	      }
	
	      return this;
	    }
	
	    // Draw Simple barlines for backward compatability
	    // Do not delete - draws the beginning bar of the stave
	
	  }, {
	    key: 'drawVertical',
	    value: function drawVertical(x, isDouble) {
	      this.drawVerticalFixed(this.x + x, isDouble);
	    }
	  }, {
	    key: 'drawVerticalFixed',
	    value: function drawVerticalFixed(x, isDouble) {
	      this.checkContext();
	
	      var top_line = this.getYForLine(0);
	      var bottom_line = this.getYForLine(this.options.num_lines - 1);
	      if (isDouble) {
	        this.context.fillRect(x - 3, top_line, 1, bottom_line - top_line + 1);
	      }
	      this.context.fillRect(x, top_line, 1, bottom_line - top_line + 1);
	    }
	  }, {
	    key: 'drawVerticalBar',
	    value: function drawVerticalBar(x) {
	      this.drawVerticalBarFixed(this.x + x, false);
	    }
	  }, {
	    key: 'drawVerticalBarFixed',
	    value: function drawVerticalBarFixed(x) {
	      this.checkContext();
	
	      var top_line = this.getYForLine(0);
	      var bottom_line = this.getYForLine(this.options.num_lines - 1);
	      this.context.fillRect(x, top_line, 1, bottom_line - top_line + 1);
	    }
	
	    /**
	     * Get the current configuration for the Stave.
	     * @return {Array} An array of configuration objects.
	     */
	
	  }, {
	    key: 'getConfigForLines',
	    value: function getConfigForLines() {
	      return this.options.line_config;
	    }
	
	    /**
	     * Configure properties of the lines in the Stave
	     * @param line_number The index of the line to configure.
	     * @param line_config An configuration object for the specified line.
	     * @throws Vex.RERR "StaveConfigError" When the specified line number is out of
	     *   range of the number of lines specified in the constructor.
	     */
	
	  }, {
	    key: 'setConfigForLine',
	    value: function setConfigForLine(line_number, line_config) {
	      if (line_number >= this.options.num_lines || line_number < 0) {
	        throw new _vex.Vex.RERR('StaveConfigError', 'The line number must be within the range of the number of lines in the Stave.');
	      }
	
	      if (line_config.visible === undefined) {
	        throw new _vex.Vex.RERR('StaveConfigError', "The line configuration object is missing the 'visible' property.");
	      }
	
	      if (typeof line_config.visible !== 'boolean') {
	        throw new _vex.Vex.RERR('StaveConfigError', "The line configuration objects 'visible' property must be true or false.");
	      }
	
	      this.options.line_config[line_number] = line_config;
	
	      return this;
	    }
	
	    /**
	     * Set the staff line configuration array for all of the lines at once.
	     * @param lines_configuration An array of line configuration objects.  These objects
	     *   are of the same format as the single one passed in to setLineConfiguration().
	     *   The caller can set null for any line config entry if it is desired that the default be used
	     * @throws Vex.RERR "StaveConfigError" When the lines_configuration array does not have
	     *   exactly the same number of elements as the num_lines configuration object set in
	     *   the constructor.
	     */
	
	  }, {
	    key: 'setConfigForLines',
	    value: function setConfigForLines(lines_configuration) {
	      if (lines_configuration.length !== this.options.num_lines) {
	        throw new _vex.Vex.RERR('StaveConfigError', 'The length of the lines configuration array must match the number of lines in the Stave');
	      }
	
	      // Make sure the defaults are present in case an incomplete set of
	      //  configuration options were supplied.
	      for (var line_config in lines_configuration) {
	        // Allow 'null' to be used if the caller just wants the default for a particular node.
	        if (!lines_configuration[line_config]) {
	          lines_configuration[line_config] = this.options.line_config[line_config];
	        }
	        _vex.Vex.Merge(this.options.line_config[line_config], lines_configuration[line_config]);
	      }
	
	      this.options.line_config = lines_configuration;
	
	      return this;
	    }
	  }]);

	  return Stave;
	}(_element.Element);

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Barline = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tables = __webpack_require__(2);
	
	var _stavemodifier = __webpack_require__(45);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// Author Larry Kuhns 2011
	
	var Barline = exports.Barline = function (_StaveModifier) {
	  _inherits(Barline, _StaveModifier);
	
	  _createClass(Barline, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'barlines';
	    }
	  }, {
	    key: 'type',
	    get: function get() {
	      return {
	        SINGLE: 1,
	        DOUBLE: 2,
	        END: 3,
	        REPEAT_BEGIN: 4,
	        REPEAT_END: 5,
	        REPEAT_BOTH: 6,
	        NONE: 7
	      };
	    }
	  }, {
	    key: 'typeString',
	    get: function get() {
	      return {
	        single: Barline.type.SINGLE,
	        double: Barline.type.DOUBLE,
	        end: Barline.type.END,
	        repeatBegin: Barline.type.REPEAT_BEGIN,
	        repeatEnd: Barline.type.REPEAT_END,
	        repeatBoth: Barline.type.REPEAT_BOTH,
	        none: Barline.type.NONE
	      };
	    }
	
	    /**
	     * @constructor
	     */
	
	  }]);
	
	  function Barline(type) {
	    _classCallCheck(this, Barline);
	
	    var _this = _possibleConstructorReturn(this, (Barline.__proto__ || Object.getPrototypeOf(Barline)).call(this));
	
	    _this.setAttribute('type', 'Barline');
	    _this.thickness = _tables.Flow.STAVE_LINE_THICKNESS;
	
	    var TYPE = Barline.type;
	    _this.widths = {};
	    _this.widths[TYPE.SINGLE] = 5;
	    _this.widths[TYPE.DOUBLE] = 5;
	    _this.widths[TYPE.END] = 5;
	    _this.widths[TYPE.REPEAT_BEGIN] = 5;
	    _this.widths[TYPE.REPEAT_END] = 5;
	    _this.widths[TYPE.REPEAT_BOTH] = 5;
	    _this.widths[TYPE.NONE] = 5;
	
	    _this.paddings = {};
	    _this.paddings[TYPE.SINGLE] = 0;
	    _this.paddings[TYPE.DOUBLE] = 0;
	    _this.paddings[TYPE.END] = 0;
	    _this.paddings[TYPE.REPEAT_BEGIN] = 15;
	    _this.paddings[TYPE.REPEAT_END] = 15;
	    _this.paddings[TYPE.REPEAT_BOTH] = 15;
	    _this.paddings[TYPE.NONE] = 0;
	
	    _this.setPosition(_stavemodifier.StaveModifier.Position.BEGIN);
	    _this.setType(type);
	    return _this;
	  }
	
	  _createClass(Barline, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Barline.CATEGORY;
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.type;
	    }
	  }, {
	    key: 'setType',
	    value: function setType(type) {
	      this.type = typeof type === 'string' ? Barline.typeString[type] : type;
	
	      this.setWidth(this.widths[this.type]);
	      this.setPadding(this.paddings[this.type]);
	      return this;
	    }
	
	    // Draw barlines
	
	  }, {
	    key: 'draw',
	    value: function draw(stave) {
	      stave.checkContext();
	      this.setRendered();
	
	      switch (this.type) {
	        case Barline.type.SINGLE:
	          this.drawVerticalBar(stave, this.x, false);
	          break;
	        case Barline.type.DOUBLE:
	          this.drawVerticalBar(stave, this.x, true);
	          break;
	        case Barline.type.END:
	          this.drawVerticalEndBar(stave, this.x);
	          break;
	        case Barline.type.REPEAT_BEGIN:
	          // If the barline is shifted over (in front of clef/time/key)
	          // Draw vertical bar at the beginning.
	          this.drawRepeatBar(stave, this.x, true);
	          if (stave.getX() !== this.x) {
	            this.drawVerticalBar(stave, stave.getX());
	          }
	
	          break;
	        case Barline.type.REPEAT_END:
	          this.drawRepeatBar(stave, this.x, false);
	          break;
	        case Barline.type.REPEAT_BOTH:
	          this.drawRepeatBar(stave, this.x, false);
	          this.drawRepeatBar(stave, this.x, true);
	          break;
	        default:
	          // Default is NONE, so nothing to draw
	          break;
	      }
	    }
	  }, {
	    key: 'drawVerticalBar',
	    value: function drawVerticalBar(stave, x, double_bar) {
	      stave.checkContext();
	      var topY = stave.getTopLineTopY();
	      var botY = stave.getBottomLineBottomY();
	      if (double_bar) {
	        stave.context.fillRect(x - 3, topY, 1, botY - topY);
	      }
	      stave.context.fillRect(x, topY, 1, botY - topY);
	    }
	  }, {
	    key: 'drawVerticalEndBar',
	    value: function drawVerticalEndBar(stave, x) {
	      stave.checkContext();
	      var topY = stave.getTopLineTopY();
	      var botY = stave.getBottomLineBottomY();
	      stave.context.fillRect(x - 5, topY, 1, botY - topY);
	      stave.context.fillRect(x - 2, topY, 3, botY - topY);
	    }
	  }, {
	    key: 'drawRepeatBar',
	    value: function drawRepeatBar(stave, x, begin) {
	      stave.checkContext();
	
	      var topY = stave.getTopLineTopY();
	      var botY = stave.getBottomLineBottomY();
	      var x_shift = 3;
	
	      if (!begin) {
	        x_shift = -5;
	      }
	
	      stave.context.fillRect(x + x_shift, topY, 1, botY - topY);
	      stave.context.fillRect(x - 2, topY, 3, botY - topY);
	
	      var dot_radius = 2;
	
	      // Shift dots left or right
	      if (begin) {
	        x_shift += 4;
	      } else {
	        x_shift -= 4;
	      }
	
	      var dot_x = x + x_shift + dot_radius / 2;
	
	      // calculate the y offset based on number of stave lines
	      var y_offset = (stave.getNumLines() - 1) * stave.getSpacingBetweenLines();
	      y_offset = y_offset / 2 - stave.getSpacingBetweenLines() / 2;
	      var dot_y = topY + y_offset + dot_radius / 2;
	
	      // draw the top repeat dot
	      stave.context.beginPath();
	      stave.context.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
	      stave.context.fill();
	
	      // draw the bottom repeat dot
	      dot_y += stave.getSpacingBetweenLines();
	      stave.context.beginPath();
	      stave.context.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
	      stave.context.fill();
	    }
	  }]);

	  return Barline;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveModifier = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _element = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// A base class for stave modifiers (e.g. clefs, key signatures)
	
	var StaveModifier = exports.StaveModifier = function (_Element) {
	  _inherits(StaveModifier, _Element);
	
	  _createClass(StaveModifier, null, [{
	    key: 'Position',
	    get: function get() {
	      return {
	        LEFT: 1,
	        RIGHT: 2,
	        ABOVE: 3,
	        BELOW: 4,
	        BEGIN: 5,
	        END: 6
	      };
	    }
	  }]);
	
	  function StaveModifier() {
	    _classCallCheck(this, StaveModifier);
	
	    var _this = _possibleConstructorReturn(this, (StaveModifier.__proto__ || Object.getPrototypeOf(StaveModifier)).call(this));
	
	    _this.setAttribute('type', 'StaveModifier');
	
	    _this.padding = 10;
	    _this.position = StaveModifier.Position.ABOVE;
	    return _this;
	  }
	
	  _createClass(StaveModifier, [{
	    key: 'getPosition',
	    value: function getPosition() {
	      return this.position;
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(position) {
	      this.position = position;return this;
	    }
	  }, {
	    key: 'getStave',
	    value: function getStave() {
	      return this.stave;
	    }
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      this.stave = stave;return this;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.width;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(width) {
	      this.width = width;return this;
	    }
	  }, {
	    key: 'getX',
	    value: function getX() {
	      return this.x;
	    }
	  }, {
	    key: 'setX',
	    value: function setX(x) {
	      this.x = x;return this;
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return '';
	    }
	  }, {
	    key: 'makeSpacer',
	    value: function makeSpacer(padding) {
	      // TODO(0xfe): Return an instance of type `Spacer` based on `GhostNote`
	      // instead of this hack.
	
	      return {
	        getContext: function getContext() {
	          return true;
	        },
	        setStave: function setStave() {},
	        renderToStave: function renderToStave() {},
	        getMetrics: function getMetrics() {
	          return { width: padding };
	        }
	      };
	    }
	  }, {
	    key: 'placeGlyphOnLine',
	    value: function placeGlyphOnLine(glyph, stave, line) {
	      glyph.setYShift(stave.getYForLine(line) - stave.getYForGlyphs());
	    }
	  }, {
	    key: 'getPadding',
	    value: function getPadding(index) {
	      return index !== undefined && index < 2 ? 0 : this.padding;
	    }
	  }, {
	    key: 'setPadding',
	    value: function setPadding(padding) {
	      this.padding = padding;return this;
	    }
	  }]);

	  return StaveModifier;
	}(_element.Element);

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Repetition = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stavemodifier = __webpack_require__(45);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Larry Kuhns 2011
	
	var Repetition = exports.Repetition = function (_StaveModifier) {
	  _inherits(Repetition, _StaveModifier);
	
	  _createClass(Repetition, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'repetitions';
	    }
	  }, {
	    key: 'type',
	    get: function get() {
	      return {
	        NONE: 1, // no coda or segno
	        CODA_LEFT: 2, // coda at beginning of stave
	        CODA_RIGHT: 3, // coda at end of stave
	        SEGNO_LEFT: 4, // segno at beginning of stave
	        SEGNO_RIGHT: 5, // segno at end of stave
	        DC: 6, // D.C. at end of stave
	        DC_AL_CODA: 7, // D.C. al coda at end of stave
	        DC_AL_FINE: 8, // D.C. al Fine end of stave
	        DS: 9, // D.S. at end of stave
	        DS_AL_CODA: 10, // D.S. al coda at end of stave
	        DS_AL_FINE: 11, // D.S. al Fine at end of stave
	        FINE: 12 };
	    }
	  }]);
	
	  function Repetition(type, x, y_shift) {
	    _classCallCheck(this, Repetition);
	
	    var _this = _possibleConstructorReturn(this, (Repetition.__proto__ || Object.getPrototypeOf(Repetition)).call(this));
	
	    _this.setAttribute('type', 'Repetition');
	
	    _this.symbol_type = type;
	    _this.x = x;
	    _this.x_shift = 0;
	    _this.y_shift = y_shift;
	    _this.font = {
	      family: 'times',
	      size: 12,
	      weight: 'bold italic'
	    };
	    return _this;
	  }
	
	  _createClass(Repetition, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Repetition.CATEGORY;
	    }
	  }, {
	    key: 'setShiftX',
	    value: function setShiftX(x) {
	      this.x_shift = x;return this;
	    }
	  }, {
	    key: 'setShiftY',
	    value: function setShiftY(y) {
	      this.y_shift = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(stave, x) {
	      this.setRendered();
	
	      switch (this.symbol_type) {
	        case Repetition.type.CODA_RIGHT:
	          this.drawCodaFixed(stave, x + stave.width);
	          break;
	        case Repetition.type.CODA_LEFT:
	          this.drawSymbolText(stave, x, 'Coda', true);
	          break;
	        case Repetition.type.SEGNO_LEFT:
	          this.drawSignoFixed(stave, x);
	          break;
	        case Repetition.type.SEGNO_RIGHT:
	          this.drawSignoFixed(stave, x + stave.width);
	          break;
	        case Repetition.type.DC:
	          this.drawSymbolText(stave, x, 'D.C.', false);
	          break;
	        case Repetition.type.DC_AL_CODA:
	          this.drawSymbolText(stave, x, 'D.C. al', true);
	          break;
	        case Repetition.type.DC_AL_FINE:
	          this.drawSymbolText(stave, x, 'D.C. al Fine', false);
	          break;
	        case Repetition.type.DS:
	          this.drawSymbolText(stave, x, 'D.S.', false);
	          break;
	        case Repetition.type.DS_AL_CODA:
	          this.drawSymbolText(stave, x, 'D.S. al', true);
	          break;
	        case Repetition.type.DS_AL_FINE:
	          this.drawSymbolText(stave, x, 'D.S. al Fine', false);
	          break;
	        case Repetition.type.FINE:
	          this.drawSymbolText(stave, x, 'Fine', false);
	          break;
	        default:
	          break;
	      }
	
	      return this;
	    }
	  }, {
	    key: 'drawCodaFixed',
	    value: function drawCodaFixed(stave, x) {
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      _glyph.Glyph.renderGlyph(stave.context, this.x + x + this.x_shift, y + 25, 40, 'v4d', true);
	      return this;
	    }
	  }, {
	    key: 'drawSignoFixed',
	    value: function drawSignoFixed(stave, x) {
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      _glyph.Glyph.renderGlyph(stave.context, this.x + x + this.x_shift, y + 25, 30, 'v8c', true);
	      return this;
	    }
	  }, {
	    key: 'drawSymbolText',
	    value: function drawSymbolText(stave, x, text, draw_coda) {
	      var ctx = stave.checkContext();
	
	      ctx.save();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      // Default to right symbol
	      var text_x = 0 + this.x_shift;
	      var symbol_x = x + this.x_shift;
	      if (this.symbol_type === Repetition.type.CODA_LEFT) {
	        // Offset Coda text to right of stave beginning
	        text_x = this.x + stave.options.vertical_bar_width;
	        symbol_x = text_x + ctx.measureText(text).width + 12;
	      } else {
	        // Offset Signo text to left stave end
	        symbol_x = this.x + x + stave.width - 5 + this.x_shift;
	        text_x = symbol_x - +ctx.measureText(text).width - 12;
	      }
	
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      if (draw_coda) {
	        _glyph.Glyph.renderGlyph(ctx, symbol_x, y, 40, 'v4d', true);
	      }
	
	      ctx.fillText(text, text_x, y + 5);
	      ctx.restore();
	
	      return this;
	    }
	  }]);

	  return Repetition;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveSection = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stavemodifier = __webpack_require__(45);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Larry Kuhns 2011
	
	var StaveSection = exports.StaveSection = function (_StaveModifier) {
	  _inherits(StaveSection, _StaveModifier);
	
	  _createClass(StaveSection, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stavesection';
	    }
	  }]);
	
	  function StaveSection(section, x, shift_y) {
	    _classCallCheck(this, StaveSection);
	
	    var _this = _possibleConstructorReturn(this, (StaveSection.__proto__ || Object.getPrototypeOf(StaveSection)).call(this));
	
	    _this.setAttribute('type', 'StaveSection');
	
	    _this.setWidth(16);
	    _this.section = section;
	    _this.x = x;
	    _this.shift_x = 0;
	    _this.shift_y = shift_y;
	    _this.font = {
	      family: 'sans-serif',
	      size: 12,
	      weight: 'bold'
	    };
	    return _this;
	  }
	
	  _createClass(StaveSection, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return StaveSection.CATEGORY;
	    }
	  }, {
	    key: 'setStaveSection',
	    value: function setStaveSection(section) {
	      this.section = section;return this;
	    }
	  }, {
	    key: 'setShiftX',
	    value: function setShiftX(x) {
	      this.shift_x = x;return this;
	    }
	  }, {
	    key: 'setShiftY',
	    value: function setShiftY(y) {
	      this.shift_y = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(stave, shift_x) {
	      var ctx = stave.checkContext();
	      this.setRendered();
	
	      ctx.save();
	      ctx.lineWidth = 2;
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = ctx.measureText('' + this.section).width;
	      var width = text_width + 6; // add left & right padding
	      if (width < 18) width = 18;
	      var height = 20;
	      //  Seems to be a good default y
	      var y = stave.getYForTopText(3) + this.shift_y;
	      var x = this.x + shift_x;
	      ctx.beginPath();
	      ctx.lineWidth = 2;
	      ctx.rect(x, y, width, height);
	      ctx.stroke();
	      x += (width - text_width) / 2;
	      ctx.fillText('' + this.section, x, y + 16);
	      ctx.restore();
	      return this;
	    }
	  }]);

	  return StaveSection;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveTempo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Radosaw Eichler 2012
	
	var StaveTempo = exports.StaveTempo = function (_StaveModifier) {
	  _inherits(StaveTempo, _StaveModifier);
	
	  _createClass(StaveTempo, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stavetempo';
	    }
	  }]);
	
	  function StaveTempo(tempo, x, shift_y) {
	    _classCallCheck(this, StaveTempo);
	
	    var _this = _possibleConstructorReturn(this, (StaveTempo.__proto__ || Object.getPrototypeOf(StaveTempo)).call(this));
	
	    _this.setAttribute('type', 'StaveTempo');
	
	    _this.tempo = tempo;
	    _this.position = _modifier.Modifier.Position.ABOVE;
	    _this.x = x;
	    _this.shift_x = 10;
	    _this.shift_y = shift_y;
	    _this.font = {
	      family: 'times',
	      size: 14,
	      weight: 'bold'
	    };
	    _this.render_options = {
	      glyph_font_scale: 30 };
	    return _this;
	  }
	
	  _createClass(StaveTempo, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return StaveTempo.CATEGORY;
	    }
	  }, {
	    key: 'setTempo',
	    value: function setTempo(tempo) {
	      this.tempo = tempo;return this;
	    }
	  }, {
	    key: 'setShiftX',
	    value: function setShiftX(x) {
	      this.shift_x = x;return this;
	    }
	  }, {
	    key: 'setShiftY',
	    value: function setShiftY(y) {
	      this.shift_y = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(stave, shift_x) {
	      var ctx = stave.checkContext();
	      this.setRendered();
	
	      var options = this.render_options;
	      // FIXME: What does the '38' mean? Why 38? Is that supposed to
	      // be the default font size for standard notation?
	      var scale = options.glyph_font_scale / 38;
	      var name = this.tempo.name;
	      var duration = this.tempo.duration;
	      var dots = this.tempo.dots;
	      var bpm = this.tempo.bpm;
	      var font = this.font;
	      var x = this.x + this.shift_x + shift_x;
	      var y = stave.getYForTopText(1) + this.shift_y;
	
	      ctx.save();
	
	      if (name) {
	        ctx.setFont(font.family, font.size, font.weight);
	        ctx.fillText(name, x, y);
	        x += ctx.measureText(name).width;
	      }
	
	      if (duration && bpm) {
	        ctx.setFont(font.family, font.size, 'normal');
	
	        if (name) {
	          x += ctx.measureText(' ').width;
	          ctx.fillText('(', x, y);
	          x += ctx.measureText('(').width;
	        }
	
	        var code = _tables.Flow.durationToGlyph(duration);
	
	        x += 3 * scale;
	        _glyph.Glyph.renderGlyph(ctx, x, y, options.glyph_font_scale, code.code_head);
	        x += code.getWidth() * scale;
	
	        // Draw stem and flags
	        if (code.stem) {
	          var stem_height = 30;
	
	          if (code.beam_count) stem_height += 3 * (code.beam_count - 1);
	
	          stem_height *= scale;
	
	          var y_top = y - stem_height;
	          ctx.fillRect(x - scale, y_top, scale, stem_height);
	
	          if (code.flag) {
	            _glyph.Glyph.renderGlyph(ctx, x, y_top, options.glyph_font_scale, code.code_flag_upstem);
	
	            if (!dots) x += 6 * scale;
	          }
	        }
	
	        // Draw dot
	        for (var i = 0; i < dots; i++) {
	          x += 6 * scale;
	          ctx.beginPath();
	          ctx.arc(x, y + 2 * scale, 2 * scale, 0, Math.PI * 2, false);
	          ctx.fill();
	        }
	
	        ctx.fillText(' = ' + bpm + (name ? ')' : ''), x + 3 * scale, y);
	      }
	
	      ctx.restore();
	      return this;
	    }
	  }]);

	  return StaveTempo;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveText = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _textnote = __webpack_require__(50);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Taehoon Moon 2014
	
	var StaveText = exports.StaveText = function (_StaveModifier) {
	  _inherits(StaveText, _StaveModifier);
	
	  _createClass(StaveText, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'stavetext';
	    }
	  }]);
	
	  function StaveText(text, position, options) {
	    _classCallCheck(this, StaveText);
	
	    var _this = _possibleConstructorReturn(this, (StaveText.__proto__ || Object.getPrototypeOf(StaveText)).call(this));
	
	    _this.setAttribute('type', 'StaveText');
	
	    _this.setWidth(16);
	    _this.text = text;
	    _this.position = position;
	    _this.options = {
	      shift_x: 0,
	      shift_y: 0,
	      justification: _textnote.TextNote.Justification.CENTER
	    };
	    _vex.Vex.Merge(_this.options, options);
	
	    _this.font = {
	      family: 'times',
	      size: 16,
	      weight: 'normal'
	    };
	    return _this;
	  }
	
	  _createClass(StaveText, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return StaveText.CATEGORY;
	    }
	  }, {
	    key: 'setStaveText',
	    value: function setStaveText(text) {
	      this.text = text;return this;
	    }
	  }, {
	    key: 'setShiftX',
	    value: function setShiftX(x) {
	      this.shift_x = x;return this;
	    }
	  }, {
	    key: 'setShiftY',
	    value: function setShiftY(y) {
	      this.shift_y = y;return this;
	    }
	  }, {
	    key: 'setFont',
	    value: function setFont(font) {
	      _vex.Vex.Merge(this.font, font);
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      this.text = text;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(stave) {
	      var ctx = stave.checkContext();
	      this.setRendered();
	
	      ctx.save();
	      ctx.lineWidth = 2;
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = ctx.measureText('' + this.text).width;
	
	      var x = void 0;
	      var y = void 0;
	      var Position = _stavemodifier.StaveModifier.Position;
	      var Justification = _textnote.TextNote.Justification;
	      switch (this.position) {
	        case Position.LEFT:
	        case Position.RIGHT:
	          y = (stave.getYForLine(0) + stave.getBottomLineY()) / 2 + this.options.shift_y;
	          if (this.position === Position.LEFT) {
	            x = stave.getX() - text_width - 24 + this.options.shift_x;
	          } else {
	            x = stave.getX() + stave.getWidth() + 24 + this.options.shift_x;
	          }
	          break;
	        case Position.ABOVE:
	        case Position.BELOW:
	          x = stave.getX() + this.options.shift_x;
	          if (this.options.justification === Justification.CENTER) {
	            x += stave.getWidth() / 2 - text_width / 2;
	          } else if (this.options.justification === Justification.RIGHT) {
	            x += stave.getWidth() - text_width;
	          }
	
	          if (this.position === Position.ABOVE) {
	            y = stave.getYForTopText(2) + this.options.shift_y;
	          } else {
	            y = stave.getYForBottomText(2) + this.options.shift_y;
	          }
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidPosition', 'Value Must be in Modifier.Position.');
	      }
	
	      ctx.fillText('' + this.text, x, y + 4);
	      ctx.restore();
	      return this;
	    }
	  }]);

	  return StaveText;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextNote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _note = __webpack_require__(22);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// `TextNote` is a notation element that is positioned in time. Generally
	// meant for objects that sit above/below the staff and inline with each other.
	// Examples of this would be such as dynamics, lyrics, chord changes, etc.
	
	var TextNote = exports.TextNote = function (_Note) {
	  _inherits(TextNote, _Note);
	
	  _createClass(TextNote, null, [{
	    key: 'Justification',
	    get: function get() {
	      return {
	        LEFT: 1,
	        CENTER: 2,
	        RIGHT: 3
	      };
	    }
	
	    // Glyph data
	
	  }, {
	    key: 'GLYPHS',
	    get: function get() {
	      return {
	        'segno': {
	          code: 'v8c',
	          point: 40,
	          x_shift: 0,
	          y_shift: -10
	        },
	        'tr': {
	          code: 'v1f',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'mordent_upper': {
	          code: 'v1e',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'mordent_lower': {
	          code: 'v45',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'f': {
	          code: 'vba',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'p': {
	          code: 'vbf',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'm': {
	          code: 'v62',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        's': {
	          code: 'v4a',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'z': {
	          code: 'v80',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'coda': {
	          code: 'v4d',
	          point: 40,
	          x_shift: 0,
	          y_shift: -8
	        },
	        'pedal_open': {
	          code: 'v36',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'pedal_close': {
	          code: 'v5d',
	          point: 40,
	          x_shift: 0,
	          y_shift: 3
	        },
	        'caesura_straight': {
	          code: 'v34',
	          point: 40,
	          x_shift: 0,
	          y_shift: 2
	        },
	        'caesura_curved': {
	          code: 'v4b',
	          point: 40,
	          x_shift: 0,
	          y_shift: 2
	        },
	        'breath': {
	          code: 'v6c',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'tick': {
	          code: 'v6f',
	          point: 50,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'turn': {
	          code: 'v72',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	        'turn_inverted': {
	          code: 'v33',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        },
	
	        // DEPRECATED - please use "mordent_upper" or "mordent_lower"
	        'mordent': {
	          code: 'v1e',
	          point: 40,
	          x_shift: 0,
	          y_shift: 0
	        }
	      };
	    }
	  }]);
	
	  function TextNote(text_struct) {
	    _classCallCheck(this, TextNote);
	
	    var _this = _possibleConstructorReturn(this, (TextNote.__proto__ || Object.getPrototypeOf(TextNote)).call(this, text_struct));
	
	    _this.setAttribute('type', 'TextNote');
	
	    // Note properties
	    _this.text = text_struct.text;
	    _this.superscript = text_struct.superscript;
	    _this.subscript = text_struct.subscript;
	    _this.glyph_type = text_struct.glyph;
	    _this.glyph = null;
	    _this.font = {
	      family: 'Arial',
	      size: 12,
	      weight: ''
	    };
	
	    // Set font
	    if (text_struct.font) _this.font = text_struct.font;
	
	    // Determine and set initial note width. Note that the text width is
	    // an approximation and isn't very accurate. The only way to accurately
	    // measure the length of text is with `canvasmeasureText()`
	    if (_this.glyph_type) {
	      var struct = TextNote.GLYPHS[_this.glyph_type];
	      if (!struct) throw new _vex.Vex.RERR('Invalid glyph type: ' + _this.glyph_type);
	
	      _this.glyph = new _glyph.Glyph(struct.code, struct.point, { cache: false });
	
	      if (struct.width) {
	        _this.setWidth(struct.width);
	      } else {
	        _this.setWidth(_this.glyph.getMetrics().width);
	      }
	
	      _this.glyph_struct = struct;
	    } else {
	      _this.setWidth(_tables.Flow.textWidth(_this.text));
	    }
	    _this.line = text_struct.line || 0;
	    _this.smooth = text_struct.smooth || false;
	    _this.ignore_ticks = text_struct.ignore_ticks || false;
	    _this.justification = TextNote.Justification.LEFT;
	    return _this;
	  }
	
	  // Set the horizontal justification of the TextNote
	
	
	  _createClass(TextNote, [{
	    key: 'setJustification',
	    value: function setJustification(just) {
	      this.justification = just;
	      return this;
	    }
	
	    // Set the Stave line on which the note should be placed
	
	  }, {
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;
	      return this;
	    }
	
	    // Pre-render formatting
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      this.checkContext();
	
	      if (this.preFormatted) return;
	
	      if (this.smooth) {
	        this.setWidth(0);
	      } else {
	        if (this.glyph) {
	          // Width already set.
	        } else {
	          this.setWidth(this.context.measureText(this.text).width);
	        }
	      }
	
	      if (this.justification === TextNote.Justification.CENTER) {
	        this.extraLeftPx = this.width / 2;
	      } else if (this.justification === TextNote.Justification.RIGHT) {
	        this.extraLeftPx = this.width;
	      }
	
	      this.setPreFormatted(true);
	    }
	
	    // Renders the TextNote
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	      }
	
	      this.setRendered();
	      var ctx = this.context;
	      var x = this.getAbsoluteX();
	      if (this.justification === TextNote.Justification.CENTER) {
	        x -= this.getWidth() / 2;
	      } else if (this.justification === TextNote.Justification.RIGHT) {
	        x -= this.getWidth();
	      }
	
	      var y = void 0;
	      if (this.glyph) {
	        y = this.stave.getYForLine(this.line + -3);
	        this.glyph.render(this.context, x + this.glyph_struct.x_shift, y + this.glyph_struct.y_shift);
	      } else {
	        y = this.stave.getYForLine(this.line + -3);
	        ctx.save();
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        ctx.fillText(this.text, x, y);
	
	        // Width of the letter M gives us the approximate height of the text
	        var height = ctx.measureText('M').width;
	        // Get accurate width of text
	        var width = ctx.measureText(this.text).width;
	
	        // Write superscript
	        if (this.superscript) {
	          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
	          ctx.fillText(this.superscript, x + width + 2, y - height / 2.2);
	        }
	
	        // Write subscript
	        if (this.subscript) {
	          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
	          ctx.fillText(this.subscript, x + width + 2, y + height / 2.2 - 1);
	        }
	
	        ctx.restore();
	      }
	    }
	  }]);

	  return TextNote;
	}(_note.Note);

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Clef = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna Cheppudira 2013.
	// Co-author: Benjamin W. Bohl
	//
	// ## Description
	//
	// This file implements various types of clefs that can be rendered on a stave.
	//
	// See `tests/clef_tests.js` for usage examples.
	
	// To enable logging for this class, set `Vex.Flow.Clef.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Clef.DEBUG) _vex.Vex.L('Vex.Flow.Clef', args);
	}
	
	var Clef = exports.Clef = function (_StaveModifier) {
	  _inherits(Clef, _StaveModifier);
	
	  _createClass(Clef, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'clefs';
	    }
	
	    // Every clef name is associated with a glyph code from the font file
	    // and a default stave line number.
	
	  }, {
	    key: 'types',
	    get: function get() {
	      return {
	        'treble': {
	          code: 'v83',
	          line: 3
	        },
	        'bass': {
	          code: 'v79',
	          line: 1
	        },
	        'alto': {
	          code: 'vad',
	          line: 2
	        },
	        'tenor': {
	          code: 'vad',
	          line: 1
	        },
	        'percussion': {
	          code: 'v59',
	          line: 2
	        },
	        'soprano': {
	          code: 'vad',
	          line: 4
	        },
	        'mezzo-soprano': {
	          code: 'vad',
	          line: 3
	        },
	        'baritone-c': {
	          code: 'vad',
	          line: 0
	        },
	        'baritone-f': {
	          code: 'v79',
	          line: 2
	        },
	        'subbass': {
	          code: 'v79',
	          line: 0
	        },
	        'french': {
	          code: 'v83',
	          line: 4
	        },
	        'tab': {
	          code: 'v2f'
	        }
	      };
	    }
	
	    // Sizes affect the point-size of the clef.
	
	  }, {
	    key: 'sizes',
	    get: function get() {
	      return {
	        'default': 40,
	        'small': 32
	      };
	    }
	
	    // Annotations attach to clefs -- such as "8" for octave up or down.
	
	  }, {
	    key: 'annotations',
	    get: function get() {
	      return {
	        '8va': {
	          code: 'v8',
	          sizes: {
	            'default': {
	              point: 20,
	              attachments: {
	                'treble': {
	                  line: -1.2,
	                  x_shift: 11
	                }
	              }
	            },
	            'small': {
	              point: 18,
	              attachments: {
	                'treble': {
	                  line: -0.4,
	                  x_shift: 8
	                }
	              }
	            }
	          }
	        },
	        '8vb': {
	          code: 'v8',
	          sizes: {
	            'default': {
	              point: 20,
	              attachments: {
	                'treble': {
	                  line: 6.3,
	                  x_shift: 10
	                },
	                'bass': {
	                  line: 4,
	                  x_shift: 1
	                }
	              }
	            },
	            'small': {
	              point: 18,
	              attachments: {
	                'treble': {
	                  line: 5.8,
	                  x_shift: 6
	                },
	                'bass': {
	                  line: 3.5,
	                  x_shift: 0.5
	                }
	              }
	            }
	          }
	        }
	      };
	    }
	
	    // Create a new clef. The parameter `clef` must be a key from
	    // `Clef.types`.
	
	  }]);
	
	  function Clef(type, size, annotation) {
	    _classCallCheck(this, Clef);
	
	    var _this = _possibleConstructorReturn(this, (Clef.__proto__ || Object.getPrototypeOf(Clef)).call(this));
	
	    _this.setAttribute('type', 'Clef');
	
	    _this.setPosition(_stavemodifier.StaveModifier.Position.BEGIN);
	    _this.setType(type, size, annotation);
	    _this.setWidth(_this.glyph.getMetrics().width);
	    L('Creating clef:', type);
	    return _this;
	  }
	
	  _createClass(Clef, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Clef.CATEGORY;
	    }
	  }, {
	    key: 'setType',
	    value: function setType(type, size, annotation) {
	      this.type = type;
	      this.clef = Clef.types[type];
	      if (size === undefined) {
	        this.size = 'default';
	      } else {
	        this.size = size;
	      }
	      this.clef.point = Clef.sizes[this.size];
	      this.glyph = new _glyph.Glyph(this.clef.code, this.clef.point);
	
	      // If an annotation, such as 8va, is specified, add it to the Clef object.
	      if (annotation !== undefined) {
	        var anno_dict = Clef.annotations[annotation];
	        this.annotation = {
	          code: anno_dict.code,
	          point: anno_dict.sizes[this.size].point,
	          line: anno_dict.sizes[this.size].attachments[this.type].line,
	          x_shift: anno_dict.sizes[this.size].attachments[this.type].x_shift
	        };
	
	        this.attachment = new _glyph.Glyph(this.annotation.code, this.annotation.point);
	        this.attachment.metrics.x_max = 0;
	        this.attachment.setXShift(this.annotation.x_shift);
	      } else {
	        this.annotation = undefined;
	      }
	
	      return this;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      if (this.type === 'tab' && !this.stave) {
	        throw new _vex.Vex.RERR('ClefError', "Can't get width without stave.");
	      }
	
	      return this.width;
	    }
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      this.stave = stave;
	
	      if (this.type !== 'tab') return this;
	
	      var glyphScale = void 0;
	      var glyphOffset = void 0;
	      var numLines = this.stave.getOptions().num_lines;
	      switch (numLines) {
	        case 8:
	          glyphScale = 55;
	          glyphOffset = 14;
	          break;
	        case 7:
	          glyphScale = 47;
	          glyphOffset = 8;
	          break;
	        case 6:
	          glyphScale = 40;
	          glyphOffset = 1;
	          break;
	        case 5:
	          glyphScale = 30;
	          glyphOffset = -6;
	          break;
	        case 4:
	          glyphScale = 23;
	          glyphOffset = -12;
	          break;
	        default:
	          throw new _vex.Vex.RERR('ClefError', 'Invalid number of lines: ' + numLines);
	      }
	
	      this.glyph.setPoint(glyphScale);
	      this.glyph.setYShift(glyphOffset);
	
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.x) throw new _vex.Vex.RERR('ClefError', "Can't draw clef without x.");
	      if (!this.stave) throw new _vex.Vex.RERR('ClefError', "Can't draw clef without stave.");
	      this.setRendered();
	
	      this.glyph.setStave(this.stave);
	      this.glyph.setContext(this.stave.context);
	      if (this.clef.line !== undefined) {
	        this.placeGlyphOnLine(this.glyph, this.stave, this.clef.line);
	      }
	
	      this.glyph.renderToStave(this.x);
	
	      if (this.annotation !== undefined) {
	        this.placeGlyphOnLine(this.attachment, this.stave, this.annotation.line);
	        this.attachment.setStave(this.stave);
	        this.attachment.setContext(this.stave.context);
	        this.attachment.renderToStave(this.x);
	      }
	    }
	  }]);

	  return Clef;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KeySignature = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _stavemodifier = __webpack_require__(45);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implements key signatures. A key signature sits on a stave
	// and indicates the notes with implicit accidentals.
	
	var KeySignature = exports.KeySignature = function (_StaveModifier) {
	  _inherits(KeySignature, _StaveModifier);
	
	  _createClass(KeySignature, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'keysignatures';
	    }
	
	    // Space between natural and following accidental depending
	    // on vertical position
	
	  }, {
	    key: 'accidentalSpacing',
	    get: function get() {
	      return {
	        '#': {
	          above: 6,
	          below: 4
	        },
	        'b': {
	          above: 4,
	          below: 7
	        },
	        'n': {
	          above: 4,
	          below: 1
	        },
	        '##': {
	          above: 6,
	          below: 4
	        },
	        'bb': {
	          above: 4,
	          below: 7
	        },
	        'db': {
	          above: 4,
	          below: 7
	        },
	        'd': {
	          above: 4,
	          below: 7
	        },
	        'bbs': {
	          above: 4,
	          below: 7
	        },
	        '++': {
	          above: 6,
	          below: 4
	        },
	        '+': {
	          above: 6,
	          below: 4
	        },
	        '+-': {
	          above: 6,
	          below: 4
	        },
	        '++-': {
	          above: 6,
	          below: 4
	        },
	        'bs': {
	          above: 4,
	          below: 10
	        },
	        'bss': {
	          above: 4,
	          below: 10
	        }
	      };
	    }
	
	    // Create a new Key Signature based on a `key_spec`
	
	  }]);
	
	  function KeySignature(keySpec, cancelKeySpec, alterKeySpec) {
	    _classCallCheck(this, KeySignature);
	
	    var _this = _possibleConstructorReturn(this, (KeySignature.__proto__ || Object.getPrototypeOf(KeySignature)).call(this));
	
	    _this.setAttribute('type', 'KeySignature');
	
	    _this.setKeySig(keySpec, cancelKeySpec, alterKeySpec);
	    _this.setPosition(_stavemodifier.StaveModifier.Position.BEGIN);
	    _this.glyphFontScale = 38; // TODO(0xFE): Should this match StaveNote?
	    _this.glyphs = [];
	    _this.xPositions = []; // relative to this.x
	    _this.paddingForced = false;
	    return _this;
	  }
	
	  _createClass(KeySignature, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return KeySignature.CATEGORY;
	    }
	
	    // Add an accidental glyph to the `KeySignature` instance which represents
	    // the provided `acc`. If `nextAcc` is also provided, the appropriate
	    // spacing will be included in the glyph's position
	
	  }, {
	    key: 'convertToGlyph',
	    value: function convertToGlyph(acc, nextAcc) {
	      var accGlyphData = _tables.Flow.accidentalCodes(acc.type);
	      var glyph = new _glyph.Glyph(accGlyphData.code, this.glyphFontScale);
	
	      // Determine spacing between current accidental and the next accidental
	      var extraWidth = 1;
	      if (acc.type === 'n' && nextAcc) {
	        var spacing = KeySignature.accidentalSpacing[nextAcc.type];
	        if (spacing) {
	          var isAbove = nextAcc.line >= acc.line;
	          extraWidth = isAbove ? spacing.above : spacing.below;
	        }
	      }
	
	      // Place the glyph on the stave
	      this.placeGlyphOnLine(glyph, this.stave, acc.line);
	      this.glyphs.push(glyph);
	
	      var xPosition = this.xPositions[this.xPositions.length - 1];
	      var glyphWidth = glyph.getMetrics().width + extraWidth;
	      // Store the next accidental's x position
	      this.xPositions.push(xPosition + glyphWidth);
	      // Expand size of key signature
	      this.width += glyphWidth;
	    }
	
	    // Cancel out a key signature provided in the `spec` parameter. This will
	    // place appropriate natural accidentals before the key signature.
	
	  }, {
	    key: 'cancelKey',
	    value: function cancelKey(spec) {
	      this.formatted = false;
	      this.cancelKeySpec = spec;
	
	      return this;
	    }
	  }, {
	    key: 'convertToCancelAccList',
	    value: function convertToCancelAccList(spec) {
	      // Get the accidental list for the cancelled key signature
	      var cancel_accList = _tables.Flow.keySignature(spec);
	
	      // If the cancelled key has a different accidental type, ie: # vs b
	      var different_types = this.accList.length > 0 && cancel_accList.length > 0 && cancel_accList[0].type !== this.accList[0].type;
	
	      // Determine how many naturals needed to add
	      var naturals = different_types ? cancel_accList.length : cancel_accList.length - this.accList.length;
	
	      // Return if no naturals needed
	      if (naturals < 1) return;
	
	      // Get the line position for each natural
	      var cancelled = [];
	      for (var i = 0; i < naturals; i++) {
	        var index = i;
	        if (!different_types) {
	          index = cancel_accList.length - naturals + i;
	        }
	
	        var acc = cancel_accList[index];
	        cancelled.push({ type: 'n', line: acc.line });
	      }
	
	      // Combine naturals with main accidental list for the key signature
	      this.accList = cancelled.concat(this.accList);
	    }
	
	    // Deprecated
	
	  }, {
	    key: 'addToStave',
	    value: function addToStave(stave) {
	      this.paddingForced = true;
	      stave.addModifier(this);
	
	      return this;
	    }
	
	    // Apply the accidental staff line placement based on the `clef` and
	    // the  accidental `type` for the key signature ('# or 'b').
	
	  }, {
	    key: 'convertAccLines',
	    value: function convertAccLines(clef, type) {
	      var offset = 0.0; // if clef === "treble"
	      var customLines = void 0; // when clef doesn't follow treble key sig shape
	
	      switch (clef) {
	        // Treble & Subbass both have offsets of 0, so are not included.
	        case 'soprano':
	          if (type === '#') customLines = [2.5, 0.5, 2, 0, 1.5, -0.5, 1];else offset = -1;
	          break;
	        case 'mezzo-soprano':
	          if (type === 'b') customLines = [0, 2, 0.5, 2.5, 1, 3, 1.5];else offset = 1.5;
	          break;
	        case 'alto':
	          offset = 0.5;
	          break;
	        case 'tenor':
	          if (type === '#') customLines = [3, 1, 2.5, 0.5, 2, 0, 1.5];else offset = -0.5;
	          break;
	        case 'baritone-f':
	        case 'baritone-c':
	          if (type === 'b') customLines = [0.5, 2.5, 1, 3, 1.5, 3.5, 2];else offset = 2;
	          break;
	        case 'bass':
	        case 'french':
	          offset = 1;
	          break;
	        default:
	          break;
	      }
	
	      // If there's a special case, assign those lines/spaces:
	      var i = void 0;
	      if (typeof customLines !== 'undefined') {
	        for (i = 0; i < this.accList.length; ++i) {
	          this.accList[i].line = customLines[i];
	        }
	      } else if (offset !== 0) {
	        for (i = 0; i < this.accList.length; ++i) {
	          this.accList[i].line += offset;
	        }
	      }
	    }
	  }, {
	    key: 'getPadding',
	    value: function getPadding(index) {
	      if (!this.formatted) this.format();
	
	      return this.glyphs.length === 0 || !this.paddingForced && index < 2 ? 0 : this.padding;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      if (!this.formatted) this.format();
	
	      return this.width;
	    }
	  }, {
	    key: 'setKeySig',
	    value: function setKeySig(keySpec, cancelKeySpec, alterKeySpec) {
	      this.formatted = false;
	      this.keySpec = keySpec;
	      this.cancelKeySpec = cancelKeySpec;
	      this.alterKeySpec = alterKeySpec;
	
	      return this;
	    }
	
	    // Alter the accidentals of a key spec one by one.
	    // Each alteration is a new accidental that replaces the
	    // original accidental (or the canceled one).
	
	  }, {
	    key: 'alterKey',
	    value: function alterKey(alterKeySpec) {
	      this.formatted = false;
	      this.alterKeySpec = alterKeySpec;
	
	      return this;
	    }
	  }, {
	    key: 'convertToAlterAccList',
	    value: function convertToAlterAccList(alterKeySpec) {
	      var max = Math.min(alterKeySpec.length, this.accList.length);
	      for (var i = 0; i < max; ++i) {
	        if (alterKeySpec[i]) {
	          this.accList[i].type = alterKeySpec[i];
	        }
	      }
	    }
	  }, {
	    key: 'format',
	    value: function format() {
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('KeySignatureError', "Can't draw key signature without stave.");
	      }
	
	      this.width = 0;
	      this.glyphs = [];
	      this.xPositions = [0]; // initialize with initial x position
	      this.accList = _tables.Flow.keySignature(this.keySpec);
	      if (this.cancelKeySpec) {
	        this.convertToCancelAccList(this.cancelKeySpec);
	      }
	      var firstAccidentalType = this.accList.length > 0 ? this.accList[0].type : null;
	      if (this.alterKeySpec) {
	        this.convertToAlterAccList(this.alterKeySpec);
	      }
	
	      if (this.accList.length > 0) {
	        this.convertAccLines(this.stave.clef, firstAccidentalType);
	        for (var i = 0; i < this.accList.length; ++i) {
	          this.convertToGlyph(this.accList[i], this.accList[i + 1]);
	        }
	      }
	
	      this.formatted = true;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.x) {
	        throw new _vex.Vex.RERR('KeySignatureError', "Can't draw key signature without x.");
	      }
	
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('KeySignatureError', "Can't draw key signature without stave.");
	      }
	
	      if (!this.formatted) this.format();
	      this.setRendered();
	
	      for (var i = 0; i < this.glyphs.length; i++) {
	        var glyph = this.glyphs[i];
	        var x = this.x + this.xPositions[i];
	        glyph.setStave(this.stave);
	        glyph.setContext(this.stave.context);
	        glyph.renderToStave(x);
	      }
	    }
	  }]);

	  return KeySignature;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeSignature = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _glyph3 = __webpack_require__(4);
	
	var _stavemodifier = __webpack_require__(45);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// Implements time signatures glyphs for staffs
	// See tables.js for the internal time signatures
	// representation
	
	var assertIsValidFraction = function assertIsValidFraction(timeSpec) {
	  var numbers = timeSpec.split('/').filter(function (number) {
	    return number !== '';
	  });
	
	  if (numbers.length !== 2) {
	    throw new _vex.Vex.RERR('BadTimeSignature', 'Invalid time spec: ' + timeSpec + '. Must be in the form "<numerator>/<denominator>"');
	  }
	
	  numbers.forEach(function (number) {
	    if (isNaN(Number(number))) {
	      throw new _vex.Vex.RERR('BadTimeSignature', 'Invalid time spec: ' + timeSpec + '. Must contain two valid numbers.');
	    }
	  });
	};
	
	var TimeSignature = exports.TimeSignature = function (_StaveModifier) {
	  _inherits(TimeSignature, _StaveModifier);
	
	  _createClass(TimeSignature, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'timesignatures';
	    }
	  }, {
	    key: 'glyphs',
	    get: function get() {
	      return {
	        'C': {
	          code: 'v41',
	          point: 40,
	          line: 2
	        },
	        'C|': {
	          code: 'vb6',
	          point: 40,
	          line: 2
	        }
	      };
	    }
	  }]);
	
	  function TimeSignature() {
	    var timeSpec = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	    var customPadding = arguments.length <= 1 || arguments[1] === undefined ? 15 : arguments[1];
	
	    _classCallCheck(this, TimeSignature);
	
	    var _this = _possibleConstructorReturn(this, (TimeSignature.__proto__ || Object.getPrototypeOf(TimeSignature)).call(this));
	
	    _this.setAttribute('type', 'TimeSignature');
	
	    if (timeSpec === null) return _possibleConstructorReturn(_this);
	
	    var padding = customPadding;
	
	    _this.point = 40;
	    _this.topLine = 2;
	    _this.bottomLine = 4;
	    _this.setPosition(_stavemodifier.StaveModifier.Position.BEGIN);
	    _this.setTimeSig(timeSpec);
	    _this.setWidth(_this.timeSig.glyph.getMetrics().width);
	    _this.setPadding(padding);
	    return _this;
	  }
	
	  _createClass(TimeSignature, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return TimeSignature.CATEGORY;
	    }
	  }, {
	    key: 'parseTimeSpec',
	    value: function parseTimeSpec(timeSpec) {
	      if (timeSpec === 'C' || timeSpec === 'C|') {
	        var _TimeSignature$glyphs = TimeSignature.glyphs[timeSpec];
	        var line = _TimeSignature$glyphs.line;
	        var code = _TimeSignature$glyphs.code;
	        var point = _TimeSignature$glyphs.point;
	
	        return {
	          line: line,
	          num: false,
	          glyph: new _glyph3.Glyph(code, point)
	        };
	      }
	
	      assertIsValidFraction(timeSpec);
	
	      var _timeSpec$split$map = timeSpec.split('/').map(function (number) {
	        return number.split('');
	      });
	
	      var _timeSpec$split$map2 = _slicedToArray(_timeSpec$split$map, 2);
	
	      var topDigits = _timeSpec$split$map2[0];
	      var botDigits = _timeSpec$split$map2[1];
	
	
	      return {
	        num: true,
	        glyph: this.makeTimeSignatureGlyph(topDigits, botDigits)
	      };
	    }
	  }, {
	    key: 'makeTimeSignatureGlyph',
	    value: function makeTimeSignatureGlyph(topDigits, botDigits) {
	      var glyph = new _glyph3.Glyph('v0', this.point);
	      glyph.topGlyphs = [];
	      glyph.botGlyphs = [];
	
	      var topWidth = 0;
	      for (var i = 0; i < topDigits.length; ++i) {
	        var num = topDigits[i];
	        var topGlyph = new _glyph3.Glyph('v' + num, this.point);
	
	        glyph.topGlyphs.push(topGlyph);
	        topWidth += topGlyph.getMetrics().width;
	      }
	
	      var botWidth = 0;
	      for (var _i = 0; _i < botDigits.length; ++_i) {
	        var _num = botDigits[_i];
	        var botGlyph = new _glyph3.Glyph('v' + _num, this.point);
	
	        glyph.botGlyphs.push(botGlyph);
	        botWidth += botGlyph.getMetrics().width;
	      }
	
	      var width = topWidth > botWidth ? topWidth : botWidth;
	      var xMin = glyph.getMetrics().x_min;
	
	      glyph.getMetrics = function () {
	        return {
	          x_min: xMin,
	          x_max: xMin + width,
	          width: width
	        };
	      };
	
	      var topStartX = (width - topWidth) / 2.0;
	      var botStartX = (width - botWidth) / 2.0;
	
	      var that = this;
	      glyph.renderToStave = function renderToStave(x) {
	        var start_x = x + topStartX;
	        for (var _i2 = 0; _i2 < this.topGlyphs.length; ++_i2) {
	          var _glyph = this.topGlyphs[_i2];
	          _glyph3.Glyph.renderOutline(this.context, _glyph.metrics.outline, _glyph.scale, start_x + _glyph.x_shift, this.stave.getYForLine(that.topLine) + 1);
	          start_x += _glyph.getMetrics().width;
	        }
	
	        start_x = x + botStartX;
	        for (var _i3 = 0; _i3 < this.botGlyphs.length; ++_i3) {
	          var _glyph2 = this.botGlyphs[_i3];
	          that.placeGlyphOnLine(_glyph2, this.stave, _glyph2.line);
	          _glyph3.Glyph.renderOutline(this.context, _glyph2.metrics.outline, _glyph2.scale, start_x + _glyph2.x_shift, this.stave.getYForLine(that.bottomLine) + 1);
	          start_x += _glyph2.getMetrics().width;
	        }
	      };
	
	      return glyph;
	    }
	  }, {
	    key: 'getTimeSig',
	    value: function getTimeSig() {
	      return this.timeSig;
	    }
	  }, {
	    key: 'setTimeSig',
	    value: function setTimeSig(timeSpec) {
	      this.timeSig = this.parseTimeSpec(timeSpec);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.x) {
	        throw new _vex.Vex.RERR('TimeSignatureError', "Can't draw time signature without x.");
	      }
	
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('TimeSignatureError', "Can't draw time signature without stave.");
	      }
	
	      this.setRendered();
	      this.timeSig.glyph.setStave(this.stave);
	      this.timeSig.glyph.setContext(this.stave.context);
	      this.placeGlyphOnLine(this.timeSig.glyph, this.stave, this.timeSig.line);
	      this.timeSig.glyph.renderToStave(this.x);
	    }
	  }]);

	  return TimeSignature;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Volta = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stavemodifier = __webpack_require__(45);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Larry Kuhns 2011
	
	var Volta = exports.Volta = function (_StaveModifier) {
	  _inherits(Volta, _StaveModifier);
	
	  _createClass(Volta, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'voltas';
	    }
	  }, {
	    key: 'type',
	    get: function get() {
	      return {
	        NONE: 1,
	        BEGIN: 2,
	        MID: 3,
	        END: 4,
	        BEGIN_END: 5
	      };
	    }
	  }]);
	
	  function Volta(type, number, x, y_shift) {
	    _classCallCheck(this, Volta);
	
	    var _this = _possibleConstructorReturn(this, (Volta.__proto__ || Object.getPrototypeOf(Volta)).call(this));
	
	    _this.setAttribute('type', 'Volta');
	    _this.volta = type;
	    _this.x = x;
	    _this.y_shift = y_shift;
	    _this.number = number;
	    _this.font = {
	      family: 'sans-serif',
	      size: 9,
	      weight: 'bold'
	    };
	    return _this;
	  }
	
	  _createClass(Volta, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Volta.CATEGORY;
	    }
	  }, {
	    key: 'setShiftY',
	    value: function setShiftY(y) {
	      this.y_shift = y;return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(stave, x) {
	      var ctx = stave.checkContext();
	      this.setRendered();
	
	      var width = stave.width;
	      var top_y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      var vert_height = 1.5 * stave.options.spacing_between_lines_px;
	      switch (this.volta) {
	        case Volta.type.BEGIN:
	          ctx.fillRect(this.x + x, top_y, 1, vert_height);
	          break;
	        case Volta.type.END:
	          width -= 5;
	          ctx.fillRect(this.x + x + width, top_y, 1, vert_height);
	          break;
	        case Volta.type.BEGIN_END:
	          width -= 3;
	          ctx.fillRect(this.x + x, top_y, 1, vert_height);
	          ctx.fillRect(this.x + x + width, top_y, 1, vert_height);
	          break;
	        default:
	          break;
	      }
	      // If the beginning of a volta, draw measure number
	      if (this.volta === Volta.type.BEGIN || this.volta === Volta.type.BEGIN_END) {
	        ctx.save();
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        ctx.fillText(this.number, this.x + x + 5, top_y + 15);
	        ctx.restore();
	      }
	
	      ctx.fillRect(this.x + x, top_y, width, 1);
	      return this;
	    }
	  }]);

	  return Volta;
	}(_stavemodifier.StaveModifier);

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabStave = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _stave = __webpack_require__(43);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	var TabStave = exports.TabStave = function (_Stave) {
	  _inherits(TabStave, _Stave);
	
	  function TabStave(x, y, width, options) {
	    _classCallCheck(this, TabStave);
	
	    var tab_options = {
	      spacing_between_lines_px: 13,
	      num_lines: 6,
	      top_text_position: 1
	    };
	
	    _vex.Vex.Merge(tab_options, options);
	
	    var _this = _possibleConstructorReturn(this, (TabStave.__proto__ || Object.getPrototypeOf(TabStave)).call(this, x, y, width, tab_options));
	
	    _this.setAttribute('type', 'TabStave');
	    return _this;
	  }
	
	  _createClass(TabStave, [{
	    key: 'getYForGlyphs',
	    value: function getYForGlyphs() {
	      return this.getYForLine(2.5);
	    }
	
	    // Deprecated
	
	  }, {
	    key: 'addTabGlyph',
	    value: function addTabGlyph() {
	      this.addClef('tab');
	      return this;
	    }
	  }]);

	  return TabStave;
	}(_stave.Stave);

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabNote = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _modifier = __webpack_require__(25);
	
	var _stem = __webpack_require__(17);
	
	var _stemmablenote = __webpack_require__(24);
	
	var _dot = __webpack_require__(26);
	
	var _glyph2 = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// The file implements notes for Tablature notation. This consists of one or
	// more fret positions, and can either be drawn with or without stems.
	//
	// See `tests/tabnote_tests.js` for usage examples
	
	// Gets the unused strings grouped together if consecutive.
	//
	// Parameters:
	// * num_lines - The number of lines
	// * strings_used - An array of numbers representing which strings have fret positions
	function getUnusedStringGroups(num_lines, strings_used) {
	  var stem_through = [];
	  var group = [];
	  for (var string = 1; string <= num_lines; string++) {
	    var is_used = strings_used.indexOf(string) > -1;
	
	    if (!is_used) {
	      group.push(string);
	    } else {
	      stem_through.push(group);
	      group = [];
	    }
	  }
	  if (group.length > 0) stem_through.push(group);
	
	  return stem_through;
	}
	
	// Gets groups of points that outline the partial stem lines
	// between fret positions
	//
	// Parameters:
	// * stem_Y - The `y` coordinate the stem is located on
	// * unused_strings - An array of groups of unused strings
	// * stave - The stave to use for reference
	// * stem_direction - The direction of the stem
	function getPartialStemLines(stem_y, unused_strings, stave, stem_direction) {
	  var up_stem = stem_direction !== 1;
	  var down_stem = stem_direction !== -1;
	
	  var line_spacing = stave.getSpacingBetweenLines();
	  var total_lines = stave.getNumLines();
	
	  var stem_lines = [];
	
	  unused_strings.forEach(function (strings) {
	    var containsLastString = strings.indexOf(total_lines) > -1;
	    var containsFirstString = strings.indexOf(1) > -1;
	
	    if (up_stem && containsFirstString || down_stem && containsLastString) {
	      return;
	    }
	
	    // If there's only one string in the group, push a duplicate value.
	    // We do this because we need 2 strings to convert into upper/lower y
	    // values.
	    if (strings.length === 1) {
	      strings.push(strings[0]);
	    }
	
	    var line_ys = [];
	    // Iterate through each group string and store it's y position
	    strings.forEach(function (string, index, strings) {
	      var isTopBound = string === 1;
	      var isBottomBound = string === total_lines;
	
	      // Get the y value for the appropriate staff line,
	      // we adjust for a 0 index array, since string numbers are index 1
	      var y = stave.getYForLine(string - 1);
	
	      // Unless the string is the first or last, add padding to each side
	      // of the line
	      if (index === 0 && !isTopBound) {
	        y -= line_spacing / 2 - 1;
	      } else if (index === strings.length - 1 && !isBottomBound) {
	        y += line_spacing / 2 - 1;
	      }
	
	      // Store the y value
	      line_ys.push(y);
	
	      // Store a subsequent y value connecting this group to the main
	      // stem above/below the stave if it's the top/bottom string
	      if (stem_direction === 1 && isTopBound) {
	        line_ys.push(stem_y - 2);
	      } else if (stem_direction === -1 && isBottomBound) {
	        line_ys.push(stem_y + 2);
	      }
	    });
	
	    // Add the sorted y values to the
	    stem_lines.push(line_ys.sort(function (a, b) {
	      return a - b;
	    }));
	  });
	
	  return stem_lines;
	}
	
	var TabNote = exports.TabNote = function (_StemmableNote) {
	  _inherits(TabNote, _StemmableNote);
	
	  _createClass(TabNote, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'tabnotes';
	    }
	
	    // Initialize the TabNote with a `tab_struct` full of properties
	    // and whether to `draw_stem` when rendering the note
	
	  }]);
	
	  function TabNote(tab_struct, draw_stem) {
	    _classCallCheck(this, TabNote);
	
	    var _this = _possibleConstructorReturn(this, (TabNote.__proto__ || Object.getPrototypeOf(TabNote)).call(this, tab_struct));
	
	    _this.setAttribute('type', 'TabNote');
	
	    _this.ghost = false; // Renders parenthesis around notes
	    // Note properties
	    //
	    // The fret positions in the note. An array of `{ str: X, fret: X }`
	    _this.positions = tab_struct.positions;
	
	    // Render Options
	    _vex.Vex.Merge(_this.render_options, {
	      // font size for note heads and rests
	      glyph_font_scale: _tables.Flow.DEFAULT_TABLATURE_FONT_SCALE,
	      // Flag to draw a stem
	      draw_stem: draw_stem,
	      // Flag to draw dot modifiers
	      draw_dots: draw_stem,
	      // Flag to extend the main stem through the stave and fret positions
	      draw_stem_through_stave: false,
	      // vertical shift from stave line
	      y_shift: 0,
	      // normal glyph scale
	      scale: 1.0,
	      // default tablature font
	      font: '10pt Arial'
	    });
	
	    _this.glyph = _tables.Flow.durationToGlyph(_this.duration, _this.noteType);
	
	    if (!_this.glyph) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Invalid note initialization data (No glyph found): ' + JSON.stringify(tab_struct));
	    }
	
	    _this.buildStem();
	
	    if (tab_struct.stem_direction) {
	      _this.setStemDirection(tab_struct.stem_direction);
	    } else {
	      _this.setStemDirection(_stem.Stem.UP);
	    }
	
	    // Renders parenthesis around notes
	    _this.ghost = false;
	    _this.updateWidth();
	    return _this;
	  }
	
	  _createClass(TabNote, [{
	    key: 'reset',
	    value: function reset() {
	      if (this.stave) this.setStave(this.stave);
	    }
	
	    // The ModifierContext category
	
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return TabNote.CATEGORY;
	    }
	
	    // Set as ghost `TabNote`, surrounds the fret positions with parenthesis.
	    // Often used for indicating frets that are being bent to
	
	  }, {
	    key: 'setGhost',
	    value: function setGhost(ghost) {
	      this.ghost = ghost;
	      this.updateWidth();
	      return this;
	    }
	
	    // Determine if the note has a stem
	
	  }, {
	    key: 'hasStem',
	    value: function hasStem() {
	      return this.render_options.draw_stem;
	    }
	
	    // Get the default stem extension for the note
	
	  }, {
	    key: 'getStemExtension',
	    value: function getStemExtension() {
	      var glyph = this.getGlyph();
	
	      if (this.stem_extension_override != null) {
	        return this.stem_extension_override;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.tabnote_stem_up_extension : glyph.tabnote_stem_down_extension;
	      }
	
	      return 0;
	    }
	
	    // Add a dot to the note
	
	  }, {
	    key: 'addDot',
	    value: function addDot() {
	      var dot = new _dot.Dot();
	      this.dots += 1;
	      return this.addModifier(dot, 0);
	    }
	
	    // Calculate and store the width of the note
	
	  }, {
	    key: 'updateWidth',
	    value: function updateWidth() {
	      var _this2 = this;
	
	      this.glyphs = [];
	      this.width = 0;
	      for (var i = 0; i < this.positions.length; ++i) {
	        var fret = this.positions[i].fret;
	        if (this.ghost) fret = '(' + fret + ')';
	        var glyph = _tables.Flow.tabToGlyph(fret, this.render_options.scale);
	        this.glyphs.push(glyph);
	        this.width = Math.max(glyph.getWidth(), this.width);
	      }
	      // For some reason we associate a notehead glyph with a TabNote, and this
	      // glyph is used for certain width calculations. Of course, this is totally
	      // incorrect since a notehead is a poor approximation for the dimensions of
	      // a fret number which can have multiple digits. As a result, we must
	      // overwrite getWidth() to return the correct width
	      this.glyph.getWidth = function () {
	        return _this2.width;
	      };
	    }
	
	    // Set the `stave` to the note
	
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      var _this3 = this;
	
	      _get(TabNote.prototype.__proto__ || Object.getPrototypeOf(TabNote.prototype), 'setStave', this).call(this, stave);
	      this.context = stave.context;
	
	      // Calculate the fret number width based on font used
	      var i = void 0;
	      if (this.context) {
	        var ctx = this.context;
	        this.width = 0;
	
	        var _loop = function _loop() {
	          var glyph = _this3.glyphs[i];
	          var text = '' + glyph.text;
	          if (text.toUpperCase() !== 'X') {
	            ctx.save();
	            ctx.setRawFont(_this3.render_options.font);
	            glyph.width = ctx.measureText(text).width;
	            ctx.restore();
	            glyph.getWidth = function () {
	              return glyph.width;
	            };
	          }
	          _this3.width = Math.max(glyph.getWidth(), _this3.width);
	        };
	
	        for (i = 0; i < this.glyphs.length; ++i) {
	          _loop();
	        }
	        this.glyph.getWidth = function () {
	          return _this3.width;
	        };
	      }
	
	      // we subtract 1 from `line` because getYForLine expects a 0-based index,
	      // while the position.str is a 1-based index
	      var ys = this.positions.map(function (_ref) {
	        var line = _ref.str;
	        return stave.getYForLine(line - 1);
	      });
	
	      this.setYs(ys);
	
	      if (this.stem) {
	        this.stem.setYBounds(this.getStemY(), this.getStemY());
	      }
	
	      return this;
	    }
	
	    // Get the fret positions for the note
	
	  }, {
	    key: 'getPositions',
	    value: function getPositions() {
	      return this.positions;
	    }
	
	    // Add self to the provided modifier context `mc`
	
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext(mc) {
	      this.setModifierContext(mc);
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        this.modifierContext.addModifier(this.modifiers[i]);
	      }
	      this.modifierContext.addModifier(this);
	      this.preFormatted = false;
	      return this;
	    }
	
	    // Get the `x` coordinate to the right of the note
	
	  }, {
	    key: 'getTieRightX',
	    value: function getTieRightX() {
	      var tieStartX = this.getAbsoluteX();
	      var note_glyph_width = this.glyph.getWidth();
	      tieStartX += note_glyph_width / 2;
	      tieStartX += -this.width / 2 + this.width + 2;
	
	      return tieStartX;
	    }
	
	    // Get the `x` coordinate to the left of the note
	
	  }, {
	    key: 'getTieLeftX',
	    value: function getTieLeftX() {
	      var tieEndX = this.getAbsoluteX();
	      var note_glyph_width = this.glyph.getWidth();
	      tieEndX += note_glyph_width / 2;
	      tieEndX -= this.width / 2 + 2;
	
	      return tieEndX;
	    }
	
	    // Get the default `x` and `y` coordinates for a modifier at a specific
	    // `position` at a fret position `index`
	
	  }, {
	    key: 'getModifierStartXY',
	    value: function getModifierStartXY(position, index) {
	      if (!this.preFormatted) {
	        throw new _vex.Vex.RERR('UnformattedNote', "Can't call GetModifierStartXY on an unformatted note");
	      }
	
	      if (this.ys.length === 0) {
	        throw new _vex.Vex.RERR('NoYValues', 'No Y-Values calculated for this note.');
	      }
	
	      var x = 0;
	      if (position === _modifier.Modifier.Position.LEFT) {
	        x = -1 * 2; // extra_left_px
	      } else if (position === _modifier.Modifier.Position.RIGHT) {
	        x = this.width + 2; // extra_right_px
	      } else if (position === _modifier.Modifier.Position.BELOW || position === _modifier.Modifier.Position.ABOVE) {
	        var note_glyph_width = this.glyph.getWidth();
	        x = note_glyph_width / 2;
	      }
	
	      return {
	        x: this.getAbsoluteX() + x,
	        y: this.ys[index]
	      };
	    }
	
	    // Get the default line for rest
	
	  }, {
	    key: 'getLineForRest',
	    value: function getLineForRest() {
	      return this.positions[0].str;
	    }
	
	    // Pre-render formatting
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      if (this.preFormatted) return;
	      if (this.modifierContext) this.modifierContext.preFormat();
	      // width is already set during init()
	      this.setPreFormatted(true);
	    }
	
	    // Get the x position for the stem
	
	  }, {
	    key: 'getStemX',
	    value: function getStemX() {
	      return this.getCenterGlyphX();
	    }
	
	    // Get the y position for the stem
	
	  }, {
	    key: 'getStemY',
	    value: function getStemY() {
	      var num_lines = this.stave.getNumLines();
	
	      // The decimal staff line amounts provide optimal spacing between the
	      // fret number and the stem
	      var stemUpLine = -0.5;
	      var stemDownLine = num_lines - 0.5;
	      var stemStartLine = _stem.Stem.UP === this.stem_direction ? stemUpLine : stemDownLine;
	
	      return this.stave.getYForLine(stemStartLine);
	    }
	
	    // Get the stem extents for the tabnote
	
	  }, {
	    key: 'getStemExtents',
	    value: function getStemExtents() {
	      return this.stem.getExtents();
	    }
	
	    // Draw the fal onto the context
	
	  }, {
	    key: 'drawFlag',
	    value: function drawFlag() {
	      var beam = this.beam;
	      var glyph = this.glyph;
	      var context = this.context;
	      var stem = this.stem;
	      var stem_direction = this.stem_direction;
	      var _render_options = this.render_options;
	      var draw_stem = _render_options.draw_stem;
	      var glyph_font_scale = _render_options.glyph_font_scale;
	
	
	      var shouldDrawFlag = beam == null && draw_stem;
	
	      // Now it's the flag's turn.
	      if (glyph.flag && shouldDrawFlag) {
	        var flag_x = this.getStemX() + 1;
	        var flag_y = this.getStemY() - stem.getHeight();
	
	        var flag_code = stem_direction === _stem.Stem.DOWN ? glyph.code_flag_downstem // Down stems have flags on the left.
	        : glyph.code_flag_upstem;
	
	        // Draw the Flag
	        _glyph2.Glyph.renderGlyph(context, flag_x, flag_y, glyph_font_scale, flag_code);
	      }
	    }
	
	    // Render the modifiers onto the context
	
	  }, {
	    key: 'drawModifiers',
	    value: function drawModifiers() {
	      var _this4 = this;
	
	      // Draw the modifiers
	      this.modifiers.forEach(function (modifier) {
	        // Only draw the dots if enabled
	        if (modifier.getCategory() === 'dots' && !_this4.render_options.draw_dots) return;
	
	        modifier.setContext(_this4.context);
	        modifier.draw();
	      });
	    }
	
	    // Render the stem extension through the fret positions
	
	  }, {
	    key: 'drawStemThrough',
	    value: function drawStemThrough() {
	      var stem_x = this.getStemX();
	      var stem_y = this.getStemY();
	      var ctx = this.context;
	
	      var stem_through = this.render_options.draw_stem_through_stave;
	      var draw_stem = this.render_options.draw_stem;
	      if (draw_stem && stem_through) {
	        var total_lines = this.stave.getNumLines();
	        var strings_used = this.positions.map(function (position) {
	          return position.str;
	        });
	
	        var unused_strings = getUnusedStringGroups(total_lines, strings_used);
	        var stem_lines = getPartialStemLines(stem_y, unused_strings, this.getStave(), this.getStemDirection());
	
	        ctx.save();
	        ctx.setLineWidth(_stem.Stem.WIDTH);
	        stem_lines.forEach(function (bounds) {
	          if (bounds.length === 0) return;
	
	          ctx.beginPath();
	          ctx.moveTo(stem_x, bounds[0]);
	          ctx.lineTo(stem_x, bounds[bounds.length - 1]);
	          ctx.stroke();
	          ctx.closePath();
	        });
	        ctx.restore();
	      }
	    }
	
	    // Render the fret positions onto the context
	
	  }, {
	    key: 'drawPositions',
	    value: function drawPositions() {
	      var ctx = this.context;
	      var x = this.getAbsoluteX();
	      var ys = this.ys;
	      for (var i = 0; i < this.positions.length; ++i) {
	        var y = ys[i] + this.render_options.y_shift;
	        var _glyph = this.glyphs[i];
	
	        // Center the fret text beneath the notation note head
	        var note_glyph_width = this.glyph.getWidth();
	        var tab_x = x + note_glyph_width / 2 - _glyph.getWidth() / 2;
	
	        // FIXME: Magic numbers.
	        ctx.clearRect(tab_x - 2, y - 3, _glyph.getWidth() + 4, 6);
	
	        if (_glyph.code) {
	          _glyph2.Glyph.renderGlyph(ctx, tab_x, y, this.render_options.glyph_font_scale * this.render_options.scale, _glyph.code);
	        } else {
	          ctx.save();
	          ctx.setRawFont(this.render_options.font);
	          var _text = _glyph.text.toString();
	          ctx.fillText(_text, tab_x, y + 5 * this.render_options.scale);
	          ctx.restore();
	        }
	      }
	    }
	
	    // The main rendering function for the entire note
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!this.stave) {
	        throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	      }
	
	      if (this.ys.length === 0) {
	        throw new _vex.Vex.RERR('NoYValues', "Can't draw note without Y values.");
	      }
	
	      this.setRendered();
	      var render_stem = this.beam == null && this.render_options.draw_stem;
	
	      this.drawPositions();
	      this.drawStemThrough();
	
	      var stem_x = this.getStemX();
	
	      this.stem.setNoteHeadXBounds(stem_x, stem_x);
	
	      if (render_stem) {
	        this.context.openGroup('stem', null, { pointerBBox: true });
	        this.stem.setContext(this.context).draw();
	        this.context.closeGroup();
	      }
	
	      this.drawFlag();
	      this.drawModifiers();
	    }
	  }]);

	  return TabNote;
	}(_stemmablenote.StemmableNote);

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VibratoBracket = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _vibrato = __webpack_require__(42);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Balazs Forian-Szabo
	//
	// ## Description
	//
	// This file implements `VibratoBrackets`
	// that renders vibrato effect between two notes.
	
	// To enable logging for this class. Set `Vex.Flow.VibratoBracket.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (VibratoBracket.DEBUG) _vex.Vex.L('Vex.Flow.VibratoBracket', args);
	}
	
	var VibratoBracket = exports.VibratoBracket = function (_Element) {
	  _inherits(VibratoBracket, _Element);
	
	  // bracket_data = {
	  //   start: Vex.Flow.Note (optional)
	  //   stop: Vex.Flow.Note (optional)
	  // };
	  // Either the stop or start note must be set, or both of them.
	  // A null value for the start or stop note indicates that the vibrato
	  // is drawn from the beginning or until the end of the stave accordingly.
	  function VibratoBracket(bracket_data) {
	    _classCallCheck(this, VibratoBracket);
	
	    var _this = _possibleConstructorReturn(this, (VibratoBracket.__proto__ || Object.getPrototypeOf(VibratoBracket)).call(this));
	
	    _this.setAttribute('type', 'VibratoBracket');
	
	    _this.start = bracket_data.start;
	    _this.stop = bracket_data.stop;
	
	    _this.line = 1;
	
	    _this.render_options = {
	      harsh: false,
	      wave_height: 6,
	      wave_width: 4,
	      wave_girth: 2
	    };
	    return _this;
	  }
	
	  // Set line position of the vibrato bracket
	
	
	  _createClass(VibratoBracket, [{
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;return this;
	    }
	  }, {
	    key: 'setHarsh',
	    value: function setHarsh(harsh) {
	      this.render_options.harsh = harsh;return this;
	    }
	
	    // Draw the vibrato bracket on the rendering context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.context;
	      this.setRendered();
	
	      var y = this.start ? this.start.getStave().getYForTopText(this.line) : this.stop.getStave().getYForTopText(this.line);
	
	      // If start note is not set then vibrato will be drawn
	      // from the beginning of the stave
	      var start_x = this.start ? this.start.getAbsoluteX() : this.stop.getStave().getTieStartX();
	
	      // If stop note is not set then vibrato will be drawn
	      // until the end of the stave
	      var stop_x = this.stop ? this.stop.getAbsoluteX() - this.stop.getWidth() - 5 : this.start.getStave().getTieEndX() - 10;
	
	      this.render_options.vibrato_width = stop_x - start_x;
	
	      L('Rendering VibratoBracket: start_x:', start_x, 'stop_x:', stop_x, 'y:', y);
	
	      _vibrato.Vibrato.renderVibrato(ctx, start_x, y, this.render_options);
	    }
	  }]);

	  return VibratoBracket;
	}(_element.Element);

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClefNote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _boundingbox = __webpack_require__(8);
	
	var _note = __webpack_require__(22);
	
	var _clef = __webpack_require__(51);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Copyright Mohit Muthanna 2010
	//
	// Author Taehoon Moon 2014
	
	/** @constructor */
	var ClefNote = exports.ClefNote = function (_Note) {
	  _inherits(ClefNote, _Note);
	
	  _createClass(ClefNote, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'clefnote';
	    }
	  }]);
	
	  function ClefNote(type, size, annotation) {
	    _classCallCheck(this, ClefNote);
	
	    var _this = _possibleConstructorReturn(this, (ClefNote.__proto__ || Object.getPrototypeOf(ClefNote)).call(this, { duration: 'b' }));
	
	    _this.setAttribute('type', 'ClefNote');
	
	    _this.setType(type, size, annotation);
	
	    // Note properties
	    _this.ignore_ticks = true;
	    return _this;
	  }
	
	  _createClass(ClefNote, [{
	    key: 'setType',
	    value: function setType(type, size, annotation) {
	      this.type = type;
	      this.clef_obj = new _clef.Clef(type, size, annotation);
	      this.clef = this.clef_obj.clef;
	      this.glyph = new _glyph.Glyph(this.clef.code, this.clef.point);
	      this.setWidth(this.glyph.getMetrics().width);
	      return this;
	    }
	  }, {
	    key: 'getClef',
	    value: function getClef() {
	      return this.clef;
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      this.context = context;
	      this.glyph.setContext(this.context);
	      return this;
	    }
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return new _boundingbox.BoundingBox(0, 0, 0, 0);
	    }
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext() {
	      /* overridden to ignore */
	      return this;
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return ClefNote.CATEGORY;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      this.setPreFormatted(true);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.stave) throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	
	      if (!this.glyph.getContext()) {
	        this.glyph.setContext(this.context);
	      }
	
	      this.setRendered();
	      var abs_x = this.getAbsoluteX();
	
	      this.glyph.setStave(this.stave);
	      this.glyph.setYShift(this.stave.getYForLine(this.clef.line) - this.stave.getYForGlyphs());
	      this.glyph.renderToStave(abs_x);
	
	      // If the Vex.Flow.Clef has an annotation, such as 8va, draw it.
	      if (this.clef_obj.annotation !== undefined) {
	        var attachment = new _glyph.Glyph(this.clef_obj.annotation.code, this.clef_obj.annotation.point);
	        if (!attachment.getContext()) {
	          attachment.setContext(this.context);
	        }
	        attachment.setStave(this.stave);
	        attachment.setYShift(this.stave.getYForLine(this.clef_obj.annotation.line) - this.stave.getYForGlyphs());
	        attachment.setXShift(this.clef_obj.annotation.x_shift);
	        attachment.renderToStave(abs_x);
	      }
	    }
	  }]);

	  return ClefNote;
	}(_note.Note);

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeSigNote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _boundingbox = __webpack_require__(8);
	
	var _note = __webpack_require__(22);
	
	var _timesignature = __webpack_require__(53);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author Taehoon Moon 2014
	
	var TimeSigNote = exports.TimeSigNote = function (_Note) {
	  _inherits(TimeSigNote, _Note);
	
	  function TimeSigNote(timeSpec, customPadding) {
	    _classCallCheck(this, TimeSigNote);
	
	    var _this = _possibleConstructorReturn(this, (TimeSigNote.__proto__ || Object.getPrototypeOf(TimeSigNote)).call(this, { duration: 'b' }));
	
	    _this.setAttribute('type', 'TimeSigNote');
	
	    var timeSignature = new _timesignature.TimeSignature(timeSpec, customPadding);
	    _this.timeSig = timeSignature.getTimeSig();
	    _this.setWidth(_this.timeSig.glyph.getMetrics().width);
	
	    // Note properties
	    _this.ignore_ticks = true;
	    return _this;
	  }
	
	  _createClass(TimeSigNote, [{
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return new _boundingbox.BoundingBox(0, 0, 0, 0);
	    }
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext() {
	      /* overridden to ignore */
	      return this;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      this.setPreFormatted(true);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.stave.checkContext();
	      this.setRendered();
	
	      if (!this.timeSig.glyph.getContext()) {
	        this.timeSig.glyph.setContext(this.context);
	      }
	
	      this.timeSig.glyph.setStave(this.stave);
	      this.timeSig.glyph.setYShift(this.stave.getYForLine(this.timeSig.line) - this.stave.getYForGlyphs());
	      this.timeSig.glyph.renderToStave(this.getAbsoluteX());
	    }
	  }]);

	  return TimeSigNote;
	}(_note.Note);

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabSlide = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tabtie = __webpack_require__(34);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	var TabSlide = exports.TabSlide = function (_TabTie) {
	  _inherits(TabSlide, _TabTie);
	
	  _createClass(TabSlide, null, [{
	    key: 'createSlideUp',
	    value: function createSlideUp(notes) {
	      return new TabSlide(notes, TabSlide.SLIDE_UP);
	    }
	  }, {
	    key: 'createSlideDown',
	    value: function createSlideDown(notes) {
	      return new TabSlide(notes, TabSlide.SLIDE_DOWN);
	    }
	  }, {
	    key: 'SLIDE_UP',
	    get: function get() {
	      return 1;
	    }
	  }, {
	    key: 'SLIDE_DOWN',
	    get: function get() {
	      return -1;
	    }
	  }]);
	
	  function TabSlide(notes, direction) {
	    _classCallCheck(this, TabSlide);
	
	    var _this = _possibleConstructorReturn(this, (TabSlide.__proto__ || Object.getPrototypeOf(TabSlide)).call(this, notes, 'sl.'));
	    /**
	     * Notes is a struct that has:
	     *
	     *  {
	     *    first_note: Note,
	     *    last_note: Note,
	     *    first_indices: [n1, n2, n3],
	     *    last_indices: [n1, n2, n3]
	     *  }
	     *
	     **/
	
	
	    _this.setAttribute('type', 'TabSlide');
	
	    if (!direction) {
	      var first_fret = notes.first_note.getPositions()[0].fret;
	      var last_fret = notes.last_note.getPositions()[0].fret;
	
	      direction = parseInt(first_fret, 10) > parseInt(last_fret, 10) ? TabSlide.SLIDE_DOWN : TabSlide.SLIDE_UP;
	    }
	
	    _this.slide_direction = direction;
	    _this.render_options.cp1 = 11;
	    _this.render_options.cp2 = 14;
	    _this.render_options.y_shift = 0.5;
	
	    _this.setFont({ font: 'Times', size: 10, style: 'bold italic' });
	    _this.setNotes(notes);
	    return _this;
	  }
	
	  _createClass(TabSlide, [{
	    key: 'renderTie',
	    value: function renderTie(params) {
	      if (params.first_ys.length === 0 || params.last_ys.length === 0) {
	        throw new _vex.Vex.RERR('BadArguments', 'No Y-values to render');
	      }
	
	      var ctx = this.context;
	      var first_x_px = params.first_x_px;
	      var first_ys = params.first_ys;
	      var last_x_px = params.last_x_px;
	
	      var direction = this.slide_direction;
	      if (direction !== TabSlide.SLIDE_UP && direction !== TabSlide.SLIDE_DOWN) {
	        throw new _vex.Vex.RERR('BadSlide', 'Invalid slide direction');
	      }
	
	      for (var i = 0; i < this.first_indices.length; ++i) {
	        var slide_y = first_ys[this.first_indices[i]] + this.render_options.y_shift;
	
	        if (isNaN(slide_y)) {
	          throw new _vex.Vex.RERR('BadArguments', 'Bad indices for slide rendering.');
	        }
	
	        ctx.beginPath();
	        ctx.moveTo(first_x_px, slide_y + 3 * direction);
	        ctx.lineTo(last_x_px, slide_y - 3 * direction);
	        ctx.closePath();
	        ctx.stroke();
	      }
	
	      this.setRendered();
	    }
	  }]);

	  return TabSlide;
	}(_tabtie.TabTie);

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraceNote = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stavenote = __webpack_require__(20);
	
	var _tables = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	
	var GraceNote = exports.GraceNote = function (_StaveNote) {
	  _inherits(GraceNote, _StaveNote);
	
	  _createClass(GraceNote, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'gracenotes';
	    }
	  }, {
	    key: 'LEDGER_LINE_OFFSET',
	    get: function get() {
	      return 2;
	    }
	  }, {
	    key: 'SCALE',
	    get: function get() {
	      return 0.66;
	    }
	  }]);
	
	  function GraceNote(note_struct) {
	    _classCallCheck(this, GraceNote);
	
	    var _this = _possibleConstructorReturn(this, (GraceNote.__proto__ || Object.getPrototypeOf(GraceNote)).call(this, _extends(note_struct, {
	      glyph_font_scale: _tables.Flow.DEFAULT_NOTATION_FONT_SCALE * GraceNote.SCALE,
	      stroke_px: GraceNote.LEDGER_LINE_OFFSET
	    })));
	
	    _this.setAttribute('type', 'GraceNote');
	
	    _this.slash = note_struct.slash;
	    _this.slur = true;
	
	    _this.buildNoteHeads();
	
	    _this.width = 3;
	    return _this;
	  }
	
	  _createClass(GraceNote, [{
	    key: 'getStemExtension',
	    value: function getStemExtension() {
	      var glyph = this.getGlyph();
	
	      if (this.stem_extension_override != null) {
	        return this.stem_extension_override;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.gracenote_stem_up_extension : glyph.gracenote_stem_down_extension;
	      }
	
	      return 0;
	    }
	  }, {
	    key: 'getCategory',
	    value: function getCategory() {
	      return GraceNote.CATEGORY;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      _get(GraceNote.prototype.__proto__ || Object.getPrototypeOf(GraceNote.prototype), 'draw', this).call(this);
	      this.setRendered();
	      var ctx = this.context;
	      var stem_direction = this.getStemDirection();
	
	      if (this.slash) {
	        ctx.beginPath();
	
	        var x = this.getAbsoluteX();
	        var y = this.getYs()[0] - this.stem.getHeight() / 2.8;
	        if (stem_direction === 1) {
	          x += 1;
	          ctx.moveTo(x, y);
	          ctx.lineTo(x + 13, y - 9);
	        } else if (stem_direction === -1) {
	          x -= 4;
	          y += 1;
	          ctx.moveTo(x, y);
	          ctx.lineTo(x + 13, y + 9);
	        }
	
	        ctx.closePath();
	        ctx.stroke();
	      }
	    }
	  }]);

	  return GraceNote;
	}(_stavenote.StaveNote);

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraceTabNote = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tabnote = __webpack_require__(56);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Balazs Forian-Szabo
	//
	// ## Description
	//
	// A basic implementation of grace notes
	// to be rendered on a tab stave.
	//
	// See `tests/gracetabnote_tests.js` for usage examples.
	
	var GraceTabNote = exports.GraceTabNote = function (_TabNote) {
	  _inherits(GraceTabNote, _TabNote);
	
	  _createClass(GraceTabNote, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'gracetabnotes';
	    }
	  }]);
	
	  function GraceTabNote(note_struct) {
	    _classCallCheck(this, GraceTabNote);
	
	    var _this = _possibleConstructorReturn(this, (GraceTabNote.__proto__ || Object.getPrototypeOf(GraceTabNote)).call(this, note_struct, false));
	
	    _this.setAttribute('type', 'GraceTabNote');
	
	    _vex.Vex.Merge(_this.render_options, {
	      // vertical shift from stave line
	      y_shift: 0.3,
	      // grace glyph scale
	      scale: 0.6,
	      // grace tablature font
	      font: '7.5pt Arial'
	    });
	
	    _this.updateWidth();
	    return _this;
	  }
	
	  _createClass(GraceTabNote, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return GraceTabNote.CATEGORY;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      _get(GraceTabNote.prototype.__proto__ || Object.getPrototypeOf(GraceTabNote.prototype), 'draw', this).call(this);
	      this.setRendered();
	    }
	  }]);

	  return GraceTabNote;
	}(_tabnote.TabNote);

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tuning = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class implements varies types of tunings for tablature.
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tuning = exports.Tuning = function () {
	  _createClass(Tuning, null, [{
	    key: 'names',
	    get: function get() {
	      return {
	        'standard': 'E/5,B/4,G/4,D/4,A/3,E/3',
	        'dagdad': 'D/5,A/4,G/4,D/4,A/3,D/3',
	        'dropd': 'E/5,B/4,G/4,D/4,A/3,D/3',
	        'eb': 'Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3',
	        'standardBanjo': 'D/5,B/4,G/4,D/4,G/5'
	      };
	    }
	  }]);
	
	  function Tuning() {
	    var tuningString = arguments.length <= 0 || arguments[0] === undefined ? 'E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2' : arguments[0];
	
	    _classCallCheck(this, Tuning);
	
	    // Default to standard tuning.
	    this.setTuning(tuningString);
	  }
	
	  _createClass(Tuning, [{
	    key: 'noteToInteger',
	    value: function noteToInteger(noteString) {
	      return _tables.Flow.keyProperties(noteString).int_value;
	    }
	  }, {
	    key: 'setTuning',
	    value: function setTuning(noteString) {
	      if (Tuning.names[noteString]) {
	        noteString = Tuning.names[noteString];
	      }
	
	      this.tuningString = noteString;
	      this.tuningValues = [];
	      this.numStrings = 0;
	
	      var keys = noteString.split(/\s*,\s*/);
	      if (keys.length === 0) {
	        throw new _vex.Vex.RERR('BadArguments', 'Invalid tuning string: ' + noteString);
	      }
	
	      this.numStrings = keys.length;
	      for (var i = 0; i < this.numStrings; ++i) {
	        this.tuningValues[i] = this.noteToInteger(keys[i]);
	      }
	    }
	  }, {
	    key: 'getValueForString',
	    value: function getValueForString(stringNum) {
	      var s = parseInt(stringNum, 10);
	      if (s < 1 || s > this.numStrings) {
	        throw new _vex.Vex.RERR('BadArguments', 'String number must be between 1 and ' + this.numStrings + ':' + stringNum);
	      }
	
	      return this.tuningValues[s - 1];
	    }
	  }, {
	    key: 'getValueForFret',
	    value: function getValueForFret(fretNum, stringNum) {
	      var stringValue = this.getValueForString(stringNum);
	      var f = parseInt(fretNum, 10);
	
	      if (f < 0) {
	        throw new _vex.Vex.RERR('BadArguments', 'Fret number must be 0 or higher: ' + fretNum);
	      }
	
	      return stringValue + f;
	    }
	  }, {
	    key: 'getNoteForFret',
	    value: function getNoteForFret(fretNum, stringNum) {
	      var noteValue = this.getValueForFret(fretNum, stringNum);
	
	      var octave = Math.floor(noteValue / 12);
	      var value = noteValue % 12;
	
	      return _tables.Flow.integerToNote(value) + '/' + octave;
	    }
	  }]);

	  return Tuning;
	}();

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KeyManager = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This class implements diatonic key management.
	
	var _vex = __webpack_require__(1);
	
	var _music = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KeyManager = exports.KeyManager = function () {
	  function KeyManager(key) {
	    _classCallCheck(this, KeyManager);
	
	    this.music = new _music.Music();
	    this.setKey(key);
	  }
	
	  _createClass(KeyManager, [{
	    key: 'setKey',
	    value: function setKey(key) {
	      this.key = key;
	      this.reset();
	      return this;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return this.key;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.keyParts = this.music.getKeyParts(this.key);
	
	      this.keyString = this.keyParts.root;
	      if (this.keyParts.accidental) this.keyString += this.keyParts.accidental;
	
	      var is_supported_type = _music.Music.scaleTypes[this.keyParts.type];
	      if (!is_supported_type) {
	        throw new _vex.Vex.RERR('BadArguments', 'Unsupported key type: ' + this.key);
	      }
	
	      this.scale = this.music.getScaleTones(this.music.getNoteValue(this.keyString), _music.Music.scaleTypes[this.keyParts.type]);
	
	      this.scaleMap = {};
	      this.scaleMapByValue = {};
	      this.originalScaleMapByValue = {};
	
	      var noteLocation = _music.Music.root_indices[this.keyParts.root];
	
	      for (var i = 0; i < _music.Music.roots.length; ++i) {
	        var index = (noteLocation + i) % _music.Music.roots.length;
	        var rootName = _music.Music.roots[index];
	
	        var noteName = this.music.getRelativeNoteName(rootName, this.scale[i]);
	        this.scaleMap[rootName] = noteName;
	        this.scaleMapByValue[this.scale[i]] = noteName;
	        this.originalScaleMapByValue[this.scale[i]] = noteName;
	      }
	
	      return this;
	    }
	  }, {
	    key: 'getAccidental',
	    value: function getAccidental(key) {
	      var root = this.music.getKeyParts(key).root;
	      var parts = this.music.getNoteParts(this.scaleMap[root]);
	
	      return {
	        note: this.scaleMap[root],
	        accidental: parts.accidental
	      };
	    }
	  }, {
	    key: 'selectNote',
	    value: function selectNote(note) {
	      note = note.toLowerCase();
	      var parts = this.music.getNoteParts(note);
	
	      // First look for matching note in our altered scale
	      var scaleNote = this.scaleMap[parts.root];
	      var modparts = this.music.getNoteParts(scaleNote);
	
	      if (scaleNote === note) {
	        return {
	          'note': scaleNote,
	          'accidental': parts.accidental,
	          'change': false
	        };
	      }
	
	      // Then search for a note of equivalent value in our altered scale
	      var valueNote = this.scaleMapByValue[this.music.getNoteValue(note)];
	      if (valueNote != null) {
	        return {
	          'note': valueNote,
	          'accidental': this.music.getNoteParts(valueNote).accidental,
	          'change': false
	        };
	      }
	
	      // Then search for a note of equivalent value in the original scale
	      var originalValueNote = this.originalScaleMapByValue[this.music.getNoteValue(note)];
	      if (originalValueNote != null) {
	        this.scaleMap[modparts.root] = originalValueNote;
	        delete this.scaleMapByValue[this.music.getNoteValue(scaleNote)];
	        this.scaleMapByValue[this.music.getNoteValue(note)] = originalValueNote;
	        return {
	          'note': originalValueNote,
	          'accidental': this.music.getNoteParts(originalValueNote).accidental,
	          'change': true
	        };
	      }
	
	      // Then try to unmodify a currently modified note.
	      if (modparts.root === note) {
	        delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[parts.root])];
	        this.scaleMapByValue[this.music.getNoteValue(modparts.root)] = modparts.root;
	        this.scaleMap[modparts.root] = modparts.root;
	        return {
	          'note': modparts.root,
	          'accidental': null,
	          'change': true
	        };
	      }
	
	      // Last resort -- shitshoot
	      delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[parts.root])];
	      this.scaleMapByValue[this.music.getNoteValue(note)] = note;
	
	      delete this.scaleMap[modparts.root];
	      this.scaleMap[modparts.root] = note;
	
	      return {
	        note: note,
	        'accidental': parts.accidental,
	        'change': true
	      };
	    }
	  }]);

	  return KeyManager;
	}();

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveHairpin = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _modifier = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This class by Raffaele Viglianti, 2012 http://itisnotsound.wordpress.com/
	//
	// This class implements hairpins between notes.
	// Hairpins can be either Crescendo or Descrescendo.
	
	var StaveHairpin = exports.StaveHairpin = function (_Element) {
	  _inherits(StaveHairpin, _Element);
	
	  _createClass(StaveHairpin, null, [{
	    key: 'FormatByTicksAndDraw',
	
	
	    /* Helper function to convert ticks into pixels.
	     * Requires a Formatter with voices joined and formatted (to
	     * get pixels per tick)
	     *
	     * options is struct that has:
	     *
	     *  {
	     *   height: px,
	     *   y_shift: px, //vertical offset
	     *   left_shift_ticks: 0, //left horizontal offset expressed in ticks
	     *   right_shift_ticks: 0 // right horizontal offset expressed in ticks
	     *  }
	     *
	     **/
	    value: function FormatByTicksAndDraw(ctx, formatter, notes, type, position, options) {
	      var ppt = formatter.pixelsPerTick;
	
	      if (ppt == null) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'A valid Formatter must be provide to draw offsets by ticks.');
	      }
	
	      var l_shift_px = ppt * options.left_shift_ticks;
	      var r_shift_px = ppt * options.right_shift_ticks;
	
	      var hairpin_options = {
	        height: options.height,
	        y_shift: options.y_shift,
	        left_shift_px: l_shift_px,
	        right_shift_px: r_shift_px };
	
	      new StaveHairpin({
	        first_note: notes.first_note,
	        last_note: notes.last_note
	      }, type).setContext(ctx).setRenderOptions(hairpin_options).setPosition(position).draw();
	    }
	
	    /**
	     * Create a new hairpin from the specified notes.
	     *
	     * @constructor
	     * @param {!Object} notes The notes to tie up.
	     * @param {!Object} type The type of hairpin
	     */
	
	  }, {
	    key: 'type',
	    get: function get() {
	      return {
	        CRESC: 1,
	        DECRESC: 2
	      };
	    }
	  }]);
	
	  function StaveHairpin(notes, type) {
	    _classCallCheck(this, StaveHairpin);
	
	    var _this = _possibleConstructorReturn(this, (StaveHairpin.__proto__ || Object.getPrototypeOf(StaveHairpin)).call(this));
	    /**
	     * Notes is a struct that has:
	     *
	     *  {
	     *    first_note: Note,
	     *    last_note: Note,
	     *  }
	     *
	     **/
	
	
	    _this.setAttribute('type', 'StaveHairpin');
	    _this.notes = notes;
	    _this.hairpin = type;
	    _this.position = _modifier.Modifier.Position.BELOW;
	
	    _this.render_options = {
	      height: 10,
	      y_shift: 0, // vertical offset
	      left_shift_px: 0, // left horizontal offset
	      right_shift_px: 0 };
	
	    _this.setNotes(notes);
	    return _this;
	  }
	
	  _createClass(StaveHairpin, [{
	    key: 'setPosition',
	    value: function setPosition(position) {
	      if (position === _modifier.Modifier.Position.ABOVE || position === _modifier.Modifier.Position.BELOW) {
	        this.position = position;
	      }
	      return this;
	    }
	  }, {
	    key: 'setRenderOptions',
	    value: function setRenderOptions(options) {
	      if (options.height != null && options.y_shift != null && options.left_shift_px != null && options.right_shift_px != null) {
	        this.render_options = options;
	      }
	      return this;
	    }
	
	    /**
	     * Set the notes to attach this hairpin to.
	     *
	     * @param {!Object} notes The start and end notes.
	     */
	
	  }, {
	    key: 'setNotes',
	    value: function setNotes(notes) {
	      if (!notes.first_note && !notes.last_note) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Hairpin needs to have either first_note or last_note set.');
	      }
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.last_note = notes.last_note;
	      return this;
	    }
	  }, {
	    key: 'renderHairpin',
	    value: function renderHairpin(params) {
	      var ctx = this.checkContext();
	      var dis = this.render_options.y_shift + 20;
	      var y_shift = params.first_y;
	
	      if (this.position === _modifier.Modifier.Position.ABOVE) {
	        dis = -dis + 30;
	        y_shift = params.first_y - params.staff_height;
	      }
	
	      var l_shift = this.render_options.left_shift_px;
	      var r_shift = this.render_options.right_shift_px;
	
	      ctx.beginPath();
	
	      switch (this.hairpin) {
	        case StaveHairpin.type.CRESC:
	          ctx.moveTo(params.last_x + r_shift, y_shift + dis);
	          ctx.lineTo(params.first_x + l_shift, y_shift + this.render_options.height / 2 + dis);
	          ctx.lineTo(params.last_x + r_shift, y_shift + this.render_options.height + dis);
	          break;
	        case StaveHairpin.type.DECRESC:
	          ctx.moveTo(params.first_x + l_shift, y_shift + dis);
	          ctx.lineTo(params.last_x + r_shift, y_shift + this.render_options.height / 2 + dis);
	          ctx.lineTo(params.first_x + l_shift, y_shift + this.render_options.height + dis);
	          break;
	        default:
	          // Default is NONE, so nothing to draw
	          break;
	      }
	
	      ctx.stroke();
	      ctx.closePath();
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var firstNote = this.first_note;
	      var lastNote = this.last_note;
	
	      var start = firstNote.getModifierStartXY(this.position, 0);
	      var end = lastNote.getModifierStartXY(this.position, 0);
	
	      this.renderHairpin({
	        first_x: start.x,
	        last_x: end.x,
	        first_y: firstNote.getStave().y + firstNote.getStave().height,
	        last_y: lastNote.getStave().y + lastNote.getStave().height,
	        staff_height: firstNote.getStave().height
	      });
	      return true;
	    }
	  }]);

	  return StaveHairpin;
	}(_element.Element);

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Curve = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements curves (for slurs)
	
	var Curve = exports.Curve = function (_Element) {
	  _inherits(Curve, _Element);
	
	  _createClass(Curve, null, [{
	    key: 'Position',
	    get: function get() {
	      return {
	        NEAR_HEAD: 1,
	        NEAR_TOP: 2
	      };
	    }
	  }, {
	    key: 'PositionString',
	    get: function get() {
	      return {
	        nearHead: Curve.Position.NEAR_HEAD,
	        nearTop: Curve.Position.NEAR_TOP
	      };
	    }
	
	    // from: Start note
	    // to: End note
	    // options:
	    //    cps: List of control points
	    //    x_shift: pixels to shift
	    //    y_shift: pixels to shift
	
	  }]);
	
	  function Curve(from, to, options) {
	    _classCallCheck(this, Curve);
	
	    var _this = _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).call(this));
	
	    _this.setAttribute('type', 'Curve');
	
	    _this.render_options = {
	      spacing: 2,
	      thickness: 2,
	      x_shift: 0,
	      y_shift: 10,
	      position: Curve.Position.NEAR_HEAD,
	      position_end: Curve.Position.NEAR_HEAD,
	      invert: false,
	      cps: [{ x: 0, y: 10 }, { x: 0, y: 10 }]
	    };
	
	    _vex.Vex.Merge(_this.render_options, options);
	    _this.setNotes(from, to);
	    return _this;
	  }
	
	  _createClass(Curve, [{
	    key: 'setNotes',
	    value: function setNotes(from, to) {
	      if (!from && !to) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Curve needs to have either first_note or last_note set.');
	      }
	
	      this.from = from;
	      this.to = to;
	      return this;
	    }
	
	    /**
	     * @return {boolean} Returns true if this is a partial bar.
	     */
	
	  }, {
	    key: 'isPartial',
	    value: function isPartial() {
	      return !this.from || !this.to;
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(params) {
	      var ctx = this.context;
	      var cps = this.render_options.cps;
	
	      var x_shift = this.render_options.x_shift;
	      var y_shift = this.render_options.y_shift * params.direction;
	
	      var first_x = params.first_x + x_shift;
	      var first_y = params.first_y + y_shift;
	      var last_x = params.last_x - x_shift;
	      var last_y = params.last_y + y_shift;
	      var thickness = this.render_options.thickness;
	
	      var cp_spacing = (last_x - first_x) / (cps.length + 2);
	
	      ctx.beginPath();
	      ctx.moveTo(first_x, first_y);
	      ctx.bezierCurveTo(first_x + cp_spacing + cps[0].x, first_y + cps[0].y * params.direction, last_x - cp_spacing + cps[1].x, last_y + cps[1].y * params.direction, last_x, last_y);
	      ctx.bezierCurveTo(last_x - cp_spacing + cps[1].x, last_y + (cps[1].y + thickness) * params.direction, first_x + cp_spacing + cps[0].x, first_y + (cps[0].y + thickness) * params.direction, first_x, first_y);
	      ctx.stroke();
	      ctx.closePath();
	      ctx.fill();
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var first_note = this.from;
	      var last_note = this.to;
	      var first_x = void 0;
	      var last_x = void 0;
	      var first_y = void 0;
	      var last_y = void 0;
	      var stem_direction = void 0;
	
	      var metric = 'baseY';
	      var end_metric = 'baseY';
	
	      function getPosition(position) {
	        return typeof position === 'string' ? Curve.PositionString[position] : position;
	      }
	      var position = getPosition(this.render_options.position);
	      var position_end = getPosition(this.render_options.position_end);
	
	      if (position === Curve.Position.NEAR_TOP) {
	        metric = 'topY';
	        end_metric = 'topY';
	      }
	
	      if (position_end === Curve.Position.NEAR_HEAD) {
	        end_metric = 'baseY';
	      } else if (position_end === Curve.Position.NEAR_TOP) {
	        end_metric = 'topY';
	      }
	
	      if (first_note) {
	        first_x = first_note.getTieRightX();
	        stem_direction = first_note.getStemDirection();
	        first_y = first_note.getStemExtents()[metric];
	      } else {
	        first_x = last_note.getStave().getTieStartX();
	        first_y = last_note.getStemExtents()[metric];
	      }
	
	      if (last_note) {
	        last_x = last_note.getTieLeftX();
	        stem_direction = last_note.getStemDirection();
	        last_y = last_note.getStemExtents()[end_metric];
	      } else {
	        last_x = first_note.getStave().getTieEndX();
	        last_y = first_note.getStemExtents()[end_metric];
	      }
	
	      this.renderCurve({
	        first_x: first_x,
	        last_x: last_x,
	        first_y: first_y,
	        last_y: last_y,
	        direction: stem_direction * (this.render_options.invert === true ? -1 : 1)
	      });
	      return true;
	    }
	  }]);

	  return Curve;
	}(_element.Element);

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextDynamics = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _note = __webpack_require__(22);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	// This file implements the `TextDynamics` which renders traditional
	// text dynamics markings, **ie: p, f, sfz, rfz, ppp**
	//
	// You can render any dynamics string that contains a combination of
	// the following letters:  P, M, F, Z, R, S
	
	// To enable logging for this class. Set `Vex.Flow.TextDynamics.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (TextDynamics.DEBUG) _vex.Vex.L('Vex.Flow.TextDynamics', args);
	}
	
	var TextDynamics = exports.TextDynamics = function (_Note) {
	  _inherits(TextDynamics, _Note);
	
	  _createClass(TextDynamics, null, [{
	    key: 'GLYPHS',
	
	    // The glyph data for each dynamics letter
	    get: function get() {
	      return {
	        'f': {
	          code: 'vba',
	          width: 12
	        },
	        'p': {
	          code: 'vbf',
	          width: 14
	        },
	        'm': {
	          code: 'v62',
	          width: 17
	        },
	        's': {
	          code: 'v4a',
	          width: 10
	        },
	        'z': {
	          code: 'v80',
	          width: 12
	        },
	        'r': {
	          code: 'vb1',
	          width: 12
	        }
	      };
	    }
	
	    // A `TextDynamics` object inherits from `Note` so that it can be formatted
	    // within a `Voice`.
	    // Create the dynamics marking. `text_struct` is an object
	    // that contains a `duration` property and a `sequence` of
	    // letters that represents the letters to render
	
	  }]);
	
	  function TextDynamics(text_struct) {
	    _classCallCheck(this, TextDynamics);
	
	    var _this = _possibleConstructorReturn(this, (TextDynamics.__proto__ || Object.getPrototypeOf(TextDynamics)).call(this, text_struct));
	
	    _this.setAttribute('type', 'TextDynamics');
	
	    _this.sequence = text_struct.text.toLowerCase();
	    _this.line = text_struct.line || 0;
	    _this.glyphs = [];
	
	    _vex.Vex.Merge(_this.render_options, {
	      glyph_font_size: 40
	    });
	
	    L('New Dynamics Text: ', _this.sequence);
	    return _this;
	  }
	
	  // Set the Stave line on which the note should be placed
	
	
	  _createClass(TextDynamics, [{
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;
	      return this;
	    }
	
	    // Preformat the dynamics text
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      var _this2 = this;
	
	      var total_width = 0;
	      // Iterate through each letter
	      this.sequence.split('').forEach(function (letter) {
	        // Get the glyph data for the letter
	        var glyph_data = TextDynamics.GLYPHS[letter];
	        if (!glyph_data) throw new _vex.Vex.RERR('Invalid dynamics character: ' + letter);
	
	        var size = _this2.render_options.glyph_font_size;
	        var glyph = new _glyph.Glyph(glyph_data.code, size);
	
	        // Add the glyph
	        _this2.glyphs.push(glyph);
	
	        total_width += glyph_data.width;
	      });
	
	      // Store the width of the text
	      this.setWidth(total_width);
	      this.preFormatted = true;
	      return this;
	    }
	
	    // Draw the dynamics text on the rendering context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this3 = this;
	
	      this.setRendered();
	      var x = this.getAbsoluteX();
	      var y = this.stave.getYForLine(this.line + -3);
	
	      L('Rendering Dynamics: ', this.sequence);
	
	      var letter_x = x;
	      this.glyphs.forEach(function (glyph, index) {
	        var current_letter = _this3.sequence[index];
	        glyph.render(_this3.context, letter_x, y);
	        letter_x += TextDynamics.GLYPHS[current_letter].width;
	      });
	    }
	  }]);

	  return TextDynamics;
	}(_note.Note);

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaveLine = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _tables = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `StaveLine` which are simply lines that connect
	// two notes. This object is highly configurable, see the `render_options`.
	// A simple line is often used for notating glissando articulations, but you
	// can format a `StaveLine` with arrows or colors for more pedagogical
	// purposes, such as diagrams.
	
	
	// Attribution: Arrow rendering implementations based off of
	// Patrick Horgan's article, "Drawing lines and arcs with
	// arrow heads on  HTML5 Canvas"
	//
	// Draw an arrow head that connects between 3 coordinates
	function drawArrowHead(ctx, x0, y0, x1, y1, x2, y2) {
	  // all cases do this.
	  ctx.beginPath();
	  ctx.moveTo(x0, y0);
	  ctx.lineTo(x1, y1);
	  ctx.lineTo(x2, y2);
	  ctx.lineTo(x0, y0);
	  ctx.closePath();
	
	  ctx.fill();
	}
	
	// Helper function to draw a line with arrow heads
	function drawArrowLine(ctx, point1, point2, config) {
	  var both_arrows = config.draw_start_arrow && config.draw_end_arrow;
	
	  var x1 = point1.x;
	  var y1 = point1.y;
	  var x2 = point2.x;
	  var y2 = point2.y;
	
	  // For ends with arrow we actually want to stop before we get to the arrow
	  // so that wide lines won't put a flat end on the arrow.
	  var distance = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	  var ratio = (distance - config.arrowhead_length / 3) / distance;
	  var end_x = void 0;
	  var end_y = void 0;
	  var start_x = void 0;
	  var start_y = void 0;
	  if (config.draw_end_arrow || both_arrows) {
	    end_x = Math.round(x1 + (x2 - x1) * ratio);
	    end_y = Math.round(y1 + (y2 - y1) * ratio);
	  } else {
	    end_x = x2;
	    end_y = y2;
	  }
	
	  if (config.draw_start_arrow || both_arrows) {
	    start_x = x1 + (x2 - x1) * (1 - ratio);
	    start_y = y1 + (y2 - y1) * (1 - ratio);
	  } else {
	    start_x = x1;
	    start_y = y1;
	  }
	
	  if (config.color) {
	    ctx.setStrokeStyle(config.color);
	    ctx.setFillStyle(config.color);
	  }
	
	  // Draw the shaft of the arrow
	  ctx.beginPath();
	  ctx.moveTo(start_x, start_y);
	  ctx.lineTo(end_x, end_y);
	  ctx.stroke();
	  ctx.closePath();
	
	  // calculate the angle of the line
	  var line_angle = Math.atan2(y2 - y1, x2 - x1);
	  // h is the line length of a side of the arrow head
	  var h = Math.abs(config.arrowhead_length / Math.cos(config.arrowhead_angle));
	
	  var angle1 = void 0;
	  var angle2 = void 0;
	  var top_x = void 0;
	  var top_y = void 0;
	  var bottom_x = void 0;
	  var bottom_y = void 0;
	
	  if (config.draw_end_arrow || both_arrows) {
	    angle1 = line_angle + Math.PI + config.arrowhead_angle;
	    top_x = x2 + Math.cos(angle1) * h;
	    top_y = y2 + Math.sin(angle1) * h;
	
	    angle2 = line_angle + Math.PI - config.arrowhead_angle;
	    bottom_x = x2 + Math.cos(angle2) * h;
	    bottom_y = y2 + Math.sin(angle2) * h;
	
	    drawArrowHead(ctx, top_x, top_y, x2, y2, bottom_x, bottom_y);
	  }
	
	  if (config.draw_start_arrow || both_arrows) {
	    angle1 = line_angle + config.arrowhead_angle;
	    top_x = x1 + Math.cos(angle1) * h;
	    top_y = y1 + Math.sin(angle1) * h;
	
	    angle2 = line_angle - config.arrowhead_angle;
	    bottom_x = x1 + Math.cos(angle2) * h;
	    bottom_y = y1 + Math.sin(angle2) * h;
	
	    drawArrowHead(ctx, top_x, top_y, x1, y1, bottom_x, bottom_y);
	  }
	}
	
	var StaveLine = exports.StaveLine = function (_Element) {
	  _inherits(StaveLine, _Element);
	
	  _createClass(StaveLine, null, [{
	    key: 'TextVerticalPosition',
	
	    // Text Positioning
	    get: function get() {
	      return {
	        TOP: 1,
	        BOTTOM: 2
	      };
	    }
	  }, {
	    key: 'TextJustification',
	    get: function get() {
	      return {
	        LEFT: 1,
	        CENTER: 2,
	        RIGHT: 3
	      };
	    }
	
	    // Initialize the StaveLine with the given `notes`.
	    //
	    // `notes` is a struct that has:
	    //
	    //  ```
	    //  {
	    //    first_note: Note,
	    //    last_note: Note,
	    //    first_indices: [n1, n2, n3],
	    //    last_indices: [n1, n2, n3]
	    //  }
	    //  ```
	
	  }]);
	
	  function StaveLine(notes) {
	    _classCallCheck(this, StaveLine);
	
	    var _this = _possibleConstructorReturn(this, (StaveLine.__proto__ || Object.getPrototypeOf(StaveLine)).call(this));
	
	    _this.setAttribute('type', 'StaveLine');
	
	    _this.notes = notes;
	
	    _this.text = '';
	
	    _this.font = {
	      family: 'Arial',
	      size: 10,
	      weight: ''
	    };
	
	    _this.render_options = {
	      // Space to add to the left or the right
	      padding_left: 4,
	      padding_right: 3,
	
	      // The width of the line in pixels
	      line_width: 1,
	      // An array of line/space lengths. Unsupported with Raphael (SVG)
	      line_dash: null,
	      // Can draw rounded line end, instead of a square. Unsupported with Raphael (SVG)
	      rounded_end: true,
	      // The color of the line and arrowheads
	      color: null,
	
	      // Flags to draw arrows on each end of the line
	      draw_start_arrow: false,
	      draw_end_arrow: false,
	
	      // The length of the arrowhead sides
	      arrowhead_length: 10,
	      // The angle of the arrowhead
	      arrowhead_angle: Math.PI / 8,
	
	      // The position of the text
	      text_position_vertical: StaveLine.TextVerticalPosition.TOP,
	      text_justification: StaveLine.TextJustification.CENTER
	    };
	
	    _this.setNotes(notes);
	    return _this;
	  }
	
	  // Set the font for the `StaveLine` text
	
	
	  _createClass(StaveLine, [{
	    key: 'setFont',
	    value: function setFont(font) {
	      this.font = font;return this;
	    }
	    // The the annotation for the `StaveLine`
	
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      this.text = text;return this;
	    }
	
	    // Set the notes for the `StaveLine`
	
	  }, {
	    key: 'setNotes',
	    value: function setNotes(notes) {
	      if (!notes.first_note && !notes.last_note) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Notes needs to have either first_note or last_note set.');
	      }
	
	      if (!notes.first_indices) notes.first_indices = [0];
	      if (!notes.last_indices) notes.last_indices = [0];
	
	      if (notes.first_indices.length !== notes.last_indices.length) {
	        throw new _vex.Vex.RuntimeError('BadArguments', 'Connected notes must have similar index sizes');
	      }
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.first_indices = notes.first_indices;
	      this.last_note = notes.last_note;
	      this.last_indices = notes.last_indices;
	      return this;
	    }
	
	    // Apply the style of the `StaveLine` to the context
	
	  }, {
	    key: 'applyLineStyle',
	    value: function applyLineStyle() {
	      var ctx = this.checkContext();
	      var render_options = this.render_options;
	
	      if (render_options.line_dash) {
	        ctx.setLineDash(render_options.line_dash);
	      }
	
	      if (render_options.line_width) {
	        ctx.setLineWidth(render_options.line_width);
	      }
	
	      if (render_options.rounded_end) {
	        ctx.setLineCap('round');
	      } else {
	        ctx.setLineCap('square');
	      }
	    }
	
	    // Apply the text styling to the context
	
	  }, {
	    key: 'applyFontStyle',
	    value: function applyFontStyle() {
	      var ctx = this.checkContext();
	
	      if (this.font) {
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      }
	
	      if (this.render_options.color) {
	        ctx.setStrokeStyle(this.render_options.color);
	        ctx.setFillStyle(this.render_options.color);
	      }
	    }
	
	    // Renders the `StaveLine` on the context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this2 = this;
	
	      var ctx = this.checkContext();
	      this.setRendered();
	
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	      var render_options = this.render_options;
	
	      ctx.save();
	      this.applyLineStyle();
	
	      // Cycle through each set of indices and draw lines
	      var start_position = void 0;
	      var end_position = void 0;
	      this.first_indices.forEach(function (first_index, i) {
	        var last_index = _this2.last_indices[i];
	
	        // Get initial coordinates for the start/end of the line
	        start_position = first_note.getModifierStartXY(2, first_index);
	        end_position = last_note.getModifierStartXY(1, last_index);
	        var upwards_slope = start_position.y > end_position.y;
	
	        // Adjust `x` coordinates for modifiers
	        start_position.x += first_note.getMetrics().modRightPx + render_options.padding_left;
	        end_position.x -= last_note.getMetrics().modLeftPx + render_options.padding_right;
	
	        // Adjust first `x` coordinates for displacements
	        var notehead_width = first_note.getGlyph().getWidth();
	        var first_displaced = first_note.getKeyProps()[first_index].displaced;
	        if (first_displaced && first_note.getStemDirection() === 1) {
	          start_position.x += notehead_width + render_options.padding_left;
	        }
	
	        // Adjust last `x` coordinates for displacements
	        var last_displaced = last_note.getKeyProps()[last_index].displaced;
	        if (last_displaced && last_note.getStemDirection() === -1) {
	          end_position.x -= notehead_width + render_options.padding_right;
	        }
	
	        // Adjust y position better if it's not coming from the center of the note
	        start_position.y += upwards_slope ? -3 : 1;
	        end_position.y += upwards_slope ? 2 : 0;
	
	        drawArrowLine(ctx, start_position, end_position, _this2.render_options);
	      });
	
	      ctx.restore();
	
	      // Determine the x coordinate where to start the text
	      var text_width = ctx.measureText(this.text).width;
	      var justification = render_options.text_justification;
	      var x = 0;
	      if (justification === StaveLine.TextJustification.LEFT) {
	        x = start_position.x;
	      } else if (justification === StaveLine.TextJustification.CENTER) {
	        var delta_x = end_position.x - start_position.x;
	        var center_x = delta_x / 2 + start_position.x;
	        x = center_x - text_width / 2;
	      } else if (justification === StaveLine.TextJustification.RIGHT) {
	        x = end_position.x - text_width;
	      }
	
	      // Determine the y value to start the text
	      var y = void 0;
	      var vertical_position = render_options.text_position_vertical;
	      if (vertical_position === StaveLine.TextVerticalPosition.TOP) {
	        y = first_note.getStave().getYForTopText();
	      } else if (vertical_position === StaveLine.TextVerticalPosition.BOTTOM) {
	        y = first_note.getStave().getYForBottomText(_tables.Flow.TEXT_HEIGHT_OFFSET_HACK);
	      }
	
	      // Draw the text
	      ctx.save();
	      this.applyFontStyle();
	      ctx.fillText(this.text, x, y);
	      ctx.restore();
	
	      return this;
	    }
	  }]);

	  return StaveLine;
	}(_element.Element);

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PedalMarking = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _element = __webpack_require__(5);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements different types of pedal markings. These notation
	// elements indicate to the performer when to depress and release the a pedal.
	//
	// In order to create "Sostenuto", and "una corda" markings, you must set
	// custom text for the release/depress pedal markings.
	
	// To enable logging for this class. Set `Vex.Flow.PedalMarking.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (PedalMarking.DEBUG) _vex.Vex.L('Vex.Flow.PedalMarking', args);
	}
	
	// Draws a pedal glyph with the provided `name` on a rendering `context`
	// at the coordinates `x` and `y. Takes into account the glyph data
	// coordinate shifts.
	function drawPedalGlyph(name, context, x, y, point) {
	  var glyph_data = PedalMarking.GLYPHS[name];
	  var glyph = new _glyph.Glyph(glyph_data.code, point);
	  glyph.render(context, x + glyph_data.x_shift, y + glyph_data.y_shift);
	}
	
	var PedalMarking = exports.PedalMarking = function (_Element) {
	  _inherits(PedalMarking, _Element);
	
	  _createClass(PedalMarking, null, [{
	    key: 'createSustain',
	
	
	    // Create a sustain pedal marking. Returns the defaults PedalMarking.
	    // Which uses the traditional "Ped" and "*"" markings.
	    value: function createSustain(notes) {
	      var pedal = new PedalMarking(notes);
	      return pedal;
	    }
	
	    // Create a sostenuto pedal marking
	
	  }, {
	    key: 'createSostenuto',
	    value: function createSostenuto(notes) {
	      var pedal = new PedalMarking(notes);
	      pedal.setStyle(PedalMarking.Styles.MIXED);
	      pedal.setCustomText('Sost. Ped.');
	      return pedal;
	    }
	
	    // Create an una corda pedal marking
	
	  }, {
	    key: 'createUnaCorda',
	    value: function createUnaCorda(notes) {
	      var pedal = new PedalMarking(notes);
	      pedal.setStyle(PedalMarking.Styles.TEXT);
	      pedal.setCustomText('una corda', 'tre corda');
	      return pedal;
	    }
	
	    // ## Prototype Methods
	
	  }, {
	    key: 'GLYPHS',
	
	    // Glyph data
	    get: function get() {
	      return {
	        'pedal_depress': {
	          code: 'v36',
	          x_shift: -10,
	          y_shift: 0
	        },
	        'pedal_release': {
	          code: 'v5d',
	          x_shift: -2,
	          y_shift: 3
	        }
	      };
	    }
	  }, {
	    key: 'Styles',
	    get: function get() {
	      return {
	        TEXT: 1,
	        BRACKET: 2,
	        MIXED: 3
	      };
	    }
	  }, {
	    key: 'StylesString',
	    get: function get() {
	      return {
	        text: PedalMarking.Styles.TEXT,
	        bracket: PedalMarking.Styles.BRACKET,
	        mixed: PedalMarking.Styles.MIXED
	      };
	    }
	  }]);
	
	  function PedalMarking(notes) {
	    _classCallCheck(this, PedalMarking);
	
	    var _this = _possibleConstructorReturn(this, (PedalMarking.__proto__ || Object.getPrototypeOf(PedalMarking)).call(this));
	
	    _this.setAttribute('type', 'PedalMarking');
	
	    _this.notes = notes;
	    _this.style = PedalMarking.TEXT;
	    _this.line = 0;
	
	    // Custom text for the release/depress markings
	    _this.custom_depress_text = '';
	    _this.custom_release_text = '';
	
	    _this.font = {
	      family: 'Times New Roman',
	      size: 12,
	      weight: 'italic bold'
	    };
	
	    _this.render_options = {
	      bracket_height: 10,
	      text_margin_right: 6,
	      bracket_line_width: 1,
	      glyph_point_size: 40,
	      color: 'black'
	    };
	    return _this;
	  }
	
	  // Set custom text for the `depress`/`release` pedal markings. No text is
	  // set if the parameter is falsy.
	
	
	  _createClass(PedalMarking, [{
	    key: 'setCustomText',
	    value: function setCustomText(depress, release) {
	      this.custom_depress_text = depress || '';
	      this.custom_release_text = release || '';
	      return this;
	    }
	
	    // Set the pedal marking style
	
	  }, {
	    key: 'setStyle',
	    value: function setStyle(style) {
	      if (style < 1 && style > 3) {
	        throw new _vex.Vex.RERR('InvalidParameter', 'The style must be one found in PedalMarking.Styles');
	      }
	
	      this.style = style;
	      return this;
	    }
	
	    // Set the staff line to render the markings on
	
	  }, {
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;return this;
	    }
	
	    // Draw the bracket based pedal markings
	
	  }, {
	    key: 'drawBracketed',
	    value: function drawBracketed() {
	      var ctx = this.context;
	      var is_pedal_depressed = false;
	      var prev_x = void 0;
	      var prev_y = void 0;
	      var pedal = this;
	
	      // Iterate through each note
	      this.notes.forEach(function (note, index, notes) {
	        // Each note triggers the opposite pedal action
	        is_pedal_depressed = !is_pedal_depressed;
	
	        // Get the initial coordinates for the note
	        var x = note.getAbsoluteX();
	        var y = note.getStave().getYForBottomText(pedal.line + 3);
	
	        // Throw if current note is positioned before the previous note
	        if (x < prev_x) {
	          throw new _vex.Vex.RERR('InvalidConfiguration', 'The notes provided must be in order of ascending x positions');
	        }
	
	        // Determine if the previous or next note are the same
	        // as the current note. We need to keep track of this for
	        // when adjustments are made for the release+depress action
	        var next_is_same = notes[index + 1] === note;
	        var prev_is_same = notes[index - 1] === note;
	
	        var x_shift = 0;
	        if (is_pedal_depressed) {
	          // Adjustment for release+depress
	          x_shift = prev_is_same ? 5 : 0;
	
	          if (pedal.style === PedalMarking.Styles.MIXED && !prev_is_same) {
	            // For MIXED style, start with text instead of bracket
	            if (pedal.custom_depress_text) {
	              // If we have custom text, use instead of the default "Ped" glyph
	              var text_width = ctx.measureText(pedal.custom_depress_text).width;
	              ctx.fillText(pedal.custom_depress_text, x - text_width / 2, y);
	              x_shift = text_width / 2 + pedal.render_options.text_margin_right;
	            } else {
	              // Render the Ped glyph in position
	              drawPedalGlyph('pedal_depress', ctx, x, y, pedal.render_options.glyph_point_size);
	              x_shift = 20 + pedal.render_options.text_margin_right;
	            }
	          } else {
	            // Draw start bracket
	            ctx.beginPath();
	            ctx.moveTo(x, y - pedal.render_options.bracket_height);
	            ctx.lineTo(x + x_shift, y);
	            ctx.stroke();
	            ctx.closePath();
	          }
	        } else {
	          // Adjustment for release+depress
	          x_shift = next_is_same ? -5 : 0;
	
	          // Draw end bracket
	          ctx.beginPath();
	          ctx.moveTo(prev_x, prev_y);
	          ctx.lineTo(x + x_shift, y);
	          ctx.lineTo(x, y - pedal.render_options.bracket_height);
	          ctx.stroke();
	          ctx.closePath();
	        }
	
	        // Store previous coordinates
	        prev_x = x + x_shift;
	        prev_y = y;
	      });
	    }
	
	    // Draw the text based pedal markings. This defaults to the traditional
	    // "Ped" and "*"" symbols if no custom text has been provided.
	
	  }, {
	    key: 'drawText',
	    value: function drawText() {
	      var ctx = this.context;
	      var is_pedal_depressed = false;
	      var pedal = this;
	
	      // The glyph point size
	      var point = pedal.render_options.glyph_point_size;
	
	      // Iterate through each note, placing glyphs or custom text accordingly
	      this.notes.forEach(function (note) {
	        is_pedal_depressed = !is_pedal_depressed;
	        var stave = note.getStave();
	        var x = note.getAbsoluteX();
	        var y = stave.getYForBottomText(pedal.line + 3);
	
	        var text_width = 0;
	        if (is_pedal_depressed) {
	          if (pedal.custom_depress_text) {
	            text_width = ctx.measureText(pedal.custom_depress_text).width;
	            ctx.fillText(pedal.custom_depress_text, x - text_width / 2, y);
	          } else {
	            drawPedalGlyph('pedal_depress', ctx, x, y, point);
	          }
	        } else {
	          if (pedal.custom_release_text) {
	            text_width = ctx.measureText(pedal.custom_release_text).width;
	            ctx.fillText(pedal.custom_release_text, x - text_width / 2, y);
	          } else {
	            drawPedalGlyph('pedal_release', ctx, x, y, point);
	          }
	        }
	      });
	    }
	
	    // Render the pedal marking in position on the rendering context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.checkContext();
	      this.setRendered();
	
	      ctx.save();
	      ctx.setStrokeStyle(this.render_options.color);
	      ctx.setFillStyle(this.render_options.color);
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	
	      L('Rendering Pedal Marking');
	
	      if (this.style === PedalMarking.Styles.BRACKET || this.style === PedalMarking.Styles.MIXED) {
	        ctx.setLineWidth(this.render_options.bracket_line_width);
	        this.drawBracketed();
	      } else if (this.style === PedalMarking.Styles.TEXT) {
	        this.drawText();
	      }
	
	      ctx.restore();
	    }
	  }]);

	  return PedalMarking;
	}(_element.Element);

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextBracket = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _tables = __webpack_require__(2);
	
	var _element = __webpack_require__(5);
	
	var _renderer = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implement `TextBrackets` which extend between two notes.
	// The octave transposition markings (8va, 8vb, 15va, 15vb) can be created
	// using this class.
	
	// To enable logging for this class. Set `Vex.Flow.TextBracket.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (TextBracket.DEBUG) _vex.Vex.L('Vex.Flow.TextBracket', args);
	}
	
	var TextBracket = exports.TextBracket = function (_Element) {
	  _inherits(TextBracket, _Element);
	
	  _createClass(TextBracket, null, [{
	    key: 'Positions',
	
	    // FIXME: Modifier.Position is singular while this is plural, make consistent
	    get: function get() {
	      return {
	        TOP: 1,
	        BOTTOM: -1
	      };
	    }
	  }, {
	    key: 'PositionString',
	    get: function get() {
	      return {
	        top: TextBracket.Positions.TOP,
	        bottom: TextBracket.Positions.BOTTOM
	      };
	    }
	  }]);
	
	  function TextBracket(_ref) {
	    var start = _ref.start;
	    var stop = _ref.stop;
	    var _ref$text = _ref.text;
	    var text = _ref$text === undefined ? '' : _ref$text;
	    var _ref$superscript = _ref.superscript;
	    var superscript = _ref$superscript === undefined ? '' : _ref$superscript;
	    var _ref$position = _ref.position;
	    var position = _ref$position === undefined ? TextBracket.Positions.TOP : _ref$position;
	
	    _classCallCheck(this, TextBracket);
	
	    var _this = _possibleConstructorReturn(this, (TextBracket.__proto__ || Object.getPrototypeOf(TextBracket)).call(this));
	
	    _this.setAttribute('type', 'TextBracket');
	
	    _this.start = start;
	    _this.stop = stop;
	
	    _this.text = text;
	    _this.superscript = superscript;
	
	    _this.position = typeof position === 'string' ? TextBracket.PositionString[position] : position;
	
	    _this.line = 1;
	
	    _this.font = {
	      family: 'Serif',
	      size: 15,
	      weight: 'italic'
	    };
	
	    _this.render_options = {
	      dashed: true,
	      dash: [5],
	      color: 'black',
	      line_width: 1,
	      show_bracket: true,
	      bracket_height: 8,
	
	      // In the BOTTOM position, the bracket line can extend
	      // under the superscript.
	      underline_superscript: true
	    };
	    return _this;
	  }
	
	  // Apply the text backet styling to the provided `context`
	
	
	  _createClass(TextBracket, [{
	    key: 'applyStyle',
	    value: function applyStyle(context) {
	      // Apply style for the octave bracket
	      context.setFont(this.font.family, this.font.size, this.font.weight);
	      context.setStrokeStyle(this.render_options.color);
	      context.setFillStyle(this.render_options.color);
	      context.setLineWidth(this.render_options.line_width);
	
	      return this;
	    }
	
	    // Set whether the bracket line should be `dashed`. You can also
	    // optionally set the `dash` pattern by passing in an array of numbers
	
	  }, {
	    key: 'setDashed',
	    value: function setDashed(dashed, dash) {
	      this.render_options.dashed = dashed;
	      if (dash) this.render_options.dash = dash;
	      return this;
	    }
	
	    // Set the font for the text
	
	  }, {
	    key: 'setFont',
	    value: function setFont(font) {
	      // We use Object.assign to support partial updates to the font object
	      this.font = _extends({}, this.font, font);
	      return this;
	    }
	    // Set the rendering `context` for the octave bracket
	
	  }, {
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;return this;
	    }
	
	    // Draw the octave bracket on the rendering context
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var ctx = this.context;
	      this.setRendered();
	
	      var y = 0;
	      switch (this.position) {
	        case TextBracket.Positions.TOP:
	          y = this.start.getStave().getYForTopText(this.line);
	          break;
	        case TextBracket.Positions.BOTTOM:
	          y = this.start.getStave().getYForBottomText(this.line + _tables.Flow.TEXT_HEIGHT_OFFSET_HACK);
	          break;
	        default:
	          throw new _vex.Vex.RERR('InvalidPosition', 'The position ' + this.position + ' is invalid');
	      }
	
	      // Get the preliminary start and stop coordintates for the bracket
	      var start = { x: this.start.getAbsoluteX(), y: y };
	      var stop = { x: this.stop.getAbsoluteX(), y: y };
	
	      L('Rendering TextBracket: start:', start, 'stop:', stop, 'y:', y);
	
	      var bracket_height = this.render_options.bracket_height * this.position;
	
	      ctx.save();
	      this.applyStyle(ctx);
	
	      // Draw text
	      ctx.fillText(this.text, start.x, start.y);
	
	      // Get the width and height for the octave number
	      var main_width = ctx.measureText(this.text).width;
	      var main_height = ctx.measureText('M').width;
	
	      // Calculate the y position for the super script
	      var super_y = start.y - main_height / 2.5;
	
	      // Draw the superscript
	      ctx.setFont(this.font.family, this.font.size / 1.4, this.font.weight);
	      ctx.fillText(this.superscript, start.x + main_width + 1, super_y);
	
	      // Determine width and height of the superscript
	      var superscript_width = ctx.measureText(this.superscript).width;
	      var super_height = ctx.measureText('M').width;
	
	      // Setup initial coordinates for the bracket line
	      var start_x = start.x;
	      var line_y = super_y;
	      var end_x = stop.x + this.stop.getGlyph().getWidth();
	
	      // Adjust x and y coordinates based on position
	      if (this.position === TextBracket.Positions.TOP) {
	        start_x += main_width + superscript_width + 5;
	        line_y -= super_height / 2.7;
	      } else if (this.position === TextBracket.Positions.BOTTOM) {
	        line_y += super_height / 2.7;
	        start_x += main_width + 2;
	
	        if (!this.render_options.underline_superscript) {
	          start_x += superscript_width;
	        }
	      }
	
	      if (this.render_options.dashed) {
	        // Main line
	        _renderer.Renderer.drawDashedLine(ctx, start_x, line_y, end_x, line_y, this.render_options.dash);
	        // Ending Bracket
	        if (this.render_options.show_bracket) {
	          _renderer.Renderer.drawDashedLine(ctx, end_x, line_y + 1 * this.position, end_x, line_y + bracket_height, this.render_options.dash);
	        }
	      } else {
	        ctx.beginPath();
	        ctx.moveTo(start_x, line_y);
	        // Main line
	        ctx.lineTo(end_x, line_y);
	        if (this.render_options.show_bracket) {
	          // Ending bracket
	          ctx.lineTo(end_x, line_y + bracket_height);
	        }
	        ctx.stroke();
	        ctx.closePath();
	      }
	
	      ctx.restore();
	    }
	  }]);

	  return TextBracket;
	}(_element.Element);

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BarNote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _note = __webpack_require__(22);
	
	var _stavebarline = __webpack_require__(44);
	
	var _boundingbox = __webpack_require__(8);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// A `BarNote` is used to render bar lines (from `barline.js`). `BarNote`s can
	// be added to a voice and rendered in the middle of a stave. Since it has no
	// duration, it consumes no `tick`s, and is dealt with appropriately by the formatter.
	//
	// See `tests/barnote_tests.js` for usage examples.
	
	// To enable logging for this class. Set `Vex.Flow.BarNote.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (BarNote.DEBUG) _vex.Vex.L('Vex.Flow.BarNote', args);
	}
	
	var BarNote = exports.BarNote = function (_Note) {
	  _inherits(BarNote, _Note);
	
	  function BarNote() {
	    var _this$metrics$widths;
	
	    var type = arguments.length <= 0 || arguments[0] === undefined ? _stavebarline.Barline.type.SINGLE : arguments[0];
	
	    _classCallCheck(this, BarNote);
	
	    var _this = _possibleConstructorReturn(this, (BarNote.__proto__ || Object.getPrototypeOf(BarNote)).call(this, { duration: 'b' }));
	
	    _this.setAttribute('type', 'BarNote');
	
	    _this.metrics = {
	      widths: {}
	    };
	
	    var TYPE = _stavebarline.Barline.type;
	    _this.metrics.widths = (_this$metrics$widths = {}, _defineProperty(_this$metrics$widths, TYPE.SINGLE, 8), _defineProperty(_this$metrics$widths, TYPE.DOUBLE, 12), _defineProperty(_this$metrics$widths, TYPE.END, 15), _defineProperty(_this$metrics$widths, TYPE.REPEAT_BEGIN, 14), _defineProperty(_this$metrics$widths, TYPE.REPEAT_END, 14), _defineProperty(_this$metrics$widths, TYPE.REPEAT_BOTH, 18), _defineProperty(_this$metrics$widths, TYPE.NONE, 0), _this$metrics$widths);
	
	    // Tell the formatter that bar notes have no duration.
	    _this.ignore_ticks = true;
	    _this.setType(type);
	    return _this;
	  }
	
	  // Get and set the type of Bar note. `type` must be one of `Vex.Flow.Barline.type`.
	
	
	  _createClass(BarNote, [{
	    key: 'getType',
	    value: function getType() {
	      return this.type;
	    }
	  }, {
	    key: 'setType',
	    value: function setType(type) {
	      this.type = typeof type === 'string' ? _stavebarline.Barline.typeString[type] : type;
	
	      // Set width to width of relevant `Barline`.
	      this.setWidth(this.metrics.widths[this.type]);
	      return this;
	    }
	  }, {
	    key: 'getBoundingBox',
	    value: function getBoundingBox() {
	      return new _boundingbox.BoundingBox(0, 0, 0, 0);
	    }
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext() {
	      /* overridden to ignore */
	      return this;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      /* overridden to ignore */
	      this.setPreFormatted(true);
	      return this;
	    }
	
	    // Render note to stave.
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      if (!this.stave) throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	      L('Rendering bar line at: ', this.getAbsoluteX());
	      var barline = new _stavebarline.Barline(this.type);
	      barline.setX(this.getAbsoluteX());
	      barline.draw(this.stave);
	      this.setRendered();
	    }
	  }]);

	  return BarNote;
	}(_note.Note);

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GhostNote = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _vex = __webpack_require__(1);
	
	var _stemmablenote = __webpack_require__(24);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	
	var GhostNote = exports.GhostNote = function (_StemmableNote) {
	  _inherits(GhostNote, _StemmableNote);
	
	  /** @constructor */
	  function GhostNote(parameter) {
	    _classCallCheck(this, GhostNote);
	
	    // Sanity check
	    if (!parameter) {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Ghost note must have valid initialization data to identify ' + 'duration.');
	    }
	
	    var note_struct = void 0;
	
	    // Preserve backwards-compatibility
	    if (typeof parameter === 'string') {
	      note_struct = { duration: parameter };
	    } else if ((typeof parameter === 'undefined' ? 'undefined' : _typeof(parameter)) === 'object') {
	      note_struct = parameter;
	    } else {
	      throw new _vex.Vex.RuntimeError('BadArguments', 'Ghost note must have valid initialization data to identify ' + 'duration.');
	    }
	
	    var _this = _possibleConstructorReturn(this, (GhostNote.__proto__ || Object.getPrototypeOf(GhostNote)).call(this, note_struct));
	
	    _this.setAttribute('type', 'GhostNote');
	
	    // Note properties
	    _this.setWidth(0);
	    return _this;
	  }
	
	  _createClass(GhostNote, [{
	    key: 'isRest',
	    value: function isRest() {
	      return true;
	    }
	  }, {
	    key: 'setStave',
	    value: function setStave(stave) {
	      _get(GhostNote.prototype.__proto__ || Object.getPrototypeOf(GhostNote.prototype), 'setStave', this).call(this, stave);
	    }
	  }, {
	    key: 'addToModifierContext',
	    value: function addToModifierContext() {
	      /* intentionally overridden */return this;
	    }
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      this.setPreFormatted(true);
	      return this;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      if (!this.stave) throw new _vex.Vex.RERR('NoStave', "Can't draw without a stave.");
	
	      // Draw the modifiers
	      this.setRendered();
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        var modifier = this.modifiers[i];
	        modifier.setContext(this.context);
	        modifier.draw();
	      }
	    }
	  }]);

	  return GhostNote;
	}(_stemmablenote.StemmableNote);

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tremolo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _modifier = __webpack_require__(25);
	
	var _glyph = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Mike Corrigan <corrigan@gmail.com>
	//
	// This class implements tremolo notation.
	
	var Tremolo = exports.Tremolo = function (_Modifier) {
	  _inherits(Tremolo, _Modifier);
	
	  _createClass(Tremolo, null, [{
	    key: 'CATEGORY',
	    get: function get() {
	      return 'tremolo';
	    }
	  }]);
	
	  function Tremolo(num) {
	    _classCallCheck(this, Tremolo);
	
	    var _this = _possibleConstructorReturn(this, (Tremolo.__proto__ || Object.getPrototypeOf(Tremolo)).call(this));
	
	    _this.setAttribute('type', 'Tremolo');
	
	    _this.num = num;
	    _this.note = null;
	    _this.index = null;
	    _this.position = _modifier.Modifier.Position.CENTER;
	    _this.code = 'v74';
	    _this.shift_right = -2;
	    _this.y_spacing = 4;
	
	    _this.render_options = {
	      font_scale: 35,
	      stroke_px: 3,
	      stroke_spacing: 10
	    };
	
	    _this.font = {
	      family: 'Arial',
	      size: 16,
	      weight: ''
	    };
	    return _this;
	  }
	
	  _createClass(Tremolo, [{
	    key: 'getCategory',
	    value: function getCategory() {
	      return Tremolo.CATEGORY;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	
	      if (!(this.note && this.index != null)) {
	        throw new _vex.Vex.RERR('NoAttachedNote', "Can't draw Tremolo without a note and index.");
	      }
	
	      this.setRendered();
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var x = start.x;
	      var y = start.y;
	
	      x += this.shift_right;
	      for (var i = 0; i < this.num; ++i) {
	        _glyph.Glyph.renderGlyph(this.context, x, y, this.render_options.font_scale, this.code);
	        y += this.y_spacing;
	      }
	    }
	  }]);

	  return Tremolo;
	}(_modifier.Modifier);

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Crescendo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vex = __webpack_require__(1);
	
	var _note = __webpack_require__(22);
	
	var _tickcontext = __webpack_require__(39);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the `Crescendo` object which draws crescendos and
	// decrescendo dynamics markings. A `Crescendo` is initialized with a
	// duration and formatted as part of a `Voice` like any other `Note`
	// type in VexFlow. This object would most likely be formatted in a Voice
	// with `TextNotes` - which are used to represent other dynamics markings.
	
	// To enable logging for this class. Set `Vex.Flow.Crescendo.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Crescendo.DEBUG) _vex.Vex.L('Vex.Flow.Crescendo', args);
	}
	
	// Private helper to draw the hairpin
	function renderHairpin(ctx, params) {
	  var begin_x = params.begin_x;
	  var end_x = params.end_x;
	  var y = params.y;
	  var half_height = params.height / 2;
	
	  ctx.beginPath();
	
	  if (params.reverse) {
	    ctx.moveTo(begin_x, y - half_height);
	    ctx.lineTo(end_x, y);
	    ctx.lineTo(begin_x, y + half_height);
	  } else {
	    ctx.moveTo(end_x, y - half_height);
	    ctx.lineTo(begin_x, y);
	    ctx.lineTo(end_x, y + half_height);
	  }
	
	  ctx.stroke();
	  ctx.closePath();
	}
	
	var Crescendo = exports.Crescendo = function (_Note) {
	  _inherits(Crescendo, _Note);
	
	  // Initialize the crescendo's properties
	  function Crescendo(note_struct) {
	    _classCallCheck(this, Crescendo);
	
	    var _this = _possibleConstructorReturn(this, (Crescendo.__proto__ || Object.getPrototypeOf(Crescendo)).call(this, note_struct));
	
	    _this.setAttribute('type', 'Crescendo');
	
	    // Whether the object is a decrescendo
	    _this.decrescendo = false;
	
	    // The staff line to be placed on
	    _this.line = note_struct.line || 0;
	
	    // The height at the open end of the cresc/decresc
	    _this.height = 15;
	
	    _vex.Vex.Merge(_this.render_options, {
	      // Extensions to the length of the crescendo on either side
	      extend_left: 0,
	      extend_right: 0,
	      // Vertical shift
	      y_shift: 0
	    });
	    return _this;
	  }
	
	  // Set the line to center the element on
	
	
	  _createClass(Crescendo, [{
	    key: 'setLine',
	    value: function setLine(line) {
	      this.line = line;return this;
	    }
	
	    // Set the full height at the open end
	
	  }, {
	    key: 'setHeight',
	    value: function setHeight(height) {
	      this.height = height;return this;
	    }
	
	    // Set whether the sign should be a descresendo by passing a bool
	    // to `decresc`
	
	  }, {
	    key: 'setDecrescendo',
	    value: function setDecrescendo(decresc) {
	      this.decrescendo = decresc;
	      return this;
	    }
	
	    // Preformat the note
	
	  }, {
	    key: 'preFormat',
	    value: function preFormat() {
	      this.preFormatted = true;return this;
	    }
	
	    // Render the Crescendo object onto the canvas
	
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.checkContext();
	      this.setRendered();
	
	      var tick_context = this.getTickContext();
	      var next_context = _tickcontext.TickContext.getNextContext(tick_context);
	
	      var begin_x = this.getAbsoluteX();
	      var end_x = next_context ? next_context.getX() : this.stave.x + this.stave.width;
	      var y = this.stave.getYForLine(this.line + -3) + 1;
	
	      L('Drawing ', this.decrescendo ? 'decrescendo ' : 'crescendo ', this.height, 'x', begin_x - end_x);
	
	      renderHairpin(this.context, {
	        begin_x: begin_x - this.render_options.extend_left,
	        end_x: end_x + this.render_options.extend_right,
	        y: y + this.render_options.y_shift,
	        height: this.height,
	        reverse: this.decrescendo
	      });
	    }
	  }]);

	  return Crescendo;
	}(_note.Note);

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.System = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// This class implements a musical system, which is a collection of staves,
	// each which can have one or more voices. All voices across all staves in
	// the system are formatted together.
	
	var _element = __webpack_require__(5);
	
	var _factory = __webpack_require__(76);
	
	var _formatter = __webpack_require__(14);
	
	var _note = __webpack_require__(22);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function setDefaults(params, defaults) {
	  var default_options = defaults.options;
	  params = _extends(defaults, params);
	  params.options = _extends(default_options, params.options);
	  return params;
	}
	
	var System = exports.System = function (_Element) {
	  _inherits(System, _Element);
	
	  function System() {
	    var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, System);
	
	    var _this = _possibleConstructorReturn(this, (System.__proto__ || Object.getPrototypeOf(System)).call(this));
	
	    _this.setAttribute('type', 'System');
	    _this.setOptions(params);
	    _this.parts = [];
	    return _this;
	  }
	
	  _createClass(System, [{
	    key: 'setOptions',
	    value: function setOptions() {
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.options = setDefaults(options, {
	        x: 10,
	        y: 10,
	        width: 500,
	        connector: null,
	        spaceBetweenStaves: 12, // stave spaces
	        factory: null,
	        debugFormatter: false,
	        formatIterations: 0, // number of formatter tuning steps
	        options: {}
	      });
	
	      this.factory = this.options.factory || new _factory.Factory({ renderer: { el: null } });
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      _get(System.prototype.__proto__ || Object.getPrototypeOf(System.prototype), 'setContext', this).call(this, context);
	      this.factory.setContext(context);
	      return this;
	    }
	  }, {
	    key: 'addConnector',
	    value: function addConnector() {
	      var type = arguments.length <= 0 || arguments[0] === undefined ? 'double' : arguments[0];
	
	      this.connector = this.factory.StaveConnector({
	        top_stave: this.parts[0].stave,
	        bottom_stave: this.parts[this.parts.length - 1].stave,
	        type: type
	      });
	      return this.connector;
	    }
	  }, {
	    key: 'addStave',
	    value: function addStave(params) {
	      var _this2 = this;
	
	      params = setDefaults(params, {
	        stave: null,
	        voices: [],
	        spaceAbove: 0, // stave spaces
	        spaceBelow: 0, // stave spaces
	        debugNoteMetrics: false,
	        options: {}
	      });
	
	      if (!params.stave) {
	        var options = { left_bar: false };
	        params.stave = this.factory.Stave({
	          x: this.options.x,
	          y: this.options.y,
	          width: this.options.width,
	          options: options
	        });
	      }
	
	      params.voices.forEach(function (voice) {
	        return voice.setContext(_this2.context).setStave(params.stave).getTickables().forEach(function (tickable) {
	          return tickable.setStave(params.stave);
	        });
	      });
	
	      this.parts.push(params);
	      return params.stave;
	    }
	  }, {
	    key: 'format',
	    value: function format() {
	      var _this3 = this;
	
	      var formatter = new _formatter.Formatter();
	      this.formatter = formatter;
	
	      var y = this.options.y;
	      var startX = 0;
	      var allVoices = [];
	      var debugNoteMetricsYs = [];
	
	      // Join the voices for each stave.
	      this.parts.forEach(function (part) {
	        y = y + part.stave.space(part.spaceAbove);
	        part.stave.setY(y);
	        formatter.joinVoices(part.voices);
	        y = y + part.stave.space(part.spaceBelow);
	        y = y + part.stave.space(_this3.options.spaceBetweenStaves);
	        if (part.debugNoteMetrics) {
	          debugNoteMetricsYs.push({ y: y, voice: part.voices[0] });
	          y += 15;
	        }
	        allVoices = allVoices.concat(part.voices);
	
	        startX = Math.max(startX, part.stave.getNoteStartX());
	      });
	
	      // Update the start position of all staves.
	      this.parts.forEach(function (part) {
	        return part.stave.setNoteStartX(startX);
	      });
	      var justifyWidth = this.options.width - (startX - this.options.x) - _note.Note.STAVEPADDING;
	      formatter.format(allVoices, justifyWidth);
	
	      for (var i = 0; i < this.options.formatIterations; i++) {
	        formatter.tune();
	      }
	
	      this.startX = startX;
	      this.debugNoteMetricsYs = debugNoteMetricsYs;
	      this.lastY = y;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      // Render debugging information, if requested.
	      var ctx = this.checkContext();
	      this.setRendered();
	
	      if (this.options.debugFormatter) {
	        _formatter.Formatter.plotDebugging(ctx, this.formatter, this.startX, this.options.y, this.lastY);
	      }
	
	      this.debugNoteMetricsYs.forEach(function (d) {
	        d.voice.getTickables().forEach(function (note) {
	          return _note.Note.plotMetrics(ctx, note, d.y);
	        });
	      });
	    }
	  }]);

	  return System;
	}(_element.Element);

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Factory = exports.X = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Mohit Cheppudira
	//
	// ## Description
	//
	// This file implements a high level API around VexFlow. It will eventually
	// become the canonical way to use VexFlow.
	//
	// *This API is currently DRAFT*
	
	var _vex = __webpack_require__(1);
	
	var _accidental = __webpack_require__(29);
	
	var _articulation = __webpack_require__(37);
	
	var _annotation = __webpack_require__(40);
	
	var _formatter = __webpack_require__(14);
	
	var _frethandfinger = __webpack_require__(28);
	
	var _stringnumber = __webpack_require__(36);
	
	var _textdynamics = __webpack_require__(67);
	
	var _modifiercontext = __webpack_require__(27);
	
	var _renderer = __webpack_require__(10);
	
	var _stave = __webpack_require__(43);
	
	var _stavetie = __webpack_require__(33);
	
	var _staveline = __webpack_require__(68);
	
	var _stavenote = __webpack_require__(20);
	
	var _staveconnector = __webpack_require__(19);
	
	var _system = __webpack_require__(75);
	
	var _tickcontext = __webpack_require__(39);
	
	var _tuplet = __webpack_require__(16);
	
	var _voice = __webpack_require__(18);
	
	var _beam = __webpack_require__(15);
	
	var _curve = __webpack_require__(66);
	
	var _gracenote = __webpack_require__(61);
	
	var _gracenotegroup = __webpack_require__(32);
	
	var _notesubgroup = __webpack_require__(31);
	
	var _easyscore = __webpack_require__(77);
	
	var _timesignote = __webpack_require__(59);
	
	var _clefnote = __webpack_require__(58);
	
	var _pedalmarking = __webpack_require__(69);
	
	var _textbracket = __webpack_require__(70);
	
	var _vibratobracket = __webpack_require__(57);
	
	var _ghostnote = __webpack_require__(72);
	
	var _barnote = __webpack_require__(71);
	
	var _tabnote = __webpack_require__(56);
	
	var _tabstave = __webpack_require__(55);
	
	var _textnote = __webpack_require__(50);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// To enable logging for this class. Set `Vex.Flow.Factory.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Factory.DEBUG) _vex.Vex.L('Vex.Flow.Factory', args);
	}
	
	var X = exports.X = _vex.Vex.MakeException('FactoryError');
	
	function setDefaults() {
	  var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var defaults = arguments[1];
	
	  var default_options = defaults.options;
	  params = _extends(defaults, params);
	  params.options = _extends(default_options, params.options);
	  return params;
	}
	
	var Factory = exports.Factory = function () {
	  function Factory(options) {
	    _classCallCheck(this, Factory);
	
	    L('New factory: ', options);
	    var defaults = {
	      stave: {
	        space: 10
	      },
	      renderer: {
	        context: null,
	        elementId: '',
	        backend: _renderer.Renderer.Backends.SVG,
	        width: 500,
	        height: 200,
	        background: '#FFF'
	      },
	      font: {
	        face: 'Arial',
	        point: 10,
	        style: ''
	      }
	    };
	
	    this.options = defaults;
	    this.setOptions(options);
	  }
	
	  _createClass(Factory, [{
	    key: 'reset',
	    value: function reset() {
	      this.renderQ = [];
	      this.systems = [];
	      this.staves = [];
	      this.voices = [];
	      this.stave = null; // current stave
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return this.options;
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _arr = ['stave', 'renderer', 'font'];
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var key = _arr[_i];
	        _extends(this.options[key], options[key]);
	      }
	      if (this.options.renderer.elementId !== null || this.options.renderer.context) {
	        this.initRenderer();
	      }
	
	      this.reset();
	    }
	  }, {
	    key: 'initRenderer',
	    value: function initRenderer() {
	      var _options$renderer = this.options.renderer;
	      var elementId = _options$renderer.elementId;
	      var backend = _options$renderer.backend;
	      var width = _options$renderer.width;
	      var height = _options$renderer.height;
	      var background = _options$renderer.background;
	
	      if (elementId === '') {
	        throw new X('HTML DOM element not set in Factory');
	      }
	
	      this.context = _renderer.Renderer.buildContext(elementId, backend, width, height, background);
	    }
	  }, {
	    key: 'getContext',
	    value: function getContext() {
	      return this.context;
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      this.context = context;return this;
	    }
	  }, {
	    key: 'getStave',
	    value: function getStave() {
	      return this.stave;
	    }
	  }, {
	    key: 'getVoices',
	    value: function getVoices() {
	      return this.voices;
	    }
	
	    // Returns pixels from current stave spacing.
	
	  }, {
	    key: 'space',
	    value: function space(spacing) {
	      return this.options.stave.space * spacing;
	    }
	  }, {
	    key: 'Stave',
	    value: function Stave(params) {
	      params = setDefaults(params, {
	        x: 0,
	        y: 0,
	        width: this.options.renderer.width - this.space(1),
	        options: {
	          spacing_between_lines_px: this.options.stave.space
	        }
	      });
	
	      var stave = new _stave.Stave(params.x, params.y, params.width, params.options);
	      this.staves.push(stave);
	      stave.setContext(this.context);
	      this.stave = stave;
	      return stave;
	    }
	  }, {
	    key: 'TabStave',
	    value: function TabStave(params) {
	      params = setDefaults(params, {
	        x: 0,
	        y: 0,
	        width: this.options.renderer.width - this.space(1),
	        options: {
	          spacing_between_lines_px: this.options.stave.space * 1.3
	        }
	      });
	
	      var stave = new _tabstave.TabStave(params.x, params.y, params.width, params.options);
	      this.staves.push(stave);
	      stave.setContext(this.context);
	      this.stave = stave;
	      return stave;
	    }
	  }, {
	    key: 'StaveNote',
	    value: function StaveNote(noteStruct) {
	      var note = new _stavenote.StaveNote(noteStruct);
	      if (this.stave) note.setStave(this.stave);
	      note.setContext(this.context);
	      this.renderQ.push(note);
	      return note;
	    }
	  }, {
	    key: 'GhostNote',
	    value: function GhostNote(noteStruct) {
	      var ghostNote = new _ghostnote.GhostNote(noteStruct);
	      if (this.stave) ghostNote.setStave(this.stave);
	      ghostNote.setContext(this.context);
	      this.renderQ.push(ghostNote);
	      return ghostNote;
	    }
	  }, {
	    key: 'TextNote',
	    value: function TextNote(textNoteStruct) {
	      var textNote = new _textnote.TextNote(textNoteStruct);
	      if (this.stave) textNote.setStave(this.stave);
	      textNote.setContext(this.context);
	      this.renderQ.push(textNote);
	      return textNote;
	    }
	  }, {
	    key: 'BarNote',
	    value: function BarNote(params) {
	      params = setDefaults(params, {
	        type: 'single',
	        options: {}
	      });
	
	      var barNote = new _barnote.BarNote(params.type);
	      if (this.stave) barNote.setStave(this.stave);
	      barNote.setContext(this.context);
	      this.renderQ.push(barNote);
	      return barNote;
	    }
	  }, {
	    key: 'ClefNote',
	    value: function ClefNote(params) {
	      params = setDefaults(params, {
	        type: 'treble',
	        options: {
	          size: 'default'
	        }
	      });
	
	      var clefNote = new _clefnote.ClefNote(params.type, params.options.size, params.options.annotation);
	      if (this.stave) clefNote.setStave(this.stave);
	      clefNote.setContext(this.context);
	      this.renderQ.push(clefNote);
	      return clefNote;
	    }
	  }, {
	    key: 'TimeSigNote',
	    value: function TimeSigNote(params) {
	      params = setDefaults(params, {
	        time: '4/4',
	        options: {}
	      });
	
	      var timeSigNote = new _timesignote.TimeSigNote(params.time);
	      if (this.stave) timeSigNote.setStave(this.stave);
	      timeSigNote.setContext(this.context);
	      this.renderQ.push(timeSigNote);
	      return timeSigNote;
	    }
	  }, {
	    key: 'TabNote',
	    value: function TabNote(noteStruct) {
	      var note = new _tabnote.TabNote(noteStruct);
	      if (this.stave) note.setStave(this.stave);
	      note.setContext(this.context);
	      this.renderQ.push(note);
	      return note;
	    }
	  }, {
	    key: 'GraceNote',
	    value: function GraceNote(noteStruct) {
	      var note = new _gracenote.GraceNote(noteStruct);
	      if (this.stave) note.setStave(this.stave);
	      note.setContext(this.context);
	      return note;
	    }
	  }, {
	    key: 'GraceNoteGroup',
	    value: function GraceNoteGroup(params) {
	      var group = new _gracenotegroup.GraceNoteGroup(params.notes, params.slur);
	      group.setContext(this.context);
	      return group;
	    }
	  }, {
	    key: 'Accidental',
	    value: function Accidental(params) {
	      params = setDefaults(params, {
	        type: null,
	        options: {}
	      });
	
	      var accid = new _accidental.Accidental(params.type);
	      accid.setContext(this.context);
	      return accid;
	    }
	  }, {
	    key: 'Annotation',
	    value: function Annotation(params) {
	      params = setDefaults(params, {
	        text: 'p',
	        vJustify: 'below',
	        hJustify: 'center',
	        fontFamily: 'Times',
	        fontSize: 14,
	        fontWeight: 'bold italic',
	        options: {}
	      });
	
	      var annotation = new _annotation.Annotation(params.text);
	      annotation.setJustification(params.hJustify);
	      annotation.setVerticalJustification(params.vJustify);
	      annotation.setFont(params.fontFamily, params.fontSize, params.fontWeight);
	      annotation.setContext(this.context);
	      return annotation;
	    }
	  }, {
	    key: 'Articulation',
	    value: function Articulation(params) {
	      params = setDefaults(params, {
	        type: 'a.',
	        position: 'above',
	        options: {}
	      });
	
	      var articulation = new _articulation.Articulation(params.type);
	      articulation.setPosition(params.position);
	      articulation.setContext(this.context);
	      return articulation;
	    }
	  }, {
	    key: 'TextDynamics',
	    value: function TextDynamics(params) {
	      params = setDefaults(params, {
	        text: 'p',
	        duration: 'q',
	        dots: 0,
	        line: 0,
	        options: {}
	      });
	
	      var text = new _textdynamics.TextDynamics({
	        text: params.text,
	        line: params.line,
	        duration: params.duration,
	        dots: params.dots
	      });
	
	      if (this.stave) text.setStave(this.stave);
	      text.setContext(this.context);
	      this.renderQ.push(text);
	      return text;
	    }
	  }, {
	    key: 'Fingering',
	    value: function Fingering(params) {
	      params = setDefaults(params, {
	        number: '0',
	        position: 'left',
	        options: {}
	      });
	
	      var fingering = new _frethandfinger.FretHandFinger(params.number);
	      fingering.setPosition(params.position);
	      fingering.setContext(this.context);
	      return fingering;
	    }
	  }, {
	    key: 'StringNumber',
	    value: function StringNumber(params) {
	      params = setDefaults(params, {
	        number: '0',
	        position: 'left',
	        options: {}
	      });
	
	      var stringNumber = new _stringnumber.StringNumber(params.number);
	      stringNumber.setPosition(params.position);
	      stringNumber.setContext(this.context);
	      return stringNumber;
	    }
	  }, {
	    key: 'TickContext',
	    value: function TickContext() {
	      return new _tickcontext.TickContext().setContext(this.context);
	    }
	  }, {
	    key: 'ModifierContext',
	    value: function ModifierContext() {
	      return new _modifiercontext.ModifierContext();
	    }
	  }, {
	    key: 'Voice',
	    value: function Voice(params) {
	      params = setDefaults(params, {
	        time: '4/4',
	        options: {}
	      });
	      var voice = new _voice.Voice(params.time);
	      this.voices.push(voice);
	      return voice;
	    }
	  }, {
	    key: 'StaveConnector',
	    value: function StaveConnector(params) {
	      params = setDefaults(params, {
	        top_stave: null,
	        bottom_stave: null,
	        type: 'double',
	        options: {}
	      });
	      var connector = new _staveconnector.StaveConnector(params.top_stave, params.bottom_stave);
	      connector.setType(params.type).setContext(this.context);
	      this.renderQ.push(connector);
	      return connector;
	    }
	  }, {
	    key: 'Formatter',
	    value: function Formatter() {
	      return new _formatter.Formatter();
	    }
	  }, {
	    key: 'Tuplet',
	    value: function Tuplet(params) {
	      params = setDefaults(params, {
	        notes: [],
	        options: {}
	      });
	
	      var tuplet = new _tuplet.Tuplet(params.notes, params.options).setContext(this.context);
	      this.renderQ.push(tuplet);
	      return tuplet;
	    }
	  }, {
	    key: 'Beam',
	    value: function Beam(params) {
	      params = setDefaults(params, {
	        notes: [],
	        options: {
	          autoStem: false,
	          secondaryBeamBreaks: []
	        }
	      });
	
	      var beam = new _beam.Beam(params.notes, params.options.autoStem).setContext(this.context);
	      beam.breakSecondaryAt(params.options.secondaryBeamBreaks);
	      this.renderQ.push(beam);
	      return beam;
	    }
	  }, {
	    key: 'Curve',
	    value: function Curve(params) {
	      params = setDefaults(params, {
	        from: null,
	        to: null,
	        options: {}
	      });
	
	      var curve = new _curve.Curve(params.from, params.to, params.options).setContext(this.context);
	      this.renderQ.push(curve);
	      return curve;
	    }
	  }, {
	    key: 'StaveTie',
	    value: function StaveTie(params) {
	      params = setDefaults(params, {
	        from: null,
	        to: null,
	        first_indices: [0],
	        last_indices: [0],
	        text: null,
	        options: {
	          direction: undefined
	        }
	      });
	
	      var tie = new _stavetie.StaveTie({
	        first_note: params.from,
	        last_note: params.to,
	        first_indices: params.first_indices,
	        last_indices: params.last_indices
	      }, params.text);
	
	      if (params.options.direction) tie.setDirection(params.options.direction);
	      tie.setContext(this.context);
	      this.renderQ.push(tie);
	      return tie;
	    }
	  }, {
	    key: 'StaveLine',
	    value: function StaveLine(params) {
	      params = setDefaults(params, {
	        from: null,
	        to: null,
	        first_indices: [0],
	        last_indices: [0],
	        options: {}
	      });
	
	      var line = new _staveline.StaveLine({
	        first_note: params.from,
	        last_note: params.to,
	        first_indices: params.first_indices,
	        last_indices: params.last_indices
	      });
	
	      if (params.options.text) line.setText(params.options.text);
	      if (params.options.font) line.setFont(params.options.font);
	
	      line.setContext(this.context);
	      this.renderQ.push(line);
	      return line;
	    }
	  }, {
	    key: 'VibratoBracket',
	    value: function VibratoBracket(params) {
	      params = setDefaults(params, {
	        from: null,
	        to: null,
	        options: {
	          harsh: false
	        }
	      });
	
	      var vibratoBracket = new _vibratobracket.VibratoBracket({
	        start: params.from,
	        stop: params.to
	      });
	
	      if (params.options.line) vibratoBracket.setLine(params.options.line);
	      if (params.options.harsh) vibratoBracket.setHarsh(params.options.harsh);
	
	      vibratoBracket.setContext(this.context);
	      this.renderQ.push(vibratoBracket);
	
	      return vibratoBracket;
	    }
	  }, {
	    key: 'TextBracket',
	    value: function TextBracket(params) {
	      params = setDefaults(params, {
	        from: null,
	        to: null,
	        text: '',
	        options: {
	          superscript: '',
	          position: 1
	        }
	      });
	
	      var textBracket = new _textbracket.TextBracket({
	        start: params.from,
	        stop: params.to,
	        text: params.text,
	        superscript: params.options.superscript,
	        position: params.options.position
	      });
	
	      if (params.options.line) textBracket.setLine(params.options.line);
	      if (params.options.font) textBracket.setFont(params.options.font);
	
	      textBracket.setContext(this.context);
	      this.renderQ.push(textBracket);
	      return textBracket;
	    }
	  }, {
	    key: 'System',
	    value: function System() {
	      var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      params.factory = this;
	      var system = new _system.System(params).setContext(this.context);
	      this.systems.push(system);
	      return system;
	    }
	  }, {
	    key: 'EasyScore',
	    value: function EasyScore() {
	      var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      params.factory = this;
	      return new _easyscore.EasyScore(params);
	    }
	  }, {
	    key: 'PedalMarking',
	    value: function PedalMarking() {
	      var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      params = setDefaults(params, {
	        notes: [],
	        options: {
	          style: 'mixed'
	        }
	      });
	
	      var pedal = new _pedalmarking.PedalMarking(params.notes);
	      pedal.setStyle(_pedalmarking.PedalMarking.StylesString[params.options.style]);
	      pedal.setContext(this.context);
	      this.renderQ.push(pedal);
	      return pedal;
	    }
	  }, {
	    key: 'NoteSubGroup',
	    value: function NoteSubGroup() {
	      var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      params = setDefaults(params, {
	        notes: [],
	        options: {}
	      });
	
	      var group = new _notesubgroup.NoteSubGroup(params.notes);
	      group.setContext(this.context);
	      return group;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this = this;
	
	      this.systems.forEach(function (i) {
	        return i.setContext(_this.context).format();
	      });
	      this.staves.forEach(function (i) {
	        return i.setContext(_this.context).draw();
	      });
	      this.voices.forEach(function (i) {
	        return i.setContext(_this.context).draw();
	      });
	      this.renderQ.forEach(function (i) {
	        if (!i.isRendered()) i.setContext(_this.context).draw();
	      });
	      this.systems.forEach(function (i) {
	        return i.setContext(_this.context).draw();
	      });
	      this.reset();
	    }
	  }], [{
	    key: 'newFromElementId',
	    value: function newFromElementId(elementId) {
	      var width = arguments.length <= 1 || arguments[1] === undefined ? 500 : arguments[1];
	      var height = arguments.length <= 2 || arguments[2] === undefined ? 200 : arguments[2];
	
	      return new Factory({ renderer: { elementId: elementId, width: width, height: height } });
	    }
	  }]);

	  return Factory;
	}();

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EasyScore = exports.X = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// This class implements a parser for a simple language to generate
	// VexFlow objects.
	
	var _vex = __webpack_require__(1);
	
	var _stavenote = __webpack_require__(20);
	
	var _parser = __webpack_require__(78);
	
	var _articulation = __webpack_require__(37);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// To enable logging for this class. Set `Vex.Flow.EasyScore.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (EasyScore.DEBUG) _vex.Vex.L('Vex.Flow.EasyScore', args);
	}
	
	var X = exports.X = _vex.Vex.MakeException('EasyScoreError');
	
	var Grammar = function () {
	  function Grammar(builder) {
	    _classCallCheck(this, Grammar);
	
	    this.builder = builder;
	  }
	
	  _createClass(Grammar, [{
	    key: 'begin',
	    value: function begin() {
	      return this.LINE;
	    }
	  }, {
	    key: 'LINE',
	    value: function LINE() {
	      return {
	        expect: [this.PIECE, this.PIECES, this.EOL]
	      };
	    }
	  }, {
	    key: 'PIECE',
	    value: function PIECE() {
	      var _this = this;
	
	      return {
	        expect: [this.CHORDORNOTE, this.PARAMS],
	        run: function run() {
	          return _this.builder.commitPiece();
	        }
	      };
	    }
	  }, {
	    key: 'PIECES',
	    value: function PIECES() {
	      return {
	        expect: [this.COMMA, this.PIECE],
	        zeroOrMore: true
	      };
	    }
	  }, {
	    key: 'PARAMS',
	    value: function PARAMS() {
	      return {
	        expect: [this.DURATION, this.TYPE, this.DOTS, this.OPTS]
	      };
	    }
	  }, {
	    key: 'CHORDORNOTE',
	    value: function CHORDORNOTE() {
	      return {
	        expect: [this.CHORD, this.SINGLENOTE],
	        or: true
	      };
	    }
	  }, {
	    key: 'CHORD',
	    value: function CHORD() {
	      var _this2 = this;
	
	      return {
	        expect: [this.LPAREN, this.NOTES, this.RPAREN],
	        run: function run(state) {
	          return _this2.builder.addChord(state.matches[1]);
	        }
	      };
	    }
	  }, {
	    key: 'NOTES',
	    value: function NOTES() {
	      return {
	        expect: [this.NOTE],
	        oneOrMore: true
	      };
	    }
	  }, {
	    key: 'NOTE',
	    value: function NOTE() {
	      return {
	        expect: [this.NOTENAME, this.ACCIDENTAL, this.OCTAVE]
	      };
	    }
	  }, {
	    key: 'SINGLENOTE',
	    value: function SINGLENOTE() {
	      var _this3 = this;
	
	      return {
	        expect: [this.NOTENAME, this.ACCIDENTAL, this.OCTAVE],
	        run: function run(state) {
	          return _this3.builder.addSingleNote(state.matches[0], state.matches[1], state.matches[2]);
	        }
	      };
	    }
	  }, {
	    key: 'ACCIDENTAL',
	    value: function ACCIDENTAL() {
	      return {
	        expect: [this.ACCIDENTALS],
	        maybe: true
	      };
	    }
	  }, {
	    key: 'DOTS',
	    value: function DOTS() {
	      var _this4 = this;
	
	      return {
	        expect: [this.DOT],
	        zeroOrMore: true,
	        run: function run(state) {
	          return _this4.builder.setNoteDots(state.matches[0]);
	        }
	      };
	    }
	  }, {
	    key: 'TYPE',
	    value: function TYPE() {
	      var _this5 = this;
	
	      return {
	        expect: [this.SLASH, this.MAYBESLASH, this.TYPES],
	        maybe: true,
	        run: function run(state) {
	          return _this5.builder.setNoteType(state.matches[2]);
	        }
	      };
	    }
	  }, {
	    key: 'DURATION',
	    value: function DURATION() {
	      var _this6 = this;
	
	      return {
	        expect: [this.SLASH, this.DURATIONS],
	        maybe: true,
	        run: function run(state) {
	          return _this6.builder.setNoteDuration(state.matches[1]);
	        }
	      };
	    }
	  }, {
	    key: 'OPTS',
	    value: function OPTS() {
	      return {
	        expect: [this.LBRACKET, this.KEYVAL, this.KEYVALS, this.RBRACKET],
	        maybe: true
	      };
	    }
	  }, {
	    key: 'KEYVALS',
	    value: function KEYVALS() {
	      return {
	        expect: [this.COMMA, this.KEYVAL],
	        zeroOrMore: true
	      };
	    }
	  }, {
	    key: 'KEYVAL',
	    value: function KEYVAL() {
	      var _this7 = this;
	
	      var unquote = function unquote(str) {
	        return str.slice(1, -1);
	      };
	
	      return {
	        expect: [this.KEY, this.EQUALS, this.VAL],
	        run: function run(state) {
	          return _this7.builder.addNoteOption(state.matches[0], unquote(state.matches[2]));
	        }
	      };
	    }
	  }, {
	    key: 'VAL',
	    value: function VAL() {
	      return {
	        expect: [this.SVAL, this.DVAL],
	        or: true
	      };
	    }
	  }, {
	    key: 'KEY',
	    value: function KEY() {
	      return { token: '[a-zA-Z][a-zA-Z0-9]*' };
	    }
	  }, {
	    key: 'DVAL',
	    value: function DVAL() {
	      return { token: '["][^"]*["]' };
	    }
	  }, {
	    key: 'SVAL',
	    value: function SVAL() {
	      return { token: "['][^']*[']" };
	    }
	  }, {
	    key: 'NOTENAME',
	    value: function NOTENAME() {
	      return { token: '[a-gA-G]' };
	    }
	  }, {
	    key: 'OCTAVE',
	    value: function OCTAVE() {
	      return { token: '[0-9]+' };
	    }
	  }, {
	    key: 'ACCIDENTALS',
	    value: function ACCIDENTALS() {
	      return { token: 'bbs|bb|bss|bs|b|db|d|##|#|n|\\+\\+-|\\+-|\\+\\+|\\+|k|o' };
	    }
	  }, {
	    key: 'DURATIONS',
	    value: function DURATIONS() {
	      return { token: '[0-9whq]+' };
	    }
	  }, {
	    key: 'TYPES',
	    value: function TYPES() {
	      return { token: '[rRsSxX]' };
	    }
	  }, {
	    key: 'LPAREN',
	    value: function LPAREN() {
	      return { token: '[(]' };
	    }
	  }, {
	    key: 'RPAREN',
	    value: function RPAREN() {
	      return { token: '[)]' };
	    }
	  }, {
	    key: 'COMMA',
	    value: function COMMA() {
	      return { token: '[,]' };
	    }
	  }, {
	    key: 'DOT',
	    value: function DOT() {
	      return { token: '[.]' };
	    }
	  }, {
	    key: 'SLASH',
	    value: function SLASH() {
	      return { token: '[/]' };
	    }
	  }, {
	    key: 'MAYBESLASH',
	    value: function MAYBESLASH() {
	      return { token: '[/]?' };
	    }
	  }, {
	    key: 'EQUALS',
	    value: function EQUALS() {
	      return { token: '[=]' };
	    }
	  }, {
	    key: 'LBRACKET',
	    value: function LBRACKET() {
	      return { token: '\\[' };
	    }
	  }, {
	    key: 'RBRACKET',
	    value: function RBRACKET() {
	      return { token: '\\]' };
	    }
	  }, {
	    key: 'EOL',
	    value: function EOL() {
	      return { token: '$' };
	    }
	  }]);
	
	  return Grammar;
	}();
	
	var Builder = function () {
	  function Builder(factory) {
	    _classCallCheck(this, Builder);
	
	    this.factory = factory;
	    this.commitHooks = [];
	    this.reset();
	  }
	
	  _createClass(Builder, [{
	    key: 'reset',
	    value: function reset() {
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.options = {
	        stem: 'auto',
	        clef: 'treble'
	      };
	      this.elements = {
	        notes: [],
	        accidentals: []
	      };
	      this.rollingDuration = '8';
	      this.resetPiece();
	      _extends(this.options, options);
	    }
	  }, {
	    key: 'getFactory',
	    value: function getFactory() {
	      return this.factory;
	    }
	  }, {
	    key: 'getElements',
	    value: function getElements() {
	      return this.elements;
	    }
	  }, {
	    key: 'addCommitHook',
	    value: function addCommitHook(commitHook) {
	      this.commitHooks.push(commitHook);
	    }
	  }, {
	    key: 'resetPiece',
	    value: function resetPiece() {
	      L('resetPiece');
	      this.piece = {
	        chord: [],
	        duration: this.rollingDuration,
	        dots: 0,
	        type: undefined,
	        options: {}
	      };
	    }
	  }, {
	    key: 'setNoteDots',
	    value: function setNoteDots(dots) {
	      L('setNoteDots:', dots);
	      if (dots) this.piece.dots = dots.length;
	    }
	  }, {
	    key: 'setNoteDuration',
	    value: function setNoteDuration(duration) {
	      L('setNoteDuration:', duration);
	      this.rollingDuration = this.piece.duration = duration || this.rollingDuration;
	    }
	  }, {
	    key: 'setNoteType',
	    value: function setNoteType(type) {
	      L('setNoteType:', type);
	      if (type) this.piece.type = type;
	    }
	  }, {
	    key: 'addNoteOption',
	    value: function addNoteOption(key, value) {
	      L('addNoteOption: key:', key, 'value:', value);
	      this.piece.options[key] = value;
	    }
	  }, {
	    key: 'addNote',
	    value: function addNote(key, accid, octave) {
	      L('addNote:', key, accid, octave);
	      this.piece.chord.push({ key: key, accid: accid, octave: octave });
	    }
	  }, {
	    key: 'addSingleNote',
	    value: function addSingleNote(key, accid, octave) {
	      L('addSingleNote:', key, accid, octave);
	      this.addNote(key, accid, octave);
	    }
	  }, {
	    key: 'addChord',
	    value: function addChord(notes) {
	      var _this8 = this;
	
	      L('startChord');
	      if (_typeof(notes[0]) !== 'object') {
	        this.addSingleNote(notes[0]);
	      } else {
	        notes.forEach(function (n) {
	          if (n) _this8.addNote.apply(_this8, _toConsumableArray(n));
	        });
	      }
	      L('endChord');
	    }
	  }, {
	    key: 'commitPiece',
	    value: function commitPiece() {
	      var _this9 = this;
	
	      L('commitPiece');
	      var factory = this.factory;
	
	
	      if (!factory) return;
	
	      var options = _extends({}, this.options, this.piece.options);
	      var stem = options.stem;
	      var clef = options.clef;
	
	      var autoStem = stem.toLowerCase() === 'auto';
	      var stemDirection = !autoStem && stem.toLowerCase() === 'up' ? _stavenote.StaveNote.STEM_UP : _stavenote.StaveNote.STEM_DOWN;
	
	      // Build StaveNotes.
	      var _piece = this.piece;
	      var chord = _piece.chord;
	      var duration = _piece.duration;
	      var dots = _piece.dots;
	      var type = _piece.type;
	
	      var keys = chord.map(function (note) {
	        return note.key + '/' + note.octave;
	      });
	      var note = factory.StaveNote({
	        keys: keys,
	        duration: duration,
	        dots: dots,
	        type: type,
	        clef: clef,
	        auto_stem: autoStem
	      });
	      if (!autoStem) note.setStemDirection(stemDirection);
	
	      // Attach accidentals.
	      var accids = chord.map(function (note) {
	        return note.accid || null;
	      });
	      accids.forEach(function (accid, i) {
	        if (accid) note.addAccidental(i, factory.Accidental({ type: accid }));
	      });
	
	      // Attach dots.
	      for (var i = 0; i < dots; i++) {
	        note.addDotToAll();
	      }this.commitHooks.forEach(function (fn) {
	        return fn(options, note, _this9);
	      });
	
	      this.elements.notes.push(note);
	      this.elements.accidentals.concat(accids);
	      this.resetPiece();
	    }
	  }]);
	
	  return Builder;
	}();
	
	function setId(_ref, note) {
	  var id = _ref.id;
	
	  if (id === undefined) return;
	
	  note.setAttribute('id', id);
	}
	
	function setClass(options, note) {
	  if (!options.class) return;
	
	  var commaSeparatedRegex = /\s*,\s*/;
	
	  options.class.split(commaSeparatedRegex).forEach(function (className) {
	    return note.addClass(className);
	  });
	}
	
	var EasyScore = exports.EasyScore = function () {
	  function EasyScore() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, EasyScore);
	
	    this.setOptions(options);
	    this.defaults = {
	      clef: 'treble',
	      time: '4/4',
	      stem: 'auto'
	    };
	  }
	
	  _createClass(EasyScore, [{
	    key: 'set',
	    value: function set(defaults) {
	      _extends(this.defaults, defaults);
	      return this;
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _this10 = this;
	
	      this.options = _extends({
	        factory: null,
	        builder: null,
	        commitHooks: [setId, setClass, _articulation.Articulation.easyScoreHook],
	        throwOnError: false
	      }, options);
	
	      this.factory = this.options.factory;
	      this.builder = this.options.builder || new Builder(this.factory);
	      this.grammar = new Grammar(this.builder);
	      this.parser = new _parser.Parser(this.grammar);
	      this.options.commitHooks.forEach(function (commitHook) {
	        return _this10.addCommitHook(commitHook);
	      });
	      return this;
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(context) {
	      if (this.factory) this.factory.setContext(context);
	      return this;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(line) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      this.builder.reset(options);
	      var result = this.parser.parse(line);
	      if (!result.success && this.options.throwOnError) {
	        throw new X('Error parsing line: ' + line, result);
	      }
	      return result;
	    }
	  }, {
	    key: 'beam',
	    value: function beam(notes) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      this.factory.Beam({ notes: notes, options: options });
	      return notes;
	    }
	  }, {
	    key: 'tuplet',
	    value: function tuplet(notes) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      this.factory.Tuplet({ notes: notes, options: options });
	      return notes;
	    }
	  }, {
	    key: 'notes',
	    value: function notes(line) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      options = _extends({ clef: this.defaults.clef, stem: this.defaults.stem }, options);
	      this.parse(line, options);
	      return this.builder.getElements().notes;
	    }
	  }, {
	    key: 'voice',
	    value: function voice(notes, voiceOptions) {
	      voiceOptions = _extends({ time: this.defaults.time }, voiceOptions);
	      return this.factory.Voice(voiceOptions).addTickables(notes);
	    }
	  }, {
	    key: 'addCommitHook',
	    value: function addCommitHook(commitHook) {
	      return this.builder.addCommitHook(commitHook);
	    }
	  }]);

	  return EasyScore;
	}();

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = exports.X = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// A generic text parsing class for VexFlow.
	
	var _vex = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// To enable logging for this class. Set `Vex.Flow.Parser.DEBUG` to `true`.
	function L() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (Parser.DEBUG) _vex.Vex.L('Vex.Flow.Parser', args);
	}
	
	var X = exports.X = _vex.Vex.MakeException('ParserError');
	
	// Converts parser results into an easy to reference list that can be
	// used in triggers.
	function flattenMatches(results) {
	  if (results.matchedString !== undefined) return results.matchedString;
	  if (results.results) return flattenMatches(results.results);
	  if (results.length === 1) return flattenMatches(results[0]);
	  if (results.length === 0) return null;
	  return results.map(flattenMatches);
	}
	
	// This is the base parser class. Given an arbitrary context-free grammar, it
	// can parse any line and execute code when specific rules are met (e.g.,
	// when a string is terminated.)
	
	var Parser = exports.Parser = function () {
	  // For an example of a simple grammar, take a look at tests/parser_tests.js or
	  // the EasyScore grammar in easyscore.js.
	  function Parser(grammar) {
	    _classCallCheck(this, Parser);
	
	    this.grammar = grammar;
	  }
	
	  // Parse `line` using current grammar. Returns {success: true} if the
	  // line parsed correctly, otherwise returns `{success: false, errorPos: N}`
	  // where `errorPos` is the location of the error in the string.
	
	
	  _createClass(Parser, [{
	    key: 'parse',
	    value: function parse(line) {
	      this.line = line;
	      this.pos = 0;
	      this.errorPos = -1;
	      var results = this.expect(this.grammar.begin());
	      results.errorPos = this.errorPos;
	      return results;
	    }
	  }, {
	    key: 'matchFail',
	    value: function matchFail(returnPos) {
	      if (this.errorPos === -1) this.errorPos = this.pos;
	      this.pos = returnPos;
	    }
	  }, {
	    key: 'matchSuccess',
	    value: function matchSuccess() {
	      this.errorPos = -1;
	    }
	
	    // Look for `token` in this.line[this.pos], and return success
	    // if one is found. `token` is specified as a regular expression.
	
	  }, {
	    key: 'matchToken',
	    value: function matchToken(token) {
	      var noSpace = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var regexp = noSpace ? new RegExp('^((' + token + '))') : new RegExp('^((' + token + ')\\s*)');
	      var workingLine = this.line.slice(this.pos);
	      var result = workingLine.match(regexp);
	      if (result !== null) {
	        return {
	          success: true,
	          matchedString: result[2],
	          incrementPos: result[1].length,
	          pos: this.pos
	        };
	      } else {
	        return {
	          success: false,
	          pos: this.pos
	        };
	      }
	    }
	
	    // Execute rule to match a sequence of tokens (or rules). If `maybe` is
	    // set, then return success even if the token is not found, but reset
	    // the position before exiting.
	
	  }, {
	    key: 'expectOne',
	    value: function expectOne(rule) {
	      var maybe = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var results = [];
	      var pos = this.pos;
	
	      var allMatches = true;
	      var oneMatch = false;
	      maybe = maybe === true || rule.maybe === true;
	
	      // Execute all sub rules in sequence.
	      for (var i = 0; i < rule.expect.length; i++) {
	        var next = rule.expect[i];
	        var localPos = this.pos;
	        var result = this.expect(next);
	
	        // If `rule.or` is set, then return success if any one
	        // of the subrules match, else all subrules must match.
	        if (result.success) {
	          results.push(result);
	          oneMatch = true;
	          if (rule.or) break;
	        } else {
	          allMatches = false;
	          if (!rule.or) {
	            this.pos = localPos;
	            break;
	          }
	        }
	      }
	
	      var gotOne = rule.or && oneMatch || allMatches;
	      var success = gotOne || maybe === true;
	      if (maybe && !gotOne) this.pos = pos;
	      if (success) this.matchSuccess();else this.matchFail(pos);
	      return { success: success, results: results, numMatches: gotOne ? 1 : 0 };
	    }
	
	    // Try to match multiple (one or more) instances of the rule. If `maybe` is set,
	    // then a failed match is also a success (but the position is reset).
	
	  }, {
	    key: 'expectOneOrMore',
	    value: function expectOneOrMore(rule) {
	      var maybe = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      var results = [];
	      var pos = this.pos;
	      var numMatches = 0;
	      var more = true;
	
	      do {
	        var result = this.expectOne(rule);
	        if (result.success) {
	          numMatches++;
	          results.push(result.results);
	        } else {
	          more = false;
	        }
	      } while (more);
	
	      var success = numMatches > 0 || maybe === true;
	      if (maybe && !(numMatches > 0)) this.pos = pos;
	      if (success) this.matchSuccess();else this.matchFail(pos);
	      return { success: success, results: results, numMatches: numMatches };
	    }
	
	    // Match zero or more instances of `rule`. Offloads to `expectOneOrMore`.
	
	  }, {
	    key: 'expectZeroOrMore',
	    value: function expectZeroOrMore(rule) {
	      return this.expectOneOrMore(rule, true);
	    }
	
	    // Execute the rule produced by the provided the `rules` function. This
	    // ofloads to one of the above matchers and consolidates the results. It is also
	    // responsible for executing any code triggered by the rule (in `rule.run`.)
	
	  }, {
	    key: 'expect',
	    value: function expect(rules) {
	      L('Evaluating rules:', rules);
	      var result = void 0;
	      if (!rules) {
	        throw new X('Invalid Rule: ' + rules, rules);
	      }
	
	      // Get rule from Grammar class.
	      var rule = rules.bind(this.grammar)();
	
	      if (rule.token) {
	        // Base case: parse the regex and throw an error if the
	        // line doesn't match.
	        result = this.matchToken(rule.token, rule.noSpace === true);
	        if (result.success) {
	          // Token match! Update position and throw away parsed portion
	          // of string.
	          this.pos += result.incrementPos;
	        }
	      } else if (rule.expect) {
	        if (rule.oneOrMore) {
	          result = this.expectOneOrMore(rule);
	        } else if (rule.zeroOrMore) {
	          result = this.expectZeroOrMore(rule);
	        } else {
	          result = this.expectOne(rule);
	        }
	      } else {
	        throw new X('Bad grammar! No `token` or `expect` property', rule);
	      }
	
	      // If there's a trigger attached to this rule, then pull it.
	      result.matches = [];
	      if (result.results) result.results.forEach(function (r) {
	        return result.matches.push(flattenMatches(r));
	      });
	      if (rule.run && result.success) rule.run(result);
	      return result;
	    }
	  }]);

	  return Parser;
	}();

/***/ }
/******/ ])
});
;
//# sourceMappingURL=vexflow-debug.js.map

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_array__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tonal_note__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tonal_interval__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tonal_distance__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tonal_dictionary__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tonal_scale__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tonal_chord__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tonal_pcset__ = __webpack_require__(100);
/* unused harmony reexport Array */
/* unused harmony reexport Note */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_tonal_interval__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3_tonal_distance__; });
/* unused harmony reexport Scale */
/* unused harmony reexport Chord */
/* unused harmony reexport PcSet */
/* unused harmony reexport Dictionary */
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-key.svg?style=flat-square)](https://www.npmjs.com/package/tonal-key)
 *
 * The `Tonal` module is a facade to the rest of the modules. They are namespaced,
 * so for example to use `pc` function from `tonal-note` you have to write:
 * `Tonal.Note.pc`
 *
 * It exports the following modules:
 * - Note
 * - Interval
 * - Distance
 * - Scale
 * - Chord
 * - PcSet
 *
 * Additionally this facade exports some functions without namespace (see "Methods" below)
 *
 * @example
 * // es6 modules
 * import * as Tonal from "tonal"
 * Tonal.Note.name("cx") // => "C##"
 *
 * @example
 * import { Note } from "tonal"
 * Note.name("bb") // => "Bb"
 *
 * @example
 * // es5 node modules
 * var Tonal = require("tonal");
 * Tonal.Distance.transpose(Tonal.Note.pc("C#2"), "M3") // => "E#"
 * Tonal.Chord.notes("Dmaj7") // => ["D", "F#", "A", "C#"]
 *
 * @module Tonal
 */











/**
 * Transpose a note by an interval
 * @function
 * @param {String} note
 * @param {String} interval
 * @return {String} the transported note
 * @see Distance.transpose
 */
const transpose = __WEBPACK_IMPORTED_MODULE_3_tonal_distance__["transpose"];
/* unused harmony export transpose */


/**
 * Get the interval from two notes
 * @function
 * @param {String} from
 * @param {String} to
 * @return {String} the interval in reverse shorthand notation
 * @see Distance.interval
 */
const interval = __WEBPACK_IMPORTED_MODULE_3_tonal_distance__["interval"];
/* unused harmony export interval */


/**
 * Get note properties
 * @function
 * @param {String} note - the note name
 * @return {Object}
 * @see Note.props
 * @example
 * Tonal.note("A4").chroma // => 9
 */
const note = __WEBPACK_IMPORTED_MODULE_1_tonal_note__["g" /* props */];
/* unused harmony export note */


/**
 * Get midi note number
 * @function
 * @param {String} note
 * @return {Number}
 * @see Note.midi
 * @example
 * Tonal.midi("A4") // => 49
 */
const midi = __WEBPACK_IMPORTED_MODULE_1_tonal_note__["d" /* midi */];
/* unused harmony export midi */


/**
 * Get note frequency using equal tempered tuning at 440
 * @function
 * @param {String} note
 * @return {Number}
 * @see Note.freq
 * @example
 * Tonal.freq("A4") // => 440
 */
const freq = __WEBPACK_IMPORTED_MODULE_1_tonal_note__["c" /* freq */];
/* unused harmony export freq */


/**
 * Get intervals from a chord type
 * @function
 * @param {String} type - the chord type (no tonic)
 * @return {Array} an array of intervals or undefined if the chord type is not known
 * @see Dictionary.chord
 * @example
 * Tonal.chord("m7b5") // => ["1P", "3m", "5d", "7m"]
 */
const chord = __WEBPACK_IMPORTED_MODULE_4_tonal_dictionary__["a" /* chord */];
/* unused harmony export chord */


/**
 * Get intervals from scale name
 * @function
 * @param {String} name - the scale name (without tonic)
 * @return {Array} an array of intervals or undefiend if the scale is not kown
 * @example
 * Tonal.scale("major") // => ["1P", "2M", "3M"...]
 */
const scale = __WEBPACK_IMPORTED_MODULE_4_tonal_dictionary__["b" /* scale */];
/* unused harmony export scale */



/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"chromatic":["1P 2m 2M 3m 3M 4P 4A 5P 6m 6M 7m 7M"],"lydian":["1P 2M 3M 4A 5P 6M 7M"],"major":["1P 2M 3M 4P 5P 6M 7M",["ionian"]],"mixolydian":["1P 2M 3M 4P 5P 6M 7m",["dominant"]],"dorian":["1P 2M 3m 4P 5P 6M 7m"],"aeolian":["1P 2M 3m 4P 5P 6m 7m",["minor"]],"phrygian":["1P 2m 3m 4P 5P 6m 7m"],"locrian":["1P 2m 3m 4P 5d 6m 7m"],"melodic minor":["1P 2M 3m 4P 5P 6M 7M"],"melodic minor second mode":["1P 2m 3m 4P 5P 6M 7m"],"lydian augmented":["1P 2M 3M 4A 5A 6M 7M"],"lydian dominant":["1P 2M 3M 4A 5P 6M 7m",["lydian b7"]],"melodic minor fifth mode":["1P 2M 3M 4P 5P 6m 7m",["hindu","mixolydian b6M"]],"locrian #2":["1P 2M 3m 4P 5d 6m 7m"],"locrian major":["1P 2M 3M 4P 5d 6m 7m",["arabian"]],"altered":["1P 2m 3m 3M 5d 6m 7m",["super locrian","diminished whole tone","pomeroy"]],"major pentatonic":["1P 2M 3M 5P 6M",["pentatonic"]],"lydian pentatonic":["1P 3M 4A 5P 7M",["chinese"]],"mixolydian pentatonic":["1P 3M 4P 5P 7m",["indian"]],"locrian pentatonic":["1P 3m 4P 5d 7m",["minor seven flat five pentatonic"]],"minor pentatonic":["1P 3m 4P 5P 7m"],"minor six pentatonic":["1P 3m 4P 5P 6M"],"minor hexatonic":["1P 2M 3m 4P 5P 7M"],"flat three pentatonic":["1P 2M 3m 5P 6M",["kumoi"]],"flat six pentatonic":["1P 2M 3M 5P 6m"],"major flat two pentatonic":["1P 2m 3M 5P 6M"],"whole tone pentatonic":["1P 3M 5d 6m 7m"],"ionian pentatonic":["1P 3M 4P 5P 7M"],"lydian #5P pentatonic":["1P 3M 4A 5A 7M"],"lydian dominant pentatonic":["1P 3M 4A 5P 7m"],"minor #7M pentatonic":["1P 3m 4P 5P 7M"],"super locrian pentatonic":["1P 3m 4d 5d 7m"],"in-sen":["1P 2m 4P 5P 7m"],"iwato":["1P 2m 4P 5d 7m"],"hirajoshi":["1P 2M 3m 5P 6m"],"kumoijoshi":["1P 2m 4P 5P 6m"],"pelog":["1P 2m 3m 5P 6m"],"vietnamese 1":["1P 3m 4P 5P 6m"],"vietnamese 2":["1P 3m 4P 5P 7m"],"prometheus":["1P 2M 3M 4A 6M 7m"],"prometheus neopolitan":["1P 2m 3M 4A 6M 7m"],"ritusen":["1P 2M 4P 5P 6M"],"scriabin":["1P 2m 3M 5P 6M"],"piongio":["1P 2M 4P 5P 6M 7m"],"major blues":["1P 2M 3m 3M 5P 6M"],"minor blues":["1P 3m 4P 5d 5P 7m",["blues"]],"composite blues":["1P 2M 3m 3M 4P 5d 5P 6M 7m"],"augmented":["1P 2A 3M 5P 5A 7M"],"augmented heptatonic":["1P 2A 3M 4P 5P 5A 7M"],"dorian #4":["1P 2M 3m 4A 5P 6M 7m"],"lydian diminished":["1P 2M 3m 4A 5P 6M 7M"],"whole tone":["1P 2M 3M 4A 5A 7m"],"leading whole tone":["1P 2M 3M 4A 5A 7m 7M"],"harmonic minor":["1P 2M 3m 4P 5P 6m 7M"],"lydian minor":["1P 2M 3M 4A 5P 6m 7m"],"neopolitan":["1P 2m 3m 4P 5P 6m 7M"],"neopolitan minor":["1P 2m 3m 4P 5P 6m 7M"],"neopolitan major":["1P 2m 3m 4P 5P 6M 7M",["dorian b2"]],"neopolitan major pentatonic":["1P 3M 4P 5d 7m"],"romanian minor":["1P 2M 3m 5d 5P 6M 7m"],"double harmonic lydian":["1P 2m 3M 4A 5P 6m 7M"],"diminished":["1P 2M 3m 4P 5d 6m 6M 7M"],"harmonic major":["1P 2M 3M 4P 5P 6m 7M"],"double harmonic major":["1P 2m 3M 4P 5P 6m 7M",["gypsy"]],"egyptian":["1P 2M 4P 5P 7m"],"hungarian minor":["1P 2M 3m 4A 5P 6m 7M"],"hungarian major":["1P 2A 3M 4A 5P 6M 7m"],"oriental":["1P 2m 3M 4P 5d 6M 7m"],"spanish":["1P 2m 3M 4P 5P 6m 7m",["phrygian major"]],"spanish heptatonic":["1P 2m 3m 3M 4P 5P 6m 7m"],"flamenco":["1P 2m 3m 3M 4A 5P 7m"],"balinese":["1P 2m 3m 4P 5P 6m 7M"],"todi raga":["1P 2m 3m 4A 5P 6m 7M"],"malkos raga":["1P 3m 4P 6m 7m"],"kafi raga":["1P 3m 3M 4P 5P 6M 7m 7M"],"purvi raga":["1P 2m 3M 4P 4A 5P 6m 7M"],"persian":["1P 2m 3M 4P 5d 6m 7M"],"bebop":["1P 2M 3M 4P 5P 6M 7m 7M"],"bebop dominant":["1P 2M 3M 4P 5P 6M 7m 7M"],"bebop minor":["1P 2M 3m 3M 4P 5P 6M 7m"],"bebop major":["1P 2M 3M 4P 5P 5A 6M 7M"],"bebop locrian":["1P 2m 3m 4P 5d 5P 6m 7m"],"minor bebop":["1P 2M 3m 4P 5P 6m 7m 7M"],"mystery #1":["1P 2m 3M 5d 6m 7m"],"enigmatic":["1P 2m 3M 5d 6m 7m 7M"],"minor six diminished":["1P 2M 3m 4P 5P 6m 6M 7M"],"ionian augmented":["1P 2M 3M 4P 5A 6M 7M"],"lydian #9":["1P 2m 3M 4A 5P 6M 7M"],"ichikosucho":["1P 2M 3M 4P 5d 5P 6M 7M"],"six tone symmetric":["1P 2m 3M 4P 5A 6M"]}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {"4":["1P 4P 7m 10m",["quartal"]],"5":["1P 5P"],"7":["1P 3M 5P 7m",["Dominant","Dom"]],"9":["1P 3M 5P 7m 9M",["79"]],"11":["1P 5P 7m 9M 11P"],"13":["1P 3M 5P 7m 9M 13M",["13_"]],"64":["5P 8P 10M"],"M":["1P 3M 5P",["Major",""]],"M#5":["1P 3M 5A",["augmented","maj#5","Maj#5","+","aug"]],"M#5add9":["1P 3M 5A 9M",["+add9"]],"M13":["1P 3M 5P 7M 9M 13M",["maj13","Maj13"]],"M13#11":["1P 3M 5P 7M 9M 11A 13M",["maj13#11","Maj13#11","M13+4","M13#4"]],"M6":["1P 3M 5P 13M",["6"]],"M6#11":["1P 3M 5P 6M 11A",["M6b5","6#11","6b5"]],"M69":["1P 3M 5P 6M 9M",["69"]],"M69#11":["1P 3M 5P 6M 9M 11A"],"M7#11":["1P 3M 5P 7M 11A",["maj7#11","Maj7#11","M7+4","M7#4"]],"M7#5":["1P 3M 5A 7M",["maj7#5","Maj7#5","maj9#5","M7+"]],"M7#5sus4":["1P 4P 5A 7M"],"M7#9#11":["1P 3M 5P 7M 9A 11A"],"M7add13":["1P 3M 5P 6M 7M 9M"],"M7b5":["1P 3M 5d 7M"],"M7b6":["1P 3M 6m 7M"],"M7b9":["1P 3M 5P 7M 9m"],"M7sus4":["1P 4P 5P 7M"],"M9":["1P 3M 5P 7M 9M",["maj9","Maj9"]],"M9#11":["1P 3M 5P 7M 9M 11A",["maj9#11","Maj9#11","M9+4","M9#4"]],"M9#5":["1P 3M 5A 7M 9M",["Maj9#5"]],"M9#5sus4":["1P 4P 5A 7M 9M"],"M9b5":["1P 3M 5d 7M 9M"],"M9sus4":["1P 4P 5P 7M 9M"],"Madd9":["1P 3M 5P 9M",["2","add9","add2"]],"Maj7":["1P 3M 5P 7M",["maj7","M7"]],"Mb5":["1P 3M 5d"],"Mb6":["1P 3M 13m"],"Msus2":["1P 2M 5P",["add9no3","sus2"]],"Msus4":["1P 4P 5P",["sus","sus4"]],"Maddb9":["1P 3M 5P 9m"],"11b9":["1P 5P 7m 9m 11P"],"13#11":["1P 3M 5P 7m 9M 11A 13M",["13+4","13#4"]],"13#9":["1P 3M 5P 7m 9A 13M",["13#9_"]],"13#9#11":["1P 3M 5P 7m 9A 11A 13M"],"13b5":["1P 3M 5d 6M 7m 9M"],"13b9":["1P 3M 5P 7m 9m 13M"],"13b9#11":["1P 3M 5P 7m 9m 11A 13M"],"13no5":["1P 3M 7m 9M 13M"],"13sus4":["1P 4P 5P 7m 9M 13M",["13sus"]],"69#11":["1P 3M 5P 6M 9M 11A"],"7#11":["1P 3M 5P 7m 11A",["7+4","7#4","7#11_","7#4_"]],"7#11b13":["1P 3M 5P 7m 11A 13m",["7b5b13"]],"7#5":["1P 3M 5A 7m",["+7","7aug","aug7"]],"7#5#9":["1P 3M 5A 7m 9A",["7alt","7#5#9_","7#9b13_"]],"7#5b9":["1P 3M 5A 7m 9m"],"7#5b9#11":["1P 3M 5A 7m 9m 11A"],"7#5sus4":["1P 4P 5A 7m"],"7#9":["1P 3M 5P 7m 9A",["7#9_"]],"7#9#11":["1P 3M 5P 7m 9A 11A",["7b5#9"]],"7#9#11b13":["1P 3M 5P 7m 9A 11A 13m"],"7#9b13":["1P 3M 5P 7m 9A 13m"],"7add6":["1P 3M 5P 7m 13M",["67","7add13"]],"7b13":["1P 3M 7m 13m"],"7b5":["1P 3M 5d 7m"],"7b6":["1P 3M 5P 6m 7m"],"7b9":["1P 3M 5P 7m 9m"],"7b9#11":["1P 3M 5P 7m 9m 11A",["7b5b9"]],"7b9#9":["1P 3M 5P 7m 9m 9A"],"7b9b13":["1P 3M 5P 7m 9m 13m"],"7b9b13#11":["1P 3M 5P 7m 9m 11A 13m",["7b9#11b13","7b5b9b13"]],"7no5":["1P 3M 7m"],"7sus4":["1P 4P 5P 7m",["7sus"]],"7sus4b9":["1P 4P 5P 7m 9m",["susb9","7susb9","7b9sus","7b9sus4","phryg"]],"7sus4b9b13":["1P 4P 5P 7m 9m 13m",["7b9b13sus4"]],"9#11":["1P 3M 5P 7m 9M 11A",["9+4","9#4","9#11_","9#4_"]],"9#11b13":["1P 3M 5P 7m 9M 11A 13m",["9b5b13"]],"9#5":["1P 3M 5A 7m 9M",["9+"]],"9#5#11":["1P 3M 5A 7m 9M 11A"],"9b13":["1P 3M 7m 9M 13m"],"9b5":["1P 3M 5d 7m 9M"],"9no5":["1P 3M 7m 9M"],"9sus4":["1P 4P 5P 7m 9M",["9sus"]],"m":["1P 3m 5P"],"m#5":["1P 3m 5A",["m+","mb6"]],"m11":["1P 3m 5P 7m 9M 11P",["_11"]],"m11A 5":["1P 3m 6m 7m 9M 11P"],"m11b5":["1P 3m 7m 12d 2M 4P",["h11","_11b5"]],"m13":["1P 3m 5P 7m 9M 11P 13M",["_13"]],"m6":["1P 3m 4P 5P 13M",["_6"]],"m69":["1P 3m 5P 6M 9M",["_69"]],"m7":["1P 3m 5P 7m",["minor7","_","_7"]],"m7#5":["1P 3m 6m 7m"],"m7add11":["1P 3m 5P 7m 11P",["m7add4"]],"m7b5":["1P 3m 5d 7m",["half-diminished","h7","_7b5"]],"m9":["1P 3m 5P 7m 9M",["_9"]],"m9#5":["1P 3m 6m 7m 9M"],"m9b5":["1P 3m 7m 12d 2M",["h9","-9b5"]],"mMaj7":["1P 3m 5P 7M",["mM7","_M7"]],"mMaj7b6":["1P 3m 5P 6m 7M",["mM7b6"]],"mM9":["1P 3m 5P 7M 9M",["mMaj9","-M9"]],"mM9b6":["1P 3m 5P 6m 7M 9M",["mMaj9b6"]],"mb6M7":["1P 3m 6m 7M"],"mb6b9":["1P 3m 6m 9m"],"o":["1P 3m 5d",["mb5","dim"]],"o7":["1P 3m 5d 13M",["diminished","m6b5","dim7"]],"o7M7":["1P 3m 5d 6M 7M"],"oM7":["1P 3m 5d 7M"],"sus24":["1P 2M 4P 5P",["sus4add9"]],"+add#9":["1P 3M 5A 9A"],"madd4":["1P 3m 4P 5P"],"madd9":["1P 3m 5P 9M"]}

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* unused harmony export names */
/* unused harmony export intervals */
/* unused harmony export notes */
/* unused harmony export exists */
/* unused harmony export tokenize */
/* unused harmony export modeNames */
/* unused harmony export chords */
/* unused harmony export toScale */
/* unused harmony export supersets */
/* unused harmony export subsets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_note__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tonal_pcset__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tonal_distance__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tonal_array__ = __webpack_require__(147);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-scale.svg?style=flat-square)](https://www.npmjs.com/package/tonal-scale)
 *
 * A scale is a collection of pitches in ascending or descending order.
 *
 * This module provides functions to get and manipulate scales.
 *
 * @example
 * // es6
 * import * as Scale from "tonal-scale"
 * // es5
 * const Scale = require("tonal-scale");
 *
 * @example
 * Scale.notes("Ab bebop") // => [ "Ab", "Bb", "C", "Db", "Eb", "F", "Gb", "G" ]
 * Scale.names() => ["major", "minor", ...]
 * @module Scale
 */






var NO_SCALE = Object.freeze({
  name: null,
  intervals: [],
  names: [],
  chroma: null,
  setnum: null
});

var properties = function (name) {
  var intervals = Object(__WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */])(name);
  if (!intervals) { return NO_SCALE; }
  var s = { intervals: intervals, name: name };
  s.chroma = Object(__WEBPACK_IMPORTED_MODULE_1_tonal_pcset__["a" /* chroma */])(intervals);
  s.setnum = parseInt(s.chroma, 2);
  s.names = __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */].names(s.chroma);
  return Object.freeze(s);
};

var memoize = function (fn, cache) { return function (str) { return cache[str] || (cache[str] = fn(str)); }; };

/**
 * Get scale properties. It returns an object with:
 * - name: the scale name
 * - names: a list with all possible names (includes the current)
 * - intervals: an array with the scale intervals
 * - chroma:  scale croma (see pcset)
 * - setnum: scale chroma number
 *
 * @function
 * @param {String} name - the scale name (without tonic)
 * @return {Object}
 */
var props = memoize(properties, {});

/**
 * Return the available scale names
 *
 * @function
 * @param {boolean} aliases - true to include aliases
 * @return {Array} the scale names
 *
 * @example
 * Scale.names() // => ["maj7", ...]
 */
var names = __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */].names;

/**
 * Given a scale name, return its intervals. The name can be the type and
 * optionally the tonic (which is ignored)
 *
 * It retruns an empty array when no scale found
 *
 * @function
 * @param {String} name - the scale name (tonic and type, tonic is optional)
 * @return {Array<String>} the scale intervals if is a known scale or an empty
 * array if no scale found
 * @example
 * Scale.intervals("major") // => [ "1P", "2M", "3M", "4P", "5P", "6M", "7M" ]
 */
var intervals = function (name) {
  var p = tokenize(name);
  return props(p[1]).intervals;
};

/**
 * Get the notes (pitch classes) of a scale.
 *
 * Note that it always returns an array, and the values are only pitch classes.
 *
 * @function
 * @param {String} tonic
 * @param {String} nameOrTonic - the scale name or tonic (if 2nd param)
 * @param {String} [name] - the scale name without tonic
 * @return {Array} a pitch classes array
 *
 * @example
 * Scale.notes("C", "major") // => [ "C", "D", "E", "F", "G", "A", "B" ]
 * Scale.notes("C major") // => [ "C", "D", "E", "F", "G", "A", "B" ]
 * Scale.notes("C4", "major") // => [ "C", "D", "E", "F", "G", "A", "B" ]
 * Scale.notes("A4", "no-scale") // => []
 * Scale.notes("blah", "major") // => []
 */
function notes(nameOrTonic, name) {
  var p = tokenize(nameOrTonic);
  name = name || p[1];
  return intervals(name).map(Object(__WEBPACK_IMPORTED_MODULE_2_tonal_distance__["transpose"])(p[0]));
}

/**
 * Check if the given name is a known scale from the scales dictionary
 *
 * @function
 * @param {String} name - the scale name
 * @return {Boolean}
 */
function exists(name) {
  var p = tokenize(name);
  return Object(__WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */])(p[1]) !== undefined;
}

/**
 * Given a string with a scale name and (optionally) a tonic, split
 * that components.
 *
 * It retuns an array with the form [ name, tonic ] where tonic can be a
 * note name or null and name can be any arbitrary string
 * (this function doesn"t check if that scale name exists)
 *
 * @function
 * @param {String} name - the scale name
 * @return {Array} an array [tonic, name]
 * @example
 * Scale.tokenize("C mixolydean") // => ["C", "mixolydean"]
 * Scale.tokenize("anything is valid") // => ["", "anything is valid"]
 * Scale.tokenize() // => ["", ""]
 */
function tokenize(str) {
  if (typeof str !== "string") { return ["", ""]; }
  var i = str.indexOf(" ");
  var tonic = Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["e" /* name */])(str.substring(0, i)) || Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["e" /* name */])(str) || "";
  var name = tonic !== "" ? str.substring(tonic.length + 1) : str;
  return [tonic, name.length ? name : ""];
}

/**
 * Find mode names of a scale
 *
 * @function
 * @param {String} name - scale name
 */
var modeNames = function (name) {
  var ivls = intervals(name);
  var tonics = notes(name);

  return Object(__WEBPACK_IMPORTED_MODULE_1_tonal_pcset__["d" /* modes */])(ivls)
    .map(function (chroma, i) {
      var name = __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */].names(chroma)[0];
      if (name) { return [tonics[i] || ivls[i], name]; }
    })
    .filter(function (x) { return x; });
};

/**
 * Get all chords that fits a given scale
 *
 * @function
 * @param {String} name
 */
var chords = function (name) {
  var inScale = Object(__WEBPACK_IMPORTED_MODULE_1_tonal_pcset__["b" /* isSubsetOf */])(intervals(name));
  return __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["a" /* chord */].names().filter(function (name) { return inScale(Object(__WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["a" /* chord */])(name)); });
};

/**
 * Given an array of notes, return the scale: a pitch class set starting from
 * the first note of the array
 *
 * @function
 * @param {Array} notes
 * @return {Array}
 */
var toScale = function (notes) {
  var pcset = Object(__WEBPACK_IMPORTED_MODULE_4_tonal_array__["a" /* compact */])(notes.map(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["f" /* pc */]));
  if (!pcset.length) { return pcset; }
  var tonic = pcset[0];
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4_tonal_array__["d" /* unique */])(pcset);
  return Object(__WEBPACK_IMPORTED_MODULE_4_tonal_array__["c" /* rotate */])(scale.indexOf(tonic), scale);
};

/**
 * Get all scales names that are a superset of the given one
 * (has the same notes and at least one more)
 *
 * @function
 * @param {String} name
 * @return {Array} a list of scale names
 */
var supersets = function (name) {
  if (!intervals(name).length) { return []; }
  var isSuperset = Object(__WEBPACK_IMPORTED_MODULE_1_tonal_pcset__["c" /* isSupersetOf */])(intervals(name));
  return __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */].names().filter(function (name) { return isSuperset(Object(__WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */])(name)); });
};

/**
 * Find all scales names that are a subset of the given one
 * (has less notes but all from the given scale)
 *
 * @function
 * @param {String} name
 * @return {Array} a list of scale names
 */
var subsets = function (name) {
  var isSubset = Object(__WEBPACK_IMPORTED_MODULE_1_tonal_pcset__["b" /* isSubsetOf */])(intervals(name));
  return __WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */].names().filter(function (name) { return isSubset(Object(__WEBPACK_IMPORTED_MODULE_3_tonal_dictionary__["b" /* scale */])(name)); });
};


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* unused harmony export props */
/* unused harmony export intervals */
/* unused harmony export notes */
/* unused harmony export exists */
/* unused harmony export supersets */
/* unused harmony export subsets */
/* unused harmony export tokenize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tonal_note__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tonal_distance__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tonal_pcset__ = __webpack_require__(100);
/**
 * [![npm version](https://img.shields.io/npm/v/tonal-chord.svg)](https://www.npmjs.com/package/tonal-chord)
 * [![tonal](https://img.shields.io/badge/tonal-chord-yellow.svg)](https://www.npmjs.com/browse/keyword/tonal)
 *
 * `tonal-chord` is a collection of functions to manipulate musical chords
 *
 * This is part of [tonal](https://www.npmjs.com/package/tonal) music theory library.
 *
 * @example
 * // es6
 * import * as Chord from "tonal-chord"
 * // es5
 * const Chord = require("tonal-chord")
 *
 * @example
 * Chord.notes("CMaj7") // => ["C", "E", "G", "B"]
 *
 * @module Chord
 */





/**
 * Return the available chord names
 *
 * @function
 * @param {boolean} aliases - true to include aliases
 * @return {Array} the chord names
 *
 * @example
 * Chord.names() // => ["maj7", ...]
 */
var names = __WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */].names;

var NO_CHORD = Object.freeze({
  name: null,
  names: [],
  intervals: [],
  chroma: null,
  setnum: null
});

var properties = function (name) {
  var intervals = Object(__WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */])(name);
  if (!intervals) { return NO_CHORD; }
  var s = { intervals: intervals, name: name };
  s.chroma = Object(__WEBPACK_IMPORTED_MODULE_3_tonal_pcset__["a" /* chroma */])(intervals);
  s.setnum = parseInt(s.chroma, 2);
  s.names = __WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */].names(s.chroma);
  return s;
};

var memo = function (fn, cache) {
  if ( cache === void 0 ) cache = {};

  return function (str) { return cache[str] || (cache[str] = fn(str)); };
};

/**
 * Get chord properties. It returns an object with:
 *
 * - name: the chord name
 * - names: a list with all possible names (includes the current)
 * - intervals: an array with the chord intervals
 * - chroma:  chord croma (see pcset)
 * - setnum: chord chroma number
 *
 * @function
 * @param {String} name - the chord name (without tonic)
 * @return {Object} an object with the properties or a object with all properties
 * set to null if not valid chord name
 */
var props = memo(properties);

/**
 * Get chord intervals. It always returns an array
 *
 * @function
 * @param {String} name - the chord name (optionally a tonic and type)
 * @return {Array<String>} a list of intervals or null if the type is not known
 */
var intervals = function (name) { return props(tokenize(name)[1]).intervals; };

/**
 * Get the chord notes of a chord. This function accepts either a chord name
 * (for example: "Cmaj7") or a list of notes.
 *
 * It always returns an array, even if the chord is not found.
 *
 * @function
 * @param {String} nameOrTonic - name of the chord or the tonic (if the second parameter is present)
 * @param {String} [name] - (Optional) name if the first parameter is the tonic
 * @return {Array} an array of notes or an empty array
 *
 * @example
 * Chord.notes("Cmaj7") // => ["C", "E", "G", "B"]
 * Chord.notes("C", "maj7") // => ["C", "E", "G", "B"]
 */
function notes(nameOrTonic, name) {
  var p = tokenize(nameOrTonic);
  name = name || p[1];
  return props(name).intervals.map(Object(__WEBPACK_IMPORTED_MODULE_1_tonal_distance__["transpose"])(p[0]));
}

/**
 * Check if a given name correspond to a chord in the dictionary
 *
 * @function
 * @param {String} name
 * @return {Boolean}
 * @example
 * Chord.exists("CMaj7") // => true
 * Chord.exists("Maj7") // => true
 * Chord.exists("Ablah") // => false
 */
var exists = function (name) { return Object(__WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */])(tokenize(name)[1]) !== undefined; };

/**
 * Get all chords names that are a superset of the given one
 * (has the same notes and at least one more)
 *
 * @function
 * @param {String} name
 * @return {Array} a list of chord names
 */
var supersets = function (name) {
  if (!intervals(name).length) { return []; }
  var isSuperset = Object(__WEBPACK_IMPORTED_MODULE_3_tonal_pcset__["c" /* isSupersetOf */])(intervals(name));
  return __WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */].names().filter(function (name) { return isSuperset(Object(__WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */])(name)); });
};

/**
 * Find all chords names that are a subset of the given one
 * (has less notes but all from the given chord)
 *
 * @function
 * @param {String} name
 * @return {Array} a list of chord names
 */
var subsets = function (name) {
  var isSubset = Object(__WEBPACK_IMPORTED_MODULE_3_tonal_pcset__["b" /* isSubsetOf */])(intervals(name));
  return __WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */].names().filter(function (name) { return isSubset(Object(__WEBPACK_IMPORTED_MODULE_2_tonal_dictionary__["a" /* chord */])(name)); });
};

// 6, 64, 7, 9, 11 and 13 are consider part of the chord
// (see https://github.com/danigb/tonal/issues/55)
var NUM_TYPES = /^(6|64|7|9|11|13)$/;
/**
 * Tokenize a chord name. It returns an array with the tonic and chord type
 * If not tonic is found, all the name is considered the chord name.
 *
 * This function does NOT check if the chord type exists or not. It only tries
 * to split the tonic and chord type.
 *
 * @function
 * @param {String} name - the chord name
 * @return {Array} an array with [type, tonic]
 * @example
 * Chord.tokenize("Cmaj7") // => [ "C", "maj7" ]
 * Chord.tokenize("C7") // => [ "C", "7" ]
 * Chord.tokenize("mMaj7") // => [ "", "mMaj7" ]
 * Chord.tokenize("Cnonsense") // => [ "C", "nonsense" ]
 */
function tokenize(name) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_0_tonal_note__["h" /* tokenize */])(name);
  if (p[0] === "") { return ["", name]; }
  // aug is augmented (see https://github.com/danigb/tonal/issues/55)
  if (p[0] === "A" && p[3] === "ug") { return ["", "aug"]; }

  if (NUM_TYPES.test(p[2])) {
    return [p[0] + p[1], p[2] + p[3]];
  } else {
    return [p[0] + p[1] + p[2], p[3]];
  }
}


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return update; });
var update=function update(){return{type:'UPDATE_SHEET'};};

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/piano-blues-maker",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/piano-blues-maker"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Player__ = __webpack_require__(581);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//import thunk from 'redux-thunk'
var player=new __WEBPACK_IMPORTED_MODULE_3__services_Player__["a" /* default */]();function playerMiddleware(){return function(store){return function(next){return function(action){if(action.type==='PLAY'){var _store$getState=store.getState(),intro=_store$getState.intro,sections=_store$getState.sections,ending=_store$getState.ending,settings=_store$getState.settings,sheet=_store$getState.sheet;player.start([intro].concat(_toConsumableArray(sections),[ending]),{tempo:settings.tempo,swing:settings.swing,key:settings.key,follow:!sheet.isOutdated});player.onFinishPlaying(function(){store.dispatch({type:'PLAY_ENDED'});});}else if(action.type==='STOP'){player.stop();}return next(action);};};};}function configureStore(initialState){var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */],initialState,Object(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(playerMiddleware())));player.loadSamples(function(){return store.dispatch({type:'SAMPLES_LOADED'});});return store;}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intro__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ending__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sheet__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(78);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_6_redux__["combineReducers"])({player:__WEBPACK_IMPORTED_MODULE_0__player__["a" /* default */],settings:__WEBPACK_IMPORTED_MODULE_1__settings__["a" /* default */],intro:__WEBPACK_IMPORTED_MODULE_2__intro__["a" /* default */],ending:__WEBPACK_IMPORTED_MODULE_3__ending__["a" /* default */],sections:__WEBPACK_IMPORTED_MODULE_4__sections__["a" /* default */],sheet:__WEBPACK_IMPORTED_MODULE_5__sheet__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = player;
var initialState={isPlaying:false,isLoading:true};function player(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'PLAY':return Object.assign({},state,{isPlaying:true});case'STOP':return Object.assign({},state,{isPlaying:false});case'PLAY_ENDED':return Object.assign({},state,{isPlaying:false});case'SAMPLES_LOADED':return Object.assign({},state,{isLoading:false});default:return state;}}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = header;
var initialState={tempo:90,swing:true,key:'C',scale:90};function header(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_KEY':return Object.assign({},state,{key:action.key});case'SET_TEMPO':return Object.assign({},state,{tempo:action.tempo});case'TOGGLE_SWING':return Object.assign({},state,{swing:!state.swing});case'SET_SCALE':return Object.assign({},state,{scale:action.scale});default:return state;}}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__presets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(101);
var initialState=__WEBPACK_IMPORTED_MODULE_0__presets__["intros"][Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* getRandomInt */])(0,__WEBPACK_IMPORTED_MODULE_0__presets__["intros"].length)];function intro(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_INTRO':return action.id===null?null:__WEBPACK_IMPORTED_MODULE_0__presets__["intros"].find(function(intro){return intro.id===action.id;});case'REMOVE_ALL':return null;default:return state;}}

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__presets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(101);
var initialState=__WEBPACK_IMPORTED_MODULE_0__presets__["endings"][Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* getRandomInt */])(0,__WEBPACK_IMPORTED_MODULE_0__presets__["endings"].length)];function intro(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_ENDING':return action.id===null?null:__WEBPACK_IMPORTED_MODULE_0__presets__["endings"].find(function(ending){return ending.id===action.id;});case'REMOVE_ALL':return null;default:return state;}}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sections;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__presets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__presets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(101);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var initialState=[createSection(true)];function createSection(){var random=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var rightHandDemoPatterns=__WEBPACK_IMPORTED_MODULE_0__presets___default.a.rightHandPatterns.filter(function(p){return p.demo;});var lhPatternInd=random?Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* getRandomInt */])(1,__WEBPACK_IMPORTED_MODULE_0__presets___default.a.leftHandPatterns.length):0;var rhPatternInd=random?Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* getRandomInt */])(1,rightHandDemoPatterns.length):0;var _presets$leftHandPatt=__WEBPACK_IMPORTED_MODULE_0__presets___default.a.leftHandPatterns[lhPatternInd],lhPhrases=_presets$leftHandPatt.phrases,leftHand=_objectWithoutProperties(_presets$leftHandPatt,['phrases']);var _rightHandDemoPattern=rightHandDemoPatterns[rhPatternInd],rhPhrases=_rightHandDemoPattern.phrases,rightHand=_objectWithoutProperties(_rightHandDemoPattern,['phrases']);lhPhrases.forEach(function(lhPhrase,phraseIndex){lhPhrase.bars.forEach(function(bar,barIndex){bar.trebleVoices=rhPhrases[phraseIndex].bars[barIndex].trebleVoices;});});return{id:Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* generateId */])(),type:'PROGRESSION',leftHand:leftHand,rightHand:rightHand,phrases:lhPhrases};}function sections(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_PATTERN':var hand=action.hand,patternId=action.patternId,sectionId=action.sectionId;var voicesObjectName=hand==='left'?'bassVoices':'trebleVoices';var _presets$$find=__WEBPACK_IMPORTED_MODULE_0__presets___default.a[hand+'HandPatterns'].find(function(pattern){return pattern.id===patternId;}),phrases=_presets$$find.phrases,patternObject=_objectWithoutProperties(_presets$$find,['phrases']);var newSections=state.map(function(section){if(section.id===sectionId){var newPhrases=section.phrases.map(function(phrase,phraseIndex){var newBars=phrase.bars.map(function(bar,barIndex){return Object.assign({},bar,_defineProperty({},voicesObjectName,phrases[phraseIndex].bars[barIndex][voicesObjectName]));});return Object.assign({},phrase,{bars:newBars});});return Object.assign({},section,_defineProperty({},hand+'Hand',patternObject),{phrases:newPhrases});}return section;});return newSections;case'ADD_SECTION':return[].concat(_toConsumableArray(state),[createSection()]);case'CLONE_SECTION':var index=state.findIndex(function(s){return s.id===action.id;});var _state$index=state[index],leftHand=_state$index.leftHand,rightHand=_state$index.rightHand,phrasesOriginal=_state$index.phrases;var phrasesCopy=phrasesOriginal.map(function(phrase){var barsCopy=phrase.bars.map(function(bar){// const trebleVoicesCopy = bar.trebleVoices.map(v => {
//   return v
// })
// const bassVoicesCopy = bar.bassVoices.map(v => {
//   return v
// })
//return {...bar, ...{trebleVoices:trebleVoicesCopy},...{bassVoices:bassVoicesCopy}}
return Object.assign({},bar,{trebleVoices:[].concat(_toConsumableArray(bar.trebleVoices)),bassVoices:[].concat(_toConsumableArray(bar.bassVoices))});});return Object.assign({},phrase,{bars:barsCopy});});var newSection=Object.assign({id:Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* generateId */])(),type:'PROGRESSION',leftHand:Object.assign({},leftHand),rightHand:Object.assign({},rightHand)},{phrases:phrasesCopy});var sectionsClone=[].concat(_toConsumableArray(state));sectionsClone.splice(index+1,0,newSection);return sectionsClone;case'MOVE_SECTION':var id=action.id,direction=action.direction;var oldIndex=state.findIndex(function(s){return s.id===id;});var newIndex=oldIndex+(direction==='UP'?-1:1);if(newIndex<0||newIndex>=state.length){return state;}var section=state[oldIndex];var sectionsCopy=[].concat(_toConsumableArray(state));sectionsCopy.splice(oldIndex,1);sectionsCopy.splice(newIndex,0,section);return sectionsCopy;case'REMOVE_SECTION':return state.filter(function(item){return item.id!==action.id;});case'REMOVE_ALL':return[];default:return state;}}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sheet;
var initialState={isOutdated:false};function sheet(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'UPDATE_SHEET':return{isOutdated:false};case'SET_INTRO':return{isOutdated:true};case'SET_ENDING':return{isOutdated:true};case'SET_PATTERN':return{isOutdated:true};case'ADD_SECTION':return{isOutdated:true};case'REMOVE_SECTION':return{isOutdated:true};case'SET_KEY':return{isOutdated:true};case'SET_SCALE':return{isOutdated:false};case'REMOVE_ALL':return{isOutdated:false};case'CLONE_SECTION':return{isOutdated:true};case'MOVE_SECTION':return{isOutdated:true};default:return state;}}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(78).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_soundfont_player__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_soundfont_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_soundfont_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transposer__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(215);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Player=function(){function Player(){_classCallCheck(this,Player);// q = 1 = 60bpm
this.nBeats=4;}_createClass(Player,[{key:'loadSamples',value:function loadSamples(callback){var _this=this;function localUrl(name){return'instruments/'+name+'.js';}var AudioContext=window.AudioContext||window.webkitAudioContext||false;if(!AudioContext){alert('Sorry, but the Web Audio API is not supported by your browser.\n             Please, consider upgrading to the latest version or downloading \n             Google Chrome or Mozilla Firefox');return callback();}var ac=new AudioContext();__WEBPACK_IMPORTED_MODULE_0_soundfont_player___default.a.instrument(ac,'piano',{nameToUrl:localUrl,gain:3,release:1}).then(function(instrument){_this.instrument=instrument;callback();}).catch(function(err){console.log('err',err);});}},{key:'parceVoice',value:function parceVoice(voice,symbol,vInd,bInd,pInd,sInd){var _this2=this;var notesDurationDenominators={};var offset=0;this.beatCounter=0;var notesToSwing=[];// ограничения по мультиолям
// поддерживаются только с основанием 2
// вложенность не поддерживается
if(voice.tuplets){voice.tuplets.forEach(function(tuplet){var from=tuplet.from,to=tuplet.to;for(var x=from;x<to;x++){notesDurationDenominators[x]=2/(to-from);}});}voice.notes.forEach(function(note,index){var noteId=sInd+'-'+pInd+'-'+bInd+'-'+symbol+'-'+vInd+'-'+index;var vexDuration=note.dur.toLowerCase();var isRest=vexDuration.indexOf('r')!==-1;var normalDuration=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* durations */][isRest?vexDuration.replace('r',''):vexDuration];if(note.dots){normalDuration=normalDuration*1.5;}var duration=normalDuration*_this2.timeDenominator;if(notesDurationDenominators[index]){duration=duration*notesDurationDenominators[index];normalDuration=normalDuration*notesDurationDenominators[index];}// swing feel
if(_this2.swing&&normalDuration===0.5&&notesDurationDenominators[index]===undefined){var beat=Math.floor(_this2.beatCounter);if(!notesToSwing[beat]){notesToSwing[beat]=[];}notesToSwing[beat].push({id:noteId});}// форшлаги, создать events  и привязать к event первой клавиши ноты
var graceNotes=[];if(note.grace){note.grace.notes.forEach(function(gn,gInd){var keys=gn.keys,duration=gn.dur;keys.forEach(function(key,keyIndex){var _transposer$transpose=this.transposer.transpose(key,duration),pitch=_transposer$transpose.trPitch;//пока все форшлаги играть как 64
graceNotes.push({id:noteId+'-'+gInd,note:pitch,time:this.currentTime+offset,duration:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* durations */]["64"]*this.timeDenominator,isRest:false,gain:symbol==='t'?3:2,gInd:gInd});}.bind(_this2));});}_this2.beatCounter=_this2.beatCounter+normalDuration;note.keys.forEach(function(key,keyIndex){var _transposer$transpose2=_this2.transposer.transpose(key,note.dur),pitch=_transposer$transpose2.trPitch;var event={id:noteId,note:pitch,time:_this2.currentTime+offset,duration:duration,isRest:isRest,gain:symbol==='t'?3:2// привяжем все форшлаги к событию первой ноты 
};if(keyIndex===0&&graceNotes.length){_this2.graceNotesEvents.push({event:event,graceNotes:graceNotes});}if(key.ties){key.ties.forEach(function(t,i){if(t.type==='start'){this.openedTies[pitch]=event;}else{if(this.openedTies[pitch]){this.ties.push({start:this.openedTies[pitch],stop:event});delete this.openedTies[pitch];}}}.bind(_this2));}_this2.events.push(event);});offset=offset+duration;});if(this.swing){notesToSwing.forEach(function(notePair){if(notePair.length===2){var firstNoteId=notePair[0].id;var secondNoteId=notePair[1].id;_this2.events.forEach(function(ev){if(ev.id===firstNoteId){ev.duration=ev.duration+_this2.swingExtraDuration;}else if(ev.id===secondNoteId){ev.duration=ev.duration-_this2.swingExtraDuration;ev.time=ev.time+_this2.swingExtraDuration;}});}});}}},{key:'play',value:function play(){var _this3=this;var curEvent=this.events[this.curEventIndex];if(!curEvent.isRest&&curEvent.duration){this.instrument.play(curEvent.note,curEvent.time,curEvent);}if(this.follow&&curEvent.id&&curEvent.duration){var el=document.getElementById('vf-'+curEvent.id);if(el!==null){// window.scrollBy({ 
//   top: x,
//   left: 0, 
//   behavior: 'smooth' 
// });
el.classList.add("currentNote");setTimeout(function(){el.classList.remove("currentNote");},curEvent.duration*1000);}}if(this.curEventIndex===this.events.length-1){return this.onFinishPlayingCallback();}var timeUntilNextEvent=this.events[this.curEventIndex+1].time-curEvent.time;this.curEventIndex++;this.timerId=setTimeout(function(){_this3.play();},timeUntilNextEvent*1000);}},{key:'start',value:function start(sections,_ref){var _this4=this;var tempo=_ref.tempo,swing=_ref.swing,key=_ref.key,follow=_ref.follow;if(this.onStartPlayingCallback){this.onStartPlayingCallback();}this.follow=follow;this.transposer=new __WEBPACK_IMPORTED_MODULE_1__Transposer__["a" /* default */](key);this.events=[];this.curEventIndex=0;this.currentTime=0;this.timeDenominator=60/tempo;// swing feel implementation
this.swing=swing;this.swingExtraDuration=this.timeDenominator*2/3-this.timeDenominator/2;//ties
this.openedTies={};this.ties=[];//grace notes
this.graceNotesEvents=[];sections.forEach(function(section,sInd){if(section!==null){section.phrases.forEach(function(phrase,pInd){phrase.bars.forEach(function(bar,bInd){_this4.transposer.resetAccidentals();bar.trebleVoices.forEach(function(voice,vInd){_this4.parceVoice(voice,'t',vInd,bInd,pInd,sInd);});bar.bassVoices.forEach(function(voice,vInd){_this4.parceVoice(voice,'b',vInd,bInd,pInd,sInd);});_this4.currentTime+=_this4.nBeats*_this4.timeDenominator;});});}});this.ties.forEach(function(tie){tie.start.duration=tie.start.duration+tie.stop.duration;tie.stop.duration=0;});this.graceNotesEvents.forEach(function(e){var _events;var eventTime=e.event.time;var gnEvents=e.graceNotes.reverse().map(function(gn){eventTime=eventTime-gn.duration;//немного увеличим длительность чтобы придать грязного звучания
return Object.assign({},gn,{time:eventTime,duration:gn.duration*4});});(_events=_this4.events).push.apply(_events,_toConsumableArray(gnEvents));});this.events.sort(function(a,b){return a.time-b.time;});if(this.events){this.play();}}},{key:'stop',value:function stop(){if(this.timerId){//this.instrument.stop();
clearTimeout(this.timerId);this.timerId=null;this.curEventIndex=0;//this.events.length = 0;
}}},{key:'onFinishPlaying',value:function onFinishPlaying(callback){this.onFinishPlayingCallback=callback;}},{key:'onStartPlaying',value:function onStartPlaying(callback){this.onStartPlayingCallback=callback;}}]);return Player;}();/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var load = __webpack_require__(583)
var player = __webpack_require__(586)

/**
 * Load a soundfont instrument. It returns a promise that resolves to a
 * instrument object.
 *
 * The instrument object returned by the promise has the following properties:
 *
 * - name: the instrument name
 * - play: A function to play notes from the buffer with the signature
 * `play(note, time, duration, options)`
 *
 *
 * The valid options are:
 *
 * - `format`: the soundfont format. 'mp3' by default. Can be 'ogg'
 * - `soundfont`: the soundfont name. 'MusyngKite' by default. Can be 'FluidR3_GM'
 * - `nameToUrl` <Function>: a function to convert from instrument names to URL
 * - `destination`: by default Soundfont uses the `audioContext.destination` but you can override it.
 * - `gain`: the gain of the player (1 by default)
 * - `notes`: an array of the notes to decode. It can be an array of strings
 * with note names or an array of numbers with midi note numbers. This is a
 * performance option: since decoding mp3 is a cpu intensive process, you can limit
 * limit the number of notes you want and reduce the time to load the instrument.
 *
 * @param {AudioContext} ac - the audio context
 * @param {String} name - the instrument name. For example: 'acoustic_grand_piano'
 * @param {Object} options - (Optional) the same options as Soundfont.loadBuffers
 * @return {Promise}
 *
 * @example
 * var Soundfont = require('sounfont-player')
 * Soundfont.instrument('marimba').then(function (marimba) {
 *   marimba.play('C4')
 * })
 */
function instrument (ac, name, options) {
  if (arguments.length === 1) return function (n, o) { return instrument(ac, n, o) }
  var opts = options || {}
  var isUrl = opts.isSoundfontURL || isSoundfontURL
  var toUrl = opts.nameToUrl || nameToUrl
  var url = isUrl(name) ? name : toUrl(name, opts.soundfont, opts.format)

  return load(ac, url, { only: opts.only || opts.notes }).then(function (buffers) {
    var p = player(ac, buffers, opts).connect(ac.destination)
    p.url = url
    p.name = name
    return p
  })
}

function isSoundfontURL (name) {
  return /\.js(\?.*)?$/i.test(name)
}

/**
 * Given an instrument name returns a URL to to the Benjamin Gleitzman's
 * package of [pre-rendered sound fonts](https://github.com/gleitz/midi-js-soundfonts)
 *
 * @param {String} name - instrument name
 * @param {String} soundfont - (Optional) the soundfont name. One of 'FluidR3_GM'
 * or 'MusyngKite' ('MusyngKite' by default)
 * @param {String} format - (Optional) Can be 'mp3' or 'ogg' (mp3 by default)
 * @returns {String} the Soundfont file url
 * @example
 * var Soundfont = require('soundfont-player')
 * Soundfont.nameToUrl('marimba', 'mp3')
 */
function nameToUrl (name, sf, format) {
  format = format === 'ogg' ? format : 'mp3'
  sf = sf === 'FluidR3_GM' ? sf : 'MusyngKite'
  return 'https://gleitz.github.io/midi-js-soundfonts/' + sf + '/' + name + '-' + format + '.js'
}

// In the 1.0.0 release it will be:
// var Soundfont = {}
var Soundfont = __webpack_require__(595)
Soundfont.instrument = instrument
Soundfont.nameToUrl = nameToUrl

if (typeof module === 'object' && module.exports) module.exports = Soundfont
if (typeof window !== 'undefined') window.Soundfont = Soundfont


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64 = __webpack_require__(584)
var fetch = __webpack_require__(585)

// Given a regex, return a function that test if against a string
function fromRegex (r) {
  return function (o) { return typeof o === 'string' && r.test(o) }
}
// Try to apply a prefix to a name
function prefix (pre, name) {
  return typeof pre === 'string' ? pre + name
    : typeof pre === 'function' ? pre(name)
    : name
}

/**
 * Load one or more audio files
 *
 *
 * Possible option keys:
 *
 * - __from__ {Function|String}: a function or string to convert from file names to urls.
 * If is a string it will be prefixed to the name:
 * `load(ac, 'snare.mp3', { from: 'http://audio.net/samples/' })`
 * If it's a function it receives the file name and should return the url as string.
 * - __only__ {Array} - when loading objects, if provided, only the given keys
 * will be included in the decoded object:
 * `load(ac, 'piano.json', { only: ['C2', 'D2'] })`
 *
 * @param {AudioContext} ac - the audio context
 * @param {Object} source - the object to be loaded
 * @param {Object} options - (Optional) the load options for that object
 * @param {Object} defaultValue - (Optional) the default value to return as
 * in a promise if not valid loader found
 */
function load (ac, source, options, defVal) {
  var loader =
    // Basic audio loading
      isArrayBuffer(source) ? loadArrayBuffer
    : isAudioFileName(source) ? loadAudioFile
    : isPromise(source) ? loadPromise
    // Compound objects
    : isArray(source) ? loadArrayData
    : isObject(source) ? loadObjectData
    : isJsonFileName(source) ? loadJsonFile
    // Base64 encoded audio
    : isBase64Audio(source) ? loadBase64Audio
    : isJsFileName(source) ? loadMidiJSFile
    : null

  var opts = options || {}
  return loader ? loader(ac, source, opts)
    : defVal ? Promise.resolve(defVal)
    : Promise.reject('Source not valid (' + source + ')')
}
load.fetch = fetch

// BASIC AUDIO LOADING
// ===================

// Load (decode) an array buffer
function isArrayBuffer (o) { return o instanceof ArrayBuffer }
function loadArrayBuffer (ac, array, options) {
  return new Promise(function (done, reject) {
    ac.decodeAudioData(array,
      function (buffer) { done(buffer) },
      function () { reject("Can't decode audio data (" + array.slice(0, 30) + '...)') }
    )
  })
}

// Load an audio filename
var isAudioFileName = fromRegex(/\.(mp3|wav|ogg)(\?.*)?$/i)
function loadAudioFile (ac, name, options) {
  var url = prefix(options.from, name)
  return load(ac, load.fetch(url, 'arraybuffer'), options)
}

// Load the result of a promise
function isPromise (o) { return o && typeof o.then === 'function' }
function loadPromise (ac, promise, options) {
  return promise.then(function (value) {
    return load(ac, value, options)
  })
}

// COMPOUND OBJECTS
// ================

// Try to load all the items of an array
var isArray = Array.isArray
function loadArrayData (ac, array, options) {
  return Promise.all(array.map(function (data) {
    return load(ac, data, options, data)
  }))
}

// Try to load all the values of a key/value object
function isObject (o) { return o && typeof o === 'object' }
function loadObjectData (ac, obj, options) {
  var dest = {}
  var promises = Object.keys(obj).map(function (key) {
    if (options.only && options.only.indexOf(key) === -1) return null
    var value = obj[key]
    return load(ac, value, options, value).then(function (audio) {
      dest[key] = audio
    })
  })
  return Promise.all(promises).then(function () { return dest })
}

// Load the content of a JSON file
var isJsonFileName = fromRegex(/\.json(\?.*)?$/i)
function loadJsonFile (ac, name, options) {
  var url = prefix(options.from, name)
  return load(ac, load.fetch(url, 'text').then(JSON.parse), options)
}

// BASE64 ENCODED FORMATS
// ======================

// Load strings with Base64 encoded audio
var isBase64Audio = fromRegex(/^data:audio/)
function loadBase64Audio (ac, source, options) {
  var i = source.indexOf(',')
  return load(ac, base64.decode(source.slice(i + 1)).buffer, options)
}

// Load .js files with MidiJS soundfont prerendered audio
var isJsFileName = fromRegex(/\.js(\?.*)?$/i)
function loadMidiJSFile (ac, name, options) {
  var url = prefix(options.from, name)
  return load(ac, load.fetch(url, 'text').then(midiJsToJson), options)
}

// convert a MIDI.js javascript soundfont file to json
function midiJsToJson (data) {
  var begin = data.indexOf('MIDI.Soundfont.')
  if (begin < 0) throw Error('Invalid MIDI.js Soundfont format')
  begin = data.indexOf('=', begin) + 2
  var end = data.lastIndexOf(',')
  return JSON.parse(data.slice(begin, end) + '}')
}

if (typeof module === 'object' && module.exports) module.exports = load
if (typeof window !== 'undefined') window.loadAudio = load


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// DECODE UTILITIES
function b64ToUint6 (nChr) {
  return nChr > 64 && nChr < 91 ? nChr - 65
    : nChr > 96 && nChr < 123 ? nChr - 71
    : nChr > 47 && nChr < 58 ? nChr + 4
    : nChr === 43 ? 62
    : nChr === 47 ? 63
    : 0
}

// Decode Base64 to Uint8Array
// ---------------------------
function decode (sBase64, nBlocksSize) {
  var sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, '')
  var nInLen = sB64Enc.length
  var nOutLen = nBlocksSize
    ? Math.ceil((nInLen * 3 + 1 >> 2) / nBlocksSize) * nBlocksSize
    : nInLen * 3 + 1 >> 2
  var taBytes = new Uint8Array(nOutLen)

  for (var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
    nMod4 = nInIdx & 3
    nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4
    if (nMod4 === 3 || nInLen - nInIdx === 1) {
      for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
        taBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255
      }
      nUint24 = 0
    }
  }
  return taBytes
}

module.exports = { decode: decode }


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global XMLHttpRequest */


/**
 * Given a url and a return type, returns a promise to the content of the url
 * Basically it wraps a XMLHttpRequest into a Promise
 *
 * @param {String} url
 * @param {String} type - can be 'text' or 'arraybuffer'
 * @return {Promise}
 */
module.exports = function (url, type) {
  return new Promise(function (done, reject) {
    var req = new XMLHttpRequest()
    if (type) req.responseType = type

    req.open('GET', url)
    req.onload = function () {
      req.status === 200 ? done(req.response) : reject(Error(req.statusText))
    }
    req.onerror = function () { reject(Error('Network Error')) }
    req.send()
  })
}


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var player = __webpack_require__(587)
var events = __webpack_require__(589)
var notes = __webpack_require__(590)
var scheduler = __webpack_require__(592)
var midi = __webpack_require__(593)

function SamplePlayer (ac, source, options) {
  return midi(scheduler(notes(events(player(ac, source, options)))))
}

if (typeof module === 'object' && module.exports) module.exports = SamplePlayer
if (typeof window !== 'undefined') window.SamplePlayer = SamplePlayer


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global AudioBuffer */


var ADSR = __webpack_require__(588)

var EMPTY = {}
var DEFAULTS = {
  gain: 1,
  attack: 0.01,
  decay: 0.1,
  sustain: 0.9,
  release: 0.3,
  loop: false,
  cents: 0,
  loopStart: 0,
  loopEnd: 0
}

/**
 * Create a sample player.
 *
 * @param {AudioContext} ac - the audio context
 * @param {ArrayBuffer|Object<String,ArrayBuffer>} source
 * @param {Onject} options - (Optional) an options object
 * @return {player} the player
 * @example
 * var SamplePlayer = require('sample-player')
 * var ac = new AudioContext()
 * var snare = SamplePlayer(ac, <AudioBuffer>)
 * snare.play()
 */
function SamplePlayer (ac, source, options) {
  var connected = false
  var nextId = 0
  var tracked = {}
  var out = ac.createGain()
  out.gain.value = 1

  var opts = Object.assign({}, DEFAULTS, options)

  /**
   * @namespace
   */
  var player = { context: ac, out: out, opts: opts }
  if (source instanceof AudioBuffer) player.buffer = source
  else player.buffers = source

  /**
   * Start a sample buffer.
   *
   * The returned object has a function `stop(when)` to stop the sound.
   *
   * @param {String} name - the name of the buffer. If the source of the
   * SamplePlayer is one sample buffer, this parameter is not required
   * @param {Float} when - (Optional) when to start (current time if by default)
   * @param {Object} options - additional sample playing options
   * @return {AudioNode} an audio node with a `stop` function
   * @example
   * var sample = player(ac, <AudioBuffer>).connect(ac.destination)
   * sample.start()
   * sample.start(5, { gain: 0.7 }) // name not required since is only one AudioBuffer
   * @example
   * var drums = player(ac, { snare: <AudioBuffer>, kick: <AudioBuffer>, ... }).connect(ac.destination)
   * drums.start('snare')
   * drums.start('snare', 0, { gain: 0.3 })
   */
  player.start = function (name, when, options) {
    // if only one buffer, reorder arguments
    if (player.buffer && name !== null) return player.start(null, name, when)

    var buffer = name ? player.buffers[name] : player.buffer
    if (!buffer) {
      console.warn('Buffer ' + name + ' not found.')
      return
    } else if (!connected) {
      console.warn('SamplePlayer not connected to any node.')
      return
    }

    var opts = options || EMPTY
    when = Math.max(ac.currentTime, when || 0)
    player.emit('start', when, name, opts)
    var node = createNode(name, buffer, opts)
    node.id = track(name, node)
    node.env.start(when)
    node.source.start(when)
    player.emit('started', when, node.id, node)
    if (opts.duration) node.stop(when + opts.duration)
    return node
  }

  // NOTE: start will be override so we can't copy the function reference
  // this is obviously not a good design, so this code will be gone soon.
  /**
   * An alias for `player.start`
   * @see player.start
   * @since 0.3.0
   */
  player.play = function (name, when, options) {
    return player.start(name, when, options)
  }

  /**
   * Stop some or all samples
   *
   * @param {Float} when - (Optional) an absolute time in seconds (or currentTime
   * if not specified)
   * @param {Array} nodes - (Optional) an array of nodes or nodes ids to stop
   * @return {Array} an array of ids of the stoped samples
   *
   * @example
   * var longSound = player(ac, <AudioBuffer>).connect(ac.destination)
   * longSound.start(ac.currentTime)
   * longSound.start(ac.currentTime + 1)
   * longSound.start(ac.currentTime + 2)
   * longSound.stop(ac.currentTime + 3) // stop the three sounds
   */
  player.stop = function (when, ids) {
    var node
    ids = ids || Object.keys(tracked)
    return ids.map(function (id) {
      node = tracked[id]
      if (!node) return null
      node.stop(when)
      return node.id
    })
  }
  /**
   * Connect the player to a destination node
   *
   * @param {AudioNode} destination - the destination node
   * @return {AudioPlayer} the player
   * @chainable
   * @example
   * var sample = player(ac, <AudioBuffer>).connect(ac.destination)
   */
  player.connect = function (dest) {
    connected = true
    out.connect(dest)
    return player
  }

  player.emit = function (event, when, obj, opts) {
    if (player.onevent) player.onevent(event, when, obj, opts)
    var fn = player['on' + event]
    if (fn) fn(when, obj, opts)
  }

  return player

  // =============== PRIVATE FUNCTIONS ============== //

  function track (name, node) {
    node.id = nextId++
    tracked[node.id] = node
    node.source.onended = function () {
      var now = ac.currentTime
      node.source.disconnect()
      node.env.disconnect()
      node.disconnect()
      player.emit('ended', now, node.id, node)
    }
    return node.id
  }

  function createNode (name, buffer, options) {
    var node = ac.createGain()
    node.gain.value = 0 // the envelope will control the gain
    node.connect(out)

    node.env = envelope(ac, options, opts)
    node.env.connect(node.gain)

    node.source = ac.createBufferSource()
    node.source.buffer = buffer
    node.source.connect(node)
    node.source.loop = options.loop || opts.loop
    node.source.playbackRate.value = centsToRate(options.cents || opts.cents)
    node.source.loopStart = options.loopStart || opts.loopStart
    node.source.loopEnd = options.loopEnd || opts.loopEnd
    node.stop = function (when) {
      var time = when || ac.currentTime
      player.emit('stop', time, name)
      var stopAt = node.env.stop(time)
      node.source.stop(stopAt)
    }
    return node
  }
}

function isNum (x) { return typeof x === 'number' }
var PARAMS = ['attack', 'decay', 'sustain', 'release']
function envelope (ac, options, opts) {
  var env = ADSR(ac)
  var adsr = options.adsr || opts.adsr
  PARAMS.forEach(function (name, i) {
    if (adsr) env[name] = adsr[i]
    else env[name] = options[name] || opts[name]
  })
  env.value.value = isNum(options.gain) ? options.gain
    : isNum(opts.gain) ? opts.gain : 1
  return env
}

/*
 * Get playback rate for a given pitch change (in cents)
 * Basic [math](http://www.birdsoft.demon.co.uk/music/samplert.htm):
 * f2 = f1 * 2^( C / 1200 )
 */
function centsToRate (cents) { return cents ? Math.pow(2, cents / 1200) : 1 }

module.exports = SamplePlayer


/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = ADSR

function ADSR(audioContext){
  var node = audioContext.createGain()

  var voltage = node._voltage = getVoltage(audioContext)
  var value = scale(voltage)
  var startValue = scale(voltage)
  var endValue = scale(voltage)

  node._startAmount = scale(startValue)
  node._endAmount = scale(endValue)

  node._multiplier = scale(value)
  node._multiplier.connect(node)
  node._startAmount.connect(node)
  node._endAmount.connect(node)

  node.value = value.gain
  node.startValue = startValue.gain
  node.endValue = endValue.gain

  node.startValue.value = 0
  node.endValue.value = 0

  Object.defineProperties(node, props)
  return node
}

var props = {

  attack: { value: 0, writable: true },
  decay: { value: 0, writable: true },
  sustain: { value: 1, writable: true },
  release: {value: 0, writable: true },

  getReleaseDuration: {
    value: function(){
      return this.release
    }
  },

  start: {
    value: function(at){
      var target = this._multiplier.gain
      var startAmount = this._startAmount.gain
      var endAmount = this._endAmount.gain

      this._voltage.start(at)
      this._decayFrom = this._decayFrom = at+this.attack
      this._startedAt = at

      var sustain = this.sustain

      target.cancelScheduledValues(at)
      startAmount.cancelScheduledValues(at)
      endAmount.cancelScheduledValues(at)

      endAmount.setValueAtTime(0, at)

      if (this.attack){
        target.setValueAtTime(0, at)
        target.linearRampToValueAtTime(1, at + this.attack)

        startAmount.setValueAtTime(1, at)
        startAmount.linearRampToValueAtTime(0, at + this.attack)
      } else {
        target.setValueAtTime(1, at)
        startAmount.setValueAtTime(0, at)
      }

      if (this.decay){
        target.setTargetAtTime(sustain, this._decayFrom, getTimeConstant(this.decay))
      }
    }
  },

  stop: {
    value: function(at, isTarget){
      if (isTarget){
        at = at - this.release
      }

      var endTime = at + this.release
      if (this.release){

        var target = this._multiplier.gain
        var startAmount = this._startAmount.gain
        var endAmount = this._endAmount.gain

        target.cancelScheduledValues(at)
        startAmount.cancelScheduledValues(at)
        endAmount.cancelScheduledValues(at)

        var expFalloff = getTimeConstant(this.release)

        // truncate attack (required as linearRamp is removed by cancelScheduledValues)
        if (this.attack && at < this._decayFrom){
          var valueAtTime = getValue(0, 1, this._startedAt, this._decayFrom, at)
          target.linearRampToValueAtTime(valueAtTime, at)
          startAmount.linearRampToValueAtTime(1-valueAtTime, at)
          startAmount.setTargetAtTime(0, at, expFalloff)
        }

        endAmount.setTargetAtTime(1, at, expFalloff)
        target.setTargetAtTime(0, at, expFalloff)
      }

      this._voltage.stop(endTime)
      return endTime
    }
  },

  onended: {
    get: function(){
      return this._voltage.onended
    },
    set: function(value){
      this._voltage.onended = value
    }
  }

}

var flat = new Float32Array([1,1])
function getVoltage(context){
  var voltage = context.createBufferSource()
  var buffer = context.createBuffer(1, 2, context.sampleRate)
  buffer.getChannelData(0).set(flat)
  voltage.buffer = buffer
  voltage.loop = true
  return voltage
}

function scale(node){
  var gain = node.context.createGain()
  node.connect(gain)
  return gain
}

function getTimeConstant(time){
  return Math.log(time+1)/Math.log(100)
}

function getValue(start, end, fromTime, toTime, at){
  var difference = end - start
  var time = toTime - fromTime
  var truncateTime = at - fromTime
  var phase = truncateTime / time
  var value = start + phase * difference

  if (value <= start) {
      value = start
  }
  if (value >= end) {
      value = end
  }

  return value
}


/***/ }),
/* 589 */
/***/ (function(module, exports) {


module.exports = function (player) {
  /**
   * Adds a listener of an event
   * @chainable
   * @param {String} event - the event name
   * @param {Function} callback - the event handler
   * @return {SamplePlayer} the player
   * @example
   * player.on('start', function(time, note) {
   *   console.log(time, note)
   * })
   */
  player.on = function (event, cb) {
    if (arguments.length === 1 && typeof event === 'function') return player.on('event', event)
    var prop = 'on' + event
    var old = player[prop]
    player[prop] = old ? chain(old, cb) : cb
    return player
  }
  return player
}

function chain (fn1, fn2) {
  return function (a, b, c, d) { fn1(a, b, c, d); fn2(a, b, c, d) }
}


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var note = __webpack_require__(591)
var isMidi = function (n) { return n !== null && n !== [] && n >= 0 && n < 129 }
var toMidi = function (n) { return isMidi(n) ? +n : note.midi(n) }

// Adds note name to midi conversion
module.exports = function (player) {
  if (player.buffers) {
    var map = player.opts.map
    var toKey = typeof map === 'function' ? map : toMidi
    var mapper = function (name) {
      return name ? toKey(name) || name : null
    }

    player.buffers = mapBuffers(player.buffers, mapper)
    var start = player.start
    player.start = function (name, when, options) {
      var key = mapper(name)
      var dec = key % 1
      if (dec) {
        key = Math.floor(key)
        options = Object.assign(options || {}, { cents: Math.floor(dec * 100) })
      }
      return start(key, when, options)
    }
  }
  return player
}

function mapBuffers (buffers, toKey) {
  return Object.keys(buffers).reduce(function (mapped, name) {
    mapped[toKey(name)] = buffers[name]
    return mapped
  }, {})
}


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var REGEX = /^([a-gA-G])(#{1,}|b{1,}|x{1,}|)(-?\d*)\s*(.*)\s*$/
/**
 * A regex for matching note strings in scientific notation.
 *
 * @name regex
 * @function
 * @return {RegExp} the regexp used to parse the note name
 *
 * The note string should have the form `letter[accidentals][octave][element]`
 * where:
 *
 * - letter: (Required) is a letter from A to G either upper or lower case
 * - accidentals: (Optional) can be one or more `b` (flats), `#` (sharps) or `x` (double sharps).
 * They can NOT be mixed.
 * - octave: (Optional) a positive or negative integer
 * - element: (Optional) additionally anything after the duration is considered to
 * be the element name (for example: 'C2 dorian')
 *
 * The executed regex contains (by array index):
 *
 * - 0: the complete string
 * - 1: the note letter
 * - 2: the optional accidentals
 * - 3: the optional octave
 * - 4: the rest of the string (trimmed)
 *
 * @example
 * var parser = require('note-parser')
 * parser.regex.exec('c#4')
 * // => ['c#4', 'c', '#', '4', '']
 * parser.regex.exec('c#4 major')
 * // => ['c#4major', 'c', '#', '4', 'major']
 * parser.regex().exec('CMaj7')
 * // => ['CMaj7', 'C', '', '', 'Maj7']
 */
function regex () { return REGEX }

var SEMITONES = [0, 2, 4, 5, 7, 9, 11]
/**
 * Parse a note name in scientific notation an return it's components,
 * and some numeric properties including midi number and frequency.
 *
 * @name parse
 * @function
 * @param {String} note - the note string to be parsed
 * @param {Boolean} isTonic - true if the note is the tonic of something.
 * If true, en extra tonicOf property is returned. It's false by default.
 * @param {Float} tunning - The frequency of A4 note to calculate frequencies.
 * By default it 440.
 * @return {Object} the parsed note name or null if not a valid note
 *
 * The parsed note name object will ALWAYS contains:
 * - letter: the uppercase letter of the note
 * - acc: the accidentals of the note (only sharps or flats)
 * - pc: the pitch class (letter + acc)
 * - step: s a numeric representation of the letter. It's an integer from 0 to 6
 * where 0 = C, 1 = D ... 6 = B
 * - alt: a numeric representation of the accidentals. 0 means no alteration,
 * positive numbers are for sharps and negative for flats
 * - chroma: a numeric representation of the pitch class. It's like midi for
 * pitch classes. 0 = C, 1 = C#, 2 = D ... It can have negative values: -1 = Cb.
 * Can detect pitch class enhramonics.
 *
 * If the note has octave, the parser object will contain:
 * - oct: the octave number (as integer)
 * - midi: the midi number
 * - freq: the frequency (using tuning parameter as base)
 *
 * If the parameter `isTonic` is set to true, the parsed object will contain:
 * - tonicOf: the rest of the string that follows note name (left and right trimmed)
 *
 * @example
 * var parse = require('note-parser').parse
 * parse('Cb4')
 * // => { letter: 'C', acc: 'b', pc: 'Cb', step: 0, alt: -1, chroma: -1,
 *         oct: 4, midi: 59, freq: 246.94165062806206 }
 * // if no octave, no midi, no freq
 * parse('fx')
 * // => { letter: 'F', acc: '##', pc: 'F##', step: 3, alt: 2, chroma: 7 })
 */
function parse (str, isTonic, tuning) {
  if (typeof str !== 'string') return null
  var m = REGEX.exec(str)
  if (!m || !isTonic && m[4]) return null

  var p = { letter: m[1].toUpperCase(), acc: m[2].replace(/x/g, '##') }
  p.pc = p.letter + p.acc
  p.step = (p.letter.charCodeAt(0) + 3) % 7
  p.alt = p.acc[0] === 'b' ? -p.acc.length : p.acc.length
  p.chroma = SEMITONES[p.step] + p.alt
  if (m[3]) {
    p.oct = +m[3]
    p.midi = p.chroma + 12 * (p.oct + 1)
    p.freq = midiToFreq(p.midi, tuning)
  }
  if (isTonic) p.tonicOf = m[4]
  return p
}

/**
 * Given a midi number, return its frequency
 * @param {Integer} midi - midi note number
 * @param {Float} tuning - (Optional) the A4 tuning (440Hz by default)
 * @return {Float} frequency in hertzs
 */
function midiToFreq (midi, tuning) {
  return Math.pow(2, (midi - 69) / 12) * (tuning || 440)
}

var parser = { parse: parse, regex: regex, midiToFreq: midiToFreq }
var FNS = ['letter', 'acc', 'pc', 'step', 'alt', 'chroma', 'oct', 'midi', 'freq']
FNS.forEach(function (name) {
  parser[name] = function (src) {
    var p = parse(src)
    return p && (typeof p[name] !== 'undefined') ? p[name] : null
  }
})

module.exports = parser

// extra API docs
/**
 * Get midi of a note
 *
 * @name midi
 * @function
 * @param {String} note - the note name
 * @return {Integer} the midi number of the note or null if not a valid note
 * or the note does NOT contains octave
 * @example
 * var parser = require('note-parser')
 * parser.midi('A4') // => 69
 * parser.midi('A') // => null
 */
/**
 * Get freq of a note in hertzs (in a well tempered 440Hz A4)
 *
 * @name freq
 * @function
 * @param {String} note - the note name
 * @return {Float} the freq of the number if hertzs or null if not valid note
 * or the note does NOT contains octave
 * @example
 * var parser = require('note-parser')
 * parser.freq('A4') // => 440
 * parser.freq('A') // => null
 */


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArr = Array.isArray
var isObj = function (o) { return o && typeof o === 'object' }
var OPTS = {}

module.exports = function (player) {
  /**
   * Schedule a list of events to be played at specific time.
   *
   * It supports three formats of events for the events list:
   *
   * - An array with [time, note]
   * - An array with [time, object]
   * - An object with { time: ?, [name|note|midi|key]: ? }
   *
   * @param {Float} time - an absolute time to start (or AudioContext's
   * currentTime if provided number is 0)
   * @param {Array} events - the events list.
   * @return {Array} an array of ids
   *
   * @example
   * // Event format: [time, note]
   * var piano = player(ac, ...).connect(ac.destination)
   * piano.schedule(0, [ [0, 'C2'], [0.5, 'C3'], [1, 'C4'] ])
   *
   * @example
   * // Event format: an object { time: ?, name: ? }
   * var drums = player(ac, ...).connect(ac.destination)
   * drums.schedule(0, [
   *   { name: 'kick', time: 0 },
   *   { name: 'snare', time: 0.5 },
   *   { name: 'kick', time: 1 },
   *   { name: 'snare', time: 1.5 }
   * ])
   */
  player.schedule = function (time, events) {
    var now = player.context.currentTime
    var when = time < now ? now : time
    player.emit('schedule', when, events)
    var t, o, note, opts
    return events.map(function (event) {
      if (!event) return null
      else if (isArr(event)) {
        t = event[0]; o = event[1]
      } else {
        t = event.time; o = event
      }

      if (isObj(o)) {
        note = o.name || o.key || o.note || o.midi || null
        opts = o
      } else {
        note = o
        opts = OPTS
      }

      return player.start(note, when + (t || 0), opts)
    })
  }
  return player
}


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var midimessage = __webpack_require__(594)

module.exports = function (player) {
  /**
  * Connect a player to a midi input
  *
  * The options accepts:
  *
  * - channel: the channel to listen to. Listen to all channels by default.
  *
  * @param {MIDIInput} input
  * @param {Object} options - (Optional)
  * @return {SamplePlayer} the player
  * @example
  * var piano = player(...)
  * window.navigator.requestMIDIAccess().then(function (midiAccess) {
  *   midiAccess.inputs.forEach(function (midiInput) {
  *     piano.listenToMidi(midiInput)
  *   })
  * })
  */
  player.listenToMidi = function (input, options) {
    var started = {}
    var opts = options || {}
    var gain = opts.gain || function (vel) { return vel / 127 }

    input.onmidimessage = function (msg) {
      var mm = msg.messageType ? msg : midimessage(msg)
      if (mm.messageType === 'noteon' && mm.velocity === 0) {
        mm.messageType = 'noteoff'
      }
      if (opts.channel && mm.channel !== opts.channel) return

      switch (mm.messageType) {
        case 'noteon':
          started[mm.key] = player.play(mm.key, 0, { gain: gain(mm.velocity) })
          break
        case 'noteoff':
          if (started[mm.key]) {
            started[mm.key].stop()
            delete started[mm.key]
          }
          break
      }
    }
    return player
  }
  return player
}


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(e){if(true){module.exports=e()}else if(typeof define==="function"&&define.amd){define([],e)}else{var t;if(typeof window!=="undefined"){t=window}else if(typeof global!=="undefined"){t=global}else if(typeof self!=="undefined"){t=self}else{t=this}t.midimessage=e()}})(function(){var e,t,s;return function o(e,t,s){function a(n,i){if(!t[n]){if(!e[n]){var l=typeof require=="function"&&require;if(!i&&l)return require(n,!0);if(r)return r(n,!0);var h=new Error("Cannot find module '"+n+"'");throw h.code="MODULE_NOT_FOUND",h}var c=t[n]={exports:{}};e[n][0].call(c.exports,function(t){var s=e[n][1][t];return a(s?s:t)},c,c.exports,o,e,t,s)}return t[n].exports}var r=typeof require=="function"&&require;for(var n=0;n<s.length;n++)a(s[n]);return a}({1:[function(e,t,s){"use strict";Object.defineProperty(s,"__esModule",{value:true});s["default"]=function(e){function t(e){this._event=e;this._data=e.data;this.receivedTime=e.receivedTime;if(this._data&&this._data.length<2){console.warn("Illegal MIDI message of length",this._data.length);return}this._messageCode=e.data[0]&240;this.channel=e.data[0]&15;switch(this._messageCode){case 128:this.messageType="noteoff";this.key=e.data[1]&127;this.velocity=e.data[2]&127;break;case 144:this.messageType="noteon";this.key=e.data[1]&127;this.velocity=e.data[2]&127;break;case 160:this.messageType="keypressure";this.key=e.data[1]&127;this.pressure=e.data[2]&127;break;case 176:this.messageType="controlchange";this.controllerNumber=e.data[1]&127;this.controllerValue=e.data[2]&127;if(this.controllerNumber===120&&this.controllerValue===0){this.channelModeMessage="allsoundoff"}else if(this.controllerNumber===121){this.channelModeMessage="resetallcontrollers"}else if(this.controllerNumber===122){if(this.controllerValue===0){this.channelModeMessage="localcontroloff"}else{this.channelModeMessage="localcontrolon"}}else if(this.controllerNumber===123&&this.controllerValue===0){this.channelModeMessage="allnotesoff"}else if(this.controllerNumber===124&&this.controllerValue===0){this.channelModeMessage="omnimodeoff"}else if(this.controllerNumber===125&&this.controllerValue===0){this.channelModeMessage="omnimodeon"}else if(this.controllerNumber===126){this.channelModeMessage="monomodeon"}else if(this.controllerNumber===127){this.channelModeMessage="polymodeon"}break;case 192:this.messageType="programchange";this.program=e.data[1];break;case 208:this.messageType="channelpressure";this.pressure=e.data[1]&127;break;case 224:this.messageType="pitchbendchange";var t=e.data[2]&127;var s=e.data[1]&127;this.pitchBend=(t<<8)+s;break}}return new t(e)};t.exports=s["default"]},{}]},{},[1])(1)});
//# sourceMappingURL=dist/index.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parser = __webpack_require__(596)

/**
 * Create a Soundfont object
 *
 * @param {AudioContext} context - the [audio context](https://developer.mozilla.org/en/docs/Web/API/AudioContext)
 * @param {Function} nameToUrl - (Optional) a function that maps the sound font name to the url
 * @return {Soundfont} a soundfont object
 */
function Soundfont (ctx, nameToUrl) {
  console.warn('new Soundfont() is deprected')
  console.log('Please use Soundfont.instrument() instead of new Soundfont().instrument()')
  if (!(this instanceof Soundfont)) return new Soundfont(ctx)

  this.nameToUrl = nameToUrl || Soundfont.nameToUrl
  this.ctx = ctx
  this.instruments = {}
  this.promises = []
}

Soundfont.prototype.onready = function (callback) {
  console.warn('deprecated API')
  console.log('Please use Promise.all(Soundfont.instrument(), Soundfont.instrument()).then() instead of new Soundfont().onready()')
  Promise.all(this.promises).then(callback)
}

Soundfont.prototype.instrument = function (name, options) {
  console.warn('new Soundfont().instrument() is deprecated.')
  console.log('Please use Soundfont.instrument() instead.')
  var ctx = this.ctx
  name = name || 'default'
  if (name in this.instruments) return this.instruments[name]
  var inst = {name: name, play: oscillatorPlayer(ctx, options)}
  this.instruments[name] = inst
  if (name !== 'default') {
    var promise = Soundfont.instrument(ctx, name, options).then(function (instrument) {
      inst.play = instrument.play
      return inst
    })
    this.promises.push(promise)
    inst.onready = function (cb) {
      console.warn('onready is deprecated. Use Soundfont.instrument().then()')
      promise.then(cb)
    }
  } else {
    inst.onready = function (cb) {
      console.warn('onready is deprecated. Use Soundfont.instrument().then()')
      cb()
    }
  }
  return inst
}

/*
 * Load the buffers of a given instrument name. It returns a promise that resolves
 * to a hash with midi note numbers as keys, and audio buffers as values.
 *
 * @param {AudioContext} ac - the audio context
 * @param {String} name - the instrument name (it accepts an url if starts with "http")
 * @param {Object} options - (Optional) options object
 * @return {Promise} a promise that resolves to a Hash of { midiNoteNum: <AudioBuffer> }
 *
 * The options object accepts the following keys:
 *
 * - nameToUrl {Function}: a function to convert from instrument names to urls.
 * By default it uses Benjamin Gleitzman's package of
 * [pre-rendered sound fonts](https://github.com/gleitz/midi-js-soundfonts)
 * - notes {Array}: the list of note names to be decoded (all by default)
 *
 * @example
 * var Soundfont = require('soundfont-player')
 * Soundfont.loadBuffers(ctx, 'acoustic_grand_piano').then(function(buffers) {
 *  buffers[60] // => An <AudioBuffer> corresponding to note C4
 * })
 */
function loadBuffers (ac, name, options) {
  console.warn('Soundfont.loadBuffers is deprecate.')
  console.log('Use Soundfont.instrument(..) and get buffers properties from the result.')
  return Soundfont.instrument(ac, name, options).then(function (inst) {
    return inst.buffers
  })
}
Soundfont.loadBuffers = loadBuffers

/**
 * Returns a function that plays an oscillator
 *
 * @param {AudioContext} ac - the audio context
 * @param {Hash} defaultOptions - (Optional) a hash of options:
 * - vcoType: the oscillator type (default: 'sine')
 * - gain: the output gain value (default: 0.4)
  * - destination: the player destination (default: ac.destination)
 */
function oscillatorPlayer (ctx, defaultOptions) {
  defaultOptions = defaultOptions || {}
  return function (note, time, duration, options) {
    console.warn('The oscillator player is deprecated.')
    console.log('Starting with version 0.9.0 you will have to wait until the soundfont is loaded to play sounds.')
    var midi = note > 0 && note < 129 ? +note : parser.midi(note)
    var freq = midi ? parser.midiToFreq(midi, 440) : null
    if (!freq) return

    duration = duration || 0.2

    options = options || {}
    var destination = options.destination || defaultOptions.destination || ctx.destination
    var vcoType = options.vcoType || defaultOptions.vcoType || 'sine'
    var gain = options.gain || defaultOptions.gain || 0.4

    var vco = ctx.createOscillator()
    vco.type = vcoType
    vco.frequency.value = freq

    /* VCA */
    var vca = ctx.createGain()
    vca.gain.value = gain

    /* Connections */
    vco.connect(vca)
    vca.connect(destination)

    vco.start(time)
    if (duration > 0) vco.stop(time + duration)
    return vco
  }
}

/**
 * Given a note name, return the note midi number
 *
 * @name noteToMidi
 * @function
 * @param {String} noteName
 * @return {Integer} the note midi number or null if not a valid note name
 */
Soundfont.noteToMidi = parser.midi

module.exports = Soundfont


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["regex"] = regex;
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["build"] = build;
/* harmony export (immutable) */ __webpack_exports__["midi"] = midi;
/* harmony export (immutable) */ __webpack_exports__["freq"] = freq;
/* harmony export (immutable) */ __webpack_exports__["letter"] = letter;
/* harmony export (immutable) */ __webpack_exports__["acc"] = acc;
/* harmony export (immutable) */ __webpack_exports__["pc"] = pc;
/* harmony export (immutable) */ __webpack_exports__["step"] = step;
/* harmony export (immutable) */ __webpack_exports__["alt"] = alt;
/* harmony export (immutable) */ __webpack_exports__["chroma"] = chroma;
/* harmony export (immutable) */ __webpack_exports__["oct"] = oct;


// util
function fillStr (s, num) { return Array(num + 1).join(s) }
function isNum (x) { return typeof x === 'number' }
function isStr (x) { return typeof x === 'string' }
function isDef (x) { return typeof x !== 'undefined' }
function midiToFreq (midi, tuning) {
  return Math.pow(2, (midi - 69) / 12) * (tuning || 440)
}

var REGEX = /^([a-gA-G])(#{1,}|b{1,}|x{1,}|)(-?\d*)\s*(.*)\s*$/
/**
 * A regex for matching note strings in scientific notation.
 *
 * @name regex
 * @function
 * @return {RegExp} the regexp used to parse the note name
 *
 * The note string should have the form `letter[accidentals][octave][element]`
 * where:
 *
 * - letter: (Required) is a letter from A to G either upper or lower case
 * - accidentals: (Optional) can be one or more `b` (flats), `#` (sharps) or `x` (double sharps).
 * They can NOT be mixed.
 * - octave: (Optional) a positive or negative integer
 * - element: (Optional) additionally anything after the duration is considered to
 * be the element name (for example: 'C2 dorian')
 *
 * The executed regex contains (by array index):
 *
 * - 0: the complete string
 * - 1: the note letter
 * - 2: the optional accidentals
 * - 3: the optional octave
 * - 4: the rest of the string (trimmed)
 *
 * @example
 * var parser = require('note-parser')
 * parser.regex.exec('c#4')
 * // => ['c#4', 'c', '#', '4', '']
 * parser.regex.exec('c#4 major')
 * // => ['c#4major', 'c', '#', '4', 'major']
 * parser.regex().exec('CMaj7')
 * // => ['CMaj7', 'C', '', '', 'Maj7']
 */
function regex () { return REGEX }

var SEMITONES = [0, 2, 4, 5, 7, 9, 11]
/**
 * Parse a note name in scientific notation an return it's components,
 * and some numeric properties including midi number and frequency.
 *
 * @name parse
 * @function
 * @param {String} note - the note string to be parsed
 * @param {Boolean} isTonic - true the strings it's supposed to contain a note number
 * and some category (for example an scale: 'C# major'). It's false by default,
 * but when true, en extra tonicOf property is returned with the category ('major')
 * @param {Float} tunning - The frequency of A4 note to calculate frequencies.
 * By default it 440.
 * @return {Object} the parsed note name or null if not a valid note
 *
 * The parsed note name object will ALWAYS contains:
 * - letter: the uppercase letter of the note
 * - acc: the accidentals of the note (only sharps or flats)
 * - pc: the pitch class (letter + acc)
 * - step: s a numeric representation of the letter. It's an integer from 0 to 6
 * where 0 = C, 1 = D ... 6 = B
 * - alt: a numeric representation of the accidentals. 0 means no alteration,
 * positive numbers are for sharps and negative for flats
 * - chroma: a numeric representation of the pitch class. It's like midi for
 * pitch classes. 0 = C, 1 = C#, 2 = D ... 11 = B. Can be used to find enharmonics
 * since, for example, chroma of 'Cb' and 'B' are both 11
 *
 * If the note has octave, the parser object will contain:
 * - oct: the octave number (as integer)
 * - midi: the midi number
 * - freq: the frequency (using tuning parameter as base)
 *
 * If the parameter `isTonic` is set to true, the parsed object will contain:
 * - tonicOf: the rest of the string that follows note name (left and right trimmed)
 *
 * @example
 * var parse = require('note-parser').parse
 * parse('Cb4')
 * // => { letter: 'C', acc: 'b', pc: 'Cb', step: 0, alt: -1, chroma: -1,
 *         oct: 4, midi: 59, freq: 246.94165062806206 }
 * // if no octave, no midi, no freq
 * parse('fx')
 * // => { letter: 'F', acc: '##', pc: 'F##', step: 3, alt: 2, chroma: 7 })
 */
function parse (str, isTonic, tuning) {
  if (typeof str !== 'string') return null
  var m = REGEX.exec(str)
  if (!m || (!isTonic && m[4])) return null

  var p = { letter: m[1].toUpperCase(), acc: m[2].replace(/x/g, '##') }
  p.pc = p.letter + p.acc
  p.step = (p.letter.charCodeAt(0) + 3) % 7
  p.alt = p.acc[0] === 'b' ? -p.acc.length : p.acc.length
  var pos = SEMITONES[p.step] + p.alt
  p.chroma = pos < 0 ? 12 + pos : pos % 12
  if (m[3]) { // has octave
    p.oct = +m[3]
    p.midi = pos + 12 * (p.oct + 1)
    p.freq = midiToFreq(p.midi, tuning)
  }
  if (isTonic) p.tonicOf = m[4]
  return p
}

var LETTERS = 'CDEFGAB'
function accStr (n) { return !isNum(n) ? '' : n < 0 ? fillStr('b', -n) : fillStr('#', n) }
function octStr (n) { return !isNum(n) ? '' : '' + n }

/**
 * Create a string from a parsed object or `step, alteration, octave` parameters
 * @param {Object} obj - the parsed data object
 * @return {String} a note string or null if not valid parameters
 * @since 1.2
 * @example
 * parser.build(parser.parse('cb2')) // => 'Cb2'
 *
 * @example
 * // it accepts (step, alteration, octave) parameters:
 * parser.build(3) // => 'F'
 * parser.build(3, -1) // => 'Fb'
 * parser.build(3, -1, 4) // => 'Fb4'
 */
function build (s, a, o) {
  if (s === null || typeof s === 'undefined') return null
  if (s.step) return build(s.step, s.alt, s.oct)
  if (s < 0 || s > 6) return null
  return LETTERS.charAt(s) + accStr(a) + octStr(o)
}

/**
 * Get midi of a note
 *
 * @name midi
 * @function
 * @param {String|Integer} note - the note name or midi number
 * @return {Integer} the midi number of the note or null if not a valid note
 * or the note does NOT contains octave
 * @example
 * var parser = require('note-parser')
 * parser.midi('A4') // => 69
 * parser.midi('A') // => null
 * @example
 * // midi numbers are bypassed (even as strings)
 * parser.midi(60) // => 60
 * parser.midi('60') // => 60
 */
function midi (note) {
  if ((isNum(note) || isStr(note)) && note >= 0 && note < 128) return +note
  var p = parse(note)
  return p && isDef(p.midi) ? p.midi : null
}

/**
 * Get freq of a note in hertzs (in a well tempered 440Hz A4)
 *
 * @name freq
 * @function
 * @param {String} note - the note name or note midi number
 * @param {String} tuning - (Optional) the A4 frequency (440 by default)
 * @return {Float} the freq of the number if hertzs or null if not valid note
 * @example
 * var parser = require('note-parser')
 * parser.freq('A4') // => 440
 * parser.freq('A') // => null
 * @example
 * // can change tuning (440 by default)
 * parser.freq('A4', 444) // => 444
 * parser.freq('A3', 444) // => 222
 * @example
 * // it accepts midi numbers (as numbers and as strings)
 * parser.freq(69) // => 440
 * parser.freq('69', 442) // => 442
 */
function freq (note, tuning) {
  var m = midi(note)
  return m === null ? null : midiToFreq(m, tuning)
}

function letter (src) { return (parse(src) || {}).letter }
function acc (src) { return (parse(src) || {}).acc }
function pc (src) { return (parse(src) || {}).pc }
function step (src) { return (parse(src) || {}).step }
function alt (src) { return (parse(src) || {}).alt }
function chroma (src) { return (parse(src) || {}).chroma }
function oct (src) { return (parse(src) || {}).oct }


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.dea66ec4.js